export const maneuvers = [
  {
    school: `revelations`,
    level: 1,
    name: `Confidence Rules`,
    type: `Stance`,
    longDesc: `Confidence persists until lost, or when combat begins or ends. It can only be gained during combat. Confidence cannot exceed your base Will save bonus plus your Wisdom modifier.
    \n\nConfidence Benefits:
    \nFor every 5 Confidence stacks, you gain a +1 untyped bonus to attack rolls, saving throws, and Armor Class against attacks of opportunity.
    \nThese bonuses are doubled against creatures who are currently shaken from an effect you personally caused.
    \n\nConfidence Loss:
    \nYou lose Confidence under the following conditions:\n1 Confidence: When hit by a melee or ranged attack, when you choose not to attack due to believing you cannot hit, or when you fail a Reflex save.\n2 Confidence: When you miss an attack.\n3 Confidence: When you fail a Fortitude or Will save.
    \nConfidence cannot drop below 0 through these effects, but specific maneuvers that reduce Confidence can result in negative values, converting to Crushing Failure stacks.
    \n\nConfidence Gain:
    \nIf you have at least 1 Confidence, you gain Confidence under the following conditions:\n1: You gain 1 confidence when you hit with all attacks in a full-round attack (all attacks must be attempted. If taking 2 bonus attacks with broken blade stance, confidence gain is increased to +2), \n2: Gain 1 confidence when you land a successful critical hit.\n3: Gain 1 confidence when you deliver a defeating blow to an enemy. If the enemy is a non-monster with with an HD or BAB equal to or greater to your own, the Confidence gain increases to 2. If both are equal or greater than your own, you gain 4 instead. Monsters grant varying confidence based on their power.
    \n\nIf you are at maximum Confidence, any additional Confidence that would be gained is not added, but you heal 1d4 hit points per excess Confidence point.
    \n\nCrushing Failure Mechanics:
    \nCrushing Failure stacks are negative Confidence stacks with distinct effects. Gaining Confidence reduces Crushing Failure stacks until they become Confidence again.
    \n\nCrushing Failure Penalties:
    \nFor each Crushing Failure stack:\n1: You take a -1 penalty to attack rolls, Armor Class, and saving throws.
    \n\nReducing Crushing Failure:
    \n1: Each successful attack removes 1 Crushing Failure stack.\n2: Each successful saving throw removes 2 Crushing Failure stacks.
    \n\nMind Palace:
    \nYou can spend 1 mythic point as a full-round action to enter your mind palace.`,
    initiationAction: `free`,
    range: `personal`,
    target: `you`,
    duration: `permanent`,
  },
  {
    school: `revelations`,
    level: 1,
    name: `Carnage`,
    type: `Strike`,
    longDesc: `Make a CMB check to sunder, doubling the bonus to attack rolls that Confidence is giving you for this check. If the sunder succeeds on breaking the item, you gain +2 Confidence. If it destroys the item, you instead gain +5 Confidence. 
    \nThe item must be something believed to have immediate value to the opponent to grant Confidence, things that are valuable but not critically so, may grant reduced Confidence. Also, items that are easier to break may grant less Confidence.
    \n\nIf the target is a monster (as decided by me), you instead can make a called shot attempt, but doing so causes the initiation of this maneuver to increase to a standard action. If it is successful, it grants Confidence equal to 2 + 1/2 the attack penalty from attacking that location. +4 if its a critical, and +4 if it's a debilitating hit. Both of these additional Confidence bonuses stack for a max of +10. 
    \nThe damage for a critical is completely arbitrary, but usually hit points from HD/2 + con-10. The attack penalty for Called shots can also be altered depending on the specifics of the target.`,
    initiationAction: `movement or standard`,
    range: `melee`,
    target: `1 enemy`,
    duration: `Instantaneous`,
    additionalTags:["Primal","Technique"]
  },
  // {
  //   school: `revelations`,
  //   level: 1,
  //   name: `Ego Boost`,
  //   type: `Boost`,
  //   longDesc: `When a creature declares an attack against you, gain a +1000 bonus to your attack for the attack. This does not augment abilities that have already been activated before this counter is activated.`,
  //   initiationAction: `immediate`,
  //   range: `personal`,
  //   target: `you`,
  //   duration: `Instantaneous`,
  //   additionalTags:["Heroic"]
  // },
  {
    school: `revelations`,
    level: 1,
    name: `Wild Rush`,
    type: `Boost`,
    longDesc: `You activate this boost when you are about to move, granting your next attack this round multiple bonuses: 
    \n1: The bonus to attack you are gaining from confidence doubles, and you gain an equal bonus to your damage. 
    \n2: If the attack is successful and deals damage, for every 10 feet in a straight line you moved directly before the attack, you gain 1 Confidence. If your attack misses, you lose 2 Confidence, plus an amount equal to twice the attack bonus you were gaining from Confidence for the attack.
    \nThe amount gained also cannot be greater than 1 per 10 feet of the distance of the shortest path between you and the target at the start of your turn.`,
    initiationAction: `swift`,
    range: `personal`,
    target: `you`,
    duration: `Instantaneous`,
    additionalTags:["Primal","Heroic"]
  },
  {
    school: `revelations`,
    level: 1,
    name: `Fire in the Flesh`,
    type: `Boost`,
    longDesc: `Make an Acrobatics check, adding a bonus equal to your Confidence score. Move in a straight line a number of feet equal to the check's result. This check also determines if you can move through a creature's threatened area without provoking attacks of opportunity (without reducing the distance moved). You can move in any direction, including upward. 
    \nIf you're threatening an enemy, you can direct the blast in their direction. You then make the Acrobatics check as normal, but also make a bull rush check against the target (doesn't provoke) using the acrobatics check as the roll, but adding any bonuses that effect your bull rush attempts. Regardless of the bull rush outcome, the target takes fire damage equal to the check (reflex halves).
    \nYou may choose to take up to your Wisdom modifier in d6 damage to increase the Acrobatics check by half the damage taken.
    \n\nYou can initiate this maneuver as a free action if you initiate it as a part of another action you are taking that is causing you to move. However the distance moved is halved, and it must follow any restrictions for that movement (eg: In a straight line, etc.).`,
    initiationAction: `swift or free`,
    range: `personal or melee`,
    target: `you`,
    duration: `Instantaneous`,
    additionalTags:["Primal","Fire"]
  },
  {
    school: `revelations`,
    level: 1,
    name: `Behold Me`,
    type: `Boost`,
    longDesc: `You strike a glorious pose to boost your self esteem and demoralize foes. All enemies within 30 feet of you can choose whether or not to make an opposing will saving throw against you. For every enemy this targets, you gain 1 confidence.
    \nIf an enemy declines the check, they are shaken for 1 round, and you gain 1 confidence. If they accept the check and they succeed the saving throw, you loose 4 confidence and are shaken for 1 round (stacks), and the effective result of your save is reduced by 2 (this can have cascading effects). 
    \nFor every enemy that fails, you gain 2 confidence and they are shaken for 1d4 rounds. While shaken this way, their successful attacks against you do not cause you to lose confidence.
    \nIf all enemies targeted accept and succeed the save, you are stunned for 1 round, lose all of your confidence, take 4 crushing failure stacks, and then are shaken for the rest of the combat. This shaken effect stacks with the regular shaken status, and cannot be removed or resisted by normal means.
    \nIf all enemies fail or refuse to accept, the confidence you gain is increased by 25%.
    \nThe initial confidence gained from the number of creatures you target does apply to the opposed will save. Roll once vs all creatures.`,
    initiationAction: `Movement`,
    range: `30 feet`,
    target: `enemies`,
    duration: `see text;`,
    additionalTags:["Primal","Heroic"]
  },
  {
    school: `revelations`,
    level: 1,
    name: `Path of Pride`,
    type: `Boost`,
    longDesc: `When moving, you can activate this boost to grant yourself several bonuses for that movement:
    \n1: Double the armor class that Confidence is granting to your armor class during the movement.
    \n2: For each AoO you provoke while moving, gain +1 Confidence.
    \n3: For each enemy that misses you with an AoO, gain +1 Confidence.
    \n4: If an enemy chooses not to take an AoO because they believe they would miss, they become shaken for 1 round and you gain +1 Confidence. Creatures shaken by this effect do not reduce your Confidence with successful attacks.
    \nHowever, if an AoO hits you during this movement, lose 3 Confidence (on top of losing 1 confidence for being hit by an attack as default).
    \nThis boost does not grant you Confidence for provoking or on missed attacks by enemies with a lower BAB than you, unless they are also equal or higher level than you. If a creature has both a higher BAB and a higher level than you, the confidence gain against them is doubled. This applies only to non-monsters, monsters will have varying confidence gain based on their power.`,
    initiationAction: `free`,
    range: `personal`,
    target: `you`,
    duration: `see text;`,
    additionalTags:["Heroic","Air"]
  },
  {
    school: `unique`,
    level: 6,
    name: `Holy Interception`,
    type: `Counter`,
    longDesc: `When an AOE ability is declared that would include an area that would be protected by this ability, you can activate this counter to create an impassable barrier on one edge of your square, plus stretching an additional 5 feet in each direction. After this counter is initiated, if you can reach the enemy who activated the ability, you can make a shield bash attempt, it deals additional damage equal to 50% of the damage this blocked (damage is same type as blocked).`,
    initiationAction: `immediate`,
    range: `personal`,
    target: `you`,
    duration: `instantaneous`,
    additionalTags:["Heroic","Guardian"]
  },
  {
    school: `unique`,
    level: 4,
    name: `Holy Fortress`,
    type: `Boost`,
    longDesc: `When you activate this boost, you create an impassable barrier on one edge of your square, plus stretching an additional 5 feet in each direction. This stops all attacks from that direction.`,
    initiationAction: `standard`,
    range: `personal`,
    target: `you`,
    duration: `instantaneous`,
    additionalTags:["Heroic","Guardian"]
  },
  {
    school: `unique`,
    level: 4,
    name: `Coordinated Attack`,
    type: `Boost`,
    longDesc: `Your next melee attack deals +6d6 additional damage, and if it hits, you can heal an ally within 30 feet for 6d6. If the ally attacks the same target within 1 round, they gain +4 attack and if their attack hits it heals you 6d6.`,
    initiationAction: `swift`,
    range: `personal`,
    target: `you`,
    duration: `instantaneous`,
    additionalTags:["Heroic","Light"]
  },
  {
    school: `unique`,
    level: 4,
    name: `Fastball Special`,
    type: `Boost`,
    longDesc: `You ready your shield, then throw an ally within the reach of your shield an amount of squares equal to your strength modifier in a straight line in any direction (even stright up). While moving, they are able to make a single attack during it (this can include strikes). This attack gains a +4 bonus to the attack, deals an additional 10d6 damage, and it's critical damage multiplier increases by +1.`,
    initiationAction: `Standard`,
    range: `personal`,
    target: `you`,
    duration: `instantaneous`,
    additionalTags:["Heroic","Power","Unique"]
  },
  {
    school: `unique`,
    level: 4,
    name: `Strike of Reinvigoration`,
    type: `Strike`,
    longDesc: `Make a melee attack, if it hits, it deals damage as normal and an ally within 30 feet heals 12d6. You can expend one use of lay on hands to heal them or yourself for an additional 6d6+6 hit points.`,
    initiationAction: `standard`,
    range: `melee`,
    target: `1 enemy`,
    duration: `instantaneous`,
    additionalTags:["Heroic","Light"]
  },
  {
    school: `azureWind`,
    level: 3,
    name: `Dragon Reaver`,
    type: `Counter`,
    longDesc: `You can only use this counter while within reach of the ground. A flying enemy within your reach is immediately grounded for initiation modifier rounds. They can make a reflex save to reduce the duration of this to one round. If you are on the ground, you can expend an attack of opportunity to make a trip attempt against them after they are grounded.`,
    initiationAction: `immediate`,
    range: `reach`,
    target: `1 enemy`,
    duration: `initiation modifier rounds`,
  },
  {
    school: `azureWind`,
    level: 3,
    name: `Under the Dragon's Wing`,
    type: `Counter`,
    longDesc: `You cannot initiate this counter in response to a hostile action. Choose an ally within your reach and make a fly check, they can move a distance equal to half the result of the check. If they are wearing heavy armor or large, the distance moved is halved (stacks if both). This doesn't work on huge or larger creatures. They can even move upwards with this counter, and they don't fall until the end of your next turn. Afterwards, they gain a +2 dodge bonus to their armor class for 1 round as long as they were wearing light or no armor. 
    \nIf you initiate this as a movement action, this movement no longer provokes and the dodge bonus to their armor class is increased to your initation modifier, however it is reduced by 1 each time they are attacked, to a minimum of +2.`,
    initiationAction: `swift or movement`,
    range: `reach`,
    target: `1 ally`,
    duration: `1 round`,
  },
  {
    school: `azureWind`,
    level: 3,
    name: `Vertical Warrior`,
    type: `Stance`,
    longDesc: `When using a discipline weapon you gain a +2 circumstance bonus to attacks and a bonus on damage rolls equal to your initiation modifier against creatures that are above you, below you, or are prone. These bonuses are doubled if the creature is currently “lifted”, or below you and prone. These bonuses are also doubled if the creature is directly above or below you (to a max of x3).`,
    initiationAction: `swift`,
    range: `personal`,
    target: `you`,
    duration: `stance`,
  },
  {
    school: "unique",
    level: 4,
    name: "Windfury Totem",
    type: "Boost",
    longDesc: "Spell Augment: +4% spell critical chance. +1 damage per dice of all elemental damage spells, +1 if its electricity/air.\n\nAura: Creatures are hasted and gain +10 untyped bonus to movement speed.\nAwaken Spirit: A specified creature within the area can take a 5-foot step without provoking, and make a single attack.",
    initiationAction: "movement",
    range: "30 feet",
    target: "15ft. Aura",
    duration: "6 rounds"
  },
  {
    school: "unique",
    level: 4,
    name: "Windtunnel Totem",
    type: "Boost",
    longDesc: "Spell Augment: +4% spell critical chance. +1 damage per dice of all elemental damage spells, +1 if its electricity/air.\n\nAura: Ranged attacks from outside to inside suffer -2; from inside to outside gain +2 and +10 ft range.\nAwaken Spirit: Double the bonuses and penalties.",
    initiationAction: "movement",
    range: "30 feet",
    target: "15ft. Aura",
    duration: "6 rounds"
  },
  {
    school: "unique",
    level: 1,
    name: "Tremoring Earth Totem",
    type: "Boost",
    longDesc: "Spell Augment: +20% spell critical power. +1 damage per dice of all elemental damage spells, +1 if its earth/acid.\n\nAura: Its area is difficult terrain, and creatures suffer a -4 penalty to CMD.\nAwaken Spirit: Move it 30 feet, doesn't provoke (it travels underground). Additionally, you gain tremorsense within its area for 1 round.",
    initiationAction: "movement",
    range: "30 feet",
    target: "15ft. Aura",
    duration: "6 rounds"
  },
  {
    school: "unique",
    level: 1,
    name: "Stoneflesh Totem",
    type: "Boost",
    longDesc: "Spell Augment: +20% spell critical power. +1 damage per dice of all elemental damage spells, +1 if its earth/acid.\n\nAura: Creatures gain DR 5/adamantine. This stacks with other DR but is reduced to DR 2/adamantine.\nAwaken Spirit: DR becomes untyped and it is doubled for 1 round.",
    initiationAction: "movement",
    range: "30 feet",
    target: "15ft. Aura",
    duration: "6 rounds"
  },
  {
    school: "unique",
    level: 3,
    name: "Tidal Totem",
    type: "Boost",
    longDesc: "Spell Augment: Allies take 25% less damage from your spells. +1 damage per dice of all elemental damage spells, +1 if it's cold/water.\n\nAura: Move an additional 5 feet when taking a 5-foot step and ignore difficult terrain. Creatures suffer a -4 penalty to CMD, and -2 to CMD vs trips.\nAwaken Spirit: All creatures within the area must make a reflex save or fall prone. If they fall prone, it also provokes attacks of opportunity from creatures that threaten them.",
    initiationAction: "movement",
    range: "30 feet",
    target: "15ft. Aura",
    duration: "6 rounds"
  },
  {
    school: "unique",
    level: 3,
    name: "Grace Totem",
    type: "Boost",
    longDesc: "Spell Augment: Allies take 25% less damage from your spells. +1 damage per dice of all elemental damage spells, +1 if it's cold/water.\n\nAura: Creatures within the area gain a +2 bonus to saves and a +2 dodge bonus to AC.\nAwaken Spirit: Immediate action, this is done after a single effect affects any number of creatures within the area. Those creatures can all roll a new save or the attack against them is rerolled.",
    initiationAction: "movement",
    range: "30 feet",
    target: "15ft. Aura",
    duration: "6 rounds"
  },
  {
    school: "unique",
    level: 2,
    name: "Wrath Totem",
    type: "Boost",
    longDesc: "Spell Augment: +10 spell power. +1 damage per dice of all elemental damage spells, +1 if it's fire.\n\nAura: +2 attack and damage. Critical hits deal 1d6+their charisma additional fire damage and 3 immolation stacks.\nAwaken Spirit: The totem spits fire in a 30-foot line, dealing 11d6 fire damage, and gives 4 immolation stacks, reflex halves, scales with fire spell power.",
    initiationAction: "movement",
    range: "30 feet",
    target: "15ft. Aura",
    duration: "6 rounds"
  },
  {
    school: "unique",
    level: 2,
    name: "Wildfire Totem",
    type: "Boost",
    longDesc: "Spell Augment: +10 spell power. +1 damage per dice of all elemental damage spells, +1 if it's fire.\n\nAura: Creatures that enter or start their turn in the area suffer 1d6 + wis fire damage and 3 immolation stacks. Each round they remain in the area the damage increases by 1 increment.\nAwaken Spirit: In 1 round, the totem explodes, dealing 11d6 fire damage (scales with fire spell power) and creatures within the area have their immolation stacks doubled, no save.",
    initiationAction: "movement",
    range: "30 feet",
    target: "15ft. Aura",
    duration: "6 rounds"
  },
  {
    school: "unique",
    level: 7,
    name: "Despair Totem",
    type: "Boost",
    longDesc: "Spell Augment: +1 Spell DCs.\n\nAura: Creatures suffer a -2 penalty to saves and armor class.\nAwaken Spirit: The next time within 8 hours the creatures make a saving throw, it suffers a -2 penalty. This stacks with the totem's base effect.",
    initiationAction: "movement",
    range: "30 feet",
    target: "15ft. Aura",
    duration: "6 rounds"
  },
  {
    school: "unique",
    level: 7,
    name: "Misfortune Totem",
    type: "Boost",
    longDesc: "Spell Augment: +1 Spell DCs.\n\nAura: Creatures within the area cannot benefit from luck bonuses or reroll effects based on luck, fate, divine intervention, or similar concepts, and attacks against you made by creatures within the area suffer a -2 penalty.\nAwaken Spirit: This is activated as an immediate action. When a creature within the area rolls a natural 20 or a natural 1, you can allow them to reroll. If it was a natural 20, you gain 1 bad luck, which will cause your next natural 20 to be rerolled; if it was a natural 1, you will gain 1 good luck, allowing you to reroll the next natural 1 you roll. Both of these are at the spirits' whims and only affect rolls of consequence.",
    initiationAction: "movement",
    range: "30 feet",
    target: "15ft. Aura",
    duration: "6 rounds"
  },
  {
    school: "unique",
    level: 6,
    name: "Null Totem",
    type: "Boost",
    longDesc: "Special: Void totems have a range of 60 feet.\nSpell Augment: 10 of a spell's damage becomes untyped damage.\n\nAura: Creatures within have their elemental resistance reduced by 15, DR reduced by 5, and their spell resistance lowered by 2.\nAwaken Spirit: Enemies have their elemental resistance and DR reduced to 0, and their spell resistance lowered by 5 for 1 round. This doesn't affect elemental immunity.",
    initiationAction: "movement",
    range: "30 feet",
    target: "15ft. Aura",
    duration: "6 rounds"
  },
  {
    school: "unique",
    level: 6,
    name: "Disruption Totem",
    type: "Boost",
    longDesc: "Special: Void totems have a range of 60 feet.\nSpell Augment: 10 of a spell's damage becomes untyped damage.\n\nAura: Movement within the area is teleportation and therefore does not provoke.\nAwaken Spirit: Teleport a creature in the area to another spot within the area or next to you, or you adjacent to the totem. Will save negates.",
    initiationAction: "movement",
    range: "30 feet",
    target: "15ft. Aura",
    duration: "6 rounds"
  },
  {
    school: "unique",
    level: 5,
    name: "Healing Light Totem",
    type: "Boost",
    longDesc: "Spell Augment: +30 positive spell power.\n\nAura: Heals everything within for 1d8+wis (doesn't scale with light mastery) at the start of each of your turns.\nAwaken Spirit: Heal one creature within 30 feet for 4d8+wis and it gains an equal amount of temporary hit points for 1 round. (1d8+wis, +1d8 per 3 levels, DOES scale with light mastery)",
    initiationAction: "movement",
    range: "30 feet",
    target: "15ft. Aura",
    duration: "6 rounds"
  },
  {
    school: "unique",
    level: 5,
    name: "Guardian Totem",
    type: "Boost",
    longDesc: "Spell Augment: +30 positive spell power.\n\nAura: Totem gains cha x level hp. Creatures within the area have half of their damage redirected to the totem as the shield other spell.\nAwaken Spirit: Creatures within the area take no damage this turn as long as the totem is standing (the totem still takes the 50% damage that an ally would have taken).",
    initiationAction: "movement",
    range: "30 feet",
    target: "15ft. Aura",
    duration: "6 rounds"
  },
  
    {
        school: `brutalCrocodile`,
        level: 1,
        name: `Ensnare`,
        type: `Boost`,
        initiationAction: `immediate`,
        range: `Melee`,
        target: `You`,
        duration: `Instant`,
        longDesc: `As you strike, you seize the opportunity and grab hold of your foe. When you hit a target with a melee attack using a discipline weapon, you may activate this boost to immediately initiate a grapple against the target.`,
        },
        {
        school: `brutalCrocodile`,
        level: 1,
        name: `Expert Grip`,
        type: `Boost`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`,
        longDesc: `You utilize your skill at carrying yourself to carry your foe much in the same way. After the initiating this boost, if you make a grapple check at any point in the round, you may make a climb check and use the result in place of your grapple check. You may add any bonuses from items, feats, or abilities that you possess to this check that would normally apply to grapple checks.`,
        },
        {
        school: `brutalCrocodile`,
        level: 1,
        name: `Hungry Jaws`,
        type: `Stance`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`,
        longDesc: `Your bare hands lash out, snagging the target in your clutches. Any attacks you make with discipline weapons gain the Grab property. In addition, you gain the constrict ability, dealing 1d6 + your strength modifier points of bludgeoning damage every round that you maintain a grapple. If you already possess the constrict ability from another source or are already dealing damage as part of maintaining a grapple, you instead deal 1d6 additional damage when using such abilities.`,
        },
        {
        school: `brutalCrocodile`,
        level: 1,
        name: `Painbringer`,
        type: `Stance`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`,
        longDesc: `You force yourself onto the opponent while grappling with them, complicating their resistance further. Any creature you are grappling has the dexterity penalty from grappling increased from -4 to -8, and takes a -4 penalty on attack rolls and combat maneuver checks rather than -2.`,
        },
        {
        school: `brutalCrocodile`,
        level: 1,
        name: `Snatching Talons`,
        type: `Strike`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Initiated grapple`,
        longDesc: `You adeptly tear through your foe's defenses and begin crushing them in your hands. Initiate a grapple attempt against the target, which does not provoke an attack of opportunity. On a success, you deal 1d8 points of damage to the target, and deal 1d8 points of damage every time you maintain a grapple. This damage stacks with that from the constrict special ability.`,
        },
        {
        school: `brutalCrocodile`,
        level: 1,
        name: `Trampling Pin`,
        type: `Strike`,
        initiationAction: `standard or [G]`,
        range: `Grappled`,
        target: `One creature grappled by you`,
        duration: `Instant`,
        longDesc: `[G]You slam your foe into the ground with excessive force and hold them down. This maneuver causes the target to gain the pinned condition and deals 2d8 points of damage. You still keep the grappled condition so long as you continue to pin the opponent.`,
        },
        {
        school: `brutalCrocodile`,
        level: 2,
        name: `Agile Redirection`,
        type: `Counter`,
        initiationAction: `immediate`,
        range: `Melee`,
        target: `Attacking Creature`,
        duration: `1 round`,
        longDesc: `You turn a foe's momentum against them and shove them across the field. When a foe makes a melee attack against you, make a Climb check opposed by their attack roll. If your result exceeds theirs, the attack is completely negated, and you may move the target 10 feet in any direction of your choice (this movement provokes attack of opportunity).`,
        },
        {
        school: `brutalCrocodile`,
        level: 2,
        name: `Anaconda's Coils`,
        type: `Boost`,
        initiationAction: `swift`,
        range: `Melee`,
        target: `Creature you are grappling`,
        duration: `Instant`,
        longDesc: `In a flash, you pounce on your opponent and slam them into the ground, pressing all of your weight on top of them. When you initiate this boost, make a Climb check. If the result exceeds the target's CMD, you immediately pin the creature.`,
        },
        {
        school: `brutalCrocodile`,
        level: 2,
        name: `Bestial Dash`,
        type: `Strike`,
        initiationAction: `standard or [G]`,
        range: `Melee`,
        target: `One creature`,
        duration: `Instant`,
        longDesc: `[G]Prey in hand, the initiator rushes across the battlefield. Make a move action using your standard movement speed as opposed to your diminished grappled speed. This movement provokes attack of opportunity as normal. Creatures you are grappling move with you, maintaining the same relative position to you all throughout the movement. If a grappled creature would end its turn in the same space as another creature or object or would collide with an object or creature in a way that would stop it being moved, both entities take 2d10 damage.`,
        },
        {
        school: `brutalCrocodile`,
        level: 2,
        name: `Gar Rush`,
        type: `Strike`,
        initiationAction: `full-round`,
        range: `Melee charge`,
        target: `One creature`,
        duration: `Initiated grapple`,
        longDesc: `You rush at your quarry and thrash yourself to them as they struggle to avoid you. Make a charge at the target, initiating a grapple attempt that does not provoke an attack of opportunity rather than making an attack. You receive a +2 bonus on this grapple attempt. On a success, you deal 2d6 points of damage to the target, and 2d6 points of damage every time you maintain a grapple. This damage stacks with that from the constrict special ability.`,
        },
        {
        school: `brutalCrocodile`,
        level: 3,
        name: `Catfish Hold`,
        type: `Stance`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`,
        longDesc: `Bracing yourself against the terrain, you steel yourself to control and redirect any oncoming assaults. While in this stance, you ignore any size modifiers to CMB that you or any creatures you are attempting to grapple possess, and may grapple creatures of any size. In addition, when you maintain a grapple, you deal an additional amount of damage equal to your initiation modifier.`,
        },
        {
        school: `brutalCrocodile`,
        level: 3,
        name: `Into the Earth`,
        type: `Strike`,
        initiationAction: `standard or [G]`,
        range: `Melee`,
        target: `Creature you are grappling`,
        duration: `Instant`,
        longDesc: `[G]You slam your prey down at your feet, dealing substantial injury from the force of your throw. The target is released from the grapple, but is immediately knocked prone and takes 2d10 points of damage.`,
        },
        {
        school: `brutalCrocodile`,
        level: 3,
        name: `Monkey Vault`,
        type: `Boost`,
        initiationAction: `swift`,
        range: `Melee`,
        target: `You and one creature or object`,
        duration: `1 round`,
        longDesc: `Snagging an opponent, you use them as a base as you vault over or around them. Make a Climb check against the foe's CMD. If successful, you may move to any square adjacent to the target, and the target is considered to be flat-footed until the end of your next turn.`,
        },
        {
        school: `brutalCrocodile`,
        level: 3,
        name: `Trapping Jaws`,
        type: `Counter`,
        initiationAction: `immediate`,
        range: `Melee`,
        target: `Attacking Creature`,
        duration: `Initiated grapple`,
        longDesc: `You snag your opponent in the midst of their attack, refusing to let go. When a creature makes a melee attack roll against you, you may initiate this counter to make a grapple check against the target. On a success, the creature's attack is negated, and you begin grappling the target. While grappling the creature, you deal 2d6 points of damage each round that you maintain the grapple (this stacks with any damage you may deal with constrict).`,
        },
        {
        school: `brutalCrocodile`,
        level: 4,
        name: `Alligator Suplex`,
        type: `Strike`,
        initiationAction: `standard or [G]`,
        range: `Melee`,
        target: `Creature you are grappling`,
        duration: `Instant`,
        longDesc: `[G]Wrapping your arms around a grappled target, you slam them into the ground with immense force. The creature takes an amount of damage equal to 4d10 damage and must make a Fortitude save or be dazed for one round (DC 14 + your initiation modifier). Initiating this maneuver automatically releases the creature from your grapple.`,
        },
        {
        school: `brutalCrocodile`,
        level: 4,
        name: `Bonebreaker Riposte`,
        type: `Counter`,
        initiationAction: `immediate`,
        range: `Melee`,
        target: `Attacking Creature`,
        duration: `1 round/level`,
        longDesc: `When faced with an attacker, you have learned that your best hope is to incapacitate them, preventing them from further assaults. When a creature makes a melee attack roll against you, you may initiate this counter to make a Climb check against the creature's attack roll. On a success, the creature's attack is negated, and it cannot for any purpose use the limb it used to make the attack for the duration of this maneuver.`,
        },
        {
        school: `brutalCrocodile`,
        level: 4,
        name: `Magebreaker`,
        type: `Boost`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `one round`,
        longDesc: `Some disciples of the Brutal Crocodile have learned pseudo-arcane techniques so as to handle supernaturally tenacious foes. Upon initiating this maneuver, you treat any creatures that you are grappling or that you grapple this turn as if they were under the effects of an Antimagic Field until the end of your next turn. This maneuver is a supernatural ability rather than an extraordinary one.`,
        },
        {
        school: `brutalCrocodile`,
        level: 4,
        name: `Silencing Grip`,
        type: `Strike`,
        initiationAction: `standard`,
        range: `Melee`,
        target: `One creature`,
        duration: `Instant`,
        longDesc: `As you grab hold of the target, you lock their jaw in place so to prevent their resistance. Make a grapple check against the target. On a success, the target cannot cast spells with verbal components or make attacks with a tongue or bite attack so long as you are grappling them. In addition, the target takes 6d6 points of damage each round that you maintain the grapple (this stacks with any damage you may deal with constrict).`,
        },
        {
        school: `brutalCrocodile`,
        level: 5,
        name: `Gut Crusher`,
        type: `Strike`,
        initiationAction: `standard or [G]`,
        range: `Melee`,
        target: `Creature you are grappling.`,
        duration: `1 round`,
        longDesc: `[G]You smash your opponent in several vulnerable areas, dealing 3d12 damage to the target. The target must succeed at a Fortitude save (DC 15 + your initiation modifier) or become unable to perform any actions save for trying to escape the grapple for one round. You may release the target from the grapple when you initiate this maneuver. If you do, a target which failed their save instead becomes nauseated for 1 round.`,
        },
        {
        school: `brutalCrocodile`,
        level: 5,
        name: `Kraken's Coils`,
        type: `Stance`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`,
        longDesc: `Like a tentacled beast of the deep, you have learned to hold foes in your clutches without the slightest impairment. While in this stance, all attacks that you make with discipline weapons gain the grab property, and you do not gain the grappled condition when grappling a creature. In addition, every round that you maintain a grapple, the grappled creature takes one point of constitution damage.`,
        },
        {
        school: `brutalCrocodile`,
        level: 5,
        name: `Meat Shield`,
        type: `Counter`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        longDesc: `An attacker finds its assault intercepted by a hapless creature in your grasp. When a creature makes a melee or ranged attack against you or you are forced to make a Reflex saving throw, you may block the threat using a creature you are grappling, gaining the benefits of improved cover. If you avoid the attack or succeed on the saving throw, the creature you are grappling is considered hit by that attack or failing his saving throw, and thus takes damage instead of you. You must be grappling a creature in order to use this counter.`,
        },
        {
        school: `brutalCrocodile`,
        level: 5,
        name: `Voracious Maul`,
        type: `Strike`,
        initiationAction: `standard or [G]`,
        range: `Melee`,
        target: `Creature you are grappling`,
        duration: `Instant`,
        longDesc: `[G]Letting loose with your unbridled feral fury, you plunge your armaments repeatedly into the hapless being in your coils. Make a full attack against a creature you are grappling. You may use all of your hands' worth of weapons for the purpose of this full attack if those hands would otherwise be used to grapple the creature under attack. This does not allow you to use weapons that you could not otherwise use while grappling.`,
        },
        {
        school: `brutalCrocodile`,
        level: 5,
        name: `Wing Ripper`,
        type: `Strike`,
        initiationAction: `standard or [G]`,
        range: `Melee`,
        target: `Creature you are grappling`,
        duration: `see text`,
        longDesc: `[G]You bend a grappled target's body in a way that hampers all attempts to move away. One creature that you are grappling takes 7d10 damage and must make a Fortitude save (DC 15 + your initiation modifier). On a failure, all of the creature's movement speeds are reduced to 0 for a number of rounds equal to your initiation modifier.`,
        },
        {
        school: `brutalCrocodile`,
        level: 6,
        name: `Atrophic Brutalization`,
        type: `Strike`,
        initiationAction: `standard`,
        range: `Melee`,
        target: `One Creature`,
        duration: `Initiated grapple`,
        longDesc: `Crippling your foe's muscles, you seize hold of your opponent and begin to compact them within your coils. Make an attack against a creature using a discipline weapon. On a successful hit, you initiate a grapple with the target while dealing 1d4 points of strength damage and 8d6 points of damage. You deal 8d6 points of damage each round that you successfully maintain the grapple (this stacks with any damage you may deal with constrict).`,
        },
        {
        school: `brutalCrocodile`,
        level: 6,
        name: `Blood in the Water`,
        type: `Boost`,
        initiationAction: `swift`,
        range: `Melee`,
        target: `Creature you are grappling`,
        duration: `Instant`,
        longDesc: `In a flash of adrenaline, you grab hold of a foe and immediately unleash your feral wrath upon it. When you initiate a grapple with a creature, you may activate this boost to initiate a single [G] maneuver as part of performing this boost.`,
        },
        {
        school: `brutalCrocodile`,
        level: 6,
        name: `Disfiguring Gouge`,
        type: `Strike`,
        initiationAction: `standard or [G]`,
        range: `Melee`,
        target: `Creature you are grappling`,
        duration: `Instant`,
        longDesc: `[G]Burrowing your weapon into their face, you inflict severe injury upon your foe's countenance. This maneuver deals 4d10 damage to the grappled creature alongside 1d8 Charisma damage. In addition, the target must make a Fortitude save (DC 16 + your initiation modifier) or become permanently blinded.`,
        },
        {
        school: `brutalCrocodile`,
        level: 6,
        name: `Insatiable Warpath`,
        type: `Stance`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`,
        longDesc: `Your explosive instinct boils over, your ensnared targets becoming implements of destruction. While in this stance, your attacks with discipline weapons gain the grab property, and you may maintain a grapple as a free action (this does not allow you to have or maintain multiple grapples against the same target). In addition, you may use grappled creatures as weapons, which have a base damage of 4d6 and a critical hit range of 20/x2. Any successful attacks with a grappled creature do the same amount of damage to the grappled creature as they do to the target.`,
        },
        {
        school: `brutalCrocodile`,
        level: 7,
        name: `Crushing Python`,
        type: `Strike`,
        initiationAction: `standard`,
        range: `Melee`,
        target: `One Creature`,
        duration: `Instant`,
        longDesc: `Seizing hold of the target, you wrap your body around them and begin crushing the life from their fragile form. Make an attack with a discipline weapon against the target. On as successful hit, you grapple the target and cause it to take 1d6 points of Constitution damage every round that you maintain the grapple.`,
        },
        {
        school: `brutalCrocodile`,
        level: 7,
        name: `Dismemberment`,
        type: `Strike`,
        initiationAction: `standard or [G]`,
        range: `Melee`,
        target: `Creature you are grappling`,
        duration: `Instant`,
        longDesc: `[G]Roaring furiously, you rip one the limbs from your grapple target, causing blood to come gushing from the wound. Choose either a grappled creature's arm or leg. You are treated as if you had succeeded at a called shot maneuver on the target and had dealt a debilitating blow to the limb and the target had failed their save by 5 or more. In addition, the target takes 3d6 points of bleed damage until a creature makes a Heal check (DC = 17 + your initiation modifier) to close the wound. Even if a creature lacks discernible arms or legs, you may still use this maneuver upon them to inflict the bleed damage, although the maneuver has no other effects.`,
        },
        {
        school: `brutalCrocodile`,
        level: 7,
        name: `Hippo Press`,
        type: `Strike`,
        initiationAction: `standard or [G]`,
        range: `Melee`,
        target: `Creature you are grappling`,
        duration: `Instant`,
        longDesc: `[G]In a smooth motion, you slam your helpless foe into the ground beneath you and prepare yourself to fight off oncoming attackers. When you initiate this maneuver, the target takes 11d8 damage while gaining the pinned condition. Upon initiating the maneuver, you lose the grappled condition, but are still considered to be pinning the target so long as you do not move from your position.`,
        },
        {
        school: `brutalCrocodile`,
        level: 7,
        name: `Meteoric Suplex`,
        type: `Strike`,
        initiationAction: `standard or [G]`,
        range: `Melee, see text`,
        target: `See text`,
        duration: `Instant`,
        longDesc: `[G]Lunging from the ground at high speed, you slam your target into the dirt, injuring any unfortunate enough to stand in the way. You must be grappling a creature to initiate this maneuver. Make a charge attack against a creature within charge range of you, ignoring any difficult terrain between you. This attack deals 10d10 damage to the target as well as the grappled creature on a successful hit. In addition, any creatures within 15 feet of where you end your charge take 2d10 damage (Reflex save for half, DC 17 + your initiation modifier).`,
        },
        {
        school: `brutalCrocodile`,
        level: 8,
        name: `Gorgonops' Jaws`,
        type: `Stance`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`,
        longDesc: `As you assume a fighting position, your hands tense, prepared to unleash your nightmarish wrestling skills on your victim as soon as your hands take hold. While you maintain this stance, any attacks that you make with discipline weapons gain the grab ability. In addition any time that you initiate a grapple with another creature, you may initiate a maneuver with the [G] descriptor as a free action once per round.`,
        },
        {
        school: `brutalCrocodile`,
        level: 8,
        name: `Gorilla Backbreaker`,
        type: `Strike`,
        initiationAction: `standard or [G]`,
        range: `Melee`,
        target: `Creature you are grappling`,
        duration: `Instant`,
        longDesc: `[G]In a monumental display of grappling, you slam your grappled quarry down and brutalize their body, severely crippling their capacity to act. A creature that you are grappling takes 10d12 damage alongside 3d4 dexterity damage.`,
        },
        {
        school: `brutalCrocodile`,
        level: 8,
        name: `Impossible Hurl`,
        type: `Strike`,
        initiationAction: `standard or [G]`,
        range: `see text`,
        target: `See text`,
        duration: `Instant`,
        longDesc: `[G]Drawing upon the might of your entire body, you heft your target as a massive projectile that flies across the battlefield. Make a ranged attack using a grappled creature as a thrown weapon with no penalty for throwing the target two-handed or using an improvised weapon. You may use your Strength modifier in place of your dexterity modifier for the attack roll. Make a Climb check to determine the range of this attack, with the attack's maximum range being set at 5 ft x the result of the Climb check. If the thrown creature hits a target, its base damage is 15d12, with the thrown creature taking the same amount of damage as the target it was thrown at.`,
        },
        {
        school: `brutalCrocodile`,
        level: 9,
        name: `Event Horizon`,
        type: `Strike`,
        initiationAction: `standard or [G]`,
        range: `Melee`,
        target: `Creatures you are grappling`,
        duration: `see text`,
        longDesc: `[G]Your grappling abilities operate in more than three dimensions, enabling you to restrain your targets by bending the physical universe itself. All creatures you are grappling must make a Reflex save or be banished to the Astral Plane. Failure indicates that the target is shifted body and all into the Astral Plane and may not return to the Material Plane for one hour. If a foe has no way to return to the Material Plane after this duration has expired, it is effectively stranded and must find its own way back to its world. Those that succeed on their save have remain on the Astral Plane for only a single round before returning to their previous position. While in the Astral Plane, the target is tethered to his body at the location he occupied before being pushed into the Astral Plane with a silver cord as normal (per astral projection). You may pull targets you have sent to the Astral Plane with this maneuver back into your world as a standard action. When a creature is pulled back or returns after having succeeded at a saving throw, they appear in a square adjacent to you and you may attempt to grapple them again as an immediate action.`,
        },
        {
            school: `brutalCrocodile`,
            level: 9,
            name: `Doomstone Tombstone`,
            type: `Strike`,
            initiationAction: `full-round`,
            range: `Melee`,
            target: `1 Creature`,
            duration: `see text`,
            longDesc: `The ultimate and way better and cooler ultimate technique of the brutal crocodile with a way better name. When you initiate this maneuver you move up to your movement speed in a straight line towards the target until they are in grapple range, then you make a grapple attempt against them. If you succeed, you grab onto the target, leaping through the air, continuing in a straight line an equal distance the amount you moved towards the creature, you also make a climb check to see how many feet high you travel. Then, once you reach the destination you spin and travel straight down, slaming them into the ground with such force that you smash their body straight through the floor, leaving only their legs dangling out. When you slam them into the ground, they take 20d6 points of damage, then you stop grappling them. Despite this, the creature remains grappled and pinned by the ground until it escapes. While stuck in the ground, the creature suffers the penalties you give from to a creature you are grappling and pinning, even though you are not, and in order to escape, it requires checks as if escaping from your grapple. 
            \nSince part of the creature is still stuck out of the top, the creature is still valid to be targeted, and may be able to use certain abilities of its own if it can use them while pinned and grappled (though its head is normally underground). When you are slamming them down on the ground, for every 10 feet dropped, the DC to escape and the damage increases by +1 and 2d6 respectively (max +10, and +20d6). If when you use this maneuver instead of colliding with the ground first, you collide with a creature (or multiple depending on the creature's sizes), you slam your target down onto them, dealing the maneuvers damage to them and the target of the maneuver and you knock both of them prone (instead of driving the target into the ground). This damage is increased by +15% for each size above medium the target of the maneuver is (-20% for sizes below medium). This is a supernatural maneuver and works even on indestructable terrain. But if it does, it leaves no side-effects to the terrain once the creature escapes from the ground.`,
    },
    {
        school: `blackSeraph`,
        level: 1,
        name: `Black Seraph's Glare`,
        type: `Stance`,
        shortDesc: `Damage foes to make a demoralization attempt as a free action with a +4 profane bonus.`,
        longDesc: `Disciples of the Black Seraph know that half the battle is won through the mind, and by attacking his opponent's mind with fear, he can goad him to make mistakes and shatter his resolve and confidence. While in this stance, the disciple may make Intimidate checks to demoralize foes as a free action, but only against those that he has damaged that turn. He gains a +4 profane bonus (see Intimidate skill description for details) to these Intimidate checks.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `blackSeraph`,
        level: 1,
        name: `Gutstrike`,
        type: `Strike`,
        shortDesc: `Make an attack, chance to sicken opponent for one round.`,
        longDesc: `With a ruthless attack or a powerful kick, the disciple strikes a foe in a way that causes him to become sickened with pain. The discipline makes a melee attack against a foe, adding his initiation modifier to the damage of the attack and the target must make a Fortitude save (DC 11 + primary initiating attribute modifier) or be sickened for one round.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `1 round`,
        savingThrow: `Fort negates`
      },
      {
        school: `blackSeraph`,
        level: 1,
        name: `Ravaging Blow`,
        type: `Strike`,
        shortDesc: `Make an attack, inflict an additional 1d6 points of profane damage and the target is shaken for one round.`,
        longDesc: `[evil, fear]; Fear is one of the main weapons in the arsenal of a Black Seraph disciple, and by using it he may shake his opponent to their core. The disciple makes a melee attack that inflicts an additional 1d6 points of profane damage and may cause the victim to be shaken for one round due to his fearful countenance and martial prowess. A successful Will save (DC 11 + initiation modifier) negates the shaken effect.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `One round`,
        savingThrow: `Will partial`
      },
      {
        school: `blackSeraph`,
        level: 1,
        name: `Savage Stance`,
        type: `Stance`,
        shortDesc: `When wielding a weapon in two hands, -2 to attacks and add an additional 1d8 points of damage.`,
        longDesc: `The blood is the life and the disciple of the Black Seraph knows that by spilling it in great amounts, he does glory to the lower planes. While in this stance and wielding a melee weapon in two hands, the disciple adds an additional 1d8 points of damage to his attacks but suffers a -2 to attack rolls from the focus on increased damage. Upon reaching initiator level 9, this bonus increases to 2d8 points of damage, and increases to 3d8 upon reaching initiator level 17.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `blackSeraph`,
        level: 1,
        name: `Strength of Hell`,
        type: `Boost`,
        shortDesc: `Gain +2 profane bonus to attack rolls, add 1d6 points of damage, -2 penalty to AC.`,
        longDesc: `By utilizing his bond to the lower planes from his training, the darkness he welcomed as his own, the martial disciple is capable of increasing his power at the cost of defense by bringing forth a momentary burst of hysterical fiendish strength. Until next turn, the disciple gains a +2 profane bonus to attack and add an additional 1d6 points of damage to the attack, but you receive a -2 penalty to ac for 1 round.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `One round`
      },
      {
        school: `blackSeraph`,
        level: 1,
        name: `Voracious Drive`,
        type: `Strike`,
        shortDesc: `Charging attack, deals an additional 1d6 damage.`,
        longDesc: `The relentless nature of the Black Seraph discipline's philosophy deems that progression must be made with each swing, lest the battle turn against the disciple. With this philosophy in mind, the disciple moves forward and strikes viciously. The disciple makes a charge attack which does not provoke attacks of opportunity, and this inflicts an additional 1d6 points of damage. When making a charge attack with this strike, he does not suffer the standard -2 Armor Class penalty.`,
        initiationAction: `full-round`,
        range: `full-round action`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `blackSeraph`,
        level: 2,
        name: `Fear Eating Technique`,
        type: `Boost`,
        shortDesc: `Successful demoralization restores 2d6 +1/initiator level in hit points.`,
        longDesc: `[evil]  The disciple's soul hungers for the fear it inspires on the battlefield, and rewards can be gained by inspiring it with greater vigor. Upon successful demoralization of an enemy, initiating this boost restores 2d6 hit points to the disciple, plus an additional +1 hit point per initiator level. This is a supernatural maneuver.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Instant`
      },
      {
        school: `blackSeraph`,
        level: 2,
        name: `Inner Demon Strike`,
        type: `Strike`,
        shortDesc: `Attack deals an additional 4d6 points of profane damage; initiator suffers 1d6 points of damage.`,
        longDesc: `[evil]  By using the black energies within him as a weapon, the disciple may channel it through his mortal form to do devastating damage to his foes, all the while heedless of the damage inflicted upon his body. This black energy inflicts an additional 4d6 points of profane damage, which also deals 1d6 points of damage to the initiator.`,
        initiationAction: `standard`,
        range: `Melee attack `,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `blackSeraph`,
        level: 2,
        name: `Intimidating Force`,
        type: `Counter`,
        shortDesc: `Make an Intimidate check to avoid an attack.`,
        longDesc: `By using this technique, the disciple's fear-inspiring countenance alone may turn aside attacks before they occur. The disciple makes an Intimidate check against the attacker's attack roll; if the Intimidate check exceeds the attack roll then the attack is negated.`,
        initiationAction: `immediate`,
        range: `Personal `,
        target: `You `,
        duration: `Instant`
      },
      {
        school: `blackSeraph`,
        level: 2,
        name: `Seraph's Wrath`,
        type: `Strike`,
        shortDesc: `Melee strike that adds +2d6 damage and forces your foe to make a Reflex save to not be knocked prone.`,
        longDesc: `The Black Seraph disciple uses the principles of overwhelming force to drive his opponent back so that he may continue to wade forward towards conquest. The disciple makes a melee attack against a target creature that inflicts an additional 2d6 points of damage and causes the target to make a Reflex save (DC 12 + initiation modifier) or be knocked prone.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`,
        savingThrow: `Reflex partial`
      },
      {
        school: `blackSeraph`,
        level: 2,
        name: `Shadow Feather Strike`,
        type: `Strike`,
        shortDesc: `Ranged touch attack that attacks your foe with feathers of shadow doing 4d6 + initiator level profane damage.`,
        longDesc: `[evil]; By concentrating dark, spiritual energy within his hand shaping it into a rough feather-like shape, the disciple may hurl his wrath at a target with a blade of a cutting hate. When initiating this strike, the disciple makes a ranged touch attack against a target that inflicts 4d6 + initiation modifier in profane damage.`,
        initiationAction: `standard`,
        range: `30-ft`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `blackSeraph`,
        level: 3,
        name: `Black Seraph Battle Stance`,
        type: `Stance`,
        shortDesc: `The initiator's weapon gains the unholy special weapon property and he gains the benefits of a protection from good spell.`,
        longDesc: `[evil]; The Black Seraph discipline teaches its disciples that relentless aggression is what wins battles, and by channeling the very might of the lower planes themselves through his form, does he gain the advantage he yearns for. Some who have witnessed a disciple of Black Seraph using this stance have seen plants wither and turn to ash around them and hazy, smoky wings appear around the disciple. Others have seen hellfire licking over their bodies. Regardless, while in this stance, any weapon that the martial disciple wields is treated as if it had the unholy special weapon property. Additionally, he is considered under the influence of a protection from good spell with a caster level equal to his initiator level.`,
        initiationAction: `swift`,
        range: `Personal `,
        target: `You `,
        duration: `Stance`
      },
      {
        school: `blackSeraph`,
        level: 3,
        name: `Savage Drive`,
        type: `Strike`,
        shortDesc: `Charging attack, deals an additional 4d6 damage.`,
        longDesc: `Ever hungry for carnage, the demonic disciple demands action and satisfaction through battle. Pressing forward with ruthless efficiency, the disciple inflicts more damage than his foes, thus outlasting them. The disciple makes a charge attack which does not provoke attacks of opportunity, and this inflicts an additional 4d6 points of damage. When making a charge attack with this strike, he does not suffer the standard -2 Armor Class penalty.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `blackSeraph`,
        level: 3,
        name: `Taunting Laugh`,
        type: `Boost`,
        shortDesc: `Make an Intimidate check to give your opponent pause, causing your foe to become demoralized and flat-footed.`,
        longDesc: `With an intimidating growl and mighty laugh at his pitiful opponents, the Black Seraph disciple causes his foe's resolve to weaken and his anger to stoke, allowing him to make the tragic mistake of giving the disciple the upper hand. As a swift action, the disciple makes a demoralization attempt against a foe, and if successful, in addition to demoralizing the foe, the target is struck flat-footed until the end of the disciple's next turn.`,
        initiationAction: `swift`,
        range: `30-ft`,
        target: `One creature`,
        duration: `One round`
      },
      {
        school: `blackSeraph`,
        level: 3,
        name: `Tendon Rip`,
        type: `Strike`,
        shortDesc: `Melee attack inflicts an additional 2d6 points of damage; halves the opponent's move speed for 1d4 rounds.`,
        longDesc: `By striking at the legs of the opponent, the disciple removes the mobility of a foe, so the foe cannot hamper his progression to victory. The initiator makes an attack on the target creature, and if successful, the attack inflicts an additional 2d6 points of damage and halves the opponent's move speed for initiation modifier in rounds.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `blackSeraph`,
        level: 3,
        name: `Unfettered Progression`,
        type: `Boost`,
        shortDesc: `Make a 10-ft movement without attacks of opportunity, next attack inflicts +2d6 points of damage and ignores DR.`,
        longDesc: `By unceasing movement in combat, the Black Seraph disciple moves into a more beneficial position to deliver a deadly blow. After attacking, he may make a free 10-ft movement without provoking attacks of opportunity and the next attack he makes inflicts an additional 2d6 points of damage that ignores damage reduction.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Instant`
      },
      {
        school: `blackSeraph`,
        level: 4,
        name: `Bilious Strike`,
        type: `Strike`,
        shortDesc: `Powerful strike that damages the target's insides, inflicting +6d6 profane damage and nauseates.`,
        longDesc: `[evil]; With a powerful strike to the abdomen, the Black Seraph disciple fills his opponent with destructive unholy power. The disciple's aim is to rupture organs within to kill his subject painfully. The initiator must make a melee attack against a target creature, and if successful the attack inflicts an additional 6d6 points of profane damage and nauseates the target for the disciple's initiation modifier in rounds. The target may make a Fortitude save (DC 14 + initiation modifier) to reduce the nauseated condition to one round.`,
        initiationAction: `standard`,
        range: `Melee`,
        target: `One creature`,
        duration: `Instant`,
        savingThrow: `Fortitude partial`
      },
      {
        school: `blackSeraph`,
        level: 4,
        name: `Circle of Razor Feathers`,
        type: `Strike`,
        shortDesc: `Make a 30-ft area attack of cutting feathers, resulting in 8d6 points of profane damage and potentially sicken foes.`,
        longDesc: `[evil]; When surrounded, a disciple of the Black Seraph may lay low many foes by the force of his hellish wrath. By crying out in horrible rage and raising his weapon straight up to the sky, the disciple's foes are showered with dozens of needles of dark energy which inflict 8d6 points of profane damage. The pain- filled nature of this attack has the potential to sicken targets with wracking agonies for the character's initiation modifier in rounds. This maneuver allows a Reflex saving throw (DC 14 + initiation modifier) for half damage and to reduce the sickened condition's duration to one round.`,
        initiationAction: `standard`,
        range: `30 ft. Area: 30-ft.-radius burst centered on you.`,
        target: ``,
        duration: `Instant`,
        savingThrow: `Reflex partial`
      },
      {
        school: `blackSeraph`,
        level: 4,
        name: `Vengeful Riposte`,
        type: `Counter`,
        shortDesc: `Make a free counterattack at target and target is staggered with agony.`,
        longDesc: `Disciples of the Black Seraph have trained themselves to look for openings while enemies attack, then respond with agonizing retorts, as vengeance is a creed the Black Seraph embraces. The disciple makes an attack at his full base attack bonus against his attacker which if successful sends a cascade of pain through the target and inflicts the staggered condition for one round.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instant`
      },
      {
        school: `blackSeraph`,
        level: 4,
        name: `Walk in the Dark`,
        type: `Stance`,
        shortDesc: `Initiator is surrounded by an aura of darkness, gains darkvision and may frighten foes within this aura.`,
        longDesc: `Using the principles of shadow and temporarily merging with the dark, the Black Seraph disciple becomes engulfed in smothering darkness and fear. While in this stance, the initiator is surrounded by a 20-ft. radius aura of darkness (this functions identically to the darkness spell while the character is in this stance). The initiator gains darkvision of 60 ft. while in this stance. Additionally, as a move action, the disciple may focus this smothering darkness to target an individual within it to frighten them for their initiation modifier in rounds (Will save DC 14 + initiation modifier reduces this to being shaken for one round).`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Instant`
      },
      {
        school: `blackSeraph`,
        level: 5,
        name: `Abyssal Lance`,
        type: `Strike`,
        shortDesc: `Ranged touch attack which deals 10d6 points of profane damage, chance to stun.`,
        longDesc: `[evil]; Those who have become masters of the Black Seraph discipline have learned that by focusing the rage within themselves, they may use it as a weapon of pure destruction at the cost of their self. These disciples know that so long as their foe is destroyed, pain is inconsequential. By summoning forth this rage and channeling it through their form, they may will a lance of venomous rage and pain into existence and fling at their enemy. This is a ranged touch attack which deals 8d6 points of profane damage and stuns a foe for one round with wracking pain (Fortitude save DC 15 + initiation modifier negates the stunned condition).`,
        initiationAction: `standard`,
        range: `Close (25 ft + 5-ft/initiator level)`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `blackSeraph`,
        level: 5,
        name: `Sensory Rip`,
        type: `Strike`,
        shortDesc: `Strike at the face of an opponent, inflicts an additional 1d4 Charisma damage and has a chance to blind the opponent.`,
        longDesc: `With a high swing towards the face of his opponent, the Black Seraph disciple attempts to shatter the confidence and appearance of his enemy and remove from them the ability to see in the cruelest fashion with painful, scarring wounds. The initiator makes a melee attack against his foe, and if successful, this strike inflicts an additional 1d4 points of Charisma damage and potentially blinds the target creature on a failed Reflex saving throw (DC 15 + initiation modifier negates blindness).`,
        initiationAction: `standard`,
        range: `Melee`,
        target: `One creature`,
        duration: `Instant`,
        savingThrow: `Reflex partial`
      },
      {
        school: `blackSeraph`,
        level: 5,
        name: `Sharing the Dark Soul`,
        type: `Strike`,
        shortDesc: `Make an attack, deals an additional 8d6 profane damage, imposes a -4 penalty on Will saves and level to resist demoralization attempts.`,
        longDesc: `[evil, mind-affecting]; By channeling their own internal despair and anguish, the disciple shares this inner pain with his enemies. A burst of crackling energy accompanies the strike as the inner fiend reaches out and touches the mind of its victim. The initiator makes an attack which deals an additional 8d6 points of profane damage, and the foe is dazed with pain for one round on a failed Fortitude save (DC 15 + initiation modifier negates dazed condition).`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `One round`
      },
      {
        school: `blackSeraph`,
        level: 5,
        name: `Soul Consumption`,
        type: `Boost`,
        shortDesc: `Draw power and health from fallen foes, healing 3d8 plus initiator level upon killing a target.`,
        longDesc: `[evil]; The fiendish energy channeled by the disciple hungers for the souls of fallen foes and it rewards the disciple with its unquenchable thirst. When the initiator reduces a foe (minimum 1/2 HD) to 0 hit points or less, he may use this boost to draw the remaining life force of the foe into his own form to restore health to his body. Use of this maneuver restores 3d8 + initiator level hit points to the initiator.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `blackSeraph`,
        level: 6,
        name: `Abyssal Drive`,
        type: `Strike`,
        shortDesc: `Charging attack, deals an additional 8d6 points of damage, leaves foe sickened for 1d4 rounds.`,
        longDesc: `The path of the conqueror demands satisfaction, and the disciple of the Black Seraph learns perfection in conquest by the ever progressing tide of battle. Pressing forward with infernally enhanced power, the disciple moves to devastate his next foe with the rage within his soul. The disciple makes a charge attack which does not provoke attacks of opportunity, and this inflicts an additional 8d6 points of damage and leaves his foe sickenedfor 1d4 rounds. If the victim successfully makes a Fortitude save (DC 16 + initiation modifier), he negates the sickened condition. When making a charge attack with this strike, he does not suffer the standard -2 Armor Class penalty.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `blackSeraph`,
        level: 6,
        name: `Black Seraph's Wrath`,
        type: `Boost`,
        shortDesc: `Make an Intimidate check, add the result as profane damage to next successful attack.`,
        longDesc: `[evil]; The disciple of the Black Seraph's anger and wrath are his strongest weapons, and in concentrating this hatred into his attacks, he may cause a horrible black power to invade the wounds of his foes to cause even more injury. The initiator makes an Intimidate check and the result of this check is added to his damage roll as profane damage on his next successful attack.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `One round`
      },
      {
        school: `blackSeraph`,
        level: 6,
        name: `Razor Wings of the Black Seraph`,
        type: `Stance`,
        shortDesc: `Gain a fly speed, +2 profane bonus to AC, and gain the use of the Whirlwind Attack feat.`,
        longDesc: `[evil]; The graceful hunting techniques of fallen angels lend their strength to the hellish Black Seraph disciple by his adoption of this stance. He becomes preternaturally graceful and deadly, his dark soul assisting his movements in combat by forming an ethereal image of a hellish angelic form and wings of shadow. While in this stance, the character gains a fly speed equal to his movement speed (average maneuverability), a +2 profane bonusto AC, and he gains the use of the Whirlwind Attack feat (he does not need to meet the prerequisites for use of this feat).`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `blackSeraph`,
        level: 6,
        name: `Shadow Raptor Swarm`,
        type: `Strike`,
        shortDesc: `A 30-ft cone of screaming, shadowy birds causing 12d6 profane damage and leaves foes shaken.`,
        longDesc: `[evil, mind-affecting]; The power of a Black Seraph disciple's hatred is made manifest by summoning a swarming mass of beating wings with razor tipped wings made of shadow that he directs at his foes in a cone of terror and rage. The initiator extends his hand or weapon and from this point a 30-ft cone of shadowy birds rip and rend at the disciple's foes and inflict 12d6 points of profane damage; a successful Reflex save (DC 16 + initiation modifier) halves this damage. All targets within this maneuver's effects are shaken for the disciple's initiation modifier in rounds.`,
        initiationAction: `standard`,
        range: `30-ft cone`,
        target: ``,
        duration: `Instant`,
        savingThrow: `Reflex half`
      },
      {
        school: `blackSeraph`,
        level: 7,
        name: `Armageddon Lance`,
        type: `Strike`,
        shortDesc: `Ranged touch attack which deals an additional 14d6 points of damage and panics target.`,
        longDesc: `[evil, mind-affecting]; One the supreme arts of the Black Seraph discipline allows the disciple to call upon the fell and eternal wrath of his dark agreement with the lower planes and use it as a devastating lance of destructive unholy terror. This is a ranged touch attack which deals 14d6 points of profane damage, but the cost of creating this powerful attack requires sacrifice by the host, resulting in the initiator suffering 2d6 points of damage. Foes struck by this potent attack must make a Will save (DC 17 + initiation modifier) or be panicked for one round.`,
        initiationAction: `standard`,
        range: `Close (25-ft + 5-ft/initiator level)`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `blackSeraph`,
        level: 7,
        name: `Charge of the Ravager`,
        type: `Strike`,
        shortDesc: `Make a charge attack, may make a full attack upon target, make attacks on foes along charge path, inflicts +2d6 points of damage per attack without provoking attacks of opportunity.`,
        longDesc: `The path to victory is not a curved line, it is a straight, bloody line. The Black Seraph teaches its disciples this and urges them to greater glory and carnage on the field of battle. The disciple makes a charge attack against an opponent to start this maneuver and he may make a full attack upon the target of this charge. This charge does not provoke attacks of opportunity. The disciple may also make one attack at his highest attack bonusagainst any opponent along his charge path, and all successful attacks inflict an additional 2d6 points of damage. He may only make one attack per target when he initiates this maneuver.`,
        initiationAction: `full-round`,
        range: `Up to twice base movement`,
        target: `One creature and all adjacent targets along charge path`,
        duration: `Instant`
      },
      {
        school: `blackSeraph`,
        level: 7,
        name: `Consumption Strike`,
        type: `Strike`,
        shortDesc: `Make an attack, deals an additional +10d6 points of damage, gain this damage as temporary hit points.`,
        longDesc: `[evil]; By channeling dark energies from the lower planes, the disciple of the Black Seraph may utilize this vampiric power through his attack, restoring health and strength to him at the cost of his foe's vitality. This strike deals an additional 10d6 points of profane damage, and the disciple gains a number of temporary hit points equal to the damage dealt by this strike. These hit points persist for up to one minute or until they are lost.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `blackSeraph`,
        level: 7,
        name: `Devastating Riposte`,
        type: `Counter`,
        shortDesc: `Intimidate check against an attack, counter attack that adds 8d6 points of damage.`,
        longDesc: `The battle-hardened nature of the disciple of the Black Seraph can be shown in their ability to take a hit and give it back to their attacker three-fold. The disciple makes an Intimidate check against the attacker's attack roll, if successful then the disciple may make an attack at his full base attack bonus against the attacker that inflicts an additional 8d6 points of damage.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `blackSeraph`,
        level: 8,
        name: `Apocalyptic Strike`,
        type: `Strike`,
        shortDesc: `Damaging attack which deals 16d6 in 40-ft radius and daze opponents within for one round.`,
        longDesc: `[evil]; This master level technique of the Black Seraph discipline allows its disciples to bring forth the true power of destruction from the darkness within. By letting out a cry of rage and driving his weapon into the ground at his feet, he lets forth a burst of destructive energy to all surrounding him, friend or foe. This destructive wrath inflicts 16d6 points of profane damage to all targets within a 40-ft radius burst, centered on the initiator. The power of this blast is such that it may daze all affected creatures for one round with unholy agony that were not quick enough to avoid the worst of the assault. Those caught within the blast of dark energy may attempt a Reflex save (DC 18 + initiation modifier) for half damage and to negate the dazed condition.`,
        initiationAction: `standard`,
        range: `40-ftArea: 40-ft-radius burst centered on you`,
        target: ``,
        duration: `Instant`,
        savingThrow: `Reflex half`
      },
      {
        school: `blackSeraph`,
        level: 8,
        name: `Soul Crusher`,
        type: `Strike`,
        shortDesc: `Strike which attacks the opponent's will to live, inflicting +3d4 Charisma damage.`,
        longDesc: `[evil]; With a mighty swing or the barest tap, the rage and hatred within the Black Seraph infects his foe and destroys his resolve and very will to live. The initiator makes a melee attack against a target creature, and if successful the attack inflicts an additional 3d4 points of Charisma damage as the essence of the target's self is devoured by the disciple's hatred for his existence.`,
        initiationAction: `standard`,
        range: `Melee`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `blackSeraph`,
        level: 8,
        name: `Vampiric Aura`,
        type: `Stance`,
        shortDesc: `20 ft radius aura which deals 2d6 profane damage to all within it and heals a like amount to the initiator.`,
        longDesc: `[evil]; By opening one's self to the eternal hunger of the darkness that resides with the disciple, he may use himself as a filter for the life energies that feed this dark urge. At the end of the disciple's turn, he inflicts 2d6 points of profane damage on all living creatures within his 20-ft aura, gaining a like amount of temporary hit points. These temporary hit points persist until the end of the encounter, the initiator leaves this stance, or until they are lost. If an initiator already has a pool of temporary hit points from this stance, when it subsequently grants him new temporary hit points he either replaces his current pool with the new number or retains his current pool, whichever is greater. The initiator may exclude a number of allies from this damage equal to initiation modifier.`,
        initiationAction: `swift`,
        range: `20-ft radius centered on the initiator`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `blackSeraph`,
        level: 8,
        name: `Void Seraph Strike`,
        type: `Strike`,
        shortDesc: `Ranged touch attack causing a foe to be covered in shadowy birds causing 6d6 points of damage per round for 1d4 rounds. This also this gives the foe a 50% miss chance for you and your allies`,
        longDesc: `[evil]; The Black Seraph disciple's power and mastery is nearly complete, and with this maneuver he may dismiss his hatred and set it upon a foe to devour the fool who would stand before him. The initiator must make a ranged touch attack against a target creature, and if successful the target is ripped and slashed by the claws and wings of shadowy birds of venomous hate, taking 6d6 points of profane damage per round for 1d4 rounds. While being devoured by these shadowy birds, the target suffers a 50% miss chance on any attacks he makes due to his senses being obscured by the flapping wings and horrible pain he is enduring.`,
        initiationAction: `standard`,
        range: `30-ft`,
        target: `One creature`,
        duration: `1d4 rounds`
      },
      {
        school: `blackSeraph`,
        level: 9,
        name: `Black Seraph Onslaught`,
        type: `Strike`,
        shortDesc: `Make an extra attack at your full base attack bonus, -2 to hit and to AC, deals an additional 4d6 points of profane damage and nauseates foes.`,
        longDesc: `A true master of the Black Seraph fears no foe, and suffers none to stand before him. Heedless of personal danger to himself, the disciple brings his enemies to their knees with a relentless flurry of strikes. As part of this maneuver, the initiator takes a full attack action and may make an additional attack as part of this action at his highest attack bonus. The initiator suffers a -2 penalty to AC due to his focus on offense while using this maneuver. This focus on offense adds an extra 4d6 points of profane damage per successful attack. The sheer force of these blows nauseates his target with pain as well, for one round per successful attack. Foes killed by use of this maneuver are mutilated so badly that attempts to use a raise dead spell to restore their lives fail automatically; a more powerful restorative magic (such as true resurrection) is required.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `brokenBlade`,
        level: 1,
        name: `Brawler's Attitude`,
        type: `Boost`,
        shortDesc: `Gain a +4 bonus on CMB checks to perform an unarmed trip, dirty trick, disarm, or grapple attempt.`,
        longDesc: `By using the skill of the empty-handed warriors that came before him, the disciple focuses his will to using his body in less conventional ways in combat. When initiating this boost, the initiator gains a +4 competence bonus to his next CMB check when using his unarmed strike or discipline weapon to perform the following combat maneuvers: dirty trick, disarm, grapple, or trip.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Instant`
      },
      {
        school: `brokenBlade`,
        level: 1,
        name: `Flurry Strike`,
        type: `Strike`,
        shortDesc: `Make two quick attacks on a target enemy.`,
        longDesc: `The disciple of the Broken Blade learns to maximize openings in his opponent's defenses and makes lightning fast attacks whenever possible. As a standard action, the initiator may make two attacks at his full base attack bonus.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `brokenBlade`,
        level: 1,
        name: `Iron Hand Stance`,
        type: `Stance`,
        shortDesc: `Gain a +2 shield bonus to AC while in this stance, increasing in bonus as the character's initiator level increases.`,
        longDesc: `By keeping his hands stiff and his arms loose and ready, the disciple uses his bare palms as shields to protect himself from the weapons of his foes. While in this stance, the initiator gains a +2 shield bonus to his AC while he has at least one free hand. At the initiator's 6th initiator level, this bonus increases by +1, again at 12th level, and a final time at 18th level.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `brokenBlade`,
        level: 1,
        name: `Pommel Bash`,
        type: `Strike`,
        shortDesc: `A vicious elbow strike, inflicting an additional 1d6 points of damage.`,
        longDesc: `When watching a Broken Blade fighter work his art, most watch for the fists and feet. The disciple knows this, and surprises his foe, catching him unaware. The disciple makes a surprise elbow strike to the foe that leaves them reeling. The initiator makes an unarmed attack against the target's flat-footed armor class, and the blow inflicts 1d6 points of additional damage. Creatures immune to sneak attacks and critical hits are unaffected by this extra damage.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `brokenBlade`,
        level: 1,
        name: `Pugilist Stance`,
        type: `Stance`,
        shortDesc: `While in this stance, unarmed or discipline weapon strikes inflict an additional 1d6 points of damage, +1d6 additional damage / eight initiator levels.`,
        longDesc: `By adopting a powerful kickboxing stance, the initiator positions himself for lightning fast, potent strikes with his hands and feet. While in this stance, unarmed or discipline weapon strikes inflict an additional 1d6 points of damage.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `brokenBlade`,
        level: 1,
        name: `Shards of Iron Strike`,
        type: `Strike`,
        shortDesc: `A piercing strike that potentially staggers an opponent with pain.`,
        longDesc: `By mimicking the speed and piercing power of the legendary shattered blade of the founder of this discipline, the disciple makes a hard jabbing strike at his opponent's vulnerable spots for maximum pain. The initiator makes an attack against his target foe and if successful, the target is staggered for one round in addition to normal damage.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `brokenBlade`,
        level: 2,
        name: `Bronze Knuckle`,
        type: `Boost`,
        shortDesc: `Add an additional 2d6 points of damage to unarmed strikes and discipline weapons and martial strikes ignore damage reduction.`,
        longDesc: `With a spectacular crack of his knuckles, the disciple delivers an extra-potent blow to his foe in the form of a bone-crushing strike. As part of a unarmed attack or a strike from this discipline, the initiator's attacks for the duration of his turn inflict an additional 2d6 points of damage and these attacks ignore a target's damage reduction.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `One turn`
      },
      {
        school: `brokenBlade`,
        level: 2,
        name: `Cartwheel Axe Kick`,
        type: `Strike`,
        shortDesc: `Make an Acrobatics check and move 10-ft. to or from adjacent enemy, unarmed strike inflicts an additional 2d6 damage.`,
        longDesc: `With a quick handspring into a cartwheel or flip, the disciple of the Broken Blade levels a powerful axe kick at his foe. The initiator must make an Acrobatics check with a DC of 15; if successful the initiator may either move 10-ft. towards or away from a target creature without provoking attacks of opportunity. The initiator makes his unarmed attack roll (before he moves if he's moving away, or after he moves if he's approaching a target) and if successful, this kick inflicts an additional 2d6 points of damage.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `brokenBlade`,
        level: 2,
        name: `Counter Step`,
        type: `Counter`,
        shortDesc: `Make an opposed Acrobatics check against target's melee attack roll, 5 ft. step to avoid attack range.`,
        longDesc: `With a twist of his body or a nimble hop, the disciple of the Broken Blade avoids a blow with a practiced step. The initiator makes an opposed Acrobatics check against an attacker's melee attack roll. If successful, the initiator may make an immediate 5 ft. step to a location that is not being threatened by his attacker without provoking attacks of opportunity. If no such square exists, then this counter cannot be used.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instant`
      },
      {
        school: `brokenBlade`,
        level: 2,
        name: `Knuckle to the Blade`,
        type: `Strike`,
        shortDesc: `Make an attack against a target, if successful, make a free disarm attempt against the opponent without provoking attacks of opportunity.`,
        longDesc: `By striking at the weapon-wielding arm of his opponent, the disciple of the Broken Blade can cleverly disarm his opponent and potentially even bring his foe's weapon to bear against him. The initiator makes an attack as normal upon his foe, if successful, the initiator may make a free disarm attempt against the opponent without provoking attacks of opportunity. If he is unarmed, he may take the weapon and use it if the disarmattempt is successful or he may drop it.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `brokenBlade`,
        level: 2,
        name: `Leg Sweeping Hilt`,
        type: `Strike`,
        shortDesc: `Make a trip attempt with a +2 bonus without provoking attacks of opportunity, if successful, make an attack.`,
        longDesc: `With quick feint high, the disciple hooks his foot behind the leg of his foe and stiffens it like the hilt of a sword, drawing it back to knock his opponent down. The initiator makes a trip attempt with a +2 competence bonus which does not provoke attacks of opportunity. If successful, the initiator trips his opponent and may make an immediate attack at his full base attack bonus.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `brokenBlade`,
        level: 3,
        name: `Broken Blade Stance`,
        type: `Stance`,
        shortDesc: `Add initiator level to Acrobatics checks and may make additional attack as part of a full attack action.`,
        longDesc: `The disciple of the Broken Blade has learned the flows of combat to a degree and has the insight necessary to see the path to victory through the patterns of steel his opponents weave before his eyes. While in this stance, the initiator gains a competence bonus equal to his initiator level to Acrobaticschecks to avoid attacks of opportunity, and may make an additional attack when making a full attack action. If the initiator is two weapon fighting, he gains this extra attack for both hands. The attack(s) uses the initiator's full base attack bonus, plus any modifiers appropriate to the situation.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `brokenBlade`,
        level: 3,
        name: `Flat Iron Riposte`,
        type: `Counter`,
        shortDesc: `Make an opposed attack roll against attacker, if successful, negate the attack and throw opponent 10-ft. in a chosen direction and potentially land prone.`,
        longDesc: `When an opponent swings to strike at the disciple, his finely trained body explodes into motion in a shower of incredible reflexes, grabbing the attacker's attacking appendage and hurling him away. The initiator makes an opposed Acrobatics check against his attacker's melee roll. If successful the initiator negates the attack and hurls the enemy 10 ft. away to potentially land prone on a failed Reflex save (DC 13 + initiation modifier). This counter only works on opponents who are no more than one size category larger than the initiator.`,
        initiationAction: `immediate`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`,
        savingThrow: `Reflex partial`
      },
      {
        school: `brokenBlade`,
        level: 3,
        name: `Iron Dust`,
        type: `Boost`,
        shortDesc: `Make a free dirty trick attempt as part of a martial strike with a +2 bonus without provoking attacks of opportunity.`,
        longDesc: `Knowing the disadvantage of fighting without proper steel in hand, the disciple of the Broken Blade must take advantage of his surroundings and openings in his foe's defenses as he sees them. As part of a martial strike, he may make a free dirty trick attempt as part of this boost with a +2 competence bonus without provoking attacks of opportunity. The initiator may choose when the effects of this boost are applied (before, during, or after) when using this in conjunction with an attack or a martial strike.`,
        initiationAction: `swift`,
        range: `Melee attack`,
        target: `One martial strike`,
        duration: `Instant`
      },
      {
        school: `brokenBlade`,
        level: 3,
        name: `Steel Flurry Strike`,
        type: `Strike`,
        shortDesc: `Make three attacks on a target enemy, inflicting up to +3d6 points of damage on each strike.`,
        longDesc: `The disciple makes a furious set of attacks upon his foe, hammering through defenses and striking rapidly. The initiator may make three attacks against his foe at full base attack bonus with a -2 penalty to hit. Successful hits inflict an additional 3d6 points of damage per hit.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `brokenBlade`,
        level: 4,
        name: `Broken Blade Riposte`,
        type: `Counter`,
        shortDesc: `After being struck in melee combat, make an immediate counter attack, inflicting an additional 3d6 points of damage and push the target back 5-ft.`,
        longDesc: `Sometimes to give, one has to take. This ebb and flow that the disciple has mastered allows him to focus his pain into a forceful counter blow to drive his opponent back. After being struck in melee combat, the initiator may make an immediate counter attack at his full base attack bonus and this attack inflicts an additional 3d6 points of damage and pushes the target away from the initiator 5-ft.; this movement does not provoke attacks of opportunity.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `brokenBlade`,
        level: 4,
        name: `Iron-Breaking Palm`,
        type: `Strike`,
        shortDesc: `Make a sundering strike against a weapon or shield, potentially entangling target and inflicting an additional 3d6 points of damage to the target item.`,
        longDesc: `By targeting the very iron, wood, and steel he has eschewed for the simple use of his own limbs as weapons, he reduces his foes effectiveness by shattering their illusion of superiority in combat. The initiator makes a sunder attempt against the opponent's weapon or shield and inflicts an additional 3d6 points of damage to the targeted item. If the initiator breaks a target's shield, the target is considered entangled until he spends a standard action to divest himself of the broken shield. This sundering attempt does not provoke an attack of opportunity.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `brokenBlade`,
        level: 4,
        name: `Iron Axe Kick`,
        type: `Strike`,
        shortDesc: `The character delivers a potent kick that inflicts an additional 6d6 points of damage and dazes target for 1d4 rounds.`,
        longDesc: `The disciple leaps up into the air and raises his leg up to hammerit down in a bone-shattering axe kick. The initiator delivers a potent kick (as an unarmed strike) that inflicts an additional 6d6 points of damage. The target must make a Fortitude save (DC 14 + primary initiation modifier) or be dazed for 1d4 rounds.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`,
        savingThrow: `Fortitude partial`
      },
      {
        school: `brokenBlade`,
        level: 4,
        name: `Iron Knuckle`,
        type: `Boost`,
        shortDesc: `For the duration of the turn, unarmed and discipline weapon strikes inflict an additional 4d6 points of damage.`,
        longDesc: `By tapping into hidden reserves of martial power locked within his form, the disciple of the Broken Blade makes his attacks strike with the force of a thousand fists. For the duration of the turn this boost is initiated on, unarmed attacks or those made with weapons of the Broken Blade discipline inflict an additional 4d6 points of damage.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `One turn`
      },
      {
        school: `brokenBlade`,
        level: 5,
        name: `Iron Monger's Throw`,
        type: `Strike`,
        shortDesc: `Make a CMB check with a +4 bonus, if successful, with a rolling throw to land 20-ft. away, inflicting 6d6 points of damage upon landing.`,
        longDesc: `Opponents with their deadly blades and powerful spears can harry the disciple who fights with his hands, and the truth that is forgotten by filling one's hands with iron and steel is that the one with open hands may use them for whatever purpose suits them, and in this case it is for taking a foe and viciously hurling him away to give the disciple room to maneuver and plan his next move. The initiator makes a CMB check with a +4 competence bonus that does not provoke attacks of opportunity, and if successful the initiator rolls into a reverse somersault to hurl his foe up to 20-ft. away from him (the disciple's player chooses the flight path of the thrown foe) where they land in heavily, taking 6d6 points of damage.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `brokenBlade`,
        level: 5,
        name: `Shards of Steel Strike`,
        type: `Strike`,
        shortDesc: `Make a penetrating attack that inflicts an additional 8d6 points of damage that ignores damage reduction or hardness and leaves a bleeding wound.`,
        longDesc: `By targeting vital soft tissues with a pointed, viper head-like finger jab, the disciple punctures flesh and releases the vital blood supply of his foe all over the ground in a deluge. The initiator makes an attack at a target creature, and if successful this strike inflicts an additional 8d6 points of damage which ignores damage reduction and the target suffers the bleeding condition, bleeding 2d4 points of damage per round for the initiator's initiation modifier in rounds. A successful DC 20 Healcheck or the application of any effect that cures hit point damage will stop the bleeding.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `brokenBlade`,
        level: 5,
        name: `Steel Grappler's Attitude`,
        type: `Stance`,
        shortDesc: `While in this stance, count as one size category larger when calculating CMB and CMD for grapple, bull rush, and overrun attempts, and add initiation modifier to CMB and CMD for grapple, bull rush, and overrun attempts and resistance.`,
        longDesc: `By assuming this stance, the disciple of the Broken Blade has learned to shift his mass and balance to his advantage when grappling and running down his foes. While in this stance, the initiator counts as one size category larger when calculating CMB and CMD for grapple, bull rush, and overrun attempts, for use during counters, and he may add his initiation modifier to his CMB checks and to his CMD for grapple, bull rush, and overrun attempts and resisting those that use those combat maneuvers against him.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `brokenBlade`,
        level: 5,
        name: `Throw the Blade Down`,
        type: `Counter`,
        shortDesc: `Make an opposed Acrobatics check against target's attack roll, if successful, make a 5-ft. step and throw opponent to the ground in your previous space to land prone.`,
        longDesc: `With a nimble sidestep and sweeping kick, the disciple of the Broken Blade both avoids an attack and uses his attack's momentum to hurl him at the ground to land prone at his feet and at his fading mercy. The initiator makes an opposed Acrobatics check against the target's attack roll. If successful the initiator makes an immediate 5-ft. step to an adjacent square and the attacker moves 5-ft. to occupy his former square and the attacker must make a Reflex save (DC 15 + initiation modifier) to resist falling prone. The initiator may not use this counter on targets that are more than one size category larger than he is and neither 5-ft step provokes an attack of opportunity.`,
        initiationAction: `immediate`,
        range: `One melee attack`,
        target: `You`,
        duration: `Instant`,
        savingThrow: `Reflex partial`
      },
      {
        school: `brokenBlade`,
        level: 6,
        name: `Finishing Kick`,
        type: `Boost`,
        shortDesc: `The character may make an additional unarmed attack at his full base attack bonus at the end of a full attack action and the attack inflicts an additional 6d6 points of damage.`,
        longDesc: `Amidst the flurry of punches, kicks, and elbows that are the hallmarks of the Broken Blade discipline, the disciple who has put his foe through the ropes of learning what it is to underestimate the warrior without weapons may deliver this powerful kick to reduce his foe to a bleeding heap. At the end of a full attack action, the initiator may use this boost to deliver one final extra unarmed attack as he delivers a powerful kick at his full base attack bonus and inflicting an additional 6d6 points of damage.`,
        initiationAction: `swift`,
        range: `One full melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `brokenBlade`,
        level: 6,
        name: `Pit Fighter's Stance`,
        type: `Stance`,
        shortDesc: `While in this stance, the character may make one dirty trick attempt per round as a swift action without provoking attacks of opportunity, and he gains a +2 bonus to his CMD to resist dirty tricks and feint attempts.`,
        longDesc: `Some disciples have had to use their skills in less than reputable areas, or their teachers have deigned it worthy to learn how to use every opening to your best advantage. Some who practice Broken Blade find those who master this particular area of the art to be of questionable honor, but none can doubt its effectiveness. While in this stance, the initiator may make one dirty trick attempt per round as a swift action without provoking attacks of opportunity, and he gains a +2 bonus to his CMD to resist dirty tricks and feint attempts. The initiator also inflicts an additional 2d6 points of damage whenever the target would be denied their Dexterity modifier to their AC`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `brokenBlade`,
        level: 6,
        name: `Singing Steel Strike`,
        type: `Strike`,
        shortDesc: `Attack inflicts an additional 8d6 points of damage and on a failed save, deafens target and renders them unable to speak for 1d4 rounds.`,
        longDesc: `With a powerful strike to the head of the target, the disciple's fist hits as hard as meteoric iron and sets the jaw of the target loose and rings the proverbial bell of the unfortunate who was unlucky to face him. The initiator makes a melee attack against the target creature, and if successful, he inflicts an additional 8d6 points of damage and this forces the target to make a Fortitude save (DC 16 + initiation modifier) or be deafened and silenced for 1d4 rounds. If the target makes the save, then the target is only deafened for one round.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `1d4 rounds`,
        savingThrow: `Fortitude partial`
      },
      {
        school: `brokenBlade`,
        level: 6,
        name: `Steel Axe Kick`,
        type: `Strike`,
        shortDesc: `The character delivers a devastating spinning kick that inflicts an additional 10d6 points of damage and potentially stuns target for 1d3 rounds.`,
        longDesc: `With a sweeping axe kick that strikes as hard as any hammerstrike could ever be hoped to, the disciple of the Broken Blade lands a crushing blow that causes even the strongest of opponents to pause in pain. The initiator delivers a devastating spinning kick (as an unarmed strike) that inflicts an additional 10d6 points of damage and potentially dazes the target for 1d3 rounds on a failed Fortitude save (DC 16 + initiation modifier).`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`,
        savingThrow: `Fortitude partial`
      },
      {
        school: `brokenBlade`,
        level: 7,
        name: `Adamantine Knuckle`,
        type: `Boost`,
        shortDesc: `For the duration of the turn, unarmed and discipline weapon strikes inflict an additional 6d6 points of damage and ignore damage reduction and hardness.`,
        longDesc: `The sheer ferocity and focus of the disciple's ability in the unarmed combat area rivals that of the greatest ki wielders in the world. By tightening his knuckles, long since numb with scars and digging deep within, the disciple strikes with steel-shattering force. Once initiated, for the rest of the initiator's turn all attacks he makes with this boost inflict an additional 6d6 points of damage and ignore the target's damage reduction or an object's hardness.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `One turn`
      },
      {
        school: `brokenBlade`,
        level: 7,
        name: `Shards of Adamantine Strike`,
        type: `Strike`,
        shortDesc: `Make a penetrating attack that inflicts an additional 12d6 points of damage, ignoring damage reduction and hardness, and may nauseate target.`,
        longDesc: `It is said that masters of the discipline are capable of using their hand in the manner of striking serpent to punch through solid stone as if it were straw, and disciples with this maneuver are those who can. Taking this training to the theater of war, a punch so potent that it can leave the foe sickened with pain is what this art form can deliver. The initiator makes an attack against the target creature and if successful, this attack inflicts an additional 12d6 points of damage that ignores the target's damage reduction or an object's hardness. If striking a living creature, the target must make a Fortitude save (DC 17 + initiation modifier) or be nauseated with the pain of the strike for 1d4 rounds.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature or object`,
        duration: `Instant`,
        savingThrow: `Fortitude partial`
      },
      {
        school: `brokenBlade`,
        level: 7,
        name: `Spinning Flurry Rush`,
        type: `Strike`,
        shortDesc: `Make two unarmed attacks at full base attack bonus against all targets within reach, inflicting an additional 4d6 points of damage per successful attack.`,
        longDesc: `The disciple of the Broken Blade takes a deep breath when he finds himself surrounded by opponents and hopes that they've made peace with the gods, for they will be seeing them soon. The initiator makes two attacks at full base attack bonus per opponent within his reach, and each attack inflicts an additional 4d6 points of damage.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `All adjacent enemies`,
        duration: `Instant`
      },
      {
        school: `brokenBlade`,
        level: 8,
        name: `Meteoric Throw`,
        type: `Strike`,
        shortDesc: `The character grabs an opponent with a successful grapple check and hurls him into another enemy as a ranged touch attack, inflicting 12d6 points of damage to both targets.`,
        longDesc: `The Broken Blade master has transcended the simple use of his own body as a weapon, and has deigned to use his opponent's body as a weapon against those who would stand against him. The initiator makes a grapple attempt and if successful, he may hurl his foe up to 25-ft. as a ranged touch attack at either the ground or another target foe. The thrown enemy suffers 12d6 points of damage upon impact, and if thrown at a target creature, that target suffers that damage as well on a failed Reflex saving throw (DC 18 + initiation modifier for half damage). The target of this grapple attempt must be within one size category of the initiator. Large or larger foes being hurled using this method may target the ground beneath multiple targets within the area that creature normally would occupy. (Large creatures, for example, occupy a 10-ft. by 10-ft. space so they would hit all targets within a 10-ft. by 10-ft. area on a failed Reflex save).`,
        initiationAction: `standard`,
        range: `Melee attack and 25-ft.`,
        target: `One creature to be thrown at another target creature`,
        duration: `Instant`,
        savingThrow: `Reflex special`
      },
      {
        school: `brokenBlade`,
        level: 8,
        name: `Spinning Adamantine Axe`,
        type: `Strike`,
        shortDesc: `The character makes one unarmed attack against each foe in range, each successful strike inflicting an addition 10d6 points of damage which ignores damage reduction and knocks the foe prone.`,
        longDesc: `With a powerful leap into the air, the disciple of the Broken Blade unleashes a powerful spinning kick to his surrounding foes that strikes with the force of a hurricane. The initiator makes one unarmed attack against each foe in range, each successful strike inflicting an additional 10d6 points of damage that ignores the target's damage reduction. Foes that are struck are also knocked prone from the force of this assault.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `All adjacent enemies`,
        duration: `Instant`
      },
      {
        school: `brokenBlade`,
        level: 8,
        name: `Unbreakable Stride Stance`,
        type: `Stance`,
        shortDesc: `While in this stance, the character takes no penalties moving through threatened areas and does not provoke attacks of opportunity when moving and gains the effects of freedom of movement.`,
        longDesc: `The master of the Broken Blade moves across the theater of war as a leaf on the wind, dodging easily out of the way of obstacles as if they weren't even there. While in this stance, the initiator takes no penalties moving through threatened areas and does not provoke attacks of opportunity when moving and acts as if under the freedom of movement spell.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `brokenBlade`,
        level: 9,
        name: `Storm of Iron Fists Strike`,
        type: `Strike`,
        shortDesc: `The character makes a full attack and each strike inflicts an additional 4d6 points of damage that ignores damage reduction. Each successful hit increases Fortitude save DC to resist being reduced to -1 hit points.`,
        longDesc: `The true master of the Broken Blade unleashes a storm of adamantine-hard strikes that rip through the defenses of his unfortunate target and resound as thunder from the force of the blows. Those witnessing this strike implemented rarely forget it, and those that feel it rarely survive it. The initiator makes a full attack and each strike inflicts an additional 4d6 points of damage that ignores damage reduction. After the attacks are made, the target must make a Fortitude save (DC is 19 + initiation modifier). Each successful hit increases Fortitude save by +1 per attack to resist this strike; failure on the Fortitude save indicates that the target is reduced to -1 hit points.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `cursedRazor`,
        level: 1,
        name: `Aura of Misfortune`,
        type: `Stance`,
        shortDesc: `Opponents within close range take a –2 penalty on saving throws.`,
        longDesc: `You project an area of ill fortune. While you maintain this stance, all opponents within close range (25 feet + 5 feet per 2 initiator levels) take a –2 penalty on saving throws. `,
        initiationAction: `swift`,
        range: `Personal`,
        target: `Self`,
        duration: `Stance`
      },
      {
        school: `cursedRazor`,
        level: 1,
        name: `Luck Shifting`,
        type: `Boost`,
        shortDesc: `Gain a +1 luck bonus to your AC for each cursed opponent within medium range (maximum +5).`,
        longDesc: `One man's ill luck is another man's fortune. After initiating this boost, you gain a +1 luck bonus to your AC until the start of your next turn for each cursed opponent within medium range (100 feet + 10 feet per initiator level), up to a maximum bonus of +5.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `Self`,
        duration: `1 round`
      },
      {
        school: `cursedRazor`,
        level: 1,
        name: `Spilled Salt`,
        type: `Counter`,
        shortDesc: `An opponent within medium range takes a –4 penalty on an attack roll or skill check`,
        longDesc: `This unsubtle counter disrupts an opponent with a blatant curse, whelming them with misfortune. You can initiate this counter when a creature within range makes an attack roll or skill check. That creature takes a –4 penalty on that attack roll or skill check.`,
        initiationAction: `immediate`,
        range: `Medium (100' + 10/level)`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `cursedRazor`,
        level: 1,
        name: `Stutter Strike`,
        type: `Strike`,
        shortDesc: `Your melee attack curses the target and causes them to take a –4 penalty on language-based skill checks, and suffer a 25% failure chance on spells with verbal components.`,
        longDesc: `With just the faintest edge of dark energies, you can afflict your victims with a word-eating curse. Make a melee attack. If it hits, it deals weapon damage as normal, and the target must succeed at a Will save (DC 11 + your initiation modifier) or take a –4 penalty on language-based skill checks and suffer a 25% chance of failure when casting spells (including divine spells) with a verbal component for a number of rounds equal to your initiator level. In addition, a struck target becomes cursed for a number of rounds equal to your initiator level, regardless of whether or not it succeeded on its save.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `cursedRazor`,
        level: 1,
        name: `Touch of the Witch`,
        type: `Stance`,
        shortDesc: `Opponents struck in melee become cursed.`,
        longDesc: `[curse]; Your weapons become charged with malicious energies. While you maintain this stance, any creature you hit with a melee weapon (including natural weapons) becomes cursed for a number of rounds equal to your initiation modifier. This stance's effect resolves after other effects relating to the attack (such as strikes or weapon properties). `,
        initiationAction: `swift`,
        range: `Personal`,
        target: `Self`,
        duration: `Stance`
      },
      {
        school: `cursedRazor`,
        level: 1,
        name: `Woeful Burden`,
        type: `Strike`,
        shortDesc: `Your melee attack curses the target and reduces their movement speed by 10 feet + 5 feet per four initiator levels.`,
        longDesc: `[curse]; This insidious strike leaves a creature burdened with phantom weight that bears them down. Make a melee attack. If it hits, it deals weapon damage as normal, and the target takes a penalty to each of their movement speeds equal to 10 feet + 5 feet per four initiator levels. In addition, a struck target becomes cursed for a number of rounds equal to your initiator level. `,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `cursedRazor`,
        level: 2,
        name: `Bad Karma`,
        type: `Counter`,
        shortDesc: `An opponent that targets you must succeed at a Will save or become cursed and take a –4 penalty to d20 rolls for 1d4 rounds.`,
        longDesc: `[curse]; Invoking the basic laws of fortune and punishment, you curse a creature that attempts to harm you. You can initiate this counter in response to being targeted by an attack, ability, maneuver, power, or spell. The creature targeting you must succeed at a Will save (DC 12 + your initiation modifier) or become cursed and take a –4 penalty on all d20 rolls for 1d4 rounds.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `cursedRazor`,
        level: 2,
        name: `Mockery`,
        type: `Strike`,
        shortDesc: `Your melee attack deals +1d6 damage, or +3d6 against a cursed opponent.`,
        longDesc: `This strike amplifies the misfortune already afflicting an enemy, turning their curse into deep wounds. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 1d6 points of damage. If the target is cursed, this strike's additional damage increases to 3d6.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `cursedRazor`,
        level: 2,
        name: `Murderous Spite`,
        type: `Boost`,
        shortDesc: `Your next melee attack against a cursed opponent is a touch attack.`,
        longDesc: `You channel your ill will into your attacks. After you initiate this boost, the next melee attack you make against a cursed creature until the start of your next turn is considered a touch attack.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `Self`,
        duration: `1 round`
      },
      {
        school: `cursedRazor`,
        level: 2,
        name: `Torment the Weak`,
        type: `Strike`,
        shortDesc: `Your melee attack deals +1d6 damage; a cursed target begins to bleed uncontrollably.`,
        longDesc: `This vicious strike rends its victims and causes those under your dark power to vent their life force. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 1d6 points of damage. If the target is cursed, it takes an additional 1d6 points of damage each round at the start of its turn for a number of rounds equal to your initiation modifier.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `cursedRazor`,
        level: 2,
        name: `Word of Retribution`,
        type: `Counter`,
        shortDesc: `Make a Spellcraft check when damaged by a cursed opponent to deal equal damage to that opponent.`,
        longDesc: `With a word you afflict your enemies with the power of your vengeance. You can initiate this counter whenever a cursed creature deals damage to you. Make a Spellcraft check (DC 10 + 1/2 that creature's Hit Dice + that creature's Charisma modifier). If you succeed, you deal damage to that creature equal to the damage it did to you. This damage is not subject to damage reduction, immunity, or resistance of any kind.`,
        initiationAction: `immediate`,
        range: `Personal (see text)`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `cursedRazor`,
        level: 3,
        name: `Aura of Shared Misery`,
        type: `Stance`,
        shortDesc: `You can curse multiple opponents at once, and cursed creatures within 20 feet take additional damage from attacks and effects.`,
        longDesc: `[curse]; This baleful aura spreads the despair you inflict and drains at the life of your victims. While you maintain this stance, whenever a creature within 20 feet of you becomes cursed as a result of another effect, you may select a different creature within 20 feet. That creature becomes cursed for a number of rounds equal to your initiation modifier. In addition, cursed creatures within 20 feet of you take 1 additional points of damage per damage die whenever they take damage from an attack or effect. At level 12 this increases to 2 damage per die rolled.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `Self`,
        duration: `Stance`
      },
      {
        school: `cursedRazor`,
        level: 3,
        name: `Dogpile Strike`,
        type: `Strike`,
        shortDesc: `Your melee attack deals +2d6 damage and may knock the target prone. This strike deals an additional +2d6 damage against flanked creatures.`,
        longDesc: `[curse]; This vicious strike preys upon the weak and persecuted. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 2d6 points of damage, and the target must succeed at a Reflex save (DC 13 + your initiation modifier) or be knocked prone. If the target is flanked (either by you or by other creatures), this strike's additional damage increases to 4d6.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `cursedRazor`,
        level: 3,
        name: `Huntsman's Curse`,
        type: `Strike`,
        shortDesc: `Your melee attack curses, staggers, and penalizes the target unless they succeed at a Will save.`,
        longDesc: `[curse]; Creatures struck down by this curse find themselves slowed as though in a nightmare, unable to escape their pursuers. Make a melee attack. If it hits, it deals weapon damage as normal, and the target must succeed at a Will save (DC 13 + your initiation modifier) or become cursed and staggered for a number of rounds equal to your initiator level. In addition, a target that fails its save takes a –1 penalty on attack rolls, Reflex saves, and to its AC, and moves at half its normal speed for the same duration.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `cursedRazor`,
        level: 3,
        name: `Sorcerer's Sidestep`,
        type: `Counter`,
        shortDesc: `You gain a luck bonus on saving throws for one round equal to +2 plus the number of cursed creatures within medium range (maximum +10)`,
        longDesc: `Drawing on your mystical connection with fortune for good and ill, you avoid even magical and unusual attacks. You can initiate this counter at any time to gain a +2 luck bonus on all saving throws for one round. This bonus improves by +1 for each cursed opponent within medium range (100 feet + 10 feet per initiator level), up to a maximum bonus of +10. `,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `Self`,
        duration: `1 round`
      },
      {
        school: `cursedRazor`,
        level: 4,
        name: `Hangman's Curse`,
        type: `Strike`,
        shortDesc: `Your melee attack curses and exhausts the target unless they succeed at a Fortitude save.`,
        longDesc: `[curse]; This grim curse afflicts its victims with a breathless exhaustion, and a dark bruise forms around their necks. Make a melee attack. If it hits, it deals weapon damage as normal, and the target must succeed at a Fortitude save (DC 14 + your initiation modifier) or become cursed and exhausted for a number of rounds equal to your initiator level. `,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `cursedRazor`,
        level: 4,
        name: `Persecution`,
        type: `Strike`,
        shortDesc: `Your attack deals +4d6 damage, or +8d8 against a cursed opponent.`,
        longDesc: `This strike amplifies the misfortune already afflicting an enemy, turning their curse into deep wounds. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 4d6 points of damage. If the target is cursed, this strike's additional damage increases to 8d8. `,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `cursedRazor`,
        level: 4,
        name: `Warlock's Stride`,
        type: `Boost`,
        shortDesc: `Your movement speed doubles and you leave behind a cursed trail for one round.`,
        longDesc: `[curse]; Like ill news you travel swiftly, leaving woe and heartbreak in your wake. After initiating this boost, your movement speeds are doubled until the start of your next turn, and you create a cursed aura in every square you leave while under the effect of this boost. Creatures entering or passing through a cursed aura must succeed at a Will save (DC 14 + your initiation modifier) or take a –4 penalty on attack rolls and skill checks for a number of rounds equal to your initiation modifier. In addition, creatures that fail their saves also become cursed and their movement speeds are reduced by 15 feet for the same duration. Cursed auras created by your movement vanish after one round. `,
        initiationAction: `swift`,
        range: `Personal`,
        target: `Self`,
        duration: `1 round`
      },
      {
        school: `cursedRazor`,
        level: 4,
        name: `Witchfinder's Brand`,
        type: `Boost`,
        shortDesc: `The next power, psi-like ability, spell, or spell-like ability the target uses within one round is disrupted unless it succeeds on a Concentration check.`,
        longDesc: `With a swift gesture, you impede the sorceries of others. When you initiate this boost, one creature within medium range (100 feet + 10 feet per level) develops an ashen brand on a visible part of its body or clothing. The next time the target attempts to cast a spell, manifest a power, or use a psi-like or spell-like ability, they must succeed at a Concentration check (DC 15 + your initiator level + your initiation modifier) or the spell, power, or ability is disrupted. If the target does not attempt to use such an ability within one round, the brand vanishes harmlessly.`,
        initiationAction: `swift`,
        range: `Medium (100' + 10/level)`,
        target: `Self`,
        duration: `1 round`
      },
      {
        school: `cursedRazor`,
        level: 5,
        name: `Festering Curse`,
        type: `Strike`,
        shortDesc: `Your melee attack deals +4d6 damage and curses the target with a festering rot.`,
        longDesc: `Your vicious strike afflicts your victims with a curse of rot. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 4d6 points of damage, and the target becomes cursed. In addition, a struck target must succeed at a Fortitude save (DC 15 + your initiation modifier) at the start of each of its turns for a number of rounds equal to your initiation modifier or take an additional 2d6 points of damage as its body begins to decay and slough off in putrid clumps.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `cursedRazor`,
        level: 5,
        name: `Shadow Pin`,
        type: `Counter`,
        shortDesc: `You curse a creature within medium range and interrupt their movement. A flying target falls.`,
        longDesc: `[curse]; By harming the shadow of your enemy, you can pin them in place. You can initiate this counter in response to a creature within range leaving its space (including via movement such as a being pushed by a gust of wind spell or bull rush combat maneuver, or teleportation effects). The target becomes cursed for one round and stops its movement, dropping to the ground and taking falling damage as normal if it is flying and cannot hover. In addition, the target cannot move or be moved from its space for one round. You cannot stop a creature's movement if it is within another creature's space. `,
        initiationAction: `immediate`,
        range: `Medium (100' + 10/level)`,
        target: `One creature`,
        duration: `1 round`
      },
      {
        school: `cursedRazor`,
        level: 5,
        name: `The Dragon Knows`,
        type: `Stance`,
        shortDesc: `You gain blindsight with a range of 60 feet, and cursed opponents cannot use Acrobatics to avoid attacks of opportunity against you.`,
        longDesc: `By meditating on your ill intentions and dark thoughts, you gain senses beyond the normal ken. While you maintain this stance, you gain the blindsight ability with a range of 60 feet, and cursed opponents automatically fail Acrobatics checks to move through your threatened space without provoking attacks of opportunity. `,
        initiationAction: `swift`,
        range: `Personal`,
        target: `Self`,
        duration: `Stance`
      },
      {
        school: `cursedRazor`,
        level: 5,
        name: `Witch's Revenge`,
        type: `Strike`,
        shortDesc: `Your melee attack curses the target, and they must succeed at a Fortitude save or take a –4 penalty to an ability score. A cursed target takes either a worse penalty or a second penalty.`,
        longDesc: `[curse]; This ancient strike utterly cripples a foe's abilities. Make a melee attack. If it hits, it deals weapon damage as normal, and the target must succeed at a Fortitude save (DC 15 + your initiation modifier) or take a –4 penalty to an ability score of your choice. If the target is cursed, you can choose to either increase this penalty to –6, or cause the target to take a second –4 penalty to another ability score of your choice. These penalties last for a number of rounds equal to your initiator level. In addition, a struck target becomes cursed for a number of rounds equal to your initiator level, regardless of whether or not it succeeded on its save. `,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `cursedRazor`,
        level: 6,
        name: `Curse of Chains`,
        type: `Strike`,
        shortDesc: `Your melee attack causes the target to become cursed and paralyzed unless it succeeds at a Will save; other opponents near them must also save or become cursed and paralyzed.`,
        longDesc: `[curse]; Phantom chains trail in the wake of your strike and spread through your enemies like wildfire. Make a melee attack. If it hits, it deals weapon damage as normal, and the target must succeed at a Willsave (DC 16 + your initiation modifier) or become cursed and paralyzed for a number of rounds equal to your initiation modifier. While the target is paralyzed by this strike, opponent that ends its turn adjacent must succeed at a Will save (DC 16 + your initiation modifier) or also become cursed and paralyzed for a number of rounds equal to your initiation modifier. Only the initial target spreads its curse in this manner. This strike can paralyze creatures normally immune to paralysis, though such creatures gain a +6 competence bonus on their saving throws.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `cursedRazor`,
        level: 6,
        name: `Eye for an Eye`,
        type: `Counter`,
        shortDesc: `An opponent suffers the effects of an attack, spell, or power they used against you.`,
        longDesc: `With a snarled curse you level vengeance at your enemy. You can initiate this counter whenever you are struck by an attack or when you fail a saving throw against a maneuver, power, psi-like ability, spell, or spell- like ability. This counter cannot be initiated in response to failing a save against a harmless effect. The creature originating the attack or effect suffers all damage and effects inflicted upon you, just as if they'd targeted themselves. This maneuver only duplicates the effects you suffered on the creature, not the entire effect.`,
        initiationAction: `immediate`,
        range: `See text`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `cursedRazor`,
        level: 6,
        name: `Oathbreaker's Aura`,
        type: `Stance`,
        shortDesc: `Opponents within 30 feet cannot benefit from anarchic, axiomatic, insight, morale, profane, or sacred bonuses, and opponents struck in melee become cursed.`,
        longDesc: `This malevolent aura robs its victims of their supernatural edges and interferes with their oaths. While you maintain this stance, opponents within 30 feet of you lose the benefits of any anarchic, axiomatic, insight, profane, or sacred bonuses they possess (they regain the benefits of these bonuses when they leave the area or you assume a different stance). In addition, any creature you hit with a melee weapon (including natural weapons) becomes cursed for a number of rounds equal to your initiation modifier. This stance's effect resolves after other effects relating to the attack (such as strikes or weapon properties). `,
        initiationAction: `swift`,
        range: `Personal`,
        target: `Self`,
        duration: `Stance`
      },
      {
        school: `cursedRazor`,
        level: 6,
        name: `Sorcerer's Gaze`,
        type: `Boost`,
        shortDesc: `Your attacks ignore ignore concealment, miss chances, and deflection bonuses to AC for one round.`,
        longDesc: `By channeling the magical energies within, you pick out the weak places in protections both magical and mundane and strike down those who cower behind them. After initiating this boost, your attacks until the start of your next turn ignore the AC bonus granted to targets by cover less than total cover, deflection bonuses to AC, and any miss chance (including the miss chance from total concealment, although you still need to choose the correct square if you cannot see your target). Total cover provides its normal benefits against your attacks. `,
        initiationAction: `swift`,
        range: `Personal`,
        target: `Self`,
        duration: `1 round`
      },
      {
        school: `cursedRazor`,
        level: 6,
        name: `Warlock's Blow`,
        type: `Strike`,
        shortDesc: `You teleport an opponent within long range to a space within your reach, then attack them. Your melee attack deals +8d6 damage.`,
        longDesc: `[teleportation]; With a savage curse and a lunge, you teleport your enemy into your weapon. When you initiate this strike, the target must succeed at a Will save (DC 16 + your initiation modifier) or be teleported to an unoccupied space within your melee reach of your choice that is not difficult terrain. If you successfully teleport your target, make a melee attack. If it hits, it deals weapon damage as normal plus an additional 8d6 points of damage. `,
        initiationAction: `standard`,
        range: `Long (400' + 40/level)`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `cursedRazor`,
        level: 7,
        name: `Black Dog's Due`,
        type: `Strike`,
        shortDesc: `Your melee attack deals +8d6 damage and may knock the target prone. This strike deals an additional +4d6 damage against flanked creatures.`,
        longDesc: `You strike a distracted foe, bringing swift death with the edge of your blade. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 8d6 points of damage, and the target must succeed at a Reflex save (DC 17 + your initiation modifier) or be knocked prone. If the target is flanked (either by you or by other creatures), this strike's additional damage increases to 12d6. `,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `cursedRazor`,
        level: 7,
        name: `Traitor's Roar`,
        type: `Strike`,
        shortDesc: `Your attack curses the target and causes them to violently betray their allies unless they succeed at a Will save.`,
        longDesc: `[compulsion, curse, mind-affecting]; Channeling dark energies through your blade, you poison the loyalty of those you strike. Make a melee attack. If it hits, it deals weapon damage as normal, and the target must succeed at a Willsave (DC 17 + your initiation modifier) or be overwhelmed with feelings of hatred for its allies. A target that fails its save immediately takes a standard action (even if it isn't its turn) to harm or hinder its allies in some way. The victim acts as though possessed of true hatred for its allies, utilizing whatever it perceives as the most harmful ability possible, and targets them as if it were their foe. Once the harmful action is taken, the creature becomes cursed for a number of rounds equal to your initiation modifier and resumes its normal attitude towards its allies. This maneuver does not change the creature's feelings about its enemies; for example, it might use its action to cast a fireball spell that includes both its allies and enemies within its area. `,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `cursedRazor`,
        level: 7,
        name: `Woedrinker`,
        type: ``,
        shortDesc: `You gain concealment and a +2 luck bonus on attack damage rolls per cursed opponent within medium range (maximum +10) for one minute. In addition, you gain temporary hit points based on the number of cursed opponents within range.`,
        longDesc: `(untyped); Like an avatar of woe, you prosper as others fail. When you initiate this maneuver, you gain concealment (20% miss chance) and a +2 luck bonus on attack and damage rolls for one minute. These bonuses improve by +2 for each cursed opponent within medium range (100 feet + 10 feet per initiator level) when you initiate this maneuver, up to a maximum bonus of +10. In addition, you gain 10 temporary hit points for one hour when you initiate this maneuver, plus an additional 10 temporary hit points for each cursed opponent within medium range (100 feet + 10 feet per initiator level), up to a maximum of 50 temporary hit points. After initiating this maneuver, the bonuses and temporary hit points granted do not change if the number of cursed opponents within range increases or decreases.`,
        initiationAction: `standard`,
        range: `Personal`,
        target: `Self`,
        duration: `1 minute`
      },
      {
        school: `cursedRazor`,
        level: 8,
        name: `Luckdrinker Aura`,
        type: `Stance`,
        shortDesc: `You steal magical and psionic effects from opponents within 30 feet.`,
        longDesc: `This cursed aura steals beneficence from your enemies and gifts it to your allies. You supernaturally sense magic around you and can twist it to your advantage. While you maintain this stance, you automatically know which spells, powers, or magical effects are active upon any individual you see within 30 feet. In addition, at the beginning of each round, you may select a power, psi-like ability, spell, or spell-like ability affecting a hostile creature within 30 feet. Make a dispel check (1d20 + your initiator level) against the effect (DC 11 + the effect's caster or manifester level). If you succeed, the effect is suppressed for a number of rounds equal to your initiation modifier, and one of your allies within 30 feet gains the benefit of that effect for the same duration. `,
        initiationAction: `swift`,
        range: `Personal`,
        target: `Self`,
        duration: `Stance`
      },
      {
        school: `cursedRazor`,
        level: 8,
        name: `Unending Nightmare Strike`,
        type: `Strike`,
        shortDesc: `Your melee attack causes the target to take repeated damage to each of its mental ability scores.`,
        longDesc: `This cruel and unusual strike traps its victims in a waking nightmare. Make a melee attack. If it hits, it deals weapon damage as normal plus 4 points of damage to the target's Intelligence, Wisdom, and Charisma scores. At the beginning of each of your turns thereafter, the target must succeed at a Will save (DC 18 + your initiation modifier) or take an additional 4 points of damage to its Intelligence, Wisdom, and Charisma scores. A successful save or the creature's death ends this effect.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `cursedRazor`,
        level: 8,
        name: `Warlock's Mirror`,
        type: `Counter`,
        shortDesc: `Make a Spellcraft check to redirect a attack or effect from a cursed opponent to up to three creatures of your choice within medium range.`,
        longDesc: `Those under your influence find their own powers betraying them. You can initiate this counter in response to any cursed creature making an attack, initiating a maneuver, or using a power, psi-like ability, spell, or spell-like ability targeting you (it may also have other targets, as long as you are one of them). Make a Spellcraft check (DC = 10 + 1/2 the cursed creature's Hit Dice + the cursed creature's Charisma modifier). If you succeed, the attack, maneuver, power, psi-like ability, spell, or spell-like ability does not affect its intended target(s) and instead affects up to three targets of your choice within range, even if it would normally affect only one creature.`,
        initiationAction: `immediate`,
        range: `Medium (100' + 10/level)`,
        target: `One cursed creature`,
        duration: `Instant`
      },
      {
        school: `cursedRazor`,
        level: 9,
        name: `Festival of Shadows`,
        type: `Strike`,
        shortDesc: `Opponents within close range must make a Reflex save or become immobilized by shadows, then you attack each creature within range. Your attack deals +10d6 damage, or +12d8 against cursed opponents.`,
        longDesc: `The ultimate expression of your grim power, you wrap your enemies in shadow, plunge your blade into the darkness, striking them down with tenebrous copies of your weapon. When you initiate this strike, all opponents within range must succeed at a Reflex save (DC 19 + your initiation modifier) or become immobilized by shadows; all their movement speeds are reduced to 0 for a number of rounds equal to your initiation modifier. Creatures in flight drop to the ground and take falling damage as normal if they cannot hover. In addition, make a melee attack roll as part of this maneuver and compare it to the AC of all creatures within range. Each creature hit by the attack roll takes weapon damage as normal plus an additional 10d6 points of damage. If a target is cursed, this strike's additional damage increases to 12d8.`,
        initiationAction: `standard`,
        range: `Close (25' + 5'/2 levels)`,
        target: `Opponents within range`,
        duration: `Instantaneous`
      },
      {
        school: `elementalFlux`,
        level: 1,
        name: `Eldritch Shield`,
        type: `Counter`,
        shortDesc: `You gain energy resistance 10 against a single attack or effect.`,
        longDesc: `By drawing upon the elements, you are capable of defending against energy effects. You can initiate this counter when you are affected by an attack, spell, or effect that deals acid, cold, fire, electricity, or sonic damage. You gain energy resistance 10 to each of those energy types against that attack, spell, or effect. Animus augmentation: You may spend one point of animus to increase this energy resistance to 20.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `One attack or effect`
      },
      {
        school: `elementalFlux`,
        level: 1,
        name: `Elemental Nimbus`,
        type: `Stance`,
        shortDesc: `You gain variable offensive effects based on your active element.`,
        longDesc: `Channeling the strength of the elements lends your attacks strength and fury. While you maintain this stance, you gain one of the following benefits, based on your active element:
        \nAir You gain a +2 bonus on attack rolls against opponents wearing metal armor, and your attacks deal an additional 1d6 points of electricity damage. At initiator level 10th, the bonus on attack rolls increases to +4 and the additional damage increases to 3d6.    
        \nEarth The strength of the earth empowers your weapon, causing it to deal damage as if it was one size category larger. Starting at initiator level 10th, your weapons instead deal damage as if they were two size categories larger.
        \nFire Your attacks deal additional fire damage equal to your initiation modifier. At initiator level 10th, this damage increases to be equal to twice your initiation modifier.
        \nWater When you successfully hit an opponent with an attack, they must succeed at a Fortitude save (DC 11 + your initiation modifier) or become staggered for one round. A creature cannot be staggered by this stance more than once per round. The save DC for this stance's effect increases by +1 at initiator level 5th and at every four initiator levels thereafter.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `elementalFlux`,
        level: 1,
        name: `Energy Fluctuation`,
        type: `Boost`,
        longDesc: `Change your active element to a new one. When you do, you can also change one of your previous <elemental> combo points to the new changed element. You can expend this boost as a free action when you change your active element another way. This boost can give a combo point for either the old element or the new one.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `instantaneous`
      },
      {
        school: `elementalFlux`,
        level: 3,
        name: `Flow of the Elements`,
        type: `Boost`,
        longDesc: `Change your active element to a new one. When you do, you can also recover a maneuver of the new elemental type. It cannot be an elemental flux maneuver. This boost can give a combo point for either the old element or the new one.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `instantaneous`
      },
      {
        school: `elementalFlux`,
        level: 3,
        name: `Elemental Surge`,
        type: `Boost`,
        longDesc: `Change a previous elemental combo point to a different elemental combo point. Then gain bonuses depending on your chains of similar elemental combo points. You count only the highest chain of each element, and it must be greater than 2. Gain 1d8 temporary hit points for the longest chain of like elemental combo points. These last 1 minute. You can choose for this boost to not grant combo points. 
        \nAir: Gain a 5 feet to your movement speed for each connected air point.
        \nEarth: Gain a +1 enhancement bonus to your natural armor for each connected earth point.
        \nFire: Gain a +2 bonus on damage rolls for every connected fire point. 
        \nWater: Gain a +1 bonus to your saves for every 2 connected water points.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      // {
      //   school: `elementalFlux`,
      //   level: 5,
      //   name: `Unleash the Elements`,
      //   type: `Finisher`,
      //   finisherType:"Strike",
      //   longDesc: `[{multi}]`,
      //   initiationAction: `swift`,
      //   range: `Personal`,
      //   target: `You`,
      //   duration: `1 round`
      // },
      {
        school: `elementalFlux`,
        level: 1,
        name: `Embrace the Elements`,
        type: `Stance`,
        shortDesc: `You gain variable defensive effects based on your active element.`,
        longDesc: `By filing yourself with the fundamentals of an element, you are capable of altering how your body defends itself in therealm of martial combat. While you maintain this stance, you gain one of the following effects, based on your active element:
        \nAir You gain a +2 dodge bonus to your AC and the benefit of the Deflect Arrows feat, even if you do not meet the normal prerequisites. This dodge bonus increases by +1 for every six initiator levels you possess.
        \nEarth You gain a +2 natural armor bonus on AC and a +4 resistance bonus on CMD to resist bull rush, grapple, and trip attempts. These bonuses increase by +1 for every six initiator levels you possess.
        \nFire You gain a +4 bonus on initiative checks and you gain the benefits of the endure elements spell. The bonus on initiative checks increases by +1 for every six initiator levels you possess.
        \nWater You gain a +2 bonus on Reflex saving throws and a +4 competence bonus on Acrobatics checks. These bonuses increase by +1 for every six initiator levels you possess.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `elementalFlux`,
        level: 1,
        name: `Fluctuation Movement`,
        type: `Boost`,
        shortDesc: `You gain a movement method or bonus based on your active element.`,
        longDesc: `Coating your feet in the power of the elements, you alter your movement to grant you a burst of speed and maneuverability. This boost has one of the following effects, based on your active element:
        \nAir You can make a single jump this round as a free action, with a +10 bonus to your Acrobatics check.
        \nEarth Your movement ignores difficult terrain for one round.
        \nFire Your base land speed increases by 10 feet for one round.
        \nWater You can make one turn of up to 90 degrees as part of the move when charging this round`,
        initiationAction: `swift or movement`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `elementalFlux`,
        level: 1,
        name: `Spark Strike`,
        type: `Strike`,
        shortDesc: `Your attack deals +2d4 energy damage.`,
        longDesc: `By letting the elements flow through you and into your attack, you're able to strike with raw primal energies at your unlucky foe. Make an attack. If it hits, it deals weapon damage as normal plus an additional 2d4 points of damage of your active element's associated energy type. \n\nAnimus augmentation: You may spend one point of animus to increase this strike's additional damage to 3d4.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `elementalFlux`,
        level: 1,
        name: `Variable Flux`,
        type: `Strike`,
        shortDesc: `Your attack has an additional effect based on your active element.`,
        longDesc: `Filling your weapon with the power of the elements, you lash out with barely-contained eldritch power. Make an attack. If it hits, it deals weapon damage as normal plus one of the following effects, based on your active element:
        \nAir If the target is wearing metal armor, wielding a metal shield, or wielding a weapon mostly composed of metal, you gain a +4 bonus on your attack roll.
        \nEarth If your attack hits, the target must succeed at a Will save or become sickened for one round.
        \nFire If your attack hits, the target must succeed at a Reflex save or catch on fire for 1d4 rounds.
        \nWater If your attack hits, the target must succeed at a Fortitude save or become fatigued for one round. Saving throws against this strike are DC 11 + your initiation modifier.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `elementalFlux`,
        level: 2,
        name: `Arcane Shield`,
        type: `Counter`,
        shortDesc: `You make a Spellcraft check to generate a small shield of force to defend against an attack.`,
        longDesc: `[force]You rely on your unique insight into eldritch powers to createa shield of energy that protects you from an attack. You can initiate this counter in response to a melee or ranged attack (including touch or ranged touch spell attacks) being made against you. Make a Spellcraft check, using your opponent's attack roll as the DC. If you succeed, the attack is negated.This is a force effect, and may be used to block incorporeal attacks. \n\nAnimus augmentation: You may spend one point of animus to have the force shield crumble slowly after the attack rather than vanishing instantly, granting you a +2 shield bonus to your AC until the start of your next turn.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `elementalFlux`,
        level: 2,
        name: `Degrade Resistance`,
        type: `Boost`,
        shortDesc: `Your attacks for one round ignore 10 points of energy resistance of your active element's associated energy type.`,
        longDesc: `As a disciple of the Elemental Flux, you understand how to use elements to assault those normally resistant to them. When you initiate this boost, your attacks ignore the first 10 points of energy resistance to your active element for one round. \n\nAnimus augmentation: You may spend one point of animus to cause your first attack during the duration of this boost to deal an additional 1d6 points of damage of your active element's associated energy type.`, 
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `elementalFlux`,
        level: 2,
        name: `Eldritch Fang`,
        type: `Boost`,
        shortDesc: `Your next attack this round deals +1d4 force damage, overcomes damage reduction, and may stagger the target.`,
        longDesc: `[force]You fill your strike with eldritch energy that overwhelms the senses of your target. After initiating this boost, the next attack you make this round deals an additional 1d4 points of force damage and automatically overcomes damage reduction. If it hits, the target must succeed at a Fortitude save (DC 12 + your initiation modifier) or become staggered for one round. \n\nAnimus augmentation: You may spend one point of animus to increase the additional damage of this boost to2d4.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `One creature`,
        duration: `1 round`
      },
      {
        school: `elementalFlux`,
        level: 2,
        name: `Elemental Strike`,
        type: `Strike`,
        shortDesc: `Your attack has an additional effect based on your active element, and can be augmented for extra damage.`,
        longDesc: `You channel the fluctuating power of the elements to land an empowered blow. Make an attack. If it hits, it deals weapon damage as normal plus one of the following effects, based on your active element:
        \nAir If your attack hits, the target must succeed at a Reflex save or be knocked prone from the force of the blow.
        \nEarth If your attack hits, the target must succeed at a Reflex save or take an additional 2d6 points of acid damage at the start of your next turn.
        \nFire If your attack hits, the target must succeed at a Reflex save or be blinded by the smoke and flames for one round.
        \nWater If your attack hits, the target must succeed at a Fortitude save or become nauseated for one round from the chilling cold. Saving throws against this strike are DC 12 + your initiation modifier. \n\nAnimus augmentation: You may spend points of animus up (up to your maximum for augmenting Elemental Flux maneuvers) to increase the initial additional damage of this strike by 1d6 per point of animus spent and increase the save DC of this strike by +1 per point of animus spent.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `elementalFlux`,
        level: 2,
        name: `Energy Spark`,
        type: `Boost`,
        shortDesc: `As part of an attack, you fire a ray that deals 3d6 points of energy damage. You can augment to fire a second ray.`,
        longDesc: `You fill the air with elemental energy, which explodes as you strike your target. When you make an attack (including a strike), you can initiate this boost to fire a ray of energy at a creature within 30 feet. This ray requires a ranged touch attack to hit and deals 3d6 points of damage of your active element's associated energy type. \n\nAnimus augmentation: You may spend two points of animus to create an additional ray. The rays may be fired at the same or different targets, but both rays must be aimed at targets within 30 feet of you.`,
        initiationAction: `swift`,
        range: `30 ft.`,
        target: `One or more creatures (see text)`,
        duration: `Instantaneous`
      },
      {
        school: `elementalFlux`,
        level: 3,
        name: `Elemental Flux Stance`,
        type: `Stance`,
        shortDesc: `Your attacks deal +2d6 energy damage. In addition, you gain energy resistance 15 and an additional effect based on your active element.`,
        longDesc: `Filling both your body and soul with the power of the elements, you open yourself up to new powers. While you maintain this stance, your attacks deal an additional 2d6points of damage of your active element's associated energy type, you gain energy resistance 15 to your active element's associated energy type, and you gain one of the following effects, based on your active element:
        \nAir Your speed and perception are heightened, granting you a +4 bonus on initiative checks and a +4 dodge bonus to your AC.
        \nEarth The strength and durability of the earth suffuses your bones, granting you DR 5/adamantine.
        \nFire Your body is filled with warmth and healing light, granting you fast healing 1. In addition, you glow like a torch as if under the effect of a light spell.
        \nWater Your body is inured against debilitating effects, granting you a +2 bonus on all saving throws.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `elementalFlux`,
        level: 3,
        name: `Energy Jolt`,
        type: `Strike`,
        shortDesc: `You fire a ray that deals 3d6 points of energy damage, plus an additional effect based on your active element.`,
        longDesc: `You fill the opponent with harmful elemental energy, dealing damage and causing them to suffer debilitating effects. You fire a ray against an opponent within 30 feet. This ray requires a ranged touch attack to hit and deals 3d6points of damage of your active element's associated energy type. This strike also has one of the following effects, based on your active element:
        \nAir If your ray hits, the target must succeed at a Fortitude save or be pushed 15 feet away from you in a direction of your choice.
        \nEarth If your ray hits, the target takes an additional 1d6 points of acid damage at the start of your next turn, and must succeed at a Fortitude save or be sickened for a number of rounds equal to your initiation modifier.
        \nFire If your ray hits, the target must succeed at a Reflex save or take an additional 2d6 points of fire damage at the start of your next turn.
        \nWater If your ray hits, the target must succeed at a Fortitude save or become entangled for a number of rounds equal to your initiation modifier. Saving throws against this strike are DC 12 + your initiation modifier. \n\nAnimus augmentation: You may spend points of animus up (up to your maximum for augmenting Elemental Flux maneuvers) to increase the initial damage of this strike by1d6 per point of animus spent and increase the save DC of this strike by +1 per point of animus spent.`,
        initiationAction: `standard`,
        range: `30 ft.`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `elementalFlux`,
        level: 3,
        name: `Lance of Power`,
        type: `Strike`,
        shortDesc: `You create a 30-foot line that deals 5d6 points of energy damage, plus an additional effect based on your active element.`,
        longDesc: `With a swing of your blade, you release a rippling line of elemental energy. When you initiate this strike, you create a 30-foot line of energy that deals 5d6 points of damage of your active element's associated energy type to each creature within its area. This strike also has one of the following effects, based on your active element:
        \nAir The crack of thunder accompanying the lightning deafens creatures for a number of rounds equal to your initiation modifier.
        \nEarth The acid spray also creates a greasy, oily slick, causing creatures who fail their Reflex saves to drop items they are holding as if affected by the grease spell.
        \nFire The intensity of the flaming blast adds an additional +1 point of damage per die and dazzles each target for a number of rounds equal to your initiation modifier.
        \nWater The icy blast makes surfaces very slippery, and creatures who fail their Reflex saves slip on the ice and fall prone. Creatures caught in the line can make a Reflex save (DC13 + your initiation modifier) to take half damage and negate the added effect. \n\nAnimus augmentation: You may spend up to five points of animus to increase the damage of this strike by2d6 per point of animus spent and increase the save DC of this strike by +1 per point of animus spent. Th number of points of animus you may spend augmenting this maneuver is not limited by your level; you may always spend up to five points, although the total damage dice for this maneuver may not exceed your initiator level (up to a maximum of15d6). For example, a 7th-level initiator could spend five points of animus augmenting this maneuver, adding a +5bonus to his save DC, but he would still only deal 7d6 points of damage.`,
        initiationAction: `standard`,
        range: `30 ft.Area: 30-ft. line`,
        duration: `Instantaneous see text`
      },
      {
        school: `elementalFlux`,
        level: 3,
        name: `Raging Flux`,
        type: `Strike`,
        shortDesc: `Your melee attack deals +4d6 energy damage and pushes the target back 5 feet for every 10 points of damage dealt.`,
        longDesc: `You know how to strike with such eldritch force that it drives your foes backwards. Make an attack. If it hits, it deals weapon damage as normal plus an additional 4d6 points of damage of your active element's associated energy type. For every 10 points of damage you deal, the target of this attack is pushed 5 feet away from you in any direction. If this movement causes the target to collide with a solid object(such as a tree or a wall), it takes an additional 1d6 points of bludgeoning damage from striking the surface. \n\nAnimus augmentation: You may spend one point of animus to push the target an additional 5 feet.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `elementalFlux`,
        level: 4,
        name: `Arcane Torrent`,
        type: `Strike`,
        shortDesc: `You fire missiles of force that deal 6d6 points of damage unless the target succeeds at a Reflex save. You can augment to instead fire an area barrage of missiles.`,
        longDesc: `[force]You unleash a sudden burst of eldritch energy that surges towards a distant foe. When you initiate this strike, selecta target within 60 feet. Magical missiles of explosive force swiftly fly at this target, dealing 6d6 points of force damage to the target unless it succeeds at a Reflex save (DC 14 +your initiation modifier). \n\nAnimus augmentation: You may spend two points of animus to instead fire a barrage of force missiles. Instead of this strike's normal effect, you create a 15-foot burst within60 feet of you, affecting each creature within its area as if you had targeted them.`,
        initiationAction: `standard`,
        range: `60 ft.`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `elementalFlux`,
        level: 4,
        name: `Assay Resistance`,
        type: `Boost`,
        shortDesc: `Your next attack ignores 25 points of energy resistances, overcomes damage reduction, and deals +2d6 energy damage.`,
        longDesc: `By directly targeting the elemental essence that suffuses all creatures, you overcome an opponent's defenses with a powerful attack. Your next attack ignores the first 25 points of energy resistance to your active element's associated energy type, automatically overcomes damage reduction, and deals an additional 2d6 points of damage. \n\nAnimus augmentation: You may spend one point of animus to increase this boost's additional damage to 3d6.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `elementalFlux`,
        level: 4,
        name: `Eldritch Consumption`,
        type: `Counter`,
        shortDesc: `Make a Spellcraft check to negate a spell or power targeting you; if you succeed, you heal 5 hit points per level of the effect.`,
        longDesc: `You have such an intimate understanding of the underlying nature of magic that you can capture its essence and feast on it to rejuvenate yourself. You can initiate this counter in response to being targeted by a spell, spell-like ability, power, or psi-like ability. Make a Spellcraft check (DC 11 +the effect's caster or manifester level). If you succeed, the effect is countered, and you heal 5 hit points per level of the effect you countered.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `elementalFlux`,
        level: 4,
        name: `Energy Hammer`,
        type: `Strike`,
        shortDesc: `Your attack deals +6d6 energy damage, plus an additional effect based on your active element.`,
        longDesc: `As you advance your training, you learn to unleash evermore powerful bursts of energy. Make an attack. If it hits, it deals weapon damage as normal plus an additional 6d6 points of damage of your active element's associated energy type. This strike also has one of the following effects, based on your active element:
        \nAir If your attack hits, the target must succeed at a Fortitude save or become deafened for 1d4 rounds.
        \nEarth If your attack hits, the target must succeed at a Will save or become stunned for 1d4 rounds
        \nFire If your attack hits, the target must succeed at a Reflex save or become blinded for 1d4 rounds.
        \nWater If your attack hits, the target must succeed at a Fortitude save or become nauseated for 1d4 rounds. Saving throws against this strike are DC 14 + your initiation modifier. \n\nAnimus augmentation: You may spend points of animus up (up to your maximum for augmenting Elemental Flux maneuvers) to increase the additional damage of this strike by 1d6 per point of animus spent and increase the save DC of this strike by +1 per point of animus spent.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `elementalFlux`,
        level: 5,
        name: `Elemental Drive`,
        type: `Strike`,
        shortDesc: `You fire a ray that deals 9d6 points of energy damage and bull rushes the target.`,
        longDesc: `You charge your weapon with kinetic and elemental energy, driving them back with a wave of elemental power. You fire a ray against an opponent within 30 feet. This ray requires a ranged touch attack to hit and deals 9d6 points of damage of your active element's associated energy type, and you attempt a bull rush against your target, calculating your CMB using your initiation modifier and initiator level in place of your Strength modifier and base attack bonus. \n\nAnimus augmentation: You may spend one point of animus to gain a +5 bonus on your bull rush attempt.`,
        initiationAction: `standard`,
        range: `30 ft.`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `elementalFlux`,
        level: 5,
        name: `Elemental Absorption`,
        type: `Counter`,
        shortDesc: `You become immune to your active element's associated energy type, instead healing for half the damage that would be dealt for one round.`,
        longDesc: `You learn to suffuse your being with an element to such a degree that its presence heals you instead of harming you. You can initiate this counter at any time to gain immunity to your active element's associated energy type for one round. While under the effect of this counter, attacks and effects that that deal energy damage of that type instead heal you for half of the damage they would normally deal.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `elementalFlux`,
        level: 5,
        name: `Elemental Vortex`,
        type: `Strike`,
        shortDesc: `Your attack deals +8d6 energy damage, plus an additional effect based on your active element.`,
        longDesc: `A whirling vortex of elemental energy engulfs your foe just as your blade lands. Make an attack. If it hits, it deals weapon damage as normal plus an additional 8d6 points of damage of your active element's associated energy type. This strike also has one of the following effects, based on your active element:
        \nAir If the target is wearing metal armor, wielding a metal shield, or wielding a weapon mostly composed of metal, you and your allies gain a +4 bonus on attack rolls against the target until the start of your next turn, regardless of whether or not your attack hits.
        \nEarth If your attack hits, you may make a free trip attempt that does not provoke attacks of opportunity, with a bonus on the attempt equal to your initiation modifier.
        \nFire If your attack hits, the target must succeed at a Reflex save or catch on fire for 2d4 rounds, and become sickened from the pain for as long as they are burning.
        \nWater If your attack hits, the target must succeed at a Fortitude save or become entangled for a number of rounds equal to your initiation modifier. Saving throws against this strike are DC 15 + your initiation modifier. \n\nAnimus augmentation: You may spend points of animus up (up to your maximum for augmenting Elemental Flux maneuvers) to increase the additional damage of this strike by 1d6 per point of animus spent and increase the save DC of this strike by +1 per point of animus spent.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `elementalFlux`,
        level: 5,
        name: `Enter the Vortex`,
        type: `Stance`,
        shortDesc: `You can fire blasts of energy that deal 4d6 damage, and gain a movement type based on your active element.`,
        longDesc: `Riding on the currents of elemental energy, you gain the benefit of a new form of movement. While you maintain this stance, you gain the ability to throw blasts of elemental energy as if using a ranged weapon. These blasts are considered to be part of the thrown weapon group, have a range increment of 30 feet, and deal double damage on a critical hit. Attacks made with these blasts are ranged touch attacks that deal 4d6 points of damage of your active element's associated energy type. In addition, you gain one of the following effects, based on your active element:
        \nAir You gain a fly speed equal to your base land speed, with good maneuverability.
        \nEarth You gain a burrow at a speed equal to your base land speed, and you gain tremor sense with a range of 30 feet. In addition, you can breath freely while underground.
        \nFire You gain a +4 circumstance bonus on initiative checks and your base land speed increases by 30 feet.
        \nWater You gain a swim speed equal to twice your base land speed, and you also gain the aquatic and amphibious subtypes.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `elementalFlux`,
        level: 6,
        name: `Eldritch Energy Hammer`,
        type: `Strike`,
        shortDesc: `Your attack affects the target as if by a greater dispel magic, dealing additional damage if you dispel an effect.`,
        longDesc: `You know how to destroy the bonds that hold magic together just as easily as you can forge them. Make an attack. If it hits, it deals weapon damage as normal, and you affect the target as if you had cast a targeted greater dispel magic on it. Make a dispel check against the spell with the highest caster level affecting the target, using your initiator level as your caster level for the check. If you do not successfully dispel that spell, compare the same result to the spell with the next highest caster level. Repeat this process until you have dispelled one spell affecting the target, or you have failed to dispel every spell. You can only end one spell with this maneuver. If you successfully dispel a spell affecting the target, your target takes 1d6 points of force damage foreach level of the effect dispelled. \n\nAnimus augmentation: You may spend points of animus up (up to your maximum for augmenting Elemental Flux maneuvers) to gain a +2 bonus on your dispel check per point spent.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `elementalFlux`,
        level: 6,
        name: `Elemental Destruction Ring`,
        type: `Strike`,
        shortDesc: `You create a 20-foot burst around you that deals 12d6 points of energy damage, plus an additional effect based on your active element.`,
        longDesc: `You whip the elements around you into a fury, then unleash the energy at all the foes who surround you. When you initiate this maneuver, you release a 20-foot burst of energy entered on you that deals 12d6 points of damage of your active element's associated energy type to any creatures in the area. You do not take damage from this burst. This strike also has one of the following effects, based on your active element:
        \nAir The flash of lightning blinds targets for 1d4 rounds.
        \nEarth The acid is gummy and sticky, applying a –4 penalty to targets' Dexterity scores and a –2 penalty to attack rolls for 1d4 rounds. In addition, targets take 1d6 points of acid damage at the start of each of their turns for a number of rounds equal to your initiation modifier.
        \nFire The intense heat and pain from the blast dazes targets for one round.
        \nWater Targets become staggered for 1d6 rounds from the intense chill. Creatures caught in the burst can make a Reflex save(DC 16 + your initiation modifier) to take half damage and negate the added effect. \n\nAnimus augmentation: You may spend any number of animus points to augment this strike, regardless of your level. For every point of animus you spend, this strike's damage increases by 1d6. The total damage dice for this maneuver may not exceed your initiator level (up to a maximum of20d6).`,
        initiationAction: `standard`,
        range: `20 ft.Area: 20-ft. radius burst, centered on you`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `elementalFlux`,
        level: 6,
        name: `Eldritch Fang Flurry`,
        type: `Boost`,
        shortDesc: `Your attacks for one round deal +3d6 force damage, overcome damage reduction, and a struck creature must make a Fortitude save or become blinded for one round.`,
        longDesc: `[force]Striking at your foes with elemental fury, you aim to disable his opponents in addition to harming them. After initiating this boost, all attacks you make for one round deal an additional 3d6 points of force damage and automatically overcome damage reduction. In addition, any opponent hit by one of your attacks must succeed at a Fortitude save(DC 16 + your initiation modifier) or become blinded for one round. Multiple hits do not extend the duration of this blinding effect, though they do prompt multiple saves.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `elementalFlux`,
        level: 6,
        name: `Nexus of Elemental Retribution`,
        type: `Stance`,
        shortDesc: `You gain resistance 30 to acid, cold, electricity and fire. Some of the damage you absorb is stored and can be unleashed as a burst around you.`,
        longDesc: `You can absorb and redirect the flow of elemental power, syphoning away energies that would harm you and making them your own. While you maintain this stance, you gain energy resistance 30 to acid, cold, electricity, and fire. Anytime your resistance reduces damage of one of those types, it is stored in a pool of up to twice your initiator level. As a swift action, you can unleash your stored energy, creating a 20-foot burst centered on you that deals damage of your active element's associated energy equal to the amount stored, then reducing the pool to 0. You do not take damage from this burst. Creatures caught within the area can make a Reflex save (DC 16 + your initiation modifier) to take half damage.`,
        initiationAction: `swift`,
        range: `Personal (see text)`,
        target: `You (see text)`,
        duration: `Stance`
      },
      {
        school: `elementalFlux`,
        level: 6,
        name: `Shatter Resistance`,
        type: `Boost`,
        shortDesc: `Your attacks deal +4d6 energy damage for one round. In addition, you ignore energy resistance for one round, and creatures immune to energy damage take half damage, rather than none. You can augment to also reduce the spell resistance of creatures struck.`,
        longDesc: `You know that the might of the elements can overwhelm any defense. After initiating this boost, all attacks you make for one round ignore energy resistance of your targets, and creatures with an energy immunity still take half damage, rather than no damage. In addition, all of your attacks deal an additional 4d6 points of damage of your active element's associated energy type for the same duration. \n\nAnimus augmentation: You may spend two points of animus to lower the spell resistance possessed by those damaged by your attacks by 10 for the duration of this boost.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `elementalFlux`,
        level: 7,
        name: `Cascade of Elemental Wrath`,
        type: `Strike`,
        shortDesc: `Make a full attack. Each attack deals additional damage equal to 1d6 + your initiation modifier, and you can change your active element as a free action after each attack.`,
        longDesc: `Each slash of your blade releases more and more eldritch power, overwhelming your enemies with the power of your strikes. Make a full attack. Each attack deals damage entirely of your active element's associated energy type, and additional damage equal to 1d6 + your initiation modifier. During your full attack, you can change your active element as a free action once after each subsequent attack. \n\nAnimus augmentation: You may spend two points of animus to make an extra attack during this strike at your highest attack bonus.`,
        initiationAction: `full-round`,
        range: `Melee or ranged attack`,
        target: `One or more creatures (see text)`,
        duration: `Instantaneous`
      },
      {
        school: `elementalFlux`,
        level: 7,
        name: `Force Majeure`,
        type: `Strike`,
        shortDesc: `Your melee attack deals +14d6 energy damage. All the damage dealt by the attack is considered energy damage, rather than its normal type. You can augment to instead deal force damage.`,
        longDesc: `You infuse your weapon with pure elemental power, striking with a force beyond mere steel. Make an attack. If it hits, it deals weapon damage as normal plus an additional 14d6points of damage. Unlike with a normal attack, all damage dealt by this attack is to be considered to be of your active element's associated energy type (including weapon damage, weapon enchantments, and bonuses from a high strength or from feats).Animus augmentation: You may spend three points of animus to infuse your strike with raw arcane energy, unaligned to any elemental forces. If you do, your attack deals force damage rather than elemental damage.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `elementalFlux`,
        level: 7,
        name: `Redirecting Flux`,
        type: `Counter`,
        shortDesc: `Make a Spellcraft check to redirect a magical effect to a new target.`,
        longDesc: `Your mastery of the Elemental Flux discipline knows how to read and alter the flow of magical energy. You can initiate this counter when you are targeted by a spell, power, spell-like ability, or psi-like ability. Make a Spellcraft check (DC15 + the effect's caster or manifester level). If you succeed, you can redirect that effect to another target of your choice within the spell's range. If the effect has multiple targets, you can choose to change all of its targets to other valid targets within range. \n\nAnimus augmentation: You may spend points of animus up (up to your maximum for augmenting Elemental Flux maneuvers) to gain a +2 bonus on your Spellcraft check per point spent.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `elementalFlux`,
        level: 8,
        name: `Elemental Breach`,
        type: `Boost`,
        shortDesc: `Your attacks for one round ignore energy resistances and immunities, and overcome damage reduction. Any damage of your active element's associated energy type is increased by 50%.`,
        longDesc: `As a master of the Elemental Flux discipline, you know how to overwhelm the defenses of your targets and expose their weaknesses to the elements. After initiating this boost, your attacks for one round ignore all energy resistances and energy immunities and automatically overcome damage reduction. Additionally, any damage you deal of your active element's associated energy type is increased by 50% for the same duration.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `elementalFlux`,
        level: 8,
        name: `Master of the Elements`,
        type: `Stance`,
        shortDesc: `You transform as if under the effect of the elemental body III spell.`,
        longDesc: `You attune your very form to roiling elemental energies and merge with them. While you maintain this stance, your type changes to outsider (native) and you gain your active element as a subtype. In addition, you are treated as if you were under the effects of the elemental body III spell. You may continue to wield weapons, wear armor, and use other items while in this form, and your new body does not damage or otherwise adversely affect your equipment.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `elementalFlux`,
        level: 8,
        name: `Zephyr Flux`,
        type: `Strike`,
        shortDesc: `You transform into energy, teleporting across the battlefield and dealing damage to creatures you touch.`,
        longDesc: `[teleportation]Upon reaching supreme levels of understanding in this discipline, you may transmute your entire being into elemental energy and travel in the blink of an eye across the battlefield, leaving a wake of devastation behind you. When you initiate this strike, select a primary target and a number of secondary targets within 30 feet of the primary target equal to your initiation modifier. A creature cannot be both a primary target and a secondary target. Your path across the battlefield deals 14d6 points of damage to the primary target and 7d6 points of damage to secondary targets. All damage is of your active element's associated energy type. This strike also has one of the following effects, based on your active element:
        \nAir Any target who fails its save is dazed by the electrical jolt for one round.
        \nEarth Any target who fails its save is deafened from the seismic vibrations for 1d3 rounds.
        \nFire Any target who fails its save is engulfed in cinders and smoke, becoming blinded for 1d3 rounds.
        \nWater Any target who fails its save is nauseated for 1d3 rounds from the bone-chilling cold. All targets can make a Reflex save (DC 18 + your initiation modifier) to take half damage and negate the added effect. After this strike concludes, you can move to any space within 10 feet of a secondary target of this strike without provoking attacks of opportunity. As a supernatural ability, this strike is not subject to spell resistance. \n\nAnimus augmentation: You may spend points of animus up (up to your maximum for augmenting Elemental Flux maneuvers) to increase the initial damage of this strike by2d6 (1d6 to secondary targets) per point of animus spent and increase the save DC of this strike by +1 per point of animus spent.`,
        initiationAction: `full-round`,
        range: `120 ft.`,
        target: `One primary target, plus additional secondary targets equal to your initiation modifier`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `elementalFlux`,
        level: 9,
        name: `Strike of Elemental Devestation`,
        type: `Strike`,
        shortDesc: `You fire five elemental rays, each dealing energy damage and an effect based on the element of the ray.`,
        longDesc: `[teleportation]The ultimate expression of elemental power can only be unleashed by a master of the Elemental Flux discipline, and by calling upon the arcane forces of magic as well as the terrific power of the elements, the disciple may crush his opponents under a fierce magical assault. The maneuver creates five distinct blasts of energy, one of each element and one of pure force. These blasts may be fired at the same or different targets, as long as each target is within 30 feet of you. Each blast requires a ranged touch attack to hit and has one of the following effects if it hits:
        \nAir: A bolt of electrical energy that deals 25 points of electricity damage and staggers the opponent for 1d4 rounds. If the target is wearing metal armor or a metal shield, or wielding a primarily metal weapon then the attack gains a +4 circumstance bonus on hit
        \nEarth: A jet of boiling acid that deals 25 points of acid damage and blinds the target for 1d4 rounds
        \nFire: A stream of sulfurous fire that deals 25 points of fire damage, nauseates the target for 1d4 rounds, and sets them on fire for the same duration
        \nForce: A hammering blast of arcane force that deals 50 points of force damage
        \nWater: A freezing beam of cold that deals 25 points of cold damage and the target must succeed at a Fortitude save (DC 19 + your initiation modifier) or become dazed for 1d4 rounds
        \n\nAnimus augmentation: For each blast, you may spend up to three points of animus to increase its initial damage by 10 per point of animus spent and its save DC (if any) by +1 per point of animus spent. You may spend any number of animus points to augment this strike, regardless of your level. However, each blast must be augmented separately, and you cannot spend more than three points per blast. The blasts of this strike are otherwise immutable; you cannot use abilities such as the mystic's elemental attunement class feature to change the damage types dealt.`,
        initiationAction: `full-round`,
        range: `30 ft.`,
        target: `Up to 5 creatures`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `eternalGuardian`,
        level: 1,
        name: `Guard's Oath`,
        type: `Strike`,
        shortDesc: `On a failed save, your foe's movement is cursed, provoking attacks of opportunity against you even if it otherwise would not.`,
        longDesc: `[curse]A central concept of the discipline of the Eternal Guardian is the ability to restrict an opponent's movement—prevent their escape or halting their advance. Your basic but potent strike allows you to harry and disrupt a foe until they laydown their arms. Make a melee attack. If it hits, it deals weapon damage as normal, and the target must succeed at a Will save (DC 11 + your initiation modifier) or become cursed and unable to move within your threatened area(including with 5-foot steps and using the Withdraw action)without provoking an attack of opportunity from you for24 hours. If the target drops all weapons it is holding, it can make another saving throw to end this effect. An affected target that is not holding a weapon can draw or pick up a weapon, then drop it to gain a new saving throw, but can never gain more than one save per round against this curse.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `eternalGuardian`,
        level: 1,
        name: `Strike of the Infinite Protector`,
        type: `Strike`,
        shortDesc: `Your attack grants an ally a +2 bonus to AC.`,
        longDesc: `You swear to protect your charge, while living or dead, with an unbreakable oath. Make an attack. If it hits, it deals weapon damage as normal and a fragment of your life force envelops an ally within 30 feet, granting them a +2 bonus to their AC for one round.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack and 30 ft. (see text)`,
        target: `One opponent and one ally`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `eternalGuardian`,
        level: 1,
        name: `Terrifying Blow`,
        type: `Strike`,
        shortDesc: `Your attack may frighten the target. Deals +1d6 damage against a cursed opponent.`,
        longDesc: `[fear]With a bellowing cry, you deliver a fearsome wound to your opponent. Make an attack. If it hits, it deals weapon damage as normal, and the target must succeed at a Will save (DC11 + your initiation modifier) or become frightened for one round. If your target is cursed, your attack deals an additional 1d6 points of damage.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `eternalGuardian`,
        level: 1,
        name: `Valiant Keeper's Stance`,
        type: `Stance`,
        shortDesc: `Allies do not provoke attacks of opportunity when moving through squares you threaten.`,
        longDesc: `The basics of the Eternal Guardian discipline teach you how to ward your allies from errant attacks. While you maintain this stance, your allies do not provoke attacks of opportunity from enemies while they move through squares you threaten.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `eternalGuardian`,
        level: 1,
        name: `Vigilant Keeper's Stance`,
        type: `Stance`,
        shortDesc: `Enemies treat squares your threatened area as difficult terrain.`,
        longDesc: `[curse]You adopt an aggressive stance which slows your enemies‘ ability to advance or retreat. While you maintain this stance, opponents treat all squares you threaten as difficult terrain. This does not prevent those opponents from charging through your threatened area, however. In addition, whenever you hit an opponent with an attack of opportunity, that opponent becomes cursed until the end of your next turn.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `eternalGuardian`,
        level: 1,
        name: `Warden's Bearing`,
        type: `Boost`,
        shortDesc: `You gain a +2 bonus to a combat maneuver attempt, and you are treated as one size category larger for determining if you can make that attempt.`,
        longDesc: `You shift your weight and assume a stronger, more impressive position. You can activate this boost while making a combat maneuver attempt. You gain a +2 bonus on your combat maneuver check, you do not provoke attacks of opportunity for making that combat maneuver attempt, and you are treated as one size category larger for purposes of determining if your combat maneuver can affect your target (such as a Medium creature attempting to bull rush a Huge creature).`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `eternalGuardian`,
        level: 2,
        name: `Debilitating Fear`,
        type: `Boost`,
        shortDesc: `Daze a cowering, shaken, frightened, or panicked opponent.`,
        longDesc: `[fear]You fill your target with the fear that prey feels when it sees a mighty predator, impairing their ability to act. When you activate this boost, choose one creature within range that is cowering, shaken, frightened, or panicked. That creature must succeed at a Will save (DC 12 + your initiation modifier) or become dazed for 1 round.`,
        initiationAction: `swift`,
        range: `60 ft.`,
        target: `One creature`,
        duration: `1 round`
      },
      {
        school: `eternalGuardian`,
        level: 2,
        name: `Fear the Reaper`,
        type: `Counter`,
        shortDesc: `Intimidate an opponent into missing an ally.`,
        longDesc: `[fear]You have learned to use the fear you create as a method of defense for both yourself and your allies. You can initiate this counter in response to a melee or ranged attack being made against an ally (including you) within 60 feet. Make an Intimidate check, using your opponent's attack roll as the DC. If you succeed, the attack is negated, and the attacker becomes shaken for one round, as if you had demoralized them with the Intimidate check.`,
        initiationAction: `immediate`,
        range: `60 ft. (see text)`,
        target: `One ally (see text)`,
        duration: `Instantaneous`
      },
      {
        school: `eternalGuardian`,
        level: 2,
        name: `Oath of the Intercessor`,
        type: `Counter`,
        shortDesc: `You take a blow meant for an ally.`,
        longDesc: `You make an unbreakable vow to take the brunt of an attack in place of your ally. You can initiate this counter in response to a melee or ranged attack being made against an ally within your melee reach. You and that ally switch places, and the attack targets you instead. Neither your nor your ally's movement provokes attacks of opportunity.`,
        initiationAction: `immediate`,
        range: `Melee reach`,
        target: `One ally`,
        duration: `Instantaneous`
      },
      {
        school: `eternalGuardian`,
        level: 2,
        name: `Strike of the Royal Guardian`,
        type: `Strike`,
        shortDesc: `Your attack reduces your opponent's damage and curses them.`,
        longDesc: `[curse]Some foes may slip past your guard, but as a disciple of the Eternal Guardian, you have other ways to minimize their threat, afflicting your enemies with an agonizing curse that cripples their attacks. Make an attack. If it hits, it deals weapon damage as normal, and the target becomes cursed, taking a –2 penalty on damage rolls with weapon attacks for as long as it is cursed. If an affected target does not make an attack during its turn, it can make a Will save (DC 12+ your initiation modifier) to end this effect. If the target prostrates itself (treated as dropping prone) and grovels fora full-round, the curse is automatically removed.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `eternalGuardian`,
        level: 2,
        name: `Relentless Warden's Strike`,
        type: `Strike`,
        shortDesc: `You teleport to a creature that is cursed or afraid, then make a melee attack that deals +2d6 damage.`,
        longDesc: `[teleportation]You hound a weakened enemy, keeping them in check. When you initiate this strike, you may teleport to any space within 60 feet that is within 10 feet of a creature that is cowering, cursed, shaken, frightened, or panicked. After you teleport, make a melee attack against that creature, if able. If it hits, it deals weapon damage as normal plus an additional2d6 points of damage.`,
        initiationAction: `standard`,
        range: `Melee attack and 60 ft. (see text)`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `eternalGuardian`,
        level: 3,
        name: `Binding Fetters`,
        type: `Boost`,
        shortDesc: `Your attack curses a creature, and that creature must make a Will save or be teleported back to you at the start of your next turn.`,
        longDesc: `[curse, teleportation]Your oath binds you and the target of your attack in combat with each other, leashing your very souls together. You can activate this boost when you hit a creature with a melee attack. That creature becomes cursed for one round, and at the start of your next turn, it must succeed at a Will save (DC 13 + your initiation modifier) be teleported to an unoccupied square adjacent to you. This teleportation functions regardless of the distance between you and the target, although it cannot teleport a target on another plane of existence. For every 10 feet the target moves during its turn preceding the teleportation, the save DC of this strike increases by +1 (up to a maximum of a +3 increase to the DC). You can touch an ally in place of a willing ally to curse them, in which case they automatically fail their Will save to resist being teleported back to you at the start of your next turn. You can end this effect and the cursed condition on any the target at any time as a free action.`,
        initiationAction: `swift`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `1 round`
      },
      {
        school: `eternalGuardian`,
        level: 3,
        name: `Intruder's End`,
        type: `Counter`,
        shortDesc: `You dare your foes to enter your protected sanctum, dramatically increasing your threatened area and gaining additional attacks of opportunity.`,
        longDesc: `[teleportation]You declare an area to be your protected sanctum, and dare any foe to try their hand at entering your sanctum. With each opportunity, you warp space, teleporting across your domain to attack before returning. After initiating this counter, your threatened area increases to 20 feet for one round. This overlaps with, rather than stacking with, any natural reach you otherwise have; if your natural reach is greater than 20 feet, it is not reduced. In addition, for the duration of this boost, you gain a +2 circumstance bonus on attack rolls while making attacks of opportunity and can make a number of additional attacks of opportunity this round equal to your initiation modifier. This stacks with the Combat Reflexes feat and other effects that increase the number of attacks of opportunity you can make in a round.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `eternalGuardian`,
        level: 3,
        name: `Stance of the Eternal Guardian`,
        type: `Stance`,
        shortDesc: `You tie your soul to a creature, giving benefits similar to a shield other spell.`,
        longDesc: `You bind your soul in a protective embrace around one of your allies. When you enter this stance, choose an ally within 60 feet. While you maintain this stance and as longas that ally is within 60 feet of you, that gains a +1 deflection bonus to its AC and a +1 bonus on all saving throws. At initiator level 8th and at every four initiator levels thereafter, these bonuses increase by +1 (up to a maximum of +5 at20th level). In addition, as long as that ally is within 60 feet of you, it takes only half damage from all wounds and attacks(including special abilities) that deal hit point damage. The amount of damage not taken by the your ally is taken by you. Forms of harm that do not involve hit points, such as charm effects, temporary ability damage, level draining, and death effects, are not shared. If the subject suffers a reduction of hit points from a lowered Constitution score, the reduction is not split with you because it is not hit point damage.`,
        initiationAction: `swift`,
        range: `Personal and 60 ft. (see text)`,
        target: `You and one ally (see text)`,
        duration: `Stance`
      },
      {
        school: `eternalGuardian`,
        level: 3,
        name: `Swallow Your Fear`,
        type: `Counter`,
        shortDesc: `You or an ally gain a +4 morale bonus to a save against a mind-affecting effect. If your target succeeds on your save, they gain temporary hit points.`,
        longDesc: `Your knowledge of fear and devotion allows you to absorb and control harmful magics which can affect the mind. you can initiate this counter in response to an ally (including yourself) within 60 feet rolling a saving throw against a mind-affecting effect. You or your ally gains a +4 morale bonus on that saving throw, and if the save is successful, that ally gains a number of temporary hit points equal to the save DC of that effect for a number of rounds equal to your initiator level.`,
        initiationAction: `immediate`,
        range: `60 ft.`,
        target: `One ally`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `eternalGuardian`,
        level: 4,
        name: `Grim Guard's Laughter`,
        type: `Strike`,
        shortDesc: `Your attack deals +4d6 damage and you can intimidate all opponents within 30 feet. If your target is cursed, they also may become frightened.`,
        longDesc: `[fear]Your deep, disturbing laughter echoes throughout the battlefield filling your foes with dread and causing their wills to falter. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 4d6 points of damage, and you can make an Intimidate check, treating that check as a demoralize attempt against every opponent within 30feet. If you successfully demoralize a cursed creature with this strike, that creature becomes frightened for one round in addition to becoming demoralized.`,
        initiationAction: `standard`,
        range: `Melee attack and 30 ft. (see text)`,
        target: `One creature (see text)`,
        duration: `Instantaneous`
      },
      {
        school: `eternalGuardian`,
        level: 4,
        name: `Oath of Torpor`,
        type: `Boost`,
        shortDesc: `Your attacks lay a binding curse on their targets, possibly slowing them if they move.`,
        longDesc: `[curse]You swear an oath to your foes, that their limbs will be heavy and their wills sapped. After initiating this boost, each successful attack or combat maneuver attempt you make against an opponent before the start of your next turn also causes that opponent to become cursed for one minute. Each time a creature cursed by this boost moves, it must succeed at a Will save (DC 14 + your initiation modifier)or become slowed (as the spell) until the end of its next turn. A successful save against this effect ends the curse. Alternatively, if a creature cursed by this boost does not willingly move from its space for two consecutive rounds, the curse ends without a need for a saving throw. A creature forced to move (such as by a bull rush) does not trigger this effect.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `eternalGuardian`,
        level: 4,
        name: `Strike of the Steadfast Legion`,
        type: `Strike`,
        shortDesc: `Your attack causes you and your allies gain damage reduction, and allies can sacrifice hit points to grant other allies temporary hit points for one round.`,
        longDesc: `When you bring your enemy low, your strength bolsters the will of your allies. Make an attack. If it hits, it deals weapon damage as normal plus additional damage equal to1/2 your initiator level, and all allies within 60 feet of you gain damage reduction/– equal to your initiation modifier(minimum 1) for one round. In addition, any ally who gains damage reduction from this strike can expend a number of hit point up to your initiator level to grant any other ally who gained damage reduction from this strike three times that amount in temporary hit points. These temporary hit points last for one round.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack and 60 ft. (see text)`,
        target: `One creature (see text)`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `eternalGuardian`,
        level: 4,
        name: `Watchman's Rebuke`,
        type: `Counter`,
        shortDesc: `You force an opponent to reroll a successful saving throw. Cursed creatures take a -2 penalty on that reroll.`,
        longDesc: `Your supernatural will calls for your enemies to cease resisting and submit to your judgement. You can initiate this counter when an opponent within 60 feet succeeds on a saving throw. That opponent must immediately reroll its save, using the result of the second roll to determine if it succeeded or failed. If that opponent is cursed, it takes a -2 penalty on this reroll.`,
        initiationAction: `immediate`,
        range: `60 ft.`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `eternalGuardian`,
        level: 5,
        name: `Jailer of the Damned`,
        type: `Stance`,
        shortDesc: `You ignore immunity to mind-affecting and fear effects, and you gain a +2 bonus on combat maneuver attempts against afraid creatures.`,
        longDesc: `You adopt the stance of the wardens which guard the gates of death. While you maintain this stance, your maneuvers and other abilities treat creatures that are normally immune to mind-affecting effects and fear effects as if they were not immune. Such creatures gain a +5 resistance bonus on saving throws against these effects, rather than ignoring them outright. In addition, while you maintain this stance, you do not provoke attacks of opportunity when attempting a combat maneuver against a creature that is shaken, frightened, or panicked, and you gain a +2 bonus on your combat maneuver checks against such creatures.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `eternalGuardian`,
        level: 5,
        name: `Unbearable Gaze`,
        type: `Counter`,
        shortDesc: `You blind an opponent, potentially causing their attack or spell to miss.`,
        longDesc: `[fear]Your stare fills a creature with supernatural dread, causing them to fear looking into your eyes lest it cause them great harm. You can initiate this counter in response to being targeted by an attack, spell, or power originating from a creature within 60 feet. That creature must succeed at a Reflex save (DC 15 + your initiation modifier) or become blinded for one round, averting its eyes as a result of utter terror. If the target fails its saving throw, the attack or effect suffers a 50% miss chance against you, even if it would normally automatically hit. A creature without eyes or that is already blind is immune to this effect.`,
        initiationAction: `immediate`,
        range: `60 ft.`,
        target: `One creature`,
        duration: `1 round`
      },
      {
        school: `eternalGuardian`,
        level: 5,
        name: `Shackles of the Condemned`,
        type: `Strike`,
        shortDesc: `Your attack deals +5d6 damage and you shackle yourself to your target with supernatural chains, entangling them.`,
        longDesc: `[curse]Your strike binds your target, summoning cursed manacles that bind both you and your enemy to a single fate. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 5d6 points of damage, and the target becomes cursed and entangled for a number of rounds equal to your initiator level. While under the effect of this maneuver, the target cannot move further than 30 feet away from you, even by teleportation effects. You or your target can pull on the chain as a trip or drag attempt as an attack action without provoking attacks of opportunity. You gain a +4 bonus on combat maneuver checks and to your CMD when making these attempts or having them made against you. If the target begins and ends its turn adjacent to you, it can make a Will save (DC 15 + your initiation modifier) to end the effects of this strike. If you move further than 30 feet away from the target, the curse is broken and the effects of this strike end. You can end the effects of this strike as a free action, and it ends automatically if you are knocked unconscious or killed.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `eternalGuardian`,
        level: 5,
        name: `Stand Your Ground`,
        type: `Counter`,
        shortDesc: `You and an ally take half damage from attacks and effects for one round.`,
        longDesc: `You and your ally stand together to defend your position, strengthened by supernatural resolve. When you initiate this counter, choose an ally within 60 feet. For one round, you and that ally each take only half the damage you would otherwise take. Damage that is redirected (such as by the shield other spell or the share pain power) or intentionally taken (such as by strike of the steadfast legion) is not reduced.`,
        initiationAction: `immediate`,
        range: `60 ft.`,
        target: `You and one ally`,
        duration: `1 round`
      },
      {
        school: `eternalGuardian`,
        level: 6,
        name: `Charge of Dismay`,
        type: `Strike`,
        shortDesc: `Charge attack that deals +6d6 damage, does not provoke attacks of opportunity, and may frighten nearby enemies.`,
        longDesc: `[fear]The disciple barrels through the enemy lines, terrifying his foes. Make a charge attack that does not provoke attacks of opportunity. If it hits, it deals weapon damage as normal plus an additional 6d6 points of damage, and all opponents(including the target) within 30 feet must succeed at a Will save (DC 16 + your initiation modifier) or become frightened for 1d4 rounds and shaken for one minute after. Creatures with more hit dice than your initiator level cannot become frightened by this strike, although they still become shaken on a failed save. Any creature that starts its turn without line of sight to you can make another saving throw to end this effect.`,
        initiationAction: `full-round`,
        range: `Melee attack and 30 ft. (see text)`,
        target: `One creature (see text)`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `eternalGuardian`,
        level: 6,
        name: `Inescapable Fetters`,
        type: `Boost`,
        shortDesc: `Your attacks for one round curse creatures, and those creature must make a Will save or be teleported back to you at the start of each of their turns.`,
        longDesc: `[curse, teleportation]Your nightmarish oath that no foe will escape you draws. After initiating this boost, each creature you hit with a melee attack before the start of your next turn becomes cursed for one round per four initiator levels you possess. At the end of each of the turns of a creature cursed by this boost, that creature must succeed at a Will save (DC 16 +your initiation modifier) or be teleported to an unoccupied square adjacent to you. This teleportation provokes an attack of opportunity from you, and functions regardless of the distance between you and the cursed creature, although it cannot teleport a target on another plane of existence. For every 10 feet a cursed creature moves during its turn preceding the teleportation, the save DC of this strike increases by +2 (up to a maximum of a +6 increase to the DC). You can touch a willing ally to curse them, in which case they automatically fail their Will save to resist being teleported back to you at the start of your next turn. you can end this effect and the cursed condition on any affected creature at any time as a free action.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `eternalGuardian`,
        level: 6,
        name: `Inescapable Grasp`,
        type: `Stance`,
        shortDesc: `Cursed creatures you threaten cannot take 5-foot steps or use the withdraw action, and their movement provokes attacks of opportunity from you even if they otherwise would not.`,
        longDesc: `Your resolution is absolute, and those affected by your ill will find themselves unable to act freely. While you maintain this stance, cursed creatures you threaten cannot take 5-footsteps or use the Withdraw action, and any such creature that leaves its square provokes an attack of opportunity from you, even if its movement would not otherwise provoke attacks of opportunity (such as with the Spring Attack feat or a teleportation effect).`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `eternalGuardian`,
        level: 6,
        name: `Infinite Focus`,
        type: `Counter`,
        shortDesc: `Your allies within 60 feet do not provoke attacks of opportunity for one round.`,
        longDesc: `You share some of your patience and dedication with your allies, allowing them to avoid careless mistakes that would allow an opponent to strike. After initiating this counter, your allies within 60 feet of you do not provoke attacks of opportunity for one round. Any ally that moves further than 60 feet away from you loses this benefit. you can initiate this counter in response to an ally provoking an attack of opportunity from an opponent; if you do, that attack is negated, and the ally gains the full benefits of this counter as normal.`,
        initiationAction: `immediate`,
        range: `60 ft.`,
        target: `All allies within 60 ft.`,
        duration: `1 round`
      },
      {
        school: `eternalGuardian`,
        level: 6,
        name: `Strike of Sacrifice`,
        type: `Strike`,
        shortDesc: `Your attack deals +6d6 damage and you transfer some of your AC to allies within 30 feet.`,
        longDesc: `You seal a portion of your life force around your allies, protecting them from harm at the cost of your own vulnerability. Make an attack. If it hits, it deals weapon damage as normal plus an additional 6d6 points of damage, and you may lower your AC by up to 1/2 your initiator level and grant all allies within 30 feet an equal bonus to their ACs. Both the reduction of your AC and the bonus to your allies' ACs lasts for a number of rounds equal to your initiator level.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack and 30 feet (see text)`,
        target: `One creature (see text)`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `eternalGuardian`,
        level: 7,
        name: `Curse of Impending Doom`,
        type: `Strike`,
        shortDesc: `Your attack deals +6d6 damage, curses the target, and inflicts a growing penalty on attack rolls, saving throws, and skill checks.`,
        longDesc: `[curse, fear]; The disciple's curse seeps into the foe's subconscious, forcing it to believe failure is just around the corner. Make an attack. If it hits, it deals weapon damage as normal plus an additional 6d6 points of damage, and the target becomes cursed for 24 hours. While cursed by this strike, the target suffers a –2 penalty on attack rolls, saving throws, and skill, checks. Whenever an affected target succeeds on an attack roll, saving throw, or skill, check, the penalty imposed by this strike increases by –2. Whenever an affected target fails on such a roll, it must succeed at a Will save (DC 17 + your initiation modifier) or become panicked for one round, and the penalty imposed by this maneuver is reset to –2. A creature under the effect of this strike can choose to intentionally fail on any of these rolls to make another saving throw against this effect. If it does, failure does not cause it to become panicked, nor does it reset the penalty to –2.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `eternalGuardian`,
        level: 7,
        name: `Grim Satisfaction`,
        type: `Boost`,
        shortDesc: `Your next attack may cause the target to cower in fear for one round.`,
        longDesc: `[fear]Seeing the fear and resignation in the eyes of your foes spurs you closer to victory. After initiating this boost, the next creature you hit with an attack for one round must succeed at a Will save (DC 17 + your initiation modifier) or cower in fear for one round, and you heal a number of hit points equal to your initiator level. If the creature that fails its save is cursed, you heal an additional 10 hit points.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `eternalGuardian`,
        level: 7,
        name: `Unbreakable Promise`,
        type: `Counter`,
        shortDesc: `Opponents within 60 feet must make a Will save or become unable to reduce other creatures below 0 hit points.`,
        longDesc: `[curse] You vow that no foe will land a killing blow against those under your protection. You can initiate this counter in response to a melee or ranged attack being made against another ally within 60 feet. All opponents within 60 feet of you must succeed at a Will save (DC 17 + your initiation modifier) or become cursed for three rounds. While a creature is cursed by this counter, it cannot reduce any creature other than itself below 0 hit points by any means; any additional damage is negated. An affected creature can strike itself as an attack action or part of a full-attack action(dealing damage as normal for the attack) to end this curse.`,
        initiationAction: `immediate`,
        range: `60 ft.`,
        target: `All opponents within 60 ft.`,
        duration: `3 rounds (see text)`
      },
      {
        school: `eternalGuardian`,
        level: 8,
        name: `Crushing Rebuke`,
        type: `Counter`,
        shortDesc: `You Intimidate an enemy, causing them to fail attack rolls for the rest of their turn.`,
        longDesc: `[fear]Your overwhelming presence castigates a foe, causing them to utterly doubt their own abilities. You can initiate this counter in response to a melee or ranged attack being made against you or an ally by an opponent within 60 feet. Make an Intimidate check, using the creature's attack roll as the dc. If you succeed, the attack is negated, and that all attacks made by that creature until the end of its turn automatically miss.`,
        initiationAction: `immediate`,
        range: `60 ft.`,
        target: `One creature`,
        duration: `1 turn`
      },
      {
        school: `eternalGuardian`,
        level: 8,
        name: `Hammer of the Immortal`,
        type: `Strike`,
        shortDesc: `You attack every opponent you threaten, dealing +8d6 points of damage and inflicting a -4 penalty to their AC and CMD. Then, you make a combat maneuver attempt against each target hit.`,
        longDesc: `You act as both hammer and anvil, striking your enemies with furious skill that breaks their lines and their spirits. Make a melee attack roll and compare it to the AC of each opponent you threaten. If the attack roll hits a target, it deals weapon damage as normal plus an additional 8d6points of damage, and the target takes a -4 penalty to its AC and CMB until the start of your next turn. Use the same damage roll for each target. In addition, you may make a single combat maneuver attempt against each target you hit with this strike as a free action. These combat maneuver attempts do not provoke attacks of opportunity.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Every threatened opponent`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `eternalGuardian`,
        level: 8,
        name: `Stance of the Infinite Warrior`,
        type: `Stance`,
        shortDesc: `Your threatened squares remain threatened for one round, and you can teleport to an opponent within your threatened area as an immediate action.`,
        longDesc: `[teleportation]Your eternal vigilance allows you to leave an echo of your presence behind to guard areas in which you are no longer physically present. While you maintain this stance, any square you threaten during your turn remains threatened by you until the end of your next turn. You can make melee attacks (including attacks of opportunity) against creatures within these squares, regardless of your actual location— a flickering glimpse of how you appeared the moment you threatened that square appears and makes the attack, just as if you were actually in the square. In addition, whenever a creature enters your threatened area, you can teleport to any unoccupied space within 10 feet of that creature as an immediate action.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `eternalGuardian`,
        level: 9,
        name: `Oath of Eternity`,
        type: `Counter`,
        shortDesc: `You swear a large area around you to be under your protection, massively increasing your threatened area and gaining additional attacks of opportunity.`,
        longDesc: `[curse, teleportation]You declare a swathe of the battlefield to be your domain, in which you will brook no trespass. You teleport across the battlefield with each blow, blinking towards an enemy then returning to your original position. After initiating this counter, your threatened area increases to 40 feet for one round. This overlaps with, rather than stacking with, any natural reach you otherwise have; if your natural reach is greater than 40 feet, it is not reduced. In addition, for the duration of this boost, your attacks of opportunity deal an additional 3d6 points of damage and curse the target for one round, and you can make a number of additional attacks of opportunity this round equal to 1/2 your initiator level. This stacks with the Combat Reflexes feat and other effects that increase the number of attacks of opportunity you can make in a round.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },

      {
        school: `goldenLion`,
        level: 1,
        name: `Demoralizing Roar`,
        type: `Boost`,
        shortDesc: `Any target struck by you in melee is shaken for 1 round.`,
        longDesc: `With a shout of rage and defiance, the Golden Lion disciple wades into battle with fearless determination, shattering the resolve of his foes. As a swift action the initiator's attacks become filled with the dread of defeat, causing his target opponent to be shaken for one round (Will save DC 11 + initiation modifier negates).`,
        initiationAction: `swift`,
        range: `Any attack`,
        target: `One creature`,
        duration: `One round`,
        savingThrow: `Will negates`
      },
      {
        school: `goldenLion`,
        level: 1,
        name: `Encouraging Roar`,
        type: `Boost`,
        shortDesc: `For one round, all allies gain a +2 morale bonus to all attacks and damage.`,
        longDesc: `The disciple lets out shouts of encouragement to bolster his allies in battle. All allies within 30-ft. of the Golden Lion disciple gain a +2 morale bonus to attack and damage rolls for one round.`,
        initiationAction: `swift`,
        range: `30-ft.`,
        target: `Allies`,
        duration: `One round`
      },
      {
        school: `goldenLion`,
        level: 1,
        name: `Hunting Party`,
        type: `Strike`,
        shortDesc: `Make an attack, grant an adjacent ally an attack of opportunity against the same enemy.`,
        longDesc: `When two or more soldiers converge on a single target, the odds of victory increase and the disciple with the knowledge of this strike can assist his comrade's potential lethality. When this strike is initiated, a successful melee attack may grant one adjacent ally who is attacking the same target an attack of opportunity against that target.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature and one adjacent ally`,
        duration: `1 round`
      },
      {
        school: `goldenLion`,
        level: 1,
        name: `Pride Leader's Stance`,
        type: `Stance`,
        shortDesc: `Initiator and allies within 20 ft. gain a +4 morale bonus to saves vs fear and demoralization effects.`,
        longDesc: `By adopting the mannerisms of commanding lions of the great savannahs, the disciple inspires heroics by his presence. By adopting this stance, the initiator and all allies within 20-ft. of his position gain a +4 morale bonus to saves vs fear effects and demoralization effects. The radius of this effect increases by 10-ft. per five initiator levels starting at initiator level 6.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `goldenLion`,
        level: 1,
        name: `Pride Movement`,
        type: `Boost`,
        shortDesc: `Grant an adjacent ally a move action.`,
        longDesc: `By having a watchful eye on the flow of combat, the disciple knows when to spur an ally into a better position. As a swift action, the initiator may grant a move action to an adjacent ally. This ally may then use this move action immediately to move up to his base speed, as if it were a free action taken on the initiator's turn.`,
        initiationAction: `swift`,
        range: ``,
        target: `One adjacent ally`,
        duration: `Instant`
      },
      {
        school: `goldenLion`,
        level: 1,
        name: `Tactical Strike`,
        type: `Strike`,
        shortDesc: `Make an attack, grant nearby ally the ability to move up to 10 ft.`,
        longDesc: `Any commander knows that in battle, footwork is key. By utilizing this theory, the Golden Lion disciple helps his comrades to understand this. The disciple makes a melee attack against a foe; if successful, any ally he designates within 10-ft. of his position may make an immediate free 10-ft. movement without provoking attacks of opportunity.`,
        initiationAction: `standard`,
        range: `Melee attack; 10-ft.`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `goldenLion`,
        level: 2,
        name: `Call to Action`,
        type: `Strike`,
        shortDesc: `Attack inflicts an additional 2d6 points of damage, grant adjacent ally an immediate move action.`,
        longDesc: `With a mighty blow, the disciple aids an ally by providing an opening in combat to move by an opponent. The initiator makes a melee attack, inflicting an additional 2d6 points of damage and granting an adjacent ally an immediate move action.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `goldenLion`,
        level: 2,
        name: `Defending the Pride`,
        type: `Boost`,
        shortDesc: `Grant all allies within 60 ft. a +4 bonus to AC for one round.`,
        longDesc: `With a cry to defend themselves from incoming attacks, the inspirational words of the disciple aid his allies in their defense. As a swift action, the initiator grants all allies within 60-ft. a +4 morale bonus to their AC for one round.`,
        initiationAction: `swift`,
        range: `60-ft.`,
        target: `Allies`,
        duration: `One round`
      },
      {
        school: `goldenLion`,
        level: 2,
        name: `Distracting Strike`,
        type: `Strike`,
        shortDesc: `Make attack against a target, inflicting an additional 2d6 points of damage and leave the foe flat-footed until his next turn.`,
        longDesc: `By attracting the attentions of a foe with a well-placed and vicious blow, the disciple of the Golden Lion may distract and weaken his foe to the predations of his allies. Upon a successful attack when using this strike, the initiator inflicts an additional 2d6 points of damage and the target creature is left flat-footed until its next turn. Creatures immune to critical hits are not left flat-footed.`,
        initiationAction: `standard`,
        range: `Any attack`,
        target: `One creature`,
        duration: `Until target's next turn`
      },
      {
        school: `goldenLion`,
        level: 2,
        name: `Pyrite Strike`,
        type: `Strike`,
        shortDesc: `Strike inflicts an additional 1d6 points of damage and moves an opponent 5 ft. in a direction of your choosing.`,
        longDesc: `With a powerful strike, the Golden Lion disciple pushes his foe into the waiting arms of his allies and their hungry blades. The initiator makes a melee attack that inflicts an additional 1d6 points of damage and forces his foe to make a 5-ft. movement (of the initiator'schoice) from the square he is currently occupying. If the target is incapable of movement, then the target simply takes the damage as normal. This movement provokes attacks of opportunity to all those capable of making them against the target except for the initiator of this maneuver.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `goldenLion`,
        level: 2,
        name: `Warning Roar`,
        type: `Counter`,
        shortDesc: `Make an opposing Diplomacy check to negate an enemy's attack on a nearby ally.`,
        longDesc: `Witnessing a clear and present danger to an ally, the disciple shouts out a well-timed warning and aids his ally in defending against an attack. The initiator makes a Diplomacy check opposing an opponent's attack roll made on an ally. If successful then the attack is negated.`,
        initiationAction: `immediate`,
        range: `60-ft.`,
        target: `One allied creature`,
        duration: `Instant`
      },
      {
        school: `goldenLion`,
        level: 3,
        name: `Circling the Prey`,
        type: `Boost`,
        shortDesc: `Grant all allies within 60 ft. a free 5 ft. step.`,
        longDesc: `With practiced precision and a quick shout, the disciple and his allies move in unison for better strategic advantage. The initiator's shout grants himself and his allies a free 5-ft. step that must be taken when this boost is used.`,
        initiationAction: `swift`,
        range: `60-ft.`,
        target: `Allies`,
        duration: `Instant`
      },
      {
        school: `goldenLion`,
        level: 3,
        name: `Golden Commander Stance`,
        type: `Stance`,
        shortDesc: `All allies within 30 ft. of your position may gain flanking if they are adjacent to an ally when engaged in melee.`,
        longDesc: `Through the use of the Golden Lion disciple's superior tactical ability, he is able to direct his allies in combat for maximum effectiveness. As long as his allies within 30-ft. of him can clearly hear his shouts and understand his language, he grants his allies the ability to gain flanking with all adjacent allies that are fighting in melee against the same opponent (i.e. if two allies of the initiator are 20-ft. away fighting a target together, and the initiator has another ally assisting him in combat against a different target, both pairs gain flanking bonuses against their foes even if they are not normally in flanking position).`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `goldenLion`,
        level: 3,
        name: `Kill the Wounded`,
        type: `Strike`,
        shortDesc: `Target of this strike takes an additional 2d6 points of damage on attacks made upon him by allies.`,
        longDesc: `The Golden Lion disciple makes a ferocious assault on his foe, opening the enemy's defenses to the attacks of his allies. The initiator makes a melee attack against a foe and if successful, subsequent attacks made by the initiator's allies inflict an additional 2d6 points of damage per successful attack until the initiator's next turn.`,
        initiationAction: `standard`,
        range: `Any attack`,
        target: `One creature`,
        duration: `One round`
      },
      {
        school: `goldenLion`,
        level: 3,
        name: `Pack Pounce`,
        type: `Strike`,
        shortDesc: `Make an attack while adjacent to an ally, gain a +5 damage per ally adjacent to that enemy (Max +15).`,
        longDesc: `By capitalizing on the opportunities granted by the presence of his allies who are attacking his foe, the lethality of the Golden Lion disciple increases dramatically due to his knowledge of pack tactics. The initiator must be attacking a target that one or more of his allies are also adjacent to, and upon successfully attacking a qualifying target, the initiator receives a+5 circumstance bonus to damage rolls against that target per ally (to a maximum of an additional 15points of damage for three allies.)`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `goldenLion`,
        level: 4,
        name: `Charge of the Battle Cat`,
        type: `Strike`,
        shortDesc: `Make a charge attack which does not provoke attacks of opportunity, the charge inflicts an additional 4d6 points of damage and has a chance to knock target prone.`,
        longDesc: `Like the charge of the mighty lion as he takes his prey to the ground, the Golden Lion disciple charges into battle, heedless of his enemies, to crash into his chosen foe with a mighty strike, knocking him to the ground at his feet. The initiator makes a charge attack, inflicting an additional 4d6 points of damage. Additionally, the foe must make a Reflex save (DC equal to 14 + initiation modifier) or be knocked prone from the strike.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`,
        savingThrow: `Reflex partial`
      },
      {
        school: `goldenLion`,
        level: 4,
        name: `Direct the Pride`,
        type: `Boost`,
        shortDesc: `Target adjacent ally who has not acted this turn, move his initiative directly after yours for this turn, the following turn he returns to his former initiative.`,
        longDesc: `Cooperation and teamwork form the backbone of tactical warfare, and through his knowledge of all of these things, the Golden Lion disciple may help direct the actions of his ally to greater effectiveness. As a swift action, the initiator targets an adjacent ally who has not yet acted this turn. That initiator may now act immediately following the Golden Lion disciple's action as if his initiative result was one lower than the disciple. The following round, the target of this boost returns to his previous initiative result.`,
        initiationAction: `swift`,
        range: `Adjacent ally`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `goldenLion`,
        level: 4,
        name: `Golden Lion Charger`,
        type: `Stance`,
        shortDesc: `When charging, gain an additional +2 bonus to attack and never provoke attacks of opportunity for charging.`,
        longDesc: `A student of the art of war and of the Golden Lion, a disciple who has training in the art of engaging an enemy knows that sometimes a powerful opening charge can be the edge the warrior needs. While in this stance and performing a charge, the initiator gains an additional +2 bonus to hit (making the bonus received from the charge attack a total of +4)and when charging through a threatened square, the initiator does not provoke attacks of opportunity.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `goldenLion`,
        level: 4,
        name: `Golden Swipe`,
        type: `Strike`,
        shortDesc: `Melee attack inflicts an additional 6d6 points of damage and moves the opponent 10 ft. in a direction of your choosing.`,
        longDesc: `With a series of furious blows against his foe, the Golden Lion disciple batters his opponent into the waiting blades of his allies. The initiator makes a melee attack, inflicting an additional 6d6 points of damage and forcing his foe to make a 10-ft. movement (if the target is capable of moving) from the square he is currently occupying in a direction of his choosing. If the target is incapable of movement, then the target simply takes the damage as normal. This movement provokes attacks of opportunity to all those capable of making them against the target except for the initiator of this maneuver.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `goldenLion`,
        level: 5,
        name: `Discipline of the Pride`,
        type: `Boost`,
        shortDesc: `Grant all allies within 30 ft. one feat that you possess for three rounds.`,
        longDesc: `Through training with his allies, the disciple has taught them the basics of his military skill that they may call upon in times of duress. As a swift action, the initiator may grant one of his combat feats to any of his allies within 30-ft. for 3 rounds. No initiator can benefit from this ability more than once at a time.`,
        initiationAction: `swift`,
        range: `30-ft.`,
        target: `Any ally within range`,
        duration: `Three rounds`
      },
      {
        school: `goldenLion`,
        level: 5,
        name: `Guard the Pride`,
        type: `Counter`,
        shortDesc: `Grant an adjacent ally +4 circumstance bonus to AC for one round as an immediate action.`,
        longDesc: `By trusting the awareness of the celestial realm, the discipline trusts in his heavenly sense of the battle around him to see where the next attack is coming and move away from danger. As an immediate action, the initiator grants a circumstance bonus to the target adjacent ally's Armor Class for one round equal to half the disciple's initiator level.`,
        initiationAction: `immediate`,
        range: `Adjacent ally`,
        target: `One ally`,
        duration: `1 round`
      },
      {
        school: `goldenLion`,
        level: 5,
        name: `Roar of Battle`,
        type: `Strike`,
        shortDesc: `Make an attack that inflicts an additional 6d6 points of damage, all other allies that attack the target inflict an additional 3d6 points of damage on successful attacks.`,
        longDesc: `The Golden Lion disciple delivers a telling blow, shattering bones and piercing defenses alike as he presses the foe into opening vital places for his allies to gain purchase. The initiator makes an attack inflicting an additional 6d6 points of damage. Allies who attack the target of this maneuver inflict an additional 3d6 points of damage on successful attacks for one round.`,
        initiationAction: `standard`,
        range: `Any attack`,
        target: `One creature`,
        duration: `One round`
      },
      {
        school: `goldenLion`,
        level: 5,
        name: `Strategic Blow`,
        type: `Strike`,
        shortDesc: `Make a successful melee attack on a target, strike inflicts 8d6 points of additional damage and grants an ally within 10 ft. of the disciple a move action.`,
        longDesc: `With a tremendous strike, the disciple confuses the enemy and creates an opening for an ally to reposition himself. The initiator makes a melee attack inflicting an additional 8d6 points of damage; additionally an ally within 10-ft. of the initiator that he chooses may immediately make a move action as if it were a free action taken on the initiator's turn.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `goldenLion`,
        level: 6,
        name: `Endurance of the Strong`,
        type: `Counter`,
        shortDesc: `When an ally within 30 ft. is struck in combat and injured, the disciple may make an immediate shout of inspiration to restore some of the ally's flagging strength, restoring twice the disciple's initiator level in hit points.`,
        longDesc: `Allies falling in combat weakens the core of the unit, so when an ally is injured, it is up to the commanding presence of the Golden Lion disciple to bolster his fallen comrades. When an ally is struck in combat and injured and within 30-ft. of the initiator, he may shout words of inspiration and encouragement to restore some fortitude to his ally. Make a diplomacy check, the target of this counter immediately heals an amount equal to the result of the check plus your level.`,
        initiationAction: `immediate`,
        range: `30-ft.`,
        target: `One ally`,
        duration: `Instant`
      },
      {
        school: `goldenLion`,
        level: 6,
        name: `Golden General's Attitude`,
        type: `Stance`,
        shortDesc: `Grant a morale bonus to attack and damage rolls, and saves against fear effects to all allies within 60 ft. vs fear, +1 for every 4/initiator levels.`,
        longDesc: `A true Golden Lion disciple is a beacon of command on the field of battle, inspiring his troops by his mere presence. All allies within 60-ft. of the initiator gain a +1 morale bonus to attack and damage rolls, and to saves vs fear effects per four initiator levels.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `goldenLion`,
        level: 6,
        name: `Harry the Prey`,
        type: `Strike`,
        shortDesc: `Make an attack, all allies within 30 ft. may make an immediate attack against any foe they are capable of attacking.`,
        longDesc: `Through coordinated tactics, the comrades at a Golden Lion disciple's side may act as one. The initiator makes an attack against a foe, and all allies within 30-ft. may make an immediate attack against any one foe that they can reach with their attacks (melee or ranged within the first range increment) at their full attack bonus.`,
        initiationAction: `standard`,
        range: `Any attack; 30-ft.`,
        target: `Allies (except the initiator)`,
        duration: `Instant`
      },
      {
        school: `goldenLion`,
        level: 6,
        name: `Lion's Feast`,
        type: `Boost`,
        shortDesc: `For one round any enemies that are slain in combat within 20 ft. of you grant any adjacent allies to you temporary hit points equal to twice the creature's Hit Dice.`,
        longDesc: `As the thrill of a successful hunt invigorates a pride of lions on the plains, so does the thrill of victory over foes invigorate the disciple's allies. By initiating this boost as a swift action, enemies that are subsequently reduced to 0 or fewer hit points within 20-ft. of the initiator grant all adjacent allies to the initiator temporary hit points equal to twice the fallen enemy's Hit Dice.`,
        initiationAction: `swift`,
        range: `All adjacent allies`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `goldenLion`,
        level: 7,
        name: `Golden General's Victory`,
        type: `Boost`,
        shortDesc: `Upon felling a foe, all allies within 60 ft. are healed a number of hit points equal to the disciple's initiator level.`,
        longDesc: `The power and majesty of the lion lords of the wild lives within the disciple, so much so that his victories are a victory for all of his allies. When the initiator reduces a foe to 0 hit points or below he may initiate this boost; his allies are then bolstered and their hearts are rededicated to victory. Make a diplomacy check, all allies within 60-ft. of the initiator have a number of hit points equal to 1/2 the result of the check plus the disciple's initiator level restored.`,
        initiationAction: `swift`,
        range: `60-ft.`,
        target: `Allies`,
        duration: `Instant`
      },
      {
        school: `goldenLion`,
        level: 7,
        name: `Orichalcum Swipe`,
        type: `Strike`,
        shortDesc: `Melee attack inflicts an additional 12d6 points of damage, target makes up to a full move in a direction of your choosing.`,
        longDesc: `A Golden Lion disciple shapes the very nature of war, and this technique allows him to direct his foes through his allies' blades as easily as a knife through bread. With a mighty cry and a tremendously potent attack, the disciple ruins his foe. The initiator makes a melee attack inflicting an additional 12d6 points of damage, and forces the foe to move up to twice the target's base speed in the direction of the initiator's choosing in a straight line. If the target is incapable of movement, then the target simply takes the damage as normal. This movement provokes attacks of opportunity to all those capable of making them against the target except for the initiator of this maneuver.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `goldenLion`,
        level: 7,
        name: `War Lion's Charge`,
        type: `Strike`,
        shortDesc: `Make a charge attack against a foe which does not provoke attacks of opportunity, if successful the attack inflicts an additional 14d6 points of damage and potentially stuns the opponent for one round.`,
        longDesc: `With the ferocity of an angered lion, the Golden Lion disciple races across the battlefield ignoring secondary targets to bear down on a single enemy and reduce him to dust. The initiator makes a charge attack against a foe (which does not provoke attacks of opportunity) and this attack inflicts an additional 14d6 points of damage. The foe must also make a Fortitude save (DC 17 + initiation modifier) or be stunned for one round.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`,
        savingThrow: `Fortitude partial`
      },
      {
        school: `goldenLion`,
        level: 8,
        name: `Alpha's Roar`,
        type: `Boost`,
        shortDesc: `The disciple releases an awesome call and grants a +4 morale bonus to all allies' saving throws for the round and increases the DC's of allies abilities by 4.`,
        longDesc: `With an awesome cry for victory and bravery from his allies, the Golden Lion disciple bolsters allies' defenses and attacks for a moment as his allies cannot help themselves but to win. Allies within 30-ft. of the disciple gain a +4 morale bonus to their saving throws and increase to the DC's of their abilities (maneuvers, spells, powers, etc.) for one round.`,
        initiationAction: `swift`,
        range: `30-ft.`,
        target: `Allies`,
        duration: `One round`
      },
      {
        school: `goldenLion`,
        level: 8,
        name: `Lion Lord's Agony`,
        type: `Strike`,
        shortDesc: `Strike inflicts additional damage equal to the hit point damage the disciple has received.`,
        longDesc: `With a fury born of desperation and determination for victory, the Golden Lion disciple pours his pain into his swings so that the enemy may drink deeply of it. The initiator makes a melee attack, and in lieu of the weapon's damage the attack instead inflicts a number of points of damage equal to the initiator's maximum hit points minus his current hit points(example, if the disciple has 200 maximum hit points and has been wounded down to 54 remaining hit points, this attack inflicts 146 points of damage). The initiator is shaken for 1 round after using this strike.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `goldenLion`,
        level: 8,
        name: `Triumphant Lion's Leadership`,
        type: `Stance`,
        shortDesc: `While in this stance, the initiator and allies within 10- ft. of the disciple, gain +1d6 points of damage for every foe that the disciple has defeated during the encounter (max +5d6).`,
        longDesc: `A beacon of victory upon the field of combat, the disciple personifies glory in combat and those in his presence may share in his prowess. The initiator and any allies within 10-ft. of the disciple gains an additional +1d6 points of damage per attack per foe that the initiator has slain (maximum of five slain foes for +5d6 bonus damage) while this stance is in effect.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `goldenLion`,
        level: 9,
        name: `Lord of the Pridelands`,
        type: `Boost`,
        shortDesc: `You and your allies gain +2 to hit, damage, AC, and saves for each and every ally within 60-ft for one round (maximum +10).`,
        longDesc: `Proving he is the undisputed master of war, the Golden Lion master calls for absolute and crushing victory through overwhelming force of numbers. This ability is greatly feared by the master's enemies, because this can turn even the most green of soldier into a capable warrior. For every ally within the 60-ft. range of this boost, the initiator and each of these allies gains a +2 morale bonus to hit, damage, AC, and saving throws for one round (to a maximum of +10).`,
        initiationAction: `standard`,
        range: `60-ft.`,
        target: `Allies`,
        duration: `One round`
      },
      {
        school: `ironTortoise`,
        level: 1,
        name: `Angering Smash`,
        type: `Strike`,
        shortDesc: `Melee attack that causes opponent to suffer -4 to hit any target but you.`,
        longDesc: `By making a quick shield bash, the disciple taunts and aggravates his foes into striking at him solely. The initiator makes a melee shield bash attempt upon a creature, and if successful, they suffer a -4 penalty on attack rolls to attack any other target but the initiator.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `One round`
      },
      {
        school: `ironTortoise`,
        level: 1,
        name: `Iron Shell`,
        type: `Counter`,
        shortDesc: `Deflect an enemy melee or missile attack with shield with an opposed attack roll plus shield bonus to AC.`,
        longDesc: `A shield is used for defense primarily, a basic martial truth. It turns aside harm, and the shield of a disciple of the Iron Tortoise can do the same thing in ways that others cannot. The initiator makes an opposed attack roll as if making a shield bash attempt at his full base attack bonus plus his shield bonus to AC against his enemy's attack roll to deflect a single enemy's melee or missile attack (that is not a spell or power).`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instant`
      },
      {
        school: `ironTortoise`,
        level: 1,
        name: `Snapping Strike`,
        type: `Strike`,
        shortDesc: `Melee attack which deals an additional 1d6 points of damage.`,
        longDesc: `Disciples of the Iron Tortoise school learn basics of the style, and that is to keep one's shield high and one's weapon low. By making a quick and vicious strike, the disciple may drive home a potent blow. The initiator makes a melee attack, and if successful, this attack inflicts an additional 1d6 points of damage.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `ironTortoise`,
        level: 5,
        name: `Shell Within`,
        type: `Boost`,
        shortDesc: ``,
        longDesc: `Gain temporary hit points equal to the current hit points of your shield that last 1 round. During this round, you also lose your shield bonus to armor class, and suffer a -4 penalty to AC.`,
        initiationAction: `movement`,
        range: `personal`,
        target: `you`,
        duration: `1 round`,
        utility:true,
      },
      {
        school: `ironTortoise`,
        level: 1,
        name: `Snapping Turtle Stance`,
        type: `Stance`,
        shortDesc: `Shield bashes inflict an additional 1d6 points of damage, and may make shield bashes without losing shield bonus to AC.`,
        longDesc: `The disciple of the Iron Tortoise in this stance holds his shield in a manner to deliver punishing shield bashes without sacrificing his ability to defend himself. While in this stance, the initiator may make shield bash attacks without losing his shield bonus to his Armor Class, and shield bash attacks inflict an additional 1d6 points of damage. This bonus damage increases by +1d6 every 8 initiator levels beyond 1st level. If you score a critical hit with a shield bash attack, you can gain choose to 1 <guardian> combo point (max 1 a round)`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`,
        additionalTags:["Guardian"],
      },
      {
        school: `ironTortoise`,
        level: 1,
        name: `Stance of the Defending Shell`,
        type: `Stance`,
        shortDesc: `Gain a bonus to shield AC based on initiator level (+1 AC/4 IL)`,
        longDesc: `An Iron Tortoise disciple learns a valuable stance that forms the core of their discipline, that being the nature of the unbreakable wall. By focusing one's attention to defense with their shield, their martial skill improves their defense. The initiator gains an additional +1 bonus to his shield AC while in this stance, and this bonus increases by +1 for every 4 initiator levels he possesses after 1st level (+2 at 5th,+3 at 9th, +4 at 13th, and to a maximum of +5 at 17thlevel).`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`,
      },
      {
        school: `ironTortoise`,
        level: 1,
        name: `Throwing Shell`,
        type: `Strike`,
        shortDesc: `Hurl shield at target, inflicting shield bash damage and an additional 1d6 points of damage.`,
        longDesc: `Using a special technique developed for surprisingly effective ranged attacks, the disciple of the Iron Tortoise knows how to deliver his shield in a powerful throw in a manner similar to a champion discuss thrower. The initiator throws his shield (light or heavy shields; this does not work with bucklers or tower shields) with a range increment of 20 ft. as a ranged attack, inflicting damage as if the character had just shield bashed his opponent and inflicting an additional 1d6 points of damage and the shield falls to a space adjacent of his target (the player may choose which space it lands in). If the attacked target is within the first two range increments, then the initiator may catch the shield as a free action and regain use of his shield on his turn.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `ironTortoise`,
        level: 2,
        name: `Defensive Shell`,
        type: `Counter`,
        shortDesc: `Use a shield bash attempt against an opponent's attack roll to defend an adjacent ally and negate the attack.`,
        longDesc: `The Iron Tortoise disciple has quick reflexes and a strong shield with which to defend his allies. The initiator makes a shield bash attempt against an enemy's attack roll that targets an adjacent ally. If the initiator succeeds, he negates the attack against his ally.`,
        initiationAction: `immediate`,
        range: `5 feet`,
        target: `One adjacent ally`,
        duration: `Instant`
      },
      {
        school: `ironTortoise`,
        level: 2,
        name: `Enduring Shell`,
        type: `Counter`,
        shortDesc: `Add your shield bonus to AC to a saving throw attempt.`,
        longDesc: `By tightening up behind his shield and dropping low under its protective aegis, the disciple of their on Tortoise learns to minimize the risk he suffers from spells and effects that would cause him to rely solely on reflexes. The initiator throws up his shield when he is forced to make a Fortitude or Reflex save and uses it to help mitigate the harm he is about to endure. The initiator may add his total shield bonus to AC to a single Fortitude or Reflex save when using this counter.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instant`
      },
      {
        school: `ironTortoise`,
        level: 2,
        name: `Enraging Strike`,
        type: `Strike`,
        shortDesc: `Melee attack deals an additional 10 points of damage, chance to make target angry and attack you.`,
        longDesc: `The defensive nature of the Iron Tortoise teaches the disciple to protect his allies, and to do so, he must focus the attentions of his foes on him. Make a melee attack, and if successful, the strike inflicts an additional 10 points of damage. The aggravating pain of this wound can cause a foe to react violently against the initiator, forcing it to make a Will save (DC 12 +initiation modifier) or it must attack him at its next available action. This attack must be a melee attack if the target his anything in hand that could be used as a weapon or an improvised weapon (this includes bows wielded as clubs, and natural weapons), otherwise he may choose a different attack method, but he must attack the initiator. Additionally, he gains a -2 penalty to attack the initiator of this strike due to the anger incited by the initiator.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature of Intelligence 1 or higher.`,
        duration: `Instant`,
        savingThrow: `Will partial`
      },
      {
        school: `ironTortoise`,
        level: 2,
        name: `Tactical Snap`,
        type: `Strike`,
        shortDesc: `Melee attack allows a free trip attempt.`,
        longDesc: `The turtle, when it on it's back, is helpless to defend itself and is immobilized unless it can right itself. The disciple of this discipline learns to use this inspirational creature's weakness as a potent weapon by making a low and powerful strike that may knock his opponent prone. As part of this maneuver, the initiator makes a single melee attack. If this attack is successful, he may initiate a free trip attempt with a +2 competence bonus against his opponent that does not provoke an attack of opportunity.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `ironTortoise`,
        level: 2,
        name: `Taunting Turtle`,
        type: `Boost`,
        shortDesc: `Point out a single enemy and take an aggressive posture forcing the enemy to attack you on a failed Will save.`,
        longDesc: `The initiator singles out an enemy on the field of battlefield and through words, postures, or gestures insults and infuriates the foe to attack him on its next available action with whatever means it possesses. The target makes a Will save (DC 12 + initiation modifier) or it must attack the initiator on its next action in some form or fashion. This maneuver only effects creatures with an Intelligence score of 2 or higher.`,
        initiationAction: `swift`,
        range: `30 ft.`,
        target: `One creature of Intelligence 2 or higher.`,
        duration: `Instant`,
        savingThrow: `Will negates`
      },
      {
        school: `ironTortoise`,
        level: 3,
        name: `Burnished Shell`,
        type: `Counter`,
        shortDesc: `Make an opposed attack roll plus shield bonus to AC vs an enemy spellcaster's CL to deny the effects of a spell targeted on you.`,
        longDesc: `By angling one's shield correctly and stepping into an enemy spell's effect, he may deflect the power of the spell that targets him. Spells or powers countered by this ability must be targeted spells (one cannot use Burnished Shield against fireball for example, as it does not specify a target) with the martial disciple as the target. The initiator makes an attack roll using his base attack bonus plus his shield bonus to AC opposing the enemy's caster level check. If successful, the spell or effect is negated.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instant`
      },
      {
        school: `ironTortoise`,
        level: 3,
        name: `Greater Snapping Strike`,
        type: `Strike`,
        shortDesc: `Melee attack that inflicts an additional 3d6 points of damage, bypasses DR.`,
        longDesc: `A decisive strike is often times what ends a battle or duel, and the disciple of the Iron Tortoise knows to keep his wits about him and wait for the moment to strike hard and strike true. Make a melee attack, and if successful, this strike inflicts an additional 3d6points of damage and ignores the creature's damage reduction (if any).`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `ironTortoise`,
        level: 3,
        name: `Iron Tortoise Stance`,
        type: `Stance`,
        shortDesc: `Increase reach for attacks of opportunity while in this stance by 5 ft., make additional attacks of opportunity, act as one size larger for CMD.`,
        longDesc: `This stance allows the disciple of the Iron Tortoise greater offensive ability while still remaining on the defensive, protecting himself and his allies. By positioning his footwork to allow for fast lunges and withdrawal, the reach of the martial disciple increases to meet his foes as they try to evade him and he stands imposing, impassable. The martial disciple is considered one size larger for the purposes of determining his CMD while in this stance, and he gains +5 ft. reach for making attacks of opportunity and may make one additional attack of opportunity per round.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `ironTortoise`,
        level: 3,
        name: `Tortoise Defense`,
        type: `Counter`,
        shortDesc: `Subtract 10-ft. from your next movement action, and gain DR 20/- against an attack.`,
        longDesc: `By focusing on defense, the disciple sacrifices his movement speed for greater protection. The initiator may voluntarily reduce his movement speed by 10 ft. On his next turn to gain damage reduction 20/- against a single attack.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `ironTortoise`,
        level: 4,
        name: `Aggravated Wounds`,
        type: `Boost`,
        shortDesc: `All successful melee attacks this round incite a cumulative -4 penalty on attacks to attack any target other than you for the target's turn.`,
        longDesc: `By making aggravating wounds and aggressive, intimidating postures, the disciple's attacks possess an unusual amount of threatening power. Each successful melee attack the initiator makes causes those hit by those attacks to suffer a -4 cumulative penalty on attack rolls against any target except the initiator himself.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `ironTortoise`,
        level: 4,
        name: `Ricochet Shell`,
        type: `Strike`,
        shortDesc: `Throw shield at target, bouncing it between up to four targets within 10 ft. of each other, inflicting an additional 3d6 points of damage.`,
        longDesc: `By hurling his shield at his foes with the speed and force of a giant-tossed boulder, the disciple of the IronTortoise bounces his shield between a few targets with rapid speed and punishing force. The initiator makes a ranged attack, hurling his shield with a range increment of 20 ft.. If successful, this attack inflicts damage as a shield bash and inflicts an additional 3d6points of damage and may bounce to another valid target using the same attack roll within 10 ft. of the target. This second target suffers damage as a shield bash plus an additional 2d6 points of damage for the second target, an additional 1d6 points of damage for the third target, and normal shield bash damage for the fourth and final target. At the end of the attack, the shield returns to the initiator who may catch it as a free action and resume its use that round.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `Up to four creatures within 10 ft. of each other`,
        duration: `Instant`
      },
      {
        school: `ironTortoise`,
        level: 4,
        name: `Smashing Shell`,
        type: `Strike`,
        shortDesc: `Make a shield bash that catches an opponent flat-footed, inflicts shield bash damage plus an additional 4d6 damage, chance to daze.`,
        longDesc: `The Iron Tortoise disciple is a master of using his shield both for offense and defense. By bringing his shield to bear and stepping in to meet a foe with a powerful and unexpected shield bash, the disciple may daze his foe into defeat. The initiator makes a shield bash attempt against his opponent, if successful this strike inflicts an additional 4d6 points of damage and has a chance to daze the target on a failed Fortitude save (DC 14 + initiation modifier).`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`,
        savingThrow: `Fortitude partial`
      },
      {
        school: `ironTortoise`,
        level: 4,
        name: `Snapping Riposte`,
        type: `Counter`,
        shortDesc: `Make an opposed shield bash against opponent's attack roll, if successful, make a counter attack with a +2 bonus to hit.`,
        longDesc: `By searching for openings in an opponent's defenses when they reach to attack, the Iron Tortoise disciple learns to strike through this opening to score a vicious wound. The disciple makes a shield bash attempt against his foe's attack roll. If successful, he may make an immediate counter attack against them with a +2 competence bonus to hit at his full attack bonus with his main hand weapon.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `ironTortoise`,
        level: 5,
        name: `Quick Snap`,
        type: `Counter`,
        shortDesc: `When struck in melee, may make an immediate counter attack and strike does double damage.`,
        longDesc: `Inevitably, a warrior will receive a wound in battle, and when that happens, those skilled in the ways of the Iron Tortoise make the best of it. By briefly trapping an enemy's weapon within his defenses, the martial disciple may deliver a powerful counterattack. If struck in melee combat, the initiator may make an immediate counter attack which inflicts double damage if successful.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `ironTortoise`,
        level: 5,
        name: `Shell Shock`,
        type: `Strike`,
        shortDesc: `Make a powerful shield bash that inflicts an additional 6d6 points of damage and may knock an opponent 20-ft. away`,
        longDesc: `The Iron Tortoise disciple has in his arsenal a stout shield and strong arms, and a will to decisively win a battle. By bringing all of his strength to bear, the Iron Tortoise disciple steps up to his foe with a devastating shield bash that sends him flying. Make a shield bash attempt which if successful inflicts an additional 6d6 points of damage and if the target fails a Reflex save(DC 15 + initiation modifier) knocks the opponent up to 20-ft away where he will land prone. Foes that succeed this saving throw are still pushed back 5-ft away from the disciple. The direction to where his opponent is flown is decided by the initiator.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`,
        savingThrow: `Reflex partial`
      },
      {
        school: `ironTortoise`,
        level: 5,
        name: `Turtle Knight's Stance`,
        type: `Stance`,
        shortDesc: `Stance that makes you difficult to move, grants improved uncanny dodge, and improves shield bonus by +4 so long as you do not move.`,
        longDesc: `By planting his feet, staying low to the ground with his shield at the ready, the martial disciple roots himself firmly in place, immovable. While in this stance, the initiator may not move from his spot, but gains several benefits for doing so. He gains a circumstance bonus equal to his initiator level to CMD, he gains the improved uncanny dodge special ability (with a rogue level equal to his initiator level), and his shield bonus to AC improves by +4. Voluntarily moving beyond a 5-ft. step per round ends this stance automatically, but should he be moved not of his own violation, he retains the stance.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `ironTortoise`,
        level: 5,
        name: `Vicious Snapping Strike`,
        type: `Strike`,
        shortDesc: `Melee attack inflicts an additional 5d6 points of damage, halves opponent's movement speed for their turn.`,
        longDesc: `A skilled disciple of the Iron Tortoise knows the secrets to slowing his opponents down to match his heavily armored speed. By landing a powerful, mobility-reducing blow, the martial disciple keeps his enemy close. Make a melee attack, and if successful, the strike inflicts an additional 5d6 points of damage and halves the opponent's movement speed for their turn.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `ironTortoise`,
        level: 6,
        name: `Mithral Tortoise Stance`,
        type: `Stance`,
        shortDesc: `Armor worn is considered one category lighter, halve armor check penalty, and gain a +2 dodge bonus to AC and to CMD.`,
        longDesc: `The Iron Tortoise disciple has become so comfortable in his armor that is like a second skin to him, and he is capable of moving better than most while wearing it. While in this stance, the initiator treats armor he is wearing as one type lighter (i.e. Heavy armor is treated as medium armor, and this stacks with the mithral material bonus, treating heavy mithral armor as light armor), increases his maximum Dexterity modifier by +2, and his total armor check penalty is halved while in this stance (any armor check penalty from armor, shields, or encumbrance). Finally, due to being stronger from wearing his burden of metal so much, the initiator moves more freely, and gains a +2 dodge bonus to his AC and to his CMD.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `ironTortoise`,
        level: 6,
        name: `Snapping Turtle Rush`,
        type: `Strike`,
        shortDesc: `Make a charge attack with your shield, strike inflicts an additional 8d6 points of damage and may knock opponent prone.`,
        longDesc: `By charging forward to gain momentum, the martial disciple may make a powerful shield bash that may knock his foes to the ground, crippled with injuries. The martial disciple must make a charge attack using his shield which if successful inflicts an additional 8d6 points of damage and knocks his foe prone on a failed Reflex save (DC 16 + initiation modifier).`,
        initiationAction: `standard`,
        range: `One melee charge attack`,
        target: `One creature`,
        duration: `Instant`,
        savingThrow: `Reflex partial`
      },
      {
        school: `ironTortoise`,
        level: 6,
        name: `Steel Shell`,
        type: `Counter`,
        shortDesc: `Make an opposed attack roll plus shield bonus against opponents attack to negate it, if failed gain DR 20/- against the attack.`,
        longDesc: `By steeling himself against an attack behind the wall of his mighty shield, an Iron Tortoise disciple may attempt to negate or reduce an incoming attack. The initiator makes an opposed attack roll using his base attack bonus plus shield bonus to AC against the opponent's attack roll. If successful, the attack is negated. If the opposed check is failed by the martial disciple, he instead gains DR 20/- to resist the attack.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instant`
      },
      {
        school: `ironTortoise`,
        level: 6,
        name: `Throwing Shell Cyclone`,
        type: `Strike`,
        shortDesc: `Thrown shield attacks all targets in a 20 ft. radius before returning to discipline, inflicting 12d6 points of damage.`,
        longDesc: `The disciple of the Iron Tortoise levels his shield out and spins, releasing it to strike out as his foes in a flurry of clanging steel as it ricochets mercilessly against all within his range and lands firmly back in his waiting hand. The initiator throws his shield and it ricochets between all enemy targets within a 20ft. burst of his position as a full-round action before returning to his hand. This attack inflicts 12d6 points of damage to all targets who fail to make a Reflex save(DC 16 + initiation modifier) for half damage.`,
        initiationAction: `full-round`,
        range: `20 ft. Area: 20 ft. radius burst, centered on initiator`,
        duration: `Instant`
      },
      {
        school: `ironTortoise`,
        level: 7,
        name: `Cyclonic Shell Crush`,
        type: `Strike`,
        shortDesc: `Make a shield bash attack against all adjacent enemies which inflicts an additional +7d6 points of damage and has the chance of dazing for 1d4 rounds.`,
        longDesc: `By making a wide, spinning strike with his shield, the Iron Tortoise master may bash all foes who surround him, teaching them that while he maybe surrounded, he will not give up without a fight. The initiator makes a shield bash attack against all adjacent foes, each successful attack inflicts an additional +7d6 points of damage and may daze the target on a failed Fortitude save (DC 17 + initiation modifier) for 1d4 rounds.`,
        initiationAction: `standard`,
        range: `One melee attack`,
        target: `All adjacent foes`,
        duration: `Instant`
      },
      {
        school: `ironTortoise`,
        level: 7,
        name: `Iron Defender's Riposte`,
        type: `Counter`,
        shortDesc: `Make an opposed attack roll plus shield bonus against a foe's attack against an ally; if successful then the attack is negated and you make a counter attack with shield at +4d6 points of damage.`,
        longDesc: `The Iron Tortoise master is wary of the danger to his charges that his enemies represent, and he is ready to spring into motion to defend them. By using this maneuver when an ally within 20-ft is attacked, the martial disciple may rush up 20 ft. to become adjacent his ally. Once there, he may make an opposed attack roll using his base attack bonus plus his shield bonus to AC to negate the attack to his ally. If successful, the attack is negated and he may make an immediate counter attack against that foe which inflicts an additional +4d6 points of damage and dazes them if the target fails a Fortitude save (DC17 + initiation modifier).`,
        initiationAction: `immediate`,
        range: `One ally within 20-ft`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `ironTortoise`,
        level: 7,
        name: `Unlimited Aggression`,
        type: `Boost`,
        shortDesc: `By assuming an aggressive posture, force all enemies within 60 ft. to attack you if they fail a Will save.`,
        longDesc: `[Mind-affecting]By assuming an aggressive posture and taunting his foes, the Iron Tortoise challenges all foes to face him if they dare. All enemies within 60 ft. must make a Will save (DC 17 + initiation modifier) to resist attacking the Iron Tortoise master on their next available action. Victims who fail this saving throw are free to choose how they will attack the Iron Tortoise disciple, but they must attack him.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `All enemies within 60 ft. with an Intelligence score of 3 or higher`,
        duration: `Instant`
      },
      {
        school: `ironTortoise`,
        level: 8,
        name: `Adamantine Shell`,
        type: `Counter`,
        shortDesc: `Make an opposed attack roll plus shield bonus against opponents attack to negate it, if failed gain DR 40/- against the attack.`,
        longDesc: `By seemingly empowering his shield with his will and perfectly setting himself against an attack, the Iron Tortoise master may attempt to render almost any attack against his person harmless. The initiator makes an opposed attack roll using his base attack bonus plus shield bonus to AC which if successful negates the attack. On a failed opposed attack roll, instead gain DR 40/- against that attack.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instant`
      },
      {
        school: `ironTortoise`,
        level: 8,
        name: `Glorious Shell Shock`,
        type: `Strike`,
        shortDesc: `Powerful shield bash that inflicts an additional +8d6 points of damage to up to three adjacent enemies and sends them hurtling 20 ft. away.`,
        longDesc: `By sweeping his shield in a deadly arc, the martial disciple may send up to three adjacent foes flying away with bone-shattering force. The initiator makes a single shield bash attempt and applies the attack roll to up to three adjacent foes; any successful attacks to these targets inflict an additional +8d6 points of damage and send them hurtling up to 20 ft. away. The initiator determines which direction his foes are hurled to.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Up to three adjacent creatures`,
        duration: `Instant`
      },
      {
        school: `ironTortoise`,
        level: 8,
        name: `Turtle General's Stance`,
        type: `Stance`,
        shortDesc: `Halved movement, but shield automatically blocks line and cone effects, +2 AC to shield bonus.`,
        longDesc: `This stance represents the Iron Tortoise warrior's ability for self sacrifice for the defense of others. While in this stance, the initiator may set his shield against incoming cone and line effects, making an attack roll with his shield against the attack roll or caster level(whichever applies, attack roll for breath weapons for example, or caster level for lightning bolt for another example) which if successful, line attacks immediate end upon the initiator's shield. Cone effects are negated in a line behind the disciple from the direction of the attack. Additionally, while in this stance the initiator gains a +2 bonus to his shield armor class bonus.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `ironTortoise`,
        level: 9,
        name: `Invulnerable Shell of the Iron Tortoise`,
        type: `Counter`,
        shortDesc: `Negates any and all damage, spells, or harmful effects that would effect the initiator and his adjacent allies.`,
        longDesc: `The ultimate technique of the Iron Tortoise discipline, the master of this discipline learns to use his unbreakable will to bolster his shield to defend himself and his allies from any attack. He plants his feet, holds his shield aloft against the oncoming attacks, and weathers the storm, unbreakable. By initiating this counter, any and all damaging or harmful effects that could affect the initiator and any of his adjacent allies are instantly negated as he and his wards take shelter under his shield and unshakable will. The initiator of this maneuver must be aware of the attack to be able to counter it, thus he must not be caught flat-footed by it. This is a supernatural maneuver.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You, plus any adjacent allies`,
        duration: `Instantaneous`
      },

      {
        school: `mithralCurrent`,
        level: 1,
        name: `Flowing Creek`,
        type: `Counter`,
        shortDesc: `Make a Perform (dance) check to negate an incoming attack. If you succeed, you can take a 5-foot step.`,
        longDesc: `Like the flowing water that inspired your art, you sidestep and work around foes instead of fighting them directly. You can initiate this counter in response to a melee or ranged attack (including touch or ranged touch spell attacks) being made against you. Make a Perform (dance) check, using your opponent's attack roll as the DC. If you succeed, the attack is negated and you may take a 5-foot step as a free action, even if you have already taken one this round.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `mithralCurrent`,
        level: 1,
        name: `Following Wake`,
        type: `Boost`,
        shortDesc: `You can make a trip attempt against the next creature you charge this round as a free action, using a Perform (dance) check in place of a combat maneuver check.`,
        longDesc: `By utilizing the momentum of your body and blade, you turn a charge into disabling slash that leaves your opponent on the ground. After initiating this boost, you can make a trip attempt against the next creature you charge this round as a free action, using a Perform (dance) check in place of your combat maneuver check. This combat maneuver attempt does not provoke an attack of opportunity.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `mithralCurrent`,
        level: 1,
        name: `Reaching Blade Stance`,
        type: `Stance`,
        shortDesc: `Your melee attacks deal +1d6 damage, and your first attack each round has its reach increased by 5 feet.`,
        longDesc: `You can translate the momentum of your swift attacks into greater reach, striking foes who would normally be out of your range. While you maintain this stance, your melee attacks deal an additional 1d6 points of damage, and you increase the reach of the first attack you make each round by 5 feet. The additional damage of this stance increases by1d6 for every eight initiator levels you possess.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `mithralCurrent`,
        level: 1,
        name: `Ready the Draw`,
        type: `Stance`,
        shortDesc: `You threaten squares as if you were wielding sheathed weapons on your person, and can draw weapons as part of any type of attack (even while flat-footed). In addition, you gain the benefits of the Combat Reflexes feat, using your initiation modifier in place of your Dexterity modifier to determine the number of attacks of opportunity you can make.`,
        longDesc: `You have the ability to draw your weapon with blinding speed, channeling that motion into deadly attacks. While you maintain this stance, you are considered to be threatening all squares within reach of your weapon even if it is sheathed, and can draw your weapon when making any type of maneuver or attack (including attacks of opportunity), even while flat-footed. In addition, you gain the benefits of the Combat Reflexes feat, even if you do not meet the normal prerequisites. You use your initiation modifier instead of your Dexterity modifier when determining the number of additional attacks of opportunity you can make each round.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `mithralCurrent`,
        level: 1,
        name: `Swift Current`,
        type: `Strike`,
        shortDesc: `Your melee attack deals +1d6 damage. If you drew your weapon as part of this strike, your target is considered flat-footed.`,
        longDesc: `One of the basic tenets of the Mithral Current is that all momentum can be turned into a powerful offensive tool. As an initiate of the discipline, you can use the momentum of drawing your blade from its sheath to increase a strike's power. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 1d6 points of damage. If you drew your weapon as part of this strike, your target is considered flat-footed against this attack.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `mithralCurrent`,
        level: 1,
        name: `Tidal Blade`,
        type: `Strike`,
        shortDesc: `Your melee attack targets two creatures within your reach. If you drew your weapon as part of this strike, you gain a +2 bonus on your attack roll.`,
        longDesc: `As a disciple of the Mithral Current discipline, your skill and grace comes from your flowing movements and lightning-quick attacks. You make a swift slash, striking through multiple enemies with your swing. Make a melee attack roll and compare it to the AC of two creatures within your reach. If the attack roll hits a target, the attack deals weapon damage as normal. Use the same damage roll for each target. If you drew your weapon as part of this strike, you gain a +2bonus on your attack roll.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Up to two creatures`,
        duration: `Instantaneous`
      },
      {
        school: `mithralCurrent`,
        level: 2,
        name: `Calm the Storm`,
        type: `Counter`,
        shortDesc: `Make an opposed attack roll to negate an attack against you. If the attack is negated, the attacker must make a Reflex Save or be unable to attack you again this round.`,
        longDesc: `By perfectly timing your counterattacks, you can force your opponent into a position where they are unable to further attack you. You can initiate this counter in response to a melee or ranged attack being made against you. Make an attack roll with a weapon you are wielding. If your attack roll is higher than your opponent's, their attack is negated and they must succeed on a Reflex Save (DC 12 + your initiation modifier) or be unable to target you with any other attacks this turn.`,
        initiationAction: `immediate`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `mithralCurrent`,
        level: 2,
        name: `Dual Crash`,
        type: `Strike`,
        shortDesc: `You make an attack, and if you drew your weapon as part of this strike, you can make a second attack at a –2 penalty.`,
        longDesc: `With a sudden reversal of direction, you strike an enemy when they least expect it—at the instant after they'd already been hit. Make a melee attack. If it hits, it deals weapon damage as normal. If you drew your weapon as part of this strike, you can make a second attack against the same target with a –2 penalty on the attack roll.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `mithralCurrent`,
        level: 2,
        name: `Iron Wave`,
        type: `Strike`,
        shortDesc: `Your melee attack deals +2d6 damage. If you drew your weapon as part of this strike, you can make this attack against a creature within close range, and your target must make a Will save or become vulnerable to silver.`,
        longDesc: `By imitating the motions of ocean waves, you extend the reach of your blade beyond its edge. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 2d6 points of damage. If you drew your weapon as part of this strike, you can make your attack against any creature within close range (25 feet + 5 feet per 2 initiator levels), even if that creature isn't within your reach. The attack is still treated as a melee attack, and a creature struck must succeed at a Will save (DC 12 + your initiation modifier) or become vulnerable to silver until the end of your next turn. Creatures with vulnerability to silver take 50% more damage from silver weapons. This maneuver is a supernatural ability.`,
        initiationAction: `standard`,
        range: `Melee or close (25 ft. + 5 ft./2 levels)`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `mithralCurrent`,
        level: 2,
        name: `Ride the Wake`,
        type: `Boost`,
        shortDesc: `If you drew your weapon as part of an attack this round, you can initiate this boost to move up to your speed without provoking attacks of opportunity.`,
        longDesc: `For a disciple of the Mithral Current discipline, stillness is death, and you acknowledge this fact by continuing to move even after striking your foes. If you drew a weapon as part of making an attack this round, you can initiate this boost to move up to your speed without provoking attacks of opportunity.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `mithralCurrent`,
        level: 2,
        name: `Riptide Strike`,
        type: `Strike`,
        shortDesc: `Your melee attack deals +2d6 damage. If you drew your weapon as part of this strike, you can make a trip attempt with a +2 competence bonus.`,
        longDesc: `Like the dangerous tidal swells that pull swimmers out to sea and under the waves, you pull an opponent to the ground with your strike. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 2d6 points of damage. If you drew your weapon as part of this strike, you may also make a trip attempt against them as a free action with a +2 competence bonus on your combat maneuver check. This trip attempt does not provoke an attack of opportunity.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `mithralCurrent`,
        level: 3,
        name: `Flowing Water Stance`,
        type: `Stance`,
        shortDesc: `You gain a +4 dodge bonus to your AC and a +4 bonus on initiative checks. Once per round, you can sheath a weapon as a free action that does not provoke attacks of opportunity.`,
        longDesc: `You adopt a stance that maximizes free movement and speed, allowing you to dance around your opponents' attacks and flow past obstacles like a rushing stream. While you maintain this stance, you gain a +4 dodge bonus to your AC and a +4 bonus on initiative checks. In addition, you can sheath your weapon once per round as a free action that does not provoke attacks of opportunity, even if it isn't your turn.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `mithralCurrent`,
        level: 3,
        name: `Rippling Current`,
        type: `Strike`,
        shortDesc: `Your melee attack deals +3d6 damage. If you drew your weapon as part of this strike, your target is considered flat-footed.`,
        longDesc: `Your blade weaves in and out of your opponent's sight to strike at an unexpected angle. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 3d6 points of damage. If you drew your weapon as part of this strike, your target is considered flat-footed against this attack.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `mithralCurrent`,
        level: 3,
        name: `Retreating Tide`,
        type: `Strike`,
        shortDesc: ``,
        longDesc: `Make a single melee attack with a -5 penalty that deals an additional 3d6 damage, then move 5 feet directly away from the target of the attack and sheathe the weapon you attacked with. You can use this strike and move even if you have taken a 5-foot step this round. You cannot attack the target of this strike for the rest of your turn, and if you already attacked them this round, this attack takes a further -4 penalty and does not deal additional damage.`,
        initiationAction: `movement`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `mithralCurrent`,
        level: 3,
        name: `Serenity`,
        type: `Boost`,
        shortDesc: ``,
        longDesc: `You can move up to half your movement speed, sheathing your weapon as you do. Sheathing your weapon this way does not provoke attacks of opportunity. For 1 round, you gain a +4 dodge bonus to your armor class and a +2 bonus on saving throws. This ends as soon as you make an attack.`,
        initiationAction: `movement`,
        range: `personal`,
        target: `you`,
        duration: `1 round`
      },
      {
        school: `mithralCurrent`,
        level: 1,
        name: `Ocean Grace`,
        type: `Boost`,
        shortDesc: ``,
        longDesc: `You gain a +4 dodge bonus to your armor class against the next melee attack against you within 1 round. If the attack misses, you can immediately move 5 feet without provoking attacks of opportunity. If you have no drawn weapons, you can choose to reduce the bonus to +2, but it is not lost after being attack. You can still only take a single 5 foot movement. If you are wearing medium armor the dodge bonus reduces by 1, and reduces by 3 if wearing heavy.`,
        initiationAction: `movement`,
        range: `personal`,
        target: `you`,
        duration: `1 round`
      },
      {
        school: `ironTortoise`,
        level: 1,
        name: `Shields Up`,
        type: `Boost`,
        shortDesc: ``,
        longDesc: `You increase your shield bonus to your armor class by an amount equal to your shield's base armor bonus. If an attack misses you by less than the amount gained, this ends. At level 9, instead of ending, the bonus reduces by 2, however you can expend an attack of opportunity to instead only reduce it by 1.`,
        initiationAction: `movement`,
        range: `personal`,
        target: `you`,
        duration: `1 round or until expended`
      },
      {
        school: `ironTortoise`,
        level: 2,
        name: `Stumbling Bash`,
        type: `Boost`,
        shortDesc: ``,
        longDesc: `Make a shield bash attack, if it hits, it deals damage as normal and if the attack or damage roll exceeded their CMD, the target suffers a -2 penalty to attack rolls and armor class for 1 round.`,
        initiationAction: `movement`,
        range: `personal`,
        target: `you`,
        duration: `1 round`
      },
      {
        school: `ironTortoise`,
        level: 3,
        name: `Conqueror's Charge`,
        type: `Strike`,
        shortDesc: ``,
        longDesc: `Move up to your movement speed, making no more than a single turn of 90 degrees or less while doing it, and the turn must be within the first half of your movement. At the end of it, make a shield bash attack, if it hits, it doesn't do damage, but the creature is automatically tripped and bull rushed 5 feet. For every 5 that the attack roll beat their CMD by, they are bull rushed a further 5 feet. You gain bonuses on this attack as if making a bull rush or overrun attempt. You can fall prone while making the attack roll to gain a +10 bonus on it (you must decide to do this before the roll, ). This still follows the maximum size restrictions for these combat maneuvers.`,
        initiationAction: `movement`,
        range: `personal`,
        target: `you`,
        duration: `1 round`
      },
      {
        school: `mithralCurrent`,
        level: 5,
        name: `Treacherous Stream`,
        type: `Counter`,
        shortDesc: ``,
        longDesc: `When a creature that is flanking you declares a melee attack against you, you can make a performance (dance) check against the CMD of the creature they are flanking you with (with a -2 penalty for every additional creature flanking you), if successful, you may move up to half your movement speed as long as that movement ends you in the space so that the flanking creature now provides cover against the attacker. This movement provokes as normal, except from the creature you are moving behind. This does not negate the attack against you, but the attack is now made with modifiers based on your new position, and you gain any bonuses to your armor class or defenses as if the attack was an attack of opportunity triggered by moving. If your performance (dance) check was also higher than the triggering attack roll, the attack is redirected to the enemy you just moved behind.`,
        initiationAction: `immediate`,
        range: `personal`,
        target: `you`,
        duration: `Instantaneous`
      },
      {
        school: `mithralCurrent`,
        level: 3,
        name: `Rushing Wake`,
        type: `Boost`,
        shortDesc: `When you charge this round, you can trip each opponent adjacent to you during your movement.`,
        longDesc: `With a sudden burst of speed, you charge towards a foe, skillfully knocking aside any others in your path. After initiating this boost, when you make a charge attack this round, you can make a trip attempt as a free action against each opponent adjacent to you at any point in your movement. These trip attempts do not provoke attacks of opportunity, although your movement still does as normal.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `mithralCurrent`,
        level: 3,
        name: `Salt Breeze Strike`,
        type: `Strike`,
        shortDesc: `Your attack deals +3d6 damage. If you drew your weapon as part of this strike, your target takes a –4 penalty on attack rolls for one round.`,
        longDesc: `Imitating the stinging winds of ocean storms, you strike with a debilitating slash and a spray of dust. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 3d6 points of damage. If you drew your weapon as part of initiating this strike, a struck target takes a –4 penalty on attack rolls for one round.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `mithralCurrent`,
        level: 4,
        name: `Blinding Reflection`,
        type: `Strike`,
        shortDesc: `Your melee attack deals +6d6 damage. If you drew your weapon as part of this strike, your target must make a Fortitude save or become blinded for one round.`,
        longDesc: `Reflecting light of your blade like a pond bathed in moonlight, you temporarily blind an opponent and swiftly strike in the opening granted. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 6d6 points of damage. If you drew your weapon as part of this strike, a struck target must succeed at a Fortitude Save(DC 14 + your initiation modifier) or become blinded for 1minute. If the target succeeds on their save, they are instead dazzled for one round.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `mithralCurrent`,
        level: 4,
        name: `Disruptive Wave`,
        type: `Counter`,
        shortDesc: `You can charge a creature casting a spell or power against you, and increase the DC to maintain concentration on their effect by 4.`,
        longDesc: `By sensing the ripples in reality caused by powerful magic, you are able to anticipate and strike before a spell takes effect. You can initiate this counter in response to being targeted by a power, psi-like ability, spell, or spell-like ability. Make a charge attack against the originator of the effect, moving up to twice your speed towards them as normal. If it hits, it deals weapon damage as normal, possibly interrupting the effect and increasing the DC of the Concentration check to not lose the effect by +4.`,
        initiationAction: `immediate`,
        range: `Melee attack (see text)`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `mithralCurrent`,
        level: 4,
        name: `Ride the Current`,
        type: `Counter`,
        shortDesc: `You move up to10 feet after an attack is made against you. If you have a sheathed weapon, you may draw it and attack the creature back.`,
        longDesc: `By reading the movements of a foe, you are able to position yourself out of your enemy's reach, striking as a final parting gift. You can initiate this counter in response to a melee or ranged attack being made against you. If your weapon is sheathed, you may draw it and make a melee attack against your attacker. If it hits, it deals weapon damage as normal. Regardless of whether or not you attacked, you can move up to 10 feet without provoking attacks of opportunity. You cannot make this counterattack if the target is not within your melee reach or otherwise targetable with a melee attack.`,
        initiationAction: `immediate`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `mithralCurrent`,
        level: 4,
        name: `Silver Wave`,
        type: `Strike`,
        shortDesc: `Your melee attack deals +6d6 damage. If you drew your weapon as part of this strike, you can make this attack against a creature within close range, your target must make a Will save or become vulnerable to silver, and you can bull rush them with a bonus on your CMB check equal to your initiation modifier.`,
        longDesc: `Drawing your blade in a powerful diagonal cut, you strike your foe with a brutal wave of kinetic energy. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 6d6 points of damage. If you drew your weapon as part of this strike, you can make your attack against any creature within close range (25 feet + 5 feet per 2 initiator levels), even if that creature isn't within your reach, and the target must succeed at a Will save (DC 14 + your initiation modifier) or become vulnerable to silver until the end of your next turn. In addition, you may also make a bullrush attempt against a struck target as a free action with a competence bonus on your combat maneuver check equal to your initiation modifier. This bull rush attempt does not provoke an attack of opportunity. Creatures with vulnerability to silver take 50% more damage from silver weapons. This maneuver is a supernatural ability.`,
        initiationAction: `standard`,
        range: `Melee or close (25 ft. + 5 ft/2 levels)`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `mithralCurrent`,
        level: 5,
        name: `Flowing Stream`,
        type: `Counter`,
        shortDesc: `Make a Perform (Dance) check to negate an attack or in place of a Reflex Save. If you succeed, you can move up to your speed, drawing a sheathed weapon and making an attack back against the creature for +3d6 damage.`,
        longDesc: `Your graceful movements allow you to distance yourself frome nemies' attacks. You can initiate this counter response toa melee or ranged attack being made against you or when caught in an effect that requires a Reflex saving throw. Makea Perform (dance) check, using your opponent's attack rollor the Reflex save DC as the DC. If you succeed, the attack is negated or you are otherwise unaffected by the effect, and you can move up to your speed without provoking attacks of opportunity towards the originator of the attack or effect. If your weapon is sheathed when you initiate this counter, you may draw it and make a melee attack against your attacker. If it hits, it deals weapon damage as normal plus an additional 3d6 points of damage. You cannot make this counter attack if the target is not within your melee reach or otherwise targetable with a melee attack`,
        initiationAction: `immediate`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `mithralCurrent`,
        level: 5,
        name: `Mithral Flash`,
        type: `Counter`,
        shortDesc: `Make an opposed attack roll to negate an opponent's attack. If you drew your weapon as part of this counter, you can attack the creature back for +5d6 damage, treating your weapons as silver while you do so.`,
        longDesc: `Though the Mithral Current discipline is noted for its graceful movements and artful dodges, you are just as capable of blocking blades as you are avoiding them. You can initiate this counter response to a melee or ranged attack being made against you. Make an attack roll with a weapon you are wielding. If your attack roll is higher than your opponent's, their attack is negated. If you drew your weapon as part of this counter, can make an attack against your attacker. If it hits, it deals weapon damage as normal plus an additional 5d6 points of damage, and your weapon is treated as silver for the purposes of vulnerabilities and overcoming damage reduction. You cannot make this counterattack if the target is not within your melee reach or otherwise targetable with a melee attack.`,
        initiationAction: `immediate`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `mithralCurrent`,
        level: 5,
        name: `Rapid Current`,
        type: `Strike`,
        shortDesc: `You make two melee attacks, dealing +3d6 damage on each. If you drew your weapon as part of this strike, you can make a third attack that does not deal additional damage.`,
        longDesc: `You unleash a rapid flurry of attacks at an enemy, carving deep wounds into their flesh. Make two melee attacks at your full base attack bonus. Each attack that hits deals weapon damage as normal plus an additional 3d6 points of damage. If you drew your weapon as part of this strike, you can make a make one additional attack at your full base attack bonus. If it hits, it deals weapon damage as normal, and does not gain bonus damage from this strike.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `mithralCurrent`,
        level: 5,
        name: `Shifting Waters Stance`,
        type: `Stance`,
        shortDesc: `You do not need to move in a straight line while charging, can charge through difficult terrain, and once per round, you can sheath your weapon as a free action that does not provoke attacks of opportunity. In addition, you increase any movement you make as part of a maneuver by 5 feet.`,
        longDesc: `You dance your way across the battlefield, heedless of any obstacles between you and your target. While you maintain this stance, you do not need to move in a straight line while charging, and may move through difficult terrain while charging (although your movement is still reduced if you do so). In addition, any time a maneuver allows you to move as part of initiating it (including maneuvers that allow you to take a 5-foot step), you may move an additional 5 feet. You can sheath your weapon once per round as a free action that does not provoke attacks of opportunity, even if it is not your turn.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `mithralCurrent`,
        level: 5,
        name: `Whirlpool Strike`,
        type: `Strike`,
        shortDesc: `You attack all adjacent opponents, dealing +3d6 damage. If you drew your weapon as part of this strike, you can attack all opponents within your reach in addition to those adjacent to you.`,
        longDesc: `With a spinning slash, you strike down all foes near you. Make a melee attack roll and compare it to the AC of each adjacent opponent. If the attack roll hits a target, it deals weapon damage as normal plus an additional 3d6 points of damage. Use the same damage roll for each target. If you drew your weapon as part of this strike, you may attack all opponents within your reach in addition to those adjacent to you.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Adjacent opponents or opponents in reach (see text)`,
        duration: `Instantaneous`
      },
      {
        school: `mithralCurrent`,
        level: 6,
        name: `Crashing Wake`,
        type: `Strike`,
        shortDesc: `You move up to 30 feet and can attack each opponent adjacent to you at any point in the movement. These attacks deal +4d6 damage.`,
        longDesc: `You rush across the battlefield, striking all foes in your path. When you initiate this maneuver, you can move up to 30 feet as a free action, provoking attacks of opportunity as normal. Make a single attack against each opponent adjacent to you at any point during your movement. If an attack hits, it deals weapon damage as normal, plus an additional 4d6 points of damage.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Adjacent opponents (see text)`,
        duration: `Instantaneous`
      },
      {
        school: `mithralCurrent`,
        level: 6,
        name: `Endless Current`,
        type: `Boost`,
        shortDesc: `You can move up to 10 feet as a free action after each attack you make for one round.`,
        longDesc: `You channel the momentum of your attacks into a leaping dance, allowing you to maneuver across the battlefield with every blow. After initiating this boost, you can move up to 10 feet as a free action without provoking attacks of opportunity each time you make an attack until the start of your next turn.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `mithralCurrent`,
        level: 6,
        name: `Mithral Current Stance`,
        type: `Stance`,
        shortDesc: `You threaten squares as if you were wielding sheathed weapons on your person, can draw weapons as part of any type of attack (even while flat-footed), and once per round, you can sheath your weapon as a free action that does not provoke attacks of opportunity. In addition, creatures you hit with an attack must make a Will save or become vulnerable to silver.`,
        longDesc: `You move with the speed and grace of a rapid flowing river, striking at blinding speeds. While you maintain this stance, any creature you hit with a melee attack must succeed at a Will save (DC 16 + your initiation modifier) or become vulnerable to silver until the end of your next turn. This effect resolves after your attack. In addition, you are considered to be threatening all squares within reach of your weapon even if it is sheathed, and can draw your weapon when making any type of maneuver or attack (including attacks of opportunity), even while flat-footed. You can sheath your weapon once per round as a free action that does not provoke attacks of opportunity, even if it isn't your turn. Creatures with vulnerability to silver take 50%more damage from silver weapons.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `mithralCurrent`,
        level: 6,
        name: `Quicksilver Wave`,
        type: `Strike`,
        shortDesc: `Your melee attack deals +8d6 damage. If you drew your weapon as part of this strike, you can make this attack against a creature within close range, your target must make a Will save or become vulnerable to silver, and you can trip them with a bonus on your CMB check equal to your initiation modifier.`,
        longDesc: `A wave of silver energy leaps from your blade to slash at a distant foe. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 8d6 points of damage. If you drew your weapon as part of this strike, you can make your attack against any creature within close range (25 feet +5 feet per 2 initiator levels), even if that creature isn't within your reach, and the target must succeed at a Will save (DC16 + your initiation modifier) or become vulnerable to silver until the end of your next turn. In addition, you may also make a trip attempt against a struck target as a free action with a competence bonus on your combat maneuver check equal to your initiation modifier. This trip attempt does not provoke an attack of opportunity. Creatures with vulnerability to silver take 50% more damage from silver weapons. This maneuver is a supernatural ability.`,
        initiationAction: `standard`,
        range: `Melee attack or close (25 ft. + 5 ft./2 levels)`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `mithralCurrent`,
        level: 7,
        name: `Blade of the Silver Sea`,
        type: `Strike`,
        shortDesc: `Your melee attack deals +8d6 damage. If you drew your weapon as part of this strike, you overcome damage reduction and suppress the target's regeneration and fast healing.`,
        longDesc: `Your blade ripples and shimmers with a bright silver light as it strikes home and rends the flesh of your enemy. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 8d6 points of damage. If you drew your weapon as part of this strike, your attack is treated as silver for the purposes of vulnerability, automatically overcomes damage reduction, and suppresses any fast healing or regeneration the target has for a number of rounds equal to your initiation modifier. This strike cannot suppress regeneration that is not overcome by any type of damage, such as that possessed by a tarrasque. This maneuver is a supernatural ability.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `mithralCurrent`,
        level: 7,
        name: `Flowing River`,
        type: `Counter`,
        shortDesc: `Make a Perform (dance) check in place of a saving throw. If you succeed, you can move to a space adjacent to the originator of the effect and attack them with a sheathed weapon for +5d6 damage.`,
        longDesc: `The dance of the Mithral Current allows you to avoid an incoming effect and return the insult with great fury. You can initiate this counter in response to being targeted by or caught in an effect that allows a saving throw. Make a Perform (dance) check in place of your saving throw. If you succeed, you can immediately move to any space adjacent to the creature that originated the effect without provoking attacks of opportunity, even if the creature is further away than your movement speed. If your weapon is sheathed when you initiate this maneuver, you may draw it and make a melee attack against that creature. If it hits, it deals weapon damage as normal plus an additional 5d6 points of damage.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `mithralCurrent`,
        level: 7,
        name: `Raging Whirlpool Strike`,
        type: `Strike`,
        shortDesc: `You attack all adjacent opponents, dealing +5d6 damage. If you drew your weapon as part of this strike, you can make a second attack against them for +3d6 damage.`,
        longDesc: `With a whirling slash, you carve through all foes that presume to approach you. Make a melee attack roll and compare it to the AC of each adjacent opponent. If the attack roll hits a target, it deals weapon damage as normal plus an additional 5d6 points of damage. Use the same damage roll for each target. If you drew your weapon as part of this strike, you may make a second attack roll identical to the first. If it hits, it deals weapon damage as normal plus an additional 3d6 points of damage.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `All adjacent enemies`,
        duration: `Instantaneous`
      },
      {
        school: `mithralCurrent`,
        level: 8,
        name: `Mithral Lightning Stance`,
        type: `Stance`,
        shortDesc: `Your speed increases by 10 feet, you gain a +6 dodge bonus to your AC against attacks of opportunity, your weapons are treated as silver, and once per round, you can sheath your weapon as a free action that does not provoke attacks of opportunity. In addition, you can make an attack against any creature that makes an attack of opportunity against you, dealing +3d6 damage. Your attacks as part of counters deal +3d6 damage.`,
        longDesc: `With blinding movements and rapid, graceful strikes, you are able to travel across the battlefield and bring death to any who would try to oppose you. While you maintain this stance, you gain a +10-foot enhancement bonus to each of your speeds and a +6 dodge bonus to your AC against attacks of opportunity. Your weapons are treated as silver for the purposes of vulnerabilities and overcoming damage reduction, and whenever an opponent makes an attack of opportunity against you, you can make a melee attack against them after their attack resolves. If it hits, it deals weapon damage as normal plus an additional 3d6 points of damage. In addition, all attacks you make as part of counter maneuvers deal an additional 3d6 points of damage on a successful hit, and you can sheath your weapon once per round as a free action that does not provoke attacks of opportunity, even if it isn't your turn.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `mithralCurrent`,
        level: 8,
        name: `Mithral Wave`,
        type: `Strike`,
        shortDesc: `Your melee attack deals +14d6 damage. If you drew your weapon as part of this strike, you can make this attack against a creature within close range, your target must make a Fortitude save or become dazed for 1d4 rounds, a Reflex save or be knocked prone, and a Will save or become vulnerable to silver.`,
        longDesc: `A wave of blinding silver energy erupts from your blade to strike a distant foe. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 14d6 points of damage. If you drew your weapon as part of this strike, you can make your attack against any creature within close range(25 feet + 5 feet per 2 initiator levels), even if that creature isn't within your reach, and the target must succeed at a Fortitude save (DC 18 + your initiation modifier) or become dazed for 1d4 rounds, a Reflex save (DC 18 + your initiation modifier) or be knocked prone, and a Will save (DC 18 +your initiation modifier) or become vulnerable to silver until the end of your next turn. Creatures with vulnerability to silver take 50% more damage from silver weapons. This maneuver is a supernatural ability.`,
        initiationAction: `standard`,
        range: `Melee attack or close (25 ft. + 5 ft./2 levels)`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `mithralCurrent`,
        level: 8,
        name: `Riptide Slice`,
        type: `Strike`,
        shortDesc: `Your melee attack deals +12d6 damage. If you drew your weapon as part of this strike, this attack is made against your opponent's touch AC.`,
        longDesc: `As a master of the Mithral Current discipline, you can make a cut so light and gentle it feels like a mere breeze while still rending your enemy to their very core. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 12d6 points of damage. If you drew your weapon as part of this strike, this attack is made against your opponent's touch AC.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `mithralCurrent`,
        level: 9,
        name: `Dance of the Silver Hurricane`,
        type: `Counter`,
        shortDesc: `For one round, you can make a Perform (dance) check in place of your AC and CMD, and can move up to 10 feet when attacked. At the start of your next turn, you can attack each creature that made an attack against you in the previous round, dealing +1d6 damage for each time a given creature missed you.`,
        longDesc: `Having reached the epitome of the Mithral Current discipline, you know the dance of battle perfectly, and every step you take is attuned to that deadly rhythm. After initiating this counter, you can make a Perform (dance) check and use it in place of your AC or CMD against any attack or combat maneuver made against you until the start of your next turn. In addition, any time an attack or combat maneuver misses you during the duration of this counter, you can move up to 10 feet as a free action. You may choose to not provoke attacks of opportunity during this movement, or to provoke attacks of opportunity as normal. At the start of your next turn, make melee attack roll and compare it to the AC of each creature that attacked you and missed while this counter was in effect. If the attack roll hits a target, it deals weapon damage as normal, and is treated as silver for the purposes of vulnerabilities and overcoming damage reduction. This attack affects creatures regardless of the distance between you and your opponents. If you drew your weapon as part of this counter, a struck opponent takes an additional 1d6 points of damage for each time it missed you while the counter was in effect (up to a maximum of 6d6 points of additional damage per creature).`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `piercingThunder`,
        level: 1,
        name: `Bronze Lancer's Edge`,
        type: `Boost`,
        shortDesc: `Your next charge attack deals +1d6 damage.`,
        longDesc: `With practiced skill, you are capable of achieving greater force with your discipline weapons. After initiating this boost, the next charge attack you make this turn deals an additional 1d6 points of damage.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `piercingThunder`,
        level: 1,
        name: `Bronze Lancet Charge`,
        type: `Strike`,
        shortDesc: `Charge attack that deals +1d6 damage and does not provoke attacks of opportunity.`,
        longDesc: `You make a thunderous charge and deliver a powerful attack. Make a charge attack that does not provoke attacks of opportunity. If your attack hits, it deals weapon damage as normal plus an additional 1d6 points of damage.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `piercingThunder`,
        level: 1,
        name: `Iron Pikeman's Attitude`,
        type: `Stance`,
        shortDesc: `Gain the benefits of the Endurance feat and reduce armor's restrictive qualities.`,
        longDesc: `You have practiced ways to mitigate and circumvent the woes of heavy armor and gear. While you maintain this stance, you gain the benefits of the Endurance feat and you may treat armor you are wearing as one category lower(heavy armor is treated as medium armor, and so forth, to a minimum of light armor). In addition, you reduce the armor check penalty of armor you are wearing by 1 (to a minimum of 0) and increase the maximum Dexterity bonus allowed by your armor by 1. For every 3 initiator levels you possess beyond 1st level, you reduce the armor check penalty and increase the maximum Dexterity bonus by an additional 1(up to a maximum of a -5 armor check penalty reduction and a +5 increase to maximum Dexterity bonus).`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `piercingThunder`,
        level: 1,
        name: `Oaken Shield`,
        type: `Counter`,
        shortDesc: `Increase your shield bonus by +4 against one attack.`,
        longDesc: `You shift your weapon's haft into a more defensible position, shielding you from assault. You can initiate this counter in response to a melee or ranged attack being made against you. Your shield bonus to your AC against that attack increases by +4 (if you have no shield bonus to AC, your shield bonus increases to +4).`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `piercingThunder`,
        level: 1,
        name: `Phalanx Lancer`,
        type: `Stance`,
        shortDesc: `Use heavy weapons one handed with a shield and deal +1d6 damage those weapons. You can lock your shields with those of allies to gain a bonus to AC.`,
        longDesc: `Though heavy conditioning and strength training, you have become adept at using a shield in tandem with a polearm to great effect. While maintain this stance, you can wield a normally two-handed discipline weapon as a one-handed weapon (or a normally one-handed discipline weapon as alight weapon) when using a shield in your off hand. When fighting in this manner, your attacks with discipline weapons and shield bashes deal an additional 1d6 points of damage (+1d6 per ten initiator levels).In addition, adjacent allies (up to a maximum number equal to your initiation modifier) wearing shields may interlock their shields with yours as a free action on their turn. Each shield-bearing character improves their shield bonus to AC by +1 for each ally in this position (up to a maximum of +5). Allies linking shields with you in this manner do not need to be in this stance unless they wish to increase the number of allies within the phalanx as well. Special Note: If you possess the armament shield class feature (see zweihander sentinel warder archetype in Path of War), its benefits are suspended while you maintain this stance. You must be wielding an actual shield to interlock it with the shields of allies.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `piercingThunder`,
        level: 1,
        name: `Piercing Strike`,
        type: `Strike`,
        shortDesc: `Strike through two opponents that are adjacent to each other.`,
        longDesc: `You issue a potent impaling blow with your weapon, battering defenses aside and striking bloodily at your foe. During this strike, your weapon's reach increases by 5 feet. Make a melee attack roll and compare it to the ACs of up to two creatures within your reach that are adjacent to each other. If the attack roll hits a target, it deals weapon damage as normal. Use the same damage roll for each target.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One or two creatures`,
        duration: `Instantaneous`
      },
      {
        school: `piercingThunder`,
        level: 2,
        name: `Armor-Piercing Thrust`,
        type: `Strike`,
        shortDesc: `Your attack is made against your opponent's touch AC.`,
        longDesc: `You make a potent attack toward your foe, unleashing a heavy thrust that pierces through their defenses. Make a melee touch attack with a weapon you are wielding. If it hits, it deals weapon damage as normal.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `piercingThunder`,
        level: 2,
        name: `Brace for Impact`,
        type: `Counter`,
        shortDesc: `Make an Acrobatics check to negate an incoming charge attack. If wielding a discipline weapon, you deal damage back.`,
        longDesc: `In the chaos of battle, you know you can truly only trust the weapon in your hand. You can initiate this counter when an opponent makes a charge attack against you. Make an Acrobatics check, using your opponent's attack roll as the DC. If you succeed, the attack is negated and that opponent takes damage equal to your initiator level. If you are wielding weapon with the brace property, this damage is doubled. If you are not wielding a discipline weapon or a piercing weapon, this counter does no damage to your opponent but can still negate the attack.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `piercingThunder`,
        level: 2,
        name: `Hastened Leap`,
        type: `Boost`,
        shortDesc: `Move up to 20 feet or make an Acrobatics check to make a running jump with a +10 bonus.`,
        longDesc: `By using this method, you become capable of a quick burst of speed, launching yourself forward with alacrity towards you foes. When you initiate this boost, you can either move up to 20 feet or make an Acrobatics check to jump. If you jump, you are treated as if you had a running start and your check is made with a +10 competence bonus.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `piercingThunder`,
        level: 2,
        name: `Throwing Thunder`,
        type: `Strike`,
        shortDesc: `Hurl your discipline weapon at a target as an attack that deals +2d6 damage and may knock the target prone.`,
        longDesc: `By rearing back for a powerful throw, you are capable of turning any pole arm into a deadly and dangerous missile. Make a ranged attack, using a discipline weapon you're wielding as a thrown weapon. The weapon's range increment increases by 20 feet for this attack. If the weapon does not normally have a range increment, it instead gains a20-foot range increment for this attack, and you do not take the normal penalty for throwing a nonstandard weapon. If your attack hits, it deals weapon damage as normal plus an additional 2d6 points of damage, and the target must succeed at a Reflex save (DC 12 + your initiation modifier) or be knocked prone.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `piercingThunder`,
        level: 2,
        name: `Thunderous Fall`,
        type: `Strike`,
        shortDesc: `Your attack deals +2d6 damage, and if the target is mounted, they may be dismounted; if they're on foot, you may make a trip attempt as a free action.`,
        longDesc: `Using the principles of Piercing Thunder, you are well-suited to taking advantage of your superior reach to bring your foes to the ground, be they cavalry or infantry. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 2d6 points of damage, and if the target is riding a mount, they must succeed at a Reflex save (DC 12 + your initiation modifier)or be dismounted, falling prone in a square of your choice adjacent to their mount. If the target is not mounted, you may instead make a trip attempt against them as a free action with a +2 competence bonus to your combat maneuver check. This strike can only be initiated with a discipline weapon.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `piercingThunder`,
        level: 3,
        name: `Goring Strike`,
        type: `Strike`,
        shortDesc: `Increases reach by 5 feet and attacks opponents in a line, dealing +3d6 damage.`,
        longDesc: `With a mighty thrust with your weapon, you pierce your enemies, delivering a devastating attack to multiple foes within your reach. During this strike, your weapon's reach increases by 5 feet. When you initiate this maneuver, your strike targets every creature in a line with a range equal toyour reach. Make a melee attack roll and compare it to the AC of each creature within the area. If the attack roll hits a target, it deals weapon damage as normal plus an additional2d6 points of damage, and the target must succeed at a Fortitude save (DC 13 + your initiation modifier) or suffer1d4 points of bleed damage. Use the same damage roll foreach target. This strike can only be initiated with a discipline weapon or a piercing weapon.`,
        initiationAction: `standard`,
        range: `See textArea: Line (see text)`,
        target: `One or more creatures (see text)`,
        duration: `Instantaneous`
      },
      {
        school: `piercingThunder`,
        level: 3,
        name: `Iron Lancer's Edge`,
        type: `Boost`,
        shortDesc: `Your next charge attack deals +3d6 damage and staggers your target.`,
        longDesc: `You urge punishing force into your attack to devastate your foes. After initiating this boost, the next charge attack you make this turn deals an additional 3d6 points of damage, and the creature struck is staggered for one round.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `piercingThunder`,
        level: 3,
        name: `Piercing Thunder Hammer`,
        type: `Strike`,
        shortDesc: `You make a powerful downward blow that deals +2d6 damage and may knock your target prone.`,
        longDesc: `As a seasoned spearman, you know how to leverage your strength properly. By drawing up your strength, you deliver a crushing strike that can bring even the most stable enemies to their knees. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 2d6 points of damage, and the target must succeed at a Reflex save (DC 13 + your initiation modifier) or be knocked prone.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `piercingThunder`,
        level: 3,
        name: `Twin Thunder Stance`,
        type: `Stance`,
        shortDesc: `You may wield two heavy weapons as if they were both one-handed weapons, and gain the benefits of the Two-Weapon fighting feat.`,
        longDesc: `You have learned how to use normally two-handed weapons in one hand, using the weapons' size and momentum to strike your foes with powerful blows. While you maintain this stance, You can wield normally two-handed weapons as one-handed weapons, and you gain the benefits of the Two-Weapon Fighting feat while using two discipline weapons in either hand (even if you do not meet its prerequisites).If you already possess the Two-Weapon Fighting feat, you may instead wield one or both of weapons as light weapons(reducing the penalties further and making them eligible for use with feats such as Weapon Finesse or Deadly Agility),and you gain the benefits of the Improved Two-Weapon Fighting feat, or the Greater Two-Weapon Fighting if you already possessed Improved Two-Weapon Fighting, even if you do not meet these feats' prerequisites. You do not need to be wielding multiple weapons to gain the benefits of this stance. Special Note: If you possess the armament shield class feature (see zweihander sentinel warder archetype in Path of War) and wielding a two-handed weapon in one hand, the benefits of armament shield will still apply to that weapon. If you are wielding a pair of two-handed weapons, armament shield only applies to one of them, although you can choose which weapon it applies to as a free action at the start of each turn. Note that even if you are wielding more than two weapons, you can only gain extra attacks with a single of hand weapon each turn.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `piercingThunder`,
        level: 4,
        name: `Iron Lancet Charge`,
        type: `Strike`,
        shortDesc: `Charge attack that deals +6d6 damage, does not provoke attacks of opportunity, and may knock the target prone.`,
        longDesc: `Your knowledge of how to deliver a powerful charge that delivers bone-shattering force is unparalleled. Make a charge attack that does not provoke attacks of opportunity. If it hits, it deals weapon damage as normal plus an additional 6d6 points of damage, and the target must succeed at a Reflex save (DC 14 + your initiation modifier) or be knocked prone.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `piercingThunder`,
        level: 4,
        name: `Leaping Strike`,
        type: `Strike`,
        shortDesc: `Use an Acrobatics check in place of your attack roll, dealing +6d6 damage if you hit.`,
        longDesc: `In a daring feat of acrobatics, you leap high into the air and descend with the force of a lightning bolt. Make a melee attack, using an Acrobatics check in place of your attack roll. Any bonuses and penalties that would be applied toa normal attack roll, such as weapon enhancements, spell effects, or the penalties for fighting with two weapons or shooting into melee, are applied to the skill check as well. If your attack hits, it deals weapon damage as normal plus an additional 6d6 points of damage.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `piercingThunder`,
        level: 4,
        name: `Repositioning Leap`,
        type: `Counter`,
        shortDesc: `Make an Acrobatics check to negate an attack and leap out of the way of danger.`,
        longDesc: `With a powerful leap and roll, you are able to evade an enemy's attack and reposition yourself to better defend yourself. Make an Acrobatics check, using your opponent's attack roll as the DC. If you succeed, the attack is negated, and you may jump away from your position, using your Acrobatics check result to determine the distance moved. This movement does not provoke attacks of opportunity.`,
        initiationAction: `immediate`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `piercingThunder`,
        level: 4,
        name: `Twisting Lance`,
        type: `Strike`,
        shortDesc: `Make a trip attempt with a +4 bonus, and if you succeed, make an attack that deals +5d6 damage.`,
        longDesc: `You sweep your enemies' legs out from under them with the haft of your weapon before following up with a spinning strike its head. Make a trip attempt with a +4 competence bonus on your combat maneuver check. This trip attempt does not provoke attacks of opportunity. If you successfully trip your target, you can make a single melee attack against them as a free action. If your attack hits, it deals weapon damage as normal plus an additional 5d6 points of damage.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `piercingThunder`,
        level: 5,
        name: `Meteor Spiral Thrust`,
        type: `Strike`,
        shortDesc: `Your attack deals +8d6 damage, automatically overcomes damage reduction, and may nauseate the target.`,
        longDesc: `You put a vicious twist in your thrust, delivering a powerful blow that penetrates armor and body alike. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 8d6 points of damage, and automatically overcomes damage reduction. In addition, the target must succeed at a Fortitude save (DC 15 + your initiation modifier) or become nauseated for 1d3 rounds.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `piercingThunder`,
        level: 5,
        name: `Stance of the Thunderbrand`,
        type: `Stance`,
        shortDesc: `You gain a +4 dodge bonus to your AC, your reach increases by 5 feet, and opponents you threaten provoke attacks of opportunity with any movement, including 5-foot steps and teleportation.`,
        longDesc: `You tightly concentrate your focus on the battlefield, maximizing the effectiveness of your reach and keeping enemy attacks at bay. While you maintain this stance, you gain a +4 dodge bonus to your AC and your weapon's reach increases by 5 feet. In addition, any creature you threaten that leaves their square provokes an attack of opportunity from you, even if their movement was a 5-foot step or movement that would not otherwise provoke attacks of opportunity (such as with the Spring Attack feat or a teleportation effect). Your opponents cannot use the Withdraw action to treat the squares they start in as no longer threatened by you.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `piercingThunder`,
        level: 5,
        name: `Throwing Comet`,
        type: `Strike`,
        shortDesc: `Hurl your weapon as a 30-foot line, dealing +8d6 damage and possibly knocking opponents prone.`,
        longDesc: `With an overhand spin, you hurl your polearm at your enemies, decimating their ranks in a whirling path. When you initiate this maneuver, you throw your weapon, creating a 30-foot line that deals damage to each creature in the area as if you had hit them with an attack with a weapon you are wielding (including damage from magical properties or other bonuses), plus an additional 8d6 points of damage, and knocks them prone. Use the same damage roll for each creature. Creatures caught in the line can make a Reflex save (DC 15 + your initiation modifier) to take half damage and not fall prone. After resolving this maneuver, the weapon you threw lands in the furthest square from you at the end of the line. If it is enchanted with a property such as returning or teleporting, or you otherwise have the ability to cause thrown weapons to return to you, it does so normally as if you had made an attack with it.`,
        initiationAction: `standard`,
        range: `30 ft.Area: 30-ft. line`,
        duration: `Instantaneous`
      },
      {
        school: `piercingThunder`,
        level: 5,
        name: `Twisting Parry`,
        type: `Counter`,
        shortDesc: `Make an attack roll opposing an incoming attack. If you succeed, you redirect the attack to an adjacent opponent.`,
        longDesc: `A champion of combat, the disciple of the Piercing Thunder is capable of using the size and weight of his weapon to buffet an attack aside to strike at another foe. You can initiate this counter in response to a melee or ranged attack being made against you. Make an attack roll with a weapon you are wielding. Use the higher of your AC and your attack roll as your effective AC against the incoming attack. If the attack against you misses, you deflect the attack at another creature you can see within reach or range of the attacker. Treat the attack as if it had been made against that creature, using the attacker's original attack roll to resolve the attack as normal. If there is no new target available, the attack is simply negated.`,
        initiationAction: `immediate`,
        range: `One attack`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `piercingThunder`,
        level: 6,
        name: `Diving Thunderbolt Stance`,
        type: `Stance`,
        shortDesc: `You gain a bonus on Acrobatics to jump equal to twice your initiator level, become immune to falling damage, and can charge enemies you attack from a higher elevation.`,
        longDesc: `Your movements are light and nimble, allowing you to reach incredible heights and strike with the force of a swooping dragon. While you maintain this stance, you become immune to falling damage, gain a bonus on Acrobatics checks made to jump equal to twice your initiator level, and your vertical jumping distance is not limited by your maximum movement speed. In addition, if you attack your opponent from a higher elevation (including after jumping towards them as a move action), you are considered to be charging that opponent for the purposes of feats and abilities you possess that would provide a beneficial effect.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `piercingThunder`,
        level: 6,
        name: `Glorious Thunder Charge`,
        type: `Strike`,
        shortDesc: `Charge attack that deals +8d6 damage, does not provoke attacks of opportunity, and may nauseate the target.`,
        longDesc: `Brandishing his potent weapon in a glorious display of martial superiority, the disciple charges to battle his foe with determination matched by only the gods themselves. Make a charge attack that does not provoke attacks of opportunity. If it hits, it deals weapon damage as normal plus an additional 8d6 points of damage, and the target must succeed at a Fortitude save (DC 16 + your initiation modifier) or become nauseated for 1d3 rounds.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `piercingThunder`,
        level: 6,
        name: `Impaling Comet Strike`,
        type: `Strike`,
        shortDesc: `Increases reach by 10 feet and attacks opponents in a line, dealing +6d6 damage and automatically overcoming damage reduction.`,
        longDesc: `You are capable of pressing an incredible assault upon a foe. During this strike, your weapon's reach increases by 10feet. When you initiate this maneuver, your strike targets every creature in a line with a range equal to your reach. Make a melee attack roll and compare it to the AC of each opponent within the area. If the attack roll hits a target, it deals weapon damage as normal plus an additional 6d6points of damage, and automatically overcomes damage reduction. Use the same damage roll for each target. This strike can only be initiated with a discipline weapon or a piercing weapon.`,
        initiationAction: `standard`,
        range: `See textArea: Line (see text)`,
        target: `One or more opponents`,
        duration: `Instantaneous`
      },
      {
        school: `piercingThunder`,
        level: 6,
        name: `Lightning Rush`,
        type: `Boost`,
        shortDesc: `Increase your speed by 30 feet for one round, then move up to your speed as a free action.`,
        longDesc: `By digging in his heels and launching of like a speeding comet, the disciple of the Piercing Thunder is capable of lightning fast sprints for a short period of time. After initiating this boost, your base land speed increases by 30feet until the start of your next turn. This adjustment is treated as an enhancement bonus. In addition, you can immediately move up to your speed as a free action. This movement does not provoke attacks of opportunity.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `piercingThunder`,
        level: 6,
        name: `Steel Lancer's Edge`,
        type: `Strike`,
        shortDesc: `Charge attack that deals +6d6 damage, does not provoke attacks of opportunity, and you can make an Acrobatics check to jump away after the attack.`,
        longDesc: `You add a burst of speed and force to the end of your charge, striking your foe with a deadly thrust before using the momentum to leap away from their counterattack. Make a charge attack that does not provoke attacks of opportunity. If it hits, it deals weapon damage as normal plus an additional 8d6 points of damage, and automatically overcomes damage reduction. In addition, regardless of whether your attack hit or not, you can make an Acrobatics check to jump as a free action. Movement during this jump does not provoke attacks of opportunity from the target.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `piercingThunder`,
        level: 7,
        name: `Breaking the Charge`,
        type: `Counter`,
        shortDesc: `Interrupt a charge attack passing through your reach with an attack that deals +5d6 damage and may knock the target prone.`,
        longDesc: `The disciple of the Piercing Thunder is wise to the ways of combat, and when opponents rush by, his lance is always at the ready. You can initiate this counter whenever a charging opponent passes within 10 feet of you (including if you yourself are being charged). Make a melee attack against that creature with a weapon you are wielding, even if its reach would not otherwise allow you to strike the foe. If it hits, it deals weapon damage as normal plus an additional5d6 points of damage, and the target must succeed at a Reflex save (DC 17 + your initiation modifier) or be knocked prone. Regardless of whether or not they succeed at the save, the target's movement ends, potentially keeping them from making their charge attack. This maneuver may only be made with a discipline weapon.`,
        initiationAction: `immediate`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `piercingThunder`,
        level: 7,
        name: `Leaping Thunder Crash`,
        type: `Strike`,
        shortDesc: `Use an Acrobatics check in place of your attack roll, dealing +35 damage if you hit and possibly disarming the target.`,
        longDesc: `With a tremendous leap into the air, you come crashing down upon your enemy with the force of the gods themselves. Make a melee attack, using an Acrobatics check in place of your attack roll. Any bonuses and penalties that would be applied to a normal attack roll, such as weapon enhancements, spell effects, or the penalties for fighting with two weapons, are applied to the skill check as well. If your attack hits, it deals weapon damage as normal plus an additional 35 points of damage, and the target must succeed at a Fortitude save (DC 17 + your initiation modifier) or drop any held items, as though they had been disarmed.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `piercingThunder`,
        level: 7,
        name: `Rush to the Fray`,
        type: `Strike`,
        shortDesc: `Charge attack that does not provoke attacks of opportunity and allows you to attack all adjacent opponents for +5d6 damage at the end of the charge.`,
        longDesc: `You charge fearlessly towards a group of foes, heedless of difficulties and deliver a flurry of potent attacks. Make a charge attack that does not provoke attacks of opportunity. During this charge, you ignore difficult terrain (potentially allowing you to charge where you otherwise could not). At the end of your charge, you can give up your regular attack sand instead make a melee attack or combat maneuver attempt at your highest base attack bonus against each opponent within reach. If an attack hits, it deals weapon damage as normal plus an additional 5d6 points of damage, or if used for a combat maneuver attempt, you gain a +5 competence bonus on your combat maneuver check. You must make a separate attack roll against each target.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One or more creatures`,
        duration: `Instantaneous`
      },
      {
        school: `piercingThunder`,
        level: 8,
        name: `Adamantine Lancer's Edge`,
        type: `Boost`,
        shortDesc: `Your next charge attack deals +8d6 damage, automatically overcomes damage reduction, and may daze your target.`,
        longDesc: `As a master of the Piercing Thunder discipline, you wield your lance with impossible strength and penetrating power, piercing steel as easily as flesh and bone. After initiating this boost, the next charge attack you make this turn deals an additional 8d6 points of damage. In addition, each attack you make during that charge automatically overcomes damage reduction, and any creature struck must succeed at a Fortitude save (DC 18 + your initiation modifier) or become dazed for one round.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round (see text)`
      },
      {
        school: `piercingThunder`,
        level: 8,
        name: `Deadly Thunder Lancer's Stance`,
        type: `Stance`,
        shortDesc: `Gain bonuses on attack rolls, damage rolls, and Acrobatics checks to jump and tumble, and you can move before or after maneuvers or attacks.`,
        longDesc: `Mastery of the spear and its many styles comes to you as you near the pinnacle of the Piercing Thunder discipline. While you maintain this stance, you add your initiation modifier to attack rolls, damage rolls, and Acrobatics checks to jump or tumble. In addition, you gain the benefits of the Spring Attack feat, even if you do not meet its prerequisites. When you use this feat, you can initiate a strike with an initiation action of one standard action or less instead of making anormal attack during your movement. If that strike includes a charge, you gain the normal benefits and penalties of the charge combat maneuver, although your movement is not limited to a straight line, you may move through difficult terrain or other obstacles as if you were not charging, and you do not have to end your movement after initiating your strike.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `piercingThunder`,
        level: 8,
        name: `Thundering Lancer's Blow`,
        type: `Strike`,
        shortDesc: `Your attack deals +12d6 damage, and you can make a bull rush attempt that also knocks the target prone.`,
        longDesc: `By leveling a heavy blow from your powerful weapon, you strike so hard to as to bring your opponent to their knees with this strike. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 12d6 points of damage, and you can make a bull rush attempt against the target as a free action. This bull rush attempt does not provoke an attack of opportunity, and you gain a bonus on your combat maneuver check equal to 1/2 your initiator level. If your bullrush attempt is successful, the target is knocked prone at the end of their movement.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `piercingThunder`,
        level: 9,
        name: `Piercing Charge of the Dread Lancer`,
        type: `Strike`,
        shortDesc: `Charge across the battlefield as a line attack, striking each opponent you pass through and dealing +15d6 damage.`,
        longDesc: `As a master of the Piercing Thunder discipline, you can make a devastating charge across the battlefield, striking all in your way with razor precision and unstoppable killing force. When you initiate this maneuver, you make a charge attack, moving up to twice your speed in a straight line as normal. Unlike a normal charge attack, you do not designate an opponent, and do not need to end your movement within reach of an opponent. In addition, your movement ignores difficult terrain and intervening creatures, and does not provoke attacks of opportunity. Rather than making an attack at the end of your charge, your strike targets every opponent who was caught in your path; treat your movement as a line-shaped effect for determining who is affected. Each opponent caught within the line takes damage as if you had hit them with an attack with a weapon you are wielding (including damage from magical properties or other bonuses), and must succeed at a Reflex save (DC 19+ your initiation modifier) or take an additional 15d6 points of damage. A successful save halves the additional damage, but does not negate the damage from your attack. Use the same damage roll for each creature. This strike can only be initiated with a discipline weapon.`,
        initiationAction: `full-round`,
        range: `See textArea: Line (see text)`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 1,
        name: `Crushing Blow`,
        type: `Strike`,
        shortDesc: `A powerful overhand blow that inflicts an additional +1d6 points of damage, enemy is left flat-footed until their next turn.`,
        longDesc: `By bringing his weapon high and bringing it down with ferocious finality, the disciple's forceful blow is enough to weaken the defenses of his foe momentarily. The initiator makes an attack and if successful, the strike inflicts an additional 1d6 points of damage and may potentially render his foe flat-footed until its next turn on a failed Fortitude save (DC 11 + initiation modifier).`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 1,
        name: `Panthera on the Hunt`,
        type: `Strike`,
        shortDesc: `The martial disciple gains a +2 bonus to hit and damage on a charge attack, and ignores attacks of opportunity`,
        longDesc: `With a deep breath and the tightening of honed muscles, the Primal Fury disciple may launch off into a lightning-fast charge. The initiator initiating this maneuver gains +2 circumstance bonus to attack and damage rolls on his charge attack, and ignores attacks of opportunity from moving through threatened squares.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 1,
        name: `Primal Wrath`,
        type: `Strike`,
        shortDesc: `A forceful strike that adds +4 to damage, or +6 to damage if used with a two-handed weapon.`,
        longDesc: `A wild but powerful strike is better than a frail and accurate one, says the disciple of Primal Fury. By sacrificing accuracy for potency, the disciple achieves his desired result. The initiator inflicts an additional4 points of damage upon a successful attack, or an additional 6 points of damage if the initiator is wielding the weapon in two hands.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 1,
        name: `Running Hunter's Stance`,
        type: `Stance`,
        shortDesc: `While in this stance, the disciple gains the scent special ability and a +10 ft. enhancement bonus to movement speed.`,
        longDesc: `The swiftest hunter catches the prey, and the Primal Fury disciple has trained his body mercilessly to increase his speed and sharpen his senses. While in this stance, the initiator gains a +10 enhancement bonus to his base land speed and gains the scent special ability.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `One creature`,
        duration: `Stance`
      },
      {
        school: `primalFury`,
        level: 1,
        name: `Shoulder Rush`,
        type: `Strike`,
        shortDesc: `Make a bull rush or overrun attempt with a +4 bonus; attempt does not provoke attacks of opportunity.`,
        longDesc: `The disciple of Primal Fury uses his aggression to take opportunities whenever possible, and a solid shoulder into a foe at an opportune moment can tip the scales of war in the disciple's favor. As a standard action, the initiator may make a bull rush or overrun attempt with a +4 circumstance bonus, and this attempt does not provoke attacks of opportunity.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 1,
        name: `Stance of Aggression`,
        type: `Stance`,
        shortDesc: `While in this stance the disciple suffers a -2 penalty to AC and inflicts an additional 1d6 points of damage per eight initiator levels on successful attacks`,
        longDesc: `By focusing his fury on the ending of his foes, the disciple forgoes finesse for devastating power. While in this stance, the initiator suffers a -2 penalty on his AC but any successful attack inflicts an additional 1d6 points of damage. This damage bonus increases by 1d6 every eight initiator levels.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `One creature`,
        duration: `Stance`
      },
      {
        school: `primalFury`,
        level: 2,
        name: `Bloody Riposte`,
        type: `Counter`,
        shortDesc: `Make a counter attack as an immediate action after being struck in melee combat with a +2d6 damage bonus.`,
        longDesc: `Stoking the furnace of rage within him upon receiving injury, the disciple uses the momentary lapse in his attacker's defenses when struck in combat to make a vicious riposte. Upon being struck in combat by an enemy, the initiator may make an immediate counter attack at his full base attack bonus that inflicts an additional 2d6 points of damage.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 2,
        name: `Crippling Strike`,
        type: `Strike`,
        shortDesc: `Melee attack that adds +2d6 points of damage and the enemy gains the bleeding condition.`,
        longDesc: `By specifically targeting a victim's most vulnerable areas, the disciple is capable of rending arterial injuries into his foe. The initiator initiating this maneuver inflicts an additional 2d6 points of damage upon a successful melee attack, and his victim gains the bleeding condition suffering 1d3 points of damage per round until the application of any spell or effect that cures hit point damage or someone staunches the blood with a DC 15 Heal check.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 2,
        name: `Devastating Rush`,
        type: `Strike`,
        shortDesc: `Make an attack that inflicts an additional 2d6 damage and ignores damage reduction and hardness.`,
        longDesc: `The disciple performing this attack executes a powerful attack that rushes in past a foe's defenses to shatter them completely. The initiator inflicts an additional 2d6 points of damage upon a successful attack and his strike ignores the damage reduction of a subject or the hardness of an object he is attacking.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature or object`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 2,
        name: `Momentum Crash`,
        type: `Boost`,
        shortDesc: `Add an additional 10 points of damage to a successful charge attack.`,
        longDesc: `By putting his fury into a charging attack, the disciple is capable of using the momentum of his charge to increase his killing power with a twist of his body upon connecting. Upon a successful charge attack, the initiator's charge attack inflicts an additional 10 points of damage in addition to the normal +2 to hit.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `One attack`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 2,
        name: `Raging Hunter Pounce`,
        type: `Strike`,
        shortDesc: `Charge at a target and make a full attack on the target.`,
        longDesc: `With the ferocity of a raging great cat, the disciple of Primal Fury provides the very real fear that users of this discipline are known to inspire with their reckless assault techniques of offense over all. The initiator makes a charge attack and makes a full attack at the end of the charge against the target creature. He must focus all of these attacks against a single target, and if the target is brought to 0 or fewer hit points, then any remaining attacks are lost as the initiator savages the foe's body with the remaining attacks.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 3,
        name: `Blade-Breaking Counter`,
        type: `Counter`,
        shortDesc: `Make an immediate sunder attempt against an attacker's weapon when they attack.`,
        longDesc: `An opponent cannot hurt you with his weapon if a weapon does not exist to do it. The Primal Fury disciple takes this to heart with a powerful parrying blow designed to shatter the weapon that his opponent uses before it can strike him. When being attacked, this counter is initiated after a successful hit but before damage is inflicted. The initiator then makes an immediate sunder attempt with a +2 circumstance bonus on his foe's weapon (which does not provoke attacks of opportunity), and if the weapon is reduced to half of its hit points, then it gains the broken condition and the disciple takes half damage from the attack. If this sunder attempt reduces the opponent's weapon to 0 hit points, then the weapon shatters and the disciple takes no damage. If the initiator possesses the Greater Sunder feat, excess damage is applied to the target as per normal.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 3,
        name: `Disparity Blow`,
        type: `Strike`,
        shortDesc: `Make a melee attack against a target, if successful inflicts an additional 2d6 damage and make a trip attempt without provoking attacks of opportunity.`,
        longDesc: `With a powerful upswing, the Primal Fury disciple brings his weapon in low and with his attack drives his opponent to the ground as he raises it high to show his superiority. The initiator makes a melee attack and if successful, inflicts an additional 2d6 points of damage and may make an immediate trip attack against the target with a +4 circumstance bonus. This trip attempt does not provoke attacks of opportunity.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 3,
        name: `Frenzy Strike`,
        type: `Strike`,
        shortDesc: `Make a melee attack with all wielded weapons against a single target and inflicts an additional 2d6 damage.`,
        longDesc: `By emulating the ferocious assault of a raging great cat, the disciple's knowledge of the natural world and the way its predators operate assists him in combat with a furious set of attacks. The initiator makes one attack with each weapon he has wielded (or with both heads of a double weapon; this includes natural attacks and armor or shield spikes) at his full base attack bonus. Upon a each successful attack, the initiator inflicts an additional 2d6 points of damage.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 3,
        name: `Primal Warrior Stance`,
        type: `Stance`,
        shortDesc: `The martial disciple and the equipment he is using is considered one size category larger.`,
        longDesc: `By taking a wide stance that invites the death of any before him, the mighty disciple of Primal Fury wields the power of overwhelming force to it's greatest effects. The initiator ignores difficult terrain when charging while in this stance, and whenever he is subject to a size modifier for CMB checks or to his CMD, the disciple is treated as one size category larger if doing so would be advantageous to him. He is also considered to be one size larger when determining whether a creature's special attacks based on size (such as grab or swallow whole) can affect him. Additionally, any melee weapon, unarmed strike, or natural weapon is treated as if it were two sizes larger. The benefits of this stance stack with abilities or effects that increase the initiator's size (such as enlarge person).`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `One creature`,
        duration: `Stance`
      },
      {
        school: `primalFury`,
        level: 4,
        name: `Furious Primal Wrath`,
        type: `Strike`,
        shortDesc: `A vicious strike that suffers a -4 penalty to attack rolls but adds an additional 20 points of damage or an additional 35 points of damage if the weapon is wielded two- handed.`,
        longDesc: `The disciple's attacks grow strong with practiced fury and primal power, forgoing accuracy for pure deadly force. The initiator suffers a -4 penalty to his attack roll, and makes an attack against a target creature. If successful, this attack inflicts an additional 20 points of damage, or 35 if the weapon is wielded in two hands.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 4,
        name: `Impaling Strike`,
        type: `Strike`,
        shortDesc: `Melee attack adds +4d6 damage and ignores damage reduction and hardness and inflicts 1d4 points of Constitution damage.`,
        longDesc: `The disciple who has reached this level of mastery in the art of Primal Fury has learned that by striking to a foe's heart and center with a singular but powerful blow, it causes the foe's ability to withstand punishment to falter. The initiator makes an attack against his target and if successful, inflicts an additional 4d6 points of damage to this attack which ignores damage reduction. The target must make a Fortitude save (DC 14 + primary initiation modifier) or suffer an additional 1d4 points of Constitution damage from being hit in a vital area. Targets immune to critical hits are not subject to this Constitution damage.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 4,
        name: `Momentum Crush`,
        type: `Boost`,
        shortDesc: `Add an additional 20 points of damage on a successful charge attack and the attack ignores the target's damage reduction.`,
        longDesc: `With a powerful overhand flourish at the end of his charge, the disciple is capable of delivering additional force to his already devastating charges. The initiator makes a charge attack against a target foe and if successful, he may spend a swift action to add an addition 20 points of damage to that single attack and ignores the target's damage reduction.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 4,
        name: `Shrug It Off`,
        type: `Counter`,
        shortDesc: `Make an opposed Survival check against a foe's attack roll to negate an attack that inflicts hit point damage.`,
        longDesc: `By relying on his instincts to protect him in the theater of war, the disciple twists and dodges to escape injury in the same manner as an animal can sense danger before it strikes. The initiator makes an opposed Survival check against the attacker's melee or ranged attack roll, including spells or supernatural effects. If the initiator's Survival check equals or exceeds the attack roll, then the attack is negated.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 5,
        name: `Cornered Frenzy Strike`,
        type: `Strike`,
        shortDesc: `Make a melee attack with all wielded weapons against all threatened foes and inflicts an additional 4d6 damage.`,
        longDesc: `As an animal cornered lashes out at all comers, so does the Primal Fury disciple when he finds himself surrounded. By using his intuition and striking where he feels a foe to be, he uses his instincts as a powerful weapon. As a full attack action, the initiator makes an attack roll at full base attack bonus against each target within his reach with each weapon he is currently wielding (including natural attacks; armor and shield spikes always count as wielded weapons), and each successful attack inflicts an additional 4d6 points of damage. After initiating this maneuver, the initiator's focus on offense causes his AC to suffer a -2 penalty until his next turn.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 5,
        name: `Dizzying Blow`,
        type: `Strike`,
        shortDesc: `A powerful charge inflicting an additional 10d6 points of damage and potentially leaves the enemy nauseated.`,
        longDesc: `The disciple of the Primal Fury rockets across the battlefield to unleash a powerful strike to the vitals of his foe, leaving him agonized and sick with pain. The initiator makes a charge attack against a target creature, if successful the attack inflicts an additional 10d6 points of damage and the target must make a Fortitude save (DC 15 + initiation modifier) or be nauseated for 1d4 rounds.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 5,
        name: `Lightning Step`,
        type: `Boost`,
        shortDesc: `Change direction once during a charge and negate the movement penalty for harsh terrain.`,
        longDesc: `Once a great cat has found its prey, the light-footed and graceful cat is capable of nearly ignoring hazards in his path to run it down. The disciple has learned this and is capable of negotiating a battlefield with ease. As a swift action the initiator may make one turn of up to 90 degrees mid-charge and ignore terrain difficulties along his charge path.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 5,
        name: `Meteoric Collision`,
        type: `Strike`,
        shortDesc: `While performing a bull rush as part of a charge with a +4 bonus, the enemy suffers 7d6 points of damage in addition to the effects of the bull rush attempt.`,
        longDesc: `The disciple makes a charge at an opponent within the theater of war with the power and force of a falling meteor, striking hard and bowling his opponent over. The initiator makes a bull rush attempt as part of a charge with a +4 bonus, and if the initiator successfully bull rushes his opponent, the fury of his strike inflicts 7d6 points of damage to his target as he bull rushes him. This bull rush attempt does not provoke attacks of opportunity.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 6,
        name: `Blade of Fury`,
        type: `Boost`,
        shortDesc: `Add twice your initiator level to damage rolls on a charge attack.`,
        longDesc: `The disciple taps into hidden reserves of fury within himself to pour his all into this strike. The initiator expends a swift action to use this boost as part of a charge attack, adding twice his initiator level to the damage roll as a circumstance bonus.`,
        initiationAction: `swift`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 6,
        name: `Charge of the Battle Panthera`,
        type: `Strike`,
        shortDesc: `Charge attack that adds an additional 12d6 to damage and potentially knocked prone.`,
        longDesc: `With a running start that ends in a blood-drenched finish, the disciple mimics the final moments of the hunting great cat as he delivers the death blow to his prey. The initiator makes a charge attack against a target, and if successful he inflicts an additional 12d6 points of damage and the target must make a Reflex save (DC 16 + initiation modifier) or be knocked prone.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 6,
        name: `Shield-Breaking Strike`,
        type: `Strike`,
        shortDesc: `Make a melee attack against a target, and in lieu of damage inflict the broken condition on their armor or shield and subtract 4 from their armor or shield bonus to AC (not to exceed the total armor or shield bonus) until it is repaired.`,
        longDesc: `By removing the protection of his prey, the disciple of Primal Fury shreds leather and metal equally as a great cat's claws would tear animal hide. The initiator makes an attack against a foe and if successful, inflicts damage as normal to the target and inflicts the broken condition on a target piece or suit armor or shield and imposes a -4 penalty to their armor or shield bonus (not to exceed the total armor or shield bonus) until the item is repaired. If the item is magical, this maneuver is resolved as a normal sunder attempt as a free action as part of the strike (which does not provoke attacks of opportunity) and the initiator gains a +2 bonus to his CMB check for this attempt.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 6,
        name: `Skirmisher's Stance`,
        type: `Stance`,
        shortDesc: `While in this stance, if the character moves 10-ft. or more in a round, he inflicts an additional 2d6 points of damage and gains a +2 dodge bonus to his AC.`,
        longDesc: `By adopting a hit-and-run attitude, the disciple of Primal Fury disciple moves swiftly and strikes with deadly force. While in this stance, if the initiator moves 10-ft. or more on his turn, attacks made by him inflict an additional 2d6 points of damage and he gains a +2 dodge bonus to his Armor Class.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `primalFury`,
        level: 7,
        name: `Blood-Spray Strike`,
        type: `Strike`,
        shortDesc: `Melee attack adds 8d6 damage and inflicts 2d4 points of Constitution damage.`,
        longDesc: `The Primal Fury disciple makes a chest-ruining arterial strike on his foe, causing the enemy to suffer grievous amounts of injury. The initiator makes an attack against a target foe and if successful, inflicts an additional 8d6 points of damage and inflicts 2d4 points of Constitution damage due to striking vital areas and organs. If the target is immune to critical hits, the target does not suffer this Constitution damage.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 7,
        name: `Devastating Momentum`,
        type: `Boost`,
        shortDesc: `Add an additional 40 points of damage on a successful charge attack and the attack ignores the target's damage reduction and potentially stuns the target.`,
        longDesc: `The charging Primal Fury disciple throws his full weight and momentum behind a blow, showing all who see it who the most powerful combatant on the field of battle truly is. Upon making a successful charge attack, the initiator may add an additional 40 points of damage to the attack as a swift action, and this attack ignores the target's damage reduction. Additionally, the target must make a successful Fortitude save (DC 17 + initiation modifier) to resist being stunned for 1 round (this effect does not stack with a maneuver that also has the potential to daze or stun an opponent; the initiator must choose which effect to use).`,
        initiationAction: `swift`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 7,
        name: `Primal Frenzy`,
        type: `Strike`,
        shortDesc: `Make a melee attack with all wielded weapons against all threatened foes and inflicts an additional 6d6 damage.`,
        longDesc: `The disciple becomes a whirling dervish of hellish weapon blows as he descends into a blood-drenched frenzy of strikes against his surrounding foes, relying on his killer instincts to see him through the fight. As a full attack action, the initiator makes an attack roll at full base attack bonus against each target within his reach with each weapon he is currently wielding (including natural attacks and armor or shield spikes), and each successful attack inflicts an additional 6d6 points of damage. After initiating this maneuver, the initiator's focus on offense causes his AC to suffer a -2 penalty until his next turn.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 8,
        name: `Iron Hide Stance`,
        type: `Stance`,
        shortDesc: `While in this stance, double the disciple's Strength bonus to damage and gain DR 5/-; disciple is treated as Large size for some effects.`,
        longDesc: `Standing strong in the theater of war, the Primal Fury master stands as a pillar of blood-soaked iron amidst the bodies of those too weak to live in his presence. While in this stance, the initiator gains a damage reduction of 5/-, and the initiator's Strength bonus to damage is doubled (or tripled if wielding a weapon with two hands). Additionally, the initiator is treated as one size category larger (so if the initiator is Medium-sized, then he counts as Large-sized) when it benefits his CMB and CMD (such as resisting trip attacks or overrun attempts).`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `primalFury`,
        level: 8,
        name: `Meteoric Crash`,
        type: `Strike`,
        shortDesc: `While performing a bull rush as part of a charge with a +4 bonus, inflicting an additional 10d6 points of damage in addition to the bull rush attempt; if the foe is bull rushed more than 10-ft. then he may be knocked prone, and he may make attack of opportunity against his prone foe.`,
        longDesc: `By rushing at a foe like a blazing comet through the sky, the Primal Fury disciple crashes through an opponent to sculpt the battlefield into a field of carnage. The initiator makes a bull rush attempt as part of a charge with a +4 bonus (this bonus stacks with the +2 bonus from making a charge); if successful, the initiator inflicts 10d6 points of damage to the target as part of the bull rush and if the target is pushed back more than 10-ft., they are knocked prone on a failed Reflex save (DC 18 + initiation modifier) and he may make an immediate attack of opportunity against his prone foe. In initiator must be able to follow or reach the target to make this attack of opportunity.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 8,
        name: `Unbreakable Panthera Guard`,
        type: `Counter`,
        shortDesc: `Make an opposed Survival check against a foe's attack roll to negate an attack that inflicts hit point damage and gain temporary hit points equal to twice the disciple's initiator level.`,
        longDesc: `In the flow of battle, a master of the Primal Fury discipline finds nothing more invigorating than a near miss that was avoided through sheer instinct. The initiator makes an opposed Survival check against an opponent's attack roll which if successful the initiator negates the attack and gains a number of temporary hit points equal to twice the disciple's initiator level for one minute.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `primalFury`,
        level: 9,
        name: `Wrath of the Primal Hunter`,
        type: `Strike`,
        shortDesc: `Make a charge attack against a target without provoking attacks of opportunity and at the end of the charge the disciple makes a full attack with deadly force.`,
        longDesc: `The true master of Primal Fury art is the disciple who brings the full ferocity of this discipline against a foe with a titanic charge that ends with ringing iron and spraying blood as his weapons do their deadly work. The initiator performs a charge attack against his foe, and makes a full attack at the end of this charge attempt. Each successful attack ignores damage reduction and the initiator may add an additional 4d6 points of damage to each attack's damage roll.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `radiantDawn`,
        level: 1,
        name: `Bolster`,
        type: `Counter`,
        shortDesc: `Ally gains DR for one round.`,
        longDesc: `You fortify an ally with akasha, hardening their skin like the scales of a dragon. You can initiate this counter in response to a melee or ranged attack hitting an ally within close range (25 feet + 5 feet per 2 initiator levels). That ally gains DR/– equal to your initiation modifier for 1 round. \n\nEssence: For each point of essence invested into this counter, the damage reduction granted increases by 1.`,
        initiationAction: `immediate`,
        range: `Close (25 ft. + 5 ft./2 levels)`,
        target: `One ally`,
        duration: `Instantaneous`
      },
      {
        school: `radiantDawn`,
        level: 1,
        name: `Decree of Mercy`,
        type: `Counter`,
        shortDesc: `Cause an attack to become nonlethal.`,
        longDesc: `A simple look and gesture can weaken one's resolve to kill. You can initiate this counter in response to a creature making any action within close range (25 feet + 5 feet per 2 initiator levels). The next time the target uses an eﬀect which deals hit point damage, the damage is nonlethal. If the effect targets or includes a creature that is immune to nonlethal, the effect instead deals half damage to that creature. \n\nEssence: Each point of essence invested into this counter causes another instance of damage from your target to deal nonlethal damage.  `,
        initiationAction: `immediate`,
        range: `Close (25 ft. + 5 ft./2 levels)`,
        target: `One creature  `,
        duration: `1 round or until discharged`
      },
      {
        school: `radiantDawn`,
        level: 1,
        name: `Dismiss`,
        type: `Strike`,
        shortDesc: `An attack that knocks down and knocks back a foe.`,
        longDesc: `This attack ‘softly' removes an enemy from your presence. Make an attack. If it hits, you deal damage as normal, and you can make a trip attempt against the target. If your trip attempt succeeds, the target is also pushed away as if you had successfully bull rushed them, using the same result as your trip attempt. You may not move with the target with this bull rush. Neither the trip attempt nor the target's movement during the bull rush provoke attacks of opportunity. When determining your combat maneuver bonus for this strike, you may use your initiator level in place of your base attack bonus, and may choose to use your Dexterity or initiation modifier in place of your Strength modifer. \n\nEssence: For each point of essence invested into this strike, you gain a cumulative +2 bonus to this maneuver's trip attempt.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `radiantDawn`,
        level: 1,
        name: `Spoils of War`,
        type: `Stance`,
        shortDesc: `Heals your allies when they attack your enemies.`,
        longDesc: `Might makes right. While you maintain this stance, allies within close range (25 feet + 5 feet per 2 initiator levels) heal 3 hit points whenever they hit with an attack. At 5th level, this healing increases to your initiation modifier plus 3. At 10th level, this healing increases to be equal to twice your initiation modifier plus 3. This eﬀect can only trigger once per round per ally. \n\nEssence: Each point of essence invested into this stance increases the amount of healing done by this stance by 1. At 5th level, each point of essence instead increases healing done by 2. At 10th level, each point of essence instead increases healing done by 3.  `,
        initiationAction: `swift`,
        range: `Personal (see text)`,
        target: `You (see text)`,
        duration: `Stance`
      },
      {
        school: `radiantDawn`,
        level: 1,
        name: `Staunching Strike`,
        type: `Strike`,
        shortDesc: `A strike that draws from an enemy's akasha to heal another.`,
        longDesc: `To help your allies and harm your enemies is the most basic tenet of the Radiant Dawn discipline. Make an attack. If it hits, it deals weapon damage as normal, and you can heal yourself and allies within close range (25 feet + 5 feet per 2 initiator levels) for a total number of hit points equal to your initiation modifier, divided as you choose between you and your allies. \n\nEssence: Each point of essence invested into this strike increases the total amount of healing done by 3 hit points. This healing is split up between targets normally.  `,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `radiantDawn`,
        level: 1,
        name: `The Caged Sun`,
        type: `Stance`,
        shortDesc: `Turn your healing inwards to become a formidable warrior.`,
        longDesc: `If you have 50% or fewer hit points, entering this stance can be done as a free action instead of a swift. While you maintain this stance, you cannot heal creatures other than yourself, but any healing you receive is increased by 50%. If you would be healed for more than your maximum amount of hit points, you instead gain an amount of temporary hit points equal to the excess healing. These temporary hit points stack with other temporary hit points granted by you, up to a maximum of your maximum hit points, and last for one minute, until initiative is rolled, or you abandon this stance. \n\nEssence: Each point of essence invested into this stance increases the amount of healing you receive by 2 (before being modified by the stance's eﬀects). Each point of essence also increases your attack, AC, and saves by 1.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `radiantDawn`,
        level: 2,
        name: `Curate's Strike`,
        type: `Strike`,
        shortDesc: `An akashic arrow that causes the target to leak essence, healing allies.`,
        longDesc: `This strike was created by a kobold leader to fight both controlling magics and vicious wounds. Make an attack. If it hits, it deals weapon damage as normal, and you can heal yourself and allies within close range (25 feet + 5 feet per 2 initiator levels) for a total number of hit points equal to twice your initiation modifier, divided as you choose between you and your allies. Alternatively, you may choose to grant a single ally within close range a saving throw against an ongoing effect on them that offers multiple saving throws over time to negate, or has its duration measured in rounds at the effect's original DC, at the effect's original DC. If it succeeds, the effect ends. This does not progress poison, diseases, or similar effects on a failed saving throw.
    
            \nEssence: Each point of essence invested into this strike increases the total amount of healing done by 4 hit points. This healing is split up between targets normally.`,
        initiationAction: `standard`,
        range: `Melee attack or ranged attacks`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `radiantDawn`,
        level: 2,
        name: `Decree of Torment`,
        type: `Strike`,
        shortDesc: `Unbalance an enemy to set them up for failure.`,
        longDesc: `You strike with an akashic brand that imbalances a creature. Make an attack. If it hits, it deals weapon damage as normal and the target becomes branded with a number of akashic brands equal to your initiation modifier. These brands last for one minute or until otherwise consumed. When a creature attacks another creature that has been branded this way, they may remove one of the brands as a part of the attack to attempt a combat maneuver of their choice against the branded creature. Ranged attackers may not choose to grapple or move with the target if the combat maneuver would normally allow it (such as if using a bull rush), but may otherwise freely select combat maneuvers. When determining their combat maneuver bonus for this strike, creatures may use your initiator level in place of their base attack bonus, and may choose to use your initiation modifier in place of their Strength modifier. Each creature may remove only one brand per round. These combat maneuvers do not provoke an attack of opportunity. \n\nEssence: Each point of essence invested into this strike lowers the branded creature's CMD by 1 for a number of rounds equal to your initiation modifier.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `radiantDawn`,
        level: 2,
        name: `Expose Weakness`,
        type: `Boost`,
        shortDesc: `A quick blow that exposes an enemy's weakpoint.`,
        longDesc: `You strike with a weak, but swift, attack that hampers an opponent. Make an attack. If it hits, it deals no damage, and the target becomes flat-footed for 1 round. \n\nEssence: Each point of essence invested into this boost also lower the target's AC by 2 on a successful hit. This lasts for one round.`,
        initiationAction: `swift`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `1 round`
      },
      {
        school: `radiantDawn`,
        level: 2,
        name: `Healer's Bane`,
        type: `Counter`,
        shortDesc: `Made to combat other practitioners of the Radiant Dawn discipline, this maneuver hijacks healing for one's own purpose. You may initiate this counter in response to a target within range healing hit point damage. The target must make a will save (DC 12 + initiation modifier) or have their healing stolen. Instead of the target (and any other creatures affected by that instance of the effect) being healed, you draw the total amount of healing done into a pool, and may redistribute this pool of healing to allies within close range (25 feet + 5 feet per 2 initiator levels), divided as you choose between you and your allies. Targets that would have been healed by the healing then take damage equal to half of the healing stolen.
 \n\nEssence: Each point of essence invested into this counter increases the DC by 2, and the healing and damage done by your initiation modifier.`,
        longDesc: `Made to combat other practitioners of the Radiant Dawn discipline, this maneuver hijacks healing for one's own purpose. You may initiate this counter in response to a target within range healing hit point damage. The target must make a will save (DC 12 + initiation modifier) or have their healing stolen. Instead of the target (and any other creatures affected by that instance of the effect) being healed, you draw the total amount of healing done into a pool, and may redistribute this pool of healing to allies within close range (25 feet + 5 feet per 2 initiator levels), divided as you choose between you and your allies. Targets that would have been healed by the healing then take damage equal to half of the healing stolen.
   \n\nEssence: Each point of essence invested into this counter increases the DC by 2, and the healing and damage done by your initiation modifier.`,
        initiationAction: `immediate`,
        range: `Close (25 ft. + 5 ft./2 levels)`,
        target: `One Creature`,
        duration: `Instant`
      },
      {
        school: `radiantDawn`,
        level: 2,
        name: `Witness to Glory`,
        type: `Counter`,
        shortDesc: `Grant a bonus to initiative and temporary HP.`,
        longDesc: `With a surge of akasha, you spur an ally into battle. You may activate this counter when initiative is rolled, after the results are revealed, even if you are ﬂat-footed. One ally within range gains a bonus on their initiative check equal to your initiation modifier, and also gains a number of temporary hit points equal to your initiator level. These temporary hit points last for 1 minute per initiator level or until used. \n\nEssence: Each point of essence invested into this counter increases the bonus to initiative by 1 and the temporary hit points granted by 2.`,
        initiationAction: `immediate`,
        range: `Close (25 ft. + 5 ft./2 levels)`,
        target: `One ally`,
        duration: `Instantaneous`
      },
      {
        school: `radiantDawn`,
        level: 3,
        name: `Armaments of the Empire`,
        type: `Stance`,
        shortDesc: `Improve you and your allies weapons with a veil of akasha.`,
        longDesc: `A thin layer of akasha ﬂows forth from you and covers your and your allies' weapons. While you maintain this stance, you empower a number of weapons (including natural weapons) within close range (25 feet + 5 feet per 2 initiator levels) up to your initiation modifier. Each empowered weapon gains the benefit of a weapon special ability with a market price of “+1 bonus”. This ability must be chosen from the list of weapon special abilities you could normally place on a mind blade (See https://www.d20pfsrd.com/alternative-rule-systems/psionics-unleashed/classes/soulknife/ ). At initiator 10th and every five levels thereafter, the market price of the weapon special ability you can grant a weapon increases (to “+2 bonus”, then “+3 bonus”, and so on). A weapon can only gain a single ability through this stance, though you need not grant the same ability to each aﬀected weapon. A weapon retains its new ability for as long as it remains within close range. You choose which weapons are empowered when you enter this stance, and you can change which weapons within range are empowered as a swift action or as part of reallocating essence. \n\nEssence: For each point of essence invested into this stance, creatures wielding weapons you have empowered gain a cumulative +1 bonus to their CMD.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `radiantDawn`,
        level: 3,
        name: `Decree of Death`,
        type: `Boost`,
        shortDesc: `An opponent becomes vulnerable to one attack.`,
        longDesc: `You single out a single target for execution. Make an attack. If it hits, the attack deals no damage. The next damaging attack made against the target by the initiator or her allies within 1 round deals 50% additional damage, applied after all other eﬀects (such as damage reduction and energy resistance). \n\nEssence: The first attack made against the target within 1 round deals an additional 2 points of damage for each point of essence invested into this boost. This damage is eligible to be increased by the eﬀect of the boost.  `,
        initiationAction: `swift`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `1 round`
      },
      {
        school: `radiantDawn`,
        level: 3,
        name: `Disrupt Essence`,
        type: `Strike`,
        shortDesc: `A strike that inhibits the use of abilities.`,
        longDesc: `A powerful blow that disrupts one's essence, inhibiting the use of abilities. Make an attack. If it hits, the target must make a Will save (DC 10 + ½ your initiation level + your initiation modifier) or have a single Extraordinary (Ex) or supernatural (Su) ability that requires an action to activate, special sense, or special movement type of your choice disabled for rounds equal to your initiation modifier. You must be aware of the ability in order to disable it (Such as a successful knowledge check, or having seen it in action). \n\nEssence: Each point of essence invested into this strike increases the DC by 1 and the number of rounds an ability is disabled by 1. At two essence, and every two essence thereafter, you may choose an additional ability to disable.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack.`,
        target: `One creature`,
        duration: `Instantaneous; see text`
      },
      {
        school: `radiantDawn`,
        level: 3,
        name: `Lifeburst Strike`,
        type: `Strike`,
        shortDesc: `A strike that causes one's essence to flair, healing all within range.`,
        longDesc: `You strike out with a simple blow with an uncanny power to heal and harm. Make an attack. If it hits, it deals weapon damage as normal plus an additional 1d6 points of damage, and you can heal yourself and allies within close range (25 feet + 5 feet per 2 initiator levels) for a total number of hit points equal to three times your initiation modifier, divided as you choose between you and your allies. Alternatively, you may choose to grant a single ally within close range a saving throw against an ongoing eﬀect on them that oﬀers a saving throw to negate, at the eﬀect's original DC. If it succeeds, the eﬀect ends. This does not progress poison, diseases, or similar eﬀects on a failed saving throw. \n\nEssence: Each point of essence invested into this strike increases the total amount of healing done by 5 hit points. This healing is split up between targets normally.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `radiantDawn`,
        level: 4,
        name: `Decree of Silence`,
        type: `Counter`,
        shortDesc: `Force a caster to make a concentration check as if they had taken damage.`,
        longDesc: `Your presence demands silence. Only those who you allow to speak may do so. You may initiate this counter in response to a creature within close range (25 feet + 5 feet per 2 initiator levels) manifesting a power, casting a spell, or using a spell-like or psi-like ability. Roll damage as if you'd made a successful attack with a weapon you're wielding; you don't deal this damage, but the target of this counter must succeed at a concentration check (DC 10 + damage that would be dealt by this attack + the level of the spell being cast or power being manifested) or lose the power, psi-like ability, spell, or spell-like ability as if it had been disrupted. \n\nEssence: Each point of essence invested into this counter increases the DC of the concentration check by 1.  `,
        initiationAction: `immediate`,
        range: `Close (25 ft. + 5 ft./2 levels)`,
        target: `One casting or manifesting creature within range`,
        duration: `Instantaneous`
      },
      {
        school: `radiantDawn`,
        level: 4,
        name: `Lifeburst Imbuement`,
        type: `Boost`,
        shortDesc: `Your or your allies attack causes healing in an area.`,
        longDesc: `This maneuver imbues another to carry out your will. The target's next attack that hits also deals an additional 2d6 points of damage. When this attack hits, you can also heal yourself and allies within close range (25 feet + 5 feet per 2 initiator levels) for a total number of hit points equal to four times your initiation modifier, divided as you choose between you and your allies. \n\nEssence: Each point of essence invested into this boost increases the total amount of healing done by 6 hit points. This healing is split up between targets normally.  `,
        initiationAction: `swift`,
        range: `Close (25 ft. + 5 ft./2 levels)`,
        target: `One ally`,
        duration: `1 round`
      },
      {
        school: `radiantDawn`,
        level: 4,
        name: `Shatter Spell`,
        type: `Strike`,
        shortDesc: `A strike with a veil of akasha that disrupts magic in place.`,
        longDesc: `A maneuver whose origins did not come from the disciples of the Radiant Dawn, but was quickly adopted and adapted to deal with spellcasters on the battlefield. Make an attack or touch a willing target. If the attack hits, it deals weapon damage as normal plus an additional 2d6 points of damage (A willing target does not take damage from this strike). Either way, the target is aﬀected by a targeted dispel magic as if you had cast it, using your initiator level as your caster level. This strike can also dispel curses as if using remove curse. \n\nEssence: Each point of essence invested into this strike increases the result of the caster level check by 2.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `radiantDawn`,
        level: 4,
        name: `Sunstroke`,
        type: `Boost`,
        shortDesc: `Yours or an ally's attack becomes a powerful beam of light.`,
        longDesc: `Your akasha shapes an attack into a powerful solar flare. Choose one ally within range. The next melee or ranged weapon attack made by that ally can be made at any target within long range (400 feet + 40 feet per initiator level) of that ally. When this maneuver is initiated, the initiator may choose to treat the amount of essence invested in this maneuver as any amount of essence equal to or less than the amount of essence invested in this maneuver (minimum 0) for determining the effects of its essence augmentation. \n\nEssence: Each point of essence invested into this boost increases the minimum area of the chosen ally's attack - while at least one point of essence is invested, the attack becomes a burst with a radius of 5 feet per point of essence invested. A single attack roll is made for the attack, and compared against all creatures within the burst, and any damage the attack does is halved. If the attack allows for a save, creatures caught within the burst may roll twice and take the better result.`,
        initiationAction: `swift`,
        range: `Close (25 ft. + 5 ft./2 levels) `,
        target: `One ally `,
        duration: `1 round or until discharged`
      },
      {
        school: `radiantDawn`,
        level: 5,
        name: `Decree of Purity`,
        type: `Boost`,
        shortDesc: `Immediately end an effect affecting you or an ally.`,
        longDesc: `A single word and a wave of the hand purifies those who would stand with you. When you initiate this maneuver, you may choose to grant a single ally within close range (25 feet + 5 feet per 2 initiator levels) a saving throw against an ongoing effect on them that offers multiple saving throws over time to negate, or has its duration measured in rounds at the effect's original DC. They gain a bonus on this saving throw equal to your initiation modifier (minimum 2). If it succeeds, the effect ends. This does not progress poison, diseases, or similar effects on a failed saving throw. In addition, you may heal yourself and allies within close range for a total number of hit points equal to five times your initiation modifier, divided as you choose between you and your allies. \n\nEssence: Each point of essence invested into this boost increases the total amount of healing done by 7 hit points. This healing is split up between targets normally.`,
        initiationAction: `swift`,
        range: `Close (25 ft. + 5 ft./2 levels)`,
        target: `One ally`,
        duration: `Instantaneous`
      },
      {
        school: `radiantDawn`,
        level: 5,
        name: `Divide and Conquer`,
        type: `Strike`,
        shortDesc: `A blow that divides the enemy across the battlefield.`,
        longDesc: `This strike pulls essence from the target, creating an effigy of the creature. When the essence returns to its creature, it brings its wounds with it. Make an attack. If it hits, it deals an additional 3d6 points of damage, and the target must make a Will save (DC 15 + initiation modifier) or have its essence drawn into one effigy until the end of your next turn. This translucent effigy appears within close range (25 feet plus 5 feet per 2 levels) of you. The effigy is the size of the target of this maneuver, but otherwise does not block movement or occupy spaces, and may be targeted by attacks, spells, or other abilities. Any attack, spell, or other ability used against the effigy (or including it in its aﬀected area) is redirected against the target of this maneuver as if they were the original target regardless of range, and the target may defend themselves normally against these attacks. \n\nEssence: Each point of essence invested into this strike increase amount of effigies created by 1 and the save DC of the strike by 1.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous; see text`
      },
      {
        school: `radiantDawn`,
        level: 5,
        name: `Noblesse Oblige`,
        type: `Counter`,
        shortDesc: `Save an ally from certain death.`,
        longDesc: `Discipline: Radiant Dawn; When all else fails, your allies turn to you to save them. Whenever an ally within close range would die or be destroyed, you may initiate this maneuver, even if it is not your turn. That ally's hit points becomes 1. Then, you may make a melee or ranged attack against an enemy. If it hits, it deals an additional 3d6 points of damage and you also heal the ally subject to this maneuver by an amount equal to the damage dealt by this attack. A creature may only benefit from this maneuver once, and must experience sunrise (or wait 24 hours, whichever comes first) before they can gain its benefit again. \n\nEssence: The ally is also healed for 7 hit points per point of essence invested into this maneuver after the attack is made.`,
        initiationAction: `free`,
        range: `Close (25 ft. + 5 ft./2 levels)`,
        target: `One ally (except the initiator)`,
        duration: `Instantaneous`
      },
      {
        school: `radiantDawn`,
        level: 5,
        name: `Stance of the Sunlight Shield`,
        type: `Stance`,
        shortDesc: `Create akashic shields to defend allies.`,
        longDesc: `This stance sits halfway between martial form and magic prowess, conjuring shields of light to defend yourself and others. While you maintain this stance, you may create sunlight shields. Creating a single sunlight shield is done as free action that can be done once per round, and is done automatically when you enter this stance. A sunlight shield can be created anywhere within close range (25 feet plus 5 feet per 2 levels) of you (to include in the air, where they ﬂoat until destroyed, dismissed, or removed). Treat a sunlight shield as a 10ft by 10ft by 1 inch thick wall of force, but with hardness equal to your initiator level plus your initiation modifier, and 1 hit point. They may be made smaller at the initiator's discretion. You may have a number of sunlight shields equal to your initiation modifier, and these shields last indefinitely, or until they are no longer within close range of you, you dismiss them as a free action, or you leave this stance. These sunlight shields can be made at any angle, and are treated as normal terrain when stepped on. You may command these shields to ﬂy an amount of feet equal to your movement speed as a move action.You may also create a sunlight shield as an immediate action, but doing so is dangerous as the hasty construction leaves your essence tied to it. Until the start of your next turn, any damage that the shield takes (before hardness is taken into account), or any spell that would fail because of the shield's sudden appearance between its caster and its target is also inﬂicted on you, regardless of distance. Creatures can attack other creatures on the other side of these shields, dealing damage to the shield first. If an attack would break the shield, the remainder of the damage is dealt to the creature if the original attack would have hit. When you enter this stance, you may designate any number of allies. These allies' attacks and abilities are not impeded by your sunlight shields. \n\nEssence: Each point of essence invested into this stance increases the hardness of the sunlight shields by 3, the number of sunlight shields you create when entering this stance by 1, and the number of sunlight shields you can possess at one time by 2.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `radiantDawn`,
        level: 6,
        name: `Battle Against the Sun`,
        type: `Stance`,
        shortDesc: `Become like the sun and strike down foes with solar flares.`,
        longDesc: `To challenge you is to challenge the sun itself: An exercise in futility. While you maintain this stance, you shed bright light, as if by a daylight spell, out to close range (25 feet + 5 feet per 2 levels). Once per round, as a free action that can be taken at any time (including when it is not your turn), you may create a line with a length of 20 feet that originates anywhere within this light. Unlike normal line attacks, this line attack does not need to fire away from you; it may travel in any direction so long as the origin point is within your daylight range. Enemies within the area take damage equal to your initiator level. A successful Reflex save (DC 16 + initiation modifier) halves this damage. Allies caught within the line are instead healed for a number of hit points equal to your initiator level. \n\nEssence: Each point of essence invested in this stance allows you to aﬀect one additional target adjacent to the line and increases the DC of the Reﬂex save by 1.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `radiantDawn`,
        level: 6,
        name: `Decree of Freedom`,
        type: `Boost`,
        shortDesc: `Allow you or an ally to move unhindered for 1 round.`,
        longDesc: `With a gesture and a single word, you cause a target's essence to ﬂare, freeing them from their bonds. The target of this boost can move and attack normally for the duration of the boost, even under the inﬂuence of magic that usually impedes movement, such as paralysis, solid fog, slow, and web. The maneuver also allows the subject to move and attack normally while underwater, even with slashing weapons such as axes and swords or with bludgeoning weapons such as ﬂails, hammers, and maces, provided that the weapon is wielded in the hand rather than thrown. \n\nEssence: Each essence invested into this boost increases the duration by 1 round.`,
        initiationAction: `swift`,
        range: `Close (25 ft. + 5 ft./2 levels)`,
        target: `You or one ally within close range`,
        duration: `1 round`
      },
      {
        school: `radiantDawn`,
        level: 6,
        name: `Karmic Strike`,
        type: `Strike`,
        shortDesc: `Heal allies and mark an enemy for retribution.`,
        longDesc: `This blow marks an enemy with a simple brand that burrows into their essence. As they do harm, the brand sees to it that they are harmed as well. Make an attack. If it hits, it deals an extra 4d6 points of damage, you may heal yourself and allies within close range (25 feet + 5 feet per 2 initiator levels) for a total number of hit points equal to six times your initiation modifier, divided as you choose between you and your allies.The target must also make a Will save (DC 16 + Initiation modifier) or have a brand placed upon them for one minute. Whenever the target would deal damage, as a free action that can be done on any turn, the creature that took damage may remove the brand, and only take half of the damage that they would have taken from the attack. The branded creature then takes half of the damage mitigated this way. \n\nEssence: Each point of essence invested in this maneuver increases the healing done by 8 points and the number of brands placed on the creature after a failed will save by 1.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous; see text`
      },
      {
        school: `radiantDawn`,
        level: 6,
        name: `King's Castle`,
        type: `Counter`,
        shortDesc: `Instantly draw an ally to your side to absorb a hit and retaliate.`,
        longDesc: `Your faithful respond to your call for help. You may initiate this counter in response to you or an ally within range being attacked. One willing ally teleports to a space adjacent to the target of the counter and gains temporary hit points equal to your initiator level, as well as DR/– equal to your initiation modifier, both of which last for 1 round. Resolve the attack against the teleported ally instead of the target of the counter. After the attack is resolved, the ally teleported may make a single melee or ranged attack at their highest base attack bonus against the attacking creature. This attack does not provoke attacks of opportunity. \n\nEssence: Each point of essence invested into this maneuver increases the temporary hit points granted by this maneuver by 6, the damage reduction by 1, and the damage made by the teleporting ally's next attack by 1d6.`,
        initiationAction: `immediate`,
        range: `Close range (25 ft. + 5 ft./2 levels)`,
        target: `Two allies`,
        duration: `Instant`
      },
      {
        school: `radiantDawn`,
        level: 6,
        name: `Path of the Sun`,
        type: `Strike`,
        shortDesc: `Fire off a beam of sunlight, then allow allies to traverse the area instantly.`,
        longDesc: `Coalesce the power of the sun into a powerful beam that washes over enemies and allies alike, leaving behind thousands of motes of light. Allies of the initiator may traverse these motes as if they were light themselves. When you initiate this maneuver, you create a close range (25 feet + 5 feet per 2 levels) foot line of light. Enemies caught within this line take damage equal to your initiator level plus your initiation modifier, and must make a Reﬂex save (DC 16 + initiation modifier) or be Blinded for rounds equal to your half your initiation modifier. This line persists as a field of golden motes for rounds equal to your initiation modifier. Enemies who enter the line or start their turn within the area take damage and must make a save as if they were struck by this maneuver. Allies do not provoke attack of opportunities when entering or moving through these squares, and can enter or move through these squares as free actions on their turn. Treat creatures within these squares as being exposed to direct sunlight. \n\nEssence: Each point invested increases the DC and duration of this maneuver by 1.`,
        initiationAction: `standard`,
        range: `Close range foot line`,
        target: `One or more creatures`,
        duration: `Instantaneous; see text`
      },
      {
        school: `radiantDawn`,
        level: 7,
        name: `Awaken the Sleeper`,
        type: `Boost`,
        shortDesc: `Embolden an ally for a brief moment.`,
        longDesc: `It's said that the soul of a mortal contains power that can rival the gods, and this maneuver awakens a fraction of that power for a brief moment. When you initiate this maneuver, choose one ally within close range other than yourself. That ally gains a maneuver known by you of 6th or lower level, readied and unexpended for the duration of this maneuver. An ally may choose to use your initiation modifier and initiator level in place of their own (if any) for this granted maneuvers. Additionally, the ally may may roll twice for any attack, saving throw, damage roll, or any skill check made as part of a maneuver they make during that round. Finally, that ally also gains temporary hit points equal to half of their maximum hit points. These temporary hit points last for 1 round. \n\nEssence: Each point of essence invested into this maneuver increases the target's movement speeds by 15 feet.`,
        initiationAction: `swift`,
        range: `Close (25 ft. + 5 ft./2 levels)`,
        target: `One ally`,
        duration: `1 round; see text`
      },
      {
        school: `radiantDawn`,
        level: 7,
        name: `Harsh Light of Day`,
        type: `Strike`,
        shortDesc: `A strike that reveals an enemy's true form.`,
        longDesc: `This attack brings with it a blast of light, forcing enemies to reveal their true selves. Make an attack. This attack ignores miss chance (such as granted by concealment, or spells) and attempts at redirection (Such as Mirror Image), and if it hits, you deal weapon damage as normal plus an additional 5d6 points of damage. The target must then make a Will save (DC 17 + Initiation modifier) or have all illusions and polymorph eﬀects you choose dispelled from them. Additionally, if they fail this will save, the target loses the ability to benefit from miss chance for rounds equal to your initiation modifier. You may attack an empty space with this maneuver. If you do so, the attack automatically veers towards the nearest enemy to the targeted space within 10ft of it, even enemies that you are unaware of or cannot see, and aﬀects them as if they were the original target of this maneuver, even if they are out of range of the original attack. Creatures you are completely unaware of count as enemies if their attitude to you is unfriendly or worse, or if they have used a harmful ability on you or your allies within the last minute. \n\nEssence: Each point of essence invested in this veil in creases the save DC and the duration of this maneuver by 1, and increase the seeking radius of an attack aimed at an empty square by 5 feet.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature; see text`,
        duration: `Instantaneous; see text`
      },
      {
        school: `radiantDawn`,
        level: 7,
        name: `Push the Advantage`,
        type: `Counter`,
        shortDesc: `An ally gains a standard action and heals after defeating a foe.`,
        longDesc: `With the enemy defeated, you spurn an ally towards further glory. You may initiate this counter when you or an ally defeats an enemy. That ally may immediately take a standard action, and you may also heal yourself and allies within close range (25 feet + 5 feet per 2 initiator levels) for a total number of hit points equal to seven times your initiation modifier, divided as you choose between you and your allies. \n\nEssence: Each point of essence invested into this counter increases the total amount of healing done by 9 hit points, and while essence is invested into this counter, the target gains the option to move up to 5 feet per point of essence invested after this maneuver is initiated, provoking attacks of opportunity as normal. This healing is split up between targets normally`,
        initiationAction: `immediate`,
        range: `Close (25 ft. + 5 ft./2 levels)`,
        target: `One ally`,
        duration: `Instantaneous`
      },
      {
        school: `radiantDawn`,
        level: 8,
        name: `Decree of Vengeance`,
        type: `Counter`,
        shortDesc: `You or an ally may initiate a strike against a target who has attacked you, healing in the process.`,
        longDesc: `You and your allies rise in revenge against your assailants. You may initiate this counter after an attack is resolved against you or an ally within close range. You or another ally threatening the attacker (or with the attacker within the first range increment of a ready ranged weapon) may perform an attack action to make a single attack or initiate a strike with an initiation action of 1 standard action against that attacker. Your ally may use your Sun's Gleam ability in place of this attack, using your abilities in place of their own score modifiers if they so wish. You also heal yourself and allies within close range (25 feet + 5 feet per 2 initiator levels) for a total number of hit points equal to eight times your initiation modifier, divided as you choose between you and your allies. \nEssence: Each point of essence invested into this counter increases the total amount of healing done by 10 hit points, and allows another ally within range to perform an attack action or initiate a standard-action strike against the attacker. This healing is split up between targets normally.`,
        initiationAction: `immediate`,
        range: `Close (25 ft. + 5 ft./2 levels)`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `radiantDawn`,
        level: 8,
        name: `Sun's Zenith`,
        type: `Stance`,
        shortDesc: ``,
        longDesc: `You mimic the eternal dance of the sun across the sky with this stance. When you assume this stance, any essence you currently have invested in maneuvers becomes uninvested (reducing their totals to 0). Essence bound into an expended maneuver remains invested until that maneuver is recovered. While you maintain this stance, you cannot invest essence into maneuvers. Each of your unexpended maneuvers and stances is treated as though it had essence invested in it equal to the number of maneuvers you've expended from this stance's source, to a maximum of ½ your initiator level (This essence can exceed the maneuver's essence cap). Only maneuvers from the class (not feats) that granted this stance are counted towards this.
\nUnlike other Radiant Dawn stances, essence may not be invested into this stance.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `radiantDawn`,
        level: 8,
        name: `Tyrant's End`,
        type: `Strike`,
        shortDesc: `A blow that crushes all defenses.`,
        longDesc: `This powerful blow brings the end to tyrant's reigns. Make an attack. If it hits, you deal weapon damage as normal plus an additional 6d6 points of damage, and the target has their spell resistance, power resistance, damage reduction, energy resistance, and immunities suppressed for one round, becoming Vulnerable to all damage for 1 round. A successful Will save (DC 18 + initiation modifier) negates the Vulnerability. \n\nEssence: Each point of essence invested into this strike reduces the target's AC by 4 for 1 round.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `radiantDawn`,
        level: 9,
        name: `Judgement Day`,
        type: `Strike`,
        shortDesc: `Render judgement upon all within your presence.`,
        longDesc: `All enemies within the area are consumed by pure akashic ﬂame, taking 50 points of untyped damage. A successful Reﬂex save (DC 19 + initiation modifier) halves this damage. Allies within range are healed for 50 points of damage. This healing acts like that of a breath of life spell, with the exception that it isn't positive energy-based, and it may revive targets that have died since the last sunrise. Allies slain by death eﬀects can attempt another saving throw against that death eﬀect with a bonus equal to your initiation modifier. If this save is successful, they are revived with hit points equal to amount of healing done by this maneuver. A creature may only benefit from the breath of life eﬀect of this maneuver once, and must experience sunrise before they can gain its benefit again, though it still benefits from this maneuver's healing normally. \n\nEssence: Each point of essence invested into this maneuver increases the healing and damage done by 15 points each, the DC by 1, and the results of new saving throws against death eﬀects by 2.`,
        initiationAction: `full-round`,
        range: `Close (25 ft. + 5 ft./2 levels) rangeArea: Burst centered on the initiator`,
        duration: `Instantaneous`
      },
      {
        school: `rivenHourglass`,
        level: 1,
        name: `Clockwatcher`,
        type: `Counter`,
        shortDesc: `You can act during a surprise round in which you would not normally be able to act.`,
        longDesc: `By pulling your perception forward in time for the barest of moments, you are able to cheat fate and act when most would be caught unaware. Unlike other immediate actions, you can initiate this counter while flat-footed, and can use this maneuver at the beginning of a surprise round you otherwise would not be able to act in. You may act during the surprise round normally.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `rivenHourglass`,
        level: 1,
        name: `Distorted Clock`,
        type: `Stance`,
        shortDesc: `You extend the effects of beneficial spells and powers, and gain resistance against harmful spell effects.`,
        longDesc: `Magic is a fickle thing that wanes in power as the sands glitter through the hourglass of existence. You halt this progression within yourself, sustaining abilities that would normally only last a few minutes. You can apply the effects of the Extend Spell metamagic feat (or Extend Power metapsionic feat) to a single beneficial extract, power, psi-like ability, spell, or spell-like ability cast upon you for as long as you maintain this stance. Leaving this stance causes the duration to resume as normal (each round of the effect spent as half of a round while in this stance). Starting at initiator level 10, you may extend a second effect. In addition, you gain a +2 circumstance bonus on saving throws against harmful effects with a duration of longer than instantaneous.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `rivenHourglass`,
        level: 1,
        name: `Minute Hand`,
        type: `Boost`,
        shortDesc: `You make an attack as a swift action with a –2 penalty.`,
        longDesc: `You make an incredibly swift strike which sacrifices some accuracy for speed. Make a melee attack with a –2 penalty on the attack roll. If it hits, it deals weapon damage as normal.`,
        initiationAction: `swift`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `rivenHourglass`,
        level: 1,
        name: `Sands of Time Stance`,
        type: `Stance`,
        shortDesc: `You gain a +2 bonus on initiative checks and Reflex Saves.`,
        longDesc: `By attuning yourself to the ebb and flow of time, you can visualize the time-stream as a metaphorical hourglass in your soul, and learn to manipulate your place within it. While you maintain this stance, you gain a +2 bonus on Initiative checks and Reflex saves. At initiator level 12th, these bonuses increase to +4.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `rivenHourglass`,
        level: 1,
        name: `Sands of Time Approach`,
        type: `Strike`,
        shortDesc: `Your attack may fatigue the target for 1d4 rounds.`,
        longDesc: `By wrapping a bit of quintessence around your weapon in the form of a glittering aura, you are capable of striking a foe and burning through the time that he has left. Make an attack. If it hits, it deals weapon damage as normal and the target must succeed at a Will save (DC 11 + your initiation modifier) or become fatigued for 1d4 rounds.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `rivenHourglass`,
        level: 1,
        name: `Strike the Hourglass`,
        type: `Strike`,
        shortDesc: `Your attack may cause the target to lose their next move action.`,
        longDesc: `With a simple strike, you influence time's attitude towards a foe and their ability to act in battle. Make an attack. If it hits, it deals weapon damage as normal and the target must succeed at a Will save (DC 11 + your initiation modifier) or it can only take a single move action or standard action during its next turn.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `rivenHourglass`,
        level: 2,
        name: `Chronal Aggression`,
        type: `Strike`,
        shortDesc: `Your fire a ray that deals 2d6 + your initiation modifier points of damage and sickens the target.`,
        longDesc: `A Riven Hourglass disciple must end fights quickly, as the sands of time halt for no man. Heeding this logic, you attack at your foe's reserves of enduring strength. You fire a ray against an opponent within close range (25 feet + 5 feet per 2 initiator levels). This ray requires a ranged touch attack to hit and deals 2d6 points of damage plus your initiation modifier, and the target must succeed at a Fortitude save (DC 12 + your initiation modifier) or become sickened for one minute. On a successful save, the target is instead sickened for one round.`,
        initiationAction: `standard`,
        range: `Close (25 ft. + 5 ft./2 levels)`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `rivenHourglass`,
        level: 2,
        name: `Rapid Strike`,
        type: `Strike`,
        shortDesc: `You make two attacks as a standard action.`,
        longDesc: `You compress the time needed to strike twice within the span of a single blow. Make two melee attacks against the same creature. If an attack hits, it deals weapon damage as normal.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `rivenHourglass`,
        level: 2,
        name: `Stopwatch`,
        type: `Counter`,
        shortDesc: `Make an Sense Motive check against an attack roll to take a 5-foot step, potentially negating the attack.`,
        longDesc: `With a dizzying burst of incredible speed, you step out of time, adjusting your position to possibly avoid an attack. You can initiate this counter in response to a melee or ranged attack being made against you. Make a Sense Motive check, using your opponent's attack roll as the DC. If you succeed, you may take a 5-foot step as part of this counter. If this movement puts you in a position where the opponent would not have been able to attack you, then the attack is negated.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `rivenHourglass`,
        level: 2,
        name: `Temporal Burn`,
        type: `Strike`,
        shortDesc: `Your attack deals +2d6 damage, overcomes damage reduction, and ignores hardness.`,
        longDesc: `By surrounding your weapon with a bubble of vastly accelerated time, you are able to strike at a foe and burn away at their personal quintessence. Make an attack. If it hits, it deals weapon damage as normal plus an additional 2d6 points of damage, automatically overcomes damage reduction, and ignores hardness.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `rivenHourglass`,
        level: 2,
        name: `Unhindered Step`,
        type: `Boost`,
        shortDesc: `Your land speed increases by 30 feet for one round.`,
        longDesc: `By slowing the falling sands of the Hourglass inside your soul, you are capable of greatly accelerating your movements. After initiating this boost, your land speed increases by 30 feet until the beginning of your next turn. This adjustment is treated as an enhancement bonus. This boost does not affect other modes of movement, such as burrow, climb, fly, or swim.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `rivenHourglass`,
        level: 3,
        name: `Flickering Defense`,
        type: `Counter`,
        shortDesc: `Your opponent must roll twice for their attack and take the worse result, and takes a –4 penalty on their attack roll.`,
        longDesc: `All actions cause new potential futures, and you can force particularly unlucky futures upon your foes by looking forward and shifting the right sands. You can initiate this counter in response to a melee or ranged attack being made against you or an ally within 60 feet. The attacker takes a –4 penalty on the attack roll, and rolls twice and takes the lower result. You must initiate this counter before the success or failure of the original roll is known.`,
        initiationAction: `immediate`,
        range: `60 ft.`,
        target: `You or an ally within 60 ft.`,
        duration: `Instantaneous`
      },
      {
        school: `rivenHourglass`,
        level: 3,
        name: `Probability Twist`,
        type: `Counter`,
        shortDesc: `You reroll a d20 roll or damage roll. You must take the results of your reroll, even if it's worse.`,
        longDesc: `While the flow of time is constantly moving, it is possible for a disciple to analyze and alter how the grains fall within his own Hourglass. You can initiate this counter to reroll any one d20 roll or damage roll you make in combat on your turn. You must take the result of the reroll, even if it is worse than the original roll.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `rivenHourglass`,
        level: 3,
        name: `Riven Hourglass Stance`,
        type: `Stance`,
        shortDesc: `You gain a +4 dodge bonus to your AC, a +4 on initiative checks, immunity to slow, and a 20% miss chance against magical effects that target you.`,
        longDesc: `By altering the flow of time around yourself, you flicker between potential time paths, slipping quietly between the grains that fall within your Hourglass. While you maintain this stance, you gain a +4 dodge bonus to your AC and a +4 bonus on Initiative checks. In addition, you become immune to the slow spell, and any power, psi-like ability, spell, or spell-like ability that targets only you suffers a 20% miss chance.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `rivenHourglass`,
        level: 3,
        name: `Temporal Fury`,
        type: `Strike`,
        shortDesc: `Your attack deals +2d6 damage and the target must make a Fortitude save or become slowed.`,
        longDesc: `You surround your weapon with quintessence, the essence of time that withers all things, and strike at your foe with its burning temporal energies. Make an attack. If it hits, it deals weapon damage as normal plus an additional 2d6 points of damage, and the target must succeed at a Fortitude save (DC 13 + your initiation modifier) or be affected as if by a slow spell for two rounds.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One living creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `rivenHourglass`,
        level: 3,
        name: `Time Skitter`,
        type: `Boost`,
        shortDesc: `You gain the benefits of a haste spell for a number of rounds equal to your initiation modifier.`,
        longDesc: `By accelerating your personal time-stream, you speed up your movements and accelerate your blows for a few moments. After initiating this boost, you gain the benefits of a haste spell for a number of rounds equal to your initiation modifier (+1 to attack rolls, AC, and Reflex saves, a +30-foot enhancement bonus to movement speeds, and one extra attack when making a full attack).`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `See text`
      },
      {
        school: `rivenHourglass`,
        level: 4,
        name: `Chronal Draw`,
        type: `Strike`,
        shortDesc: `Your attack deals +3d6 damage and the target must make a Will save or become exhausted.`,
        longDesc: `By damaging the time-flow on a target's vital forces, you temporarily age a foe, exhausting their body before their Hourglass can stabilize. Make an attack. If it hits, it deals weapon damage as normal plus an additional 3d6 points of damage, and the target must succeed at a Will save (DC 14 + your initiation modifier) or become exhausted for a number of rounds equal to your initiation modifier.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `rivenHourglass`,
        level: 4,
        name: `Gift of Time`,
        type: `Boost`,
        shortDesc: `You donate part or all of your turn to an ally.`,
        longDesc: `By focusing and carefully gathering glittering grains of quintessence from within your Hourglass into your hands, you can donate time to another with a touch. You can only initiate this boost at the start of your turn, before taking any other actions. Select an adjacent ally you can touch. You can choose to grant them a standard, move, or full-round action. That ally can take the action you selected, and must use them immediately, changing their place in the initiative order as if they had readied an action. You lose the chosen action, and cannot take it this turn. You cannot grant more actions than you could normally take during your turn, thus if you are staggered you could not grant an ally a full-round action, only a standard or move action.`,
        initiationAction: `swift`,
        range: `Touch`,
        target: `One ally`,
        duration: `Instantaneous`
      },
      {
        school: `rivenHourglass`,
        level: 4,
        name: `Temporal Body Adjustment`,
        type: `Counter`,
        shortDesc: `You negate any one negative condition that currently affects you.`,
        longDesc: `By reversing the flow of your personal Hourglass, you can turn back time, undoing a harmful event. You can initiate this counter when you would be affected by a negative condition (such as being cursed, dazed, paralyzed, or sickened), or are affected by a negative condition. You ignore the condition that would affect you, or end any one such condition currently affecting you. You cannot negate your death with this counter.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `rivenHourglass`,
        level: 4,
        name: `Tip the Hourglass`,
        type: `Strike`,
        shortDesc: `Your attack deals +4d6 damage and the target must make a Fortitude save or become slowed.`,
        longDesc: `By wrapping a field of anarchic temporal energy around your weapon, you strike at your foe's own inner Hourglass, seeking to disrupt its flow. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 4d6 points of damage, and target must succeed at a Fortitude save (DC 14 + your initiation modifier) or be affected as if by a slow spell for a number of rounds equal to your initiation modifier.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `rivenHourglass`,
        level: 5,
        name: `Chronal Fission`,
        type: `Stance`,
        shortDesc: `You can initiate one counter per round without using an immediate action.`,
        longDesc: `You enter a meditative trance, manipulating your personal time to react faster than you otherwise would be able to. While you maintain this stance, you may initiate a single counter each round without using an immediate action. This expends the counter as normal. You can use this stance's effect to initiate a counter even if you have already used an immediate action this round.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `rivenHourglass`,
        level: 5,
        name: `Hour Hand`,
        type: `Boost`,
        shortDesc: `Make an extra attack with a –4 penalty that deals +4d6 damage.`,
        longDesc: `You compress the timeframe of your attack, sacrificing precision to make a lightning-fast strike. After initiating this boost, you can make one additional attack as part of your next attack action, full-attack action, or strike. This extra attack is made at your highest attack bonus with a –4 penalty on the attack roll. If it hits, it deals weapon damage as normal plus an additional 4d6 points of damage.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `rivenHourglass`,
        level: 5,
        name: `Sands of Time Tornado`,
        type: `Strike`,
        shortDesc: `You attack each adjacent opponent, dealing additional damage equal to twice your initiation modifier and potentially sickening your targets.`,
        longDesc: `You accelerate your personal Hourglass, speeding up your mind and body to the point that you seem to be a blur, surrounded by a phantom aura of glittering smoke. Make a melee attack roll and compare it to the AC of each adjacent opponent. If the attack roll hits a target, it deals weapon damage as normal plus additional points of damage equal to twice your initiation modifier, and the target must succeed at a Fortitude save (DC 15 + your initiation modifier) or become sickened for 1d4 rounds. Use the same damage roll for each target.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Adjacent opponents`,
        duration: `1d4 rounds`
      },
      {
        school: `rivenHourglass`,
        level: 5,
        name: `Time-Thief's Talons`,
        type: `Strike`,
        shortDesc: `Your attack deals an additional 2 points of damage per initiator level and heals you for the same amount.`,
        longDesc: `Every being holds within its Hourglass sands of time that mark how long they will reside in this world, and you have learned to steal another's grains to replenish your own. Make an attack. If it hits, it deals weapon damage as normal plus additional points of damage equal to twice your initiator level, and you regain a number of hit points equal to twice your initiator level.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `rivenHourglass`,
        level: 5,
        name: `Relativity Burst`,
        type: `Counter`,
        shortDesc: `You gain a move action.`,
        longDesc: `By rearranging how your time is managed, you can manipulate the present, shifting your position on the battlefield. When you initiate this counter, you can immediately take a move action. You cannot gain more than one move action per round this way.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `rivenHourglass`,
        level: 6,
        name: `Sand-Bearer's Swiftness`,
        type: `Stance`,
        shortDesc: `You gain the benefits of a haste spell, immunity to slow, and a 20% miss chance against attacks and effects that target you.`,
        longDesc: `You open a floodgate within your soul, channeling time-accelerating energies through your body to move at blindingly-fast speeds. While you maintain this stance, you gain the benefits of a haste spell (+1 to attack rolls, AC, and Reflex saves, a +30-foot enhancement bonus to movement speeds, and one extra attack when making a full attack), and are immune to the slow spell and similar effects. In addition, your great speed makes you exceptionally hard to hit; all attacks, powers, psi-like abilities, spells, and spell-like abilities targeting only you suffer a 20% miss chance.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `rivenHourglass`,
        level: 6,
        name: `Shatter the Hourglass`,
        type: `Strike`,
        shortDesc: `Your attack may freeze the target in time for 1d4 rounds, paralyzing them.`,
        longDesc: `With a heavy blow, you strike your foe's Hourglass directly, temporarily shattering it and freezing their timeline in place. Make a melee attack. If it hits, it deals weapon damage as normal, and the target must succeed at a Fortitude save (DC 16 + your initiation modifier) or become paralyzed for 1d4 rounds. A successful save negates the paralysis and causes the foe to be affected as if by a slow spell for 1d4 rounds.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `rivenHourglass`,
        level: 6,
        name: `Temporal Distortion`,
        type: `Counter`,
        shortDesc: `You move up to twice your speed without provoking attacks of opportunity.`,
        longDesc: `By finding yourself in an immediate need of action, you are capable of stretching a tiny amount of time into the moments needed to move yourself away from danger. You can initiate this counter to move up to twice your speed without provoking attacks of opportunity. You cannot gain more than one movement from this counter per round.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `rivenHourglass`,
        level: 6,
        name: `Temporal Wave`,
        type: `Strike`,
        shortDesc: `You unleash a 30-foot cone of glimmering temporal energy that slows and may nauseate creatures caught in the area.`,
        longDesc: `You reach deep within your soul and pull forth a handful of quintessence to cast at your foes, wreaking havoc upon their ability to act. When you initiate this maneuver, you create a 30-foot cone of quintessence. Creatures caught within the cone must succeed at a Will save (DC 16 + your initiation modifier) or become nauseated and affected as if by a slow spell for a number of rounds equal to your initiation modifier. Creatures that succeed on their save are instead affected as if by a slow spell for one round.`,
        initiationAction: `standard`,
        range: `30 ft.Area: 30-ft. cone`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `rivenHourglass`,
        level: 7,
        name: `Beat the Clock`,
        type: `Counter`,
        shortDesc: `You gain a standard action.`,
        longDesc: `You briefly accelerate your personal timeframe, acting so fast that you appear to be a blur. You can initiate this counter to immediately take a standard action, as if you had readied an action. You cannot gain more than one standard action per round this way.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `rivenHourglass`,
        level: 7,
        name: `Sands of Time Hurricane`,
        type: `Strike`,
        shortDesc: `You attack each adjacent opponent twice with a +4 bonus on your attack rolls. A struck target must make a Fortitude save or become nauseated for one round.`,
        longDesc: `By pouring time-accelerating energies through your form, your perception of time grinds to a halt, allowing you to erupt into a whirlwind of perfect strikes and glittering quintessence at supernatural speed. Make two melee attack rolls with a +4 bonus and compare them to the AC of each opponent within your reach. If an attack roll hits a target, it deals weapon damage as normal and the target must succeed at a Fortitude save (DC 17 + your initiation modifier) or become nauseated for one round. Use the same damage rolls for each target.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `All opponents within reach`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `rivenHourglass`,
        level: 7,
        name: `Temporal Dilation`,
        type: `Strike`,
        shortDesc: `Your melee touch attack removes a foe from the timestream for 1d4 rounds.`,
        longDesc: `By summoning up a time-altering aura into your hand and channeling it through a foe, you can destabilize their Hourglass, pushing them out of sync with the present for a few scant moments. Make a melee touch attack. If it hits, the target disappears from reality for 1d4 rounds. After this duration, the target reappears in exactly the same orientation and condition as before. From the target's point of view, no time has passed at all. If the space from which the target departed is occupied upon his return to the time stream, he appears in the closest unoccupied space, still in his original orientation. Determine the closest space randomly if necessary. A successful Will save (DC 17 + your initiation modifier) reduces the duration of this strike to one round.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `rivenHourglass`,
        level: 8,
        name: `God of the Hourglass Stance`,
        type: `Stance`,
        shortDesc: `You can act in surprise rounds and within time stop spells, and you gain an additional move or standard action each round.`,
        longDesc: `Your control over your own time-stuff allows you to isolate your Hourglass from reality, causing you to move with unparalleled speed and grace and affording you protection from those who would manipulate your quintessence. While you maintain this stance, you may take an additional move or standard action during your turn, you become immune to the slow spell and similar effects, and you cannot become fatigued or exhausted. In addition, can always act during a surprise round, even if you're caught unaware, and if an ally or opponent uses a time stop spell or similar effect while you are within 50 feet of them you can take a single standard action during the duration of that spell or effect.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `rivenHourglass`,
        level: 8,
        name: `Heart of the Time Lord`,
        type: `Counter`,
        shortDesc: `You gain the effects of a heal spell when you would be reduced to 0 or fewer hit points.`,
        longDesc: `When the sands within your Hourglass finally run dry, you can force your timeline to restart, willing the sands to reverse within your soul and restore what has been lost. You can initiate this counter in response to taking damage that would reduce you to 0 hit points or less. You recover hit points and are cured of debilitating effects as if a heal spell had been cast on you, using your initiator level as the caster level.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `rivenHourglass`,
        level: 8,
        name: `Wrath of Time`,
        type: `Strike`,
        shortDesc: `You unleash a massive wave of temporal energy, dealing damage and potentially disintegrating anything within a 60-foot cone.`,
        longDesc: `You open your Hourglass and those of all around you, willing their grains to scatter in an attempt to outright erase their futures. When you initiate this maneuver, you unleash a 60-foot cone of violent temporal energy, reducing people and objects alike to harmless white sand. Make a Sense Motive check as part of this strike. Each opponent or object within the area takes damage equal to twice the result of your check. A successful Fortitude save (DC 18 + your initiation modifier) halves the damage. If this damage reduces a creature or object to 0 or fewer hit points, it is entirely disintegrated, leaving only a scattered pile of white dust.`,
        initiationAction: `standard`,
        range: `60 ft.Area: Cone-shaped burst`,
        duration: `Instantaneous`
      },
      {
        school: `rivenHourglass`,
        level: 9,
        name: `Break the Hourglass`,
        type: `Counter`,
        shortDesc: `You strike within the moments before an opponent can act against you, gaining a move and standard action (or full-round action) with which to attack your opponent.`,
        longDesc: `By forcing your will upon the quintessence of the universe and acting within pockets of time so small that blink past within the gap between seconds, you turn time on its end and react to an opponent's actions before they have even been made. You can initiate this counter in response to being targeted or caught within the area of an attack or effect. You can immediately take a standard action and a move action (or a single full-round action by combining them) before that effect resolves. While taking these actions, you can only attack or otherwise affect the originator of the attack or effect. If you reduce the originator of the attack or effect to 0 or fewer hit points with these actions, then the attack or effect (including parts of the effect that affect other creatures) is completely negated, having been prevented from happening at all. You cannot gain more than one standard action and move action per round this way.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `scarletThrone`,
        level: 1,
        name: `Blade of Breaking`,
        type: `Strike`,
        shortDesc: `Make a disarm or sunder attempt against an opponent's weapon without provoking attacks of opportunity.`,
        longDesc: `A Scarlet Throne disciple knows that sometimes to defeat the beast, you must remove its claws. By clashing blades with a foe to set their weapon vibrating, the disciple then delivers a final smashing blow in an attempt to shatter it or knock it from their grasp. The disciple may make a disarm or sunder attempt with a +4 competence bonus against his foe's weapon without provoking attacks of opportunity.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `scarletThrone`,
        level: 1,
        name: `Circular Stance`,
        type: `Stance`,
        shortDesc: `Flankers do not receive combat bonus against you when flanking.`,
        longDesc: `Practitioners of Scarlet Throne know that to be a lord amongst warriors, he must walk the path of battle alone, and he understands that often times he may be beset by all sides. By adopting the Circular Stance, the disciple learns to defend himself from the predations of those who would think him outflanked. While in this stance, the initiator is never considered flanked (this thwarts sneak attack attempts as well, provided that the rogue or ninja's level does not exceed the disciple's initiator level by 4 or more).`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `scarletThrone`,
        level: 1,
        name: `Prince's Attitude`,
        type: `Boost`,
        shortDesc: `+4 AC against attacks of opportunity while moving, +2 bonus to Reflex and Will saves until next turn.`,
        longDesc: `The Scarlet Throne disciple knows that he is nobility in the savagery of war, and conducts himself as such when moving through melee. The initiator gains a +4 dodge bonus to his Armor Class when he moves through threatened areas and provokes attacks of opportunity and a +2 competence bonus to Reflex and Will saves until his next turn.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `One round`
      },
      {
        school: `scarletThrone`,
        level: 1,
        name: `Red Zephyr's Strike`,
        type: `Strike`,
        shortDesc: `Make a melee attack, then make an immediate 10-ft. movement.`,
        longDesc: `With swiftness born of skill, a disciple of the Scarlet Throne learns how to move through the battlefield as lord among warriors. The disciple makes an attack against a foe, and if successful, he may make an immediate 10-ft. movement which does not provoke attacks of opportunity.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `scarletThrone`,
        level: 1,
        name: `Scarlet Einhander`,
        type: `Stance`,
        shortDesc: `+2 shield bonus to AC and +1d6 damage on attacks when fighting with one weapon.`,
        longDesc: `By adopting this stance, the disciple presents a slim profile to his foes, holding his weapon low and one-handed, and leads with his blade in an elegant and graceful manner, his strikes strong and his profile aiding him in defense. When wielding a melee weapon in one hand, the initiator presents a slim profile with strong offensive and defensive ability. The initiator gains a +2 shield bonus to his Armor Class and inflicts an additional 1d6 points of damage while in this stance. The shield bonus granted by this stance increases by +1 when the character's initiator level reaches 6th, and increases again by +1 at 12th and 18th initiator level. Upon reaching 10th initiator level, the bonus damage increases to 2d6.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `scarletThrone`,
        level: 1,
        name: `Scything Strike`,
        type: `Strike`,
        shortDesc: `Make a melee attack on two adjacent enemies as a single attack.`,
        longDesc: `The principles of the Scarlet Throne teach its disciples that every swing must be made with precision and excellence; no movement is wasted and no attack should be fruitless. The disciple may make a single attack against two adjacent enemies using the same attack roll and applying it to each target.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `scarletThrone`,
        level: 2,
        name: `Garnet Lance`,
        type: `Strike`,
        shortDesc: `Melee attack inflicts an additional 2d6 points of damage and ignores damage reduction.`,
        longDesc: `With a sudden and powerful thrust, the disciple penetrates the defenses of his foe with devastating alacrity. The initiator makes a melee attack against a target creature, and if successful the attack inflicts an additional 2d6 points of damage and the attack automatically bypasses the target's damage reduction.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `scarletThrone`,
        level: 2,
        name: `Regal Blade`,
        type: `Boost`,
        shortDesc: `Add +2 to attack roll and +1d8 to damage roll on a single melee attack.`,
        longDesc: `A disciple of the Scarlet Throne learns that in moments of precise focus, a single stroke of the blade can fell a potent enemy. The disciple may add a +2 insight bonus to his attack roll and +1d8 insight bonus to his damage roll on a single melee attack made during this turn.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `scarletThrone`,
        level: 2,
        name: `Rising Zenith Strike`,
        type: `Strike`,
        shortDesc: `Make a Sense Motive check, strike does double damage.`,
        longDesc: `With supreme focus, comes great insight into the workings of a foe's defenses. When the moment is right, the disciple releases his attack in a vicious upward swing. The disciple makes a Sense Motive check in place of his normal attack roll (he may add any enhancement bonus from his weapon or feats that apply from the use of his weapon to this Sense Motive check as well), and if this Sense Motive check equals or exceeds the target's armor class, the attack deals double damage. If this check does not meet or exceed the target's armor class, then the attack fails and the disciple misses.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `scarletThrone`,
        level: 2,
        name: `Sanguine Barrier`,
        type: `Counter`,
        shortDesc: `Make a Sense Motive check to block an attack.`,
        longDesc: `The focus required in battle allows the disciple to anticipate incoming attacks. The disciple makes a Sense Motive check and add a +2 competence bonus to the roll, opposing a single melee or non-spell or spell-like ability ranged attack. If successful, the disciple negates the attack.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `scarletThrone`,
        level: 3,
        name: `Dazing Attack`,
        type: `Strike`,
        shortDesc: `Make a melee attack, strike inflicts +2d6 points of damage and may daze enemy.`,
        longDesc: `The swiftness of the Scarlet Throne disciple's blade is a thing of terrific power, and by initiating this strike he demonstrates this potency. The disciple makes a melee attack against a target which if successful inflicts an additional 3d6 points of damage and upon a failed Fortitude save (DC 13 + initiation modifier) dazes the opponent for one round.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous, or one round`
      },
      {
        school: `scarletThrone`,
        level: 3,
        name: `Scarlet Eye's Perception`,
        type: `Boost`,
        shortDesc: `Next melee attack is resolved as a touch attack.`,
        longDesc: `By watching his opponent's defenses and waiting for the hole in them to open, the Scarlet Throne disciple strikes with the speed of the gods. The initiator's next melee attack against that target is resolved as a touch attack.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `scarletThrone`,
        level: 3,
        name: `Strike of Defeat`,
        type: `Strike`,
        shortDesc: `Make a melee attack against a foe, deals additional damage based on current hit points.`,
        longDesc: `A dead foe is a foe that can trouble you no more,' is an old adage of the Scarlet Throne disciple. An injured foe is easy prey, but is still a foe nonetheless. By utilizing this swift executioner's strike, the Scarlet Throne disciple removes a potential threat and obstacle from his path. The disciple makes an attack against a foe which if successful deals additional damage determined by the state of the enemy's hit points. If the enemy has more than 75% of his total hit points, this strike does no additional damage. If the foe has less than 75% hit points, this strike inflicts an additional 4d6 points of damage. If the foe has less than 25% of his total hit points, this strike inflicts an additional 8d6 points of damage.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `scarletThrone`,
        level: 3,
        name: `Unfettered Movement`,
        type: `Stance`,
        shortDesc: `Gain an additional +10 ft. to base speed, +4 bonus to AC vs. attacks of opportunity.`,
        longDesc: `The Scarlet Throne disciple is swift in battle and in his ability to go from one skirmish to the next to choose his next foe. By assuming this stance, the disciple gains a +10-ft. bonus to his base speed and gains a +4 dodge bonus to his armor class against attacks of opportunity.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `scarletThrone`,
        level: 4,
        name: `Noble Blade`,
        type: `Boost`,
        shortDesc: `+5 to attack roll and +2d8 to damage roll on a single melee attack.`,
        longDesc: `Scarlet Throne practitioners who know the Noble Blade may use their battle focus to add additional force to their strikes. The disciple may add a +5 insight bonus to his attack roll and +2d8 insight bonus to his damage roll on a single melee attack made during this turn.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `One round`
      },
      {
        school: `scarletThrone`,
        level: 4,
        name: `Red Zephyr's Dance`,
        type: `Strike`,
        shortDesc: `Each successful melee attack allows the martial disciple to move 10 ft. and make an additional attack.`,
        longDesc: `The Red Zephyr's Dance allows the disciple to step confidently through a battlefield, his blade leading the way in decisive sweeps as a graceful as a ballroom dance. The disciple makes a melee attack at his full attack bonus against a target, and if successful, the disciple moves 10-ft. (no more or no less) and may make another attack at his next highest attack bonus. He may not make more attacks in a round than his maximum main-hand number of attacks, nor may he move farther than his normal maximum speed. For example, if a warlord with a base attack bonus of +13 initiated this maneuver, he would make one attack at +13, move 10-ft., make his second attack at +8, then move 10-ft. again, and make a final attack at +3.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `scarletThrone`,
        level: 4,
        name: `Sanguine Perseverance`,
        type: `Counter`,
        shortDesc: `Use Sense Motive in place of relevant save on saving throw.`,
        longDesc: `The focus of battle that a disciple of Scarlet Throne has allows him to react to danger before he actively knows it is present, his senses acknowledging peril before his mind would know of it. A disciple may initiate this counter when required to make a saving throw. The disciple makes a Sense Motive check and uses the result of this check in place of his normal saving throw.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `scarletThrone`,
        level: 4,
        name: `Weeping Scarlet Razor`,
        type: `Strike`,
        shortDesc: `Arterial strike that inflicts an additional 4d6 points of damage and grants the bleeding condition on the target.`,
        longDesc: `Even the basest common soldier knows that there are places on a man's body where if he were to be stabbed, then he would bleed out in minutes. The Scarlet Throne disciple takes this knowledge and arms himself with his superior skill to utilize this arterial strike against his foes. The initiator makes a melee attack against a target creature, and if successful, this attack inflicts an additional 4d6 points of damage and the target begins to bleed profusely, inflicting 4 points of bleed damage per round until a successful Heal check (DC 20) or a spell or effect that cures hit point damage has been administered to the target.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Special`
      },
      {
        school: `scarletThrone`,
        level: 5,
        name: `Riddle of Iron`,
        type: `Strike`,
        shortDesc: `Melee attack that inflicts an additional 5d6 points of damage and dazes a target for one round.`,
        longDesc: `With a flourishing of his blade, the Scarlet Throne disciple confuses the senses of his foe as he lands a strike from an unexpected angle. The initiator must make a melee attack against a foe, and if successful the strike inflicts an additional 5d6 points of damage and dazes the target for one round on a failed Will save (DC 15 + initiation modifier).`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `scarletThrone`,
        level: 5,
        name: `Ruby Zenith Strike`,
        type: `Strike`,
        shortDesc: `Make a Sense Motive check, strike does triple damage.`,
        longDesc: `The focus of battle teaches that in a single hair's breadth of time, a warrior may strike down a foe in a single blow. The disciple makes a Sense Motive check in place of his normal attack roll (he may add any enhancement bonus from his weapon or feats that apply from the use of his weapon to this Sense Motive check as well), and if this Sense Motive check equals or exceeds the target's armor class, the attack deals triple damage. If this check does not meet or exceed the target's armor class, then the attack fails and the disciple misses.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `scarletThrone`,
        level: 5,
        name: `Sanguine Perfection`,
        type: `Counter`,
        shortDesc: `Temporarily overcome negative condition ailments.`,
        longDesc: `The supreme clarity of mind and focus of form allows a disciple of Scarlet Throne to simply overcome any obstacle placed before him, albeit for the short term. The disciple calls upon his supreme will and focus and may delay or stop a number of negative conditions placed upon him through the use of this maneuver for a number of rounds equal to the disciple's initiation modifier. Conditions that are subjected to this maneuver are: blinded, confused, cowering, dazed, dazzled, deafened, disabled, dying (though he still suffers hit point damage each round), energy drained, exhausted, fascinated, fatigued, frightened, helpless, nauseated, panicked, paralyzed, petrified, shaken, sickened, staggered, stunned, or unconscious. If the condition has a duration that would expire before the use of this maneuver, then the effect is negated. If the effect would have continue to have effect after the duration of this maneuver expires, then the subject suffers the remaining duration of that effect as normal after the maneuver ends.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `initiation modifier rounds`
      },
      {
        school: `scarletThrone`,
        level: 5,
        name: `Scarlet Riposte`,
        type: `Counter`,
        shortDesc: `Make a Sense Motive check opposing an enemy's attack roll, if successful, block the attack then make an immediate counter attack inflicting an additional 3d6 points of damage.`,
        longDesc: `Within the focus of the disciple's mind, pathways to victory form which he uses to sculpt and mold the outcome of the battle. When an enemy's attack threatens to unravel these pathways, a supreme act of will can restore order to them. The disciple makes a Sense Motive check with a +4 competence bonus opposing his enemy's melee attack roll. If successful, the attack is blocked and he may make an immediate counter attack against that opponent at his full attack bonus and inflict an additional 3d6 points of damage.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `One attack`,
        duration: `Instantaneous`
      },
      {
        school: `scarletThrone`,
        level: 6,
        name: `Blade of Perfection`,
        type: `Strike`,
        shortDesc: `Melee attack unerringly hits and ignores damage reduction.`,
        longDesc: `In an instant of perfect clarity, the disciple finds his moment to strike true. The disciple simply strikes the opponent with deadly swiftness, penetrating defenses as if they were not even there. This attack automatically hits its target and ignores damage reduction. For the purposes of counters that have systems that oppose an attack roll, treat this attack as if the disciple had rolled a natural 20.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `scarletThrone`,
        level: 6,
        name: `Final Blow`,
        type: `Strike`,
        shortDesc: `Make a melee attack; if foe is below 25% of maximum hit points, target is slain.`,
        longDesc: `Mercy has a place on the battlefield, a disciple of Scarlet Throne understands, as does the benefit of an honorable and swift death. By showing his enemy a merciful, swift death in battle, the disciple may continue to his next victory while letting both keep their honor. The disciple makes a melee attack against an injured foe, and if the attack is successful and the foe is under 25% of his maximum hit points, the attack is treated as a coup de grace that is performed as part of that attack action instead of the full-round action usually required. This does not provoke attacks of opportunity. The attack does damage as a critical hit, and the foe must make a Fortitude save with a DC equal to 10 + the damage inflicted or die. If the foe is above 25% of his maximum hit points, then this maneuver has no effect and normal damage is rolled. Disciples with this maneuver readied have a keen sense of their enemy's condition, and may make a Sense Motive check as a free action (DC 20) to gauge if their opponent is eligible to be finished by this maneuver.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `scarletThrone`,
        level: 6,
        name: `Red Zephyr's Fleetness`,
        type: `Boost`,
        shortDesc: `Add +30 ft. to your movement for the round and 50% miss chance on incoming attacks.`,
        longDesc: `The combat focus of a Scarlet Throne disciple lends itself to the analogy of the coiled spring; when necessary, the spring can rapidly unfold and launch with incredible celerity. With this principle adapted to the royal court of battle, the disciple may launch himself with alacrity across the field. The disciple may add 30 ft. to his base speed until his next turn, and his opponents suffer a 50% miss chance when attacking him due to his incredible speed.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `One round`
      },
      {
        school: `scarletThrone`,
        level: 6,
        name: `Scarlet Duelist Attitude`,
        type: `Stance`,
        shortDesc: `Add +5 insight bonus to AC and initiative.`,
        longDesc: `The force of will that a disciple of Scarlet Throne possesses is enough to protect him and guide his steps through battle, and his battle focus allows him to anticipate danger before it happens. By adopting this stance, the disciple may add +5 insight bonus to his Armor Class, CMD, and to his Initiative score.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `scarletThrone`,
        level: 7,
        name: `Royal Blade`,
        type: `Boost`,
        shortDesc: `+5 to attack roll and +5d8 to damage roll on a single melee attack, potentially cowering foe.`,
        longDesc: `As a true king of battle, the disciple brings his mastery of Scarlet Throne to the battlefield to the despair of his foes. By initiating this maneuver, his show of majestic force proves his claim to power. The disciple may add a +5 insight bonus to his attack roll and +5d8 insight bonus to his damage roll on a single melee attack made during this turn. Additionally targets who've been struck by an attack augmented with this boost must make a Will save (DC 17 + initiation modifier) or be left cowering for 1 round.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `One round`
      },
      {
        school: `scarletThrone`,
        level: 7,
        name: `Ruby Battle Lord's Strike`,
        type: `Strike`,
        shortDesc: `Make a full attack at a single target using full base attack bonus for each attack with a +2 insight bonus.`,
        longDesc: `Perfection in combat is the true goal of any disciple of Scarlet Throne, and to become a true master of this discipline is to know how to strike perfectly with each and every attack. The disciple initiating Ruby Battle Lord's Strike must make a full attack against a target, each attack using his full base attack bonus with a +2 insight bonus instead of the normal -5 reduction of each consecutive attacks (i.e. an initiator with a base attack bonus of +16, who normally has four attacks in a full attack action, would make each attack using this maneuver using his full +16 base attack bonus with a +2 insight bonus in addition).`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },      
      {
        school: `scarletThrone`,
        level: 7,
        name: `Sanguine Proclamation`,
        type: `Strike`,
        shortDesc: `Powerful attack that inflicts an additional 10d6 points of damage and potentially knocks the target prone.`,
        longDesc: `[Mind Affecting]With a mighty overhand swing the Scarlet Throne disciple puts his foe in their place; on their knees before the majesty of a prince of warriors. The initiator must make a melee attack against a target creature which if successful inflicts an additional 10d6 points of damage and the target must make a successful Will save (DC 17 + initiation modifier) to resist being driven to its knees, knocked prone.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `scarletThrone`,
        level: 8,
        name: `Descending Sunset Strike`,
        type: `Strike`,
        shortDesc: `Make a Sense Motive check, strike does quadruple damage.`,
        longDesc: `With a downward swing of his blade, the Scarlet Throne adapt proves his mastery of the discipline by shattering the will of the enemy to fight. The disciple makes a Sense Motive check in place of his normal attack roll (he may add any enhancement bonus from his weapon or feats that apply from the use of his weapon to this Sense Motive check as well), and if this Sense Motive check equals or exceeds the target's armor class, the attack deals quadruple damage. If this check does not meet or exceed the target's armor class, then the attack fails and the disciple misses.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `scarletThrone`,
        level: 8,
        name: `Riddle of Steel`,
        type: `Strike`,
        shortDesc: `Make a melee attack, strike inflicts an additional 10d6 points of damage and stuns target for 1d4 rounds.`,
        longDesc: `With a swift and deadly strike, the disciple is capable of disabling a foe's senses for a few moments, effectively eliminating the threat. The disciple makes a melee attack against his opponent which if successful deals an additional 10d6 points of damage and stuns his opponent for 1d4 rounds on a failed Will save (DC 18 + initiation modifier).`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `scarletThrone`,
        level: 8,
        name: `Scarlet Majesty Stance`,
        type: `Stance`,
        shortDesc: `Enemies must make a Will save to attack you.`,
        longDesc: `[Mind-Affecting]The fearsome glory of a master disciple of the Scarlet Throne discipline causes him to appear as nothing less than a god of war incarnated in flesh and steel. While in this stance, any creature with an Intelligence of 1 or higher must make a Will save (DC 18 + initiation modifier) to make an attack against him. If this saving throw is a success, then it may proceed to attack him as normal. If the opponent fails, it may not attack the disciple on this round but its action is not wasted. Targets who have successfully struck the disciple for damage after a successful Will save acquire immunity to this effect for 24 hours. Should the target fail to hit the disciple after a successful Will save, it must make another Will save in subsequent rounds to attempt to attack the disciple. A single attempt to overcome the awe-inspiring presence of the Scarlet Throne disciple may be made per round by any one creature.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },      
      {
        school: `scarletThrone`,
        level: 9,
        name: `Heavenly Blade of the Scarlet Throne`,
        type: `Strike`,
        shortDesc: `Make a melee attack, if successful, add an additional 100 points of damage to your weapon damage and enemy is left paralyzed.`,
        longDesc: `The supreme technique of the Scarlet Throne, the disciple who knows of it is the lord of all battlefields and marks his name amongst the legends of war. The disciple makes a melee attack which if successful inflicts an additional 100 points of damage. The target must then make a Will save (DC 19 + initiation modifier) to resist becoming paralyzed for 1d4 rounds.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `shatteredMirror`,
        level: 1,
        name: `Breaking Glass Strike`,
        type: `Strike`,
        shortDesc: `Your melee attack dazzles the target and may daze them.`,
        longDesc: `Your vicious strike flares with shards of mirror-bright color that dazzle and dizzy your victim. Make a melee attack. If it hits, it deals weapon damage as normal, and the target must succeed at a Will save (DC 11 + your initiation modifier) or become dazed for one round. Regardless of whether or not they succeed at their save, a struck target also becomes dazzled for a number of rounds equal to your initiation modifier.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `shatteredMirror`,
        level: 1,
        name: `Copycat Cut`,
        type: `Strike`,
        shortDesc: `Your melee attack deals +1d6 damage, and you can use one of your target's attack rolls in place of a later attack.`,
        longDesc: `With a slight shift of your stance, you mimic an attack you've witnessed in the last few seconds of combat. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 1d6 points of damage, and you can choose to use the result of any attack roll made by your target in their next turn in place of one of your attack rolls in your next turn. If you strike that opponent with their own attack roll, you deal an additional 2d4 points of damage. An attack made using an opponent's attack roll does not threaten or confirm critical hits.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `shatteredMirror`,
        level: 1,
        name: `Doppelganger Dance`,
        type: `Stance`,
        shortDesc: `You can follow when opponents make 5-foot steps.`,
        longDesc: `With supernatural alacrity, you mimic your foes' movements, preventing them from escaping you. While you maintain this stance, whenever an adjacent opponent takes a 5-foot step to leave one of your threatened squares, you may immediately take a 5-foot step towards that opponent, even if you have already moved or taken a 5-foot step this round. Whenever you use this ability, your movement speeds during your next turn are reduced by 5 feet.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `shatteredMirror`,
        level: 1,
        name: `Funhouse Waltz`,
        type: `Boost`,
        shortDesc: `Your speed increases by 10 feet and you can turn while running and charging for one round.`,
        longDesc: `With a moment's concentration, you shift your movements, advancing like a warped reflection. After initiating this boost, you gain a 10-foot enhancement bonus to each of your movement speeds and do not need to move in a straight line while running or charging for one round.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `shatteredMirror`,
        level: 1,
        name: `Left-Hand Strike`,
        type: `Strike`,
        shortDesc: `A successful Craft check causes opponent to lose shield bonus to AC and causes the target to take +1d6 damage from your melee attack.`,
        longDesc: `A minor twist of reality makes it seem like your strike is two places at once. When you initiate this strike, make a Craft check, using the target's AC as the DC. Then make a melee attack against the target. If it hits, it deals weapon damage as normal. If your Craft check succeeded, your target loses its shield bonus to AC against this and other attacks this round, and your attack deals an additional 1d6 points of damage.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `shatteredMirror`,
        level: 1,
        name: `Obsidian Reflection Stance`,
        type: `Stance`,
        shortDesc: `You apply a bonus or penalty on attack and damage rolls to all creatures within 20 feet (including you).`,
        longDesc: `You emanate an aura that either enhances the perceptions of those within it or makes them warped and twisted. While you maintain this stance, all creatures (including you) within 20 feet of you gain either a +1 bonus on attack and damage rolls or a –1 penalty on attack and damage rolls. Once per round as a free action, you can change which of these effects is applied. These bonuses increase by +1 for every four initiator levels you possess (+/– 2 at 4th level, +/– 3 at 8th level, and so on).`,
        initiationAction: `swift`,
        range: `Personal (see text)`,
        target: `You (see text)`,
        duration: `Stance`
      },
      {
        school: `shatteredMirror`,
        level: 2,
        name: `Broken Mirror Strike`,
        type: `Strike`,
        shortDesc: `Your melee attack may break the target's armor or shield.`,
        longDesc: `With a mirror-bright slash, you put jagged cracks in your opponent's defenses. Make a melee attack. If it hits, it deals weapon damage as normal, and the target must succeed at a Reflex save (DC 12 + your initiation modifier) or its armor or shield (your choice) gains the broken condition for a number of rounds equal to your initiator level.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `shatteredMirror`,
        level: 2,
        name: `Equivocate`,
        type: `Counter`,
        shortDesc: `You establish a reflective relationship with an opponent, sharing magical effects between the two of you.`,
        longDesc: `You ensnare yourself and a foe in a reflective relationship. You can initiate this counter in response to opponent within close range (25 feet + 5 feet per 2 initiator levels) being targeted by a power, psi-like ability, spell, or spell-like ability. For one round, any such effect targeting that opponent also targets you (and vice versa), even if it normally could not affect that many targets or one of you would be out of range. This counter happens before the effect takes place, allowing you to gain the effect you responded to.`,
        initiationAction: `immediate`,
        range: `Close (25 ft. + 5 ft./2 levels)`,
        target: `You and one other creature`,
        duration: `1 round`
      },
      {
        school: `shatteredMirror`,
        level: 2,
        name: `Mimic's Gambit`,
        type: `Strike`,
        shortDesc: `Your melee attack allows you to copy a spell or power affecting the target.`,
        longDesc: `Drawing on your power over reflections and mimicry, you copy an effect from your victim. Make a melee attack. If it hits, it deals weapon damage as normal, and you can choose one spell or power affecting the target. You gain the effects of the spell or power, just as if it had been cast or manifested on you, except that its duration is equal to its duration or a number of rounds equal to your initiation modifier (whichever is lower). If you do not have any knowledge of the spells or powers affecting the target, then choose one at random.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `See text`
      },
      {
        school: `shatteredMirror`,
        level: 2,
        name: `Obsidian Razor Style`,
        type: `Boost`,
        shortDesc: `You add your Craft ranks as a bonus on damage rolls for one round.`,
        longDesc: `Like obsidian, you create a reflection that is beautiful, dark, and deadly at the edge of your weapon. After initiating this boost, you gain an insight bonus equal to your ranks in one Craft skill (chosen when you initiate this boost) on melee damage rolls for one round.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `shatteredMirror`,
        level: 2,
        name: `Obsidian Sidestep`,
        type: `Counter`,
        shortDesc: `Make a Craft check in place of a saving throw.`,
        longDesc: `With an act of will, you distort reality to avoid harm. You can initiate this counter in response to making a saving throw. Make a Craft check in place of your saving throw, using the result of that check to determine that save's success.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `shatteredMirror`,
        level: 3,
        name: `Curse of the Twisted Reflection`,
        type: `Strike`,
        shortDesc: `Your melee attack curses the target and may confuse them.`,
        longDesc: `[curse, mind-affecting]With a hideous strike, you distort the perceptions of your enemies. Make an attack. If it hits, it deals weapon damage as normal, and the target must succeed at a Will save (DC 13 + your initiation modifier) or become confused for a number of rounds equal to your initiation modifier. In addition, a struck target becomes cursed for a number of rounds equal to your initiation modifier, regardless of whether or not it succeeded on its save.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `shatteredMirror`,
        level: 3,
        name: `Infinity Mirror Stance`,
        type: `Stance`,
        shortDesc: `You create mirror images of yourself.`,
        longDesc: `By bending the light near yourself, you create a deceptive defense against assault. When you enter this stance, you gain the benefits of a mirror image spell with a caster level equal to your initiator level. Instead of the normal amount of mirror images generated, you create one image for every four initiator levels you possess (minimum 1), and the effect lasts until you enter another stance, at which point any remaining images fade.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `shatteredMirror`,
        level: 3,
        name: `Reflected Blade Style`,
        type: `Boost`,
        shortDesc: `You copy the effects of a strike against a second target within close range.`,
        longDesc: `Your will creates a glimmering mirror of your assaults, afflicting two enemies at once. After initiating this boost, the next strike you initiate with an initiation action of 1 standard action that targets one creature also affects an additional opponent within close range (25 feet + 5 feet per 2 initiator levels), even if that opponent would normally be out of range of the strike. If the strike requires an attack roll, use the same attack roll against both targets.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `shatteredMirror`,
        level: 3,
        name: `Shattered Glass Smite`,
        type: `Strike`,
        shortDesc: `Your melee attack deals +3d6 damage and creates a 30-foot cone of shattered, magical glass behind them.`,
        longDesc: `With your will and your weapon, you shatter reality as you would shatter a mirror, shredding your enemies with false glass. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 3d6 points of magical slashing damage, and you create a 30-foot cone of shattered glass originating in the target's space and aimed in a direction of your choice. This cone deals 3d6 points of magical slashing damage to each creature caught within it. You and the initial target of this strike do not take damage from this cone.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature (see text)`,
        duration: `Instantaneous`
      },
      {
        school: `shatteredMirror`,
        level: 4,
        name: `Blazing Mirror Strike`,
        type: `Strike`,
        shortDesc: `You make a touch attack with a weapon you are wielding; the target must make a Fortitude save or become blinded.`,
        longDesc: `In a flash of bright death, your weapon transforms into light, passing through your foe's armor and scorching their eyes. Make a melee touch attack with a weapon you are wielding. If it hits, it deals weapon damage as normal, and the target must succeed at a Fortitude save (DC 14 + your initiation modifier) or become blinded for a number of rounds equal to your initiator level.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `shatteredMirror`,
        level: 4,
        name: `Carnival Swap`,
        type: `Boost`,
        shortDesc: `You trade a power or spell affecting you with one affecting the target.`,
        longDesc: `You catch your enemy in the reflection of your blade and twist reality like a funhouse mirror, leaving an unfair trade. The next time this round that you make an attack that hits, you may select one power, psi-like ability, spell, or spell-like ability affecting the struck creature. That creature loses the benefits of the chosen effect and you gain them for a number of rounds equal to your initiation modifier. Select a power, psi-like ability, spell, or spell-like ability affecting you. You lose the chosen effect and the struck creature gains it for a number of rounds equal to your initiation modifier.`,
        initiationAction: `swift`,
        range: `Close (25-ft + 5-ft/2 levels)`,
        target: `You and one other creature`,
        duration: `Special (see text)`
      },
      {
        school: `shatteredMirror`,
        level: 4,
        name: `Doppleganger Waltz`,
        type: `Counter`,
        shortDesc: `You can move when your target does.`,
        longDesc: `Like a reflection in the mirror, you follow your enemies' every move. You can initiate this counter in response to an opponent within close range (25 feet + 5 feet per 2 initiator levels) moving any distance. Whenever that opponent moves this round, you may move an equal distance or up to your speed (whichever is lower) as a free action, even if it isn't your turn. This movement provokes attacks of opportunity as normal and takes place after your opponent's movement. You may only move up to three times your highest movement speed in one round using this maneuver. You can only use this counter against a given opponent once per round.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `shatteredMirror`,
        level: 4,
        name: `Fetch's Wrath`,
        type: `Strike`,
        shortDesc: `Your melee attack deals +4d6 damage, and you can teleport before or after the attack.`,
        longDesc: `[teleportation]Like an unquiet spirit, you travel through light and reflections, striking down those foolish enough to tempt your wrath. When you initiate this strike, you may teleport to any unoccupied space within medium range (100 feet + 10 feet per initiator level), then make a melee attack. Alternately, you may make a melee attack and then teleport to unoccupied space within medium range. In either case, the attack you make deals weapon damage as normal plus an additional 4d6 points of damage.`,
        initiationAction: `standard`,
        range: `Medium (100 ft. + 10ft./level)`,
        target: `One creature and you (see text)`,
        duration: `Instantaneous`
      },
      {
        school: `shatteredMirror`,
        level: 5,
        name: `Curse of the Smoking Mirror`,
        type: `Strike`,
        shortDesc: `Your attack causes the target to fall prey to a reflective curse unless it succeeds at a Will save.`,
        longDesc: `<[curse]> With an obsidian-edged blow, you reflect an enemy's malice back onto itself, tainting them from within. Make a melee attack. If it hits, it deals weapon damage as normal, and the target must succeed at a Will save (DC 15 + your initiation modifier) or fall prey to a reflected curse for a number of rounds equal to your initiation modifier. While affected, the target becomes cursed, and whenever it deals damage (by any means) during this time it takes an equal amount of damage of the same type(s). Damage reduction, resistances, and immunities are applied to this damage as normal.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`,
        additionalTags:["Curse"]
      },
      {
        school: `shatteredMirror`,
        level: 5,
        name: `Empty Frame`,
        type: `Counter`,
        shortDesc: `You become incorporeal in response to harm.`,
        longDesc: `With an effort of will you shed substance but not form. After you initiate this counter, you and all objects worn, carried, or wielded by you become incorporeal for one round.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `shatteredMirror`,
        level: 5,
        name: `Gleaming Imprisonment`,
        type: `Strike`,
        shortDesc: `Your melee attack traps a creature within a sphere of mirrors.`,
        longDesc: `Twisting the reflections around your blade, you mark an enemy with it and imprison them in a sphere of mirrors. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 4d6 points of damage, and the target must succeed at a Reflex save (DC 15 + your initiation modifier) or become trapped within a sphere of two-sided mirrors that forms around them for a number of rounds equal to your initiation modifier. While this sphere of mirrors exists, a trapped creature cannot move or be moved from its space by any means (including teleportation), target or be targeted by any other creature or object (except for objects it is attending, carrying, or using), and is immune to attacks and effects that target an area and originate from outside its space. Such effects originating from the trapped creature affect only its own space.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `shatteredMirror`,
        level: 5,
        name: `Silvered Mirror Stance`,
        type: `Stance`,
        shortDesc: `A power or spell cast on you can also affect allies.`,
        longDesc: `Like a prism or a silver mirror, you splash joy and light onto those whom you love. When you enter this stance, choose a single power, psi-like ability, spell, or spell-like ability with a range greater than personal affecting you. While you maintain this stance, allies within 30 feet of you also gain the benefits of the chosen effect for as long as it is affecting you.`,
        initiationAction: `swift`,
        range: `Personal (see text)`,
        target: `You (see text)`,
        duration: `Stance`
      },
      {
        school: `shatteredMirror`,
        level: 6,
        name: `Copycat's Cunning`,
        type: `Boost`,
        shortDesc: `You copy armor, shield, or weapon special abilities of items wielded by an opponent.`,
        longDesc: `Your supernatural mimicry permits you to ape the tools used by your friends and foes. When you initiate this boost, choose another creature's armor, shield, or weapon within close range (25 feet + 5 feet per 2 initiator levels. A single piece of equipment wielded or worn by you of the same type as the targeted item may use the enhancement bonus of that item for a number of rounds equal to your initiation modifier. In addition, for the same duration, that piece of equipment gains the properties and special abilities on the chosen item in addition to its own, unless those properties or special abilities could not be applied to your equipment (for example, if you targeted a +2 distant longbow with this boost while wielding a +1 greatsword, your greatsword's enhancement bonus would increase to +2, but it would not gain the distant weapon special ability).`,
        initiationAction: `swift`,
        range: `Close (25 ft. + 5 ft./2 levels)`,
        target: `Armor, shield, or weapon worn or wielded by anopponent within range`,
        duration: `See text`
      },
      {
        school: `shatteredMirror`,
        level: 6,
        name: `Cursed Mirror Stance`,
        type: `Stance`,
        shortDesc: `You can make additional attacks of opportunity each round equal to your initiation modifier, and attacks that hit you in melee provoke an attack of opportunity from you.`,
        longDesc: `You mimic your opponents' movements, visiting retribution upon them. While you maintain this stance, you can make a number of additional attacks of opportunity each round equal to your initiation modifier. This stacks with the Combat Reflexes feat and other effects that increase the number of attacks of opportunity you can make in a round. In addition, any creature that hits you with a melee attack or melee touch attack provokes an attack of opportunity from you.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `shatteredMirror`,
        level: 6,
        name: `Murderous Reflection`,
        type: `Strike`,
        shortDesc: `Your melee attack gains a bonus equal to the target's Strength modifier on the attack roll and deals +7d6 damage.`,
        longDesc: `Like something out of a nightmare you turn an opponent's strength against them. Make a melee attack with a bonus on your attack roll equal to the target's Strength modifier. If it hits, it deals weapon damage as normal plus an additional 7d6 points of damage.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `shatteredMirror`,
        level: 6,
        name: `Plagiarism`,
        type: `Counter`,
        shortDesc: `You temporarily steal an ability used against you.`,
        longDesc: `You copy an opponent's technique, stripping it from them in the process. You can initiate this counter in response to being targeted with a power, psi-like ability, spell, spell-like ability, or supernatural ability. The creature targeting you becomes unable to use that ability for a number of rounds equal to your initiation modifier (although the ability they targeted you with still occurs and is resolved as normal) and you gain the ability to use that ability for a number of rounds equal to your initiation modifier. If the ability is a spell, you can use it once as a spell-like ability. If the ability is a psionic power, you can manifest it once as a psi-like ability. Otherwise, you can use the ability as often as is detailed in the ability description. Calculate the save DCs for the ability based on your initiation modifier and treat your initiator level as your caster level, manifester level, or hit dice, as appropriate for the ability.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `See text`
      },
      {
        school: `shatteredMirror`,
        level: 6,
        name: `Warped Glass Strike`,
        type: `Strike`,
        shortDesc: `Your melee attack deals +4d6 damage and causes the target to lose the ability to tell friend from foe.`,
        longDesc: `[Mind-Affecting]You re-write the perceptions of your victim with a blow, turning friend and enemy alike into horrific nightmares that can only be opposed. When you initiate this maneuver, make a melee attack. If you hit, it deals normal weapon damage plus 4d6 and your victim must succeed at a Will save (DC 16 + your initiation modifier) or lose all ability to tell friend from foe for a number of rounds equal to your initiation modifier. A creature so affected treats all other creatures as hostile, forgets all friendships, and targets the closest creature to it or the last creature that dealt damage to it in preference to other targets.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Creature struck`,
        duration: `Special (see text)`
      },
      {
        school: `shatteredMirror`,
        level: 7,
        name: `Double Team`,
        type: `Strike`,
        shortDesc: `Your melee attack knocks the target prone and deals additional damage equal to twice the result of a Craft check.`,
        longDesc: `You create a semi-real copy of yourself to attack an opponent, striking them high and low. When you initiate this maneuver, make a melee attack and a Craft check. If the attack hits, it deals normal weapon damage plus additional damage equal to twice the result of the Craft check, and the target is knocked prone.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `shatteredMirror`,
        level: 7,
        name: `Infinite Reflections`,
        type: `Strike`,
        shortDesc: `You deliver a cascade of melee attacks.`,
        longDesc: `As your blade connects, you seem to vanish, before reappearing around your opponent several times in succession and delivering blow after blow. Make a melee attack. If it hits, it deals weapon damage as normal, and you can make another melee attack with a –4 penalty on your attack roll. If that attack hits, you can make a further melee attack at a –8 penalty. You continue to repeat this process, taking a cumulative –4 penalty for each additional attack, until you miss an attack or you reduce your target to 0 or fewer hit points. You must direct all of these attacks at the same creature.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `shatteredMirror`,
        level: 7,
        name: `Mirror Demon's Waltz`,
        type: `Boost`,
        shortDesc: `You teleport to an unoccupied space within long range, cursing opponents adjacent to you and rendering them flat- footed.`,
        longDesc: `[curse, teleportation]You step through reflected light, vanishing into the splash of light of of a blade and emerging from a mirror, a prism, or even the reflection in an enemy's eye. When you initiate this boost, you can teleport to any unoccupied space within long range (400 feet + 40 feet per initiator level). Opponents adjacent to the square you leave and the square you arrive in become cursed and flat-footed for one round.`,
        initiationAction: `swift`,
        range: `Long (400 ft. + 40 ft./ level)`,
        target: `You and adjacent opponents (see text)`,
        duration: `instant (see text)`
      },
      {
        school: `shatteredMirror`,
        level: 8,
        name: `Obsidian Negation`,
        type: `Counter`,
        shortDesc: `You make a Craft check against a spell, power, or maneuver to negate its effect and cause the effect's originator to be unable to use it temporarily.`,
        longDesc: `You conjure a shard of black glass, imprisoning not only your enemy's power but the very concept of the tool he attempts to use. You can initiate this counter in response to opponent within close range (25 feet + 5 feet per 2 initiator levels) casting a spell, initiating a maneuver, manifesting a power, or using a psi-like or spell-like ability. Make a Craft check opposed by your opponent's caster level, initiator level, or manifester level check (as appropriate) plus their Wisdom modifier; if you succeed, the effect is completely negated, and that opponent may not use it for a number of rounds equal to your initiation modifier.`,
        initiationAction: `immediate`,
        range: `Close (25 ft. + 5 ft./2 levels)`,
        target: `One creature`,
        duration: `See text`
      },
      {
        school: `shatteredMirror`,
        level: 8,
        name: `Shattered Mirror Strike`,
        type: `Strike`,
        shortDesc: `Your melee attack deals +6d6 damage and causes the target to be unable to see other creatures.`,
        longDesc: `[mind-affecting]With a casual blow, you annihilate your opponent's perceptions, writing and rewriting their senses until they can only perceive reality as a shattered ruin. Make an attack. If it hits, your attack deals weapon damage as normal plus an additional 6d6 points of damage, and you make a Craft check, using the target's CMD as the DC. If you succeed, the target's senses are violently altered for a number of rounds equal to your initiation modifier; it treats all other creatures as having total concealment and suffers a 50% failure chance on spells with verbal or somatic components.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `shatteredMirror`,
        level: 8,
        name: `Unholy Mirror Stance`,
        type: `Stance`,
        shortDesc: `Harmful powers and spells used against opponents within 30 feet of you are copied to affect additional targets.`,
        longDesc: `Woe and discord are multiplied by your reflective power. While you maintain this stance, you can choose to have any power, psi-like ability, spell, and/or spell-like ability that targets an opponent within 30 feet also affect a number of secondary targets equal to your initiation modifier. Each secondary target must be within 30 feet of you, and none can be affected more than once. If the original effect requires an attack roll, use the same roll for each target. If the effect deals damage, secondary targets take half as much damage as the primary target, and if it does not deal damage, its save DC is reduced by 4 instead.`,
        initiationAction: `swift`,
        range: `Personal (see text)`,
        target: `You (see text)`,
        duration: `Stance`
      },
      {
        school: `shatteredMirror`,
        level: 9,
        name: `Septennial Seal`,
        type: `Strike`,
        shortDesc: `Your melee attack traps the target's soul within a mirror for seven years.`,
        longDesc: `The ultimate expression of your reflective power creates a mirror behind your victim just before you strike them with your magic-laced blade, blowing their soul out of their body and into your trap. Make a melee attack. If it hits, it deals weapon damage as normal, and the target must succeed at a Will save (DC 19 + your initiation modifier) or die instantly, their soul becoming trapped for seven years in a small steel mirror that appears somewhere on your person. If they succeed at their save, your attack instead deals 13d6 additional damage. Destroying the mirror created by this strike frees your victim's soul, allowing it to be returned to life as normal.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `silverCrane`,
        level: 1,
        name: `Crane Step`,
        type: `Boost`,
        shortDesc: `Make a free 5-ft step.`,
        longDesc: `[Good]The grace of the Silver Crane blesses the initiator with the ability to step through battle unhindered and unharmed. The initiator makes a free 5-ft step, even if he has already made one.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `silverCrane`,
        level: 1,
        name: `Enduring Crane Strike`,
        type: `Strike`,
        shortDesc: `Successful melee attack heals the initiator or ally within 30-ft 1d6 points of damage.`,
        longDesc: `[Good]Making his soul a wellspring of holy power, the disciple strikes out at a foe to unleashed his holy power to restore health to himself or an ally. The initiator makes an attack against a target creature, inflicting damage as normal, and the strike restores 1d6 hit points plus his initiation modifier to the initiator or to an ally within 30-ft.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Target creature(s)`,
        duration: `Instantaneous`
      },
      {
        school: `silverCrane`,
        level: 1,
        name: `Eyes of the Crane`,
        type: `Stance`,
        shortDesc: `When making Perception checks or rolls against concealment, roll twice and use the better of the two rolls, and may use detect evil as a spell-like ability at will.`,
        longDesc: `[Good]Using the perception of the disciple's heavenly training to assist him, the Silver Crane practitioner may see many things which would remain hidden from the eyes of the impure. While in this stance, the initiator rolls twice on Perception checks or when attempting to pierce concealment, using the higher of the two rolls. Additionally, he may use detect evil as a spell-like ability at will with a caster level equal to his initiator level.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `silverCrane`,
        level: 1,
        name: `Flashing Wings`,
        type: `Strike`,
        shortDesc: `Melee attack that dazzles an opponent and inflicts +1d4 damage.`,
        longDesc: `[Good]The flashing wings of the Silver Crane daze the foes of the martial disciple, burning their eyes with the light of Heaven. Make a melee attack and if successful, this attack inflicts an additional 1d4 points of damage and the target is dazzled for one round.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `1 round`
      },
      {
        school: `silverCrane`,
        level: 1,
        name: `Silver Crane Waltz`,
        type: `Stance`,
        shortDesc: `Gain a +4 bonus to initiative checks and +2 to Reflex saves and to AC, increasing every eight levels.`,
        longDesc: `[Good]The divine vantage point of the celestial realms infuses the mind of the disciple, granting him momentary flickers of foresight. A faint, ghostly image of wings is visible around the disciple but vanishes when he is looked upon directly. The initiator gains a +4 insight bonus to initiative checks if he is in this stance before combat begins, and a +2 insight bonus to Reflex saves and to AC. These bonuses increase by an additional +1 every eight levels after 1st level.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `silverCrane`,
        level: 1,
        name: `Silver Strike`,
        type: `Strike`,
        shortDesc: `Roll two attack rolls; use the better of the two rolls to determine result.`,
        longDesc: `[Good]Using the insight of the Heavens, the martial disciple learns to read the tangles of fate to direct their efforts in battle. The initiator makes two attack rolls and uses the better of the two rolls to determine result of the attack.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `silverCrane`,
        level: 2,
        name: `Blazing Crane's Wing`,
        type: `Boost`,
        shortDesc: `Add 2d6 points of damage to attacks against undead or evil outsiders.`,
        longDesc: `[Good]By filling the Silver Crane disciple's weapon with the strength of his celestial patrons, the warrior funnels their righteous wrath against those that are abominations in the eyes of all that is good. The initiator's attacks until his next turn inflict an additional 2d6 points of damage against undead or evil outsiders.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Until next turn`
      },
      {
        school: `silverCrane`,
        level: 2,
        name: `Blessed Pinions`,
        type: `Strike`,
        shortDesc: `Melee attack deals an additional 2d6 sacred damage, strikes incorporeal creatures or possessing creatures without harming the host.`,
        longDesc: `[Good]The pinion feathers of the Silver Crane's wings gain an ethereal glimmer as if they were blessed steel. Heavenly agents guide their disciple's attack so it may strike true as if it were blessed, even allowing it to strike the unseen. Make an attack against a foe that inflicts an additional 2d6 points of sacred damage and the attack is considered good aligned for the purposes of overcoming damage reduction. The disciple may also choose to strike incorporeal foes with this strike as if they were made manifest, including fiends who currently possess a creature. To strike a possessing fiend, the body they inhabit must be also struck, but all damage from the attack is inflicted upon the possessing fiend without harming the host.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `silverCrane`,
        level: 2,
        name: `Defensive Step`,
        type: `Counter`,
        shortDesc: `Make Perception check opposing opponent's attack roll, if successful make a free 5-ft step to evade the attack.`,
        longDesc: `[Good]Inspired by the awareness of the celestial realm, the discipline trusts in his heavenly sense of the battle around him to see where the next attack is coming and move away from danger. He makes a Perception check opposing the opponent's attack roll; if successful, the initiator may make a free 5-ft step in order to evade the attack. If he is unable to move to an adjacent square, he may not use this counter.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instant`
      },
      {
        school: `silverCrane`,
        level: 2,
        name: `Emerald Displacement Strike`,
        type: `Strike`,
        shortDesc: `Make a successful attack, target suffers 20% miss chance and Perception penalties.`,
        longDesc: `[Good]Sight is imperative in arts of the hunting bird, and a warrior learns that this holds true for his enemy. An enemy that cannot see is an enemy who can be defeated with greater ease. Make an attack and the target must make a Fortitude save (DC 12 + initiation modifier) or suffer a -4 penalty to Perception checks and a 20% miss chance on all attack rolls for the character's initiation modifier in rounds (minimum of one round).`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Initiation modifier rounds`
      },
      {
        school: `silverCrane`,
        level: 3,
        name: `Exorcism Strike`,
        type: `Strike`,
        shortDesc: `Melee attacks inflicts an additional 6d6 sacred damage to undead and evil outsiders; chance to daze.`,
        longDesc: `[Good]The foes of the celestial realms tremble in fear at the wrath of the Heavens themselves, and a disciple of the Silver Crane wields that righteous anger in battle. This strike inflicts an additional 6d6 points of sacred damage to the foe if it is an undead creature or an outsider with the Evil subtype, with a chance to daze the target for 1 round if it fails a Fortitude save (DC 13 + initiation modifier). Success negates the daze effect. If the target is a possessing entity within a host creature, the damage inflicted from this strike is solely inflicted upon the possessor, not the host. If the target is neither undead nor an evil outsider, this attack inflicts an additional 2d6 points of damage, and does not daze the target.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `silverCrane`,
        level: 3,
        name: `Silver Crane's Blessing`,
        type: `Boost`,
        shortDesc: `Upon a successful attack, initiator or ally within 30-ft is healed 2d6 plus initiation modifier points of damage.`,
        longDesc: `[Good]By invoking the powers of his celestial patrons upon successfully smiting an enemy of the heavens, the holy power of the Silver Crane disciple's patron flows through him to restore the health of the vessel or the ally of the vessel. Upon a successful attack, the character may initiate this boost to heal himself or an ally within 30-ft of 2d6 points of damage plus his initiation modifier.`,
        initiationAction: `swift`,
        range: `Personal or 30-ft`,
        target: `You or ally`,
        duration: `Instantaneous`
      },
      {
        school: `silverCrane`,
        level: 3,
        name: `Silver Knight's Blade`,
        type: `Strike`,
        shortDesc: `Attack inflicts an additional 4d6 points of damage, heals that damage to initiator or nearby ally.`,
        longDesc: `[Good]Those graced with the blessings of the Silver Crane are both terrors to their foes and heroes to their fellows. This strike inflicts an additional 4d6 points of sacred damage and heals a like amount of damage to either the initiator or to a single ally within 30-ft of the martial disciple.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `silverCrane`,
        level: 3,
        name: `Stance of the Silver Crane`,
        type: `Stance`,
        shortDesc: `Weapons wielded by the initiator gain the holy weapon quality, and the initiator radiates a protection from evil.`,
        longDesc: `[Good]The martial disciple with knowledge of this stance learns to channel the potency of their celestial patrons to combat evil with great efficiency. In the midst of battle ghostly images of wings or blazing wrathful haloes can often be seen near Silver Crane disciples. While in this stance, any weapon that the martial disciple wields is treated as if it had the holy special weapon property. Additionally, the character is considered under the influence of a protection from evil spell with a caster level equal to his initiator level.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `silverCrane`,
        level: 4,
        name: `Sacred Pinions`,
        type: `Strike`,
        shortDesc: `Melee attack deals an addition 5d6 sacred damage, strikes incorporeal or possessing creatures and stuns them for 1d4 rounds.`,
        longDesc: `[Good]The martial disciple enhances his melee strikes with the blessed wings of the Silver Crane, infusing them with celestial might to strike beyond flesh and bite spirit. Make an attack against a foe that inflicts an additional 5d6 points of damage. The initiator may also choose to strike incorporeal foes with this strike as if they were made manifest, including fiends who currently possess a creature. To strike a possessing fiend, the body they inhabit must be also struck, but all damage goes to the possessing fiend without harming the host.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `silverCrane`,
        level: 4,
        name: `Sapphire Displacement Strike`,
        type: `Strike`,
        shortDesc: `Make a successful melee attack, target suffers 50% miss chance.`,
        longDesc: `[Good]The agents of the celestial realms guide your blade and hinder the senses of your foes. Make a successful attack and the target must make a Fortitude save (DC 14 + initiation modifier) or fail on all Perception checks and suffers a 50% miss chance on attack rolls for the disciple's initiation modifier in rounds (minimum of one round).`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `silverCrane`,
        level: 4,
        name: `Silver Crane Resurgence`,
        type: `Counter`,
        shortDesc: `Initiator or ally within 30-ft may reroll a save with +4 sacred bonus.`,
        longDesc: `[Good]By invoking the power of his celestial patron, the Silver Crane disciple may overcome the fell powers and curses of his enemies and return to full fighting ability. As an immediate action, the initiator may grant himself or an ally within 30-ft of his position the ability to reroll a failed saving throw with a +4 sacred bonus.`,
        initiationAction: `immediate`,
        range: `Personal or 30-ft`,
        target: `You or ally`,
        duration: `Instantaneous`
      },
      {
        school: `silverCrane`,
        level: 4,
        name: `Silver Crane's Leap`,
        type: `Boost`,
        shortDesc: `Move up to normal movement speed without provoking attacks of opportunity.`,
        longDesc: `[Good]The flow of battle runs sharply through the Silver Crane disciple's mind, allowing him to see where his opponents will move before he makes his own. By watching these flows, he may step before their movements, allowing him greater mobility without a cost to defense. The disciple may make a free movement up to his normal movement speed without provoking attacks of opportunity.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Instant`
      },
      {
        school: `silverCrane`,
        level: 5,
        name: `Argent Knight's Banner`,
        type: `Strike`,
        shortDesc: `Make a successful charge attack, inflicts an additional 8d6 points of damage, heals initiator and all allies within 30-ft for 5d6 hit points.`,
        longDesc: `[Good]Infusing his arms and weapon with the glory of the Silver Crane's majesty, the martial disciple smites his foe and radiates a banner of heavenly wings, which explode with celestial light and power. Make a melee attack that inflicts an additional 8d6 points of damage and heals the initiator and all of his allies within 30-ft for 4d6 points of damage.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Special`,
        duration: `Instantaneous`
      },
      {
        school: `silverCrane`,
        level: 5,
        name: `Emerald-Tipped Feathers`,
        type: `Counter`,
        shortDesc: `Gain DR 20/evil against a single attack.`,
        longDesc: `[Good]A defensive technique of the Silver Crane calls for the hardening of the channeled celestial's essence around the disciple to protect him from harm. This essence often manifests in the form of a wing-like shield of faintly green light, which grants you damage reduction of 20/evil against a single attack.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `One attack`
      },
      {
        school: `silverCrane`,
        level: 5,
        name: `Silver Crane's Spiral`,
        type: `Strike`,
        shortDesc: `Make a single attack at full attack bonus +2 against each adjacent enemy.`,
        longDesc: `[Good]Filling himself with the wrath of the heavens, the Silver Crane disciple takes on a nimbus of glowing wings and lashes out at all of his nearby enemies with smiting strikes. The character makes a single attack at his full attack bonus with a +2 insight bonus at each adjacent enemy or enemy that is within the area he threatens. Ranged attacks used with this maneuver may only be used against opponents within the weapon's first range increment.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `Special`,
        duration: `Instantaneous`
      },
      {
        school: `silverCrane`,
        level: 5,
        name: `Stance of the Crane Knight`,
        type: `Stance`,
        shortDesc: `Gain a fly speed equal to twice your base speed and DR 10/evil, radiate light.`,
        longDesc: `[Good]As a disciple of the Silver Crane, the martial disciple may manifest the essence of his celestial patrons along his body, its light radiating from his soul to form silver-feathered ethereal wings from his back and a blazing halo of argent radiance around his head. While in this stance, you gain a fly speed equal to twice your base land speed with average maneuverability and you gain DR 10/evil. You also radiate light as a light spell from the halo-like effect of this stance while it is in effect.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `silverCrane`,
        level: 5,
        name: `Guardian of the Faith`,
        type: `Stance`,
        shortDesc: `Gain DR 10/Adamantine and allies within 20ft gain +4 to saves, ac, cmd`,
        longDesc: `[Good]While in this stance you gain DR 10/Adamantine and allies within 20 feet of you, excluding you, gain +4 sacred bonus to AC, CMD, and saves.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You `,
        duration: `Stance`
      },
      {
        school: `silverCrane`,
        level: 6,
        name: `Argent King's Scepter`,
        type: `Strike`,
        shortDesc: `Make a successful melee attack, inflicts an additional 12d6 points of damage, heals initiator 60 points of damage.`,
        longDesc: `[Good]The initiator of this strike holds his weapon aloft briefly, allowing it to fill with holy wrath before striking the blazing weapon down with righteous finality. This strike inflicts an additional 12d6 points of damage and heals the initiator for 60 points of damage.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `silverCrane`,
        level: 6,
        name: `Holy Pinions`,
        type: `Strike`,
        shortDesc: `Melee attack deals an additional 10d6 sacred damage, strikes incorporeal or possessing creatures and makes them corporeal for one minute.`,
        longDesc: `[Good]Using this advanced technique of the Silver Crane, the martial disciple infuses his strike with the pure celestial essence of their heavenly companion and smites the forces of the Lower Planes. Make an attack that inflicts and additional 10d6 points of damage. The disciple may also choose to strike incorporeal foes with this strike as if they were made manifest, including fiends who currently possess a creature. To strike a possessing fiend, the body they inhabit must be also struck, but all damage goes to the possessing fiend without harming the host. If used against a possessing fiend or an incorporeal creature, he may attempt to make this creature corporeal (if used against a possessing fiend, the creature will appear adjacent of the host) temporarily. The creature must make a Will save (DC 16 + initiation modifier) or be made corporeal and stunned for the character's initiation modifier in rounds (minimum of one round).`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `silverCrane`,
        level: 6,
        name: `Silver Crane Endurance`,
        type: `Stance`,
        shortDesc: `Initiator gains fast healing 5.`,
        longDesc: `[Good]By reciting a litany of praises and prayers to the glory of the angels and to the heavens above, the Silver Crane disciple is filled with restorative power from his patrons. Some disciples shimmer with a holy glow, and others bear a halo or nimbus around their head when in this stance. While in this stance, the initiator gain fast healing 5.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `silverCrane`,
        level: 6,
        name: `Silver Crane's Mercy`,
        type: `Boost`,
        shortDesc: `Upon successful attack, initiator or ally within 30-ft is healed 9d6 points of damage.`,
        longDesc: `[Good]With a recitation of power and a prayer for mercy upon those who are servants of heaven, the Silver Crane disciple strikes out at the evil he battles. Upon making a successful attack, you or an ally within 30-ft of you is healed of 9d6 points of damage.`,
        initiationAction: `swift`,
        range: `Personal or 30-ft`,
        target: `You or ally`,
        duration: `Instantaneous`
      },
      {
        school: `silverCrane`,
        level: 7,
        name: `Diamond Displacement Strike`,
        type: `Strike`,
        shortDesc: `Make a successful melee attack, target is rendered blind and deaf permanently.`,
        longDesc: `[Good]A blinded warrior cannot strike with his eyes, and most cannot strike with their mind. The disciple of the Silver Crane strikes hard at his opponent's senses and rips them from him decisively, burning them out with holy light and thunderous power. Make an attack, the target of which must make a Will save (DC 17 + initiation modifier) or be permanently blinded and deafened by a celestial hand. Targets that succeed their saving throw are staggered for one round from the sensory overload of the attack.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instant`
      },
      {
        school: `silverCrane`,
        level: 7,
        name: `Diamond-Tipped Feathers`,
        type: `Counter`,
        shortDesc: `Gain DR 30/evil for one attack or negate one condition upon the initiator.`,
        longDesc: `[Good]The ultimate defensive technique of the Silver Crane, glittering wings of celestial might wrap around the martial disciple initiating this maneuver, protecting him from harm. You gain DR 30/evil against a single attack, or may shed one condition that has been placed upon you or negate one that is about to be placed upon you (such as bestow curse or the effect of a power word: blind spell, but not damage effects from spells such as fireball).`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `silverCrane`,
        level: 7,
        name: `Holy Rush`,
        type: `Boost`,
        shortDesc: `Teleport yourself to a nearby ally's adjacent square within 50-ft.`,
        longDesc: `[Good, Teleportation]With a rush of speed and flare of arching wings of light, the martial disciple speeds towards an ally within the blink of an eye. When initiating this boost, you teleport to an square within 50 ft. and adjacent to an ally. If there is no ally within this range, this maneuver cannot be used. The disciple may teleport himself, his gear and equipment, and up to 25 pounds of carried objects.`,
        initiationAction: `swift`,
        range: `50-ft`,
        target: `You`,
        duration: `Instant`
      },
      {
        school: `silverCrane`,
        level: 8,
        name: `Benediction of the Silver Crane`,
        type: `Boost`,
        shortDesc: `Upon a successful attack, initiator and all allies within 30-ft. are healed for 12d6 points of damage.`,
        longDesc: `[Good]With a powerful cry of need, the true glory of heaven's mercy pours down upon the Silver Crane disciple in a flood of healing benediction. Upon a successful attack, the initiator and all allies within 30- ft of his position are healed of 12d6 points of damage.`,
        initiationAction: `swift`,
        range: `30-ft`,
        target: `You and allies`,
        duration: `Instantaneous`
      },
      {
        school: `silverCrane`,
        level: 8,
        name: `Celestial Pinions`,
        type: `Strike`,
        shortDesc: `Melee attack that strikes incorporeal creatures, inflicts an additional 15d6 points of sacred damage or slays incorporeal creatures.`,
        longDesc: `[Good]Martial disciples with this technique have learned to strike through the ether and destroy the very essence of their infernal foes in a blazing torrent of holy light. Make an attack against a foe that inflicts an additional 15d6 points of damage. The disciple may also choose to strike incorporeal foes with this strike as if they were made manifest, including fiends who currently possess a creature. To strike a possessing fiend, the body they inhabit must be also struck, but all damage goes to the possessing fiend without harming the host. If used against a possessing fiend or an incorporeal creature, the creature must make a Will save (DC 18 + initiation modifier) or be instantly slain.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `silverCrane`,
        level: 8,
        name: `Diamond Wings of the Imperial Crane`,
        type: `Stance`,
        shortDesc: `Gain spell resistance and a +4 sacred bonus to saves, effects resisted heal the initiator.`,
        longDesc: `[Good]The true master of the Silver Crane discipline who learns its mysteries must be prepared to take the fight to the enemies of the Upper Planes. By initiating this stance, a halo of ghostly wings erupts around the disciple to ward away harmful magics. While in this stance, the ghostly image of wings protects the initiator against the spells and powers of evil spells and dark powers, granting him spell resistance equal to 15 + his initiator level and a +4 sacred bonus to saving throws. Effects that fail to pass the initiator's spell resistance restore twice the level of the effect in hit points to the disciple.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `silverCrane`,
        level: 9,
        name: `Strike of Silver Exorcism`,
        type: `Strike`,
        shortDesc: `Melee attack inflicts +80 sacred damage, or +120 damage to/slays undead or evil outsiders.`,
        longDesc: `The ultimate technique of the Silver Crane is a strike that rends the essence of the foes of the heavens asunder and brings them to ruin in one blazing stroke. This strike adds an additional 80 points of sacred damage to the attack and dazzles the foe for one round. Undead or evil outsiders who are struck by this attack suffer 120 points of sacred damage instead and must make a Will save (DC 19 + initiation modifier) or be instantly slain. Creatures that succeed on the saving throw are instead hindered by holy power, being under the effects of a slow spell for the character's initiation modifier in rounds as their very essence quakes with the agonies inflicted by pure celestial energies.`,
        initiationAction: `1 Standard Action `,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous, 1d4 rounds`,
savingThrow: `Will Partial`
      },
      {
        school: `sleepingGoddess`,
        level: 1,
        name: `Battle Mantra`,
        type: `Stance`,
        shortDesc: `You gain flexible insight bonuses to aid your combat ability.`,
        longDesc: `In the heat of battle, every second matters and every blow is crucial. Your focus and psionic powers enhance your senses, allowing you to detect subtle movements and mental impressions, reacting to the ever-changing melee before those changes manifest. While you maintain this stance, you gain one of the following benefits. 
    \nYou gain a +1 insight bonus to your AC. 
    \nYou gain a +1 insight bonus on all attack rolls. 
    \nYou gain a +2 insight bonus on combat maneuver checks and to your CMD. 
    \nOnce per round as a free action, you can turn your attention to another facet of the combat, losing your current bonus and gaining a different benefit from this stance. These bonuses increase by +1 for every four initiator levels you possess. `,
        initiationAction: `swift`,
        range: `Personal `,
        target: `Self `,
        duration: `Stance`
      },
      {
        school: `sleepingGoddess`,
        level: 1,
        name: `Body of Delusion`,
        type: `Counter`,
        shortDesc: `Make an Sense Motive check to halve damage taken from an attack.`,
        longDesc: `The most basic tenet of the Sleeping Goddess discipline is that a strong enough belief, channeled through the lens of psionic power, can do anything. With this technique, you momentarily enter a state of denial, asserting through your power that you are not and will not be harmed. You can initiate this counter when you take damage from a melee or ranged attack. Make a Sense Motive check, using your opponent's attack roll as the DC. If you succeed, you take only half damage from the attack, although any other effects of the attack are resolved normally. \nAugment: You can augment this maneuver in one or more of the following ways:
\nFor every power point you spend, you gain a +1 bonus on your Sense Motive check.
\nIf you spend 3 power points, you take no damage from the attack on a successful Sense Motive check, rather than half.
\nIf you spend 5 power points, you are completely unaffected by the attack on a successful Sense Motive check, taking no damage and ignoring any additional effects of the attack.
\nIf you expend your psionic focus while initiating this counter, you can use it in response to an attack damaging an ally within 60 feet. Make a Sense Motive check as normal, then apply the effects of this counter to that ally rather than yourself.`,
        initiationAction: `immediate`,
        range: `Personal or 60 ft. (see text)`,
        target: `You or one ally (see text)`,
        duration: `Instantaneous`
      },
      {
        school: `sleepingGoddess`,
        level: 1,
        name: `Ego-wounding Strike`,
        type: `Strike`,
        shortDesc: `Your attack may inflict a –2 penalty on attack rolls, skill checks, and ability checks.`,
        longDesc: `You wrap your blade in psionic energy, telepathically amplifying the pain of the blow. Make an attack. If it hits, it deals weapon damage as normal, and the target must succeed at a Will save (DC 11 + your initiation modifier) or take become overwhelmed with agonizing pain, taking a –2 penalty on attack rolls, ability checks, and skill checks for one round. Each time one of your allies successfully hits that creature while it is under the effect of this strike, the duration increases by one round, up to a maximum number of rounds equal to your initiator level. \nAugment: You can augment this maneuver in one or more of the following ways:• For every 2 power points you spend, the penalty inflicted by this strike increases by –1.• If you expend your psionic focus while initiating this strike, your target does not get a saving throw against it.`,
        initiationAction: `standard`,
        range: `melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `sleepingGoddess`,
        level: 1,
        name: `Flash of Insight`,
        type: `Boost`,
        shortDesc: `On a successful attack or CMB check, you grant an ally a new save against an ongoing effect.`,
        longDesc: `You turn a sudden burst of inspiration into strength for your allies, sharing your power to give them an edge in battle and help them shrug of their wounds. You can activate this boost after making a successful attack or combat maneuver check. One ally within 30 feet gains another saving throw against a non-instantaneous effect that allows a saving throw affecting them. This saving throw has the same DC as the original save. If your ally succeeds, the effect ends. The ally does not suffer any additional effects for failing the save (such as a poison's damage). You cannot grant an ally more than one additional save against a given effect. \nAugment: You can augment this maneuver in one or more of the following ways:
    
    For every power point you spend, your ally gains a +1 insight bonus on their saving throw.
    
    If you expend your psionic focus while initiating this boost, this boost instead affects up to two allies within 30 feet.`,
        initiationAction: `swift`,
        range: `30 ft.`,
        target: `One or two allies (see text)`,
        duration: `Instantaneous`
      },
      {
        school: `sleepingGoddess`,
        level: 1,
        name: `Harmony-Shattering Strike`,
        type: `Strike`,
        shortDesc: `Your attack may increase the damage the target takes by your allies by +1d6.`,
        longDesc: `You strike at both your enemy's body and his spirit, creating a destructive link between them and your allies. Make an attack. If it hits, it deals weapon damage as normal, and the target must succeed at a Will save (DC 11 + your initiation modifier) or for one round, any attacks from your allies against the target deal an additional 1d6 points of damage. \nAugment: You can augment this maneuver in one or more of the following ways:
    
    For every 2 power points you spend, the additional damage your allies deal to the target increases by 1d6.
    
    If you expend your psionic focus while initiating this strike, your target does not get a saving throw against it.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `sleepingGoddess`,
        level: 1,
        name: `Unbroken Stride`,
        type: `Stance`,
        shortDesc: `You can walk on liquids and unstable surfaces, and eventually walls and even the air.`,
        longDesc: `With careful steps and focused psionic power, you can slightly shift how you interact with the world, moving over liquids as if they were solid, sprinting along walls, and even walking through the air. While you maintain this stance, you can walk and stand on liquids and other unfirm surfaces as if they were solid ground. You can move at your normal speed, but you cannot run on such a surface. This stance does not protect you from any negative effects that the surface might carry, such as the heat of lava or the stickiness of a spider's web. At initiator level 5th, you gain the ability to move along walls and ceilings as if under the effect of a spider climb spell while you maintain this stance, except that you do not need to use your hands to climb and can fight normally. At initiator level 10th, you can walk through the air as if it were solid ground, gaining a fly speed equal to your land speed with good maneuverability while you maintain this stance. However, while flying in such a way, you cannot hover. At initiator level 15th, your maneuverability when flying in this way increases to perfect, and you can even stand still in midair, hovering as normal.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `sleepingGoddess`,
        level: 2,
        name: `Adamant Will`,
        type: `Counter`,
        shortDesc: `You an one ally gain a +4 insight bonus to your ACs.`,
        longDesc: `Though armor can be pierced and shields can be broken, your will remains a final bastion, and those who witness this resolution of mind can be inspired to cultivate it within themselves. You can initiate this counter in response to a melee or ranged attack being made against you. You gain a +4 insight bonus to your AC against that attack, potentially causing it to miss. In addition, one of your allies within 60 feet gains a +4 insight bonus to their AC against the next attack made against them for one round. \nAugment: You can augment this maneuver in one or more of the following ways:
    
    For every power point you spend, the insight bonus to you and your ally's AC increases by +1.
    
    For every 3 power points you spend, this counter lasts an additional round. If you augment this counter in this way, the bonus to your ally's AC applies against every attack made against that ally during the duration, rather than only the next attack.`,
        initiationAction: `immediate`,
        range: `Personal and 60 ft. (see text)`,
        target: `You and one ally (see text)`,
        duration: `1 round (see text)`
      },
      {
        school: `sleepingGoddess`,
        level: 2,
        name: `Fearless Faith`,
        type: `Counter`,
        shortDesc: `You reduce the effects of a fear effect as it happens.`,
        longDesc: `You know that fear is as great an enemy as the foes in front of you, and through this knowledge and your faith in yourself, you can power through even the most terrifying situations. You can initiate this counter when you would become shaken, frightened, or panicked. You reduce the fear by one step (from panicked to frightened, frightened to shaken, or shaken to unafraid), and are treated as having successfully saved against the effect for the purposes of determining if you can be affected again. \nAugment: You can augment this maneuver in one or more of the following ways:
    
    For every 2 power points you spend, the fear is reduced by an additional step.
    
    If you expend your psionic focus while initiating this counter, you can use it in response to an ally within 60 feet becoming shaken, frightened, or panicked. If you do, you apply the effects of this counter to that ally rather than yourself.`,
        initiationAction: `immediate`,
        range: `Personal or 60 ft. (see text)`,
        target: `You or one ally (see text)`,
        duration: `Instantaneous`
      },
      {
        school: `sleepingGoddess`,
        level: 2,
        name: `Mind-Revealing Strike`,
        type: `Strike`,
        shortDesc: `Your attack deals +1d6 damage, and you become able to read the target's surface thoughts on a failed Will save.`,
        longDesc: `[mind-affecting]; You and your allies harry a foe, weakening its resolve and leaving it open to mental intrusion. Make an attack. If it hits, it deals an additional 1d6 points of damage, and the target must succeed at a Will save (DC 12 + your initiation modifier) or you become able to read their surface thoughts, as if by the read thoughts power, for a number of rounds equal to your initiation modifier. You do not need to concentrate on this ability to maintain it. Each time one of your allies successfully hits that creature while it is under the effect of this strike, the duration increases by one round, up to a maximum number of rounds equal to your initiator level \n.Augment: You can augment this maneuver in one or more of the following ways:
    
    For every power point you spend, this strike deals an additional 1d6 points of damage. For every 2d6 you increase the damage by, the save DC of this strike increases by +1.
    
    If you expend your psionic focus while initiating this strike, you may make a melee touch attack against the target rather than a normal attack. If it hits, it deals no damage, but you still can read their surface thoughts on a failed save.
    
    If you expend your psionic focus while initiating this strike, your target does not get a saving throw against it.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `sleepingGoddess`,
        level: 2,
        name: `Reactive Reversion`,
        type: `Boost`,
        shortDesc: `You mark your location and can teleport back to it until the start of your next turn.`,
        longDesc: `[teleportation]; You create a spiritual waypoint tied to your mind and body, allowing you to return to it in an instant for a short time. When you initiate this boost, mark your current location. At any time during the next round, you may teleport back to the marked space as a free action (even if it isn't your turn). Using this ability ends this boost. If your former space is occupied, you are instead teleported to the nearest unoccupied space. If you use this ability to move out of the reach or range of an attack or effect, the attack or effect is negated. \nAugment: You can augment this maneuver in one or more of the following ways:
    
    For every 2 power points you spend, the effect of this boost lasts an additional round.
    
    For every 2 power points you spend, you can teleport to the marked space one additional time before ending this boost.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round (see text)`
      },
      {
        school: `sleepingGoddess`,
        level: 2,
        name: `Twofold Assault`,
        type: `Strike`,
        shortDesc: `Your attack deals +1d6 damage and you may attempt a combat maneuver, using an Sense Motive check in place of your combat maneuver check.`,
        longDesc: `You assault your opponent's mind and body at the same instant, overwhelming them utterly with a single blow. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 1d6 points of damage, and you can make a combat maneuver attempt against the target as a free action. This combat maneuver attempt does not provoke an attack of opportunity, and you use a Sense Motive check in place of your combat maneuver check. \nAugment: You can augment this maneuver in one or more of the following ways:
    \nFor every power point you spend, this strike deals an additional 1d6 points of damage.
    \nIf you expend your psionic focus while initiating this strike, you can make a second combat maneuver attempt against the target as a free action, using a Sense Motive check in place of your combat maneuver check.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `sleepingGoddess`,
        level: 3,
        name: `Chains of Doubt`,
        type: `Strike`,
        shortDesc: `Your attack deals +3d6 damage and may nauseate your target and its allies.`,
        longDesc: `[mind-affecting]; You deliver a psionically-charged blow directly to your enemy's willpower and ability to press onwards, dragging them down with crushing doubt and despair. Make an attack. If it hits, it deals weapon damage as normal plus an additional 3d6 points of damage, and the target must succeed at a Will save (DC 13 + your initiation modifier) or become nauseated for one round. \nAugment: You can augment this maneuver in one or more of the following ways:
    
    For every power point you spend, this strike deals an additional 1d6 points of damage. For every 2d6 you increase the damage by, the save DC of this strike increases by +1.
    
    If you expend your psionic focus while initiating this strike, one of the target's allies within 60 feet of your choice also becomes nauseated for the same duration if the target fails its saving throw. The target's ally does not receive a saving throw against this effect.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack and 60 ft. (see text)`,
        target: `One or more creatures (see text)`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `sleepingGoddess`,
        level: 3,
        name: `Grasp of the Goddess`,
        type: `Boost`,
        shortDesc: `Your reach is increased by 5 feet and you can make an additional attack of opportunity this round.`,
        longDesc: `For a brief moment, you transcend the limits of your physical form, striking beyond the reach of your weapons and reacting with a speed and grace you would not normally have. After initiating this boost, your melee reach increases by 5 feet for one round, and you can make one additional attack of opportunity this round. This extra attack of opportunity stacks with other effects that grant additional attacks of opportunity, such as the Combat Reflexes feat. In addition, at any time during this boost's duration, you may expend your psionic focus as an immediate action to warp the world around you and move to any unoccupied space within your melee reach without provoking attacks of opportunity. \nAugment: You can augment this maneuver in one or more of the following ways:
    
    For every 2 power points you spend, you can make another additional attack of opportunity each round while under the effect of this boost.
    
    For every 3 power points you spend, this boost's effect lasts for an additional round.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `sleepingGoddess`,
        level: 3,
        name: `Inexorable Embrace of Sleep`,
        type: `Strike`,
        shortDesc: `Your attack deals +2d6 damage and puts victim into a trance.`,
        longDesc: `[mind-affecting]; With a devastating psychic strike, you can render a foe's higher mind catatonic, reducing him to the state of a sleepwalker. Make an attack. If it hits, it deals weapon damage as normal plus an additional 2d6 points of damage, and the target must succeed at a Will save (DC 13 + your initiation modifier) or be forced into a dreamlike trance for three rounds. While in this trance, the target cannot activate spell-like or supernatural abilities, cast spells, manifest powers, use psi-like abilities, or initiate maneuvers. Supernatural abilities that do not require an action or require only a free action to activate are unaffected, and spells and powers that the target is already concentrating on can be concentrated on as normal. The target may otherwise act normally, moving attacking, and performing other actions as it sees fit. \nAugment: You can augment this maneuver in one or more of the following ways:
    
    For every power point you spend, this strike deals an additional 1d6 points of damage. For every 2d6 you increase the damage by, the save DC of this strike increases by +1.
    
    If you expend your psionic focus while initiating this strike, your target does not get a saving throw against it. However, the duration of the trance is reduced to one round rather than three.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `sleepingGoddess`,
        level: 3,
        name: `Internal Dominion of the Sleeping Goddess`,
        type: `Stance`,
        shortDesc: `Once per round, you can reroll a failed saving throw or force an opponent to reroll an attack roll.`,
        longDesc: `The term “sleeping goddess” refers not to any tangible entity, but a state of being; by focusing your psionic might through the lens of true belief, you become something akin to a minor divine power whose realm lies within your physical form. Through this power, you can outright deny the world when it tries to exert such paltry concepts as “reality” on you. While you maintain this stance, you gain the following abilities:
    
    You can reroll a failed saving throw, taking the higher of the two rolls.
    
    You can force an opponent who has just hit you with an attack or succeeded at a combat maneuver check against you to reroll his attack roll or combat maneuver check and take the lower of the two rolls.You may only use a single one of these abilities per round, and activating them is a free action that can be taken even if it isn't your turn.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `sleepingGoddess`,
        level: 4,
        name: `Armory of the Sleeping Goddess`,
        type: `Boost`,
        shortDesc: `You create an enhanced weapon of ideals or empower your mind blade.`,
        longDesc: `Your immense force of will allows you to shape your ideals into a more powerful weapon than before. When you initiate this boost, a soul's blade appears in your hands, taking the form of a +3 melee weapon you are proficient with. Alternatively, you may create two soul's blades, each taking the form of an identical +2 melee weapons you are proficient with. A soul's blade created with this boost has hardness 15 and 30 hit points. The blade lasts a number of rounds equal to your initiator level before vanishing. If you throw your soul's blade or otherwise relinquish your grip on it (such as by being disarmed), it dissipates after one round unless you reclaim it. You can have multiple soul's blades created at once if you initiate this boost or other boosts that create a soul's blade multiple times, although only as many as you can wield. Alternatively, You can choose to amplify a currently wielded weapon instead of this boost's normal effects. Until the start of your next turn, all such weapons you wield (including those created after initiating this boost) gain the benefit of a single weapon special ability equivalent to up to +2 enhancement bonus. This ability must be chosen from the list of weapon special abilities you can normally place on a mind blade.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round/level (see text)`
      },
      {
        school: `sleepingGoddess`,
        level: 4,
        name: `Puppet of the Goddess`,
        type: `Strike`,
        shortDesc: `Your attack deals +4d6 damage and may override one of the target's senses.`,
        longDesc: `[mind-affecting]; You take control of your foe's perceptions, shutting them of from reality and substituting a false world of your choosing. Make an attack. If it hits, it deals weapon damage as normal plus an additional 4d6 points of damage, and the target must succeed at a Will save (DC 14 + your initiation modifier) or have one of its senses completely overridden for one round, as if you had manifested the false sensory input power on them. You do not need to concentrate on this ability to maintain it, although you cannot switch the sense you are falsifying with this strike. \nAugment: You can augment this maneuver in one or more of the following ways:
    
    For every power point you spend, this strike deals an additional 1d6 points of damage. For every 2d6 you increase the damage by, the save DC of this strike increases by +1.
    
    For every 3 power points you spend, the effect of this strike lasts an additional round.
    
    If you expend your psionic focus while initiating this strike, you ignore any immunity to mind-affecting effects the target possesses. Instead, a normally-immune target gains a +5 resistance bonus on its saving throw.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `sleepingGoddess`,
        level: 4,
        name: `Reunion in Dreams`,
        type: `Boost`,
        shortDesc: `You teleport a willing creature to your side.`,
        longDesc: `[teleportation]; Your understanding of the world and your place in it grows, and allows you to reach out to others and bring them under your protection even over great distances. When you initiate this boost, you teleport one willing creature that you can see within close range (25 feet + 5 feet per 2 initiator levels) to an unoccupied square adjacent to you. If there are no unoccupied adjacent squares for the creature to appear in, this boost has no effect. \nAugment: You can augment this maneuver in one or more of the following ways:
    
    For every power point you spend, you can teleport an additional willing creature within close range to an adjacent square.
    
    If you expend your psionic focus while initiating this boost, you may teleport yourself to an unoccupied square adjacent to a willing creature within close range before resolving the other effects of this boost. Measure the range of this boost from and teleport targets to unoccupied squares adjacent to your new position.`,
        initiationAction: `swift`,
        range: `Close (25 ft. + 5 ft./2 levels)`,
        target: `One willing creature (see text)`,
        duration: `Instantaneous`
      },
      {
        school: `sleepingGoddess`,
        level: 4,
        name: `Traumatic Reversal`,
        type: `Counter`,
        shortDesc: `You take half damage from an effect, and the effect's originator must succeed at a Will save or take half the damage they would have dealt.`,
        longDesc: `[mind-affecting]; Just as a warrior with a superior weapon may try to sunder an attacker's blade, you are able to shatter your foe's mind in order to defend yourself, creating a momentary psionic link along which the effects of their attack are shared. You can activate this counter when you take damage from an attack or effect originating from an opponent. You take only half damage from the attack or effect, although any other effects are resolved normally. In addition, the opponent that damaged you must succeed at a Will save (DC 14 + your initiation modifier) or take damage equal to half the damage they would have dealt. \nAugment: You can augment this maneuver in one or more of the following ways:
    
    If you spend 6 power points, you take no damage from the attack, and the opponent that damaged you takes the full amount of damage they dealt to you on a failed saving throw.
    
    If you expend your psionic focus while initiating this counter, you can use it in response to an attack or effect damaging an ally within 60 feet. If you do, you apply the effects of this counter to that ally and the opponent that damaged that ally rather than yourself.`,
        initiationAction: `immediate`,
        range: `Personal (see text)`,
        target: `You and one opponent (see text)`,
        duration: `Instantaneous`
      },
      {
        school: `sleepingGoddess`,
        level: 5,
        name: `Inarguable Presence of the Sleeping Goddess`,
        type: `Stance`,
        shortDesc: `You ignore immunity to mind-affecting effects and gain a 20% miss chance against attacks.`,
        longDesc: `Your psionic might and the strength of your belief exert an immense pressure on the minds of your foes merely by being near them. You are a fact, and your power will not be denied. While you maintain this stance, your maneuvers and other abilities treat creatures that are normally immune to mind-affecting effects as if they were not immune. Such creatures gain a +5 resistance bonus on saving throws against your mind-affecting effects, rather than ignoring them outright. In addition, attacks made against you suffer a 20% miss chance.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `sleepingGoddess`,
        level: 5,
        name: `Reshape the Sculpted Mind`,
        type: `Strike`,
        shortDesc: `Your attack deals 1d4 damage to a mental ability score and may damage the opponent's mind temporarily.`,
        longDesc: `[mind-affecting]; Your intimate acquaintance with the nature of the mind allows you to strike it where it's most vulnerable. Make an attack. If it hits, it deals weapon damage as normal plus an additional 1d4 points of Intelligence, Wisdom, or Charisma damage (your choice), and the target must succeed at a Will save (DC 15 + your initiation modifier) or be affected by one of the following effects, depending on the type of ability damage selected. A target that is immune to ability damage still suffers this additional effect. Intelligence: The target's ability to express its thoughts is dampened, causing it to be unable to communicate with others, even by telepathy, for a number of rounds equal to the Intelligence damage dealt by this strike. The target can still hear others, but anything it says or tries to convey non-verbally is completely unintelligible, even to a creature under the effect of a tongues spell or similar effect. Spells that require verbal components suffer a 50% chance of failure while the target is affected by this strike. Wisdom: The target loses its grasp on reality, causing it to become confused for a number of rounds equal to the Wisdom damage dealt by this strike. Charisma: The target's confidence and ability to believe in itself is shattered, causing it to become frightened for a number of rounds equal to the Charisma damage dealt by this strike. At the end of each of the target's turns while it is frightened, it can attempt another save to end this effect. This use of this strike is considered a fear effect. \nAugment: You can augment this maneuver in one or more of the following ways:
    
    For every 2 power points you spend, the ability damage dealt by this strike increases by one.
    
    If you expend your psionic focus while initiating this strike, you ignore any immunity to mind-affecting effects or fear effects the target possesses. Instead, a normally-immune target gains a +5 resistance bonus on its saving throw.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `sleepingGoddess`,
        level: 5,
        name: `Reverberation of Defeat`,
        type: `Boost`,
        shortDesc: `When you reduce an opponent to 0 or fewer hit points, that target's allies must succeed at a Will save or become shakened and sickened.`,
        longDesc: `As you destroy one foe, his allies feel the weight of his failure, the pain, fear, and feeling of utter defeat cascading down the ties of friendship or belief. You can activate this boost when you reduce an opponent to 0 or lower hit points. Each of that opponent's allies within 30 feet must succeed at a Will save (DC 15 + your initiation modifier) or become shaken and sickened for a number of rounds equal to your initiation modifier.`,
        initiationAction: `swift`,
        range: `30 ft.`,
        target: `One or more creatures (see text)`,
        duration: `Instantaneous`
      },
      {
        school: `sleepingGoddess`,
        level: 5,
        name: `The Ties that Bind`,
        type: `Strike`,
        shortDesc: `Your attack deals +5d6 damage, and your target along with one of its allies may become entangled.`,
        longDesc: `With a psionically-empowered strike, you stab through an enemy's physical form and attack their spirit and those tied to it. In the minds of your targets, the world warps, keeping them from fighting or moving effectively. Make an attack. If it hits, it deals weapon damage as normal plus an additional 5d6 points of damage, and the target must succeed at a Will save (DC 15 + your initiation modifier) or it and one of the target's allies within 60 feet of your choice become entangled for a number of rounds equal to your initiation modifier. The target's ally does not receive a saving throw against this effect. \nAugment: You can augment this maneuver in one or more of the following ways:
    
    For every power point you spend, this strike deals an additional 1d6 points of damage. For every 2d6 you increase the damage by, the save DC of this strike increases by +1.
    
    For every 3 power points you spend, you may select an additional one of the target's allies to entangle if the target fails its saving throw.
    
    If you expend your psionic focus while initiating this strike, the target and its affected allies also become nauseated for one round on a failed saving throw.`,
        initiationAction: `standard`,
        range: `Melee attack and 60 ft. (see text)`,
        target: `One or more creatures (see text)`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `sleepingGoddess`,
        level: 6,
        name: `Convert Intrusion`,
        type: `Counter`,
        shortDesc: `Make an Sense Motive check to transform an opponent's spell into a bonus on saving throws for your allies.`,
        longDesc: `With a practiced flourish of your weapon and a surge of spiritual might, you tear magic asunder and redirect its power to assist your allies. You can initiate this counter when in response to being targeted by or within the area of a power, psi-like ability, spell, or spell-like ability. Make a Sense Motive check with a DC of 11 + the effect's caster or manifester level. If you succeed, the effect is negated, and all allies within 30 feet of you gain a competence bonus on saving throws equal to 1/2 your initiation modifier for one round. \nAugment: You can augment this maneuver in one or more of the following ways:
    
    For every 2 power points you spend, the bonuses granted by this counter last an additional round.
    
    If you expend your psionic focus while initiating this counter, you can use it in response to an ally within 60 feet being targeted by or within the area of a power, psi-like ability, spell, or spell-like ability. If you do, make a Sense Motive check as normal, then apply the effects of this counter to that ally rather than yourself. Your allies within 30 feet of that ally gain the bonus on saving throws from this counter.`,
        initiationAction: `immediate`,
        range: `Personal and 30 ft. (see text)`,
        target: `You (see text)`,
        duration: `1 round (see text)`
      },
      {
        school: `sleepingGoddess`,
        level: 6,
        name: `Dreaming Nomad Strike`,
        type: `Strike`,
        shortDesc: `You teleport across the battlefield, striking multiple enemies.`,
        longDesc: `[teleportation]; You force reality around you to become dreamlike, eschewing the restrictions of distance and becoming a whirlwind of strikes flowing across the battlefield without needing to take a single step. When you initiate this strike, you may teleport to any space within 50 feet from which you could make a melee attack against an opponent. After you teleport, make a melee attack against that opponent. If it hits, it deals weapon damage as normal, and you can repeat this process, teleporting to a space within 50 feet of your new location. The maximum number of attacks you can make in this way is equal to one plus an additional attack for every four initiator levels you possess, and each attack is made at your highest attack bonus. You cannot attack an individual creature more than once during this strike. \nAugment: You can augment this maneuver in one or more of the following ways:
    
    For every power point you spend, this strike deals an additional 1d6 points of damage. For every 2d6 you increase the damage by, the distance you can teleport before each attack increases by 10 feet.
    
    For every 2 power points you spend, the maximum number of attacks you can make with this strike is increased by one.
    
    If you expend your psionic focus while initiating this strike, you may teleport to any open space within 50 feet at the conclusion of this strike, whether or not the strike ended because you missed an attack or because you made all possible attacks.`,
        initiationAction: `full-round`,
        range: `Melee attack and 50 ft. (see text)`,
        target: `One or more creatures (see text)`,
        duration: `Instantaneous`
      },
      {
        school: `sleepingGoddess`,
        level: 6,
        name: `Overpowering Optimism`,
        type: `Boost`,
        shortDesc: `You automatically regain psionic focus, and one of your maneuvers in the next three rounds is augmented for free.`,
        longDesc: `Your faith in yourself allows you to press the advantage further than most—by believing you can succeed, you change yourself into someone who will. When you initiate this boost, you instantly regain your psionic focus. In addition, you may augment a maneuver you initiate within the next three rounds without spending power points, gaining the benefits of the maneuver as if you had spent the maximum number of power points you could spend on that maneuver. You may not spend additional power points when augmenting a maneuver in this way, nor does this maneuver allow you to spend more power points than you would normally be allowed to.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `3 rounds`
      },
      {
        school: `sleepingGoddess`,
        level: 6,
        name: `Strike of Transfixed Awe`,
        type: `Strike`,
        shortDesc: `Your attack deals +6d6 damage and may stun the target. If the target is a spellcaster or manifester, they lose one of their highest- level spell slots and power points.`,
        longDesc: `Your strike momentarily alters the flow of magic around your opponent, viciously rending power from their mind. Make an attack. If it hits, it deals weapon damage as normal plus an additional 6d6 points of damage, and the target must succeed at a Will save (DC 16 + your initiation modifier) or become stunned for one round. In addition, if the target fails its save, you learn their caster level or manifester level (if any) and the target loses their highest level unexpended spell slot as if they had cast it (chosen at random) and power points equal to their manifester level. A target that cannot cast spells or does not possess power points is unaffected by this additional effect. \nAugment: You can augment this maneuver in one or more of the following ways:
    
    For every power point you spend, this strike deals an additional 1d6 points of damage. For every 2d6 you increase the damage by, the save DC of this strike increases by +1.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `sleepingGoddess`,
        level: 6,
        name: `Unavoidable Gaze of the Sleeping Goddess`,
        type: `Stance`,
        shortDesc: `You do not need to make Perception checks to notice creatures within 60 feet, gain a bonus on initiative checks, and can read the thoughts of those around you by expending psionic focus.`,
        longDesc: `You open your senses, gaining perfect awareness of the world around you with your enhanced perception. While you maintain this stance, you gain a bonus on initiative checks equal to your initiation modifier. You do not need to make Perception checks to notice creatures; you can detect and pinpoint all creatures within 60 feet. You also ignore miss chances granted by concealment, darkness, and invisibility, although you still must have line of effect to a creature or an object to discern it. In addition, you can expend your psionic focus as a move action to pierce creatures' minds as easily as your senses pierce darkness. For a number of rounds equal to your initiation modifier after activating this ability, you can read the surface thoughts of all creatures within 60 feet as if you had manifested the read thoughts power. A creature can make a Will save (DC 16 + your initiation modifier) to keep you from reading their thoughts. A creature that successfully saves against this effect is immune to having its surface thoughts read by this stance for 24 hours. You do not need to concentrate on this ability to maintain it. This use of this stance is considered a mind-affecting effect.`,
        initiationAction: `swift`,
        range: `Personal (see text)`,
        target: `You (see text)`,
        duration: `Stance`
      },
      {
        school: `sleepingGoddess`,
        level: 7,
        name: `Perfect Distillation of the Soul`,
        type: `Boost`,
        shortDesc: `You create a powerful weapon of ideals or empower your mind blade.`,
        longDesc: `Your soul's blade is unparalleled in form, shining as a beacon of your will and ideals, and carving through your foes as well as even the most powerful magic weapons. When you initiate this boost, a soul's blade appears in your hands, taking the form of a +5 melee weapon you are proficient with. Alternatively, you may create two soul's blades, each taking the form of an identical +4 melee weapons you are proficient with. A soul's blade created with this boost has hardness 20 and 50 hit points. Th blade lasts a number of rounds equal to your initiator level before vanishing. If you throw your soul's blade or otherwise relinquish your grip on it (such as by being disarmed), it dissipates after one round dissipates after one round unless you reclaim it. You can have multiple soul's blades created at once if you initiate this boost or other boosts that create a soul's blade multiple times, although only as many as you can wield. Alternatively, you can choose to amplify a weapon instead of this boost's normal effects. Until the start of your next turn, all weapons you wield (including those created after initiating this boost) gain the benefit of a single weapon special ability equivalent to up to +3 enhancement bonus. This ability must be chosen from the list of weapon special abilities you can normally place on a mind blade.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round/level (see text)`
      },
      {
        school: `sleepingGoddess`,
        level: 7,
        name: `Pierce the Soul`,
        type: `Strike`,
        shortDesc: `Your attack deals +7d6 damage and strikes at a creature connected to the target's mind or spirit, rather than the target.`,
        longDesc: `You deliver a deadly blow to an enemy with a familiar or similar bond, striking through the mystic ties between master and servant. Make an attack. If it hits, it deals weapon damage as normal plus an additional 7d6 points of damage. If your target is an animal companion, eidolon, familiar, psicrystal, or similar creature with a telepathic or empathic link to another creature (including creatures within a collective or under the effect of a mindlink power or telepathic bond spell, although not including creatures communicating with the telepathy ability), you can choose to deal this attack's damage to the creature that your target is linked to. The target can make a Will save (DC 17 + your initiation modifier) to negate this transfer of damage; if it succeeds, it takes the strike's damage as normal. The linked creature does not receive a saving throw against this effect. You automatically know whether or not the target is such a creature when this strike hits, although you do not learn the identity of the creature linked to it. If the target is linked to multiple other creatures, then the damage is transferred to one of them at random. This strike can transfer damage across any distance, although it cannot damage a creature on another plane of existence from the target. \nAugment: You can augment this maneuver in one or more of the following ways:
    
    For every power point you spend, this strike deals an additional 1d6 points of damage. For every 2d6 you increase the damage by, the save DC of this strike increases by +1.
    
    If you expend your psionic focus while initiating this strike, you deal damage to both the target and the linked creature. The target may still make a Will save to negate the damage being dealt to that creature.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature (see text)`,
        duration: `Instantaneous`
      },
      {
        school: `sleepingGoddess`,
        level: 7,
        name: `Soul-Crushing Mien`,
        type: `Counter`,
        shortDesc: `Gain a +4 bonus on a Will save, and possibly stun the effect's originator.`,
        longDesc: `[mind-affecting]; Your resolution proves dangerous, and able to damage minds that even slightly contact your own. You can initiate this maneuver when you are targeted or otherwise affected by an effect that requires a Will save. You gain a +4 bonus on that saving throw, and if you succeed, the originator of the effect becomes stunned for one round. \nAugment: You can augment this maneuver in one or more of the following ways:
    
    For every 2 power points you spend, the bonus on your Will save increases by +1.
    
    If you expend your psionic focus while initiating this counter, the originator of the effect is dazed for one round if you succeed on your Will save, rather than stunned. The creature still drops held items, takes a –2 penalty to its AC, and loses its Dexterity bonus to its AC (if any) as if it were stunned.`,
        initiationAction: `immediate`,
        range: `Personal (see text)`,
        target: `You (see text)`,
        duration: `1 round`
      },
      {
        school: `sleepingGoddess`,
        level: 8,
        name: `Indomitable Idealism`,
        type: `Counter`,
        shortDesc: `You avoid death, recreating yourself from the thoughts of onlookers.`,
        longDesc: `An idea cannot be killed as long as it still inhabits a mind. As a master of the Sleeping Goddess discipline, you have the ability to use this fact to your advantage, channeling overwhelming psionic power through yourself for a brief moment in order to become a living embodiment of your ideals and beliefs. You can initiate this counter when you would be killed or knocked unconscious, either through damage reducing you to 0 or fewer hit points or by an effect that kills you outright (such as a death effect or a vorpal weapon). You do not take the damage or are completely unaffected by the effect, and may move to a space adjacent to any creature within 100 feet that has seen you or otherwise knows who you are. This movement does not provoke attacks of opportunity, nor does it require line of sight or line of effect, although you must be aware that the creature in question is in range. To observers, you seem to vanish and reappear next to the creature, folding out of space and becoming to all eyes a near-flawless, ideal version of yourself for a few seconds before returning to your normal appearance.`,
        initiationAction: `immediate`,
        range: `Personal and 100 ft. (see text)`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `sleepingGoddess`,
        level: 8,
        name: `Self Beyond the Self`,
        type: `Strike`,
        shortDesc: `Your attack allows you to take control of the target's mind temporarily, as if by a Geth's mind control power.`,
        longDesc: `[compulsion, mind-affecting]With your studied understanding of the mind and its motivations, beliefs, and ideals, you can temporarily subvert the spirit of a foe, briefly making them into a staunch ally. Make an attack. If it hits, it deals weapon damage as normal, and the target must succeed at a Will save (DC 18 + your initiation modifier) or fall under your complete control for one round, as if you had affected them with the Dominate creature spell on them, \nAugment: You can augment this maneuver in one or more of the following ways:
    
    For every power point you spend, this strike deals an additional 1d6 points of damage. For every 2d6 you increase the damage by, the save DC of this strike increases by +1.
    
    If you spend 6 power points, the target is controlled for an additional round.
    
    If you expend your psionic focus while initiating this strike, you ignore any immunity to mind-affecting effects the target possesses. Instead, a normally-immune target gains a +5 resistance bonus on its saving throw.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instant (see text)`
      },
      {
        school: `sleepingGoddess`,
        level: 8,
        name: `Unimpeachable Authority of the Sleeping Goddess`,
        type: `Stance`,
        shortDesc: `Your presence causes opponents to become shaken, and you can focus your attention to panic an opponent for one round.`,
        longDesc: `[fear, mind-affecting]; You focus your spirit and belief, becoming a terrible and awe-inspiring sight; the world around you pales in comparison to your reality, and those who meet your eyes can feel your presence boring into their very soul. You may enter and maintain this stance even if you are immune to mind-affecting effects or fear effects. While you maintain this stance, opponents within 60 feet of you become shaken. This stance cannot create a stronger fear condition if an opponent is already shaken; affected opponents merely remain shaken while they remain within 60 feet of you (although other fear effects can do so as normal). In addition, as a move action, you can turn your attention to an opponent within 60 feet that can see or otherwise perceive you. That opponent must succeed at a Will save (DC 18 + your initiation modifier) or become panicked for one round. If you expend your psionic focus as part of using this ability, you ignore any immunity to mind-affecting or fear effects possessed by the target. Instead, a normally-immune target gains a +5 resistance bonus on its saving throw.`,
        initiationAction: `swift`,
        range: `Personal (see text)`,
        target: `You (see text)`,
        duration: `Stance`
      },
      {
        school: `sleepingGoddess`,
        level: 9,
        name: `Immortal Truths of the Sleeping Goddess`,
        type: `Strike`,
        shortDesc: `Your attack deals +10d6 damage, and if you would reduce the target to 0 or fewer hit points, you enter an instantaneous dialogue with them, potentially converting them to your way of thinking.`,
        longDesc: `[mind-affecting]; Standing at the pinnacle of the Sleeping Goddess discipline's students, you have the ability to share your beliefs in a way that no others can. By making contact with your opponent's mind and soul, you can open a dialogue, communicating your respective ideals instantaneously and debating their merits. Make an attack. If it hits, it deals an additional 10d6 points of damage. If this damage would reduce the target to 0 or fewer hit points, you can attempt to convert them to your way of thinking, clashing beliefs in a brief moment of spiritual contact. If you do, you and the target make an opposed ability check, with you using your initiation modifier and the target using its Charisma modifier. If the target succeeds, they take damage as normal, potentially killing them or knocking them unconscious.If you succeed, the target is instead reduced to 1 hit point, and their attitude towards you and your allies changes to helpful. This is not a compulsion, nor is it forcing the target to follow your orders, but rather the result of a spiritual conversation that took place in the instant of the strike. The target now understands your beliefs and ideals and either believes in them as well or respects your belief enough to be unwilling to oppose you. Regardless of whether or not the target succeeds on their check, you gain a deep understanding of their own beliefs and ideals. While you have this maneuver readied and unexpended, you automatically know the current hit point total of each creature within your melee reach. \nAugment: You can augment this maneuver in one or more of the following ways:
    
    For every power point you spend, this strike deals an additional 1d6 points of damage. For every 2d6 you increase the damage by, you gain a +1 bonus on your ability check.
    
    If you expend your psionic focus while initiating this strike, you ignore any immunity to mind-affecting effects the target possesses.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `solarWind`,
        level: 1,
        name: `Curving Ray Shot`,
        type: `Strike`,
        shortDesc: `Roll Perception check against target's AC, negate cover for this attack.`,
        longDesc: `The disciple's keen eyes allow him to fire his weapon around his foe's cover. The initiator makes an opposed Perception check against target's Armor Class before making a single ranged attack; if successful then the foe's cover is negated.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `solarWind`,
        level: 1,
        name: `Horizon Wind Lancet`,
        type: `Boost`,
        shortDesc: `Give a single ranged attack a +1d6 damage bonus.`,
        longDesc: `The tenets of the Solar Wind have taught the disciple how to place more force behind his attacks. The initiator inflicts an additional 1d6 points of damage on a single ranged attack he makes this round. If the initiator is making multiple attacks in this round, this bonus applies to the first attack the initiator makes.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `solarWind`,
        level: 1,
        name: `Phantom Sun Stance`,
        type: `Stance`,
        shortDesc: `Generate phantom ammunition for ranged attacks by copying a single weapon, arrow, or bolt.`,
        longDesc: `Using the principles of shadow and light, the Solar Wind disciple is capable of making phantom copies of his ammunition for use in combat. While in this stance, the initiator may make semi-real copies of arrows, bolts, bullets, or throwing weapons by willing them into existing as a free action while possessing at least one of the above on his person. Weapons that need reloading, such as crossbows and firearms, are fully reloaded as a move action (and if the character possesses the Rapid Reload feat, he may reload as a swift action). Magical properties, alchemical properties, or special materials of the ammunition are not copied, only the base properties of the ammunition (as if they were made of mundane steel with no special abilities or properties). Once the ammunition has been used, it disappears immediately after the attack. If the bow, firearm, sling, or cross bow making the attack has magical properties these are bestowed upon the ammunition. Thrown weapons copied by this stance are duplicates of the original, but do not manifest the material portion of the weapon, only it's magical enhancements, and this only works with actual weapons, not things treated as weapons. Once these weapons are used, they fade away immediately after use. This is a supernatural ability.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `solarWind`,
        level: 1,
        name: `Solar Sting`,
        type: `Strike`,
        shortDesc: `Turn a piece of ammunition or a ranged weapon into a field of caltrops.`,
        longDesc: `The Solar Wind disciple readies his attack and launches it into the sky. The weapon crashes down into the targeted area and creates a semi-real field of phantom caltrops. The initiator chooses a target area within range of his ranged attack, and makes an attack roll to hit that location (AC 5 plus any range penalties). The target area (one 10-ft. by 10-ft. square) becomes covered with phantom caltrops of softly glowing light that cause the area to be considered difficult terrain and act as vicious caltrops, using the initiator's initiation modifier as their attack bonus and inflicting 1d2 points of damage and halving the base speed of any they manage to hit. Targets are denied their armor bonus, shield bonus, and deflection bonus to AC against this attack, but if they're wearing boots or heavy foot gear they have a +2 armor bonus to their AC against this attack.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `10-ft. by 10-ft. square`,
        duration: `1 round / 2 initiator levels`
      },
      {
        school: `solarWind`,
        level: 1,
        name: `Stance of Piercing Rays`,
        type: `Stance`,
        shortDesc: `While in this stance fired ranged weapons / thrown weapons gain an additional 1d6 points of fire damage, +1d6/ eight initiator levels.`,
        longDesc: `A Solar Wind disciple learns to cause his ammunition to pierce like the burning rays of the sun itself. While in this stance, the initiator's ranged attacks inflict an additional 1d6 points of fire damage. This bonus damage increases by an additional 1d6 points of fire damage every eight initiator levels. This is a supernatural ability.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `solarWind`,
        level: 1,
        name: `Steady Hand`,
        type: `Boost`,
        shortDesc: `Increase the range on a ranged attacks by +30 ft..`,
        longDesc: `The disciple's limbs and muscles are strong and wise with the knowledge of weapons in flight. As a swift action, the initiator may increase the range of his ranged attacks by an additional 30-ft. for the first range increment (first increment only) for one round.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `solarWind`,
        level: 2,
        name: `Feel The Wind`,
        type: `Boost`,
        shortDesc: `Overcome environmental difficulties for ranged combat.`,
        longDesc: `By studying the wind and air around him, the Solar Wind disciple learns to overcome his surrounding's difficulties when using ranged weapons and may fire true. The initiator may ignore environmental variables such as high winds and storm and rain that would cause the initiator to suffer penalties to his attack rolls, magically created (such as wall of wind or control weather) or naturally caused such as in a gale force wind), when making ranged attacks for one round. This is a supernatural ability.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `One round`
      },
      {
        school: `solarWind`,
        level: 2,
        name: `Intercepting Shade`,
        type: `Counter`,
        shortDesc: `Make an opposed attack against an incoming attack against you or nearby ally, success negates the attack.`,
        longDesc: `Sometimes a good offense can be used as a good defense, so the Solar Wind discipline learns, as he uses his range to dissuade attacks by his sheer skill and exceptional aim. The initiator makes an opposed attack roll against his foe's attack roll on an incoming attack (such as an arrow or thrown weapon, a charging barbarian, or a skillful slash from a sword, but not a spell or similar attack) targeting himself or an ally he can see within his weapon's first range increment; if successful then the attack is negated.`,
        initiationAction: `immediate`,
        range: `Personal, or weapon's first range increment`,
        target: `You or ally`,
        duration: `Instantaneous`
      },
      {
        school: `solarWind`,
        level: 2,
        name: `Solar Lance`,
        type: `Strike`,
        shortDesc: `Ranged attack that inflicts an additional 2d6 damage and allows for a bull rush attempt as part of the strike.`,
        longDesc: `The disciple focuses his energies into his weapon and lets loose a powerful shot in a gusting wind. The initiator makes a ranged attack against his foe and if successful, the attack inflicts an additional 2d6 points of damage. The force of the wind that accompanies this blow is enough to potentially bull rush an opponent, allowing the initiator to make a free bull rush attempt as part of this attack, using his initiation modifier to calculate his CMB for the attempt with a +2 circumstance bonus. This is a supernatural ability.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `solarWind`,
        level: 3,
        name: `Blinding Ray Shot`,
        type: `Strike`,
        shortDesc: `Ranged attack becomes infused with blinding light.`,
        longDesc: `The disciple wraps incandescent light with the brightness of the midday sun around his weapon and lets fly at an opponent. The initiator makes an attack against a target creature and if successful, the target is blinded for 1d4 rounds. This is a supernatural ability.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instantaneous, 1d4 rounds`
      },
      {
        school: `solarWind`,
        level: 3,
        name: `Phantom Wind Ray`,
        type: `Boost`,
        shortDesc: `Next ranged attack is sheathed in dazzling light to obscure it, target must make an opposed Perception check to the attack roll or be caught flat-footed.`,
        longDesc: `The disciple's knowledge of the desert mirages caused by the sun grants him the ability to obscure his attacks, using gaps in a foe's perception. The target must make a Perception check opposed by the initiator's next attack roll against the target; if the Perception check fails then he is caught flat-footed against the attack and the attack is resolved against his flat-footed armor class. This is a supernatural ability.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `solarWind`,
        level: 3,
        name: `Solar Reflection`,
        type: `Strike`,
        shortDesc: `Make a ranged attack at a foe with a +2d6 damage bonus, if this attack is successful you can ricochet the shot to another enemy within 20 ft. using the same attack roll (no bonus damage).`,
        longDesc: `As reflective surfaces bounce the rays of the sun, so can the Solar Wind disciple ricochet a missile weapon from one target to another. The initiator makes a single ranged attack roll and if this roll is successful, he may apply this same attack roll against another opponent within 20-ft. of the first. This strike inflicts an additional 2d6 points of damage to the first target, and normal damage to the second target. Each reflection attack is considered a separate attack for the purposes of determining the effectiveness of single attack boosting abilities, such as boosts that affect one attack or spells like true strike. If the ammunition had special properties, the ammunition retains its properties on each attack until the strike ends.`,
        initiationAction: `full-round`,
        range: `Ranged attack`,
        target: `One or two targets, see description`,
        duration: `Instantaneous`
      },
      {
        school: `solarWind`,
        level: 3,
        name: `Sunwalker Stance`,
        type: `Stance`,
        shortDesc: `May make attacks while moving, +4 AC vs ranged attacks.`,
        longDesc: `Using the hunting techniques of the ancient days of the White Steppes, the Solar Wind disciple hunts on the move, making attacks while chasing down his prey. The initiator gains the benefits of the Shot on the Run feat (As a full-round action, you can move up to your speed and make a single ranged attack at any point during your movement) while in this stance (he does not need to meet the prerequisites of this feat), and he gains a +2 circumstance bonus to his armor class against attacks if he moves more than 10-ft. during his turn.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `solarWind`,
        level: 4,
        name: `Dazzling Solar Flare`,
        type: `Strike`,
        shortDesc: `Make a ranged attack against a foe, inflicts +4d6 points of fire damage and chance of dazing.`,
        longDesc: `With swift and deadly precision, the disciple attacks with the force of the scorching sun. The initiator makes a ranged attack against a foe, and if successful the attack inflicts an additional 4d6 points of fire damage and dazes the target on a failed Fortitude saving throw (DC 14 + initiation modifier) for 1d4 rounds. If the save is successful, the target is dazzled instead for one round. This is a supernatural ability.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `1d4 rounds`
      },
      {
        school: `solarWind`,
        level: 4,
        name: `Disarming Gust`,
        type: `Strike`,
        shortDesc: `Make a ranged disarming attack the inflicts 3d6 points of damage to the target and disarms them.`,
        longDesc: `A swift breeze and an explosion of agony is what the enemy of the disciple knows when this strike is used in battle as his sword hand is struck by the disciple's skillful attack. The initiator makes a ranged attack against the target's CMD using his initiation modifier to calculate his CMB in place of his Strength or Dexterity modifier (initiator's choice). The initiator also gains a +2 circumstance bonus to the CMD check. If successful, he inflicts 3d6 points of damage and the target is successfully disarmed.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `solarWind`,
        level: 4,
        name: `Solar Storm`,
        type: `Strike`,
        shortDesc: `Make a ranged attack at target creature or at the space it occupies, creates a brief but fierce cyclone that protects against and prevents ranged attacks.`,
        longDesc: `By wrapping the winds of tornadic force around his weapon and attacking a foe or the ground at a target's feet, the Solar Wind disciple may cause a brief tornado to wrap around a target and both shield and limit their abilities. The initiator makes an attack against either a target creature (inflicting damage as normal) or at the ground at a target creature's feet (friend or foe). The 5-ft. square that the target occupies or the targeted 5-ft. space itself becomes wrapped in a sheath of swirling tornado-like winds. The subject of this cannot be targeted by missile weapons of any kind (but spells can target him as normal) nor can the initiator make ranged attacks out of this storm (but spells may be cast as normal). If the creature tries to leave the area of effect of this maneuver, he must make a Reflex save (DC 14 + initiation modifier) or be forced to stay in that space, unable to make a move action or free 5-ft. step out of that space. If he succeeds or if the duration of 1d6 rounds expires, then the winds are dispersed and the target may act as normal. This is a supernatural ability.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature or 5-ft. space`,
        duration: `1d6 rounds`
      },
      {
        school: `solarWind`,
        level: 4,
        name: `Searing Break`,
        type: `Boost`,
        shortDesc: `All ranged attacks gain +3d6 points of fire damage for the round.`,
        longDesc: `By binding the light of the sun's rays into his weapons, the disciple of the Solar Wind may attack with the sun's burning heat. As a swift action, the initiator may add an additional 3d6 points of fire damage on all ranged attack for one round. This is a supernatural ability.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `One round`
      },
      {
        school: `solarWind`,
        level: 5,
        name: `Blinding The Bull`,
        type: `Boost`,
        shortDesc: `Automatically confirm a critical threat on a missile weapon attack.`,
        longDesc: `When a Solar Wind disciple finds the perfect shot, he makes sure that the attack is as destructive as a tornado on the plains. The initiator may use this boost to automatically confirm a critical threat he has made on a ranged attack.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `solarWind`,
        level: 5,
        name: `Double Solar Reflection`,
        type: `Strike`,
        shortDesc: `Shot strikes three targets with one attack roll. First target takes +4d6 damage, second takes +2d6 damage, third just takes weapon damage. No two targets can be more than 20 ft. apart.`,
        longDesc: `The disciple of the Solar Wind may bend and reflect his missile weapons as an illusionist may bend and reflect light with mirrors. The initiator makes a single ranged attack roll and if this roll is successful, he may apply this same attack roll against another opponent within 20-ft. of the first, and if this is also successful, he may use the same attack roll to strike a third target no farther than 20-ft. away (but not the original target). This strike inflicts an additional +4d6 points to the first target, +2d6 points of damage to the second, and normal damage to the third target. Each reflection attack is considered a separate attack for the purposes of determining the effectiveness of single attack boosting abilities, such as boosts that affect one attack or spells like true strike. If the ammunition had special properties, the ammunition retains its properties on each attack until the strike ends.`,
        initiationAction: `full-round`,
        range: `Ranged attack`,
        target: `Up to three creatures, see description`,
        duration: `Instantaneous`
      },
      {
        school: `solarWind`,
        level: 5,
        name: `Focused Solar Lance`,
        type: `Strike`,
        shortDesc: `Make an attack that if successful, inflicts an additional 5d6 points of damage and potentially pins target.`,
        longDesc: `The disciple raises his deadly weapon and lets loose an attack so powerful as to pin a target to the ground with a hurricane force wind. The initiator makes a ranged attack on a target and if successful, inflicts an additional 4d6 points of damage from the excessive force of the hit. Additionally, upon a successful hit, the initiator may make an immediate CMB check using his initiation modifier in place of Strength or Dexterity with a +2 circumstance bonus against the target's CMD. If this check is successful, the target is either pinned to the ground beneath him and is knocked prone and considered pinned, or is attached to a wall or tree or other object within a straight line of fire from the initiator and is considered pinned there if the target is within 5-ft. of said object or wall. Targets may not be pinned to other creatures. This maneuver does not function against flying targets.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        duration: `Instantaneous`
      },
      {
        school: `solarWind`,
        level: 5,
        name: `Solar Wind Lancet`,
        type: `Boost`,
        shortDesc: `Next ranged attack gains +4d6 points of damage for the round, potentially knocks foe down.`,
        longDesc: `With the mighty force of the Solar Wind, the disciple lets loose a missile with breath-stealing, devastating force. Upon initiating this boost, the next ranged attack that the initiator makes inflicts an additional 4d6 points of damage upon a successful attack and potentially knocks his target prone (a successful DC 15 + initiation modifier Fortitude save negates being knocked prone). This is a supernatural ability.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `One creature`,
        duration: `One turn`
      },
      {
        school: `solarWind`,
        level: 6,
        name: `Burning Break`,
        type: `Boost`,
        shortDesc: `All ranged attacks gain +5d6 points of fire damage for the round.`,
        longDesc: `The burning wrath of the sun itself takes root in the disciple's ammunition as he lets loose the wrath of the Solar Wind. All ranged attacks made by the initiator this round inflict an additional 5d6 points of fire damage. This is a supernatural ability.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `One round`
      },
      {
        school: `solarWind`,
        level: 6,
        name: `Solar Meteor Blow`,
        type: `Strike`,
        shortDesc: `High fired shot that when it lands on target inflicting +6d6 points of damage and creates a massive gust of wind capable of knocking surrounding foes down.`,
        longDesc: `The disciple of the Solar Wind wraps the force of a hurricane around his weapon before launching it high into the air to have it crash down amongst his enemies, scattering them to the ground. The initiator makes an attack against either a target creature inflicting an additional 6d6 damage to the target or at the ground at a target creature's feet. The 5-ft. square that the target occupies or the targeted 5-ft. space itself immediately sets of a powerful wave of air that potentially knocks enemies prone within a 15-ft. radius of the target on a failed Fortitude saving throw (DC 16 + initiation modifier; this including the target, who suffers a -4 penalty to this saving throw). This is a supernatural ability.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature or space, then a 15-ft. radius for the air blast`,
        duration: `Instantaneous`
      },
      {
        school: `solarWind`,
        level: 6,
        name: `True Shot Stance`,
        type: `Stance`,
        shortDesc: `Ignore concealment, double the threat range on ranged attacks.`,
        longDesc: `The Solar Wind disciple has honed his incredible senses and while in this stance uses his inner vision to strike his foes with his most deadly attacks. While in this stance, the initiator ignores a foe's partial concealment or any cover and he doubles the critical threat range on any ranged weapon he uses. Other effects that increase critical threat range, such as a keen weapon, do not stack with this effect.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `solarWind`,
        level: 6,
        name: `Twisting Wind Shot`,
        type: `Strike`,
        shortDesc: `Make a ranged attack, successful attack is treated as a critical hit.`,
        longDesc: `The keen vision of the Solar Wind disciple allows him to pick out the vulnerable spots on a foe's form and plant a missile directly into them. Make an attack roll against a foe which if successful inflicts damage as if the weapon had scored a critical hit, multiplying damage accordingly. This strike does count as a critical hit for the purposes of applying bonuses that activate with a successful critical hit, such as with critical feats. If the initiator scores a successful critical hit when initiating this strike, then the target is dazed for one round from the power of the attack.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `solarWind`,
        level: 7,
        name: `Phantom Sunstorm`,
        type: `Boost`,
        shortDesc: `Creates a hail of quasi- real weapons that strike with the real one, causing maximum damage on a single attack`,
        longDesc: `The disciple draws back one weapon and lets loose with a hundred. The initiator creates dozens of phantom weapons that cause very real injuries in addition to the one real weapon used in the attack. The initiator initiates this boost as part of an attack or strike. If the attack is successful, then it inflicts maximum damage. This is a supernatural ability.`,
        initiationAction: `swift`,
        range: `One ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `solarWind`,
        level: 7,
        name: `Stunning Solar Flare`,
        type: `Strike`,
        shortDesc: `Make a ranged attack against a foe, if successful the target takes an additional +8d6 points of damage and has a chance of being stunned.`,
        longDesc: `The Solar Wind disciple can steal the fight from an enemy with a single attack, such is his great skill. The initiator makes a ranged attack against a foe. If successful the attack inflicts an additional 8d6 points of damage and stuns the opponent on a failed Fortitude save (DC 17 + initiation modifier) for 1d3 rounds.`,
        initiationAction: `standard`,
        range: `30 ft.`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `solarWind`,
        level: 7,
        name: `Triple Solar Reflection`,
        type: `Strike`,
        shortDesc: `Shot strikes four targets with one attack roll. First target takes +6d6 damage, second takes +4d6 damage, third takes +2d6 damage, and the fourth attack takes normal damage. No two targets can be more than 20 ft. apart.`,
        longDesc: `The Solar Wind disciple has mastered the art of the ricochet shot and may target up to four attackers. The initiator makes a single ranged attack roll and if this roll is successful, he may apply this same attack roll against another opponent within 20-ft. of the first, and if this is also successful, he may use the same attack roll to strike a third target no farther than 20- ft. away (but not the original target), and again on a fourth target no farther than 20-ft. from the last. This strike inflicts an additional +6d6 points to the first target, +4d6 points of damage to the second, +2d6 on the third, and normal damage to the fourth, and final, target. Each reflection attack is considered a separate attack for the purposes of determining the effectiveness of single attack boosting abilities, such as boosts that affect one attack or spells like true strike. If the ammunition had special properties, the ammunition retains its properties on each attack until the strike ends.`,
        initiationAction: `full-round`,
        range: `Ranged attack`,
        target: `Up to four creatures, see description`,
        duration: `Instantaneous`
      },
      {
        school: `solarWind`,
        level: 8,
        name: `Aurora Break`,
        type: `Boost`,
        shortDesc: `All ranged attacks gain +8d6 points of fire damage for the round.`,
        longDesc: `The Solar Wind disciple masters the light of the sky and burns with a nimbus of colors from sunset to the far northern lights. All ranged attacks made by the initiator inflict an additional 8d6 points of fire damage for the round. This is a supernatural ability.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `One round`
      },
      {
        school: `solarWind`,
        level: 8,
        name: `Solar Hailstorm Stance`,
        type: `Stance`,
        shortDesc: `Gain 2 extra attacks on any full-round attack with a ranged weapon and add initiator attribute modifier to damage rolls.`,
        longDesc: `A master of the Solar Wind, the disciple may attack with the speed of the sun's rays. While in this stance and making a full attack, he may make two additional ranged weapon attacks using his full base attack bonus and he may add his initiation modifier to damage on these attacks. This is a supernatural ability.`,
        initiationAction: `swift`,
        range: `personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `solarWind`,
        level: 8,
        name: `Solar Wind Tsunami`,
        type: `Strike`,
        shortDesc: `With a single arrow or thrown weapon, generate a phantom wave of arrows in a 60-ft. cone, inflicts 15d6 + IL (+20 max) points of damage to all in the area of effect.`,
        longDesc: `The disciple holds aloft a glowing weapon which burns with the wrath of the Solar Wind, and lets it loose against his foes in a wave of destruction. The initiator creates a 60-ft. cone-shaped burst of quasi-real missiles that tear his foes to shreds. The attack inflicts 15d6 + initiator level (max +20) points of damage to all within the area of effect. Targets within may make a Reflex save (DC 18 + initiation modifier) to take half damage. The initiator need not loose his projectile weapon as part of this attack, retaining it to use at a later time. This is a supernatural ability.`,
        initiationAction: `standard`,
        range: `60-ft.Area: Cone shaped`,
        duration: `Instantaneous`
      },
      {
        school: `solarWind`,
        level: 9,
        name: `Solar Wind Nova`,
        type: `Strike`,
        shortDesc: `Fire a phantom volley of burning arrows into a 20-ft. burst hitting all targets within its area, inflicting 10d6 damage and 10d6 fire damage and may leave targets knocked prone.`,
        longDesc: `The true champion and master of the Solar Wind may unleash this devastating attack against all of his foes by unleashing his attack towards the sky where it splits apart into a deadly rain of phantom weapons and brilliant sunlight. The initiator picks a target creature or area as if he were using a grenade like weapon and a 20-ft. burst of burning phantom ammunition crashes down on this area, inflicting weapon damage as normal, plus 10d6 and 10d6 points of fire damage. The targets in the area of effect may make a Reflex save (DC 19 + initiation modifier) to reduce the damage by half. On a failed save, the targets are knocked prone from the force of the attack. This maneuver creates its own ammunition.`,
        initiationAction: `standard`,
        range: `Close (25-ft. + 5-ft. / 2 levels)Area: 20-ft. burst effect on targeted area or creature`,
        target: `All targets within area of effect`,
        duration: `Instantaneous`
      },
      {
        school: `steelSerpent`,
        level: 1,
        name: `Body of the Night`,
        type: `Stance`,
        shortDesc: `Add your ranks in Heal to your Stealth, bonus to attack against flat-footed foes.`,
        longDesc: `A wielder of the secrets of Steel Serpent knows his body and how to use it effectively in the art of stealth. By learning to manipulate his ki flows to obscure his movements from sight and hearing, using his body-control to mask the signs of his passage. The disciple may add his ranks in the Heal skill to his ranks in the Stealth skill when making a Stealth check while in this stance as a competence bonus. While in this stance, when making an attack against a flat-footed opponent or one that has been denied its Dexterity bonus to AC, the disciple gains a +4 competence bonus to attack rolls and inflicts an additional 1d6 points of damage. This is a supernatural ability.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `steelSerpent`,
        level: 1,
        name: `Dizzying Venom Prana`,
        type: `Boost`,
        shortDesc: `Next attack inflicts 2 points of Wisdom damage and staggers foe.`,
        longDesc: `By focusing his ki onto a weapon, the disciple readies a spiritual poison which dizzies and confuses the minds of his foes. After initiating this boost, the next melee or ranged attack that the disciple makes staggers his foe for 1 round. In addition, if the target fails a Fortitude save (DC 11 + initiation modifier), the target also suffers 2 points of Wisdom damage. This is a supernatural ability.`,
        initiationAction: `swift`,
        range: `Next melee attack or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `steelSerpent`,
        level: 1,
        name: `Hunting Serpent Blow`,
        type: `Strike`,
        shortDesc: `Disciple makes a Heal check, chance to make target flat-footed and inflict an additional 1d6 points of damage.`,
        longDesc: `The disciple hunts his foe through the emulation of a hunting serpent, obfuscating his true attack until the moment he strikes. The disciple makes a Heal check with a difficulty equal to his opponent's armor class. If this check is successful, then the target is made flat-footed and the disciple may make a melee attack against him, inflicting an additional 1d6 points of damage if successful. If this Heal check fails, then his opponent sees through this ruse, and the disciple makes his melee attack with a -2 penalty as the enemy is anticipating his attack.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `steelSerpent`,
        level: 1,
        name: `Poisoner's Stance`,
        type: `Stance`,
        shortDesc: `Gain poison use, increased DC on poisons.`,
        longDesc: `One of the first lessons of Steel Serpent disciples is the knowledge of mundane poisons and how to use them with expertise. While in this stance, the disciple gains the poison use class feature (the disciple no longer risks accidentally poisoning himself when attempting to apply poison to a weapon) and gains a +1 DC per two initiator levels as a competence bonus (maximum +10) to the saving throw DC's of any poison (mundane, magical, sting maneuver or prana maneuver) he applies through the use of this stance.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `steelSerpent`,
        level: 1,
        name: `Sting of the Rattler`,
        type: `Strike`,
        shortDesc: `Attack that inflicts an additional 1d4 points of damage plus 1d4 damage the following round.`,
        longDesc: `Disciples of Steel Serpent learn to emulate the swift and powerful strikes of the serpent kingdom and leave lasting wounds through the power of their ki. By focusing this harmful energy into a single attack, the disciple may cause more grievous injuries than his opponent would register immediately. The disciple makes an attack and if successful, inflicts an additional 1d4 points of damage. The following round on the disciple's turn, the enemy takes an additional 1d4 points of damage due to the venomous ki that has built up in the wound. This is a supernatural ability.`,
        initiationAction: `standard`,
        range: `Melee attack or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `steelSerpent`,
        level: 2,
        name: `Fading Dodge`,
        type: `Counter`,
        shortDesc: `As an immediate action, make a Heal check against your foe's attack roll; if successful, you evade the attack and may make a free dirty trick attempt.`,
        longDesc: `By using his knowledge of anatomy to contort away from a strike, the Steel Serpent disciple may bend away from an attacker's grasp and make a swift counter-offensive. As an immediate action, the disciple makes a Heal skill check against the attacker's roll to bend or otherwise contort himself to evade an attack. If successful he negates the attack and may make a free dirty trick attempt without provoking attacks of opportunity.`,
        initiationAction: `immediate`,
        range: `One attack`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `steelSerpent`,
        level: 2,
        name: `Iron Fang`,
        type: `Strike`,
        shortDesc: `Attack which ignores DR and inflicts an additional 2d6 points of damage and increases poison virulence.`,
        longDesc: `By hardening ki along edge of his weapon, the Steel Serpent disciple uses the pressure of his ki to penetrate the defenses of his foe. The disciple makes an attack against a foe which if successful inflicts an additional 2d6 points of damage and ignores any damage reduction the target may possess. Additionally, if the disciple is using poison or a prana maneuver with this strike, increase the saving throw DC by +2. This is a supernatural ability.`,
        initiationAction: `standard`,
        range: `Melee attack or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `steelSerpent`,
        level: 2,
        name: `Sting of the Asp`,
        type: `Strike`,
        shortDesc: `Attack that inflicts an additional 1d6 points of damage and 2 points of Strength damage, with an additional 2 points of Strength damage the following round.`,
        longDesc: `Through the use of this maneuver, the disciple readies a weakening dose of ki energy with his weapon's strike to sap his foe of its power. The disciple makes an attack against a target; if successful the strike inflicts an additional 1d6 points of damage and 2 points of Strength damage (Fortitude save DC 12 + initiation modifier; success halves this Strength damage). On the round following a failed save, the corrupted ki energies inflict an additional 1d6 points of damage and 2 additional points of Strength damage. This is a supernatural ability.`,
        initiationAction: `standard`,
        range: `Melee attack or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `steelSerpent`,
        level: 2,
        name: `Weakening Venom Prana`,
        type: `Boost`,
        shortDesc: `Next attack inflicts an additional 1d4 Strength damage.`,
        longDesc: `By forming a deadly weakening sheen of ki poison along his weapon, the disciple strikes at his foe's physical might. The next attack that the disciple makes inflicts 1d4 points of Strength damage to his opponent unless the foe succeeds on a Fortitude save (DC 12 + initiation modifier). This is a supernatural ability.`,
        initiationAction: `swift`,
        range: `Melee attack or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `steelSerpent`,
        level: 3,
        name: `Night's Knife`,
        type: `Boost`,
        shortDesc: `Grants a damage bonus equal to the number of ranks in Heal possessed.`,
        longDesc: `With the surgical precision of the striking serpent, the disciple lands an attack with exacting damage through his knowledge of anatomy. The initiator's attacks for the round gain a damage bonus equal to the number of ranks he possesses in the Heal skill.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `One turn`
      },
      {
        school: `steelSerpent`,
        level: 3,
        name: `Sickening Venom Strike`,
        type: `Strike`,
        shortDesc: `Attack which inflicts 2 points of Constitution damage and chance to sicken opponent.`,
        longDesc: `With a sharp jab of sickening ki energy, the Steel Serpent disciple can rob an enemy of his will to continue to fight as their body rebels against them. Make an attack against an opponent, and if this is successful, the strike inflicts an additional 2 points of Constitution damage and has the chance to sicken the target for 1d4 rounds. A successful Fortitude save (DC 13 + initiation modifier) negates the sickened effect. This is a supernatural ability.`,
        initiationAction: `standard`,
        range: `Melee attack or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous, 1d4 rounds`
      },
      {
        school: `steelSerpent`,
        level: 3,
        name: `Sight Piercing Fang`,
        type: `Strike`,
        shortDesc: `Attack which inflicts an additional 2d6 points of damage, blinds opponent.`,
        longDesc: `With the swiftness of a striking snake, the disciple makes a jab at his opponent's face to temporarily steal its vision. The disciple makes a melee attack against his target which if successful inflicts an additional 2d6 points of damage and the target must make a Reflex save (DC 13 + initiation modifier). If this save is unsuccessful, the target is blinded for 1 minute as his eyes are temporarily rendered useless.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `1 minute`
      },
      {
        school: `steelSerpent`,
        level: 3,
        name: `Steel Coils`,
        type: `Stance`,
        shortDesc: `Constrict for 4d6 + Dexterity modifier damage while grappling and +4 to natural armor.`,
        longDesc: `In this stance, the movements and motions of the disciple become more sinuous and deliberate, as if he were a serpent coiled to strike. While in this stance, the disciple may make grapple attempts without provoking attacks of opportunity, and if the disciple successfully grapples a foe, he may constrict his opponent to inflict 4d6 + his Strength modifier in damage. The manner in which he must carry himself in this stance, muscles taught and stiffened, grants him some degree of protection, adding a +4 bonus to his natural armor.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `steelSerpent`,
        level: 4,
        name: `Sting of the Adder`,
        type: `Strike`,
        shortDesc: `Attack that inflicts an additional 5d6 points of damage and 1d4 points of Wisdom damage, with an additional 2 points of Wisdom damage the following round.`,
        longDesc: `Striking with surety and precision, the disciple attacks the chakra of wisdom on his foe with his ki in an attempt to cloud his foe's mind. The disciple makes an attack against a target; if successful the strike inflicts an additional 5d6 points of damage and 1d4 points of Wisdom damage (Fortitude save DC equal to 14 + initiation modifier to halve this Wisdom damage). On the round following a failed save, the corrupted ki energies inflict an additional 1d6 points of damage and 2 additional points of Wisdom damage. This is a supernatural ability.`,
        initiationAction: `standard`,
        range: `Melee attack or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous, two rounds`
      },
      {
        school: `steelSerpent`,
        level: 4,
        name: `Poison Blood`,
        type: `Counter`,
        shortDesc: `When struck in combat, disciple's blood becomes venomous to the attacker.`,
        longDesc: `Every disciple of Steel Serpent has long accepted that in battle, sometimes the superior warrior gets injured. The Steel Serpent however, believes that for every wound inflicted upon the disciple, a wound must be inflicted upon the attacker. By forcing ki energies into his blood at the point of being wounded, the blood lost from this attack sprays at the disciple's foe as a caustic acid. To use this counter, the disciple must have been struck in combat by a slashing or piercing weapon. Upon the initiating of this counter, the attacker takes acid damage equal to twice the disciple's initiator level. This is a supernatural ability.`,
        initiationAction: `immediate`,
        range: `One attack that inflicts slashing or piercing damage`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `steelSerpent`,
        level: 4,
        name: `Rattler's Feint`,
        type: `Boost`,
        shortDesc: `Feint attempt to catch opponent flat-footed, +2 bonus to confirm critical hits.`,
        longDesc: `Just as the rattlesnake's tail serves as a distraction to its prey, the disciple of Steel Serpent learns to obscure his attack by causing his opponent to look where he wants him to. Upon initiating this boost, the disciple may make a free feint attempt against his opponent with a +4 competence bonus; if successful, the target loses his Dexterity modifier to his armor class per feint attempts. This feint attempt does not provoke attacks of opportunity. If the attack threatens a critical hit, add a +2 bonus to the confirmation of this critical.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `steelSerpent`,
        level: 4,
        name: `Tearing Fang`,
        type: `Boost`,
        shortDesc: `Attacks add +2d6 damage and causes 2 points of bleed damage for 1d4 rounds`,
        longDesc: `Weakening a foe with repeated nips and bleeding wounds will cripple them, so the Steel Serpent mantra goes, and then you may proceed with the kill. Each successful attack the disciple makes this turn against the target creature deals an additional 2d6 points of damage and causes the target to take an additional 2 points of bleed damage for 1d4 rounds following the attack. Additional applications of this maneuver stack for additional bleed damage, and further applications increase the duration by an additional 1d4 rounds for the total bleed damage. A successful Heal check (DC 15) or any magical effect that cures hit point damage will stop the bleeding.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `One creature`,
        duration: `Instantaneous, 1d4 rounds`
      },
      {
        school: `steelSerpent`,
        level: 5,
        name: `Burning Venom Prana`,
        type: `Boost`,
        shortDesc: `Next attack inflicts an additional 1d4 Wisdom damage.`,
        longDesc: `By focusing his ki along the edge of a close combat weapon, the disciple readies his energies to disrupt his foe's mind with burning mental fire. The next attack that the disciple makes inflicts 1d4 points of Wisdom damage to his opponent unless the foe succeeds on a (DC 15 + initiation modifier) Fortitude saving throw. This is a supernatural ability.`,
        initiationAction: `swift`,
        range: `One melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `steelSerpent`,
        level: 5,
        name: `Hooded Killer's Stance`,
        type: `Stance`,
        shortDesc: `Disciple gains +3d6 sneak attack dice and half the character's initiator level to Intimidate and Stealth checks.`,
        longDesc: `The disciple adopts the mannerisms and cold blooded nature of the hooded cobra, the lord of serpent kind. While in this stance, the disciple gains an additional +3d6 sneak attack dice (see rogue class feature) and a competence bonus to Intimidate and Stealth checks equal to half of his initiator level. If the disciple possessed the sneak attack class feature previously, the benefits of this stance stack with his class feature.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `steelSerpent`,
        level: 5,
        name: `Pressure Point Break`,
        type: `Boost`,
        shortDesc: `While grappling an opponent and inflicting damage, the character may add any sneak attack or deadly strike damage possessed plus an additional +2d6 damage.`,
        longDesc: `Just as the deadly coils of the constrictor snake may squeeze the life out of a foe, the Steel Serpent disciple has learned to use his knowledge of his foe's body against him in surprising ways. While in a grapple, the initiator may add any deadly strike or sneak attack damage he possesses to damaging attacks he makes while grappling, plus an additional 2d6 points of damage.`,
        initiationAction: `swift`,
        range: `One melee attack`,
        target: `One creature`,
        duration: `One round`
      },
      {
        school: `steelSerpent`,
        level: 5,
        name: `Steel Fang`,
        type: `Strike`,
        shortDesc: `Attack which ignores DR and inflicts an additional 8d6 points of damage, potential to daze an opponent, and increases poison virulence.`,
        longDesc: `The spiritual ki focus of the disciple is so intense that it gains armor piercing force when applied to a weapon or hand strike. The disciple makes an attack against an opponent, and if successful, the attack deals an additional 8d6 points of damage and bypasses all damage reduction the target may possess. The awesome force of the disciple's ki is so strong that it has the potential to daze the opponent on a failed Will save (DC 15 + initiation modifier) for one round. Additionally, if the disciple is using poison or a prana maneuver with this strike, increase the saving throw DC by +3. This is a supernatural ability.`,
        initiationAction: `standard`,
        range: `One melee attack or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `steelSerpent`,
        level: 6,
        name: `Blend with the Night`,
        type: `Boost`,
        shortDesc: `Discipline: Steel Serpent (Boost)Level: 6Prerequisites: Two Steel Serpent ManeuversInitiation Action: 1 swift actionRange: personalTarget: youDuration: One roundPractitioners of the Steel Serpent discipline are known for their ability to disappear while in plain sight and reappear moments later, unleashing their devastating skill upon a subject. The disciple who initiates this maneuvers gains the benefits of being under the effects of a greater invisibility spell for one round, and during that round, he gains 2d6 points of sneak attack damage per attack he makes that round (as per the rogue class feature). This is a supernatural ability.`,
        longDesc: `Practitioners of the Steel Serpent discipline are known for their ability to disappear while in plain sight and reappear moments later, unleashing their devastating skill upon a subject. The disciple who initiates this maneuvers gains the benefits of being under the effects of a greater invisibility spell for one round, and during that round, he gains 2d6 points of sneak attack damage per attack he makes that round (as per the rogue class feature). This is a supernatural ability.`,
        initiationAction: `swift`,
        range: `personal`,
        target: `you`,
        duration: `One round`
      },
      {
        school: `steelSerpent`,
        level: 6,
        name: `Spitting Cobra Stance`,
        type: `Stance`,
        shortDesc: `Increases damage done by thrown weapons and poison duration.`,
        longDesc: `Some serpents spit their venom, and as they are deadly at a distance so does the disciple learn to be deadlier at range with his attacks. When at range, thrown weapons inflict an additional 2d6 points of damage and throwing them does not provoke attacks of opportunity. Use of poison (mundane or magical poisons such as stings or prana maneuvers) are more vicious as well, adding +1 to each damage die or ability damage die rolled for its effect (effects with a flat number of damage increase this by +1).`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `steelSerpent`,
        level: 6,
        name: `Sting of the Viper`,
        type: `Strike`,
        shortDesc: `Attack that inflicts an additional 8d6 points of damage and 1d6 points of Charisma damage, with an additional 2 points of Charisma damage the following two rounds.`,
        longDesc: `The disciple reaches out and strikes at his opponents will and force of being, crushing his foe's chakras with his ki. The disciple makes an attack against a target which if successful inflicts an additional 8d6 points of damage and 1d6 points of Charisma damage (Fortitude save DC equal to 16 + initiation modifier to halve this Charisma damage). After a failed save, for the following two rounds, the corrupted ki energies inflict an additional 2d6 points of damage and 2 additional points of Charisma damage. This is a supernatural ability.`,
        initiationAction: `standard`,
        range: `Melee attack or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous, 3 rounds`
      },
      {
        school: `steelSerpent`,
        level: 6,
        name: `Virulence`,
        type: `Boost`,
        shortDesc: `Increase the DC on a single poison by +5`,
        longDesc: `Through intense focus, the disciple is capable of increasing the potency of venoms and poisons he uses by channeling his ki into them and twisting that energy. Use of this boost empowers one single mundane poison, sting, or prana with a +5 boost to the save DC of effect. This lasts until used, and the maneuver may not be recovered until it is expended, nor another maneuver readied in its place. This is a supernatural ability.`,
        initiationAction: `swift`,
        range: `Melee attack or ranged attack`,
        target: `One poison`,
        duration: `Until used`
      },
      {
        school: `steelSerpent`,
        level: 7,
        name: `Bite the Mongoose`,
        type: `Counter`,
        shortDesc: `Make a counter attack which inflicts 6d6 points of damage and 1d6 Constitution damage when struck in combat.`,
        longDesc: `Inevitably, the disciple of Steel Serpent will be struck in combat and through the use of this technique; he learns to make his foe regret its actions. Just as the cobra often poisons the foolish mongoose, so does the disciple of Steel Serpent poison his foe. Upon being struck in combat, the disciple takes advantage of the opening that his injury makes available and strikes out once with poisoned, life sapping ki energies. Make an immediate attack at full base attack bonus against the opponent that has successfully attacked you; if this attack hits it inflicts an additional 6d6 points of damage and 1d6 Constitution damage (Fortitude save DC 17 + initiation modifier halves this Constitution damage). This is a supernatural ability.`,
        initiationAction: `immediate`,
        range: `Melee attack`,
        target: `Target: `,
        duration: `ne attackerDuration:One attack`,
        savingThrow: `Fortitude half`
      },
      {
        school: `steelSerpent`,
        level: 7,
        name: `Desert Serpent Mirage`,
        type: `Counter`,
        shortDesc: `Make an opposed attack roll against an opponent's attack; if successful the foe losses sight of the disciple for one round.`,
        longDesc: `One of the Steel Serpent's teachings is that for a disciple to be successful, he must find his opponent's blind spot. By initiating this counter, the disciple learns to use his foe's attacks to blind it against him then take advantage of this impairment. The initiator makes an opposed attack roll against his foe's attack roll, and if successful the attacker misses the initiator who then gains total concealment from his foe 1d4 rounds. This is a supernatural ability.`,
        initiationAction: `immediate`,
        range: `Melee attack`,
        target: `One attacker`,
        duration: `1d4 rounds`
      },
      {
        school: `steelSerpent`,
        level: 7,
        name: `Numbing Venom Prana`,
        type: `Boost`,
        shortDesc: `Next attack inflicts an additional 2d4 Dexterity damage.`,
        longDesc: `By filling his next attack with chill and numbing ki energies, the Steel Serpent disciple strikes at the nervous energies that cause the body to move, draining away from the victim his grace and motor control. The next attack that the disciple makes inflicts an additional 2d4 points of Dexterity damage. A successful Fortitude save (DC 17 + initiation modifier) halves this. This is a supernatural ability.`,
        initiationAction: `swift`,
        range: `Melee attack or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `steelSerpent`,
        level: 7,
        name: `Silencing Strike`,
        type: `Strike`,
        shortDesc: `Swift throat punch that can silence opponent, deals an additional 8d6 points of damage.`,
        longDesc: `By focusing his ki and striking at a foe's throat chakra, he can close it temporarily and cut off the target's ability to speak. The disciple makes a melee attack and if successful the strike inflicts an additional 5d6 points of damage. On a failed Fortitude save (DC 17 + initiation modifier) the target is silenced and unable to speak or vocalize for 1d6 rounds. On a successful saving throw, the target is still unable to speak for one round. This is a supernatural ability.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous, 3 rounds`
      },
      {
        school: `steelSerpent`,
        level: 8,
        name: `Adamantine Fang`,
        type: `Strike`,
        shortDesc: `Powerful attack which ignores DR and deals an additional 12d6 damage, potential to paralyze an opponent. and increases poison virulence.`,
        longDesc: `When initiating this maneuver, the disciple congeals the totality of his ki along his weapon which glitters almost like a diamond just before he strikes. The disciple makes an attack against an opponent which if successful deals an additional 12d6 points of damage and bypasses all damage reduction the target may possess. The awesome force of the disciple's ki is so strong that it has the potential to paralyze the opponent on a failed Will save (DC 18 + initiation modifier) for one round. Additionally, if the disciple is using poison or a prana maneuver with this strike, increase the saving throw DC by +4. This is a supernatural ability.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous, 3 rounds`
      },
      {
        school: `steelSerpent`,
        level: 8,
        name: `Hooded Cobra Attitude`,
        type: `Stance`,
        shortDesc: `Gain gaze ability to temporarily paralyze a foe while focusing on them.`,
        longDesc: `[Mind-affecting, Compulsion]By adopting this stance, the disciple of Steel Serpent evokes the menacing dread of the hooded cobra. The weaving, hypnotic motions of that most venomous of serpents manifests in the lithe movements of the disciple, whose gaze paralyzes a foe with its intensity. The disciple gains a gaze attack with a range of 30- ft. Creatures coming within this range are shaken by the disciple's deadly presence and the glint of his eyes (Will save DC 18 + initiation modifier negates). When the disciple focuses his gaze (as an attack action) on a target, it may make a Will save (DC 18 + initiation modifier) to resist being paralyzed for 1d4 rounds by his hypnotic gaze. A successful save negates this effect. The disciple may only have one opponent paralyzed at a time. This is a mind-affecting, compulsion effect. This is a supernatural ability.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `steelSerpent`,
        level: 8,
        name: `Sting of the Cobra`,
        type: `Strike`,
        shortDesc: `Attack that inflicts an additional 12d6 points of damage and 2d4 points of Constitution damage, with an additional 2 points of Constitution damage the following two rounds.`,
        longDesc: `By focusing destructive, life-destroying ki into his attack, the Steel Serpent disciple strikes at the very heart of his foe's life force. The disciple makes an attack against a target. If successful the strike inflicts an additional 8d6 points of damage and 2d4 points of Constitution damage (Fortitude save DC equal to 18 + initiation modifier to halve this Constitution damage). Upon a failed save, on the following two rounds the corrupted ki energies inflict an additional 2d6 points of damage and 2 additional points of Constitution damage. This is a supernatural ability.`,
        initiationAction: `standard`,
        range: `Melee attack or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous, 3 rounds`
      },
      {
        school: `steelSerpent`,
        level: 9,
        name: `Five-Fold Hydra Sting`,
        type: `Strike`,
        shortDesc: `Chance to instantly slay target and destroy them entirely.`,
        longDesc: `<[Death]> A true master of the discipline of Steel Serpent possesses the knowledge how to use his skill, ki, and knowledge of the systems of living creatures, putting them to use for ending of a life. When a disciple initiates this maneuver and strikes a foe, he shows his deadly intent and knowledge in a display of terrible force, striking a foe's heart chakra and sending a cascade of poisonous ki through its body to annihilate the lifeforce of the target. The disciple makes an attack against a foe which if successful the target must make a Fortitude save (DC 19 + initiation modifier). If this save fails, the target is instantly slain as its body's energies revolt and consume it in a flash, reducing the body to ash (equipment is unharmed). If the target succeeds on this save, its body still suffers from the experience as the attack inflicts an additional 100 points of damage. If the target dies from this, its body also dissolves into ash. Victims slain by this attack cannot be resurrected normally; a wish or miracle spell must be cast first to restore the life-force of the victim's spirit before any raise attempt can be attempted. This is a supernatural ability.`,
        initiationAction: `standard`,
        range: `Melee attack or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`,
        additionalTags:["Death"],
      },
      {
        school: `tempestGale`,
        level: 1,
        name: `Disarming Shot`,
        type: `Strike`,
        shortDesc: `Your ranged attack attack allows you to make a ranged disarm attempt using Stealth in place of your CMB.`,
        longDesc: `Your careful training allows you to fire shots from an unexpected angle and strike opponents where they least expect it, their weapons. Make a ranged attack. If it hits, it deals weapon damage as normal, and you can make a disarm attempt against the target as a free action, using a Stealth check in place of your combat maneuver check. This disarm attempt does not provoke an attack of opportunity.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `tempestGale`,
        level: 1,
        name: `Distant Gale`,
        type: `Strike`,
        shortDesc: `Your ranged attack deals +1 damage for every 20 feet between you and the target (maximum +5).`,
        longDesc: `Firing with the strength of the winds at your back, you unleash an attack that becomes more dangerous the more distance it travels. Make a ranged attack. If it hits, it deals weapon damage as normal plus an additional +1 point of damage for every 20 feet of distance between you and the target (up to a maximum of +5).`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `tempestGale`,
        level: 1,
        name: `Eye of the Needle`,
        type: `Boost`,
        shortDesc: `Your next ranged attack against an opponent engaged in melee gains a +4 bonus.`,
        longDesc: `For most archers, an enemy engaged in melee is a difficult target at best, but for you a smaller target only presents greater opportunity. After you initiate this boost, your next ranged attack roll this round gains a +4 bonus if the target of the attack is engaged in melee.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `tempestGale`,
        level: 1,
        name: `Galebreaker's Stance`,
        type: `Stance`,
        shortDesc: `Your ranged attacks ignore wind effects and the wind wall spell.`,
        longDesc: `Your ability to accurately read the wind allows you to fight effectively even in the most adverse conditions. While you maintain this stance, you do not take any penalties on ranged attacks due to high wind speed, and your ranged attacks ignore the wind wall spell and similar magical wind effects that would adversely affect them.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `tempestGale`,
        level: 1,
        name: `Slipstream Strike`,
        type: `Strike`,
        shortDesc: `Your ranged attack ignores cover less than total cover.`,
        longDesc: `The most basic protection against an arrow is some form of cover, but you know many ways to negate this defense. Make a ranged attack, ignoring any cover bonuses to the target's AC. If it hits, it deals weapon damage as normal.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `tempestGale`,
        level: 1,
        name: `Sniper's Eye Stance`,
        type: `Stance`,
        shortDesc: `You reduce the penalty for making attacks at multiple range increments, and gain a bonus on ranged combat maneuver attempts.`,
        longDesc: `As a Tempest Gale disciple, distance is no obstacle to you. While you maintain this stance, you reduce the total penalty from attacking creatures beyond your weapon's first range increment by 2, and you gain a +2 bonus on combat maneuver checks made with ranged attacks. For every four initiator levels you possess, the penalty to ranged attacks lessens by another 2, and the bonus to ranged combat maneuver checks increases by +2.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `tempestGale`,
        level: 1,
        name: `Curved Arrow Stance`,
        type: `Stance`,
        longDesc: `If you make a ranged weapon attack and the target uses deflect arrows or a similar ability that automatically negates a ranged attack made against them, they must instead make an opposing attack roll to negate the ranged attack (or a relevant roll depending on the ability). If their ability instead allows them to make an opposing roll (such as cut from the air, or many martial counters) then they suffer a penalty to their roll equal to -2. The penalty increases by -1 every 3 levels.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `tempestGale`,
        level: 2,
        name: `Deflecting Shot`,
        type: `Counter`,
        shortDesc: `Make a Stealth check to disarm an opponent attacking an ally within 30 feet.`,
        longDesc: `You know well that a sudden shot can disrupt the enemy and remove a potential threat. You can initiate this counter in response to an attack being made against you or an ally within 30 feet of you. Make a ranged disarm attempt against the attacker, using a Stealth check in place of your combat maneuver check. If your disarm attempt is successful, the attack is negated (even if the weapon cannot actually be disarmed). This disarm attempt does not provoke an attack of opportunity.`,
        initiationAction: `immediate`,
        range: `30 ft. (see text)`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `tempestGale`,
        level: 2,
        name: `Distracting Draft`,
        type: `Boost`,
        shortDesc: `Make a Stealth check in place of Bluff to feint against a creature at range. Your next ranged attack against that target deals +1d6 damage if successful.`,
        longDesc: `Your well placed shot can both hurt the enemy and put them of their guard. Make a ranged feint attempt against a creature you can see, using a Stealth check in place of the normal Bluff check. If your feint is successful, your next ranged attack against that target within one round deals an additional 1d6 points of damage.`,
        initiationAction: `swift`,
        range: `Line of sight (see text)`,
        target: `One creature`,
        duration: `1 round`
      },
      {
        school: `tempestGale`,
        level: 2,
        name: `Dustcatching Breeze`,
        type: `Strike`,
        shortDesc: `Your ranged attack deals +2d6 damage and allows you to make a ranged dirty trick attempt using Stealth in place of your CMB.`,
        longDesc: `You target your enemy with unscrupulous tactics, throwing them of balance and allowing your allies to seize the advantage. Make a ranged attack. If it hits, it deals weapon damage as normal plus an additional 2d6 points of damage, and you can make a dirty trick attempt against the target as a free action, using a Stealth check in place of your combat maneuver check.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `tempestGale`,
        level: 2,
        name: `Piercing Shot`,
        type: `Strike`,
        shortDesc: `Shoot your weapon in a 30-foot line, dealing 3d6 damage (Reflex half).`,
        longDesc: `The power behind your ranged attacks is such that they can strike through one foe to pierce another behind them. When you initiate this strike, you create a 30-foot line that deals 3d6 points of damage. Creatures caught in the line can make a Reflex save (DC 12 + your initiation modifier) to take half damage.`,
        initiationAction: `standard`,
        range: `30 ft.Area: 30-ft. line`,
        duration: `Instantaneous`
      },
      {
        school: `tempestGale`,
        level: 2,
        name: `Sudden Gust`,
        type: `Strike`,
        shortDesc: `Your ranged attack deals +2d6 damage and allows you to make a ranged trip attempt using Stealth in place of your CMB.`,
        longDesc: `Your placed shot can knock an enemy to the ground as easily as a mighty sword swing. Make a ranged attack. If it hits, it deals weapon damage as normal plus an additional 2d6 points of damage, and you can make a trip attempt against the target as a free action, using a Stealth check in place of your combat maneuver check. This trip attempt does not provoke an attack of opportunity.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `tempestGale`,
        level: 3,
        name: `Battering Gale`,
        type: `Strike`,
        shortDesc: `Your ranged attack deals +3d6 damage and allows you to make a ranged bull rush attempt using Stealth in place of your CMB.`,
        longDesc: `Your arrows strike with such force that they can drive back even the mightiest foes. Make a ranged attack. If it hits, it deals weapon damage as normal plus an additional 3d6 points of damage, and you can make a bull rush attempt against the target as a free action, using a Stealth check in place of your combat maneuver check. This bull rush attempt does not provoke an attack of opportunity.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `tempestGale`,
        level: 3,
        name: `Cascading Draft`,
        type: `Boost`,
        shortDesc: `Your next ranged attack deals +2 damage for every 20 feet between you and the target (maximum +20).`,
        longDesc: `Reading the winds allows you to hit further and strike harder than any other martial artist. After you initiate this boost, your next ranged attack this round deals an additional +2 damage for every 20 feet of distance between you and the target (up to a maximum of +20 damage).`,
        initiationAction: `standard`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `tempestGale`,
        level: 3,
        name: `Disarming Blast`,
        type: `Strike`,
        shortDesc: `Your ranged attack deals +3d6 damage and allows you to make a ranged disarm attempt using Stealth in place of your CMB.`,
        longDesc: `With a combination of might and skill, you fire a shot that hits with such force it disarms the enemy. Make a ranged attack. If it hits, it deals weapon damage as normal plus an additional 3d6 points of damage, and you can make a disarm attempt against the target as a free action, using a Stealth check in place of your combat maneuver check. This disarm attempt does not provoke an attack of opportunity.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `tempestGale`,
        level: 3,
        name: `Tempest Gale Stance`,
        type: `Stance`,
        shortDesc: `You add your initiation modifier to damage rolls with ranged weapons and gain a bonus on ranged combat maneuver attempts and the save DCs oftempestGalemaneuvers equal to 1/4 your initiator level.`,
        longDesc: `You move as swiftly as the wind, and strike with all the fury of the storm. While you maintain this stance, you add your initiation modifier to damage rolls made with ranged weapons and gain a bonus on ranged combat maneuver checks and the save DCs of Tempest Gale maneuvers you initiate equal to 1/4 your initiator level (minimum +1).`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `tempestGale`,
        level: 4,
        name: `Cutting Gale`,
        type: `Strike`,
        shortDesc: `Your ranged attack deals +5d6 damage, automatically overcomes damage reduction, and may inflict a bleeding wound.`,
        longDesc: `Your arrows leave wounds which bleed more fiercely than the pinpricks of a thousand lesser archers. Make a ranged attack. If it hits, it deals weapon damage as normal plus an additional 5d6 points of damage and automatically overcomes damage reduction. In addition, a struck target must succeed at a Fortitude save (DC 14 + your initiation modifier) or take points of bleed damage equal to your initiation modifier. The target continues to bleed until the bleeding is stopped via magical healing or a successful DC 15 Heal check.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `tempestGale`,
        level: 4,
        name: `Exploding Gale`,
        type: `Strike`,
        shortDesc: `Your ranged attack deals +4d6 damage and explodes outwards, the shrapnel dealing damage to adjacent creatures equal to your initiation modifier.`,
        longDesc: `Even those who hide behind their fellows cannot save themselves from your deadly shots. Make a ranged attack. If it hits, it deals weapon damage as normal plus an additional 4d6 points of damage, and sparks and shrapnel explode from the attack, dealing damage to creatures adjacent to the target equal to your initiation modifier. Creatures other than the primary target can make a Reflex save (DC 14 + your initiation modifier) to avoid the damage.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature and adjacent squares (see text)`,
        duration: `Instantaneous`
      },
      {
        school: `tempestGale`,
        level: 4,
        name: `Iron Wind`,
        type: `Strike`,
        shortDesc: `Your ranged attack deals +4d6 damage and may stagger the target.`,
        longDesc: `A single powerful blow can leave an enemy reeling, and you excel at delivering such blows. Make a ranged attack. If it hits, it deal weapon damage as normal plus an additional 4d6 points of damage, and the target must succeed at a Fortitude save (DC 14 + your initiation modifier) or become staggered for a number of rounds equal to your initiation modifier.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `tempestGale`,
        level: 4,
        name: `Wind Tunnel`,
        type: `Boost`,
        shortDesc: `Your ranged attacks for one round do not take penalties for making attacks at multiple range increments.`,
        longDesc: `No foe can hide from your sharp eyes. After you initiate this boost, your ranged attacks for one round ignore any cover bonuses to the target's AC, and you do not take penalties on attack rolls from attacking creatures beyond your weapon's first range increment.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `tempestGale`,
        level: 5,
        name: `Blinding Shot`,
        type: `Strike`,
        shortDesc: `Your ranged attack deals +5d6 damage and may blind the target.`,
        longDesc: `With a skilled shot, you take your opponent's sight, and with it, the threat they pose. Make a ranged attack. If it hits, it deals weapon damage as normal plus an additional 5d6 points of damage, and the target must succeed at a Fortitude save (DC 15 + your initiation modifier) or become blinded for a number of rounds equal to your initiation modifier.`,
        initiationAction: `swift`,
        range: `Touch`,
        target: `1 piece of ammunition`,
        duration: `1 round / level; see text`,
        savingThrow: `Will negates harmless, object`
      },
      {
        school: `tempestGale`,
        level: 5,
        name: `Dancing Winds Stance`,
        type: `Stance`,
        shortDesc: `As long as you move at least 10 feet in a round, you gain improved evasion and a 20% miss chance against all attacks.`,
        longDesc: `The wind whips around you as you move, guarding you against attacks so long as you remain in motion. While you maintain this stance, in any round that you move at least 10 feet, you gain the benefits of the improved evasion ability and attacks made against you suffer a 20% miss chance until the start of your next turn.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `tempestGale`,
        level: 5,
        name: `False Wind`,
        type: `Counter`,
        shortDesc: `Make a ranged attack against an opponent that attacks an ally. If it hits, the ally can move up to their speed, even if it isn't their turn.`,
        longDesc: `You unleash a rapid shot that distracts or disables an enemy, preventing them from harming you or your ally. You can initiate this counter in response to an attack being made against you or an ally by a creature you can see. Make a ranged attack against that creature. If it hits, it deals weapon damage as normal, and the ally targeted by the creature you attacked can move up to their speed as a free action, even if it isn't their turn. This movement does not provoke attacks of opportunity.`,
        initiationAction: `immediate`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `tempestGale`,
        level: 5,
        name: `Grounding Shot`,
        type: `Strike`,
        shortDesc: `Your ranged attack deals +5d6 damage and if the target is flying, they must succeed at a Fly check opposed by your Stealth check or lose the ability to fly.`,
        longDesc: `Your slings and arrows can bring down even the mightiest fliers, dropping them to the earth where their wings mean nothing. Make a ranged attack. If it hits, it deals weapon damage as normal plus an additional 5d6 points of damage, and if the target of the attack is fling, they must succeed at a Fly check opposed by your Stealth check or lose their ability to fly for a number of rounds equal to your initiation modifier, falling to the ground and taking falling damage as normal.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `tempestGale`,
        level: 5,
        name: `Piercing Gale`,
        type: `Strike`,
        shortDesc: `Shoot your weapon in a 50-foot line, dealing 10d6 damage (Reflex half). Creatures that fail their saves are knocked prone.`,
        longDesc: `No foe can withstand the force of your weapons. When you initiate this maneuver, you create a 50-foot line that deals 10d6 points of damage. Creatures caught in the line can make a Reflex save (DC 15 + your initiation modifier) to take half damage. Any creature that fails its save is also knocked prone by the force of the attack.`,
        initiationAction: `standard`,
        range: `50 ft.`,
        target: `50-ft. line`,
        duration: `Instantaneous`
      },
      {
        school: `tempestGale`,
        level: 6,
        name: `Razor Tempest`,
        type: `Strike`,
        shortDesc: `Your ranged attack deals +8d6 damage and inflicts a bleeding wound.`,
        longDesc: `A scything wind seems to follow your attacks, leaving gashes that bleed profusely in the flesh of your enemy. Make a ranged attack. If it hits, it deals weapon damage as normal plus an additional 8d6 points of damage and bleed damage equal to your initiation modifier. The target continues to bleed until the bleeding is stopped via magical healing or a successful DC 15 Heal check.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `tempestGale`,
        level: 6,
        name: `Trick of the Wind`,
        type: `Boost`,
        shortDesc: `Use Stealth check in place of attack roll for ranged attacks for one round.`,
        longDesc: `Your skill at reading the wind is such that the very air itself seems to bend to your will. After initiating this boost, you can make a Stealth check in place of ranged attack rolls for your ranged attacks this round. Any bonuses and penalties that would be applied to a normal attack roll, such as weapon enhancements, spell effects, or the penalties for fighting with two weapons or shooting into melee, are applied to the skill check as well.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `tempestGale`,
        level: 6,
        name: `Wind Lance`,
        type: `Strike`,
        shortDesc: `Your ranged attack deals double damage, or triple damage if used at the end of a charge with a thrown weapon.`,
        longDesc: `Your attacks strike with the force of a mounted cavalry charge. Make a ranged attack. If it hits, it deals deals double damage. If you make this attack with a thrown weapon at the end of a charge, the attack instead deals triple damage.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `tempestGale`,
        level: 6,
        name: `Winds of Vengeance Stance`,
        type: `Stance`,
        shortDesc: `You can make additional attacks of opportunity equal to your initiation modifier and opponents that hit allies provoke a ranged attack of opportunity from you.`,
        longDesc: `Every move that your enemies make is an opportunity for you, and one that you relish taking advantage of. While you maintain this stance, you can make a number of additional attacks of opportunity each round equal to your initiation modifier. This stacks with the Combat Reflexes feat and other effects that increase the number of attacks of opportunity you can make in a round. In addition, any time an enemy hits an ally within 60 feet of you with an attack, you can make an attack of opportunity against that enemy using a ranged weapon you are wielding.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `tempestGale`,
        level: 7,
        name: `Black Wind`,
        type: `Strike`,
        shortDesc: `Shoot your weapon in a 50-foot line, dealing 15d6 damage (Reflex half). Creatures that fail their saves must also make a Fortitude save or become dazed for one round.`,
        longDesc: `You unleash a mighty shot that thunders through enemy lines, knocking aside any in its path. When you initiate this maneuver, you create a 50-foot line that deals 15d6 points of damage. Creatures caught in the line can make a Reflex save (DC 17 + your initiation modifier) to take half damage. Any creature that fails its Reflex save must also succeed at a Fortitude save with the same DC or become dazed for one round.`,
        initiationAction: `standard`,
        range: `50 ft.`,
        target: `50-ft. line`,
        duration: `Instantaneous`
      },
      {
        school: `tempestGale`,
        level: 7,
        name: `Hunting Zephyr`,
        type: `Strike`,
        shortDesc: `Your ranged attack automatically hits and threatens a critical hit.`,
        longDesc: `As a master of the Tempest Gale, you never miss your mark; each shot is perfect. Make a ranged attack. This attack automatically hits, threatens a critical hit, and cannot be negated by the Deflect Arrows feat, a counter, or another defensive ability activated as an immediate action (such as the emergency force sphere spell or a similar effect). It deals weapon damage as normal.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `tempestGale`,
        level: 7,
        name: `Punishing Tempest`,
        type: `Boost`,
        shortDesc: `Your ranged attacks for one round allow you to make ranged bull rush attempts against the targets, using Stealth in place of your CMB.`,
        longDesc: `Each shot you fire contains the force necessary to drive back even the sturdiest opponent, or knock them of their feet. After initiating this boost, whenever you hit a creature with a ranged attack for one round, you can make a bull rush attempt against that creature as a free action, using a Stealth check in place of your combat maneuver check. These bull rush attempts do not provoke an attack of opportunity.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `tempestGale`,
        level: 8,
        name: `Breath Stealing Wind`,
        type: `Strike`,
        shortDesc: `Your ranged attack deals +10d6 damage and silences the target.`,
        longDesc: `You fire a single shot that steals the very breath from his target. Make a ranged attack. If it hits, it deals weapon damage as normal plus an additional 10d6 points of damage, and the target must succeed at a Fortitude save (DC 18 + your initiation modifier) or become silenced (as the spell) for a number of rounds equal to your initiation modifier.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `tempestGale`,
        level: 8,
        name: `Eye of the Storm Stance`,
        type: `Stance`,
        shortDesc: `You You add your initiation modifier to damage rolls with ranged weapons, ignore cover and concealment less than total, and ignore weather and winds on your attacks (including magical winds such as a wind wall spell).`,
        longDesc: `Like the calm winds at the center of a hurricane, you are bastion of serenity on the chaos of the battlefield. While you maintain this stance, you add your initiation modifier to damage rolls made with ranged weapons, you do not take penalties on attack rolls from attacking creatures beyond your weapon's first range increment, and ignore the effects of weather conditions and wind effect on your ranged attacks (including magical winds such as a wind wall spell). In addition, your ranged attacks ignore the AC bonus granted to targets by anything less than total cover, and the miss chance granted to targets by anything less than total concealment.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `Self`,
        duration: `Stance`
      },
      {
        school: `tempestGale`,
        level: 8,
        name: `Steel Tornado`,
        type: `Strike`,
        shortDesc: `Your ranged attack deals +10d6 damage and allows you to make a ranged trip attempt using Stealth in place of your CMB. In addition, you can make a ranged disarm attempt against them for each item they are holding.`,
        longDesc: `Your masterful shot spins your enemy around with incredible force, causing them to lose their grip and their balance. Make a ranged attack. If it hits, it deals weapon damage as normal plus an additional 10d6 points of damage, and you can make a trip attempt against the target as a free action. In addition, you can make a disarm attempt against the creature for each item it is holding or wielding. These combat maneuver attempts use a Stealth check in place of your combat maneuver check, and do not provoke attacks of opportunity.`,
        initiationAction: `standard`,
        range: `Ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `tempestGale`,
        level: 9,
        name: `Vicious Tempest Volley`,
        type: `Strike`,
        shortDesc: `You make a full attack with your ranged weapon, with each hit dealing +2d6 damage and allowing you to make a ranged bull rush, dirty trick, disarm, sunder, or trip attempt using Stealth in place of your CMB.`,
        longDesc: `Unleashing the might of the winds to carry your attacks throughout the battlefield, you launch a hail of arrows, bolts, stones or weapons to devastate your enemies. Make a full attack with any ranged weapon you are wielding. Each attack deals an additional 2d6 points of damage, and any time you hit with an attack during this full attack, you can make a bull rush, dirty trick, disarm, sunder, or trip attempt against the creature struck as a free action. These combat maneuver attempts use a Stealth check in place of your combat maneuver check, and do not provoke attacks of opportunity.`,
        initiationAction: `full-round`,
        range: `Ranged attack`,
        target: `One or more creatures (see text)`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 1,
        name: `Inner Sphere Stance`,
        type: `Stance`,
        shortDesc: `When wielding two weapons, disciple gains +2 dodge bonus to AC and a +2 bonus to Will saves.`,
        longDesc: `A defensive stance that focuses on using the disciple's dance-like movements to confound his foe, Inner Sphere Stance allows the disciple to use erratic movements to defend himself and bolster his confidence. When wielding two weapons while in this stance, the disciple gains a +2 dodge bonus to AC and a +2 morale bonus to Will saves. These bonuses increase by +1 when the character's initiator level reaches 6th, and increases again by +1 at 12th and 18th initiator level.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `thrashingDragon`,
        level: 1,
        name: `Leaping Dragon`,
        type: `Boost`,
        shortDesc: `Make an Acrobatics check to jump as a swift action with a +10 bonus.`,
        longDesc: `As a dragon takes wing, his powerful legs thrust him skyward as his wings spread out to clutch the air. The disciple of the Thrashing Dragon uses this technique to suddenly launch himself into the air as if he were attempting flight. The initiator may make an Acrobatics check to jump as a swift action, and he gains a +10 competence bonus to his Acrobatics check and is treated as if he had a running start.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 1,
        name: `Offensive Roll`,
        type: `Strike`,
        shortDesc: `Move by an opponent and make a Acrobatics check against target's AC, if successful, the target is flat-footed and the strike inflicts +1d6 points of damage.`,
        longDesc: `As the disciple moves by his opponent, he may drop into a tumbling roll and strike at it from a surprising angle. The initiator must move at least 10 ft. alongside an enemy (which provokes attacks of opportunity unless the initiator is using Acrobatics to tumble) and make a Acrobatics check with a DC equal to the target's Armor Class. If successful, the target is considered flat-footed and the strike inflicts an additional 1d6 points of damage. The character initiating this maneuver may move up to his full base speed, making the attack along any point of the moment.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 1,
        name: `Outer Sphere Stance`,
        type: `Stance`,
        shortDesc: `When wielding two weapons, disciple inflicts an additional 1d6 points of damage per attack, -2 to AC.`,
        longDesc: `The Thrashing Dragon disciple flips both of his blades down and concentrates solely on slaying his foe without heed to his own life. When wielding two weapons while in this stance, the disciple gains +1d6 points of damage with his weapons and suffers a -2 penalty to AC. The AC penalty to this decreases by 1 once the character's initiator level reaches 8th, and is negated at 16th initiator level. Upon reaching 10th initiator level, the bonus damage increases to 2d6.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `thrashingDragon`,
        level: 1,
        name: `Swift Claws`,
        type: `Strike`,
        shortDesc: `Attack a single target with two wielded weapons.`,
        longDesc: `The Thrashing Dragon disciple's skill with his dual weapons allows him to strike with practiced speed and alacrity, allowing him to make an attack with two wielded weapons (or unarmed strikes), using the same attack action. Creatures with more than two arms may still only strike with two wielded weapons.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 1,
        name: `Wyrmling's Fang`,
        type: `Strike`,
        shortDesc: `Thrown weapon inflicts an additional 1d6 points of damage.`,
        longDesc: `With a quick flick of his wrist, the disciple hurls a blade deeply into his foe with blinding speed. The initiator must make a ranged attack against a target by throwing a light weapon with a range increment (such as a dagger) or a weapon from an associated Thrashing Dragon weapon group (improvised weapon penalties apply if applicable). If this attack is successful, the attack inflicts an additional 1d6 points of damage.`,
        initiationAction: `standard`,
        range: `Thrown`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 2,
        name: `Flash Kick`,
        type: `Boost`,
        shortDesc: `Make an additional unarmed attack as part of a full attack action at a -2 penalty to hit but the attack gains +2d6 points of damage.`,
        longDesc: `As part of a full attack action, the disciple may make a powerful and swift kick while his blades strike. The initiator makes an additional unarmed strike against a target as part of his full attack action at his full attack bonus but suffers a -2 penalty. If this attack hits then it inflicts an additional 2d6 points of damage. The character does not provoke attacks of opportunity for not possessing the Improved Unarmed Strike feat when using this strike, but damage is only considered lethal if the character does possess that feat or weapon that would be worn on one's foot.`,
        initiationAction: `swift`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 2,
        name: `Flick of the Wrist`,
        type: `Strike`,
        shortDesc: `Make at least two successful attack rolls with two weapons on a full attack action with a +2 bonus, if successful gain a free disarm attempt.`,
        longDesc: `With two rapid slaps from his blades, the Thrashing Dragon disciple's ferocity puts an opponent off balance and with a flick of the wrist the disciple takes away the weapon of his foe. The initiator makes two rapid attack rolls at his full base attack bonus against the target's AC with a +2 bonus. If both attacks are successful, the target is disarmed of his primary weapon (no roll needed). Resolve damage from the two attacks made as part of this strike as normal. If the target is using natural attacks or the target has a locked gauntlet, then this maneuver is ineffective for disarming a foe.`,
        initiationAction: `full-round`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 2,
        name: `Reflexive Twist`,
        type: `Counter`,
        shortDesc: `Make an Acrobatics check in place of a Reflex save.`,
        longDesc: `With his athletic abilities and reflexes honed to a razor's edge, the Thrashing Dragon disciple may incorporate reflexive evasions into his fighting dance at a moment's notice to defend himself from danger. When making a Reflex save, the initiator may instead make an Acrobatics check in place of his Reflex saving throw bonus to determine his success.`,
        initiationAction: `immediate`,
        range: `One melee attack`,
        target: `Personal`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 2,
        name: `Sun Dips Low`,
        type: `Counter`,
        shortDesc: `Make an opposed Acrobatics check against an attack to negate it.`,
        longDesc: `With a sudden, darting movement the Thrashing Dragon disciple may dodge an attack and protect himself from harm, if perfectly timed. The disciple opposes an enemy's attack roll by making an Acrobatics check. If successful then he successfully evades the attack. If not, he is struck by the blow as normal.`,
        initiationAction: `immediate`,
        range: `One melee attack`,
        target: `Personal`,
        duration: `Instant`
      },
      {
        school: `thrashingDragon`,
        level: 2,
        name: `Sweeping Tail`,
        type: `Strike`,
        shortDesc: `Make a trip attack against a foe with a +4 bonus to the attempt., inflicts 2d6 + initiation modifier damage.`,
        longDesc: `Within his battle dance, the disciple dips low and sweeps his leg out to knock an opponent down. The disciple makes a trip attempt which does not provoke attacks of opportunity, and he gains a +4 bonus to this check. Creatures successfully tripped suffer 2d6 + the initiator's initiation modifier in damage from the heavy fall.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 3,
        name: `Ancient's Fang`,
        type: `Strike`,
        shortDesc: `Thrown weapon inflicts an additional 4d6 points of damage`,
        longDesc: `With a powerful overhand throw, the Thrashing Dragon disciple hurls one of his blades into his foe's form with force and power rivaling the snapping jaws of an ancient dragon. The initiator must make a ranged attack against a target by throwing a weapon with a range increment (such as a dart, dagger or shuriken) or an improvised throwing weapon (normal rules and penalties apply for improvised weapons). If this attack is successful, the attack inflicts an additional 4d6 points of damage.`,
        initiationAction: `standard`,
        range: `One ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 3,
        name: `Battle Dragon's Stance`,
        type: `Stance`,
        shortDesc: `Reduce penalties of two-weapon fighting by 2, +4 to Initiative checks and adds 1d6 + initiation modifier to damage while two-weapon fighting.`,
        longDesc: `The Battle Dragon's Stance shows the disciple how to balance his fighting style and through this centering of being, he may find speed, finesse, and power. While in the Battle Dragon's Stance, the disciple reduces his two-weapon fighting penalties by 2, and gains a +4 bonus to Initiative checks and adds 1d6 + initiation modifier to melee damage while fighting with two weapons. Whenever you make a full-round attack with at least 2 weapons that is not part of a strike, you can choose to gain a <flurry> combo point.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `thrashingDragon`,
        level: 3,
        name: `Fangs Strike Low`,
        type: `Strike`,
        shortDesc: `Make two successful attack rolls, halve target's land speed and inflicts 1d6 bleed damage per round for 3 rounds or until healed.`,
        longDesc: `By forcing an opponent's guard up, the Thrashing Dragon spins low and attacks at the legs of the target to reduce his mobility and cause deep, flensing wounds. Upon successfully striking a target in melee combat with this maneuver, in addition to weapon damage the initiator's attack halves the target's land speed and inflicts 1d6 points of bleed damage per round for three rounds or until the target has been healed (magically or by a successful DC 15 Heal check).`,
        initiationAction: `standard`,
        range: `One melee attack`,
        target: `Personal`,
        duration: `3 rounds`
      },
      {
        school: `thrashingDragon`,
        level: 3,
        name: `Vicious Swipe`,
        type: `Strike`,
        shortDesc: `Make a successful melee attack, attack inflicts an additional +3d6 and potentially dazes opponent.`,
        longDesc: `The disciple's combat style allows him to get in close to a target and strike beneath its guard, dealing a powerful blow and potentially knocking it senseless for a few moments. The initiator makes a melee attack, and if successful the attack inflicts an additional 3d6 points of damage and potentially dazes the opponent for 1d4 rounds (Fortitude save DC 13 + initiation modifier negates the dazed condition).`,
        initiationAction: `standard`,
        range: `One melee attack`,
        target: `One creature`,
        duration: `Instantaneous, up to 4 rounds`
      },
      {
        school: `thrashingDragon`,
        level: 4,
        name: `Devastation Roll`,
        type: `Strike`,
        shortDesc: `Move by an opponent and make a successful Acrobatics check against the target's AC, if successful, make an attack against the target's flat-footed AC and the attack inflicts an additional 6d6 points of damage.`,
        longDesc: `The martial disciple's movements are so quick and precise, his deadly strikes are hard to evade. With a sudden twist and jump through the opponent's defenses, the disciple strikes hard into the exposed and undefended foe. The initiator must move at least 10-ft. through two spaces that his opponent threatens and make a Acrobatics check equal to the target's CMD (this roll counts as both a check to use the maneuver as well as to negate potential attacks of opportunity from moving through a threatened area). If successful, make an attack against the target's flat-footed Armor Class, and the attack inflicts an additional 6d6 points of damage.`,
        initiationAction: `standard`,
        range: `One melee attack`,
        target: `One creature`,
        duration: `One round`
      },
      {
        school: `thrashingDragon`,
        level: 4,
        name: `Dragon Assault`,
        type: `Strike`,
        shortDesc: `Make a full-round attack, each successive melee attack inflicts an additional 1d6 points of damage more than the previous one (maximum +5d6 per successful attack).`,
        longDesc: `By unleashing his full wrath against his enemies, a Thrashing Dragon disciple is capable of inflicting incredibly powerful blows that get more potent per successive hit. The initiator makes a full-round attack against a target(s), the first successful hit inflicting normal damage. Each subsequent successful attack inflicts an additional 1d6 points of damage that carry over to the next attack, the third attack inflicting +2d6 damage, the fourth +3d6 damage and so on to a maximum of +5d6 on all subsequent attacks.`,
        initiationAction: `full-round`,
        range: `One melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 1,
        name: `Spined Wing Assault`,
        type: `Strike`,
        longDesc: `Make a full-attack action. For every successful attack you make during it, it deals damage as normal and you gain a stacking +1 shield bonus to your armor class until the start of your next turn. Whenever a creature makes a melee attack against you and misses by an amount less than the shield bonus granted, they take damage equal to your off-hand attack's damage dice, plus its enhancement bonus.`,
        initiationAction: `full-round`,
        range: `melee`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 3,
        name: `Black Fang`,
        type: `Strike`,
        longDesc: `The initiator makes a full-round attack against a target, with the exception of his attack at his highest bonus, which he saves for his final strike. For every attack you successfully hit, your final strike gains a flat +1 bonus to its critical threat range. For every attack that you roll within your critical threat range, it automatically fails to confirm, but your final strike has its critical damage multiplier increased by a +1. Once all of your other attacks are made, you make your final strike against the target, if it hits, the target also must make a fortitude save or be stunned for 1 round. If the final strike is a confirmed critical hit, it receives a penalty to its save equal to 2x the amount of other attacks this round you have successfully landed.`,
        initiationAction: `full-round`,
        range: `melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 4,
        name: `Dragon Rush`,
        type: `Boost`,
        shortDesc: `Upon a successful attack, make an immediate kick which inflicts an additional 3d6 points of damage.`,
        longDesc: `With the ferocity of a dragon, the disciple follows through a successful attack with a vicious kick to his foe to keep punishing the fool who would stand before the might of a Thrashing Dragon. Upon successfully striking a foe as part of an attack, martial strike, or a full attack, he may as a swift action use this maneuver to deliver a vicious kick at his full attack bonus with his unarmed strike. This attack inflicts an additional 3d6 points of damage.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `One round`
      },
      {
        school: `thrashingDragon`,
        level: 4,
        name: `Sharpened Talons`,
        type: `Boost`,
        shortDesc: `When two-weapon fighting , the disciple inflicts an additional 2d6 points of damage for one round.`,
        longDesc: `As a dragon might drag his claws across a castle wall to hone their edge, the disciple has learned to give his own attacks a deadly edge for his next attack. When two-weapon fighting, the disciple's attacks with those weapons inflict an additional 2d6 points of damage for the round and they have their critical threat range increased by a flat +1. Whenever you confirm a critical hit during the round with one of your weapons when two-weapon fighting, your critical threat range with the other weapon increases by a further flat +1.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 5,
        name: `Bend with the Wind`,
        type: `Stance`,
        shortDesc: `Gain +2 to AC successively until next turn or take a free 5 ft. step whenever an attack misses the initiator.`,
        longDesc: `The graceful, flowing movements of the Thrashing Dragon's dance helps defend the disciple in combat while providing him the ability to move through danger unscathed. While in this stance, for each attack that misses the disciple, he may either gain a +2 dodge bonus until his next turn, or he may make a free 5-ft. step to any square his attacker threatens (which does not provoke attacks of opportunity). The initiator can mix which benefit he wishes to gain from this stance from multiple missed attacks. If the initiator is unable to take a 5 ft. step, he is not permitted to select a dodge bonus due to being constrained and having no room to move around in.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `thrashingDragon`,
        level: 5,
        name: `Hurricane of Fangs`,
        type: `Boost`,
        shortDesc: `Thrown weapons for the round have their range increased by 30 ft. and inflict an additional damage equal to initiator level.`,
        longDesc: `Utilizing this technique, a Thrashing Dragon disciple is capable of hurling multiple blades at a target in rapid succession with brutal power and incredible accuracy and range. For one round, the range of thrown weapons with range increments (such as daggers) or thrown weapons from an associated Thrashing Dragon weapon group (improvised weapon penalties apply as applicable) is increased by +30-ft.. Additionally, these thrown weapons strike with deadly force, inflicting an additional amount of damage equal to the initiator's initiator level.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `One round`
      },
      {
        school: `thrashingDragon`,
        level: 5,
        name: `Reversing Thrust`,
        type: `Counter`,
        shortDesc: `Make a successful opposed Acrobatics check against a target's attack roll; evade the attack and then make an immediate counter-attack.`,
        longDesc: `By watching the form of the enemy attacking him, the disciple may expertly twist and dodge way from the attack while making an attack on his foe in return. The initiator makes an opposed Acrobatics check against the target's attack roll. If successful, the disciple evades and negates his foe's attack and may make an immediate counter attack at his full attack bonus.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 5,
        name: `Thrashing Dragon Twist`,
        type: `Strike`,
        shortDesc: `Make an attack with two wielded weapons (one attack per weapon) against each adjacent enemy surrounding the initiator.`,
        longDesc: `Like a coiled spring, the disciple of the Thrashing Dragon twists his body and with powerful recoil, he spins to swipe at all of his available targets. The initiator attacks surrounding foes while fighting with two weapons, making an attack roll with both wielded weapons against each target at full base attack bonus (effectively making two attacks on each target, one with each weapon) against each enemy that he threatens. If the initiator is capable of making an unarmed strike or natural attack (through Improved Unarmed Strike feat or natural weapons) then the initiator may add an additional attack per target using his unarmed or one chosen natural attack, also at full base attack bonus.`,
        initiationAction: `standard`,
        range: `One melee attack`,
        target: `Any adjacent target`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 6,
        name: `Great Wyrm's Fang`,
        type: `Strike`,
        shortDesc: `Thrown weapon inflicts an additional 9d6 points of damage.`,
        longDesc: `By focusing his will into one of his blades, the Thrashing Dragon disciple wields the power of a mighty great wyrm in the palm of his hand. The initiator must make a ranged attack against a target by throwing a light weapon with a range increment (such as a dagger) or a signature Thrashing Dragon weapon. If this attack is successful, the attack inflicts an additional 9d6 points of damage.`,
        initiationAction: `standard`,
        range: `One ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 6,
        name: `Rending Claws`,
        type: `Boost`,
        shortDesc: `Make two successful melee attacks with wielded weapons, automatically rend victim for an additional 8d6 points of damage.`,
        longDesc: `When both of his blades strike home, the Thrashing Dragon disciple may rend and tear with his blades to cause excruciatingly painful and deadly injuries. As a swift action after having made two successful attacks with two wielded weapons (which inflict either piercing or slashing damage) or natural weapons that do slashing or piercing damage against a single target, the initiator may rend his opponent inflicting an additional 8d6 points of damage.`,
        initiationAction: `swift`,
        range: `Melee`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 6,
        name: `Tail Slap`,
        type: `Strike`,
        shortDesc: `Unleash a powerful kick which inflicts an additional 6d6 points of damage and stuns an opponent for up to 1d4 rounds.`,
        longDesc: `As the true dragon fights and employs all of its mighty limbs in combat, so does the disciple that emulates their graceful and deadly style. As part of this strike, the initiator makes a normal melee attack and if successful, the disciple makes an additional powerful spinning kick, landing a heavy blow to his foe which may temporarily rob it of its senses. The initiator makes an attack against a foe at full base attack bonus. If successful, the attack inflicts additional damage equal his unarmed strike damage plus an additional 6d6 points of damage and potentially stuns his foe. On a failed Fortitude saving throw (DC 16 + initiation modifier) the foe is stunned for 1d4 rounds. If the saving throw is successful, the foe is merely dazed for one round. The character does not provoke attacks of opportunity for not possessing the Improved Unarmed Strike feat when using this strike, but additional damage from this strike inflicts non-lethal damage unless the character possesses that feat.`,
        initiationAction: `standard`,
        range: `One melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 6,
        name: `Unbreakable Talons`,
        type: `Boost`,
        shortDesc: `When two-weapon fighting with light weapons, the disciple's attacks strike as adamantine and inflict an additional 4d6 points of damage.`,
        longDesc: `Using his superior skill and speed, the disciple knows where and how to strike for maximum effectiveness. By striking at the right angle, the disciple's blades set off discordant harmonies within the target for increased destructive potential. When two-weapon fighting with bladed weapons or with natural attacks that inflict slashing damage, the disciple's attacks with those weapons inflict an additional 4d6 points of damage for the round and strike as if they were adamantine weapons for the purposes of overcoming damage reduction or sundering items.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `One turn`
      },
      {
        school: `thrashingDragon`,
        level: 7,
        name: `Alacrity on Wing`,
        type: `Counter`,
        shortDesc: `Make an opposed Acrobatics check against an opponent's attack roll, evade the attack and you may make an attack against the target with both weapons with +2d6 damage as part of this immediate action.`,
        longDesc: `With reflexes honed from many combats, the disciple may react to danger with speed so great he may even attack multiple times while he evades the unlucky attacker. The initiator makes an Acrobatics check opposed by the target's attack roll. If successful the attack is negated and the initiator may make a melee attack with two wielded weapons or unarmed strikes, each dealing an additional +2d6 points of damage.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 7,
        name: `Brutal Dragon's Stance`,
        type: `Stance`,
        shortDesc: `When two-weapon fighting in this stance, the character suffers a -2 to AC, but all attacks inflict an additional 2d6 + initiation modifier points of damage.`,
        longDesc: `A Thrashing Dragon disciple sometimes realizes that the best defense is having a field of lifeless opponents at his feet. By adopting the mannerisms of the rampant dragon, he inflicts heavy, chopping blows that decimate his foes as he wades through their broken forms. While in this stance and wielding two-weapons, the initiator suffers a -2 penalty to AC and gains a damage bonus to all melee attacks and unarmed strikes equal to 2d6 + the initiator's initiation modifier.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `thrashingDragon`,
        level: 7,
        name: `Thrashing Dragon Frenzy`,
        type: `Strike`,
        shortDesc: `Make two melee attacks with two wielded weapons (two attacks per weapon) against each adjacent enemy surrounding the initiator.`,
        longDesc: `By focusing on the principles of speed and power, the Thrashing Dragon disciple explodes into motion, making a vicious flurry of strikes against all nearby attackers in a deadly dance of death. Make two attacks with two-wielded weapons (making two attack rolls with each weapon, effectively making four attacks) against each adjacent enemy that surrounds the initiator. If the initiator is capable of making an unarmed strike or natural attack (through Improved Unarmed Strike feat or natural weapons) then the initiator may add in two additional attacks per target using his unarmed or natural attack.`,
        initiationAction: `standard`,
        range: `One melee attack`,
        target: `Any adjacent target`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 8,
        name: `Doom Talon`,
        type: `Boost`,
        shortDesc: `Upon scoring a critical hit, initiation of this maneuver confirms the critical hit and inflicts an additional 4d6 points of damage.`,
        longDesc: `When a potentially deadly strike occurs, the Thrashing Dragon disciple knows how to make the blow count. When the initiator makes an attack roll that scores a critical threat, as a swift action the initiator may automatically confirm this critical hit and inflict an additional 4d6 points of damage. Creatures immune to critical hits may still be affected by this strike, not taking the normal double damage but still suffering the additional 4d6 points of damage.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 8,
        name: `Dragon Warrior's Talons`,
        type: `Stance`,
        shortDesc: `When two- weapon fighting in this stance, all attacks made ignore damage reduction and inflict bleeding arterial wounds.`,
        longDesc: `With mastery of the Thrashing Dragon's dance comes supremacy in effectiveness and efficiency with the arms that emulate the weapons of the dragon race. His mien is that of a ferocious, implacable dragon and his blades, hands and feet represent the deadly weapons of the wyrms that inspired the style in their deadly prowess. When wielding two weapons in this stance, all melee attacks and unarmed strikes made ignore a target's damage reduction and inflict bleeding wounds on foes, inflicting 2d4 points of bleed damage per round. A successful DC 20 Heal check or the application of any effect that cures hit point damage will stop the bleeding.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `thrashingDragon`,
        level: 8,
        name: `Thrashing Blades`,
        type: `Strike`,
        shortDesc: `Make a full-round attack as a standard action, each attack (including any unarmed or natural secondary attacks) is at full attack bonus plus an additional 2d6 points of damage, suffer -4 penalty to AC and to Reflex saves.`,
        longDesc: `With the speed and ferocity of a rampaging dragon, the disciple rends his foe to ribbons with his furious onslaught as he turns the quickening principles of fighting many opponents to fight only one. The initiator may make a full attack action at his foe, each attack at full attack bonus (with no reduction from iterative attacks), with both wielded weapons and any natural attacks or unarmed strikes the initiator possesses. Each of these attacks inflicts an additional 2d6 points of damage due to the sheer ferocity of the attack. The price for this ferocity is that the initiator must leave himself open to some attack; until his next turn the initiator suffers a -4 penalty to his AC and to Reflex saves.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 9,
        name: `Deadly Dragon Strike`,
        type: `Strike`,
        shortDesc: `Make an attack with both main and off hand weapon against one or two targets; attack strikes to the heart of a target may cause instant death or 12d6 points of damage.`,
        longDesc: `Upon reaching mastery of the Thrashing Dragon discipline, the disciple learns the truth of his deadly war dance; at its center is a deadly calm. It is in this calm that he discovers the true nature of his art and that one perfect blow can spell instant death for a foe. The disciple analyzes his foes in the blur of combat and finds his perfect moment and strikes for the heart and pierces it through. The initiator makes an attack roll against one or two foes using his two weapons (both attacks made through this strike are made at full attack bonus) and if these attacks are successful, his weapon perfectly and precisely pierces the foe's heart or other vital zone, killing it instantly on a failed Fortitude save (DC 19 + initiation modifier). Even if the creature successful saves, the strike inflicts his weapon's damage plus an additional 12d6 points of damage from the trauma of the blow. The initiator can use this strike to attack the same target with both attacks, forcing the target to make two Fortitude saves as above. Creatures immune to precision damage are not subject to the death effects of this strike.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One or two creatures`,
        duration: `Instantaneous`
      },
      {
        school: `thrashingDragon`,
        level: 9,
        name: `Dragon God's War Dance`,
        type: `Stance`,
        shortDesc: `When two- weapon fighting in this stance, all attacks made ignore damage reduction and inflict bleeding arterial wounds.`,
        longDesc: `While in the Dragon God's War Dance stance as a full-round action you may move any distance as a free action so long as your total movement for the round does not exceed twice your movement speed. You may continue subsequent attacks (up to your maximum number of attacks on a full attack action) after this movement is complete, so long as you have moved at least 10-ft prior to the last attack. Each attack inflicts an additional 4d6 damage. Unlike most stances this stance is particularly strenuous, and may only be maintained for a number of rounds equal to 3+con modifier, after which this stance ends and you are fatigued for a number of rounds equal to the number of rounds you were in this stance. You cannot activate this stance while fatigued, If you have something that would stop you from being fatigued after raging, you can spend spell points equal to the amount of rounds spent in this stance to not become fatigued.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You `,
        duration: `Stance`
      },
      {
        school: `unquietGrave`,
        level: 1,
        name: `Bean Nighe Attitude`,
        type: `Stance`,
        shortDesc: `Gain a prophetic awareness of impending death that increases your saving throws.`,
        longDesc: `By reading whispers of impending death, you stay one step ahead of your fate, avoiding even magical attempts on your life. While you maintain this stance, your clothing and equipment takes on a ravaged, blood-splattered appearance, as though you have been horrifically slain; additionally, you gain a +1 insight bonus on saving throws, which improves by 1 at 4th level and again every 4 levels thereafter.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `unquietGrave`,
        level: 1,
        name: `Gravekeeper's Hood`,
        type: `Boost`,
        shortDesc: `Become immune to blindness for 1 round.`,
        longDesc: `Drawing on the power that gives sight to the sightless dead, your vision transcends mortal limits. You become immune to the blinded condition for 1 round. \nGrave Call: An undead creature initiating this boost may instead increase their channel resistance by 6 for 1 round.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `unquietGrave`,
        level: 1,
        name: `Hungry Stillness Strike`,
        type: `Strike`,
        shortDesc: `Make a melee attack and deal an additional 1d8 negative energy damage.`,
        longDesc: `You infuse your weapon with negative energy as you strike your foe. Make a melee attack. If it hits, it deals weapon damage as normal plus an additional 1d8 points of negative energy damage.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Creature struck`,
        duration: `Instantaneous`
      },
      {
        school: `unquietGrave`,
        level: 1,
        name: `Starving Vampire Stance`,
        type: `Stance`,
        shortDesc: `Gain temporary hit points whenever you slay a creature.`,
        longDesc: `When you assume this stance, you skin gains a deathly pallor, and your canines, if any, sharpen and elongate. While maintaining this stance, whenever you reduce a creature to 0 or fewer hit points, you gain twice that creature's Hit Dice in temporary hit points. The temporary hit points gained from this stance stack with those gained from other Unquiet Grave maneuvers, up to the normal maximum.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `unquietGrave`,
        level: 1,
        name: `Thirsting Axe Strike`,
        type: `Strike`,
        shortDesc: `Make a melee attack and gain temporary hit points.`,
        longDesc: `Drawing on the primal hunger of the negative energy plane, you lash out at your victim. Make a melee attack. If it hits, it deals weapon damage as normal and you gain temporary hit points equal to the damage dealt. The temporary hit points gained from this maneuver stack with those gained from other Unquiet Grave maneuvers, to the normal maximum.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Creature struck`,
        duration: `Instantaneous`
      },
      {
        school: `unquietGrave`,
        level: 1,
        name: `Whisper of Undeath`,
        type: `Counter`,
        shortDesc: `Gain negative energy resistance 5, +1 bonus on saving throws vs. death effects and energy drain.`,
        longDesc: `You infuse yourself with subtle threads of negative energy. When you initiate this counter, you gain negative energy resistance 5, as well as a +1 bonus to saving throws vs. energy drain and death effects, for 1 round. \nGrave Call: An undead creature initiating this maneuver instead improves their positive energy resistance by 5 and gains a +1 bonus to saving throws vs. effects with the good and/or light descriptors for 1 round.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `unquietGrave`,
        level: 2,
        name: `Chilling Grave Defense`,
        type: `Counter`,
        shortDesc: `Opponent suffers -4 penalty to Strength and Dexterity in response to an attack.`,
        longDesc: `You afflict an attacker with the chill of the grave, sapping the strength from their limbs. You may activate this counter in response to a melee or ranged attack being made against you. The creature making that attack suffers a -4 penalty to its Strength and Dexterity for 1 round. Apply these penalties before calculating the attack and damage rolls for the attack (this may cause the attack to miss).`,
        initiationAction: `immediate`,
        range: `Close (25 ft. plus 5 ft. per 2 levels)`,
        target: `1 creature`,
        duration: `1 round`
      },
      {
        school: `unquietGrave`,
        level: 2,
        name: `Headstone Breaking Strike`,
        type: `Strike`,
        shortDesc: `Make a melee attack; the victim suffers 4 points of damage to a physical ability score. This ignores undead immunity.`,
        longDesc: `You mimic the savage fury of the undying, breaking the bodies of your foes. Make a melee attack. If it hits, it deals weapon damage as normal, plus an additional 1d4 points of damage to a physical ability score of your choice. This ability damage ignores the normal immunity to physical ability damage enjoyed by undead creatures, though they still cannot suffer Constitution damage.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Creature struck`,
        duration: `Instantaneous`
      },
      {
        school: `unquietGrave`,
        level: 2,
        name: `Raging Specter Strike`,
        type: `Strike`,
        shortDesc: `Make a melee attack as a touch attack.`,
        longDesc: `You transmute your weapon into a semi-ethereal state, striking with the undying hate of a specter. Make a melee attack against your opponent's touch AC. If it hits, it deals weapon damage as normal. Unlike normal touch attacks, you may use Power Attack to enhance the damage dealt by this maneuver.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Creature struck`,
        duration: `Instantaneous`
      },
      {
        school: `unquietGrave`,
        level: 2,
        name: `Rattling Skeleton Parry`,
        type: `Counter`,
        shortDesc: `Gain DR 5/ bludgeoning and magic and cold resistance 10 until the beginning of your next turn.`,
        longDesc: `Your flesh shrivels, revealing hard bones that turn aside enemy weapons. When you initiate this counter, you gain DR 5/bludgeoning and magic, as well as cold resistance 10, until the beginning of your next turn. \nGrave Call: Undead creatures initiating this maneuver also improve their natural armor by 1.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `unquietGrave`,
        level: 2,
        name: `Stalking Ghoul`,
        type: `Boost`,
        shortDesc: `Gain a +4 bonus to Stealth checks; move out of cover or concealment without losing Stealth.`,
        longDesc: `You move with the swiftness and cunning of the cannibalistic ghouls. When you initiate this boost you gain a +4 competence bonus to Stealth checks for 1 round. During that time, you do not require cover or concealment to remain hidden using the Stealth skill, which may permit you to move in the open without being detected. You still suffer the usual effects of not having cover or concealment while using Stealth when the duration of this boost expires.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `unquietGrave`,
        level: 3,
        name: `Avenging Revenant's Advance`,
        type: `Stance`,
        shortDesc: `You are healed by negative energy and harmed by positive energy, and your movement speeds may not be reduced below 1/2 their normal values.`,
        longDesc: `When you assume this stance, your skin pales and your breath fogs with the chill of the grave. While you maintain this stance, you are healed by negative energy and harmed by positive energy, just as an undead creature is (you gain no other benefit or drawback of being undead). Additionally, the unstoppable vengeance of revenants drives you: your movement speeds may not be reduced to less than 1/2 their normal value while you maintain this stance. \nGrave Call: An undead creature maintaining this stance is healed by cold damage in the same manner that it is healed by negative energy damage instead of the normal effects of this stance. Its movement speeds still cannot be reduced to less than ½ their normal value while it maintains this stance.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `unquietGrave`,
        level: 3,
        name: `Darkened Axe Style`,
        type: `Boost`,
        shortDesc: `Your melee attacks deal an additional 2d8 negative energy damage until the beginning of your next turn.`,
        longDesc: `Discpline: Unquiet Grave ; You infuse your attacks with negative energy, draining the life of your victims. When you initiate this boost, your melee attacks deal an additional 2d8 points of negative energy damage for 1 round.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `unquietGrave`,
        level: 3,
        name: `Life Sealing Strike`,
        type: `Strike`,
        shortDesc: `Make a melee attack, deal an additional 2d8 negative energy damage and your victim cannot benefit from healing.`,
        longDesc: `You afflict your victim with an entropic curse, sealing their life force away from succor. Make a melee attack. If it hits, it deals weapon damage as normal, plus an additional 2d8 points of negative energy damage, and your victim must succeed at a Will save or become cursed and unable to heal hit point damage (by any means) for a number of rounds equal to your initiation modifier.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Creature struck`,
        duration: `Instantaneous (see text)`
      },
      {
        school: `unquietGrave`,
        level: 3,
        name: `Wight's Blow`,
        type: `Strike`,
        shortDesc: `Make a melee attack, deal an additional 1d8 negative energy damage and your victim gains a negative level.`,
        longDesc: `You call upon the anger of the hungry wight, draining the vital essence of your foes. Make a melee attack. If it hits, it deals weapon damage as normal, plus an additional 1d8 points of negative energy damage. The creature struck also gains a negative level, which lasts until the end of the encounter.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Creature struck`,
        duration: `Instantaneous`
      },
      {
        school: `unquietGrave`,
        level: 4,
        name: `Hunting Mohrg Strike`,
        type: `Strike`,
        shortDesc: `Make a melee attack, deal an additional 2d8 negative energy damage and your victim becomes paralyzed.`,
        longDesc: `Your axe lashes out like a hungry mohrg. Make a melee attack. If it hits, it deals weapon damage as normal, plus an additional 2d8 points of negative energy damage, and your victim must succeed at a Fortitude save or become paralyzed for 1 round.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Creature struck`,
        duration: `Instantaneous and special; see text`
      },
      {
        school: `unquietGrave`,
        level: 4,
        name: `Rotting Axe Style`,
        type: `Boost`,
        shortDesc: `Your melee attacks ignore hardness and some damage reduction until the beginning of your next turn.`,
        longDesc: `You draw upon the destructive entropy of the negative energy plane, infusing it into your strikes. When you initiate this boost, your melee attacks ignore hardness and overcome an amount of damage reduction equal to your initiator level for 1 round. \nGrave Call: Attacks by undead creatures initiating this boost overcome damage reduction entirely for the duration of this boost.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `1 round`
      },
      {
        school: `unquietGrave`,
        level: 4,
        name: `Shrieking Shadow Axe`,
        type: `Strike`,
        shortDesc: `Make a melee attack, deal an additional 1d8 Strength damage and gain temporary hit points.`,
        longDesc: `You wrap your weapon in tenebrous energy that saps the strength of your victims. Make a melee attack. If it hits, it deals weapon damage as normal, plus 1d8 points of Strength damage. You gain temporary hit points equal to twice the Strength damage dealt by this strike. The temporary hit points gained from this maneuver stack with those gained from other Unquiet Grave maneuvers, to the normal maximum.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Creature struck`,
        duration: `Instantaneous`
      },
      {
        school: `unquietGrave`,
        level: 4,
        name: `Wretched Ghast Riposte`,
        type: `Counter`,
        shortDesc: `Opponent who attacks you becomes sickened and may become nauseated.`,
        longDesc: `You afflict an attacker with the charnel stench of the ghast, ruining their blow. You may initiate this counter in response to a melee or ranged attack being made against you. The creature attacking you becomes sickened for 1 round and must succeed at a Fortitude save or also become nauseated for 1 round. Apply these penalties before calculating the attack and damage rolls for the attack (this may cause the attack to miss or not occur).`,
        initiationAction: `immediate`,
        range: `Close (25 ft. plus 5 ft. per 2 levels)`,
        target: `1 creature`,
        duration: `1 round`
      },
      {
        school: `unquietGrave`,
        level: 5,
        name: `Ancient Lich Parry`,
        type: `Counter`,
        shortDesc: `Gain spell resistance equal to 15 + your initiator level until the beginning of your next turn.`,
        longDesc: `You shield yourself with webs of entropic energy that sap at magic directed at you. When you initiate this counter, you gain spell resistance equal to 15 plus your initiator level until the beginning of your next turn. \nGrave Call: An undead creature initiating this counter also gains an equal amount of positive energy resistance until the beginning of its next turn.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Special (see text)`
      },
      {
        school: `unquietGrave`,
        level: 5,
        name: `Flowing Gore Blow`,
        type: `Strike`,
        shortDesc: `Make a melee attack, deal an additional 4d8 bleed damage that is difficult to heal.`,
        longDesc: `Your axe flows forth with negative energy, creating a cursed wound. Make a melee attack. If it hits, it deals weapon damage as normal, plus an additional 4d8 points of bleed damage. The wound left behind is laced with negative energy; the caster of a healing spell or similar effect must succeed at a caster level check (DC 11 + initiator level) to halt the bleed damage (healing from the spell or effect still occurs even if the check fails to halt the bleeding), and the DC to apply first aid with the Heal skill increases by 5 + your initiation modifier.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Creature struck`,
        duration: `Instantaneous`
      },
      {
        school: `unquietGrave`,
        level: 5,
        name: `Howling Banshee Strike`,
        type: `Strike`,
        shortDesc: `Make a melee attack, deal an additional 4d8 negative energy damage and your victim becomes deafened.`,
        longDesc: `Your weapon screams like a grieving banshee as you drive it into your foe. Make a melee attack. If it hits, it deals weapon damage as normal, plus an additional 4d8 points of negative energy damage, and the creature struck becomes deafened for a number of rounds equal to your initiation modifier.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Creature struck`,
        duration: `Instantaneous and special (see text)`
      },
      {
        school: `unquietGrave`,
        level: 5,
        name: `Mourning Ghost Attitude`,
        type: `Stance`,
        shortDesc: `Your armor gains the ghost touch special property, and you may move through solid objects as though incorporeal.`,
        longDesc: `When you assume this stance, your outline smudges gently and your hair and equipment become semi-transparent, as though you had become a ghost. While you maintain this stance, your armor has the ghost touch property (even if it is not otherwise magical) and you - along with your worn, carried, or held equipment - may move through solid objects as though you were incorporeal, provided you do not end your movement within a solid object.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `unquietGrave`,
        level: 6,
        name: `Ascending Necromancer Style`,
        type: `Counter`,
        shortDesc: `Gain immunity to energy drain and Constitution damage until the beginning of your next turn.`,
        longDesc: `You wrap yourself in armoring layers of negative energy, shielding your life force with the touch of undeath. When you initiate this counter, you become immune to energy drain and Constitution damage until the beginning of your next turn. \nGrave Call: An undead creature initiating this maneuver instead becomes immune to channeling and positive energy damage until the beginning of its next turn.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Special (see text)`
      },
      {
        school: `unquietGrave`,
        level: 6,
        name: `Feasting Wraith Strike`,
        type: `Strike`,
        shortDesc: `Make a melee attack, deal an additional 2d4 Constitution damage and your victim becomes shaken.`,
        longDesc: `Sickly gray tar clings to your blade as you initiate this dread strike. Make a melee attack. If it hits, it deals weapon damage as normal plus 2d4 points of Constitution damage, and your victim becomes shaken for a number of rounds equal to your initiation modifier. A successful Will save halves the Constitution damage and prevents the shaken condition.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Creature struck`,
        duration: `Instantaneous`
      },
      {
        school: `unquietGrave`,
        level: 6,
        name: `Headsman's Descending Axe`,
        type: `Strike`,
        shortDesc: `Make a melee attack, deal an additional 6d8 negative energy damage or execute creature at 1/4 its maximum hit points or lower and you gain temporary hit points.`,
        longDesc: `You cleave into your foe with an executioner's strike. Make a melee attack. If it hits and your victim is at more than 1/4 their maximum hit point total, it deals weapon damage as normal, plus an additional 6d8 points of negative energy damage. If your victim is at 1/4 or less of their maximum hit point total, that creature instead dies (no save) and you gain temporary hit points equal to twice its Hit Dice. The temporary hit points gained from this maneuver stack with those gained from other Unquiet Grave maneuvers, to the normal maximum.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Creature struck`,
        duration: `Instantaneous`
      },
      {
        school: `unquietGrave`,
        level: 6,
        name: `Looming Nightwalker Parry`,
        type: `Counter`,
        shortDesc: `Gain DR 15/silver and good and negative energy resistance 20 until the beginning of your next turn.`,
        longDesc: `You transform your body into shadowy energy, turning blows aside. When you initiate this boost, you gain negative energy resistance 20 and DR 15/silver and good until the beginning of your next turn. \nGrave Call: An undead creature initiating this boost gains positive energy resistance 20 instead of negative energy resistance.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Special (see text)`
      },
      {
        school: `unquietGrave`,
        level: 7,
        name: `Charging Dullahan's Advance`,
        type: `Stance`,
        shortDesc: `You do not provoke attacks of opportunity for moving through threatened squares. Creatures you flank suffer additional negative energy damage from attacks made by you and your allies.`,
        longDesc: `Your head vanishes when you assume this stance, leaving behind a dripping, bloody neck stump (this may complicate attempts to identify you). You suffer no ill effects from not having a head, such as blindness or an inability to utilize potions or head slot items. While maintaining this stance, you do not provoke attacks of opportunity for moving through threatened spaces (you may still provoke attacks of opportunity for other reasons). Furthermore, you and other allies within 30 ft. deal additional negative energy damage equal to your initiator level against creatures you are flanking. Your other allies do not necessarily have to also be flanking such creatures. \nGrave Call: Additionally, an undead creature maintaining this stance may imbue its mount with this power; its mount does not provoke attacks of opportunity for moving through threatened squares (it might still provoke attacks of opportunity for other reasons).`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `unquietGrave`,
        level: 7,
        name: `Poltergeist's Wrath`,
        type: `Strike`,
        shortDesc: `Make a melee attack at range, deal an additional 6d8 negative energy damage and your victim is knocked prone by phantasmal wrath.`,
        longDesc: `You strike out with your weapon and emit a wave of rage and sorrow that brings your victim to their knees. Choose a creature within range, then make a melee attack against that creature (even if you don't threaten the chosen creature). If it hits, it deals weapon damage as normal, plus an additional 6d8 points of negative energy damage, and your victim is knocked prone (no save).`,
        initiationAction: `standard`,
        range: `Medium (100 ft. plus 10 ft. per level)`,
        target: `1 creature`,
        duration: `Instantaneous`
      },
      {
        school: `unquietGrave`,
        level: 7,
        name: `Scything Reaper Riposte`,
        type: `Counter`,
        shortDesc: `Opponent attacking you must succeed at a saving throw or gain 2d4 negative levels.`,
        longDesc: `You form a scythe of crackling negative energy and sweep it through your attacker, draining their vital essence. You may initiate this counter in response to a melee or ranged attack being made against you. The creature attacking you gains 2d4 negative levels (Will save half) that last until the end of the encounter.`,
        initiationAction: `immediate`,
        range: `Close (25 ft. plus 5 ft. per 2 levels)`,
        target: `1 creature`,
        duration: `Instantaneous`
      },
      {
        school: `unquietGrave`,
        level: 8,
        name: `Chilling Mist Sidestep`,
        type: `Counter`,
        shortDesc: `Assume a misty form in response to an attack and the attacker suffers 7d8 negative energy damage.`,
        longDesc: `You turn into dark mist that crackles with negative energy. You may initiate this counter in response to a melee or ranged attack being made against you. Until the beginning of your next turn, you are immune to weapon damage, and spells targeted against you have a 50% miss chance. If you initiated this counter in response to a melee attack, the creature attacking you suffers 7d8 points of negative energy damage.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Special (see text)`
      },
      {
        school: `unquietGrave`,
        level: 8,
        name: `Laughing Demilich Attitude`,
        type: `Stance`,
        shortDesc: `Gain undead immunities, flight, and death knell fallen enemies.`,
        longDesc: `The skin and muscle of your face pull tightly against your skull when you assume this stance, revealing yellow bone studded with phantasmal gemstones that crackle and dance with negative energy. While you maintain this stance, you gain a 100 ft. fly speed (or improve your existing fly speed by 50 ft.) with Good maneuverability, as well as the immunities enjoyed by creatures with the undead type. You do not gain any of the other benefits or drawbacks of being undead (notably, you are not healed by negative energy, nor are you vulnerable to effects that specifically target undead creatures). Additionally, you may use death knell as a spell-like ability once per round as a free action, though any bonuses gained this way fade when you leave this stance. \nGrave Call: Undead creatures maintaining this stance do not gain the immunities enjoyed by the undead type; instead, they become immune to positive energy damage and gain DR 20/bludgeoning and good. They still benefit from the other effects of this stance.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `unquietGrave`,
        level: 8,
        name: `Soul Drinking Strike`,
        type: `Strike`,
        shortDesc: `Make a melee attack, deal an additional 3d4 Intelligence, Wisdom, and Charisma damage.`,
        longDesc: `You channel the all-consuming void through your axe, brutally rending your victim's soul. Make a melee attack. If it hits, it deals weapon damage as normal, plus an additional 3d4 points of Intelligence, Wisdom, and Charisma damage. A successful Will save halves this damage.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Creature struck`,
        duration: `Instantaneous`
      },
      {
        school: `unquietGrave`,
        level: 9,
        name: `Pitiless Axe of the Executioner`,
        type: `Strike`,
        shortDesc: `Make a melee attack, deal an additional 3d6 Constitution damage and 9d6 bleed damage and leave behind cursed wounds.`,
        longDesc: `Your weapon descends in a merciless swing, its cursed edge crawling into the wounds of your victims. Make a melee attack. If it hits, it deals weapon damage as normal, plus an additional 3d6 Constitution damage and 9d8 bleed damage that ignores immunity to bleed. The wound left behind is laced with negative energy; the caster of a healing spell or similar effect must succeed at a caster level check (DC 11 + initiator level) to halt the bleed damage (healing from the spell or effect still occurs even if the check fails to halt the bleeding), and the DC to apply first aid with the Heal skill increases by 9 + your initiation modifier. \nGrave Call: An undead creature initiating this maneuver gains temporary hit points equal to twice the Hit Dice of the creature struck. The temporary hit points gained from this maneuver stack with those gained from other Unquiet Grave maneuvers, to the normal maximum.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `Creature struck`,
        duration: `Instantaneous`
      },
      {
        school: `veiledMoon`,
        level: 1,
        name: `Inner Sense`,
        type: `Counter`,
        shortDesc: `Spiritual senses grant a +2 insight bonus to a saving throw.`,
        longDesc: `By sensing ripples in the spiritual world around him, the Veiled Moon disciple is capable of better avoiding dangerous effects and situations. This counter grants the disciple a +2 insight bonus to a single saving throw.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `veiledMoon`,
        level: 1,
        name: `Disturbing Blow`,
        type: `Strike`,
        shortDesc: `Make an attack against a target; successful strike inflicts a -4 penalty to the target's next d20 roll.`,
        longDesc: `[Mind-affecting]By establishing counter-resonance within the spirit of an enemy with a well-placed blow, the disciple may disrupt and disturb its next action. The initiator must make a melee attack against a target creature, and if successful, cause the target to suffer a -4 penalty to the next d20 roll that he makes.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Special`
      },
      {
        school: `veiledMoon`,
        level: 1,
        name: `Dimensional Strike`,
        type: `Strike`,
        shortDesc: `For a brief moment, the disciple becomes difficult to perceive; resolving the attack against the target as if they were flat-footed.`,
        longDesc: `By shifting slightly between two worlds, the disciple confuses the senses of his foe so he may land his attack more easily. The initiator initiating this strike causes his foe to be flat-footed to this attack.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `veiledMoon`,
        level: 1,
        name: `Leaping Spirit Dance`,
        type: `Stance`,
        shortDesc: `This stance grants the disciple a +2 to AC and a +2 to Reflex saves.`,
        longDesc: `Light as a feather, the Veiled Moon disciple moves gracefully in combat, with the smooth and practiced grace of an incorporeal being. The disciple gains a +2 dodge bonus to AC and a +2 competence bonus to Reflex saves while in this stance so long as he moves at least 10 feet on his turn each round. This bonus increases by +2 at initiator level 9, and by an additional +2 at initiator level 17.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `veiledMoon`,
        level: 1,
        name: `Spirit Sensing Stance`,
        type: `Stance`,
        shortDesc: `The disciple in this stance gains the scent special ability and can use it to sense incorporeal creatures that are hiding on the Ethereal plane nearby.`,
        longDesc: `By sensing the different patterns all beings that exist have, the senses of the Veiled Moon disciple exceed that of natural beings and move into the realm of supernatural awareness. While in this stance, the initiators gains the scent special ability and he may detect creatures on the Ethereal plane that are near the Material plane within 30-ft. of his position.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `veiledMoon`,
        level: 1,
        name: `Ghost Hunting Blow`,
        type: `Boost`,
        shortDesc: `Momentarily grants the disciple's attacks the ghost touch property.`,
        longDesc: `By reaching across the barrier between worlds, the disciple may strike at disembodied spirits as easily he would strike a normal mortal. Any and all of the initiator's attacks made this round, including attacks of opportunity, are made as if the initiator's weapon possessed the ghost touch property. This is an Ethereal plane using maneuver.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `One round`
      },
      {
        school: `veiledMoon`,
        level: 2,
        name: `Half-Gone`,
        type: `Counter`,
        shortDesc: `As an attack targets you, make a Stealth check to become incorporeal to avoid it.`,
        longDesc: `(Teleportation)By momentarily slipping through the barrier between the Material and the Astral planes, the Veiled Moon disciple may attempt to avoid an attack by being incorporeal. The initiator makes an opposed Stealth check against the attacker's Perception check; if successful the initiator is incorporeal for that attack (resolve the attack against the initiator as normal for striking an incorporeal target). This counter may be attempted to defend against targeted and area of effect spells, making a Stealth check in place of a Reflex save.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `veiledMoon`,
        level: 2,
        name: `Fading Strike`,
        type: `Strike`,
        shortDesc: `Teleport up to your movement speed to an opponent and make an attack.`,
        longDesc: `(Teleportation)The disciple learns the basic technique at this level for walking between worlds to reach locations that previously could be inaccessible on the mortal world and potentially attack foes at those locales. As a standard action, the initiator may either teleport to a location no farther away than his maximum movement speed, and make an attack action against an opponent as part of the same standard action, or attack an adjacent target and then teleport to a location no farther away than his maximum movement speed. The teleportation destination must be clearly seen by the disciple to teleport to that location, and it must be unoccupied.`,
        initiationAction: `standard`,
        range: `Personal`,
        target: `Up to the disciple's movement speed`,
        duration: `Instantaneous`
      },
      {
        school: `veiledMoon`,
        level: 2,
        name: `Cursed Fate`,
        type: `Strike`,
        shortDesc: `Make an attack against a target, inflict +2d6 damage -4 to all d20 rolls for one round.`,
        longDesc: `(Mind-affecting)The disciple can befuddle and bewilder his opponent with this strike, causing a grave imbalance in the psyche of the victim. The initiator must make a successful attack against the target, inflicting an additional 2d6 points of damage and the target must attempt a Will save (DC 12 + initiation modifier) or suffer a -4 to all d20 rolls until the disciple's next turn.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `veiledMoon`,
        level: 2,
        name: `Resonance Strike`,
        type: `Strike`,
        shortDesc: `Strike inflicts 3d6 force damage + initiator level damage in lieu of normal damage, and may strike incorporeal creatures without risking a miss chance.`,
        longDesc: `[Force]By funneling his spiritual power into his attack, the Veiled Moon practitioner may strike an opponent with glowing silvery light on the Material or the Ethereal plane. This strike is resolved as a melee or ranged touch attack, and it inflicts 3d6 + initiator level points of force damage in lieu of normal damage, and this attack may strike incorporeal creatures without suffering reduced damage. This is an Ethereal plane using maneuver.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `veiledMoon`,
        level: 3,
        name: `Brilliant Moon`,
        type: `Strike`,
        shortDesc: `Make an attack against a foe, attack ignores armor bonuses to AC and inflicts an additional 4d4 points of force damage.`,
        longDesc: `By partially phasing a portion of his attack out of this reality, the disciple may ignore certain obstacles, such as armor, when striking at an opponent. The initiator makes an attack roll and ignores the target's armor bonus to AC (unless this armor bonus comes from a force effect, such as mage armor). A successful hit inflicts an additional 4d4 points of force damage from the spiritual power the disciple infuses into the attack.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `veiledMoon`,
        level: 3,
        name: `Formless Dance`,
        type: `Stance`,
        shortDesc: `Gain the benefits of a see invisibility spell and blur while the stance is in effect.`,
        longDesc: `[Glamer]The Veiled Moon disciple immerses himself in a sort of dimensional flux, causing him to be able to see what cannot be perceived and seemingly be in many places at once. While in this stance, the initiator gains the benefits of a see invisibility spell and the blur spell.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `veiledMoon`,
        level: 3,
        name: `Ghostwalk`,
        type: `Boost`,
        shortDesc: `Become incorporeal until your next turn.`,
        longDesc: `(Teleportation)The initiator steps through to the borderland between the Material and the Ethereal planes, becoming an incorporeal figure in both realities for a few moments. Until the beginning of his next turn, the initiator gains the incorporeal subtype. This is an Ethereal plane using maneuver.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `One round`
      },
      {
        school: `veiledMoon`,
        level: 3,
        name: `Altered Penumbra`,
        type: `Counter`,
        shortDesc: `Make an opposed Stealth check opposing your attackers Perception check after their attack roll, if you are successful, teleport to any spot within 10-ft. away and leave a minor image to be hit in your place.`,
        longDesc: `(Teleportation, Figment)Position is relative to the Veiled Moon disciple's thinking, and his position in the universe is mutable. Using these principles, the disciple may circumvent reality to remove himself from harms way when necessary. The initiator makes a Stealth check opposing the attacker's Perception check. If successful then the initiator may teleport to any spot within 10- ft. away from his current position and leave a minor image duplicate of himself behind to take the attack of his foe in his place. Minor images created by this counter last for 1d4 rounds or until dispersed. This ability may be used to defend against spells and effects that directly target the initiator with an attack roll (such as ranged touch effects) or for those that allow for a Reflex save. If the attack would still encompass an area to where the initiator is teleporting (such as with the fireball spell he has not vacated), the initiator would still be struck by the attack.`,
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `veiledMoon`,
        level: 4,
        name: `Ethereal Reminiscence`,
        type: ``,
        shortDesc: `Become incorporeal for one round, regain twice your ranks in Stealth in hit points or potentially being lost in the Ethereal briefly.`,
        longDesc: `(Teleportation)The ectoplasmic nature of beings on the Ethereal plane allows for the Veiled Moon disciple to briefly transport himself to that realm and use his will to restore some his form by filling his wounds with spectral energies, displacing his injuries but at a great potential risk. As a full-round action, the initiator may become incorporeal for one round and restore twice his ranks in Stealth in hit points to himself. Every time the initiator makes the transition between planes, however, he runs the risk of potentially losing himself there briefly. The initiator initiating this maneuver must make a Will save (DC 14, +1 DC for every time he's initiated this maneuver since he last rested for 8 hours after the first use); if successful, the maneuver works as normal. If the saving throw fails, the initiator does not regain any hit points, instead suffering 2d6 points of damage, and spends the next 2d4 rounds lost in the borderland between the Prime Material Plane and the Ethereal Plane, and when he returns to the Prime, he is fatigued for an hour. This is an Ethereal plane using maneuver.`,
        initiationAction: `full-round`,
        range: `Personal`,
        target: `You`,
        duration: `One round`
      },
      {
        school: `veiledMoon`,
        level: 4,
        name: `Flicker Strike`,
        type: `Strike`,
        shortDesc: `Teleport to strike an opponent's flat-footed AC and then teleport away.`,
        longDesc: `(Teleportation)In a flickering blur of teleportation and movement, the Veiled Moon disciple may disappear, blink into existence to strike a foe, and then disappear again to appear a safe distance away. The initiator may teleport up to his movement speed to a target enemy, make an attack or a combat maneuver (such as disarm or trip) against the foe using its flat-footed armor class or CMD (denying the target his Dexterity bonus due to the surprising nature of the attack), then teleport away up to his movement speed, all without drawing attacks of opportunity for the movement or attack.`,
        initiationAction: `standard`,
        range: `Melee attack, movement speed`,
        target: `One creature`,
        duration: `Instantaneous`
      },
      {
        school: `veiledMoon`,
        level: 4,
        name: `Breath of the Moon`,
        type: `Strike`,
        shortDesc: `Make an attack against a target, target must make save or be confused for 1d4 rounds.`,
        longDesc: `(Mind-affecting)The moon is a source of madness, so the legend goes, and by using the principles of lunar cycles on the psyche of mortals, the disciple may temporarily relieve a target of its sanity for a few moments in combat. The initiator must make a melee attack against a target creature, and if successful, in addition to damage the target must make a Will save (DC 14 + initiation modifier) or be confused (as the spell confusion) for 1d4 rounds. After the application of this maneuver, the subject briefly forgets that the initiator exists and thus may not target the initiator while confused.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `1d4 rounds`
      },
      {
        school: `veiledMoon`,
        level: 4,
        name: `Fading Leap`,
        type: `Boost`,
        shortDesc: `As a move action, the disciple may teleport to a spot up to twice his movement speed away.`,
        longDesc: `(Teleportation)With nary a thought and a gesture the Veiled Moon disciple may flow like moonlight from one location to another through the Astral plane, moving faster than his earthly body would allow. As a move action, the initiator may teleport to a location in range of twice the disciple's base movement speed away.`,
        initiationAction: `movement`,
        range: `Up to twice movement speed`,
        target: `You`,
        duration: `Instantaneous`,
        utility:true,
      },
      {
        school: `veiledMoon`,
        level: 6,
        name: `Soul Unbound`,
        type: `Boost`,
        shortDesc: ``,
        longDesc: `Move 10 feet in a straight line without provoking attacks of opportunity, leaving a shadowy image of yourself behind (it cannot be attacked or destroyed except through anti-magic, in which case this manuever ends). Afterwards, for 3 rounds, every time you attack and damage a creature with a physical attack, they receive one spirit hunter mark. When this maneuver ends, you are teleported back to your original position, and the marks are consumed, damaging the creatures for 1d6 force damage for every mark on them. You can end this maneuver early as an immediate action, doing so immediately teleports you back and triggers the marks, though their damage is reduced to 1d4 force damage. 
        \nIf a creature is in the marked location when you return, you appear in the closest available space, but it provokes an attack of opportunity from them and you suffer 2d6 damage per square moved. If the space is filled some other way, you just appear in the closest available space, taking 2d6 damage for every 5 feet travelled through objects.`,
        initiationAction: `movement`,
        range: ``,
        target: `You`,
        duration: `3 rounds`
      },
      {
        school: `veiledMoon`,
        level: 5,
        name: `Twisting Ether`,
        type: `Boost`,
        shortDesc: `Switch places within 30-ft. via teleportation with target willing ally.`,
        longDesc: `(Teleportation)With a nod to his ally, the Veiled Moon adept may sink through the world with his ally and switch places with him for better effect in combat. As a swift action, the initiator may designate a willing ally within 30-ft. and swap places with him via teleportation.`,
        initiationAction: `swift`,
        range: `30-ft.`,
        target: `You and willing ally`,
        duration: `Instantaneous`
      },
      {
        school: `veiledMoon`,
        level: 5,
        name: `Stance of the Ether Gate`,
        type: `Stance`,
        shortDesc: `The disciple flows with dimensional power and may as a move action teleport up to his movement speed, or as a full-round action move up to twice his movement speed.`,
        longDesc: `(Teleportation)By shifting his essence partially into the Astral plane, the disciple finds that moving through that plane as just as easy as moving through the Material plane. While the disciple is in this stance, he may teleport up to his movement speed as a move action, or twice his movement speed as a full-round action, at will. He must see his destination clearly to be able to teleport to it. The initiator may not take any creatures with him when teleporting; only himself and the gear he is carrying plus up to an additional 20 lbs. This stance meets the qualifications for the Dimensional Agility feats, should the initiator wish to take them.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `veiledMoon`,
        level: 5,
        name: `Warp Worm`,
        type: `Strike`,
        shortDesc: `Make a touch attack against up to three targets which must be no farther apart than 20-ft. from each other, teleport through them inflicting 10d6 points of force damage and appear up to 15-ft. from the final target.`,
        longDesc: `[Teleportation, Force]By creating temporary breaches between the worlds of the Material and the Astral, the disciple may teleport through a few enemies and emerge from the space between worlds having done his foes great internal harm. The initiator makes a melee touch attack against a target, and may teleport to another target no more than 20-ft. from the first (and do the same for a third target) making another melee touch attack on each subsequent target and inflicting 10d6 points of force damage to all affected. On a failed attack or after the final target, the disciple appears up to 15-ft. from the final target to finish his turn. The touch attacks themselves cannot be unarmed strikes or weapon strikes that inflict damage normally; the disciple must lay their hand against the target in a non-damaging way to initiate this maneuver (even if wielding a weapon in that hand, this can be used by simply touching the target with a fist or back of the hand).`,
        initiationAction: `full-round`,
        range: `Melee touch`,
        target: `Up to three targets`,
        duration: `Instantaneous`
      },
      {
        school: `veiledMoon`,
        level: 5,
        name: `Essence Shattering Strike`,
        type: `Strike`,
        shortDesc: `Make an attack against a target which inflicts an additional 6d6 points of force damage, potentially dazes the target.`,
        longDesc: `[Force]With a powerful strike, the Veiled Moon disciple attacks at the very spirit of his foe with his silver-blue light. The initiator makes an attack against a target creature, and inflicts an additional 6d6 points of force damage and dazes his foe for 1d4 rounds due to the disturbance on a failed Fortitude save (DC 15 + initiation modifier).`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One creature`,
        duration: `Instantaneous, 1d4 rounds`
      },
      {
        school: `veiledMoon`,
        level: 6,
        name: `Vaporform Crash`,
        type: `Strike`,
        shortDesc: `Make a melee attack against an incorporeal target, if successful the disciple becomes incorporeal and the target suffers 12d6 points of force damage and becomes corporeal; the switch in body state lasts for 1d4 rounds.`,
        longDesc: `[Force]The Veiled Moon teaches that its disciples must know how to balance the scales between both worlds, so to make a foe real in the Material world, then the disciple must briefly sojourn to the other side. The disciple makes a melee attack against an incorporeal target, and if successful the target loses their incorporeal subtype for 1d4 rounds and takes 12d6 points of force damage (incorporeal foes lose their Charisma bonus to AC and have a Strength score equal to their Charisma score -4; all incorporeal equipment temporarily becomes corporeal with the target). The disciple gains the incorporeal subtype for a like number of rounds (losing his Strength score and gaining a +4 bonus to Charisma and he may apply his Charisma bonus to his AC as a deflection bonus; all of his equipment becomes temporarily incorporeal with him as well). This is an Ethereal plane using maneuver.`,
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `1d4 rounds`
      },
      {
        school: `veiledMoon`,
        level: 6,
        name: `Phantom Penumbra`,
        type: `Counter`,
        shortDesc: `Make a Stealth check opposing the attackers Perception check, if successful, teleport up to 20-ft. away and leave behind 1d6 major images.`,
        longDesc: `[Teleportation, Figment]To slip through the worlds is a simple matter for the disciple, and using this to deceive and evade an attacker is effortlessly done. The initiator makes a Stealth check against the attacker's Perception check. If the disciple succeeds he is able to teleport to a position up to 20-ft. away, gain the incorporeal subtype, and leave behind 1d6 major images where his previous position lay. Major images persist until they are slain or until 4 rounds have elapsed and the initiator remains incorporeal until his next turn. This ability may be used to attempt evade spells and effects that directly target the initiator or for those that allow for a Reflex save. This is an Ethereal plane using maneuver.`,
        initiationAction: `immediate`,
        range: `Personal, 20-ft.`,
        target: `You`,
        duration: `Instantaneous, 4 rounds`
      },
      {
        school: `veiledMoon`,
        level: 6,
        name: `Spiritual Weapon Stance`,
        type: `Stance`,
        shortDesc: `In this stance, the character is treated as having ghost touch on offensive and defensive items and weapons, gains spell resistance, and attacks inflict an additional 2d6 points of force damage.`,
        longDesc: `[Force]By channeling ethereal energies along his weapons and his body, the initiator becomes immersed in both worlds, being as solid on the Ethereal Plane as he is on the Material. While in this stance, the initiator's weapons, armor, and equipment are treated as if they had the ghost touch property (ammunition retains the property until used), and his attacks inflict an additional 2d6 points or force damage. As a side-effect of this empowerment from the Ethereal plane, this energy acts a buffer against magical attacks, and grants the disciple spell resistance equal to 5 + his initiator level. This is an Ethereal plane using stance.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `veiledMoon`,
        level: 6,
        name: `Ether Wave`,
        type: `Strike`,
        shortDesc: `The disciple unleashes a potent wave of dimensional energy as a 40-ft. cone inflicting 12d6 points of force damage.`,
        longDesc: `[Force]The Veiled Moon disciple concentrates his spiritual energies to his hand and tears into the barrier between the Astral and the Material, and releases the energies that form from this in a wracking wave of silvery-blue energy. The initiator unleashes a 40-ft. cone of dimensional energy which inflicts 12d6 points of force damage to all targets within its area with a Reflex saving throw (DC 16 + initiation modifier) for half damage.`,
        initiationAction: `standard`,
        range: `40-ft.Area: Cone-shaped emanation`,
        duration: `Instantaneous`
      },
      {
        school: `veiledMoon`,
        level: 7,
        name: `Fade Through`,
        type: `Boost`,
        shortDesc: `The disciple may teleport up to twice his movement speed as a swift action.`,
        longDesc: `[Teleportation]An advanced technique, the Veiled Moon disciple at this point learns how to fold two points in space around him to appear at another location within the span of a heart beat. The initiator may teleport to a location up to twice his movement speed away as a swift action.`,
        initiationAction: `swift`,
        range: `Twice the disciple's movement speed`,
        target: `You`,
        duration: `Instantaneous`
      },
      {
        school: `veiledMoon`,
        level: 7,
        name: `Dispersal Strike`,
        type: `Strike`,
        shortDesc: `Target becomes incorporeal and takes 12d6 points of force damage, on a failed Will their gear does not become ethereal with them, duration until end of next turn.`,
        longDesc: `[Force]With a powerful strike and flash of silver-blue light, the disciple slams his foe directly into the Ethereal for a few moments, causing it to become ghostly and unreal. The initiator makes an attack on a target creature and if successful, the strike inflicts 12d6 points of force damage in place of normal damage, and the target gains the incorporeal subtype for 1d4 rounds. The target must make a Will save (DC 17 + initiation modifier) to negate the incorporeality portion of this strike or only his body becomes incorporeal and items held in his hands do not, falling to the ground at their feet. This strike does not function on targets who already possess the incorporeal subtype. This is an Ethereal plane using maneuver.`,
        initiationAction: `standard`,
        range: `Melee or ranged attack`,
        target: `One target`,
        duration: `1d4 rounds`
      },
      {
        school: `veiledMoon`,
        level: 7,
        name: `Flashing Ether Touch`,
        type: `Strike`,
        shortDesc: `Make a melee touch attack against a target, if successful teleport the target up to 60-ft. away, deal 10d6 points of damage and knocking them prone.`,
        longDesc: `[Teleportation]With but a touch the Veiled Moon disciple may send a foe hurtling through the Astral to reappear with frightening velocity to hit the ground. The initiator makes a melee touch against a target, and the target makes a Will save (DC 17 + initiation modifier) or is teleported up to 60-ft. away, successful saving throw negating the maneuver. Upon a failed saving throw, the target suffers 10d6 points of damage from reaching high speeds and slamming hard into the ground and are considered prone.`,
        initiationAction: `standard`,
        range: `Melee attack, 60-ft.`,
        target: `One target`,
        duration: `Instantaneous`
      },
      {
        school: `veiledMoon`,
        level: 8,
        name: `Eclipsing Moon`,
        type: `Strike`,
        shortDesc: `As part of a full-round attack, you may teleport up to your movement range between attacks, and continue the full-round attack, adding +2 to hit and +4d4 force damage to each strike against a target's flat-footed AC.`,
        longDesc: `[Teleportation, Force]Folding space around his form effortlessly, the disciple is capable of leaps through the ether and attacking through the barrier between the worlds in a series of staccato bursts of silvery-blue light, his image blinking as he strikes. As a full attack action, the initiator may make an attack against a target and then teleport a distance up to his movement speed to a new target to strike again, and each attack is made against the target's flat-footed armor class. He may do this a number of times equal to the number of attacks he possesses on a full attack action (including off hand attacks or secondary attacks), and he may select the same target for each attack but each teleportation must land him in position to make an attack against a target creature (he must attack a target creature at the end of each teleportation). Each attack gains a +2 competence bonus and inflicts an additional 4d4 points of force damage. Secondary attacks such as off-hand attacks and secondary natural attacks only add 2d4 of force damage. The initiator may forgo the first attack of this maneuver to teleport himself into position to use the rest of the attacks of this maneuver.`,
        initiationAction: `full-round`,
        range: `Melee attack, movement speed`,
        target: `Special`,
        duration: `Instantaneous`
      },
      {
        school: `veiledMoon`,
        level: 8,
        name: `Lunar Penumbra`,
        type: `Counter`,
        shortDesc: `When targeted by a spell or effect, the disciple may make an opposed Stealth check against the enemy's Perception; success indicates that the two switch positions through teleportation and the enemy suffers the spell or effect instead.`,
        longDesc: `[Teleportation]It is said that the moon is portrayed in some legends as a laughing trickster, and with this powerful ability, the Veiled Moon disciple is capable of pulling an incredible trick upon his foe. The initiator makes a Stealth check against his foe's Perception check. If successful he and his attacker switch positions, and the attack that was directed against the disciple now affects the attacker, effectively causing the target to strike itself. This ability may be used to evade spells and effects that directly target the initiator or for those that allow for a Reflex save (but if the initiator is still within the radius of the effect, he still is struck by it).`,
        initiationAction: `immediate`,
        range: `Personal. Close (25-ft. + 5-ft./2 initiator levels)`,
        target: `You and one target`,
        duration: `Instantaneous`
      },
      {
        school: `veiledMoon`,
        level: 8,
        name: `Anchoring Spirit`,
        type: `Stance`,
        shortDesc: `Disciple gains the incorporeal subtype; any attempt to teleport into or out of any space within 30-ft. of the disciple automatically fails unless he initiates the effect or willingly allows it.`,
        longDesc: `The Veiled Moon disciple pulls himself fully into the Ethereal and manifests a ghostly apparition of his form upon the Material, and in doing so he locks his immediate area for travel through the Ethereal or Astral plane. While in this stance, the initiator gains the incorporeal subtype and anyone within 30-ft. of his position who attempts to use an effect with the [Teleportation] type likely fails. The disciple can exclude allied creatures from this effect. Those effected can attempt an opposed initiator level check (using their caster or initiator level) to successfully execute their teleportation effect. Once outside of this stance's range, creatures are no longer affected. If two or more instances of Anchoring Spirit overlap, they cease functioning until separated. This is an Ethereal plane using maneuver.`,
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`
      },
      {
        school: `veiledMoon`,
        level: 9,
        name: `Banish to the Beyond`,
        type: `Strike`,
        shortDesc: `The disciple makes a melee touch attack against a target, and if successful then the foe is banished wholly to the Astral Plane, and they are barred from returning to the Material Plane for 1 hour.`,
        longDesc: `(teleportation); The ultimate technique of the Veiled Moon disciple is the ability to lay a mark against a target and shunt it gently into the Astral plane where it may ponder its reasons for crossing the likes of a master. The initiator makes a melee touch attack against a target, who then makes a Will save (DC 19 + initiation modifier). Failure indicates that the target is shifted fully into the Astral plane, body and all, and the target may not return to the Material plane for one hour. If the foe has no way to return to the Material plane after this duration has expired, he is effectively stranded and must find his own way back to his world. If the target succeeds his saving throw, he is still shunted to the Astral plane, but returns automatically to the Material plane after one minute. While in the Astral plane, the target is tethered to his body at the location he occupied before being pushed into the Astral Plane with a silver cord as normal (per astral projection).`,
        initiationAction: `standard`,
        range: `Melee touch`,
        target: `One creature`,
        duration: `Special (see text)`,
        savingThrow: `Will partial`
      },
        {
        school:'heartOfTheMaelstrom',
        level:1,
        name:'Static Charge Stance',
        type:'Stance',
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`,
        longDesc:'You can charge up a particularly devastating strike. Each time you attack, or are attacked, you gain 1 static charge stack (max initiation modifier) that you can then unleash when declaring a melee attack. When you do, you expend all stacks, gaining +1 to the attack roll and dealing 1d6 electricity damage for each stack expended. Once you expend your stacks, you suffer a -1 penalty to armor class for each stack expended for 1 round. You do not gain charges for the unleashing attack, and if the attack is against multiple opponents, this bonus only applies to one.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:1,
        name:'Charged Current Stance',
        type:'Stance',
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`,
        longDesc:'Increase your land speed by 10 feet. Increase the DC of all reflex saves caused by a Heart of the Maelstrom maneuver by +2, and attacks made as part of initiating Heart of the Maelstrom maneuvers deal an additional 2d6 electricity damage. Every 4 levels the DC of reflex saves increase by a further +1 and deal an additional 1d6 electricity damage. Maneuvers from other disciplines get half of these bonuses. If a maneveuver makes multiple attacks, the bonus damage only applies to the first.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:1,
        name:'Lightning Draw',
        type:'Counter',
        initiationAction: `immediate`,
        range: `Personal`,
        target: `You`,
        duration: `Instantaneous`,
        longDesc:'When a creature declares an attack on you, make an attack of opportunity on them first, deal an additional 1d6 electricity damage to them.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:1,
        name:'Over Acceleration',
        type:'Boost',
        initiationAction: `swift`,
        range: `Personal`,
        target: `One attack`,
        duration: `1 round`,
        longDesc:'Your next attack this turn is devastatingly fast, however the burst of speed takes time to recover from, leaving you open to attack. You gain a +4 to your next attack roll, however you have -4 to armor class for 1 round.',
        },
        // {
        // school:'heartOfTheMaelstrom',
        // level:1,
        // name:'In the Eye',
        // type:'Strike',
        // initiationAction: `standard`,
        // range: `Melee attack`,
        // target: `One creature`,
        // duration: `1d4 rounds`,
        // longDesc:'Make an attack against a target, if it hits the target must make a fortitude save or become blinded for 1d4 rounds',
        // },
        {
        school:'heartOfTheMaelstrom',
        level:1,
        name:'Flash Strike',
        type:'Strike',
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`,
        longDesc:'You unleash a blazingly fast melee attack. The target of this strike must make a reflex saving throw or be flat-footed against the attack, and suffer an additional 2d6 electricity damage.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:2,
        name:'Stormborn',
        type:'Boost',
        initiationAction: `swift`,
        range: `personal`,
        target: `You`,
        duration: `1 round`,
        longDesc:'For 1 round, you double your movement speed, gain a +2 dodge bonus to your AC, and your attacks deal an additional 1d6 electricity damage. For 1 round afterwards, you suffer a -2 penalty to attack and AC.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:2,
        name:'Backstep Bolt',
        type:'Counter',
        initiationAction: `immediate`,
        range: `Personal `,
        target: `You `,
        duration: `Instant`,
        longDesc:'Make an acrobatics check vs a melee or ranged attack, if you succeed, negate the attack. You then move up to half your speed but at least 1 square, this still provokes attacks of opportunity, including from the target whos attack possibly negated. You cannot use acrobatics to negate this attack of opportunity.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:2,
        name:'Voltaic Edge',
        type:'Strike',
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `1d4 rounds`,
        longDesc:'Make an attack against a target, if it hits, it deals damage as normal, but they must also make a will save or become vulnerable to electricity damage for 1d4 rounds and lose 5 electricity resistance.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:2,
        name:'Volt Crash',
        type:'Strike',
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `1 round`,
        longDesc:'Make a melee attack that deals an additional 1d6 electricity damage, and if successful the target must make a fortitude save or become dazed for 1 round. Creatures who take no electricity damage from this gain a +4 bonus on their save, creatures vulnerable to electricity take a -2, creatures taking double damage from electricty take a -4 penalty to the save.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:2,
        name:'Flash Follow Up',
        type:'Strike',
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`,
        longDesc:'Make two attacks against the same target as a standard action, the first dealing an additional 1d6 electricity damage, the second at a -4 to attack, but dealing an additional 2d6 electricity damage',
        },
        {
        school:'heartOfTheMaelstrom',
        level:3,
        name:'Lightning Flash Blade',
        type:'Strike',
        initiationAction: `standard`,
        range: `Melee attack`,
        target: `One creature`,
        duration: `Instantaneous`,
        longDesc:`Make a single attack that is so fast the target becomes flat-footed to it and deals an additional 3d6 electricty damage. This doesn't negate immunity to being flat-footed such as from uncanny dodge.`,
        },
        {
        school:'heartOfTheMaelstrom',
        level:3,
        name:'Flowing Current Strike',
        type:'Strike',
        initiationAction: `standard`,
        range: `Melee attack, then 15 feet`,
        target: `One creature`,
        duration: `Instantaneous`,
        longDesc:'Make an attack against a target, if it hits, it deals an additional 2d6 electricity damage, then target another enemy creature within 15 feet, that target must make a reflex save or also take 2d6 electricity damage, you may continue targeting creatures until one makes a reflex save, but never the same creature twice.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:3,
        name:'Thunderball Stance',
        type:'Stance',
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`,
        longDesc:'Increase your land speed by 20 feet. Whenever you could take an attack of opportunity, you can take an additional melee against them at a -5 penalty. This bonus attack does not count as an attack of opportunity.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:3,
        name:'Reverse The Current',
        type:'Counter',
        initiationAction: `immediate`,
        longDesc:`You can activate this counter in response to making a reflex saving throw, or when targeted by a ranged attack. 
        \nWhen activating it in response to a reflex save, you gain a +4 bonus to the save and the benefits of evasion against it (if you already had evasion, you instead gain improved evasion). 
        \nWhen used in response to a ranged attack, you gain a +6 dodge bonus to AC against the attack. 
        \nIf you succeed on the saving throw, or successfully avoid the ranged attack, you may move up to your movement speed if it would place you within melee attack reach of the attacker, and make a single melee attack against them.`,
        },
        {
        school:'heartOfTheMaelstrom',
        level:3,
        name:'Speed Amp',
        type:'Boost',
        initiationAction: `swift`,
        longDesc:`Your next melee attack this turn becomes devastatingly fast, and is made against the creature's flat-footed armor class. If the target would already be flat-footed against it, they also lose all bonuses to AC that they would lose if they were helpless (eg: their dexterity score becomes 0, lose monk AC bonus, etc.). If you use this against a creature who would already be considered flat-footed (not from this maneuver) if not for immunity to the condition, such as uncanny dodge, they are still considered flat-footed, but do not lose all of their additional armor class as if they were helpless.`,
        },
        {
        school:'heartOfTheMaelstrom',
        level:4,
        name:'Conductive Rend',
        type:'Strike',
        initiationAction: `standard`,
        longDesc:`Make a melee attack that deals an additional 6d6 electricity damage, and if successful, the target must also make a will save or lose 15 electricity resistance and become vulnerable to electricity damage for 1d4 rounds. They must also make a reflex save or be knocked 15 feet directly away from you. If they collide with another creature, that creature also takes 4d6 electricity damage, but the target of this maneuver's movement stops where they collided.`,
        },
        {
        school:'heartOfTheMaelstrom',
        level:4,
        name:'Outrun All Of My Problems',
        type:'Counter',
        initiationAction: `immediate`,
        longDesc:'Make a reflex save in place of a different saving throw. If the ability would have a reduced effect on a successful save, this does not allow you to apply evasion or improved evasion to that ability.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:4,
        name:'Overdrive',
        type:'Boost',
        initiationAction: `swift`,
        longDesc:'The next time you take a melee attack within 1 round, you may make another attack against the same target, gaining a +2 bonus on the attack and dealing an additional 3d6 electricity damage. After the attack is resolved, you may move 15 feet, provoking as normal. Until you take the attack gained from this boost, you gain a +2 dodge bonus to armor class. After taking the attack gained from this boost, you take a -6 penalty to your armor class until the end of your next turn.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:4,
        name:'Flash Bang',
        type:'Strike',
        initiationAction: `standard`,
        longDesc:'Make a melee attack, if successful, it deals damage as normal, and the target must make a reflex save or be blinded for 1d2 rounds, a fortitude save or be deafened for 1d4 rounds, and a will save or be dazed for 1 round.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:4,
        name:'Leaping Thunder',
        type:'Strike',
        initiationAction: `full-round`,
        longDesc:`Move up to your movement speed and make a melee attack, substituting the attack roll with an acrobatics check (but still gaining bonuses to the attack roll as if it were an attack, such as from weapon enhancement, feats, etc.). You gain a bonus on the roll equal to your dodge bonuses to armor class and any bonuses you gain on melee attacks (weapon's enchantments, morale, circumstance, etc.). The attack deals an additional 4d6 electricity damage and the target must make a reflex save or be knocked prone. Gain +4 AC vs attacks of opportunity provoked from movement during this attack.`,
        },
        {
          school:'heartOfTheMaelstrom',
          level:4,
          name:'Steel Tempest',
          type:'Strike',
          initiationAction: `See Text;`,
          range: `See Text;`,
          longDesc:`This maneuver is not expended as normal, instead, it expended once it has been activated 3 times (resets at the start or end of combat).
          \n1st) Steel Tempest Gathering: Swift action, Make a melee attack with a -4 penalty, if it is a confirmed critical hit, it deals an additional 4d6 electricity damage (increase the dice step for critical multipliers larger than 3x: 4d8, 4x: 4d10, 5x 8d6 etc.) And if the attack is successful, the next time within this initiation of the maneuver, the attack is instead Steel Wind Rising
          \n2nd) Steel Wind Rising: Swift action, Make a melee attack with a -6 penalty, gaining a flat +2 to its critical threat range. If this attack hits, it deals damage as normal and the next time within this initiation of the maneuver, the attack is instead Maelstrom of Steel.
          \n3rd) Maelstrom of Steel: movement action, your swing your blade and unleashe a 15 foot tall tornado. Make a melee attack with a -4 penalty and comparing it against the armor classes of all creatures within a 30 foot line (15 feet high) away from you, dealing damage as normal plus 6d6 electricity damage, and causing them to make a reflex check or be knocked prone. Flying creatures that fail the reflex save are knocked the ground and then knocked prone. If a creature is within your threatened area and in the tornado's path, your critical threat range against them for this attack is increased by a flat +2 and they suffer electricity damage as Steel Tempest Gathering if it is a critical hit.`,
        },
        {
        school:'heartOfTheMaelstrom',
        level:5,
        name:'Thunderclap and Flash',
        type:'Strike',
        initiationAction: `full-round`,
        longDesc:`Move up to twice your movement speed in a straight line, attacking any single target that you move through. While moving with this maneuver, you can use an acrobatics check to allow you to ignore occupied spaces, difficult terrain, and even move through the air any direction. The DC for this equals 5x the ignored squares, +5 per square with enemy creatures in it. If this roll fails, you stop at the last available square you moved through before your roll was no longer high enough to move you. If there is an applicable target within reach of where you stopped, you can still make the attack against them. This movement provokes as normal. For this attack, the target is considered flat-footed, you gain +2 to attack, a +2 flat bonus to the critical threat range, your critical damage multiplier increases by +1, and it deals an additional 4d6 electricity damage. 
        \nYou do not have to end your movement once you attack the target of this strike, and can continue moving if you have movement speed left. During the movement for this strike you gain a +4 dodge bonus to your armor class, however afterwards you suffer a -6 penalty to it for 1 round.`,
        },
        {
        school:'heartOfTheMaelstrom',
        level:5,
        name:'Four Fold Flash',
        type:'Strike',
        initiationAction: `full-round`,
        longDesc:`<flurry>Make 4 melee attacks against a single target. \nThe first attack deals an additional 1d6 electricty damage and the target is flat-footed \nThe second attack has a -2 penalty to attack but the target is flat-footed and it deals an extra 2d6 electricity damage \nThird and fourth attacks both take a -2 penalty and are against normal armor class, but deal an extra 4d6 electricity damage.
        \nThis burst of speed leaves you exhausted, and you lose -6 AC until the start of your next turn`,
        additionalTags:["Flurry"]
        },
        {
        school:'heartOfTheMaelstrom',
        level:5,
        name:'Thunder Cross Split Attack',
        type:'Strike',
        initiationAction: `full-round`,
        longDesc:`Move up to your stance bonus movement speed (doesn't provoke) and declare an attack against a target, if the target has a counter (or any ability that can be used in response to an attack to potentially avoid or reduce it) readied they must expend it without getting its effects, and then the initator must then yell, "you fell for it you fool, thundero crosseu splito attaaack", and then a different party member MUST yell "incredible, by crossing his arms he can attack while keeping his guard up" and then a third party member MUST yell "no fighter has ever escaped it". If all 4 conditions are met, then make two attacks against against the target at flat-footed AC, each dealing a bonus 4d6 electricity damage and the target makes a will save or becomes dazed for 1 round. If the target does not have a counter ready, or a party member fails to say their line, then the initiator falls prone, and the target may make a free attack against the initiator. You can only use this strike against an enemy once.`,
        },
        {
        school:'heartOfTheMaelstrom',
        level:5,
        name:'Amp Up',
        type:'Boost',
        initiationAction: `swift`,
        longDesc:'Gain two additional immediate actions this round (immediate actions can be used for swift actions on your turn). Once you have used both of the immediate actions granted by this boost, you gain a penalty to your armor class and attack of -4 until the end of your next turn. Increase the spell point cost of this maneuvers by 5 for every time this round you have used Amp Up.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:5,
        name:'Thunder Storm',
        type:'Strike',
        initiationAction: `full-round`,
        longDesc:'Make a single attack against all enemies within reach which deals an additional 3d6 electricity damage, all targets struck must then must make a reflex save or be knocked prone.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:5,
        name:'Slicing Maelstrom',
        type:'Stance',
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`,
        longDesc:'Increase your land speed by 30 feet. Gain a competence bonus to confirming critical hits equal to your initiator modifier. Every time you confirm a critical hit with a weapon attack you deal an additional 3d6 electricity damage, plus 3d6 for every critical multiplier higher than x2. This also places a stack of charge on the creature, if a creature ever has two charges on it, the charge triggers dealing another 3d6 electricity damage, plus 3d6 for every critical multiplier higher than x2.',
        },
        {
          school:'heartOfTheMaelstrom',
          level:5,
          name:'Yamabuki Peak',
          type:'Stance',
          initiationAction: `swift`,
          range: `Personal`,
          target: `You`,
          duration: `Stance`,
          longDesc:`Increase your land speed by 30 feet. Your <technique>, <royal>, and <sakura> maneuvers treat creatures with fortification as being 33% lower (treat creatures with critical immunity as having 100% fortification). If you make a weapon attack during a <sakura> maneuver against a creature with no fortification (whether before or after the reduction granted by this stance) you gain a flat +1 increase to your critical threat range, though if you roll within this extended range, you suffer a -8 penalty to the confirmation roll. Confirmed critical hits deal an additional 1d6 points of damage per +2 of your initiation modifier (precision damage).`,
        },
        {
          school:'heartOfTheMaelstrom',
          level:5,
          name:'Surge Dash',
          type:'Counter',
          initiationAction: `immediate`,
          longDesc:'When an enemy creature either enters or leaves your threatened area, you can move up to your movement speed -30ft. This movement still provokes as normal.',
        },
        {
          school:'heartOfTheMaelstrom',
          level:6,
          name:'J2M Raiden',
          type:'Counter',
          initiationAction: `immediate`,
          longDesc:'Automatically negate any status, damage, or condition of an attack or effect and move your movement speed. The damage becomes a metaphysical entity that remains on the square you avoided the attack from. At the start of each of your turns it moves toward you. The first round it moves 40 feet, and every round after the speed increases by 20 feet. Once it reaches you, you take the damage, conditions, and statuses of being hit by the attack, plus for every round you avoided it, the damage increases by 25% (max 200%). Every time the entity has to move around an object or creature, it has a 10% (+5% per turn evaded) chance of striking the object or creature instead, dealing its damage to it and ceaseing to exist, though the creature can make a reflex save to avoid it and allow it to keep moving past them. The DC increases by +2 every round you have avoided it. If the attack or ability had a DC and it strikes a creature other than you, the struck creature is allowed a save against it. You are not, and cannot use a reflex save to avoid it either.',
          range: `Personal`,
          duration: `instantaneous`,
          target: `you`,
        },
        {
        school:'heartOfTheMaelstrom',
        level:6,
        name:'Lightning Rod Wrack',
        type:'Strike',
        initiationAction: `standard`,
        longDesc:'Make a melee attack that deals an additional 6d6 electricity damage, and if successful the target must make a will save or lose all resistance and become vulnerable to electricity damage for 1d4 rounds. Plus, while it is active, any attack that would deal electricity damage against the target gains a +3 bonus, and they suffer a -2 penalty on saves against electricity effects. If the target is immune to electricity, it instead takes 50% damage from it.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:6,
        name:'Chain Lightning Strike',
        type:'Strike',
        initiationAction: `full-round`,
        longDesc:'Move up to half your movement speed, attacking each opponent adjacent to you at any point in the movement. These attacks deal an additional 4d6 electricity damage, and you gain a +2 dodge bonus to AC vs attacks of opportunity provoked from your movement during this strike. If a creature attacks and misses you with an attack of opportunity provoked from your movement during this strike, it provokes an attack of opportunity from you.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:6,
        name:'Form of the Storm Dragon',
        type:'Stance',
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        longDesc:'Increase your land speed by 40 feet. Whenever you hit an opponent with a melee attack, they must make a fortitude save or become vulnerable to electricity and lose 20 electricity resistance for 1d4 rounds. Creatures immune to electricity instead take 50% damage from electricity if they fail.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:6,
        name:'Static Field',
        type:'Counter',
        initiationAction: `immediate`,
        longDesc:'When a creature attacks you in melee, you can use the lingering electric energy in the air you create to strike at them first. The attacker must make a reflex save or lose the attack, if they fail they also make a fortitude save or become stunned until the start of their next turn, and it provokes an attack of opportunity from you.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:6,
        name:'Shock and Awe',
        type:'Boost',
        initiationAction: `swift`,
        longDesc:'Make two melee attacks. The first attack suffers a -4 penalty to attack but deals an additional 4d6 electricity damage. The second attack suffers a -8 penalty to the attack but gain a flat +2 bonus to its critical threat range. After initiating this boost, you suffer a -6 penalty to your armor class until the end of your next turn.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:7,
        name:'Flash Dodge',
        type:'Counter',
        initiationAction: `immediate`,
        longDesc:'Make an acrobatics check vs an attack, if you succeed, you negate the attack and can move up to half your movement speed, this provokes attacks of opportunity as normal, but if any creature attacks you with an attack of opportunity, you may also make an attack of opportunity on them directly after, with an additional 4d6 electricity damage.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:7,
        name:'Overcharged Blade',
        type:'Boost',
        initiationAction: `swift`,
        longDesc:'You gain a +6 bonus to your next melee attack this round, and if it hits it deals an additional 4d6 electricity damage and the target must make a fort save or be dazed for 1 round. After initiating this boost you suffer a -8 penalty to your armor class for 1 round.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:7,
        name:'Thunderous Follow Up',
        type:'Boost',
        initiationAction: `swift`,
        longDesc:'You can initiate this boost when declaring a strike against a target. If the strike hits, you may make an additional melee attack against that target that deals an additional 2d6 electricity damage, and has a flat +2 bonus to its critical threat range. If this additional attack is a confirmed critical hit, you can make another melee attack that deals an additional 4d6 electricity damage, and the target must make a reflex or be knocked prone. If you miss your strike the boost is wasted and it provokes an attack of opportunity from the target you missed the strike on. If your strike targets multiple creatures it provokes from all the creatures you miss.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:7,
        name:'Thunder Dragon Gigavolt Strike',
        type:'Strike',
        initiationAction: `standard`,
        longDesc:'<power> Make a single devastating electrically charged melee attack with the force of an ancient thunder dragon. This attack deals an additional 15d6 electricity damage and has a +1 bonus to its critical damage multiplier.',
        additionalTags:["Power"]
        },
        {
        school:'heartOfTheMaelstrom',
        level:7,
        name:"Thunder Dragon's Fury",
        type:'Strike',
        initiationAction: `full-round`,
        longDesc:'<flurry> Make 5 melee attacks at your full BAB-5 against the same creature. Each attack deals an additional 2d6 electricity damage, and each confirmed critical hit increases the critical damage multiplier by +1 for the remaining attacks. After initiating this strike, you suffer a -8 penalty to your armor class until the end of your next turn.',
        additionalTags:["Flurry"]
        },
        {
        school:'heartOfTheMaelstrom',
        level:8,
        name:'Overclock',
        type:'Boost',
        initiationAction: `swift`,
        longDesc:"The next heart of the maelstrom maneuver you use this round has its initiation action reduced by 1 step, but this burst of energy leaves you weakened for 3 rounds. While weakened, you have -8 to armor class and reduce your movement speed by 50 feet. You cannot initiate this boost multiple times in 1 round.",
        },
        {
        school:'heartOfTheMaelstrom',
        level:8,
        name:'Godspeed',
        type:'Boost',
        initiationAction: `swift`,
        duration:"2 rounds",
        longDesc:'Immediately move up to half your movement speed. For 1 round afterwards you triple your movement speed, gain a +4 dodge bonus to AC against attacks of opportunity, and +4 dodge bonus to AC against all attacks, and each of your attacks deals an additional 3d6 electricity damage. When this boost ends you take a -6 penalty to AC, attacks, and reduce your movement speed by 30 feet for 1 round.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:8,
        name:'Power Overwhelming',
        type:'Boost',
        initiationAction: `swift`,
        longDesc:'Gain 3 immediate actions this round (immediate actions can be used for swift actions on your turn), you also gain +4 dodge bonus to AC and reflex saves until you use up the last immediate action, after which you suffer a -8 penalty to AC for 1 round. This cannot be used on the same turn as you used Amp Up, nor can you initiate this boost twice in one round.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:8,
        name:'Unlimited Chain Strike',
        type:'Strike',
        initiationAction: `full-round`,
        longDesc:'You fire a bolt of chain lightning at a target within 30 feet, they must make a reflex save or receive 4d6 + initiation modifier electricity damage, then select another target with 20 feet of them to do the same. You can continue selecting new targets until one succeeds the reflex save, but never the same target more than twice, and never the same target twice in a row. After the chain lightning ends, you dash at blazingly fast speeds, moving to each of the targets in the order they chain lightning struck them, making a melee attack against each (including attacking a target twice if it failed the save twice). You can move up to 10x your movement speed with this, and your movement during it does not provoke. You end this strike adjacent to the last target you attacked.',
        },
        {
        school:'heartOfTheMaelstrom',
        level:8,
        name:'Honoikazuchi no Kami',
        type:'Strike',
        initiationAction: `full-round`,
        longDesc:`Move up to four times your movement speed in a straight line (you can reduce the distance you travel by 1x your movement speed to allow one turn up to 90 degrees, minimum 2x your movement speed), attacking any single target along the way. While moving with this maneuver you can ignore occupied spaces, difficult terrain, or squares that you normally cannot walk through (even moving through the air, though not through physical obstacles like walls) by making an acrobatics check. The DC for this equals 4x the ignored squares, +4 per square with an enemy in it. If this roll fails, you stop at the last applicable square you moved through before your roll was no longer high enough to move you. If there is an applicable target within reach of where you stopped, you can still make the attack against them. This movement provokes as normal. For this attack, the target is flat-footed, even if they cannot normally be caught flat-footed, you gain +4 to attack, a +2 flat bonus to the critical threat range, a +2 to the critical damage multiplier, and it deals an additional 8d6 electricity damage. If the first attack is a confirmed critical hit, you can make a second melee attack with the same weapon with a -5 penalty, for which your critical threat range and multiplier becomes the default of the weapon (not including any abilities or enchantments that would modify it, even this maneuver, nor can it be modified or automatically threaten or critical by other abilities). If your second attack is a confirmed critical hit, the critical damage multiplier increases by 4x.
        \nYou dont not have to end your movement once you attack the target of this strike, and can continue moving if you have movement speed left. During the movement of this strike you gain a +8 dodge bonus to your armor class against attacks of opportunity, but afterwards you suffer a -8 penalty to your armor class for 1 round.`,
        },
        {
        school:'heartOfTheMaelstrom',
        level:8,
        name:'Breath of the Thunder God',
        type:'Stance',
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`,
        longDesc:`Increase your land speed by 50 feet. You can initiate a boost as an immediate action, and can initiate <sakura> and <technique> strikes that don't include movement and are standard actions or less to initiate as attacks of opportunity. Gain +6 dodge bonus to ac while moving, and +6 to reflex saves. Your attacks deal an additional 4d6 electricity damage. At the beginning of your turns you can recover one heart of the maelstrom boost, you cannot use that boost the turn you recover it.`,
        },
        {
        school:'heartOfTheMaelstrom',
        level:9,
        name:'Thunder God Maximum Speed Strike',
        type:'Strike',
        initiationAction: `full-round`,
        longDesc:'<flurry> Attack a single target 9 times, each with cumulative -2 penalty to attack, but with an additional 2d6 electricity damage. Each successful attack increases the electricity damage of the remaining attacks by 1d6 damage, a critical hit increases it by 1d6 X the critical multiplier. After the initiation of this strike, until the end of your next turn, your movement speed is reduced to 1/10th and you suffer a -12 penalty to your armor class. You can take any additional attacks you gain from full-round attacks, such as from haste or the Lightning Strike ability (but not from abilities such as flurry of blows, two-weapon fighting, or natural attacks), but they do not gain any benefit of the strike.',
        additionalTags:["Flurry"]
        },
        {
        school:'heartOfTheMaelstrom',
        level:9,
        name:'Heart of the Maelstrom',
        type:'Stance',
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`,
        longDesc:'You are more than just lightning, you are an entire storm, striking everything in raw destructive force and never in the same way twice. When you enter this stance you can choose two other heart of the maelstrom stances you know and act as if you were in them both. However, like lightning you fizzle out quickly, at the end of each of your turns you had this stance active take 2 points of drain to your dexterity and 2 points of damage to your constitution, neither of these can be healed until you are no longer in heart of the maelstrom stance. You cannot initiate the same strike twice during the same activation of this stance. On the round you leave this stance (which you can do while making any other attack) you finish with a final cataclysmic flash, gain a +1 bonus to critical threat range (flat) and 2d6 electricity damage for each round you were in this stance, and a +1 on critical multiplier for each 3 rounds you were in this stance, but you also receive a -2 penalty to AC for each round you were in this stance, for rounds equal to half the rounds you were in this stance (minimum 1)',
        },
        {
        school:'burningCitadel',
        level:1,
        name:'Blazing Aggression Stance',
        type:'Stance',
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`,
        longDesc:'Your melee attacks deal an additional 2d6 fire damage and apply 1 stack of immolation, but at the end of each of your turns receive 2d6 fire damage and 1 stack of immolation. At 8th level the damage for your attacks and to self increases to 4d6 fire damage and 2 stacks of immolation, and again at 16th to 6d6 points of fire damage, and 3 stacks of immolation',
        },
        {
        school:'burningCitadel',
        level:1,
        name:'Flame Heart Stance',
        type:'Stance',
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`,
        longDesc:'Every time a creature attacks you with a melee non-reach weapon or natural attack they take 1d6 fire damage. If the damage dice roll is 5 or higher they also receive one 1 stack of immolation. For every 6 levels you have this increases by 1d6 and the roll to grant a stack is reduced by 1 (each dice has the chance to apply individually).',
        },
        {
        school:'burningCitadel',
        level:1,
        name:'Flame of Life',
        type:'Stance',
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`,
        longDesc:'At the end of each of your turns you can remove up to initiation modifier stacks of immolation from yourself to heal yourself 1d4 per stack. When you strike an enemy with a melee weapon, you can remove up to initiation modifier immolation stacks on them to heal 1d4 for each point removed. These stacks are removed before any damage from the attack is dealt.',
        },
        {
        school:'burningCitadel',
        level:1,
        name:'Fire Smash',
        type:'Strike',
        initiationAction: `standard`,
        longDesc:`Make an attack that deals an additional 2d6 fire damage and applies 1 stack of immolation, and if it hits, all targets adjacent to the target (possibly including you) must make a reflex save or also receive 2d6 fire damage and 1 immolation.
        \n[Overheat-10x]: Increase the area of the damage by 2 additional squares around the target and the AoE fire damage is increased by 1d6. You suffer 2 immolation.`,
        range: "melee",
        target: "1 enemy",
        },
        {
        school:'burningCitadel',
        level:1,
        name:'Burning Cleave',
        type:'Strike',
        initiationAction: `standard`,
        longDesc:`Make a melee attack against two targets within reach, these attacks deal an additional 1d6 fire damage and apply 1 stack of immolation. You suffer a -2 penalty to AC for 1 round.
        \n[Overheat-10x]: You can make the attack against an additional target within reach. Increase the fire damage by 1d6 and immolation stacks by 1. Increase the AC penalty by -2.`,
        range: "melee",
        target: "2 enemies",
        },
        {
        school:'burningCitadel',
        level:1,
        name:'Engulfing Flame',
        type:'Strike',
        initiationAction: `standard`,
        longDesc:`Make a melee attack that that deals additional fire damage of 1d4 per stack of immolation on the target (instead of the usual 1). After it deals this damage, the target has half of their immolation stacks removed.
        \n[Overheat-20]: You can choose to make this strike as a swift action boost instead, causing its effect to trigger on your next attack this turn instead.`,
        },
        {
        school:'burningCitadel',
        level:1,
        name:'Up The Heat',
        type:'Boost',
        initiationAction: `swift`,
        longDesc:`This round, double the amount of immolation stacks you give.
        \n[Overheat-10]: Give yourself 5 immolation (is not doubled by this boost).`,
        },
        {
        school:'burningCitadel',
        level:1,
        name:'Smoke Screen',
        type:'Counter',
        initiationAction: `immediate`,
        longDesc:`[poison] You initiate this counter in response to a melee attack being made against you. You gain partial concealment against the attack as a blast of smoke hides you (20% miss chance). After the attack finishes, they must make a fortitude save or become nauseated until the start of their next turn.
        \n[Overheat-1x]: Increase the miss chance by 2%.`,
        },
        {
        school:'burningCitadel',
        level:4,
        name:'Counter Burn',
        type:'Counter',
        initiationAction: `immediate`,
        longDesc:'Make an opposed attack roll against a melee attack made against you as the DC. If you succeed, the attack is negated, and if you threaten them, you can make a melee against them. After initiating this counter, you double the stacks of immolation on yourself and then take 1d6 points of fire damage per odd level.',
        },
        {
        school:'burningCitadel',
        level:2,
        name:'Ignition Strike',
        type:'Strike',
        initiationAction: `standard`,
        longDesc:`Make an attack that deals an additional 2d6 points of fire, and the target must make a reflex check or catch fire, taking 1d6 fire damage at the end of each of its turns and 1 stack of immolation. The DC is increased by +1 for each 4 stacks of immolation on the target.
        \n[Overheat-15x]: The amount of damage it deals per round increases by 1d6.`,
        },
        {
        school:'burningCitadel',
        level:2,
        name:'Burning Conviction',
        type:'Strike',
        initiationAction: `standard`,
        longDesc:`Make an intimidation check against the target of the strike while making the attack. If the attack hits, for each point your intimidation check beats the DC to intimidate them by, the attack deals an additional point of fire damage. For each 5 additional fire damage you deal with this strike it also gives a stack of immolation.
        \n[Overheat-25]: The attack also gains a bonus equal to the amount your intimidation check beats the DC to intimidate them by /5. Suffer immolation equal to the bonus attack this gained.`,
        },
        {
          school:'burningCitadel',
          level:4,
          name:'Burning Oath',
          type:'Strike',
          initiationAction: `standard`,
          longDesc:'Make a melee attack, if it hits, you remove all stacks of immolation from yourself, and the attack deals an additional 1d4 points of fire damage per stack of immolation removed. If the attack misses, you take fire damage equal to your immolation stacks and then double your immolation stacks.',
          range: "melee",
          target: "1 enemy",
        },
        {
          school:'burningCitadel',
          level:2,
          name:'Rekindle',
          type:'Boost',
          initiationAction: `movement`,
          longDesc:`Move up to your movement speed, and then touch an ally (excluding yourself). If you dont move, it provokes as if you did. Remove all stacks of immolation from them, and they heal 1 hit point and gain 1d3 temporary hit points per stack removed for the rest of combat. If this brings them from below 0 hit points to above, they gain a +4 morale bonus to armor class for 2 rounds. If this brings them from below 25% to above 25% hit points, they gain a +2 morale bonus to armor class for 1 round.
          \n[Overheat-5x]: Increase your movement speed by 5 feet, but you take HD/2 untyped damage.`,
          range: "touch",
          target: "1 ally",
          additionalTags:["Heroic"],
        },
        {
          school:'burningCitadel',
          level:4,
          name:'Bonfire',
          type:'Boost',
          initiationAction: `movement`,
          longDesc:`You may remove any number of immolation stacks from allies within 30 feet of you, granting them 1d3 temporary hit points per stack removed that last until the end of combat. If any of these immolation stacks were placed on them by an enemy, you can only remove half of their stacks.
          \n[Overheat-25]: You gain 1 temporary hit point for every stack removed from every ally.`,
          range: "30 feet",
          target: "allies",
          additionalTags:["Heroic"],
        },
        {
        school:'burningCitadel',
        level:2,
        name:'Warm Hearth',
        type:'Strike',
        initiationAction: `standard`,
        longDesc:`Make a melee attack, if successful the attack deals +1d6 points of fire damage you remove all stacks of immolation from your target and you heal 1d3 for each stack removed + initiator level.
        \n[Overheat-20]: This strike can be made as a swift action boost instead, causing its effect to trigger on your next attack this turn instead. If the attack is AoE, it instead heals only half.`,
        },
        {
        school:'burningCitadel',
        level:2,
        name:'Soul Accelerant',
        type:'Boost',
        initiationAction: `movement`,
        longDesc:'Make an intimidate check vs all creatures within 30 feet. Instead of rounds shaken, they instead receive stacks of immolation. This affects all creatures within the range, including allies and yourself. Creatures can only be affected by Soul Accelerant once per 24 hours. At level 10 and 20, the range increases by 15 feet and creatures can be affected by this an additional time per 24 hours. You can make this intimidate check against a creature even if they are immune to fear or being shaken.',
        range: "30 feet",
        targets: "All creatures",
        },
        {
        school:'burningCitadel',
        level:3,
        name:'Burning Tower Stance',
        type:'Stance',
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`,
        longDesc:'Increase your reach by 5 feet when initiating a strike. Once per round when you successfully make a melee attack and deal damage you may make a second attack against an enemy adjacent to them (even if they are not within your reach), this extra attack deals 2d6 points of fire damage. All of your attacks give 2 stacks of immolation. You can make another additional attack this way for each 6 levels you possess. At the end of each of your turns receive 2 stacks of immolation and 1 point of fire damage.',
        },
        {
        school:'burningCitadel',
        level:3,
        name:'Tinder Swipe',
        type:'Strike',
        initiationAction: `standard`,
        duration:"1d6 rounds",
        longDesc:'Make a melee attack against an enemy, if it hits, it deals damage as normal plus 3d6 fire damage, but they must also make a will save or they have their fire resistance reduced by 2 for each stack of immolation on the target for 1d6 rounds. If they have fire immunity, they can now take fire damage, though the maximum amount they can take at once becomes their stacks of immolation for this duration instead.',
        },
        {
          school:'burningCitadel',
          level:3,
          name:'Blazing Crescent',
          type:'Strike',
          initiationAction: `standard`,
          longDesc:`Make a melee attack, treating the attack as if it were a scatter weapon with a range equal to your reach +5 feet. These attacks deal an additional 2d6 fire damage and give 1 immolation. After this attack is made, the weapon you used to initiate it deals an additional 1d6 fire damage on all attacks until the end of your next turn.
          \n[Overheat-25]: If any of the attacks is a critical hit, the critical threat range for all of the other attacks increases by a flat +1. This affects the other attacks retroactively.`,
          duration:"instantaneous and 1 round",
          range: "Melee"
        },
        {
        school:'burningCitadel',
        level:3,
        name:'Wall of Flame',
        type:'Strike',
        initiationAction: `standard`,
        duration:"initiation modifier rounds",
        longDesc:'Choose initiation modifier squares adjacent to each other and within your reach. all targets in those squares take 4d6 fire damage, receive 2 stacks of immolation. The ground stays on fire for 1 round per initiator level, dealing 2d6 fire damage and gives 1 stack of immolation to each target that moves through them. They must also make a reflex save or catch on fire for 1d6 fire damager and 1 stack of immolation per round.',
        },
        {
        school:'burningCitadel',
        level:3,
        name:'Smoke Inhalation',
        type:'Strike',
        initiationAction: `standard`,
        longDesc:`This attack deal an additional 2d6 fire damage, 1 stack of immolation, and they must make a fortitude save or be nauseated for 1 round. The DC increases by 1 for each 4 stacks of immolation on the target.
        \n[Overheat-20]: The nausea lasts 1d4 rounds instead.`,
        },
        {
        school:'burningCitadel',
        level:3,
        name:'Flash Flare',
        type:'Counter',
        initiationAction: `immediate`,
        longDesc:'When a target declares an attack against you in melee, you can expend all stacks of immolation on them to deal 1d3 points of fire damage per stack and reduce their attack by -1 per 2 stacks for the attack, and -1 per 4 stacks to other attacks for the rest of their turn.',
        },
        {
        school:'burningCitadel',
        level:3,
        name:'Burn Down',
        type:'Boost',
        initiationAction: `swift`,
        longDesc:"Your next attack or damaging burning citadel maneuver this turn that would add stacks of immolation instead reduces twice the amount of stacks of and deals an additional 1d8 fire damage for each stack removed. If the maneuver has a duration, it only applies this effect to creature's damaged within 1 round.",
        },
        {
        school:'burningCitadel',
        level:4,
        name:"Dragon's Breath",
        type:'Strike',
        initiationAction: `standard`,
        longDesc:`You breath a 30-foot cone of fire, dealing damage as if you had struck the target with your initiating weapon plus 2d6 and giving 2 immolation stacks. All of this damage is fire damage, and a successful reflex halves all of the damage.
        \n[Overheat-5x]: Increase the DC by +1 and the range by 5 feet. You suffer 1d6 fire damage and 1 immolation.`,
        },
        {
        school:'burningCitadel',
        level:4,
        name:'Witch Burner',
        type:'Strike',
        initiationAction: `standard`,
        longDesc:'<[curse]> Make an attack, if it hits, it deals damage as normal, and if the target has levels in a spellcasting class, they they become cursed for initiation modifier rounds (fortitude reduces the duration to 1 round). While cursed, every time they attempt to cast a spell or they receive 1 point of fire damage per immolation stack they currently have on them, and 1 stack of immolation. This causes them to make a concentration check to cast the spell as normal.',
        additionalTags:["Curse"],
        },
        {
        school:'burningCitadel',
        level:4,
        name:'Burning Rush',
        type:'Strike',
        initiationAction: `full-round`,
        longDesc:`Make a charge attack. After that attack, you can also make a single attack against all enemies adjacent to them. All of the attacks deal 3d6 additional fire damage and give 3 stacks of immolation. During this charge attack, you gain a dodge bonus to your armor class of +1 per 3 stacks of immolation on yourself. You can only make a single attack against the target of the charge with this maneuver, even if you can normally take more.
        \n[Overheat-25]: The attack can be against enemies within your reach instead of just adjacent to the target, but they suffer a -5 penalty.`,
        range:"melee",
        },
        {
        school:'burningCitadel',
        level:4,
        name:'Combustion Overload',
        type:'Strike',
        initiationAction: `standard`,
        longDesc:`Make a melee attack that deals an additional 10d6 fire damage and applies 4 stacks of immolation. After you make this attack, you take 4d6 fire damage and receive 4 immolation.
        \n[Overheat-10x]: Increase the damage and immolation stacks given to the enemy and yourself by 1d6 and 2 respectively.`,
        range:"Melee",
        },
        {
        school:'burningCitadel',
        level:4,
        name:'Reignition',
        type:'Boost',
        initiationAction: `swift`,
        longDesc:'Expend all stacks of immolation on yourself. For every stack expended, your next melee attack this round deals an additional 1d3 fire damage and if it is successful heals you for 1 hit point.',
        },
        {
        school:'burningCitadel',
        level:4,
        name:'Heat Transfer',
        type:'Boost',
        initiationAction: `swift`,
        longDesc:'On your next melee attack this round, if you hit and deal damage to a creature, you can transfer all stacks of immolation you have to a target, or transfer all of theirs to you.',
        },
        {
        school:'burningCitadel',
        level:2,
        name:'Burning Rage Retaliation',
        type:'Counter',
        initiationAction: `immediate`,
        longDesc:'After your target strikes you, retaliate with a strike that deals an additional fire 1d6 points of damage and 1 stack of immolation. For every 5 points of damage they dealt to you, the attack deals an additional 1d6 points of fire damage and gives an additional immolation stack.',
        },
        {
        school:'burningCitadel',
        level:5,
        name:'Sunset Wheel',
        type:'Strike',
        initiationAction: `full-round`,
        longDesc:`Make a single melee attack, applying it to all enemies within your reach. To every enemy it hits, it expends all stacks of immolation on the targets to deal an additional 1d4 points of fire damage per stack to the target. For every 3 stacks expended, you can move 5 feet in a straight line without provoking attacks of opportunity. You cannot attack any of the creatures you attacked with this maneuver until the end of your next turn, however they suffer a penalty on their next attack against you within 1 round equal to the stacks expended from them.`,
        },
        {
          school:'burningCitadel',
          level:5,
          name:'Sunrise Break',
          type:'Strike',
          initiationAction: `full-round`,
          longDesc:'Move 10 feet without provoking attacks of opportunity and make a single melee attack, applying it to all enemies within your reach. To every enemy hit, it deals damage as normal plus 3d6 fire damage, and increases their immolation stacks until they have an equal amount of stacks as your highest level of Burning Citadel maneuver known +1.',
          target:"1 creature",
        },
        {
        school:'burningCitadel',
        level:5,
        name:'Flame Eruption',
        type:'Strike',
        initiationAction: `standard`,
        longDesc:'You strike the ground with your initiating weapon, causing bursts of fire to erupt from the ground in a 45 foot straight line. All creatures along the line take damage as if they were struck by your initiating weapon plus 2d6 and take 2 stacks of immolation. All of the damage from this attack is fire damage. A reflex save halves all of the damage, and if they fail it, they catch fire for 2d6 fire damage and 2 stacks of immolation per turn on fire.',
        },
        {
          school:'burningCitadel',
          level:4,
          name:'Pyrozerking',
          type:'Strike',
          initiationAction: `standard`,
          longDesc:`Make a melee attack against all enemies within reach. It deals damage as normal plus 2d6 fire damage and gives 2 stacks of immolation. For every enemy hit, you gain a +2 morale bonus to damage for 2 rounds. You suffer a -4 penalty to armor class as long as the morale bonus to damage lasts.
          \n[Overheat-10x]: The Morale bonus to damage lasts an additional round.`,
          range:"Melee",
        },
        {
        school:'burningCitadel',
        level:5,
        name:'Butane Strike',
        type:'Strike',
        initiationAction: `standard`,
        longDesc:'Make a melee attack, if it hits, it deals damage as normal plus 4d6 fire damage, doubles their stacks of immolation, and they are sickened for 1d6 rounds. If the target of the attack is currently on fire, the attack gains a +2 bonus to hit and they suffer a -2 penalty on saves against putting out that fire until it is put out.',
        },
        {
        school:'burningCitadel',
        level:5,
        name:'To the Flame',
        type:'Boost',
        initiationAction: `swift`,
        longDesc:'Remove half of the immolation stacks on a creature (rounded down). The next attack you take against them this turn gains a bonus on the attack roll equal to the stacks removed. If the attack hits, you gain those immolation stacks removed, and then take damage equal to the stacks gained.',
        range:"30 feet"
      },
        {
          school:'burningCitadel',
          level:5,
          name:'Conflagration',
          type:'Boost',
          initiationAction: `swift`,
          longDesc:`Your next melee attack this turn can have one of two effects depending on the type of attack:           \nSingle Target: The attack gives additional immolation stacks equal to half of your stacks.          \nMultiple Targets: All targets of the attack have their stacks increased by half of the stacks of the target with the most stacks, except the target of the attack, which has their stacks halved.
          \nIf the attack has any saves to reduce stacks, that save applies to these bonus stacks.`,
        },
        {
        school:'burningCitadel',
        level:5,
        name:'Controlled Burn',
        type:'Stance',
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`,
        longDesc:'When you use a maneuver that target an area or multiple creatures, you can select half your initiation modifier squares or creatures to not be affected. All melee attacks add your initiation modifier as fire damage and 3 stacks of immolation, and strikes that hit multiple targets at once deal an additional 2d6 fire damage',
        },
        {
        school:'burningCitadel',
        level:5,
        name:'Roaring Flame',
        type:'Counter',
        initiationAction: `immediate`,
        longDesc:'When an attack is declared against you, you can make an opposed attack roll with a melee weapon against it, if successful negate their attack and make a free intimidation check against them, instead of rounds of shaken, they receive 1 stack of immolation. They then suffer a penalty to all further attacks this round equal to their immolation stacks. If during your next turn, you apply any immolation stacks to them, they are doubled, up to a total maximum of bonus immolation stacks equal to the amount of immolation stacks this counter applied to them.',
        },
        {
          school:'burningCitadel',
          level:7,
          name:'Sacred Fire',
          type:'Counter',
          initiationAction: `immediate`,
          longDesc:'When an attack is declared against you, you can absorb as many immolation stacks as you want from any creatures within 30 feet. For every stack you absorb, you gain them as normal, but you also gain a +1 deflection bonus to your armor class against the attack. The deflection bonus is then halved, but remains until the start of your next turn.',
          },
        {
        school:'burningCitadel',
        level:6,
        name:'Barbeque Strike',
        type:'Strike',
        initiationAction: `standard`,
        longDesc:'Make a melee attack, if successsful, it deals damage as normal and they must make reflex save (DC 16 + init mod) or catch on fire, taking 1d3 points of fire damage per stack of immolation they have each round. Each time they take this damage, their immolation stacks are reduced by 2. If their immolation stacks are reduced to 0, this fire is immediately put out.',
        },
        {
        school:'burningCitadel',
        level:6,
        name:'Blazing Tornado Spiral',
        type:'Strike',
        initiationAction: `standard`,
        longDesc:`You swing your blade around you, unleashing a circle of flame with a radius equal to your reach plus 10 feet. This deals your initiating weapon's damage plus 4d6 fire damage and gives 4 stacks of immolation (reflex halves). If a creature fails its save it also has its fire resistance reduced by 3 per stack of immolation they have for 1d6 rounds.`,
        },
        {
          school:'burningCitadel',
          level:6,
          name:'Phoenix Dawn',
          type:'Strike',
          initiationAction: `full-round`,
          longDesc:'You swing your sword and unleash a a 15 foot wide burning phoenix that travels in a straight line for 45 feet. Each creature it comes in contact with takes 4d6 fire damage and 2 stacks of immolation and it makes a CMB check against them to bullrush them at your bonus with a -5 penalty. If successful, it moves them 5 feet directly in front of the phoenix, they take another 4d6 fire damage and 1 stack of immolation, and if the phoenix travels into them again, they are once again subject to the bull rush, however with a stacking -2 penalty for each time it has been affected by this from this usage. You can continue doing this against each creature until the bull rush fails against them or the maximum distance is reached.',
        },
        {
        school:'burningCitadel',
        level:6,
        name:'Fires of Revenge',
        type:'Strike',
        initiationAction: `standard`,
        longDesc:'You make an attack that is fueled by a hot rage, for each 15% of your health missing (rounded down) this attack deals an additional 4d6 fire damage, 1 stack of immolation, and you gain +1 to attack. If the attack misses, you instead take the fire damage and immolation stacks, but the next time this combat you use this strike, it deals an additional 1d6 points of fire damage per 10% of health missing.',
        },
        {
        school:'burningCitadel',
        level:6,
        name:'Heat Sync',
        type:'Boost',
        initiationAction: `swift`,
        longDesc:'You can remove any number of stacks of immolation from any enemies within 30 feet of you. For every stack removed, they have their fire resistance reduced by 2 for initiation modifier rounds and you heal for 1d4 hit points, and gain cold resistance 2 for 1 round.',
        range: "30 feet"
        },
        {
        school:'burningCitadel',
        level:6,
        name:'Smoke Stack',
        type:'Stance',
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`,
        longDesc:'You surround yourself with a billowing plume of smoke making it difficult for any creature to properly see you to attack you. Although they always know your space, you gain total concealment unless the attacker has the ability to see through magical smoke, such as the smokesight, blindsight or tremorsense.',
        },
        {
        school:'burningCitadel',
        level:7,
        name:'Flame Vortex',
        type:'Strike',
        initiationAction: `standard`,
        longDesc:`You make a melee attack against a target and attempt to surrounded them in a flaming vortex for 2d4 rounds (reflex negates). A creature trapped in the flaming vortex takes 6d6 fire damage and 2 stacks of immolation immediately. Then, At the start of each of your turns the vortex deals this damage again to any creature within its area. The vortex's initial area is a radius equal to the area of the creature plus 5 feet, but at the end of each of your turns after it deals damage, its radius grows 5 feet. A creature stuck in the tornado is unable to move from their current space, and any attacks in, out, or through the vortex take a -5 penalty. As as standard action as a part of a movement the creature can attempt to escape it with a reflex saving, though they take a -1 penalty for each round the tornado has been active. If the initial attack misses or the creature avoids or escapes it with a reflex save, the vortext remains in the space for the rest of its duration.`,
        },
        {
        school:'burningCitadel',
        level:4,
        name:'One Of Us Will Burn',
        type:'Boost',
        initiationAction: `swift`,
        longDesc:'You direct your burning rage against a creature within 60 feet of you, causing both of you to instantly catch on fire. At the start of each of your turns, that creature takes 1d6 fire damage and 1 immolation stack. Each time the damage is dealt, it increases by 1d6. This also increases damage for the other creature as well. This fire cannot be put out by normal methods except full submersion in water, and putting it out for one of you, puts it out for the other as well. This lasts until one of you is reduced below 25% hit points, in which case that creature immediately takes the fire damage they would have taken that round and this ends. This cannot trigger on the enemy creature the round it is initiated.',
        range:"60 feet",
        },
        {
        school:'burningCitadel',
        level:7,
        name:"Maximum Inferno Blast Annihilation",
        type:'Strike',
        initiationAction: `standard`,
        longDesc:'Make a devastating attack that roars with the rage of the power that fuels the sun, the attack deals an additional 20d6 fire damage and gives 10 stacks of immolation. After the attack you take 8d6 fire damage and 8 stacks of immolation.',
        },
        {
        school:'burningCitadel',
        level:7,
        name:'Explosive Fire Spin',
        type:'Strike',
        initiationAction: `full-round`,
        longDesc:`Make an attack and apply it against all enemies within reach. Against creatures it is successful against, it deals damage as normal plus 8d6 fire damage and 4 immolation stacks, and allows you to make a bull rush attempt against them as a free action with a bonus equal to the amount of immolation stacks on them (doesn't provoke, you cannot move with this bull rush). Any creature you sucessfully move 15 or more feet must make a reflex save or be kocked prone (DC +4 for every 5 feet after 15 they are moved). This bull rush attempt also ignores any normal size limitations of bull rush, however for every size larger than you that they are, you suffer a -2 penalty on the bull rush attempt.`,
        },
        {
        school:'burningCitadel',
        level:7,
        name: 'Suffocating Heat',
        type:'Boost',
        initiationAction: `swift`,
        longDesc:'[poison] This round whenever you deal fire damage, the creature must make a fortitude save or be nauseated for one round and receive 2 immolation stacks. If the fire damage is dealt to you, you gain a +4 bonus to the roll. Creature that succeed the save still take 1 stack of immolation.',
        },
        {
        school:'burningCitadel',
        level:8,
        name:'Heart Ablaze',
        type:'Boost',
        initiationAction: `swift`,
        longDesc:`<heroic> Expend all stacks of immolation on yourself and all allies within 50 feet. For each stack expended from yourself, you and all allies heal 1d4 hit points. For each stack expended from them, they heal an additional 1d6 hit points. Additionally, affected allies (excluding you) also gain initiation modifier blazing heart stacks. They can expend a blazing heart stack to give themselves one of 4 benefits. Each is a +1 bonus, and multiple can be expended at once.
        \n1: A morale bonus to an attack roll or as bonus fire damage to an attack (must be declared before the attack is rolled)        \n2: A morale bonus to a saving throw (must be declared before the save is made)        \n3: To heal hit points. You must be able to take mental actions to do this, and able to gain morale bonuses.`,
        additionalTags:["Heroic"]
        },
        {
        school:'burningCitadel',
        level:8,
        name:'Pyroclasm',
        type:'Boost',
        initiationAction: `movement`,
        longDesc:'Make an intimidation check. All creatures within feet equal to the check suffer fire damage equal to the result of the check, and then have their immolation stacks doubled. For every stack added, the creature has its fire resistance reduced by 2. Creatures can make a will save to reduce the damage and immolation stacks added by half. A target can only be affected by this once per 24 hours. This reduction to their fire resistance lasts for initiation modifier rounds.',
        range:"intimidation check",
        duration:"initiation modifier rounds",
        },
        {
          school:'burningCitadel',
          level:8,
          name:'Super Heat Death',
          type:'Boost',
          initiationAction: `movement`,
          longDesc:'Expend all stacks of immolation on a creature and then make a melee touch attack against them with a -10 penalty, if it hits, the creature suffers fire damage equal to the stacks removed. The damage then occurs again, until it has been dealt an amount of times equal to your initiation modifier. The creature can make a fortitude save to reduce this damage by half (one roll to reduce all ticks of damage).',
          range:"touch"
        },
        {
        school:'burningCitadel',
        level:8,
        name:'God of Flame Infinite Judgement',
        type:'Strike',
        initiationAction: `full-round`,
        longDesc:`Make a melee attack, if it hits, it deals damage as normal and the creature catches on fire, taking the damage of this attack at the start of each of their turns as fire damage, and then increasing their immolation stacks by 5. Reroll the damage roll every time they take damage from this, not including any bonus damage gained from precision damage or critical hits. This fire cannot be put out the normal method, instead it can only be put out by taking a full-round action to make a will save against the DC for catching fire.`,
        },
        {
          school:'burningCitadel',
          level:8,
          name:'Cruel Sun',
          type:'Strike',
          initiationAction: `full-round`,
          longDesc:`Expend all immolation stacks on a creature and then make a melee attack against them. For every stack expended, the attack deals an additional 2d6 fire damage, and for every 5 immolation stack expended, the attack gains a +1 bonus to the attack roll. The total damage of the attack is increased by a percentage equal to 2x your immolation stacks. If the attack hits, reduce your immolation stacks by half. If the attack misses, increase your immolation stacks by your initiation modifier and then take fire damage equal to your immolation stacks.`,
        },
        {
          school:'burningCitadel',
          level:8,
          name:'Become Nuclear',
          type:'Strike',
          initiationAction: `see text;`,
          longDesc:`You unleash a massive blast of extreme heat and force in a large radius. Make an intimidation check, this strike deals 20d6 + the result of the check in a radius equal to 2x the check result in feet (rounded down to the nearest 5 foot increment) and applies 5+init mod stacks of immolation to all creatures in the radius (the immolation stacks are applied to you as well). Half of this damage is fire damage, and the other half is untyped damage. Afterwards, all creatures that were damaged by the ability are bull rushed directly away from you using the result of the intimidate check as the CMB (This ignores usual size limitations to bull rushing). Creatures can make a reflex save to reduce the damage by half and negates the bull rush. You can choose to also be subject to this bullrush, allowing you to bull rush yourself any direction you would like. Each creature within the blast radius must also make a fortitude save or be stunned for 1d4 rounds.
          \nInitiating this maneuver is usually a full-round action, but you can also initiate it at a movement action, but you must accept the bull rush, and the damage and immolations stacks are reduced to 1/4 of the normal amount.`,
        },
        {
        school:'burningCitadel',
        level:8,
        name:'Phoenix Soul',
        type:'Stance',
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`,
        longDesc:'While this stance is active, you gain a flight speed of 60ft (perfect) as giant flaming wings sprout from your back, vulnerability to cold, immunity to fire (except from your own burning citadel maneuvers as normal), and you no longer take additional damage from immolation stacks. At the end of each of your turns, you gain 2 immolation stacks, and every time you are healed, you gain 1 immolation stack (you can only receive 1 immolation stack per individual healing effect per round). If you die while in this stance, your body bursts into flame, removing all of your stacks of immolation and dealing 1d6 points of fire damage for every stack removed to all creatures within a radius of your choice, to a maximum of your reach (reflex halves the damage). At the end of your next turn you heal 1d6 hit points for every stack that was removed. If this healing is enough to return you to life, you are. If you are returned to life, it also removes all ability score damage, removes all curses, poisons, diseases, stuns, dazes, and petrification. Once this resurrection triggers, you cannot be resurrected this way again until the next combat.',
        },
        {
          school:'burningCitadel',
          level:4,
          name:'Brutal Cauterization',
          type:'Strike',
          initiationAction: `Standard`,
          range: `melee`,
          target: `1 creature`,
          duration: `initiation modifier rounds`,
          longDesc:'Make a melee attack, if successful, it deals damage as normal plus 3d6 fire damage, but also attempts to cauterize their wounds. The target makes a fortitude save with a penalty of -1 per 5 stacks removed. If they fail, all hit point damage they currently have becomes cauterized hit point damage. Cauterized damage cannot be healed by fast healing, regeneration, or other forms of natural healing, and all magical healing is 33% as effective at healing it. This ends all bleed effects on them. Cauterized hit point damage lasts initiation modifier rounds, but can be removed by effects like restoration and greater restoration.',
        },
        {
          school:'burningCitadel',
          level:8,
          name:'Scorched Earth Policy',
          type:'Stance',
          initiationAction: `swift`,
          range: `Personal`,
          target: `You`,
          duration: `Stance`,
          longDesc:'While this stance is active, all creatures within 30 feet of you take 1d2 points of fire damage per immolation stack they currently have on them at the start of each of their turns. If a creature is killed within 30 feet of you, all other creatures within 30 feet of you (including you) immediately take 4 immolation stacks.',
          gameDesc:'While this stance is active, all creatures within 30 feet of you take 1d2 points of fire damage per immolation stack they currently have on them at the start of each of their turns. If a creature is killed within 30 feet of you, all other creatures within 30 feet of you (including you) immediately take 4 immolation stacks. All healing within 30 feet of you is reduced by 50%, except healing from Burning Citadel maneuvers.',
        },
        {
        school:'burningCitadel',
        level:9,
        name:'Earth Fall',
        type:'Strike',
        initiationAction: `full-round`,
        longDesc:`As a full-round action you bring your weapon down in an apocalyptic strike with the force of a primordial, however it is also slow and easy to dodge. Make a melee attack against a target with a -15 penalty, if it hits, it bypasses hardness and damage reduction, and it deals 4x damage plus an additional 20d6 fire damage, 20d6 bludgeoning damage, and 10 stacks of immolation. Then, whether the attack was successful or not, each target within 20 feet radius burst of the target takes 20d6 fire damage and 5 stacks of immolation (reflex half). If your attack was successful, the target of the strike is knocked prone and stunned for 1 round, and all creatures within 20 feet of the targeted square for this attack (except the target) takes 20d6 fire damage (reflex halves). If the creature was in the air when this maneuver is made against them, instead of knocking them prone, they are launched directly towards the ground a number of feet equal to 1/2 the damage taken. Afterwards, the whole area is caught ablaze for 2d4 rounds. Any creature that enters or ends their turn in the area must succeed a reflex save or take 6d6 fire damage and 2 stacks of immolation.
        \nAfter initiating this maneuver, you are staggered until the end of your next turn, or nauseated if you are already staggered (unresistable and unremovable)
        \nThis attack cannot be countered by maneuvers or abilities that use opposing attack rolls, or any ability that it implies it is physically blocking the attack.`,
        },
        {
        school:'burningCitadel',
        level:9,
        name:'Burning Citadel',
        type:'Stance',
        initiationAction: `swift`,
        range: `Personal`,
        target: `You`,
        duration: `Stance`,
        longDesc:'You become the embodiment of both flame and war. Gain an armor bonus equal to 1/2 the stacks of immolation on yourself. Every melee attack you make deals bonus fire damage equal to the stacks of immolation on yourself, this bonus damage bypasses fire resistance. Once per round as free action you can take 5d6 fire damage to double the stacks of immolation on yourself. At the end of each of your turns you had this stance active, you take 10d6 fire damage.',
        },
        {
          school:'enlightenedPath',
          level:0,
          subSchool:'basic',
          name:'Mountain Stance',
          type:'Stance',
          initiationAction: `swift`,
          range: `Personal`,
          target: `You`,
          duration: `Stance`,
          longDesc:`Gain a +2 bonus to your constitution, reduce your dexterity by -2, +2 natural armor, 5% fortification, DR 1/-. Every time you take damage from an attack you gain 1 spell point. Reduce your movement speed by 5 feet.
          \nAt level 4: \n     Changed: +4 bonus to natural armor, 10% fortification, DR 2/-. 
          \nAt level 8: \n     Changed: +3 constitution, -3 dexterity, +6 natural armor, 15% fortification, DR 3/-. Spell point gain when hit +2. Reduce movement speed by 10 feet.
          \nAt level 12: \n     Changed: +4 constitution, +8 natural armor, 25% fortification, DR 5/-. \n     Additional: When a creature rolls a potential critical hit against you (whether successful or not), you restore 6 spell points.
          \nAt level 16: \n     Changed: +6 constitution, -4 dexterity, +10 natural armor, 30% fortification, DR 8/-. Spell point gain when hit +3. Reduce movement speed by 15 feet. Spell point gain on critical against you becomes 8.
          \nAt level 20: \n     Changed: +8 constitution, -5 dexterity, +12 natural armor, 40% fortification, DR 10/- Spell point gain when hit +4. Reduce movement speed by 20 feet. Spell point gain on critical against you becomes 10.
          \n\nThe bonuses to fortification and damage reduction stack with all others.`,
          additionalTags:['Earth']
        },
        {
          school:'enlightenedPath',
          level:0,
          subSchool:'basic',
          name:'Ocean Stance',
          type:'Stance',
          initiationAction: `swift`,
          range: `Personal`,
          target: `You`,
          duration: `Stance`,
          longDesc:`Gain a +2 bonus to your highest mental stat, reduce your strength by -2, +2 dodge bonus to armor class, and a +1 bonus on all saves, and gain your level as a bonus on acrobatics checks to move through threatened space or through an enemy creature. The dodge bonus is reduced by half if you are wearing armor or using a shield.
          \nAt level 4: \n     Changed: +3 dodge bonus to armor class, +3 bonus to all saves. \n     Additional: When a creature misses you with an attack of opportunity or you successfully use acrobatics to avoid an attack of opportunity, the creature is flat-footed to your next attack within 1 round against it.
          \nAt level 8: \n     Changed: +3 highest mental, -3 strength +4 dodge bonus to armor class, +3 to all saves\n     Additional: When a creature misses you with an attack, you can move 5 feet. You can use acrobatics to avoid attacks of opportunity for this movement.
          \nAt level 12: \n     Changed: +4 highest mental, -4 strength, +6 dodge bonus to armor class, +4 all saves. When you move 5 feet because of ocean stance, you can move an additional 5 feet. \n     Additional: When any other maneuver you initiate allows you to move, you increase the movement by 10 feet.
          \nAt Level 16: \n     Changed: +6 highest mental, -8 strength, +8 dodge bonus to armor class, +5 all saves.
          \nAt level 20: \n     Changed: +8 highest mental, -8 strength, +10 dodge bonus to armor class, +6 all saves. Additional movement when initiating other maneuvers increases to 15 feet. \n     Additional: When a creature misses you with an attack of opportunity or you successfully use acrobatics to avoid an attack of opportunity, the creature is considered flat-footed for all of your attacks against it for the rest of your turn.`,
          additionalTags:['Water']
        },
        {
          school:'enlightenedPath',
          level:0,
          subSchool:'basic',
          name:'Sun Stance',
          type:'Stance',
          initiationAction: `swift`,
          range: `Personal`,
          target: `You`,
          duration: `Stance`,
          longDesc:`Gain a +2 bonus to strength, reduce your highest mental stat by -2. Every time you hit and deal damage with a melee unarmed attack, you gain 1 spell point. On a successful critical hit, you gain 2 spell points.
          \nAt level 4: \n     Changed: Spell points gained on a critical hit becomes 3. \n     Additional: The critical threat range of all weapons you use increases by a flat +1. 
          \nAt level 8: \n     Changed: +3 strength, -3 highest mental. Spell points gained on hit becomes 2. Spell points gained on a critical hit becomes 4. \n     Additional: The critical multiplier of all weapons you use increases by 1 if the natural result of the roll was a 20.
          \nAt level 12: \n     Changed: +4 strength. Spell points gained on a critical hit becomes 6. The critical threat range of all weapons you use increases by a flat +2.
          \nAt level 16: \n     Changed: +6 strength, -4 highest mental. Spell points gained on a critical hit becomes 8. \n     Additional: The critical damage multiplier of all of your weapons increases by +1. Spell points gained on hit becomes 3. 
          \nAt level 20: \n     Changed: +8 strength, -5 highest mental. Spell points gained on a critical hit becomes 10. The critical multiplier of all weapons you use increases by 1 if the natural result of the roll was a 19-20, and by 1 if the confirmation of a critical hit is within your critical threat range again.`,
          additionalTags:['Fire']
        },
        {
          school:'enlightenedPath',
          level:0,
          subSchool:'basic',
          name:'Wind Stance',
          type:'Stance',
          initiationAction: `swift`,
          range: `Personal`,
          target: `You`,
          duration: `Stance`,
          longDesc:`Gain a +2 bonus to dexterity, reduce your constitution by -2, gain +3 bonus on reflex saves. When making a full-round attack with unarmed strikes you may make an additional unarmed attack at your highest bonus, though it only deals half its normal damage. When you do this, all attacks you make in that round take a -2 penalty. Gain a 10-foot bonus to your movement speed.
          \nAt level 4: \n     Changed: Gain a 15-foot bonus to your movement speed. \n     Additional: You gain the benefits of evasion, or improved evasion if you already have evasion. 
          \nAt level 8: \n     Changed: +3 dexterity, -3 constitution, +4 bonus on reflex saves. Gain a 20-foot bonus to your movement speed. \n     Additional: When making a full-round attack with unarmed strikes, you may make another additional unarmed attack, though this one with a -5 penalty and it deals only half its normal damage.
          \nAt level 12: \n     Changed: +4 dexterity. +6 bonus on reflex saves. Gain a 25-foot bonus to your movement speed. \n     Additional: When making a full-round attack with unarmed strikes, you may make a third additional unarmed attack, though this one with a -10 penalty and it deals only half its normal damage.
          \nAt level 16: \n     Changed: +6 dexterity, -4 constitution, +8 bonus on reflex saves. Gain a 30-foot bonus to your movement speed. \n     Additional: When making a full-round attack with unarmed strikes, you may make a fourth additional unarmed attack, though this one with a -15 penalty and and it deals only half its normal damage.
          \nAt level 20: \n     Changed: +8 dexterity, -5 constitution, +10 bonus on reflex saves. Gain a 40-foot bonus to your movement speed. \n     Additional: When making a full-round attack with unarmed strikes, you can make an additional unarmed attack at your highest attack bonus, though all attacks you make this round take an additional -2 penalty.`,
          additionalTags:['Air']
        },
        {
          school: `enlightenedPath`,
          level: 1,
          subSchool:'basic',
          name: `Strike of the Enduring`,
          type: `Strike`,
          longDesc: `<earth> Make an unarmed attack, increase its damage by 2 dice steps.`,
          initiationAction: `swift`,
          spCost:2,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Earth"],
        },
        {
          school: `enlightenedPath`,
          level: 1,
          subSchool:'basic',
          name: `Storm Strike`,
          type: `Strike`,
          longDesc: `<air> Make an unarmed attack, it deals an additional 2d6 points of electricity damage.`,
          initiationAction: `swift`,
          spCost:2,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Air"],
        },
        {
          school: `enlightenedPath`,
          level: 1,
          name: `Storm Flurry`,
          type: `Strike`,
          longDesc: `<air> Make a full-round attack with unarmed strikes at a -2 penalty. You may make an additional unarmed attack. It deals damage as if it was an off-hand attack.`,
          initiationAction: `full-round`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Air"]
        },
        {
          school: `enlightenedPath`,
          level: 1,
          name: `Fanning the Flames`,
          type: `Strike`,
          longDesc: `<fire> Make a full-round attack with unarmed strikes. Each attack deal an additional 1 point of fire damage and gives 1 stack of immolation. If you score a critical hit against the creature, instead all enemies within reach get a stack of immolation multiplied by your critical damage multiplier. `,
          initiationAction: `full-round`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Fire"]
        },
        {
          school: `enlightenedPath`,
          level: 1,
          name: `The Wall of Heaven`,
          type: `Strike`,
          longDesc: `<earth> Make a full-round attack with unarmed strikes. Until the start of your next turn you gain a +4 cover bonus to your armor class and a +2 cover bonus to your reflex saves.`,
          initiationAction: `full-round`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Earth"]
        },
        {
          school: `enlightenedPath`,
          level: 3,
          name: `Fists of Fire`,
          type: `Strike`,
          longDesc: `<fire> Make a full attack with unarmed strikes. All unarmed attacks this round, including the ones made as a part of this strik deal additional fire damage equal to ability score modifier you use to determine your damage.`,
          initiationAction: `full-round`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Fire"]
        },
        {
          school: `enlightenedPath`,
          level: 1,
          subSchool:'basic',
          name: `Ocean Weave`,
          type: `Strike`,
          longDesc: `<water> Make a full attack with unarmed strikes. After making an attack this round you may move 5 feet. This movement provoke as normal, but you gain a +4 dodge bonus to your armor class against attacks of opportunity made against you for this movement, and if the attack misses, you gain a +1 dodge bonus to armor class until the start of your next turn. You cannot move further than your movement speed in the round. If you move out of a creatures threatened area this round and later move back into it during the same round, any attack against them after that gains a +2 bonus.`,
          initiationAction: `full-round`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Water"]
        },
        {
          school: `enlightenedPath`,
          level: 1,
          subSchool:'basic',
          name: `Fires of Purity`,
          type: `Strike`,
          longDesc: `<fire> Make an unarmed attack, it deals an additional 2d6 points of fire damage.`,
          spCost:2,
          initiationAction: `swift`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Fire"]
        },
        {
          school: `enlightenedPath`,
          level: 1,
          subSchool:'basic',
          name: `Flowing Water Strike`,
          type: `Strike`,
          longDesc: `<water> Make an unarmed attack, it deals an additional 2d6 points of cold damage.`,
          initiationAction: `swift`,
          spCost:2,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Water"]
        },
        {
          school: `enlightenedPath`,
          subSchool:`basic`,
          level: 2,
          name: `Fist of Light`,
          type: `Strike`,
          longDesc: `<light><[curse]> Make an unarmed attack, it deals an additional 1d8 untyped damage, increasing by 1d8 every 4 levels, this bonus damage is increased by 50% against aberrations and undead. If the attack is successful, the target is wrapped in a healing shield for 3 rounds. For those 3 rounds, every time a creature successfully strikes them with a melee attack they heal 1d2 hit points, increased by 1d2 every 6 levels. On a natural 20 the untyped damage is multiplied by the critical damage multiplier. All healing done towards a creature per round is totalled as one source of healing before being modified.`,
          initiationAction: `swift`,
          spCost:4,
          range: `Melee attack`,
          target: `One creature`,
          duration: `3 rounds`,
          additionalTags:["Light", "Curse"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`light`],
          level: 3,
          name: `Burst of Light`,
          type: `Counter`,
          longDesc: `<light> When an creature within 30 feet is being healed or harmed by positive energy, you can initiate this counter to increase the healing gained by 33%. If the creature is being harmed by that positive energy, it receives a will save to decrease the additional damage to 20%.`,
          initiationAction: `immediate`,
          range: `30 feet`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Light"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`dark`],
          level: 3,
          name: `Call of Oblivion`,
          type: `Counter`,
          longDesc: `<dark> When an creature within 30 feet is being damaged, you can initiate this counter to increase the damage taken by 25%. It receives a will save to decrease the additional damage to 10%. You can initiate this counter even in response to a natural 20.`,
          initiationAction: `immediate`,
          range: `30 feet`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Dark"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`void`],
          level: 3,
          name: `The Emptiness`,
          type: `Counter`,
          longDesc: `<void> You can initiate this counter in response to a critical hit being confirmed against you, even if the roll is a natural 20. The critical hit automatically misses you.`,
          initiationAction: `immediate`,
          range: `personal`,
          target: `you`,
          duration: `instantaneous`,
          additionalTags:["Void"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`light`],
          level: 5,
          name: `Protector's Interception`,
          type: `Counter`,
          longDesc: `<light> This counter is a free action that you can take even when not your turn. When an ally that you can see takes damage, you can intercept the damage, taking it in their place. You take all damage and effects of the attack, though the ally is still the creature that is considered hit by the attack. Once you use this counter, you cannot use it on that ally for the rest of the combat.`,
          initiationAction: `free`,
          range: `sight`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Light"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`light`],
          level: 3,
          name: `Kukan-Do`,
          type: `Boost`,
          longDesc: `<light> You lock gazes with an enemy, stunning them for 1 round on a failed Will save. Sightless creatures are unaffected by this ability.`,
          initiationAction: `swift`,
          range: `sight`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Light"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`light`],
          level: 3,
          name: `Protector's Shout`,
          type: `Boost`,
          longDesc: `<light> You shout at a creature, trying to draw its attention and attack you. It must make a will save (dc=10 + level + initiation modifier) or on its next turn, if it makes any attacks or uses an offensive ability you must be included in it.`,
          initiationAction: `swift`,
          range: `sight`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Light"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`dark`,"void"],
          level: 3,
          name: `Shadow Veil`,
          type: `Boost`,
          longDesc: `<void> or <dark>. You become invisible, incorporeal, and your movement speed doubles for 1 round.`,
          initiationAction: `swift`,
          range: `personal`,
          target: `you`,
          duration: `1 round`,
          additionalTags:["Dark","Void"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`dark`],
          level: 5,
          name: `Shield of Hatred`,
          type: `Boost`,
          longDesc: `<dark> For 1 round, every time a creature damages you, they take an equal amount of damage. The first time they damage you in the round, they can make a fortitude save to reduce this damage to 50% of the damage they deal to you.`,
          initiationAction: `swift`,
          range: `personal`,
          target: `you`,
          duration: `1 round`,
          additionalTags:["Dark"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`dark`],
          level: 3,
          name: `Dark Burst`,
          type: `Strike`,
          longDesc: `<dark> You focus your mind and unleash a burst of shadow energy. Each creature in the area takes damage as if you had struck them with an unarmed attack, however all damage is converted to negative energy. A reflex save halves this. If they took any damage from it, they must make a fortitude save or they are dazed for 1 round.`,
          initiationAction: `standard`,
          range: `30 feet. Area: 20-ft.-radius burst`,
          duration: `instantaneous and 1 round`,
          additionalTags:["Dark"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`dark`],
          level: 9,
          name: `Touch of Death`,
          type: `Strike`,
          longDesc: `<dark> You make an unarmed attack attack with a -10 penalty. If successful, it deals twice the normal damage and deals an additional 200 points of negative energy damage. A will save reduces the negative energy damage by half.`,
          initiationAction: `movement`,
          range: `melee attack`,
          duration: `instantaneous`,
          additionalTags:["Dark"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`void`],
          level: 3,
          name: `Perfect Clarity of Purpose`,
          type: `Boost`,
          longDesc: `<Void> You remove your last combo point.`,
          initiationAction: `free`,
          range: `personal`,
          duration: `instantaneous`,
          targets:"you",
          additionalTags:["Void"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`light`],
          level: 8,
          name: `Mandate of Heaven`,
          type: `Boost`,
          longDesc: `<light> You heal a creature 150 hit points. Any bonuses that effect your healing Ki finisher also affects this.`,
          initiationAction: `movement`,
          range: `30 feet`,
          targets:"allies",
          duration: `instantaneous`,
          additionalTags:["Light"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`dark`,`void`],
          level: 9,
          name: `Enlightenment of the Black Sun`,
          type: `Stance`,
          longDesc: `This counts as a <fire> and <dark> stance. Your attacks are devastating against those you despise and consider unfit to live. This stance only deals its effects to creature that have an opposing good/evil alignment, or if you are neutral, any creature with an opposing chaotic/lawful alignment. If you are true neutral, this stance applies against creatures of all alignments except true neutral. 
          \n\nAll unarmed attacks against such creatures deals additional untyped damage equal to 2x your initiation modifier. If the attack is a natural 20, the bonus untyped damage for that attack is doubled.
          \nWhenever you score a critical hit with an unarmed attack, all enemies of the opposing alignments that you can see, except the target of the critical hit take untyped damage equal to 6 times your initiation modifier and you can choose to gain 1 stack of either <dark> or <fire> for your combo.`,
          initiationAction: `swift`,
          range: `personal`,
          target: `self`,
          duration: `Stance`,
          additionalTags:["Dark", "Fire"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`light`,`void`],
          level: 8,
          name: `Bastion of Light`,
          type: `Stance`,
          longDesc: `This counts as an <earth> stance. Whenever a critical hit is scored against you, all allies except you heal hit points equal to your highest mental modifier multiplied by 5, and you can choose to add a <light> or <earth> stack to your finisher progression.`,
          initiationAction: `swift`,
          range: `personal`,
          target: `self`,
          duration: `Stance`,
          additionalTags:['Light','Void']
        },
        {
          school: `enlightenedPath`,
          subSchool:[`light`],
          level: 9,
          name: `Sustainer of the Heavenly Principles`,
          type: `Stance`,
          longDesc: `This counts as an <earth>, <air>, <fire>, and <water> stance. Whenever an enemy within 60 feet rolls a natural 20, it must roll again taking the lower result. Whenever an ally is rolling to confirm a critical hit, or rolls a natural 1, it rolls again, taking the higher result. If the enemy is undead or an aberration, it instead rolls 3 times taking the lowest result. Whenever an enemy rolls a natural 20 on an attack roll (even if you cause it to be reroll and therefor negate it) you can automatically teleport to a square adjacent to the target of the critical hit, transfer any damage from the attack to yourself, and if the enemy is within your reach, you can make a single unarmed attack against it, and gain 1 stack of <light> towards your finisher progression. This ability only ever causes a single reroll per roll (so if a creature rerolls into another natural 20, it can take that result).`,
          initiationAction: `swift`,
          range: `personal`,
          target: `self`,
          duration: `Stance`,
          additionalTags:['Earth','Air','Fire','Water']
        },
        {
          school: `enlightenedPath`,
          subSchool:[`light`,`dark`],
          level: 9,
          name: `Walker of the Sun and Moon`,
          type: `Stance`,
          longDesc: `This counts as a <water>, <light>, and <dark> stance. Every time you confirm a critical hit with an unarmed attack, the creature suffers 1d4 negative levels and all allies within 30 feet of you heal 100 hit points.`,
          initiationAction: `swift`,
          range: `personal`,
          target: `self`,
          duration: `Stance`,
          additionalTags:['Light','Dark','Water']
        },
        {
          school: `enlightenedPath`,
          subSchool:[`void`],
          level: 9,
          name: `The Honored One`,
          type: `Stance`,
          longDesc: `This counts as a <air> stance. Your armor class is reduced by 10. All attacks against you suffer an 85% miss chance. This doesn't stack with other miss chances, even those that normally do stack. This miss chance cannot be bypassed, except by great old ones who automatically ignore it.`,
          initiationAction: `swift`,
          range: `personal`,
          target: `self`,
          duration: `Stance`,
          additionalTags:['Air','Void']
        },
        {
          school: `enlightenedPath`,
          subSchool:[`void`],
          level: 8,
          name: `The Eye That Sees Beyond`,
          type: `Stance`,
          longDesc: `This is a void stance. You gain blindsight and x-ray vision 60 feet. Reduce your spell point costs by 33%. This cannot reduce the spell point cost of any abilities below 1.`,
          initiationAction: `swift`,
          range: `personal`,
          target: `you`,
          duration: `stance`,
          additionalTags:['Void']
        },
        {
          school: `enlightenedPath`,
          subSchool:[`void`],
          level: 7,
          name: `Step Into the Beyond`,
          type: `Counter`,
          longDesc: `<void> You can initiate this counter whenever you would like. If done in response to an action, this happens before the action effects you. You vanish into the void for 1d2+1 rounds. When you return you can return to any square within 30 feet of where you vanished from, and when you do you are at full hit points and all ability score damage and drain is removed, except for drain to your wisdom. You suffer 1 point of wisdom drain and 1 negative level after using this counter.`,
          initiationAction: `immediate`,
          range: `personal`,
          target: `you`,
          duration: `1d2+1 rounds`,
          additionalTags:["Void"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`light`],
          level: 3,
          name: `Breath of the Heavens`,
          type: `Boost`,
          longDesc: `<light> Heal all allies within 30 feet of you for 3d6 hit points. This only adds to your finisher combo once per round.`,
          initiationAction: `free`,
          range: `30 feet centered on you`,
          target: `all allies`,
          duration: `instantaneous`,
          additionalTags:["Light"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`light`],
          level: 3,
          name: `Evil Wanes, Harmony Grows`,
          type: `Stance`,
          longDesc: `This counts as a <fire> and <light> stance. Every time you hit with an unarmed attack, all allies within 30 feet of you (excluding you) heals 1d6 hit points. At level 12 and 18 this increases by 1d6. When you confirm a critical hit the healing increases by the critical damage multiplier.`,
          initiationAction: `swift`,
          range: `personal`,
          target: `you`,
          duration: `stance`
        },
        {
          school: `enlightenedPath`,
          subSchool:[`light`],
          level: 5,
          name: `Take Up The Burden`,
          type: `Boost`,
          longDesc: `<light> For 1 round, all damage your allies within 30 feet of you take is instead transfered to you. Reduce all damage you take this round by 25%. After this maneuver is activated, you take 1 permanent negative level.`,
          initiationAction: `swift`,
          range: `30 feet`,
          target: `allies`,
          duration: `1 round`,
          additionalTags:["Light"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`light`],
          level: 7,
          name: `Fist of Revealing Light`,
          type: `Boost`,
          longDesc: `<light> For 1 round, all enemy damage is reduced by 33%, and all ally damage is reduced by 50%. You can also make a check to dispel all illusions on the map (DC = 10 + casters level, you roll 1d20+your level + highest mental), and all creatures suffer a -40 penalty to stealth checks for 1 round.`,
          initiationAction: `movement`,
          range: `map`,
          target: `all creatures`,
          duration: `1 round`,
          additionalTags:["Light"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`dark`],
          level: 5,
          name: `Reverse Karma`,
          type: `Counter`,
          longDesc: `<dark> You reduce the damage an ally within 60 feet was about to take by 50%, and the creature that dealt that damage takes that reduced damage.`,
          initiationAction: `immediate`,
          range: `60 feet`,
          target: `one ally and one enemy`,
          duration: `instantaneous`,
          additionalTags:["Dark"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`dark`],
          level: 8,
          name: `Twist Karma`,
          type: `Counter`,
          longDesc: `<dark> You reduce the damage you were about to take to 0 and the creature that dealt that damage takes that damage in your place. It can make a will save to reduce this damage to 50% of the damage you were about to take.`,
          initiationAction: `immediate`,
          range: `60 feet`,
          target: `you and one enemy`,
          duration: `instantaneous`,
          additionalTags:["Dark"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`light`],
          level: 8,
          name: `Ultimate Martyr`,
          type: `Stance`,
          longDesc: `This counts as a <water> stance. 50% of all damage allies within 60 feet of you would take is transfered to you. You must be able to see the ally to transfer the damage.`,
          initiationAction: `swift`,
          range: `personal`,
          target: `you`,
          duration: `stance`,
          additionalTags:['Light','Water']
        },
        {
          school: `enlightenedPath`,
          subSchool:[`dark`],
          level: 8,
          name: `Manifest Death`,
          type: `Boost`,
          longDesc: `<dark> You focus your dark will on a creature you can see within 60 feet. All damage it takes for 1 round increases by 25%.`,
          initiationAction: `full-round`,
          range: `60 feet`,
          target: `one creature`,
          duration: `1 round`,
          additionalTags:["Dark"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`dark`],
          level: 4,
          name: `Die In Hatred`,
          type: `Counter`,
          longDesc: `<dark> You can initiate this counter whenever you are killed. The creature that killed you suffers negative energy damage equal to your highest mental modifier multiplied by 25. You can initiate this counter as a free action even when it is not your turn.`,
          initiationAction: `free`,
          range: ``,
          target: `one creature`,
          duration: `instantaneous`,
          additionalTags:["Dark"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`light`],
          level: 4,
          name: `Rise and Shine`,
          type: `Counter`,
          longDesc: `<light> When you are reduced below 0 hit points and knocked unconscious you can activate this counter to immediately heal yourself and all allies within 30 feet 1d6 hit points, plus 1d6 4 levels and also you emit a bright light in a 30-foot radius as the daylight spell, only you treat it as if it was heightened to level 5, potentially dispelling darkness spells.`,
          initiationAction: `immediate`,
          range: `personal`,
          target: `you`,
          duration: `one round`,
          additionalTags:["Light"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`dark`],
          level: 5,
          name: `Seething Hatred`,
          type: `Stance`,
          longDesc: `This counts as a <fire> and <dark> stance. Whenever a creature attacks and damages you or you fail a save against an ability of theirs, they take 1d4-1 points of negative energy damage per your initiation modifier.`,
          initiationAction: `swift`,
          range: `personal`,
          target: `you`,
          duration: `stance`,
          additionalTags:['Dark','Fire']
        },
        {
          school: `enlightenedPath`,
          subSchool:[`dark`],
          level: 5,
          name: `Reverse The Curse`,
          type: `Counter`,
          longDesc: `<dark> When you are about to take damage, you instead heal the amount you were about to take. This doesn't work on any self inflicted or voluntary damage (even from things like the shield other spell).`,
          initiationAction: `immediate`,
          range: `personal`,
          target: `you`,
          duration: `instantaneous`,
          additionalTags:["Dark"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`void`],
          level: 3,
          name: `Inevitable Approach`,
          type: `Strike`,
          longDesc: `<void> Make an unarmed attack, it deals an additional 3d12 points of force damage and they become marked by you for initiation modifier rounds. You can teleport to any square adjacent to a marked creature as a free action, and reduce the remaining duration by 3 rounds. You cannot teleport to the same creature more than once per round.`,
          initiationAction: `swift`,
          range: `melee attack`,
          target: `one creature`,
          duration: `initiation modifier rounds`,
          additionalTags:["Void"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`light`],
          level: 5,
          name: `Convert Essence`,
          type: `Strike`,
          longDesc: `<light> Make an unarmed attack, if successful it deals damage as normal and you can heal an ally within 30 feet of you damage equal to the damage of the attack, or split it up amongst allies within 30 feet as you see fit.`,
          initiationAction: `swift`,
          range: `melee attack`,
          target: `one creature`,
          duration: `instantaneous`,
          additionalTags:["Light"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`void`],
          level: 3,
          name: `Strike the First Gate`,
          type: `Strike`,
          longDesc: `<void> Make an unarmed attack, if it is successful it deals damage as normal and the creature suffers 1d3 negative levels, but heals 1d3*25 hit points. At level 12 and 18 the negative levels and hit points healed increases by 1d3.`,
          initiationAction: `standard`,
          range: `melee attack`,
          target: `one creature`,
          duration: `instantaneous`,
          additionalTags:["Void"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`void`],
          level: 5,
          name: `Strike the Second Gate`,
          type: `Strike`,
          longDesc: `<void> Make an unarmed attack, if it is successful it deals damage as normal and creature must make a will save or be removed from existence for 1 round. You must also make a will save against this, if you fail, you suffer 1 wisdom drain.`,
          initiationAction: `standard`,
          range: `melee attack`,
          target: `one creature`,
          duration: `1 round`,
          additionalTags:["Void"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`void`],
          level: 7,
          name: `Strike the Third Gate`,
          type: `Strike`,
          longDesc: `<void><[curse]> Make an unarmed attack, if it is successful it deals damage as normal and the creature's time becomes limited. Each round at the start of its turn it suffers 1 negative level and then makes a will save. If it fails this will save the negative levels it takes each turn increases by 1. Using this maneuver on a creature multiple times increases the negative levels they take at the start of each turn by 1.`,
          initiationAction: `standard`,
          range: `melee attack`,
          target: `one creature`,
          duration: `permanent`,
          additionalTags:["Void","Curse"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`void`],
          level: 9,
          name: `Knock on the Gate of Gates`,
          type: `Finisher`,
          longDesc: `[void-void-void-void-void-void-void] Make an unarmed attack, this bypasses all miss chances and cannot be countered. If the attack it hits, the creature is obliterated. If the creature is the final boss, this instead just instantly kills it, however it still gets its second phase or death mechanic as normal. Regardless of whether it hits or not, you are also obliterated. Nothing can ever bring you back. This attack automatically fails on great old ones and their servants. 
          \nIn order to initiate this finisher, you must have used 'Strike the First Gate', 'Strike the Second Gate', and 'Strike the Third Gate' as a part of your last 5 combo points.`,
          initiationAction: `full-round`,
          range: `melee`,
          target: `1 enemy`,
          duration: `instantaneous`,
          additionalTags:["Void"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`void`],
          level: 4,
          name: `Void Walker`,
          type: `stance`,
          longDesc: `This counts as an <air> and <void> stance. Whenever you initiate a maneuver you can teleport 5 feet per level of the maneuver. You can do this before or after initiating it.`,
          initiationAction: `swift`,
          range: `personal`,
          target: `you`,
          duration: `stance`,
          additionalTags:['Air','Void']
        },
        {
          school: `enlightenedPath`,
          subSchool:[`void`],
          level: 5,
          name: `See Everything`,
          type: `Boost`,
          longDesc: `<void> For 1 round, once each turn that you are attacked, targeted by an ability, or within the area of an AoE you can teleport 10 feet before the attack or effect resolves, possibly negating it.`,
          initiationAction: `swift`,
          range: `personal`,
          target: `you`,
          duration: `1 round`,
          additionalTags:["Void"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`void`],
          level: 9,
          name: `Unlimited Void`,
          type: `Stance`,
          longDesc: `This is a void stance. You fill the minds of all creatures within 15 feet of you with a near infinite amount of stimulus. Each round a creature starts its turn in this range it must make an intelligence check (dc = 10 + initiation modifier) or it is unable to take actions that turn. Great old ones are immune to this.`,
          initiationAction: `swift`,
          range: `personal`,
          target: `you`,
          duration: `stance`,
          additionalTags:['Void']
        },
        {
          school: `enlightenedPath`,
          subSchool:[`void`],
          level: 9,
          name: `Hollow Purple`,
          type: `Strike`,
          longDesc: `<void> You launch a mass of immense energy in a 10 foot wide straight line. All creatures in the area take damage as if you had struck them with unarmed attacks equal to your highest mental modifier. They can make a reflex save to halve the damage.`,
          initiationAction: `1 round action`,
          range: `100 foot line, 10 feet wide`,
          target: ``,
          duration: `instantaneous`,
          additionalTags:["Void"]
        },

        {
          school: `enlightenedPath`,
          subSchool:[`light`],
          level: 5,
          name: `Jade Strike`,
          type: `strike`,
          longDesc: `<light> Make a melee unarmed attack that is especially powerful against those you consider tainted. If the attack hits and the creature has an opposing good/evil alignment to you, they take an additional 10% damage from physical attacks, and their fortification is reduced by 25% for 3 rounds. Aberrations and undead creatures take double this effect. A will save negates this effect (dc=10 + level/2 + highest mental modifier). If the attack is a critical hit, the creature is instead locked into a tomb of jade if it fails the will save. A creature within jade is paralyzed, but can take no damage. You can dismiss the jade as a movement action.`,
          initiationAction: `standard`,
          range: `sight`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Light"]
        },
        {
          school: `enlightenedPath`,
          subSchool:[`light`],
          level: 5,
          name: `Tomb of Jade`,
          type: `strike`,
          longDesc: `<light> Make a melee unarmed attack. If the attack hits and the creature has an opposing good/evil alignment to you, the creature is locked into a tomb of jade if it fails a will save (dc=10 + level/2 + highest mental modifier). Aberrations and undead must roll twice and take the lower result to avoid this. A creature within jade is paralyzed, but can take no damage. You can dismiss the jade as a movement action.`,
          initiationAction: `standard`,
          range: `sight`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Light"]
        },
        {
          school: `enlightenedPath`,
          subSchool:'basic',
          level: 2,
          name: `Fist of Darkness`,
          type: `Strike`,
          longDesc: `<dark>[fear] Make an unarmed attack, it deals an additional 1d12 negative energy damage, increasing by 1d12 every 4 levels. If the attack is successful, the target must make a will save (dc= 10 + level + initiation modifier) or become shaken for initiation modifier rounds (minimum 1). On a natural 20, the negative energy damage is multiplied by the critical damage multiplier.`,
          initiationAction: `swift`,
          spCost:4,
          range: `Melee attack`,
          target: `One creature`,
          duration: `initiation modifier rounds`,
          additionalTags:["Dark"]
        },
        {
          school: `enlightenedPath`,
          subSchool:`basic`,
          level: 2,
          name: `Fist of the Void`,
          type: `Strike`,
          longDesc: `<void> Make an unarmed attack, it deals an additional 1d12 force damage, increasing by 1d12 every 4 levels. The attack gains a flat +1 bonus to its critical threat range and critical damage multiplier. On a natural 20, the force damage is multiplied by the critical damage multiplier.`,
          initiationAction: `swift`,
          spCost:4,
          range: `Melee attack`,
          target: `One creature`,
          duration: `initiation modifier rounds`,
          additionalTags:["Void"]
        },
        {
          school: `enlightenedPath`,
          level: 2,
          name: `Fists of Iron`,
          type: `Strike`,
          longDesc: `<earth> Make an unarmed attack, increase its damage by 2 dice steps. The attack gains a flat +1 bonus to its critical threat range and critical damage multiplier.`,
          initiationAction: `swift`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Earth"]
        },
        {
          school: `enlightenedPath`,
          level: 2,
          name: `Knock on the Sky`,
          type: `Strike`,
          longDesc: `<air> Make an unarmed attack, it deals an additional 2d6 points of electricity damage. If the attack is successful, the target also takes a -1 penalty on all attack rolls for initiation modifier rounds. This penalty stacks with repeated uses of this maneuver and other Enlightened Path maneuvers with the same effect, however additional applications only increase the duration by 1 round.`,
          initiationAction: `swift`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `initiation modifier rounds`,
          additionalTags:["Air"]
        },
        {
          school: `enlightenedPath`,
          level: 2,
          name: `Melting Claw Strike`,
          type: `Strike`,
          longDesc: `<fire> Make an unarmed attack, it deals an additional 2d6 points of fire damage. If the attack is successful, the target also has their armor bonus to armor class reduced by -2 and their fortification reduced by -10% for initiation modifier rounds. This can reduce their armor bonus below 0. This penalty stacks with repeated uses of this maneuver and other Enlightened Path maneuvers with the same effect, however additional applications only increase the duration by 1 round.`,
          initiationAction: `swift`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `initiation modifier rounds`,
          additionalTags:["Fire"]
        },
        {
          school: `enlightenedPath`,
          level: 2,
          name: `Unbalancing Strike`,
          type: `Strike`,
          longDesc: `<water> Make an unarmed attack, it deals an additional 2d6 points of cold damage. If the attack is successful, the target must make a reflex save (dc=10 + level/2 + initiation modifier) or they also become flat-footed for 1 round.`,
          initiationAction: `swift`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `1 round`,
          additionalTags:["Water"]
        },
        // {
        //   school: `enlightenedPath`,
        //   level: 3,
        //   name: `Imbument of the Enduring`,
        //   type: `Boost`,
        //   longDesc: `<earth>[strike imbument] Your next unarmed attack this turn has its damage dealt increased by 3 dice steps.`,
        //   initiationAction: `movement`,
        //   range: `Melee attack`,
        //   target: `One creature`,
        //   duration: `1 turn`,
        //   additionalInfoTags:["Strike Imbument"],
        //   additionalTags:["Earth"]
        // },
        // {
        //   school: `enlightenedPath`,
        //   level: 3,
        //   name: `Imbument of Storm`,
        //   type: `Boost`,
        //   longDesc: `<air>[strike imbument] Your next attack unarmed this turn deals an additional 4d6 electricity damage.`,
        //   initiationAction: `free`,
        //   range: `Melee attack`,
        //   target: `One creature`,
        //   duration: `1 turn`,
        //   additionalInfoTags:["Strike Imbument"],
        //   additionalTags:["Air"]
        // },
        // {
        //   school: `enlightenedPath`,
        //   level: 3,
        //   name: `Imbument of Purity`,
        //   type: `Boost`,
        //   longDesc: `<fire>[strike imbument] Your next attack unarmed this turn deals an additional 4d6 fire damage.`,
        //   initiationAction: `free`,
        //   range: `Melee attack`,
        //   target: `One creature`,
        //   duration: `1 turn`,
        //   additionalInfoTags:["Strike Imbument"],
        //   additionalTags:["Fire"]
        // },
        // {
        //   school: `enlightenedPath`,
        //   level: 3,
        //   name: `Imbument of Flowing Water`,
        //   type: `Boost`,
        //   longDesc: `<water>[strike imbument] Your next attack unarmed this turn deals an additional 4d6 cold damage.`,
        //   initiationAction: `free`,
        //   range: `Melee attack`,
        //   target: `One creature`,
        //   duration: `1 turn`,
        //   additionalInfoTags:["Strike Imbument"],
        //   additionalTags:["Water"]
        // },

        // {
        //   school: `enlightenedPath`,
        //   level: 4,
        //   name: `Imbument of Iron`,
        //   type: `Boost`,
        //   longDesc: `<earth>[strike imbument] Your next unarmed attack this turn has its damage dealt increased by 3 dice steps and gains a flat +1 bonus to its critical threat range and critical damage multiplier.`,
        //   initiationAction: `free`,
        //   range: `Melee attack`,
        //   target: `One creature`,
        //   duration: `1 turn`,
        //   additionalInfoTags:["Strike Imbument"],
        //   additionalTags:["Earth"]
        // },
        // {
        //   school: `enlightenedPath`,
        //   level: 4,
        //   name: `Imbument of Sky Knocking`,
        //   type: `Boost`,
        //   longDesc: `<air>[strike imbument] Your next unarmed attack this turn deals an additional 4d6 electricity damage and if the attack is successful, the target also takes a -1 penalty on all attack rolls for initiation modifier rounds. This penalty stacks with repeated uses of this maneuver and other Enlightened Path maneuvers with the same effect, however additional applications only increase the duration by 1 round.`,
        //   initiationAction: `free`,
        //   range: `Melee attack`,
        //   target: `One creature`,
        //   duration: `initiation modifier rounds`,
        //   additionalInfoTags:["Strike Imbument"],
        //   additionalTags:["Air"]
        // },
        // {
        //   school: `enlightenedPath`,
        //   level: 4,
        //   name: `Imbument of the Melting Claw`,
        //   type: `Boost`,
        //   longDesc: `<fire>[strike imbument] Your next unarmed attack this turn deals an additional 4d6 fire damage and if the attack is successful, the target also has their armor bonus to armor class reduced by -2 and their fortification reduced by -10% for initiation modifier rounds. This can reduce their armor bonus below 0. This penalty stacks with repeated uses of this maneuver and other Enlightened Path maneuvers with the same effect, however additional applications only increase the duration by 1 round.`,
        //   initiationAction: `free`,
        //   range: `Melee attack`,
        //   target: `One creature`,
        //   duration: `initiation modifier rounds`,
        //   additionalInfoTags:["Strike Imbument"],
        //   additionalTags:["Fire"]
        // },
        // {
        //   school: `enlightenedPath`,
        //   level: 4,
        //   name: `Imbument of Unbalancing`,
        //   type: `Boost`,
        //   longDesc: `<water>[strike imbument] Your next unarmed attack this turn deals an additional 4d6 cold damage and if the attack is successful, the target must make a reflex save (dc=10 + level/2 + initiation modifier) or they also become flat-footed for 1 round.`,
        //   initiationAction: `free`,
        //   range: `Melee attack`,
        //   target: `One creature`,
        //   duration: `1 round`,
        //   additionalInfoTags:["Strike Imbument"],
        //   additionalTags:["Water"]
        // },

        {
          school: `enlightenedPath`,
          level: 4,
          name: `Falling of The Earth`,
          type: `Strike`,
          longDesc: `<earth> Make an unarmed attack, increase its damage by 6 dice steps. This attack cannot critically hit.`,
          initiationAction: `swift`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Earth"]
        },
        {
          school: `enlightenedPath`,
          level: 4,
          name: `Falling Heavens`,
          type: `Strike`,
          longDesc: `<air> Make 2 unarmed attacks with a -6 penalty, each deals an additional 1d6 points of electricity damage.`,
          initiationAction: `swift`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Air"]
        },
        {
          school: `enlightenedPath`,
          level: 4,
          name: `Falcon Kick`,
          type: `Strike`,
          longDesc: `<fire> Move up to half your movement speed in a straight line and then make an unarmed attack that deals an additional 8d6 fire damage. This movement provokes as normal, and must be made so that your attack could qualify as a charge. You can move any direction for the movement, even straight up. If your attack misses, you suffer a -4 penalty to your armor class for 1 round.`,
          initiationAction: `movement`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Fire"]
        },
        {
          school: `enlightenedPath`,
          level: 4,
          name: `Flowing Water Strike`,
          type: `Strike`,
          longDesc: `<water> Make an unarmed attack that deals an additional 4d6 cold damage, then move up to your movement speed. You must end your movement threatening the creature the attack was made against. This movement does not provoke.`,
          initiationAction: `swift`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Water"]
        },
        
        {
          school: `enlightenedPath`,
          level: 5,
          name: `Master Strike of the Enduring`,
          type: `Strike`,
          longDesc: `<earth> Make an unarmed attack, increase its damage by 5 dice steps.`,
          initiationAction: `swift`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Earth"]
        },
        {
          school: `enlightenedPath`,
          level: 5,
          name: `Master of the Storm Strike`,
          type: `Strike`,
          longDesc: `<air> Make an unarmed attack, it deals an additional 8d6 points of electricity damage.`,
          initiationAction: `swift`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Air"]
        },
        {
          school: `enlightenedPath`,
          level: 5,
          name: `Master of the Fires of Purity`,
          type: `Strike`,
          longDesc: `<fire> Make an unarmed attack, it deals an additional 8d6 points of fire damage.`,
          initiationAction: `swift`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Fire"]
        },
        {
          school: `enlightenedPath`,
          level: 5,
          name: `Master of Flowing Water Strike`,
          type: `Strike`,
          longDesc: `<water> Make an unarmed attack, it deals an additional 8d6 points of cold damage.`,
          initiationAction: `swift`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Water"]
        },

        {
          school: `enlightenedPath`,
          level: 7,
          name: `Grandmaster Strike of the Enduring`,
          type: `Strike`,
          longDesc: `<earth> Make an unarmed attack, increase its damage by 7 dice steps and its critical damage multiplier increases by +1.`,
          initiationAction: `swift`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:['Earth']
        },
        {
          school: `enlightenedPath`,
          level: 7,
          name: `Grandmaster of the Storm Strike`,
          type: `Strike`,
          longDesc: `<air> Move up to half your movement speed and make an unarmed attack, it deals an additional 15d6 points of electricity damage. While using this movement you can even move straight up, and you dont fall until the start of your next turn.`,
          initiationAction: `swift`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Air"]
        },
        {
          school: `enlightenedPath`,
          level: 7,
          name: `Grandmaster of the Fires of Purity`,
          type: `Strike`,
          longDesc: `<fire> Make an unarmed attack, it deals an additional 15d6 points of fire damage. The critical threat range of this attack increases by a flat +2 and the fire damage from this attack is multiplied on critical hits.`,
          initiationAction: `swift`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Fire"]
        },
        {
          school: `enlightenedPath`,
          level: 7,
          name: `Grandmaster of Flowing Water Strike`,
          type: `Strike`,
          longDesc: `<water> Make an unarmed attack, it deals an additional 15d6 points of cold damage. If the attack is successful, the creature takes a -4 penalty to its attacks and armor class and cannot 5-foot step for 1 round.`,
          initiationAction: `swift`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Water"]
        },

        {
          school: `enlightenedPath`,
          level: 6,
          name: `Falling of the Mountain Peaks`,
          type: `Strike`,
          longDesc: `<earth> Make a full-round attack with unarmed strikes. Each attack has its damage dealt increased by 2 dice steps, and their critical damage multiplier increased by a flat +1.`,
          initiationAction: `full-round`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Earth"]
        },
        {
          school: `enlightenedPath`,
          level: 6,
          name: `The Storm Rages`,
          type: `Strike`,
          longDesc: `<air> Make a full-round attack with unarmed strikes. Each attack deals an additional 3d6 electricity damage.`,
          initiationAction: `standard`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Air"]
        },
        {
          school: `enlightenedPath`,
          level: 6,
          name: `Dewdrops of the Rising Sun`,
          type: `Strike`,
          longDesc: `<fire> Make a full-round attack with unarmed strikes. Each attack deals an additional 5d6 fire damage and has their critical threat range increased by a flat +1.`,
          initiationAction: `full-round`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`,
          additionalTags:["Fire"]
        },
        {
          school: `enlightenedPath`,
          level: 6,
          name: `Rushing Torrent, Dancing Stream`,
          type: `Strike`,
          longDesc: `<water> Make a full-round attack with unarmed strikes. Each attack deals an additional 5d6 cold damage, and after every attack you make during this maneuver and any others unarmed strikes you make before the start of your next turn, if it is successful, you may move 5 feet and you gain a +1 dodge bonus to your armor class (stacks) until the start of your next turn. This movement does not provoke.`,
          initiationAction: `full-round`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `1 round`,
          additionalTags:["Water"]
        },
        {
          school: `enlightenedPath`,
          level: 0,
          name: `The Trembling Earth`,
          type: `Finisher`,
          finisherType:"Strike",
          longDesc: `[earth-earth-earth] Make an unarmed attack, it has a +1 bonus on its critical damage multiplier, and if the attack hits the target must make a fortitude save (dc= 10 + level/2 + initiation modifier) or be unable to cast spells for 3 rounds.`,
          initiationAction: `free`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `3 rounds`,
        },

        {
          school: `enlightenedPath`,
          level: 0,
          name: `The Gathering Storm`,
          type: `Finisher`,
          finisherType:"Strike",
          longDesc: `[air-air-air] Make an unarmed attack, if successful it deals damage as normal and the target must make a fortitude save (dc= 10 + level/2 + initiation modifier) or be surrounded by buffeting winds, causing all attacks it makes to suffer a 20% miss chance for 3 rounds. This stacks with other miss chance (unless they are from essentially the same effect), but is rolled seperately.`,
          initiationAction: `free`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `3 rounds`
        },

        {
          school: `enlightenedPath`,
          level: 0,
          name: `The Raging Sea`,
          type: `Finisher`,
          finisherType:"Strike",
          longDesc: `[water-water-water] Make an unarmed attack, if successful it deals damage as normal and the target must make a fortitude save (dc= 10 + level/2 + initiation modifier) or be staggered for 3 rounds.`,
          initiationAction: `free`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `3 rounds`
        },
        {
          school: `enlightenedPath`,
          level: 0,
          name: `Breath of the Fire Dragon`,
          type: `Finisher`,
          finisherType:"Strike",
          longDesc: `[fire-fire-fire] You breathe a 15-ft cone of searing fire dealing 1d6 points of fire damage per level, plus the modifier of the ability score you use to determine your unarmed strike damage. Every 5 levels it adds the ability score modifier again. Creatures in the area can make a reflex saving throw (dc= 10 + level/2 + initiation modifier) to reduce the damage by half. Every 4 levels the cone's size increases by 5 feet.`,
          initiationAction: `swift`,
          range: `15-foot cone`,
          target: ``,
          duration: `instantaneous`
        },
        {
          school: `enlightenedPath`,
          level: 0,
          name: `Healing Ki`,
          type: `Finisher`,
          finisherType:"Boost",
          longDesc: `[light-light-light] You and all allies within 30 feet of you heal 1d4 hit points per level. (This scales with double healing spell power)`,
          initiationAction: `free`,
          range: `30 feet`,
          target: `all allies`,
          duration: `instantaneous`
        },
        {
          school: `enlightenedPath`,
          level: 0,
          name: `Gasp of the Earth Dragon`,
          type: `Finisher`,
          finisherType:"Boost",
          longDesc: `[earth-light-earth] With a quick prayer you grant a blessing of earth to yourself and all allies within 30 feet of you for 3 rounds. All allies blessed becomes immune to daze, paralysis, stun, and sleep.`,
          initiationAction: `free`,
          range: `30 feet`,
          target: `all allies`,
          duration: `3 rounds`
        },
        {
          school: `enlightenedPath`,
          level: 0,
          name: `Dance of the Clouds`,
          type: `Finisher`,
          finisherType:"Boost",
          longDesc: `[air-light-air] With a quick prayer you grant a blessing to yourself and all allies within 30 feet of you for 3 rounds. All allies blessed are surrounded in buffeting winds, causing all physical attacks against them to suffer a 20% miss chance. This stacks with other miss chance (unless they are from essentially the same effect), but is rolled seperately.`,
          initiationAction: `free`,
          range: `30 feet`,
          target: `all allies`,
          duration: `3 rounds`
        },
        {
          school: `enlightenedPath`,
          level: 0,
          name: `Walk of the Sun`,
          type: `Finisher`,
          longDesc: `[fire-light-fire] With a quick prayer you grant a blessing to yourself and all allies within 30 feet of you for 3 rounds. All allies blessed gain a +2 bonus on attack rolls, saves, and skill checks.`,
          initiationAction: `free`,
          range: `30 feet`,
          target: `all allies`,
          duration: `3 rounds`
        },
        {
          school: `enlightenedPath`,
          level: 0,
          name: `Aligning the Heavens`,
          type: `Finisher`,
          finisherType:"Boost",
          longDesc: `[water-light-water] With a quick prayer you grant a blessing to yourself and all allies 30 feet for 3 rounds. All allies blessed have the cost of their spells reduced by 25%.`,
          initiationAction: `swift`,
          range: `30 feet`,
          target: `all allies`,
          duration: `3 rounds`
        },

        {
          school: `enlightenedPath`,
          level: 0,
          name: `Touch of Despair`,
          type: `Finisher`,
          finisherType:"Strike",
          longDesc: `[dark-dark-dark] Make an unarmed attack, if successful it deals damage as normal plus an additional 1d12 points of negative energy damage per 3 levels (This scales with double negative spell power) and the target must make a fortitude save (dc= 10 + level + initiation modifier) or be struck by a terrible curse, halving all positive energy healing done to them, reducing its fortification by 25%, and increasing its negative energy vulnerability by 25% for initiation modifier rounds (minimum 1).`,
          initiationAction: `free`,
          range: `melee attack`,
          target: `one creature`,
          duration: `initiation modifier rounds`
        },
        {
          school: `enlightenedPath`,
          level: 0,
          name: `Pain Touch`,
          type: `Finisher`,
          finisherType:"Strike",
          longDesc: `[earth-dark-earth] Make an unarmed attack, if successful it deals damage as normal and the target must make a fortitude save (dc= 10 + level/2 + initiation modifier) or be nauseated for 3 rounds.`,
          initiationAction: `free`,
          range: `melee attack`,
          target: `one creature`,
          duration: `3 rounds`
        },
        {
          school: `enlightenedPath`,
          level: 0,
          name: `Falling Stars Strike`,
          type: `Finisher`,
          finisherType:"Strike",
          longDesc: `[air-dark-air] Make an unarmed attack, if successful it deals damage as normal and the target must make a fortitude save (dc= 10 + level/2 + initiation modifier) or become blind for 3 rounds.`,
          initiationAction: `free`,
          range: `melee attack`,
          target: `one creature`,
          duration: `3 rounds`
        },
        {
          school: `enlightenedPath`,
          level: 0,
          name: `Karmic Fist`,
          type: `Finisher`,
          finisherType:"Strike",
          longDesc: `[fire-dark-fire] Make an unarmed attack, if successful it is an automatic critical threat.`,
          spCost:"level spell points",
          initiationAction: `free`,
          range: `melee attack`,
          target: `one creature`,
          duration: `instantaneous`
        },
        {
          school: `enlightenedPath`,
          level: 0,
          name: `Freezing the Lifeblood`,
          type: `Finisher`,
          finisherType:"Strike",
          longDesc: `[water-dark-water] Make an unarmed attack, if successful it deals damage as normal and the target must make a fortitude save (dc= 10 + level/2 + initiation modifier) or become paralysed for initiation modifier rounds (minimum 1, max 3).`,
          initiationAction: `swift`,
          range: `melee attack`,
          target: `one creature`,
          duration: `initiation modifier (max 3)`
        },


        {
          school: `enlightenedPath`,
          level: 0,
          name: `Infinite Force Strike`,
          type: `Finisher`,
          finisherType:"Strike",
          longDesc: `[void-void-void] Make an unarmed attack, if successful it deals damage as normal and you can make a free bull rush attempt against the creature as a free action gaining a bonus on the attempt equal to half the damage dealt by the attack. This bull rush attempt does not provoke.`,
          initiationAction: `free`,
          range: `melee attack`,
          target: `one creature`,
          duration: `instantaneous`
        },
        {
          school: `enlightenedPath`,
          level: 0,
          name: `Empty Body`,
          type: `Finisher`,
          finisherType:"Boost",
          longDesc: `[earth-void-earth] With a quick prayer, you grant a blessing to yourself and all allies within 30 feet 30 feet of you. For 3 rounds, all those blessed gain 50% fortification. This stacks with other fortification, but it is reduced to 25%.`,
          initiationAction: `free`,
          range: `30 feet`,
          target: `all allies`,
          duration: `3 rounds`
        },
        {
          school: `enlightenedPath`,
          level: 0,
          name: `Step of the Void`,
          type: `Finisher`,
          finisherType:"Boost",
          longDesc: `[air-void-air] You can teleport to any square you can see. You can initiate this finisher as a free action even when it is not your turn.`,
          initiationAction: `free`,
          range: `sight`,
          target: `you`,
          duration: `instantaneous`
        },
        {
          school: `enlightenedPath`,
          level: 0,
          name: `Curse of the Void`,
          type: `Finisher`,
          finisherType:"Strike",
          longDesc: `[fire-void-fire][mind-affecting] Make an unarmed attack, if successful it deals damage as normal and the creature is dazed. At the start of each of its turns and any time it is attacked it gets a fortitude save (dc= 10 + level/2 + initiation modifier) to end this.`,
          initiationAction: `free`,
          range: `melee attack`,
          target: `one creature`,
          duration: `instantaneous`
        },
        {
          school: `enlightenedPath`,
          level: 0,
          name: `Moment of Clarity`,
          type: `Finisher`,
          finisherType:"Boost",
          longDesc: `[water-void-water] With a quick prayer you grant a blessing to yourself and all allies within 30 feet of you. For 3 rounds, all those blessed gain a +4 bonus on attack rolls and skill checks.`,
          initiationAction: `free`,
          range: `30 feet`,
          target: `all allies`,
          duration: `3 rounds`
        },
        {
          school: `enlightenedPath`,
          level: 4,
          name: `Ebb and Flow`,
          type: `Finisher`,
          finisherType:"Counter",
          longDesc: `[water-water] This counts as a finisher and a counter. When a creature makes an attack roll against you, you can initiate this counter to cause it to automatically miss. You can initiate this counter even against attacks you can't normally counter, such as if the attack was a natural 20, or you were flat-footed. After you negate the attack, you may move up to your movement speed directly towards the attacker, and if you end your movement within your melee reach of the creature, you can make an unarmed attack against them. When you make your attack roll, you can choose to take the dice roll of the enemy, or your own, whichever is higher (only the result of the dice, not the total modifier). Whichever attack roll you choose not to use, your counterattack does bonus damage equal to the unused attack roll (the whole roll, not just the dice result).`,
          initiationAction: `immediate`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`
        },
        {
          school: `enlightenedPath`,
          level: 3,
          name: `Unwavering Mountain`,
          type: `Finisher`,
          finisherType:"Boost",
          longDesc: `[earth-earth-earth] You gain damage reduction /adamantine equal to your initiation modifier for 2 rounds. Every 6 levels it lasts an additional round.`,
          initiationAction: `free`,
          range: `personal`,
          target: `you`,
          duration: `2 rounds, plus 1 round/6 levels`
        },
        {
          school: `enlightenedPath`,
          level: 3,
          name: `Lightning Finish`,
          type: `Finisher`,
          finisherType:"Strike",
          longDesc: `[air-air-air-air] Make a unarmed attack that deals an additional 1d6 points of electricity damage per 4 levels. After you use the attack, for 1 round you can at any point you can as an immediate action move 5 feet per your initiation modifier and make another unarmed attack against the original target of this maneuver. You must move the maximum distance and cannot step on the same square twice.`,
          initiationAction: `free`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`
        },
        {
          school: `enlightenedPath`,
          level: 3,
          name: `Falcon Punch`,
          type: `Finisher`,
          finisherType:"Strike",
          longDesc: `[fire-fire-fire-fire] When you initiate this maneuver your turn instantly ends, and on your next turn you are automatically staggered (unresistable, unremovable). At the start of your next turn, you make an automatic unarmed attack. For the attack, you gain a +4 bonus to the attack roll, it deals an additional 1d6 fire damage per 3 levels, your reach increases by 5 feet, and if it hits, it automatically becomes a potential critical hit and the creature is pushed away from you 5 feet per initiation modifier. This attack ignores immunity or resistance to critical hits. You can take your 5-foot step before the attack is made, but you can take no other actions. Creatures more than 3 sizes larger than you are immune to being pushed away.`,
          initiationAction: `swift`,
          range: `Melee attack`,
          target: `One creature`,
          duration: `instantaneous`
        },
        // {
        //   school: `enlightenedPath`,
        //   level: 6,
        //   name: `Black Turtle Wave`,
        //   type: `Finisher`,
        //   finisherType:"Strike",
        //   longDesc: `[fire-dark-dark-fire] Make a ranged touch attack, if it hits, you deal damage as if you had struck with all of your attacks during a full-round attack, except they all deal half damage. These attacks automatically deal your sneak attack damage, even if the creature is immune or resistant to sneak attack damage.`,
        //   initiationAction: `standard`,
        //   range: `90 feet`,
        //   target: `One creature`,
        //   duration: `instantaneous`
        // },
        // {
        //   school: `enlightenedPath`,
        //   level: 6,
        //   name: `Hermit Wave`,
        //   type: `Finisher`,
        //   finisherType:"Strike",
        //   longDesc: `[water-light-light-water] Make a ranged touch attack, if it hits, you deal damage as if you had struck with all of your attacks during a full-round attack, except they all deal half damage. `,
        //   initiationAction: `standard`,
        //   range: `90 feet`,
        //   target: `One creature`,
        //   duration: `instantaneous`
        // },
        // {
        //   school: `enlightenedPath`,
        //   level: 4,
        //   name: `Cast Away`,
        //   type: `Finisher`,
        //   finisherType:"Boost",
        //   longDesc: `[dark-dark-dark-dark-dark] You deal 1d8 negative energy damage per level to a creature within range. If this reduces the creature below 0 hit points, they die, even if they have regeneration. If this kills a creature, they are reduced to ashes.`,
        //   initiationAction: `free`,
        //   range: `close (25 ft. + 5 ft./2 levels)`,
        //   target: `One living creature`,
        //   duration: `instantaneous`
        // },
        {
          school: `enlightenedPath`,
          level: 3,
          name: `Bleed Light`,
          subSchool:["light"],
          type: `Finisher`,
          finisherType:"Counter",
          longDesc: `[light-light] You can initiate this finisher even when it is not your turn. When you take damage, you can heal all allies within 30 feet (excluding you) for half the amount of damage you took.`,
          initiationAction: `free`,
          range: `30 feet`,
          target: `allies`,
          duration: `instantaneous`
        },
        {
          school: `enlightenedPath`,
          level: 5,
          name: `Guide Back`,
          subSchool:["light"],
          type: `Finisher`,
          finisherType:"Boost",
          longDesc: `[light-light-light-light] You heal a creature within range for 1d8 hit points per level. This healing can restore a creature to life as the breath of life spell.`,
          initiationAction: `free`,
          range: `60 feet`,
          target: `One creature`,
          duration: `instantaneous`
        },
        {
          comboTags: ['Light'],
          level: 3,
          name: `Encouraging Resurgence`,
          type: `Finisher`,
          finisherType:"Counter",
          longDesc: `[light-light] You can initiate this finisher even when it is not your turn, and can do so even in response to a natural 20. When you take damage, you can heal an ally within 30 feet (excluding you) for the amount of damage you just took.`,
          initiationAction: `free`,
          range: `30 feet`,
          target: `allies`,
          duration: `instantaneous`
        },
        {
          comboTags: ['Light'],
          level: 5,
          name: `Call Back`,
          type: `Finisher`,
          finisherType:"Boost",
          longDesc: `[light-light-light-light] You heal a creature within range for 2d6 hit points per 5 <light> mastery. This healing can restore a creature to life as the breath of life spell.`,
          initiationAction: `swift`,
          range: `60 feet`,
          target: `One creature`,
          duration: `instantaneous`
        },
        {
          school: `enlightenedPath`,
          level: 7,
          name: `Infinite Hurricane Fist`,
          type: `Finisher`,
          finisherType:"Boost",
          longDesc: `[air-air-air-air-air] You can initiate another <air> maneuver that has an initiation action of a standard action or less as a part of initiating this finisher. Your bonuses to Strike finishers is conferred to this strike, though only to the first attack if multiple.`,
          initiationAction: `movement`,
          range: `personal`,
          target: `you`,
          duration: `instantaneous`
        },
        {
          comboTags: ['Air'],
          level: 7,
          name: `Infinite Hurricane Strike`,
          type: `Finisher`,
          finisherType:"Boost",
          longDesc: `[air-air-air-air-air] You can initiate another <air>, <sakura>, or <flurry> maneuver that has an initiation action of a standard action or less as a part of initiating this finisher. After initiating it, you suffer a -5 penalty to your armor class until the end of your next turn. Your bonuses to Strike finishers is conferred to this strike, though only to the first attack if it includes multiple.`,
          initiationAction: `movement`,
          range: `personal`,
          target: `you`,
          duration: `instantaneous`
        },
        {
          school: `enlightenedPath`,
          level: 9,
          name: `I Alone`,
          subSchool:["void"],
          type: `Finisher`,
          finisherType:"Boost",
          longDesc: `[void-void-void-void-void-void-void] Throughout heaven and earth, you alone have been honored by the universe's blessing. The round you are initiating this maneuver and the round that it is active, you heal 50% of your maximum hit points, you gain a 50% miss chance on all attacks against you, your initiation modifier as a dodge bonus to your armor class, and you automatically succeed on all saving throws. Then the round after the initiation round, you gain an additional standard action, blindsight 300 feet, all of your unarmed attacks have their critical threat range increased by a flat +4, you can teleport as a free action to a maximum of <void> mastery on your turn, and all <void> maneuvers cost 50% less spell points.`,
          initiationAction: `1 round`,
          range: `personal`,
          target: `you`,
          duration: `1 round`
        },
        {
          school: `enlightenedPath`,
          level: 9,
          name: `Black Palm, Silent Fate`,
          subSchool:["dark"],
          type: `Finisher`,
          longDesc: `[dark-dark-dark-dark-dark] You make an unarmed attack against a living creature, if it hits, it deals an additional 500 points of negative energy damage. A will save reduces it by half.`,
          initiationAction: `standard`,
          range: `melee attack`,
          target: `1 enemy`,
          duration: `instantaneous`
        },
        {
          school: `enlightenedPath`,
          level: 9,
          subSchool:["dark"],
          name: `Rubedo, the Final Strike`,
          type: `Finisher`,
          longDesc: `[dark-fire-dark-fire-dark] The universe shakes and shudders as you swing your fist forward, unleashing a blinding flash of of light, darkness, and then finally, a deep crimson red. The attack rocks the foundation of the very being of all enemies in your presence. Make attacks against all enemies on the map as if making a full-round attack with melee unarmed strikes. These attacks deal an additional 5 points of fire damage and 5 points of negative energy damage, and if the creature you are making the attack against has an opposing good/evil or chaotic/lawful alignment from you, the bonus fire and negative energy damage both increase by 5 points (stacks if both). The damage from all attacks is totaled before applying damage reduction, resistances, or immunities. The attacks bypass any concealment or cover the targets may possess. You can exclude any enemies you wish.`,
          initiationAction: `full-round`,
          range: `map`,
          target: `all enemies`,
          duration: `instantaneous`
        },
        {
          school: `enlightenedPath`,
          level: 9,
          name: `Force of Nature`,
          type: `Finisher`,
          longDesc: `[light/void/dark-earth-fire-air-water] Make an unarmed attack, its damage dealt increased by 5 dice steps, deals an additional 10d6 fire, cold, and electricity damage, gains a flat +2 bonus to its critical threat range and critical damage multiplier, and if the attack hits, the creature takes a -2 penalty on all attack rolls and armor class for initiation modifier rounds, and becomes flat-footed for 1 round.`,
          initiationAction: `standard`,
          range: `melee attack`,
          target: `1 enemy`,
          duration: `see text;`
        },
        // {
        //   school: `enlightenedPath`,
        //   level: 9,
        //   name: `Genesis Zero`,
        //   subSchool:["dark","void"],
        //   type: `Finisher`,
        //   finisherType:"Strike",
        //   longDesc: `[dark-dark-void-void-void-dark-dark] You strike a creature, utilizing the forces that created the very universe itself. Make a melee unarmed attack, `,
        //   initiationAction: `standard`,
        //   range: `melee attack`,
        //   target: `1 enemy`,
        //   duration: `see text;`
        // },
        {
          school: `enlightenedPath`,
          level: 7,
          name: `The Sun Shines Again`,
          type: `Finisher`,
          finisherType:"Boost",
          longDesc: `[light-light-light-light-light] You heal all allies within range for 1d10 hit points per level. This healing can restore a creature to life as the breath of life spell, except that it can restore a creature to life as long as they have died within the last 3 rounds.`,
          initiationAction: `movement`,
          range: `30 feet`,
          target: `allies`,
          duration: `instantaneous;`
        },
        // {
        //   school: `enlightenedPath`,
        //   level: 7,
        //   name: `The Sun Shines Again`,
        //   type: `Finisher`,
        //   finisherType:"Boost",
        //   longDesc: `[light-light-light-light-light-light] You heal all creature within range for 1d10 hit points per level. This healing can restore a creature to life as the breath of life spell, except that it can restore a creature to life as long as they have died within the last 3 rounds.`,
        //   initiationAction: `movement`,
        //   range: `melee attack`,
        //   target: `1 enemy`,
        //   duration: `see text;`
        // },
        {
          comboTags: ['Light',],
          level: 7,
          name: `Miracle`,
          type: `Finisher`,
          finisherType:"Boost",
          longDesc: `[light-light-light-light-light] You heal all allies within range for 1d4 per 5 <light> mastery. This healing can restore a creature to life as the breath of life spell, except that it can restore a creature to life as long as they have died within the last 2 rounds.`,
          initiationAction: `movement`,
          range: `30 feet`,
          target: `allies`,
          duration: `see text;`
        }, 
          {
          school: `indomitableWill`,
          level: 1,
          name: "Gritted Teeth",
          type: "Stance",
          longDesc: `Gain DR 1/- and a +1 bonus to will saves. Every 3 levels the DR increases by 1, and every 6 levels the will save bonus increases by +1. The DR stacks with other DR. This bonus to will saves counts as a part of your base will save.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
            school: `indomitableWill`,
            level: 3,
            name: "Imbued with Purpose",
            type: "Stance",
            longDesc: `Your attacks with discipline weapons bypass DR that is lower than half your will save bonus, except for DR that is /-. At level 18 your attacks even bypass DR /-`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `stance`,
            target: `you`,
          },
          // {
          //   school: `indomitableWill`,
          //   level: 3,
          //   name: "Volition",
          //   type: "Strike",
          //   longDesc: ``,
          //   initiationAction: `standard`,
          //   range: `melee attack`,
          //   duration: `instantaneous`,
          //   target: `1 enemy`,
          // },
          // {
          //   school: `indomitableWill`,
          //   level: 2,
          //   name: "Walk it Off",
          //   type: "Counter",
          //   longDesc: ``,
          //   initiationAction: `immediate`,
          //   range: `personal`,
          //   duration: `instantaneous`,
          //   target: `you`,
          // },
          {
          school: `indomitableWill`,
          level: 1,
          name: "You Only Lose When You Don't Get Up",
          type: "Stance",
          longDesc: `You do not fall unconscious when reduced below 0 hit points, but can instead act as if you were disabled. Each round that you do this you take 1d4 points of damage which bypass temporary hit points (instead of the normal 1 point, and this doesn't trigger this stance's ability). Once per round when you are reduced below 0 hit points you make a will save and gain temporary hit points equal to the result of the roll. This even activates when you would be reduced below 0 because of the loss of temporary hit points. These do not stack with themselves and all of them are lost if you receive healing from another source or leave this stance.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
          school: `indomitableWill`,
          level: 1,
          name: "Didn't Even Feel That One",
          type: "Counter",
          longDesc: `You can initiate this counter when you take damage from an enemy, even if flat-footed or the result of the roll was a natural 20. Gain temporary hit points equal to the damage you just took, this applies after the damage and therefor does not reduce it. These temporary hit points last initiation modifier rounds. Until these temporary hit points are lost, any effect that applies due to dealing damage to a creature (bleed, poison, disease, etc.), do not affect you (and their duration and onset is paused). This doesn't effect things like grab or trip.`,
          initiationAction: `immediate`,
          range: `personal`,
          duration: `initiation modifier rounds`,
          target: `you`,
          },
          {
          school: `indomitableWill`,
          level: 1,
          name: "Even I Can Pierce the Heavens",
          type: "Strike",
          longDesc: `Make a melee attack, it deals damage as normal. For every time this encounter you have used this strike previously, it gains a +1 bonus on its attack and deals 2d6 extra damage. On long floors it is reduces to times used this combat.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 enemy`,
          },
          {
          school: `indomitableWill`,
          level: 1,
          name: "That's Just the Beginning",
          type: "Strike",
          longDesc: `Make a melee unarmed attack using a will save in place of the attack roll. If the attack is successful, it deals damage as normal and they are staggered for 1 round.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `1 round`,
          target: `1 creature`,
          },
          {
          school: `indomitableWill`,
          level: 2,
          name: "Will to Live",
          type: "Counter",
          longDesc: `You initiate this counter in response to taking damage from an enemy. You make a will save and reduce the damage taken by an amount equal to the result of the save.`,
          initiationAction: `immediate`,
          range: `personal`,
          duration: `instantaneous`,
          target: `you`,
          },
          {
          school: `indomitableWill`,
          level: 2,
          name: "Remember Your Oaths!",
          type: "Boost",
          longDesc: `All allies within 30 feet gain 1 of 2 bonuses, either they can make an immediate saving throw against an ongoing mind-affecting effect with a +2 morale bonus, or they gain a +2 morale bonus on all saving throws and temporary hit points equal to your level for 1 round. At level 8 and 16 the bonus increases by +1, and the temporary hit points increase by your level again.`,
          initiationAction: `swift`,
          range: `30 feet`,
          duration: `1 round`,
          target: `allies`,
          },
          {
          school: `indomitableWill`,
          level: 2,
          name: "Suffocating Pressure",
          type: "Strike",
          longDesc: `Make a melee attack, if it hits, you deal damage as normal and you make an opposed will saving throw against the target, the loser is dazed for 1 round. For every 2 points the winner wins the opposed check by, the loser takes 1d6 points of damage. the daze is a [mind-affecting][fear] effect.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `1 round`,
          target: `1 creature`,
          },
          {
          school: `indomitableWill`,
          level: 2,
          name: "Last Chance to Run",
          type: "Strike",
          longDesc: `Make an attack, if it hits you deal damage as normal plus an additional 2d6 and they must make a will save or be frightened for 1 round. The frightened is a [mind-affecting][fear] effect.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `1 round`,
          target: `1 creature`,
          },
          {
            school: `indomitableWill`,
            level: 2,
            name: "My Will is Far Greater Than Yours",
            type: "Strike",
            longDesc: `Make a melee attack, it deals damage as normal, plus 4 additional points of damage for every point higher your will save bonus is than theirs. At level 8 and 16 the damage is increased by an additional 2x the difference.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 creature`,
          },
          {
          school: `indomitableWill`,
          level: 2,
          name: "Unbreakable Beacon",
          type: "Counter",
          longDesc: `When making a save that effects multiple creatures, you can choose to initiate this counter before making the roll, doing so causes you to suffer a -4 penalty to the roll, however if you succeed, any creature that failed that save can make a new saving throw, gaining a +4 morale bonus to it. At level 8 and 16 the bonus increases by +2.`,
          initiationAction: `immediate`,
          range: `-`,
          duration: `instantaneous`,
          target: `allies`,
          },
          {
          school: `indomitableWill`,
          level: 2,
          name: "Death Glare",
          type: "Counter",
          longDesc: `When an enemy within 60 feet who you can see, and can see you makes an attack, you can initiate this counter to make an opposed will save against them. If you win, the attack is negated and they are shaken for 1 round. If they win, the attack gains a +4 bonus, and it deals an additional 2 points of damage per amount they beat you by.`,
          initiationAction: `immediate`,
          range: `60 feet`,
          duration: `instantaneous`,
          target: `1 enemy`,
          },
          {
          school: `indomitableWill`,
          level: 3,
          name: "Indomitable Will",
          type: "Stance",
          longDesc: `Each round at the start of your turn you make a will saving throw. You gain temporary hit points equal to the result of the save for 1 round. These are lost if you leave the stance.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
          school: `indomitableWill`,
          level: 3,
          name: "Don't Even Bother Trying!",
          type: "Boost",
          longDesc: `Make an opposed will saving throw against every enemy who can see and hear you within 60 feet, any creature that fails is shaken and the DC's of any of their spells, and extraordinary and supernatural abilities is reduced by -2. Both effects lasts for 1d4 rounds. [mind-affecting][fear]. Any creature that beats your will save bonus, you suffer a -4 penalty to all saves against their effects for 1d4+1 rounds.`,
          initiationAction: `swift`,
          range: `60 feet`,
          duration: `1d4 rounds`,
          target: `enemies`,
          },
          {
          school: `indomitableWill`,
          level: 3,
          name: "Unstoppable Force",
          type: "Strike",
          longDesc: `Make a melee attack, if it hits, it deals damage as normal plus 2d6, but you can also make a CMB check to bull rush the creature as a free action. This bull rush does not provoke attacks of opportunity and you gain a bonus to the check equal to half the damage you dealt with the attack, excluding the bonus damage. You cannot move with this bull rush. You can use this maneuver at the end of a charge, and you gain +1 bonus on the check for every 10 feet moved during the charge.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 creature`,
          },
          {
            school: `indomitableWill`,
            level: 4,
            name: "Bullheaded",
            type: "Strike",
            longDesc: `Make a headbutt attack. This is treated as an unarmed strike that deals damage as normal plus 4d6, but you cannot use weapons for it, even unarmed augmenting weapons. If it is the first time using this attack against the creature, it is flat-footed for the attack, regardless of its immunities to be flat-footed. If the attack hits, the initiator suffers the bonus damage it dealt, and both the initiator and the target must make a fortitude save or be dazed for 1 round. If the creature was grappling you, it must make an additional fortitude save with a -4 penalty or immediately release you. Creatures with no discernable head or brain are immune to the daze. You can increase the DC for both the target and yourself by up to your wisdom modifier (chosen when initiated).`,
            initiationAction: `movement`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 creature`,
          },
          {
          school: `indomitableWill`,
          level: 3,
          name: "Roll With the Blows",
          type: "Counter",
          longDesc: `You can initiate this counter after you are hit with a melee attack, a projectile attack from a large projectile (such as a cannon or large rock), or an AoE instantaneous damaging effect such as fireball or an explosion, and you can activate it even if the attack roll was a natural 20. Reduce the damage of the attack by 50%, and you move away from the attacker/source of the effect feet equal to damage reduced (rounded down to nearest 5 feet), and then you are knocked prone (or suffer the penalties of being prone for 1 round if you are flying). If you collide with an object or another creature, it must make reflex save dc = distance left to travel -10 or you collide with it, causing you and the creature/object take 1d6 points of damage for every 5 feet you had left to move and the creature is also knocked prone.`,
          initiationAction: `immediate`,
          range: `personal`,
          duration: `instantaneous`,
          target: `you`,
          },
          {
            school: `indomitableWill`,
            level: 3,
            name: "Helping Hand",
            type: "Counter",
            longDesc: `When an ally within natural reach would be knocked prone, you can stop them from doing so. Alternatively, you can initiate this to just lift them to their feet, this doesn't provoke attacks of opportunity. You can also use this counter when an ally within your natural reach has a successful CMB check made against them to move them or grapple them, you make an opposing CMB check against the grappling enemy's check, if you succeed the grapple or movement fails and you can move the ally to any other square within your natural reach. This movement doesn't provoke.`,
            initiationAction: `immediate`,
            range: `natural reach`,
            duration: `instantaneous`,
            target: `1 ally`,
          },
          {
            school: `indomitableWill`,
            level: 3,
            name: "I Will Do What I Must",
            type: "Boost",
            longDesc: `You can expend 3 random maneuvers (doesn't cost spell points) to recover a single maneuver of choice. You can expend an additional 3 random maneuvers to recover another maneuver.`,
            gameDesc:`You can expend 2 random maneuvers to recover a single maneuver of choice. You can expend an additional 2 random maneuvers to recover another maneuver.`,
            initiationAction: `free`,
            range: `personal`,
            duration: `instantaneous`,
            target: `you`,
          },
          {
            school: `indomitableWill`,
            level: 4,
            name: "Smallest of Things",
            type: "Boost",
            longDesc: `Can make all the difference. Expend a maneuver of a higher level to recover a maneuver of a lower level. Gain 2d6 temporary hit points per difference in level between the higher level maneuver and the lower level maneuver. These last initiation modifier rounds.`,
            initiationAction: `free`,
            range: `personal`,
            duration: `instantaneous`,
            target: `you`,
          },
          {
          school: `indomitableWill`,
          level: 3,
          name: "Born To Inherit the Stars",
          type: "Counter",
          longDesc: `You can activate this counter in response to taking hit point damage or becoming physically restrained. You sacrifice a body part in order to keep fighting on. The part you lose is randomly chosen between your remaining arms, legs, and head. After losing your limb you reduce the damage of that attack to 0 (or automatically end the restraining effect) and enter into hyper adrenaline mode for level/2 rounds. While in hyper adrenaline mode you gain a morale bonus bonus to all attack, damage, saves, and skills equal to half your base will save bonus, you gain DR -/ equal to your base will save bonus, and immediately and then again at the start of each of your turns you make a will save and gain temporary hit points equal to the result. These stack, but end when hyper adrenaline mode ends. You also take 4 constitution damage from losing the limb, as well as the following penalties depending on the limb lost:
          \nArm: -10 on climb, craft, disable device, -8 grapple.
          \nLeg: -10 acrobatics, climb, stealth, cannot run or charge, cannot bullrush or overrun and a -8 to CMD. Your speed is reduced to 5 feet. On second leg lost, your movement is reduced to 0 feet.
          \nHead: You die and can no longer be brought back to life with breath of life or raise dead, requiring resurrection or greater.
          \nYou also cannot do anything that would require that limb to do (such as making attacks) 
          \n\nOnce a limb is lost from this maneuver it becomes unusable until the end of the floor.
          \n\nThis maneuver can instead be initiated as a free action (that you can take even when not your turn) in response to damage that would kill you or cause you to start dying. If you do, it not only reduces the damage of that attack to 0, but also any other damage for the rest of the turn to 0, and it costs no spell points. However, if you do, the limbs you sacrifice become completely destroyed, the constitution damage becomes drain, and the limb is lost permanently until you are healed by a spell like regeneration or heal. You cannot heal the drain until your limb is re-attached, nor can the drain be reduced or resisted.`,
          initiationAction: `immediate`,
          range: `personal`,
          duration: `permanent`,
          target: `you`,
          },
          {
            school: `indomitableWill`,
            level: 3,
            name: "Fight or Die",
            type: "Counter",
            longDesc: `When you or an ally within 60 feet are about to be reduced below 0 hit points and knocked unconcious or killed, you can initiate this counter, allowing the ally to make a single attack against the enemy that reduced them below 0 hit points, which deals damage as normal, plus an amount equal to the amount below 0 they were reduced to. They gain temporary hit points equal to the damage dealt for 1 round.`,
            initiationAction: `immediate`,
            range: `60 feet`,
            duration: `1 round`,
            target: `ally`,
            },
          {
          school: `indomitableWill`,
          level: 4,
          name: "Break the Chains",
          type: "Counter",
          longDesc: `You can initiate this counter when you are about to be affected by any condition that restricts your ability to take actions or move freely, whether physical or magical, as long as it is not from affecting your mind. You negate that condition. This counter does not remove any additional effects tied to the condition unless they also fall within the scope of valid targets for this ability. This usually includes things like grappled, paralyzed, entangled, slowed, staggered, nauseated, or chained up, but not conditions such as confused, fear, dominated, or charmed. After you negate the status, make a will save and gain temporary hit points equal to the result (last level/2 rounds), you then gain an immediate movement action that you can use to move, draw an item/weapon, or use an ability that directly harms the source of the status you just took. 
          \nAdditionally, on your turn, you may activate this counter to simultaneously end all applicable conditions, though you do not gain the movement action to take actions. You are able to initiate this counter even if a condition that is a is restricting your use of your swift action, as long as that condition is something that this counter can end. This counter does not work on conditions such as dying or dead.`,
          initiationAction: `immediate`,
          range: `personal`,
          duration: `instantaneous`,
          target: `you`,
          },
          {
            school: `indomitableWill`,
            level: 4,
            name: "The Lion",
            type: "Boost",
            longDesc: `Move up to half your movement speed in a straight line, and then make an opposing will save against a creature within 60 feet of you, if you win, they lose all morale bonuses for 1 round plus 1 round per 4 that you beat them by, and cannot gain any additional morale bonuses during the time. If they win, you lose all temporary hit points gained from maneuvers and lose all morale bonuses for 2 rounds, plus 1 round per 2 they beat you by.`,
            initiationAction: `movement`,
            range: `60 feet`,
            duration: `1 round`,
            target: `1 enemy`,
          },
          {
            school: `indomitableWill`,
            level:8,
            name: "The Destroyer",
            type: "Boost",
            longDesc: `Move up to half your movement speed in a straight line, and then make an opposing will save against all enemies within 60 feet of you, if you win, they lose all morale bonuses for 1 round, plus 1 round per 4 you beat them by, cannot gain any additional morale bonuses during the time, and they suffer -2 penalties on saves against your abilities. For every creature that beats your will save, you lose all morale bonuses for 1 round (stacks), plus 1 round for every 4 they beat you by.`,
            initiationAction: `movement`,
            range: `60 feet`,
            duration: `1 round`,
            target: `enemies`,
          },
          {
          school: `indomitableWill`,
          level: 4,
          name: "I'm Just Getting Started",
          type: "Boost",
          longDesc: `Make a will save, you gain temporary hit points equal to the result of the save for initiation modifier rounds. If below 25% hit points when you initiate this, the temporary hit points are increased by 25%, though these additional temporary hit points are lost in 1 round. If you activate then when at or below 0 hit points, the temporary hit points are increased by 50%, and are lost within 1 round the same way.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `initiation modifier rounds`,
          target: `you`,
          },
          {
          school: `indomitableWill`,
          level: 4,
          name: "Victory At Any Cost",
          type: "Strike",
          longDesc: `You disregard all defenses and focus purely on the offense, preparing for the perfect attack. You open yourself up for attacks, provoking an attack of opportunity from all enemies that threaten you, then you rush in on your target using the opening created. If your attack is successful, it deals double the normal damage and the target must make a fortitude save or be stunned for 1 round. For each attack of opportunity taken against you for this maneuver, your attack gains a +2 bonus, has its damage multiplier increased by 1, and the stun's DC increases by +2.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `see text;`,
          target: `1 creature`,
          },
          {
          school: `indomitableWill`,
          level: 4,
          name: "Stay Away From Family",
          type: "Counter",
          longDesc: `You make this counter in response to an ally within your movement speed being successfully hit by a melee attack. You can move up to your movement speed so long as you end your movement adjacent to the ally. The attack is redirected to you, and automatically hitting you. Afterwards, if the enemy is within your melee reach, you can make a melee attack against them, and then either a bull rush or trip, neither of which provoke.`,
          initiationAction: `immediate`,
          range: `-`,
          duration: `instantaneous`,
          target: `1 ally`,
          },
          {
          school: `indomitableWill`,
          level: 4,
          name: "Once More Unto The Breach",
          type: "Boost",
          longDesc: `If Swift: You may move up to your movement speed, this provokes as normal. You gain damage reduction /- and resistance to all elements equal to half your base will save for 1 round.
          \nIf Movement: You may move up to your movement speed, you gain a bonus to your armor class during this movement and against the next attack against you after initiating this maneuver equal to your half your base will save. You reduce the damage you take by an amount equal to half your base will save for 1 round.`,
          initiationAction: `swift or movement`,
          range: `personal`,
          duration: `1 round`,
          target: `you`,
          },
          {
          school: `indomitableWill`,
          level: 4,
          name: "Force of Will",
          type: "Counter",
          longDesc: `Make a will save in place of a different saving throw. If you succeed and the effect would have a reduced effect even on success, you delay the onset of any statuses, penalties, or damage for 1 round. If it would have lingering effects that may affect you later, such as web that creates difficult terrain, you completely ignore it for 1 round.`,
          initiationAction: `immediate`,
          range: `personal`,
          duration: `instantaneous`,
          target: `you`,
          },
          {
          school: `indomitableWill`,
          level: 4,
          name: "Let's See You Grit Those Teeth ",
          type: "Strike",
          longDesc: `When an ally is failing to weakness, you are there to remind them who to believe in, and who believes in them. Move up to twice your movement speed and make a melee attack against an ally, gaining a bonus equal to your base will save. If it hits and deals damage and if they are suffering from any status that is restricting their ability to take actions or having their actions controlled, including possession or fear, they can make a new save against the effect, but they can use half the damage you rolled as their bonus to their saving throw in place of their normal bonus. If this new save succeeds and the effect is remove, they make another will saving throw using their normal bonus and get temporary hit points equal to the result. These last until combat ends, and stack with themselves.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 ally`,
          },
          {
          school: `indomitableWill`,
          level: 4,
          name: "Break Upon My Body",
          type: "Counter",
          longDesc: `When a creature strikes you with a weapon or natural attack, you can make a will save in response. You reduce the damage you take from the attack by your will save. If the attack was with a natural or unarmed attack, they take damage equal to the result of the save. If it was a melee weapon, the weapon takes damage equal to the result of the save. This bypasses hardness equal to your base will save.`,
          initiationAction: `immediate`,
          range: `personal`,
          duration: `instantaneous`,
          target: `you`,
          },
          {
          school: `indomitableWill`,
          level: 5,
          name: "Heart of Courage",
          type: "Stance",
          longDesc: `Gain a +4 bonus on all saving throws, doubled against fear. Whenever you succeed on a saving throw against an enemy ability or win an opposed will saving throw you gain temporary hit points equal to whichever ability score you use to determine your will saving throw bonus (only one ability score if you use multiple). These temporary hit points last until the end of the encounter plus 3 rounds, and stack with themselves. When you gain a morale bonus, or give a morale bonus to an ally through a maneuver, you increase the bonus by +1. At level 14 and 19, the increase to morale bonuses increases by +1.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
          school: `indomitableWill`,
          level: 5,
          name: "I Could Do This All Day",
          type: "Boost",
          longDesc: `Any temporary hit points you currently have are removed and you heal hit points equal to half the amount removed.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `instantaneous`,
          target: `you`,
          },
          {
          school: `indomitableWill`,
          level: 5,
          name: "Dominating Glare",
          type: "Counter",
          longDesc: `When a creature you can see, and can see you declares an attack against you, you make an opposed will saving throw against them, if they win, the attack automatically hits you and deals 5% extra damage for every point they beat you by. If you win, the attack automatically misses, they cannot directly attack you again for 1 round, and they become shaken for 1 round, plus 1 round every 2 you beat them by. The shaken is a [mind-affecting][fear] effect.`,
          initiationAction: `immediate`,
          range: `sight`,
          duration: `see text;`,
          target: `1 enemy`,
          },
          {
          school: `indomitableWill`,
          level: 5,
          name: "I'll Stake My Life On It",
          type: "Strike",
          longDesc: `You lose all current temporary hit points, then make a melee attack, it deals additional damage equal to the temporary hit points lost.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 creature`,
          },
          {
          school: `indomitableWill`,
          level: 6,
          name: "Relentless",
          type: "Counter",
          longDesc: `When you are about to subject to a hostile effect or condition that restricts your ability to move freely or take actions (grappled, paralyzed, staggered), or one that seizes control of your actions (frightened, charmed, dominated), you can initiate this counter to negate that condition. This counter does not remove any additional effects tied to the condition unless they also fall within the scope of valid conditions for this ability.
          \nAfter you negate the status, make a will save and gain temporary hit points equal to the result (last level/2 rounds).
          \nAdditionally, on your turn, you may activate this counter to simultaneously end all applicable conditions. You are able to initiate this counter even if a condition that is a is restricting your use of your swift action, as long as that condition is something that this counter can end. This counter does not work on conditions such as dying or dead, but does allow you to stand up from prone without provoking attacks of opportunity. After you negate the status, make a will save and gain temporary hit points equal to the result (last level/2 rounds)`,
          initiationAction: `immediate`,
          range: `personal`,
          duration: `instantaneous`,
          target: `you`,
          },
          {
          school: `indomitableWill`,
          level: 7,
          name: "By Any Means Necessary",
          type: "Strike",
          longDesc: `Your pure aura of dedication is terrifying to your opponents. As a full-round action, move up to twice your movement speed. This movement is so fast that it is impossible to even see you as you move. Once you stop moving, all enemies within 30 feet of where you arrive that can see you must make a will save or be paralyzed with fear for 1d4 rounds. If your movement ends with you threatening a enemy that can see you, that enemy instead makes an opposed will save to you, and if they fail, they are paralyzed for an additional 1d4 rounds. If you use this strike on an unaware opponent, the DC increases by +4. [fear][mind-affecting]. Once a creature has been targeted by this maneuver, they are immune to further uses of it.`,
          initiationAction: `full-round`,
          range: `30 feet`,
          duration: `1d4 rounds`,
          target: `enemies`,
          },
          {
          school: `indomitableWill`,
          level: 5,
          name: "Battle of Wills",
          type: "Counter",
          longDesc: `When you make a successful will saving throw against a mind-affecting affect, you can cause the creature who forced you to make the will save or become stunned for 1 round. The DC of the will save is equal to the result of the will save you made.`,
          initiationAction: `immediate`,
          range: `60 feet`,
          duration: `1 round`,
          target: `1 enemy`,
          },
          {
          school: `indomitableWill`,
          level: 6,
          name: "You Will Feel Fear",
          type: "Stance",
          longDesc: `You strike fear, even into those who have never felt fear before. Creatures within 30 feet can be affected by your fear effects even if they are normally immune to fear (even if the ability as has the mind-affecting tag). Creatures that are normally immune to mind-affecting effects can still be affected as well, although they gain a +5 bonus on saves against such effects. Your fear effects gain a bonus to their DCs equal to 1/2 your base will save (or as a bonus on their checks/opposed checks).`,
          gameDesc: `You strike fear, even into those who have never felt fear before. Creatures within 30 feet can be affected by your fear effects even if they are normally immune to fear (even if the ability as has the mind-affecting tag). Creatures that are normally immune to mind-affecting effects can still be affected as well, although they gain a +5 bonus on saves against such effects. Your fear effects gain a bonus to their DCs equal to your base will save (or as a bonus on their checks/opposed checks).`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
          school: `indomitableWill`,
          level: 6,
          name: "No, That's Your Limitation!",
          type: "Boost",
          longDesc: `You automatically succeed any saving throws for 1 round. When making an opposed will saving throw you gain a bonus on it equal to 1/2 your base will saving throw.`,
          gameDesc:`You automatically succeed all saving throws for 1 round. When making an opposed will saving throw you gain a bonus on it equal to your base will saving throw.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `1 round`,
          target: `you`,
          },
          {
          school: `indomitableWill`,
          level: 6,
          name: "Who the Hell Do You Think I Am?",
          type: "Boost",
          longDesc: `You can choose to either gain a morale bonus to damage rolls equal to 1/2 your will save bonus, or a morale bonus equal to 1/4 your base will save on attack rolls. Either way, your attacks also bypass all DR. Both of these bonuses last 1 round.`,
          gameDesc: `You can choose to either gain a morale bonus to damage rolls equal to 1/2 your will save bonus, or a morale bonus equal to 1/2 your base will save on attack rolls. Either way, your attacks also bypass all DR. Both of these bonuses last 1 round.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `1 round`,
          target: `you`,
          },
          {
          school: `indomitableWill`,
          level: 8,
          name: "The Planet Will Break Before Me",
          type: "Boost",
          longDesc: `You cannot be reduced below 0 hit points for 1 round. This does not stop you from dying from other conditions that kill you outright, such as your constitution reaching 0 or death effects. If you are already below 0 hit points, you just cannot be reduced any lower. If you heal hit points from a creature other than yourself, this ends. If the planet explodes, this maneuver ends immediately.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `1 round`,
          target: `you`,
          },
          {
          school: `indomitableWill`,
          level: 6,
          name: "That May Be, But I Still Believe",
          type: "Strike",
          longDesc: `Make a melee attack, for every 10% of your hp you're missing, and for every 5% higher the creatures hit point percentage is than yours, you gain +0.5 (rounded down) attack and 1d6 damage. (If you had 69% hit points, and it had 95%, you'd gain +4 attack and +8d6 damage)`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 creature`,
          },
          {
          school: `indomitableWill`,
          level: 6,
          name: "Just You and Me",
          type: "Strike",
          longDesc: `You make a melee attack against an enemy, then they make a melee attack against you. You can choose to make an additional attack, then they can make an additional attack. You can continue to do this for attacks equal to your initiation modifier. Each attack is made at the highest bonus, with a stacking -2 penalty for each following attack.`,
          initiationAction: `full-round`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 enemy`,
          },
          {
          school: `indomitableWill`,
          level: 6,
          name: "Hold Fast My Friends",
          type: "Counter",
          longDesc: `You initiate this counter when any allies are making a saving throw. All allies in the area can use your saving throw bonus on saving throws for their next saving throw.`,
          initiationAction: `immediate`,
          range: `60 feet`,
          duration: `instantaneous`,
          target: `allies`,
          },
          {
            school: `indomitableWill`,
            level: 2,
            name: "A Heart Made Fullmetal",
            type: "Counter",
            longDesc: `As long as you have this boost readied, every time you fail a saving throw you gain 1 fullmetal stack. You initiate this counter when you are rolling a saving throw from a hostile effect, you gain a bonus on that roll equal to your fullmetal stacks. If you succeed, you reduce your fullmetal stacks by half, if fail you increase them by 2. Fullmetal stacks last through floors. Once you succeed on a save for a creature's specific ability it no longer grants stacks, even if you fail later on. The exception is if it requires multiple saves to remove the effect, then it can no longer grant stacks once the required amount of saves are made.`,
            initiationAction: `immediate`,
            range: `personal`,
            duration: `instantaneous`,
            target: `you`,
            stacksOne: 0,
            stacksOneName: 'Fullmetal Stacks',
          },
          {
            school: `indomitableWill`,
            level: 8,
            name: "Libera Me",
            type: "Boost",
            longDesc: `You blaze across the battlefield to allies in need. When you initiate this boost you can move adjacent to an ally within twice your movement speed. You can reduce the movement by half to move upwards (if you cannot fly) or also crash through any physical obstacle in your way, using a will save for break DC's. If you arrive next to the target, you can pick them up from prone instantly, and then all allies within 50 feet of you (excluding you) may reroll a save against a single ongoing effect that is restricting their ability to take actions using their will save in place of any other saving throw. Failure on this save never confers penalties. The ally you moved adjacent to can choose to either use your will save on their reroll or get a +6 morale bonus on their save. When allies are making their new saves, you and any ally in the area of the boost who is not making a save can expend additional <heroic> boosts to grant a morale bonus equal to the level of the boost to a single allies reroll. Multiple boosts expended at once can be used to increase the morale bonus already given by this maneuver to a creature or to grant a different creature a new bonus. You must all expend your maneuvers before the rolls are made. Any ally who uses this bonus and succeeds on a new saving throw may immediately stand up without provoking and gains temporary hit points equal to what they rolled on the new save.`,
            initiationAction: `movement`,
            range: `50ft`,
            duration: `instantaneous`,
            target: `allies`,
          },
          {
            school: `indomitableWill`,
            level: 6,
            name: "It's a Dream That Lives In All of Us",
            type: "Boost",
            longDesc: `When you initiate this boost, you create a 10ft-10ft-10ft box, the box must be created so that it encompasses you. The box lasts for rounds equal to your initiation modifier. Allies within the area gain a +1 bonus to armor class and saves for every other ally also within the box, but is reduced by every non-helpless enemy within the area. If an ally starts their turn within the area they gain a 4d6 temporary hit points that last as long as they stay within the area (doesn't stack with itself). If there are more non-helpless enemies within the area than non-helpless allies, the maneuver ends immediately, including any expansions to it. You can have multiple boxes created at once, but they must all touch each other. The bonus to saves and temporary hit points increase by 1 and 2d6 respectively for each expansion. The duration of these expansions becomes the duration of the original activation, but once you activate an expansion, the duration of all connected boxes increases by 2 rounds.`,
            initiationAction: `movement`,
            range: `0ft`,
            duration: `initiation modifier rounds`,
            target: ``,
          },
          {
            school: `indomitableWill`,
            level: 4,
            name: "Carve a Way",
            type: "Strike",
            longDesc: `Move up to twice your movement speed and make a melee attack against an enemy. You must provoke attacks of opportunity from this movement. You carve a path through all of the squares you moved through, and for 1 round those tiles do not count as difficult terrain and allies do not provoke attacks of opportunity for moving through them or for the square moving into or out of it. If your attack at the end hits, it deals an additional 6d6 damage and for 1 round the creature takes a -4 penalty to armor class against you and any ally that had moved into and out of the area on its turn.`,
            initiationAction: `full-round`,
            range: `melee attack`,
            duration: `1 round`,
            target: `1 enemy`,
          },          
          {
          school: `indomitableWill`,
          level: 7,
          name: "My Soldiers Do Not Yield",
          type: "Stance",
          longDesc: `Allies within 30 feet of you get the benefits of the diehard feat. At the start of each of your turns, you make a will save. All allies (excluding you) within the area gain temporary hit points equal to half the result of the save for 1 round. If the ally is below 0 hit points, the temporary hit points are doubled. If the temporary hit points return them to consciousness, they can stand up as a free action they can take even when not their turn and it does not provoke. If an ally is killed within the area, they can grant another ally they know the existence of a +4 morale bonus on attack rolls and a +8 morale bonus on damage rolls against the creature that killed them. These last until the ally is brought back to life, even if this stance ends, as long as you didn't end it willingly, and return to as soon as able. Multiple allies can grant this bonus to the same ally, its benefits stack.`,
          initiationAction: `swift`,
          range: `30 feet`,
          duration: `stance`,
          target: `allies`,
          },
          {
          school: `indomitableWill`,
          level: 7,
          name: "Unbreakable",
          type: "Stance",
          longDesc: `When you take damage from an enemy, you can choose to either delay its onset for 1 round or to convert half of it to nonlethal damage. If you are immune to non-lethal damage, instead of converting it to non-lethal damage you reduce all damage you take by 25%. You never fall prone or drop your weapons when unconscious.
          \nOnce per round you can expend a <heroic> maneuver to grant yourself 1d6 temporary hit points per level of the maneuver. These last as long as you remain in this stance and stack with each other, however a maneuver cannot be recovered until the temporary hit points it granted from this ability are lost.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
          school: `indomitableWill`,
          level: 7,
          name: "I Didn't Hear No Bell",
          type: "Boost",
          longDesc: `Gain temporary hit points equal to your missing hit points for 1d4+1 rounds. These are lost if you are healed by an ally (other than yourself). If you have temporary hit points, these are included for the calculation on how many hit points you currently have.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `1d4+1 rounds`,
          target: `you`,
          },
          {
            school: `indomitableWill`,
            level: 7,
            name: "Save the World",
            type: "Boost",
            longDesc: `You dedicate yourself to saving the world. For 3 rounds:
            \nThe amount of negative hit points you can go to before you would die is increased to constitution score x2 + wisdom score x2\nYou cannot die\nYou are immune to any effect/status/condition that restricts or controls your ability to take actions of your own accord. (only negates the status, not additional effects, this includes dying)
            \nWhen this boost ends, you suffer 1 wisdom drain, and if at any point you would have died, you die and you cannot be revived for 6 rounds. If you would have been subject to a status that would have limited your actions, you suffer their effects now, treating their onset as having been delayed (unless irrelevant now, such as failing a save against a web you are no longer within the area of).`,
            initiationAction: `standard`,
            range: `personal`,
            duration: `3 rounds`,
            target: `you`,
          },
          {
          school: `indomitableWill`,
          level: 5,
          name: "Let's Go Then",
          type: "Strike",
          longDesc: `Make a full-round attack against an opponent with melee weapons, with each successful attack you deal damage as normal and can make a bull rush as a free action that doesn't provoke. You can move with each bull rush, ignoring your usual maximum movement speed.`,
          initiationAction: `full-round`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 enemy`,
          },
          {
          school: `indomitableWill`,
          level: 6,
          name: "Once More Dear Friends, Once More",
          type: "Boost",
          longDesc: `You and all allies within 15 feet of you may move up to their movement speeds, this provokes as normal and all of your allies must end their movement with at least 15 feet of you. All of you gain damage reduction /- equal to 1/2 their base will save for 1 round.`,
          gameDesc:`You and all allies within 15 feet of you may move up to their movement speeds, this provokes as normal and all of your allies must end their movement with at least 15 feet of you. All of you gain damage reduction /- equal to their base will save for 1 round.`,
          initiationAction: `swift`,
          range: `15 feet`,
          duration: `instantaneous`,
          target: `allies`,
          },
          {
          school: `indomitableWill`,
          level: 7,
          name: "Blaze of Glory",
          type: "Counter",
          longDesc: `When you are killed, you can make a full-round attack against the creature that killed you, each attack suffering a -4 penalty to attack and -8 to damage. If the creature that killed you is out of your reach, you can sacrifice one of your attacks to move up to your movement speed. You can sacrifice multiple attacks to keep moving. All attacks bypass DR. If you kill the creature, you suffer 1 permanent negative level, but instead of dying, you are reduced to hit points 1 away from where you would die.`,
          initiationAction: `immediate`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 creature`,
          },
          {
          school: `indomitableWill`,
          level: 7,
          name: "The Dreams of Those Who Have Fallen",
          type: "Strike",
          longDesc: `Make a melee attack, it deals 10d6 bonus damage for each ally that is currently unconscious. All allies currently unconscious gain temporary hit points equal to the result of the bonus damage of this attack for level/4 rounds. If an ally is dead, the damage is increased to 15d6 and the temporary hit points last twice as long. These temporary hit points do not stack with themselves.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 creature`,
          },
          {
          school: `indomitableWill`,
          level: 8,
          name: "A Heart Ablaze",
          type: "Stance",
          longDesc: `Desperate situations light a fire in your soul, pushing you to rise to heights even greater. 
          \n•	When you are outnumbered: For every creature you are outnumbered by, you gain a +2 bonus on damage rolls, up to a max of initiation modifier more creature. Creatures with less than half your HD do not count towards this.
          \n•	When you are up against unbeatable odds: When attacking a creature whose CR is greater than your HD, you gain a bonus to attack equal to half the difference and bonus to your damage rolls equal to the whole difference. You lose the bonus to attack for 1 round once you hit the creature.
          \n•	When your own failures are stacking up: When you miss an attack your next attack gains a +5 bonus. If you fail to confirm a critical hit, your next potential critical automatically confirms.
          \n•	When your allies are faltering by your side: When an ally falls unconscious you gain an immediate standard action. When an ally dies you gain a full-round action. An ally can only provide each of these once per floor. If they kill themselves it doesn't count.
          \n•	When you are being pushed past your limits: When you would die or fall unconscious, you delay the onset of that effect for 1 round. If you are brought to a hit point total where you would no longer be dead or unconscious, the status is negated.
          \n•	When the your body is about to falter: For each negative status or penalty you are suffering from because of an enemy ability, you gain a +1 bonus on attack rolls and saves, and +2 to damage.
          \n•	When even the bravest would lose hope: When more than 4 of these conditions are active at once, all of your attacks gain a bonus on their damage rolls equal to half your base will save bonus.
          \n•	When there is nothing left but your sheer force of will: When 6 of these conditions are active at once, your movement speed is doubled, you are not hindered by difficult terrain, you reduce any damage you take by an amount equal to a will saving throw -10 (rolled for each instance of damage).`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
          school: `indomitableWill`,
          level: 8,
          name: "Behold.",
          type: "Boost",
          longDesc: `Move half your movement speed and then make an opposed will save against all enemies within 60 feet. If any creature succeeds, you are shaken for 3 rounds + 1 round per creature affected. If all of them fail, they are all paralyzed by fear for 1 round. A creature who succeeds their save against this is immune to it for 24 hours [fear][mind-affecting]. Creatures immune to fear or mind-affecting effects can still be affected by this, they are just instead shaken for 1d4 rounds.`,
          initiationAction: `movement`,
          range: `60 feet`,
          duration: `1 round`,
          target: `enemies`,
          },
          {
          school: `indomitableWill`,
          level: 8,
          name: "Twelve Labors",
          type: "Boost",
          longDesc: `You can initiate this boost when you are dead during the point in initiative you would have otherwise acted one round after you have died (even though you cannot normally take a standard action). You are restored to life as the resurrection spell. When you are restored to life, you do so standing up. You can only initiate this boost 5 times before you can never initiate it again.`,
          initiationAction: `standard`,
          range: `personal`,
          duration: `instantaneous`,
          target: `you`,
          },
          {
          school: `indomitableWill`,
          level: 8,
          name: "The Hopes of Those Who Will Follow",
          type: "Strike",
          longDesc: `Make a melee attack against a target, if it is successful, the attack deals damage as normal and the target takes a penalty on its armor class equal to 1/2 your base will save and all allies deal an additional 5d6 bonus damage on attacks against the target for 1 round.`,
          initiationAction: `full-round`,
          range: `melee attack`,
          duration: `1 round`,
          target: `1 creature`,
          },
          {
          school: `indomitableWill`,
          level: 9,
          name: "Crimson Face",
          type: "Strike",
          longDesc: `Your will knows no limits, not even from the overwhelming force of the gods. You break through all boundaries and protections, and bring even the mightiest back down to the realm of mortals. It is completely unstoppable, always hits, cannot be reduced, negated, deflected, or redirected in any way, and in fact the more unfair nonsense there is to the opponent's defenses, the more unrealistic and absurd the attack becomes to avoid and bypass it, even bypassing abilities that let you counter anything and that let you counter un-counterable things. The only one who truly knows what happened during this attack is the man who was driven to the point of being forced to use it.
          \nYou make a melee unarmed attack against anything you know the existence of (max 100ft. + 10ft./level) or can see (no max range). This attack bypasses critical immunity or fortification. When your attack connects, you make opposing will saves, for each point you beat their save by, you gain a point you can spend on bonuses for the attack. These are chosen after the attack and will save are made. You can select a bonus multiple times for the bonus listed in the ( ):
          \n1: Deal an additional 10d6 damage (+5d6)\n1: Target is knocked prone (target cannot stand up from prone for +1 round)\n2: Target is staggered for 1 round (+1 round)\n2: Target falls 30 feet (+30 feet) (can move 30 feet in any direction as it falls)\n2: Flat +2 to critical threat range\n4: Target is dazed for 1 round, ignores immunity (+1 round)\n4: Increase critical damage multiplier by +1. 
          \nAfter you finish this attack, you end your movement(?) within your melee reach of the target. If you fail the opposed will save against the creature, you cannot use this strike against them again.
          \nAs long as you are not dead, you can always initiate and finish this strike. No condition can ever stop it. Once the strike is complete, the condition returns. 
          \nYou suffer a permanent -1 to will saves every time you initiate this strike.`,
          initiationAction: `full-round`,
          range: `see text;`,
          duration: `see text;`,
          target: `1 creature`,
          },
          {
          school: `indomitableWill`,
          level: 9,
          name: "I Am the One Who Decides",
          type: "Counter",
          longDesc: `This counter is activated in response to a creature using an ability to negate an action or ability of yours, or when an ability of yours is going to be reduced or negated because of a passive immunity (such as evasion, fortification, or immunity to mind-affecting effects). If it is an active ability, that active ability fails. If it is a passive ability, that passive ability does not function against you for 1 round. If you are activating this in response to an ability a creature is using to negate or restrict an action or ability of yours, activating this counter can be done as a free action you can take even when not your turn. Since it will probably come up, this counter cannot be used to stop (or allow another ability to stop) the Crimson Face strike.`,
          initiationAction: `immediate`,
          range: `-`,
          duration: `instantaneous`,
          target: `1 creature`,
          },
          // {
          // school: `indomitableWill`,
          // level: 9,
          // name: "Immortal Hero",
          // type: "Stance",
          // longDesc: `You gain immunity to death effects and effects which would kill you without reducing you to 0 hit points. You also become immortal, unable to die from old age, and immune to magical aging. You lose any penalties from age, but continue to gain benefits. If you are killed, your corpse becomes completely invulnerable, unaffected by things like disintegration or dismemberment.`,
          // initiationAction: `swift`,
          // range: `personal`,
          // duration: `stance`,
          // target: `you`,
          // },
          {
          school: `crimsonReaper`,
          level: 1,
          name: "Reaper's Thirsting",
          type: "Stance",
          longDesc: `Your melee attacks deal an additional 1d6 points of siphon damage. You heal for this bonus amount done. Every 6 levels the damage increases by 1d6.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
          school: `crimsonReaper`,
          level: 1,
          name: "Crimson Aegis",
          type: "Stance",
          longDesc: `Every time you take more than your HDx3 damage from a single attack you gain a +1 racial bonus to your natural armor. This stacks up to your initiation modifier and lasts until you leave combat, plus constitution modifier rounds after. If you leave this stance, the natural armor bonus remains, but reduces at the start of each of your turns by 1. At level 8 you also gain level/2 temporary hit points whenever this activates. At level 16 its level temporary hit points. Damage taken from temporary hit points do not count for determining damage taken for this stance.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
          school: `crimsonReaper`,
          level: 1,
          name: "Inhuman Form",
          type: "Stance",
          longDesc: `Gain DR level/2 piercing or slashing (your choice when you adopt the stance), and a +2 bonus to fortitude saves, which increases by +1 every 5 levels. At level 8 you gain 10% fortification, which increases at level 16 to 25% fortification. This fortification stacks with other fortification. At level 10 you also become immune to bleed effects unless you choose to accept them.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
          school: `crimsonReaper`,
          level: 1,
          name: "Red Thirst",
          type: "Strike",
          longDesc: `Make a melee attack, you gain temporary hit points equal to the damage of the attack. These temporary hit points last until the end of the floor. This doesn't apply to damage that would already heal or grant you temporary hit points. This only works on creatures susceptible to siphon damage.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 living creature`,
          },
          {
          school: `crimsonReaper`,
          level: 1,
          name: "Draw Blood",
          type: "Strike",
          longDesc: `Make a melee attack, if successful the creature takes 1d6 points of bleed damage. Every 9 levels, the bleed damage increases by 1d6. \n1 blood point: increase the bleed damage by 1d6.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 living creature`,
          },
          {
          school: `crimsonReaper`,
          level: 1,
          name: "Chi Strike",
          type: "Strike",
          longDesc: `When initiating this strike you take 2d6 points of damage, then you can make a melee attack, it deals an additional 3d6 siphon damage. Every odd level after first the self damage taken increases by 1d6 and the bonus damage dealt increases by 2d6. Creatures immune to siphon damage still take half.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 living creature`,
          },
          {
          school: `crimsonReaper`,
          level: 1,
          name: "Chains of Pain",
          type: "Counter",
          longDesc: `When you take damage from an enemy, you can attempt to redirect the damage to a creature within 30 feet of you. They must make a fortitude save, on failure, the damage you take is reduced by half, and that amount is transfered to them as siphon damage.`,
          initiationAction: `immediate`,
          range: `30 feet`,
          duration: `instantaneous`,
          target: `1 living creature`,
          },
          {
          school: `crimsonReaper`,
          level: 1,
          name: "Blood Rush",
          type: "Boost",
          longDesc: `Move 10 feet. This movement provokes as normal. Then you can choose to gain a permanent or temporary blood point: 
          \nPermanent: Reduce your maximum hit points by 1d3 per odd level. This reduces your current hit points only if your new maximum hit points would be less than your current hit points. Gain a blood point. 
          \nTemporary: Reduce your current hit points by 1d6 per odd level and gain a temporary blood point for level/3 rounds (minimum 1). This boost can only be initiated in combat.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `instantaneous`,
          target: `you`,
          },
          {
          school: `crimsonReaper`,
          level: 2,
          name: "Exsanguinating Strike",
          type: "Strike",
          longDesc: `Make a melee attack, you heal hit points equal to half the damage dealt. This doesn't apply to damage that would already heal or grant you temporary hit points. This only works on creatures not immune to siphon damage`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 creature`,
          },          
          {
          school: `crimsonReaper`,
          level: 2,
          name: "Viscera Slash",
          type: "Strike",
          longDesc: `Make an attack, if it hits, you use the gore created from the attack to launch at another enemy within close range of the original target. Make a ranged attack at another creature behind the original (you must be able to draw a straight line through you and both other creatures), you can use either your dexterity or initiation modifier to determine your attack modifier. If it hits, the new target takes the same amount of damage dealt by the original attack. This counts as magical piercing and slashing damage, and the new gains its damage reduction and resistances again. If this attack hits, you can continue the process as long as you can draw a line through all targets, dealing the damage the previous target took to another new target, though you take a -4 to the attack for each following target. Max total range for all targets is close range.`,
          initiationAction: `standard`,
          range: `close (25ft. + 5ft./2 levels)`,
          duration: `instantaneous`,
          target: `1 living creature`,
          },
          {
            school: `crimsonReaper`,
            level: 4,
            name: "Till the Fields",
            type: "Strike",
            longDesc: `You can choose to make this attack in 1 of three shapes, a 20 foot cone, a 40 foot line, or 180 degrees on one of your sides out to an area of twice your reach (includes squares partially encompassed by that area). Whichever you choose, you make a melee attack that deals an additional 2d6 damage, applying the attack roll to every creature in the area, though they may make a reflex save to reduce the damage by half. On a natural 1 on the save, the attack deals critical damage to that creature (stacks if the attack roll was also a natural 20).`,
            initiationAction: `standard`,
            range: `see text;`,
            duration: `instantaneous`,
          },
          {
            school: `crimsonReaper`,
            level: 2,
            name: "Soulvore's Curse",
            type: "Strike",
            longDesc: `Make a melee attack, if successful it deals damage as normal and the target must make a fortitude save or takes a 1d6 penalty to a physical ability score of your choice for initiation modifier rounds. You gain the amount they lost as a racial bonus for the duration.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `1d6 rounds`,
            target: `1 living creature`,
          },
          {
          school: `crimsonReaper`,
          level: 2,
          name: "Blood Barrier",
          type: "Counter",
          longDesc: `You initiate this counter after you have taken damage, and can do so even if the attack against you was a natural 20. Gain temporary hit points equal to twice the damage taken. These temporary hit points last initiation modifier rounds and are always lost first (even before other temporary hit points). As long as these they remain you gain a +4 cover bonus to your armor class and a +2 cover bonus to your reflex saves. This does not stop you from provoking attacks of opportunity.`,
          initiationAction: `immediate`,
          range: `personal`,
          duration: `initiation modifier rounds`,
          target: `you`,
          },
          {
          school: `crimsonReaper`,
          level: 2,
          name: "Death Feast",
          type: "Counter",
          longDesc: `When a creature dies or is reduced below 0 hit points within 30 feet of you, you can activate this counter heal 2d6 + initiation modifier hit points and gain 2d6 + initiation modifier temporary hit points that lasts for 1 round, plus 1 round per 4 levels. Additionally, you can choose to either deal 2d6 + initiation modifier damage to them, or gain a temporary blood point that lasts 1 round, plus 1 round per 4 levels.`,
          initiationAction: `immediate`,
          range: `30 feet`,
          duration: `1 round +1 round/4 levels`,
          target: `1 living creature`,
          },
          {
            school: `crimsonReaper`,
            level: 4,
            name: "Rupture",
            type: "Strike",
            longDesc: `You make a strike, twisting and rupturing vital veins all across the creature's body. Make a melee attack, if it hits, it deals damage as normal plus 2d6 siphon damage, and the creature's vital functions are disrupted. Whenever the creature moves with any movement type except for magical flight, it takes 1d8 points of damage for every 5 feet moved. This damage bypasses damage reduction. This lasts initiation modifier rounds, however a successful fortitude save reduces its duration to 1 round. Creatures immune to bleed are immune to this damage. This effect can also be ended by powerful healing effects like regeneration and heal.`,
            initiationAction: `Standard`,
            range: `melee attack`,
            duration: `initiation modifier rounds`,
            target: `1 living creature`,
          },
          {
          school: `crimsonReaper`,
          level: 3,
          name: "Crimson Reaper Stance",
          type: "Stance",
          longDesc: `When you take or deal damage with an attack you gain a thirst stack, the maximum amount of stacks is equal to your initiation modifier or constitution modifier, whichever is higher. As a free action that you can take even when not your turn, but must be declared before you make the attack roll, you can unleash these stacks. When you do so, you immediately take 1d6 points of damage per stack (this does not grant a stack), but the attack gains +1 bonus and deals an additional 1d6 points of siphon damage per stack, you heal half of the result of this bonus damage. Additionally, when you are expending stacks on an attack, you can move 5 feet per 2 stacks expended, this provokes as normal. You choose whether this movement is done before or after the attack.
          \nIf your maximum hit points are reduced by one of your crimson reaper maneuvers, you gain additional stacks equal to your level/4 (minimum 1). These stacks can go over the normal limit of stacks up to twice the normal limit.
          \nAt level 10, 15, and 20 the damage per stack increases by 1 dice step.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
            school: `crimsonReaper`,
            level: 3,
            name: "Blood Clot",
            type: "Stance",
            longDesc: `While in this stance, for every 5 points of damage you take in combat, you get 1 clot stack for the rest of the floor. You can leave this stance as a movement action to unleash your stacks, expending all of them to create a blastwave in a 10 foot radius around you. All creatures in the area take damage equal your stacks (reflex halves). Damage to temporary hit points count for this stance.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `stance`,
            target: `you`,
          },
          {
            school: `crimsonReaper`,
            level: 1,
            name: "Blade of Red Tears",
            type: "Stance",
            longDesc: `While in this stance, your slashing and piercing weapons deal 1 point of bleed damage. Repeated attacks against the same creature increases the bleeding damage its takes each rounds (only counts as one stack of bleeding). This bleed stacks with other bleed damage. Every 6 levels the bleed damage increases by 1.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `stance`,
            target: `you`,
          },
          {
          school: `crimsonReaper`,
          level: 3,
          name: "Empty Cup",
          type: "Strike",
          longDesc: `Make a melee attack, it deals bonus siphon damage equal to how many maximum hit points you are currently missing due to your crimson reaper maneuvers.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 living creature`,
          },
          {
            school: `crimsonReaper`,
            level: 3,
            name: "Red Strings",
            type: "Boost",
            longDesc: `You can activate this maneuver in one of two ways:
            \nSwift: During the turn you activate this, As you move, red strings to appear beneath your feet as you move, allowing you to walk through the air during your movement. Roll a spellcraft check, and move that distance. You can use that check to avoid attacks of opportunity for moving, and doing so does not reduce the movement gained from this maneuver (but reduces other movement). After you have moved, the strings remain until the start of your next turn.
            \nMovement: You leap into the air and cause a red string to appear beneath you for which you stand on. Make a spellcraft check, you move directly upwards that distance and can stand on the string until the end of your next turn. This movement does not provoke. If you leap from the string to attack a creature lower than you, that attack gains a +2 bonus and the critical threat range increases by a flat +1, and critical hits deal 1d6 points of bleed damage multiplied by your critical damage multiplier.`,
            initiationAction: `movement or swift`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
          },
          {
          school: `crimsonReaper`,
          level: 3,
          name: "Shred Self",
          type: "Counter",
          longDesc: `Instead of failing to the weakness of the mind or flesh, you simply power your way through, discarding the parts that fail you. Make a fortitude save in place of a reflex or will save. After using this counter you also lose hit points equal to 20% of your maximum hit points.`,
          initiationAction: `immediate`,
          range: `personal`,
          duration: `instantaneous`,
          target: `you`,
          },
          {
          school: `crimsonReaper`,
          level: 3,
          name: "Crimson Flood",
          type: "Strike",
          longDesc: `As a full-round action you make a single melee attack. You can expend a blood point to make an additional attack, or to move 10 feet, provoking as normal. Each attack deals 2d6 more siphon damage than the previous one.`,
          initiationAction: `full-round`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 enemy`,
          },
          {
          school: `crimsonReaper`,
          level: 3,
          name: "Unstaunchable Flow ",
          type: "Strike",
          longDesc: `Make a melee attack, if successful it deals damage as normal and they start bleeding for 1d6 damage. While the are bleeding from this, attempting to heal them with positive energy requires a spell caster check DC equal to your maneuver DC or it only heals half and any bleed effects they are currently suffering from do not stop. Each time they take bleeding damage from this maneuver, the damage increases by 1d6, up to a maximum number of d6's equal to twice your initiation modifier.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 living creature`,
          },
          {
          school: `crimsonReaper`,
          level: 3,
          name: "Ghoul's Claws",
          type: "Boost",
          longDesc: `For 1 round your melee attacks deal bonus damage equal to your constitution modifier. If the weapon you are attacking with has a different ability score multiplier on the damage of the weapon, such as 0.5x for off-hand attacks or 1.5x for two-handed weapons, the bonus damage has the same multiplier.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `1 round`,
          target: `you`,
          },
          {
          school: `crimsonReaper`,
          level: 4,
          name: "Bloodshadow",
          type: "Counter",
          longDesc: `When you are targeted by an attack roll or ability or allowed a reflex save vs an ability, you make a spellcraft check vs the creatures spellcraft or sense motive (their choice), if you succeed, you dissolve into blood, leaving behind a copy made from blood to take the attack, while teleporting 10-ft away. If the attack would still encompass an area to where you are teleporting (such as with the fireball spell), you are still struck by the attack. You can spend 1 blood point to increase the distance teleported by 10 feet, or to give your spellcraft a +5 bonus for the roll (must be declared before the roll is made).`,
          initiationAction: `immediate`,
          range: `personal`,
          duration: `instantaneous`,
          target: `you`,
          },
          {
          school: `crimsonReaper`,
          level: 4,
          name: "Sanguine Rush",
          type: "Boost",
          longDesc: `The next time you deal siphon damage this round, it is increased by 25% (this only applies to damage from abilities activated this round). Then you choose between gaining permanent or temporary blood points: 
          \nPermanent: Reduce your maximum hit points by 1d4 per odd level. Gain a blood point and a temporary blood point that lasts 1 round. This only reduces your current hit points if your new maximum hit points would be lower than your current hit points.
          \nTemporary: Reduce your current hit points by 1d8 per odd level and gain 2 temporary blood points that lasts level/3 rounds (minimum 1). This boost can only be initiated in combat.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `1 round`,
          target: `you`,
          },
          {
          school: `crimsonReaper`,
          level: 4,
          name: "Sanguine Wave",
          type: "Strike",
          longDesc: `You teleport up to close range (25ft. + 5ft./2 levels) and make a melee attack against a creature, the attack deals an additional 6d6 damage. If the target of the attack is bleeding, the teleportation distance is doubled and your critical threat range for the attack increases by a flat +1.`,
          initiationAction: `standard`,
          range: `close (25ft. + 5ft./2 levels)`,
          duration: `instantaneous`,
          target: `1 living creature`,
          },
          {
          school: `crimsonReaper`,
          level: 4,
          name: "Wrack",
          type: "Strike",
          longDesc: `Make a melee attack, it deals an additional 6d6 siphon damage and the creature must make a fortitude save or be nauseated for 1 round and staggered for 1 round after. The nausea and stagger are [pain] effects.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `2 rounds`,
          target: `1 living creature`,
          },
          {
          school: `crimsonReaper`,
          level: 4,
          name: "Soul Hemorrhage",
          type: "Strike",
          longDesc: `Make a melee attack, it deals an additional 4d6 damage and the creature takes 1d3 points of bleed to an ability score of choice (except constitution). If you choose a physical ability score: You gain temporary hit points equal to the bleeding creatures HD/2 for each point of ability score bleed this ability deals. These temporary hit points lasts initiation modifier rounds (minimum 1) and stack with themselves. \nIf you choose a mental ability score, you gain a temporary blood point that lasts 1 round every time they take 2 points of ability score bleed from this maneuver.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 living creature`,
          },
          {
            school: `crimsonReaper`,
            level: 2,
            name: "Crimson Curse",
            type: "Strike",
            longDesc: `<[curse]> Make a melee attack, if successful it deals damage as normal and the creature's fast healing and regeneration no longer stops bleeding, and any creature that uses magic to heal it requires a caster level check equal to the DC of this maneuver or it does not stop the bleeding. It also takes a -4 penalty on any saves against bleeding effects. A successful fortitude save reduces the duration of this to one round, and it doesn't take a penalty on saves against bleed effects.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `initiation modifier rounds`,
            target: `1 living creature`,
            additionalTags:["Curse"],
          },
          {
            school: `crimsonReaper`,
            level: 6,
            name: "Digging Teeth",
            type: "Strike",
            longDesc: `<[curse]> Make a melee attack, it deals an additional 6d6 siphon damage and if successful the creature becomes cursed by you for initiation modifier rounds, a will save reduces duration to 1 round. All healing and temporary hit points the creature receives is redirected to you. The creature can attempt to resave against this effect as a full-round action.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `initiation modifier rounds`,
            target: `1 living creature`,
            additionalTags:["Curse"],
          },
          {
          school: `crimsonReaper`,
          level: 4,
          name: "Indulgence",
          type: "Counter",
          longDesc: `You initiate this counter when an enemy within range takes any kind of bleed damage. Increase all the bleed damage they take this turn by 100% and heal half of the damage they take. This can work on multiple kinds of bleed at once. If it was ability score bleed, you heal ability damage from the same score, or you can gain a racial bonus to that score for initiation modifier rounds (both are an amount equal to half the damage they took). This stacks, however the duration is only extended by 1 round instead of being reset.`,
          initiationAction: `immediate`,
          range: `60 feet`,
          duration: `see text`,
          target: `1 bleeding creature`,
          },
          {
            school: `crimsonReaper`,
            level: 3,
            name: "Pulsation",
            type: "Boost",
            longDesc: `Reduce your maximum hit points by 1d4 per maneuver level to recover it. You can spend 2 blood points to recover additional maneuvers (max constitution mod, minimum 0), reducing your maximum hit points the same way. The damage is increased to 1d8 when not recovering a <death/sakura> maneuver.`,
            initiationAction: `free`,
            range: `personal`,
            duration: `instantaneous`,
            target: `you`,
          },
          {
          school: `crimsonReaper`,
          level: 5,
          name: "Lord of Blood",
          type: "Stance",
          longDesc: `While in this stance you, whenever you use a Crimson Reaper maneuver that includes "Rush" in its name to gain blood points or temporary blood points, you gain an additional temporary blood point that lasts 1 round. Max 1 bonus point at a time.
          \nYou can spend a blood point as a free action for any of the following benefits: 
          \nGain a movement or swift action\nMake a melee attack as a swift action\nYour next attack gains a racial bonus to attack equal to half your constitution modifier`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
            school: `crimsonReaper`,
            level: 5,
            name: "Blood Cardinal",
            type: "Stance",
            longDesc: `Whenever you use a Crimson Reaper maneuver that deals bonus siphon damage to an enemy, you gain cardinal stacks equal to the bonus siphon damage dealt (this doesn't include not instantaneous damage). If the bonus damage heals or grants temporary hit points, reduce the amount of stacks you gain from it equal to the amount healed/temporary hit points gained. As a standard action by touching the creature, or as a part of healing it another way, you can expend as many stacks as you'd like, healing them hit points equal to the stacks expended. If you are delivering this healing through some other way of healing them, this healing applies first, possibly reducing the other healing. You cannot do this to yourself.
            \nAdditionally, If you use a maneuver that would normally heal yourself, you can instead heal an ally within 10 feet of you (+10 feet at level 14 and 19). Your stacks in this stance remain even if you leave it, but are reset each floor.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `stance`,
            target: `you`,
          },
          {
            school: `crimsonReaper`,
            level: 5,
            name: "Open the Vein",
            type: "Strike",
            longDesc: `Make a melee attack, if successful the creature's bleed damage is doubled and any DC to remove that bleed damage is increases by +2.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 bleeding creature`,
          },
          {
          school: `crimsonReaper`,
          level: 5,
          name: "Scarlet Retribution",
          type: "Boost",
          longDesc: `You can activate this maneuver in two ways:
          \n1: For 1 round, for every 3 points of damage you take you gain +1 damage, for every 6 points you gain +1 attack, for every 30 points your crit range increases by +1, and for every 60 your critical multiplier increased by +1. 
          \n2: You can instead choose to also gain 10x initiation modifier temporary hit points, but the bonuses you gain to be halved.
          \n\nThese bonuses apply to the first attack you make on the following round.
          \n1 blood point: gain 3x initiation modifier temporary hit points.\n1 blood point: increase duration to expend the attack by 1 round.\n2 blood points: increase duration that this charges by 1 round.`,
          initiationAction: `standard`,
          range: `personal`,
          duration: `1 round`,
          target: `you`,
          },
          {
          school: `crimsonReaper`,
          level: 5,
          name: "Bloodsurge",
          type: "Boost",
          longDesc: `Your next attack this round gives you temporary hit points equal to damage dealt. AoE attacks only give temporary hit points equal to the most damage done to any target, +10% for each target past the first hit. Temporary hit points from this maneuver do not stack with themselves and are lost when combat ends. This doesn't apply to damage that would already heal you, or grant you temporary hit points. This doesn't work on creatures immune to siphon damage.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `1 round`,
          target: `you`,
          },
          {
          school: `crimsonReaper`,
          level: 5,
          name: "Weeping River",
          type: "Strike",
          longDesc: `Move up to your movement speed, making a melee attack against any enemy adjacent to you along the movement. All creatures struck take an additional 3d6 bleed damage. If the attack is a critical hit, the bleed damage is also multiplied by the critical damage multiplier. If the creature was already suffering hit point bleed damage, your critical damage multiplier against them increases by +1.`,
          initiationAction: `full-round`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `adjacent enemies`,
          },
          {
            school: `crimsonReaper`,
            level: 5,
            name: "Inner Annihilation",
            type: "Strike",
            longDesc: `Make a melee attack, if it hits it deals damage as normal, but they must also make a fortitude save or take an additional 20d6 points of siphon damage. 
            \n1 Blood point: Increase DC by +2, and damage by 2d6.`,
            initiationAction: `full-round`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 living enemy`,
          },
          {
          school: `crimsonReaper`,
          level: 5,
          name: "Viscera Cleave",
          type: "Strike",
          longDesc: `Make a melee attack against all enemies within your reach, each attack dealing 3d6 additional damage. Additionally, all creatures within your reach except you (whether they were attacked or struck by this maneuver) must make a reflex save or be blinded by spray of blood. The blind lasts until they spend a movement action wiping it away. If a creature is killed by this maneuver, the DC increases by +2 and it takes an additional movement action to wipe away the blood (for each creature killed).`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `enemies within reach`,
          },
          {
          school: `crimsonReaper`,
          level: 5,
          name: "Sanguine Shift",
          type: "Counter",
          longDesc: `This counter cannot not made in response to an offensive action against you, but can otherwise be done at any time. You dissolve into blood and reform up to 30 feet away. This otherwise acts like teleportation.
          \n1 blood point: Increase distance by 10 feet.`,
          initiationAction: `immediate`,
          range: `30 feet`,
          duration: `instantaneous`,
          target: `you`,
          },
          {
            school: `crimsonReaper`,
            level: 7,
            name: "Pale Hands",
            type: "Counter",
            longDesc: `Many hands lay on the ground. They are the hands of the people you once loved. When a creature that is currently bleeding dies, you can as an immediate action attempt to transfer the bleed damage it was taking to another enemy. They receive a fortitude save to negate, however for each individual source of bleeding the creature was suffering from, the DC increases by +1.`,
            initiationAction: `immediate`,
            range: `60 feet`,
            duration: `instantaneous`,
            target: `1 dead and 1 living creature`,
            },
          {
            school: `crimsonReaper`,
            level: 4,
            name: "Insatiable",
            type: "Counter",
            longDesc: `This counter can be made when a creature that is currently bleeding from an effect you caused is healed. The creature makes a will saving throw, on failure, the healing is redirected to you. The redirected healing is not considered positive energy. If they succeed, they heal only half, and if the healing would allow a check to end the bleed, they take a -4 penalty on the roll. If multiple creatures are being healed at once, you can activate this counter against all bleeding creatures that are being healed by that instance of the effect.`,
            initiationAction: `immediate`,
            range: `100 feet`,
            duration: `instantaneous`,
            target: `1 bleeding creature(s)`,
          },
          {
          school: `crimsonReaper`,
          level: 6,
          name: "Bleed Their Heart",
          type: "Strike",
          longDesc: `Make a melee attack, it deals damage as normal and the creature takes 1d4 points of constitution bleed damage. As long as you are within 30 feet of the target, for each point of constitution damage taken by this maneuver you heal for points equal to half their HD.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 living enemy`,
          },
          {
            school: `crimsonReaper`,
            level: 6,
            name: "Red Room",
            type: "Boost",
            longDesc: `You create a 20ft. cube (roof and floor included) from walls of blood starting from a point adjacent to you. If a creature is adjacent to a square where a blood wall is being formed, they can make a reflex save to disrupt that particular wall from forming. The walls have hardness equal to your initiation modifier, and each 10 foot section has hit points equal to 6x constitution modifier. You can move freely through these walls, but not attack through them. Once the walls have been formed they remain for initiation modifier rounds. Any creature that attacks the walls from the inside with a non-reach melee weapons takes 1d6+initiation modifier piercing damage, this bypasses DR magic. You can only have 1 Red Room active at a time, activating it again causes the previous one to return to liquid. While you are inside of the red room, for every other enemy also inside of the red room, you gain a +1 insight bonus on attack rolls and your melee attacks deal an additional 2d6 damage.
            \nYou can spend 2 blood points to increase the size of the room by 5 feet.`, 
            initiationAction: `standard`,
            range: `0ft. Area: 20 foot cube`,
            duration: `initiation modifier rounds`,
          },
          {
            school: `crimsonReaper`,
            level: 6,
            name: "Banquet of Blood",
            type: "Boost",
            longDesc: `For 1 round, any time a creature within the range takes bleed damage, you can heal one or more allies within the area a total amount equal to the bleed damage, split amongst them as you see fit. If it is ability score bleed damage, you can either choose to heal damage from that ability score or grant an enhancement bonus equal to the amount lost for 1 round, plus 1 round per 5 levels.`, 
            initiationAction: `swift`,
            range: `50 feet`,
            duration: `1 round`,
          },
          {
            school: `crimsonReaper`,
            level: 5,
            name: "Balemoon Rising",
            type: "Boost",
            longDesc: `All enemies within 30 feet must make a reflex save or suffer bleed damage equal to your constitution modifier. This stacks with other bleed damage, but not itself.
            \nYou can expend a blood point to increase the range by 15 feet.`, 
            initiationAction: `movement`,
            range: `30 feet`,
            duration: `instantaneous`,
          },
          {
          school: `crimsonReaper`,
          level: 6,
          name: "Bloodstorm Blade",
          type: "Strike",
          longDesc: `You take a weapon and coat it in your blood before throwing it up to 30 feet. The weapon spins as it moves, striking all creatures along the way. Make an attack against each creature the weapon moves through, dealing your weapons damage as normal plus an additional 4d6 damage. Then you can choose to either let the weapon remain there in the air, or draw it back immediately. If you let it remain there, you can draw it back up to 1 round per initiation modifier later as a movement action. If you let it linger for at least when 1 round, when you call it back it moves directly towards you, attacking and dealing damage the same way as when you threw it out. If the weapon strikes an object, it can make a sunder attempt to break it, if it fails, the weapon drops to the ground there.
          \n1 blood point: increase range by 20 feet.`,
          initiationAction: `full-round`,
          range: `30 feet`,
          duration: `initiation modifier rounds`,
          target: `your weapon`,
          },
          {
          school: `crimsonReaper`,
          level: 6,
          name: "Grisly Rebellion",
          type: "Strike",
          longDesc: `Make a melee attack, If the attack would do any damage that would heal you, it no longer does, but instead that bonus healing is dealt to the target of the attack at as damage. This doesn't stack with other abilities that cause your siphon damage not heal.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 living creature`,
          },
          {
          school: `crimsonReaper`,
          level: 6,
          name: "Red River Axe",
          type: "Strike",
          longDesc: `You make a melee attack, it deals an additional 6d6 siphon damage. For every 20% of its hit points the target of the attack is missing, the attack gains a flat +1 bonus to its critical threat range and deals an additional 4d6 damage.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 living creature`,
          },
          {
            school: `crimsonReaper`,
            level: 4,
            name: "Blood Spike",
            type: "Boost",
            longDesc: `Make a melee touch attack, if successful, it deals no damage, but the creature instantly takes its bleed damage again.`,
            initiationAction: `swift`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 bleeding creature`,
          },
          {
          school: `crimsonReaper`,
          level: 6,
          name: "Reaper of the Harvest Moon",
          type: "Stance",
          longDesc: `Every time an enemy within 60 feet begins dying, you heal you 4d6 hit points, get 4d6 temporary hit points (lasts 10 minutes), a temporary blood point that lasts level/2 rounds, and then they must make a will or die instantly. If they fail, you get a blood point, +1 bonus on attack rolls, and a +4 bonus to weapon damage rolls these last until you leave this stance. If you are what caused the creature to begin dying or if they fail the save against this ability, the DC of this stance increases by +2 for the rest of the floor. At level 18 the DC increases by an additional +1 if you are what caused the creature to begin dying and the bonus to damage you gain increases by +2.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
          school: `crimsonReaper`,
          level: 7,
          name: "Chi no Tsuki Descent",
          type: "Strike",
          longDesc: `Take 5d6 points of damage, then move up to your movement speed in a straight line (even straight up). Make a single melee attack against a creature you were adjacent to during the movement. It deals damage as normal plus an additional 20d6 damage (half the bonus damage is siphon damage). 
          \n1 Blood Point: Increase the bonus damage dealt by 4d6 and self damage taken by 1d6.
          \n3 Blood Points: Take an additional 5d6 damage and make an additional attack against a different enemy that you are within reach of during your movement. It doesn't get any of the additional damage bonuses from blood points spent, and you must spend them individually.`,
          initiationAction: `full-round`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 living creature(s)`,
          },
          {
            school: `crimsonReaper`,
            level: 7,
            name: "Soul Mutilation",
            type: "Strike",
            longDesc: `Make a melee attack, if it hits, it deals damage as normal plus it deals 1d6 points of damage to one of the creature's ability scores, and causes them to suffer 2d6 bleed to that ability score. If you choose constitution the damage is reduced to 2d4. The damage to the soul from this maneuver is extreme, and stopping it is very difficult; the caster of a healing spell or similar effect must succeed at a caster level check (DC 11 + initiator level) to halt the bleed damage (healing from the spell or effect still occurs even if the check fails to halt the bleeding), and the DC to apply first aid with the Heal skill increases by 7 + your initiation modifier. 
            \n1 Blood Point: Increase the DC to halt the bleed damage by 2 (increase Heal DC by 4).`,
            initiationAction: `full-round`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 living creature`,
            },
          {
          school: `crimsonReaper`,
          level: 7,
          name: "Dipsia",
          type: "Boost",
          longDesc: `If your your next weapon attack this turn is against a living creature, it heals you for half of the damage dealt. If it hits multiple creatures, only applies to the first creature +10% each creature after that is hit. This doesn't apply to damage that would already heal you or grant you temporary hit points.`,
          initiationAction: `swift`,
          range: `melee attack`,
          duration: `1 round`,
          target: `you`,
          },
          {
            school: `crimsonReaper`,
            level: 2,
            name: "Bloody Stream",
            type: "Boost",
            longDesc: `You can take 1d6 points of damage to move 5 feet without provoking attacks of opportunity. You can take as many 1d6s as you want to move further, up to a maximum of twice your constitution or initiation modifier. Movement adjacent to a bleeding enemy allows you to move twice as far, and you can triple the damage you take to move through an enemy's space, though you must make a spellcraft check equal to their CMD - your initiation modifier or the movement fails and you provoke an attack of opportunity.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `instantaneous`,
            target: `you`,
          },
          {
            school: `crimsonReaper`,
            level: 2,
            name: "Smells Blood",
            type: "Boost",
            longDesc: `If Swift: Move up to your movement speed.
            \nIf Movement: Move up to twice your movement speed, and the damage bonus increases by 2d6.
            \nYou must end your movement threatening a bleeding creature. Your next attack this turn you make against it gets a +2 bonus to attack and deals an additional 1d6 damage. If your attack misses, or you fail to attack it at all this round, you suffer 4d6 points of damage and take a -2 penalty on all d20 rolls until the end of your next turn.`,
            initiationAction: `swift or movement`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
          },
          {
          school: `crimsonReaper`,
          level: 7,
          name: "Phantom Blood",
          type: "Strike",
          longDesc: `Make a melee attack, if it hits it deals half damage (including any additional bonus damage to the attack), then 1 round later they take damage equal to the difference in their hit points from now and right before this strike was made.
          \n2 Blood Points: increase duration by 1 round.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `1 round`,
          target: `1 living creature`,
          },
          {
            school: `crimsonReaper`,
            level: 8,
            name: "Oceans of Blood",
            type: "Strike",
            longDesc: `You teleport adjacent to all bleeding enemies within 100 feet and make a melee attack against them at your highest bonus. If an attack hits, the attack deals damage as normal plus 5d6 and the creature takes its bleed damage immediately. For each individual type and stack of bleeding the creature has, the attack gains a +0.5 flat bonus to its critical threat range. After you make your attacks, you finish your teleportation adjacent to any square that contained a creature you attacked (whether they are still there or alive)
            \n1 Blood Point: Increase the range by 30 feet
            \n1 Blood Point: Take an additional attack against a single creature during this. Attacking the same target mutiple times increases the BP cost by 1 per additional attack.`,
            initiationAction: `full-round`,
            range: `100 feet`,
            duration: `instantaneous`,
            target: `bleeding creature(s)`,
          },
          {
            school: `crimsonReaper`,
            level: 8,
            name: "Elegy of the End",
            type: "Strike",
            longDesc: `Make a melee attack, if successful, it deals damage as normal, plus 8d6 siphon damage, and you cause profuse bleeding to the creature's soul and body. The creature suffers 1d6 bleed damage to all of their ability scores. This counts as only a single bleeding effect for how many types of bleeding the creature is suffering from. Stopping this bleeding is particularly difficult, requiring the healer to roll a caster level check DC 23 + initiation modifier to end it (DC to apply first aid with the Heal skill increases by 8 + your initiation modifier. )
            \n1 Blood Point: Increase the bleed damage to a specific ability score by 1d6 (except constitution).
            \n2 Blood Points: Increase the bleed damage to the creature's constitution by 1d6.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 creature`,
          },
          {
            school: `crimsonReaper`,
            level: 3,
            name: "Gluttony",
            type: "Boost",
            longDesc: `Reduce your maximum hit points by an amount of d3's up to a maximum of 2x your initiation modifier. For each d3, heal 1d8 hit points and gain 1d8 temporary hit points. The temporary hit points last until the end of the floor.`,
            initiationAction: `free`,
            range: `personal`,
            duration: `instantaneous`,
            target: `you`,
          },
          {
            school: `crimsonReaper`,
            level: 7,
            name: "Amaranthine: Undying",
            type: "Counter",
            longDesc: `You can take 2 points of constitution drain to get temporary hit points equal to your maximum hit points (before reductions from crimson reaper maneuvers, but not constutition drain, damage, or other similar effects).`,
            initiationAction: `immediate`,
            range: `personal`,
            duration: `constitution modifier rounds`,
            target: `you`,
            },
            {
              school: `crimsonReaper`,
              level: 7,
              name: "Cruel Reaper",
              type: "Strike",
              longDesc: `You make a melee attack at all enemies within your reach that deals an additional 5d6 points of damage, then you immediately teleport 15 feet and make another melee attack against all creatures within reach that deals an additional 5d6 siphon damage. If the second attack confirms a critical hit, you may make another attack against that creature as a free action, though it suffers a -8 penalty to the attack roll. Until the end of your turn, you count as being in both your current position and original original square for the purposes of flanking, even allowing you to flank with yourself.
              \n1 Blood Point: Increase the distance teleported by 10 feet.\n4 Blood Points: Increase the critical threat range of the second attack by a flat +1.`,
              initiationAction: `full-round`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `see text;`,
              },
            {
              school: `crimsonReaper`,
              level: 6,
              name: "Ruby Reflection",
              type: "Counter",
              longDesc: `When you are targeted by a ranged supernatural ability or spell, you can initiate this counter to make an opposed spellcraft roll against the creature's spellcraft or perception (their choice). If your roll is higher than theirs, you negate the effect on you and can redirect it to another creature within close range (25ft. + 5ft./2 levels). The creature who began the effect is still in control of the effect as normal.`,
              initiationAction: `immediate`,
              range: `close (25ft. +5 ft./2 levels)`,
              duration: `instantaneous`,
              target: `1 enemies`,
            },
            {
              school: `crimsonReaper`,
              level: 5,
              name: "Chains of Agony",
              type: "Counter",
              longDesc: `When you take damage, you reflect your pain on enemies. All enemies within 30 feet take siphon damage equal to the amount of damage you just took, though they may make a fortitude save to reduce it by half. If even one target of this maneuver failed their save, you reduce the damage you took by by the triggering attack by half. You can initiate this counter even against a natural 20, however you cannot take it because of self inflicted damage.`,
              initiationAction: `immediate`,
              range: `30 foot radius`,
              duration: `instantaneous`,
              target: `1 or more living enemies`,
          },
          {
            school: `crimsonReaper`,
            level: 3,
            name: "Blood Bind",
            type: "Strike",
            longDesc: `<[curse]> Make a melee attack, if it hits, it deals half the normal damage, but for initiation modifier rounds as long as you are within close range (25ft. + 5ft./2 levels) of the creature, whenever you take damage, the creature takes damage equal to half the damage you took. A creature can make a will save to reduce the duration of this to one round. This does not transfer self inflicted damage. The creature can attempt another will save as a free action at the start of each of their turns except the round it is applied to remove this. You can have only a single blood bind or similar effect active on a single creature at a time.`,
            initiationAction: `standard`,
            range: `melee attack; close`,
            duration: `initiation modifier rounds`,
            target: `1 living enemy`,
            additionalTags:["Curse"],
          },
          {
            school: `crimsonReaper`,
            level: 2,
            name: "Crimson Scar",
            type: "Strike",
            longDesc: `<[curse]> Make a melee attack, if it hits, it deals damage as normal and the creature stops healing from fast healing, regeneration, or other healing over time effects. This also includes abilities that grant repeated temporary hit points, such as berserking. A creature that has regeneration does not die when below its constitution, it just simply does not heal any hit points from it.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `initiation modifier rounds`,
            target: `1 living enemy`,
            additionalTags:["Curse"],
          },
          {
            school: `crimsonReaper`,
            level: 4,
            name: "Injection",
            type: "Counter",
            longDesc: `You can initiate this counter any time, even using it to stop a creature from dying. You give a living ally as many of your temporary hit points as you desire. Their durations do not change.`,
            initiationAction: `immediate`,
            range: `60 feet`,
            duration: `see text;`,
            target: `1 living ally`,
          },
          {
          school: `crimsonReaper`,
          level: 6,
          name: "Scarlet Rush",
          type: "Boost",
          longDesc: `You gain a morale bonus to your damage on melee attacks equal to your initiation modifier for 1 round. Then you choose between gaining permanent or temporary blood points: 
          \nPermanent: Reduce your maximum hit points by 1d6 per odd level. Gain a blood point and 2 temporary blood points that last 2 rounds. This only reduces your current hit points if your new maximum hit points would be lower than your current hit points. Additionally, the bonus damage this boost grants is increased to 3 rounds.
          \nTemporary: Reduce your current hit points by 2d8 per odd level and gain 3 temporary blood points that lasts level/3 rounds (minimum 1). This boost can only be initiated in combat.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `1 round`,
          target: `you`,
          },
          {
            school: `crimsonReaper`,
            level: 6,
            name: "Velvet Shroud",
            type: "Boost",
            longDesc: `You gain 1d12 temporary hit points per constitution modifier. These temporary hit points are always lost first (even before other temporary hit points). Until these temporary hit points are lost you gain a +4 cover bonus to your armor class, a +2 cover bonus to reflex saves, and all targeted spells and effects against you have a 50% miss chance unless you choose to accept them.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `see text;`,
            target: `you`,
          },
          {
            school: `crimsonReaper`,
            level: 5,
            name: "Crimson Waves",
            type: "Boost",
            longDesc: `Choose a melee weapon, for 1 round all of your attacks with it can be made at close range (25ft. + 5ft./2 levels), but each attack makes you suffer 2d6 damage, or 6d6 if it is a strike that only makes a single attack.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
          },
          {
            school: `crimsonReaper`,
            level: 8,
            name: "Crimson Rush",
            type: "Boost",
            longDesc: `Your next melee attack this round deals 25% additional damage as long as it is against a living creature. This bonus damage counts as siphon damage. Then you choose between gaining permanent or temporary blood points: 
            \nPermanent: Reduce your maximum hit points by 1d6 per odd level. Gain 2 blood points and 2 temporary blood points that lasts 3 rounds. This only reduces your current hit points if your new maximum hit points would be lower than your current hit points.
            \nTemporary: Reduce your current hit points by 2d12 per odd level and gain 3 temporary blood points that lasts level/3 rounds (minimum 1). This boost can only be initiated in combat.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `3 rounds`,
            target: `you`,
          },
          {
            school: `crimsonReaper`,
            level: 8,
            name: "Unbearable Urging",
            type: "Boost",
            longDesc: `Gain a standard action this round. To activate this boost you must spend 5 blood points. You can replace a missing blood point by instead taking 1 constitution drain.`,
            initiationAction: `free`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
          },
          // {
          //   school: [`crimsonReaper`,`shadowAssassin`,`unquietGrave`],
          //   level: 5,
          //   name: "Royal Execution",
          //   type: "Finisher",
          //   longDesc: `[royal-death-death-death] This is a [death] effect. Make a melee attack, instead of normal damage, it deals damage equal to the amount of hit points the creature is missing. Creatures immune to death effects halve this damage.`,
          //   initiationAction: `standard`,
          //   range: `melee attack`,
          //   duration: `instantaneous`,
          //   target: `1 living enemy`,
          // },
          {
            school: `crimsonReaper`,
            level: 3,
            name: "Edacity",
            type: "Boost",
            longDesc: `Gain a movement action this round. To activate this boost you must spend 2 blood points. You can replace a missing blood point by instead taking 1 constitution drain.`,
            initiationAction: `free`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
          },
          {
            school: `crimsonReaper`,
            level: 4,
            name: "Avid Thirst",
            type: "Boost",
            longDesc: `Gain a swift action this round. To activate this boost you must spend 2 blood points. You can replace a missing blood point by instead taking 1 constitution drain.`,
            initiationAction: `free`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
          },
          {
            school: `crimsonReaper`,
            level: 3,
            name: "Red Eyes",
            type: "Boost",
            longDesc: `You gain lifesight 10 feet for 1 round. At level 10, 15, and 20, the distance increases by 5 feet, and it lasts an additional round.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
          },
          {
            school: `crimsonReaper`,
            level: 8,
            name: "Lamentation of the Sanguine Moon",
            type: "Strike",
            longDesc: `You hold your weapon into the air above your head, commanding pillars of blood to rise from the ground beneath enemies within a 50 foot radius of you (max initiation modifier enemies). Each enemy must make a reflex saving throw or become impaled. Creatures bleeding take a -4 penalty on their save. Impaled creatures take damage as if you had struck them with your wielded weapon and and become grappled. Creatures must make a CMB check or an escape artist check to escape, the DC to escape being determined by a spellcraft check. Every time a creature attempts to escape it takes 10d6 points of damage. Alternatively, if the pillar takes initiation modifier * constitution modifier damage the pillar breaks and the creature is free.`,
            initiationAction: `full-round`,
            range: `50 foot radius`,
            duration: `see text;`,
            target: `1 or more enemies`,
          },
          {
            school: `crimsonReaper`,
            level: 7,
            name: "Massacre of the Crimson Count",
            type: "Stance",
            longDesc: `When you kill a creature, you cause a pillar of blood to sprout from its blood, impaling the body in a grisly display for all enemies. All enemies within 30 feet of the pillar when created must make a will save or become frightened for 1 round, and shaken until it leaves the area of the pillar or the pillar is destroyed. For every pillar it is already within the area of, it suffers a -2 penalty to the save. The pillar has hit points equal to your initiation modifier * your constitution modifier. Allies gain a +1 morale bonus to attacks and saves for every pillar within 30 feet of them (stacks). [fear][mind-affecting][emotion]`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `stance`,
            target: `you`,
          },
          {
          school: `crimsonReaper`,
          level: 9,
          name: "Requiem of the Eucharist",
          type: "Strike",
          longDesc: `You cut open the sky, revealing a crimson eclipse that pours tears of blood onto the battlefield. At the start of each of your turns after activating this strike, drops of blood fall from the sky striking random creatures within 30 feet of you. Each turn a number of drops equal to your constitution modifier fall. If it falls on a living enemy they take 1d8 points of damage per your initiation modifier, if its an ally they heal that amount. Enemies can roll a reflex saving throw to reduce the damage by half, and allies can make a reflex saving throw to negate the healing. If multiple drops are targeting the same enemy, the DC to avoid it increases by +2 per additional drop. At the start of each of your turns, as long as at least 1 enemy was harmed and 1 ally was healed, you gain a temporary blood point that lasts until the eclipse ends (max 4 at once). Additional activations of this maneuver do not stack, only reset the duration.
          \n1 Blood Point: Increase the radius by 30 feet for 2 rounds. Can be spent after maneuver initiation.
          \n2 Blood Points: Double the drops that fall this round. Can be spent after maneuver initiation.`,
          initiationAction: `full-round`,
          range: `30 foot radius`,
          duration: `4 rounds`,
          target: `you`,
          },
          {
            school: `crimsonReaper`,
            level: 5,
            name: "Miracle for the Faithful",
            type: "Stance",
            longDesc: `Your bleed damage bypasses bleed immunity. If creatures are immune to ability damage, you can spend 2 blood points while applying ability score bleed to cause it to bypass this immunity as well, though any ability score bleed is halved. These abilities only function as long as the creature is not also immune to negative energy.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `stance`,
            target: `you`,
          },
          {
            school: `crimsonReaper`,
            level: 8,
            name: "Indelible Stains of Blood",
            type: "Strike",
            longDesc: `Make a melee attack, if it hits, the attack deals damage as normal plus 10d6 points of bleed damage. Removing this bleeding is very difficult, requiring a heal check or caster level check when healed equal to the DC of this maneuver + 5. This stacks with other bleed damage, except from bleed damage from this maneuver.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 living enemy`,
          },
          {
            school: `crimsonReaper`,
            level: 3,
            name: "Corrupted Rush",
            type: "Boost",
            longDesc: `Expend a Crimson Reaper maneuver plus another random maneuver (doesn't cost spell points), gain temporary blood points equal to half the chosen maneuver's level rounded down for 1 round. You cannot recover the chosen maneuver for 2 rounds, and the random maneuver for 4 rounds.`,
            initiationAction: `free`,
            range: `personal`,
            duration: `see text;`,
            target: `you`,
          },
          {
            school: `crimsonReaper`,
            level: 9,
            name: "Death March for the Crimson Finale",
            type: "Stance",
            longDesc: `When you enter this stance, you take 10d6 points of damage, and every living creature within 30 feet of you takes 5d6 points of siphon damage. At the start of each of your turns afterwards, the damage is taken again by you and all creatures within 30 feet of you, and it is increased by 10d6 and 5d6 respectively. These increased amounts last the rest of the floor. Every time a creature within the area takes damage, you gain a requiem stack which last until the end of the floor. You gain 1 additional stack when a creature is damaged by this stance. You can choose to supress the area of effect damage for 1 round as a free action at the start of your turn (this also means the damage does not increase). Alternatively, for 1 blood point you can reduce its area to 10 feet or increase it to 60 feet for 1 round. If a creature is killed within its area, you gain 3 requiem stacks, increased to 6 if killed by you, and 10 if killed by this stance. Additionally, every time a creature dies within the area or you score a critical hit, you gain a temporary blood point that lasts until you end this stance. The DC to remove bleeding effects increases by +5 for creatures within the area.
            \n\nYou can exit this stance as a full-round action, when you do, you focus all of the blood and gore absorbed by this stance into a devastating attack, choosing one of the two following options:
            \n1: Execution: Teleport or move to any creature that took damage from this stance at least once and that is within 200 feet and make a single melee attack against them, it deals 1d6 bonus damage per 3 stacks. 
            \n2: Massacre: All creatures within 30 feet (except you) take 1d8 points of damage per 3 requiem stacks and are nauseated for 1 round and knocked prone. Fortitude halves the damage and reduces the nausea to stagger. For every 10 stacks, the DC increases by 1.
            \n\nOnce you exit the stance this way, you cannot re-enter it for the rest of the floor.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `stance`,
            target: `you`,
          },
          {
          school: `shadowAssassin`,
          level: 1,
          name: "Master of Shadows",
          type: "Stance",
          longDesc: `Your shadows have their duration increased by 1d4 rounds, plus 1d4 per 6 levels, shadows deal an additional 10% damage, and have their hit points increased by 10% of your maximum hit points. Both bonuses increase by 5% per 6 levels. If you swap out of this stance with shadows active, they retain the bonus hit points and duration, but not the bonus damage.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
          school: `shadowAssassin`,
          level: 1,
          name: "Contempt for the Weak",
          type: "Stance",
          longDesc: `Gain 1d6 points of sneak attack damage, plus 1d6 per 6 levels. When you attack a creature with below 25% hit points, the first time you deal sneak attack damage against them the sneak attack damage is doubled. At level 10, when you damage a creature and that brings them from above to below 25% hit points that dealt sneak attack damage, that creature immediately suffers the bonus damage that this deals for striking a creature below 25% hit points.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
          school: `shadowAssassin`,
          level: 1,
          name: "Shadow Strike",
          type: "Strike",
          longDesc: `[Shadow Initiation] Make a melee attack against a creature. For each other shadow threatening the creature the attack gains a +1 bonus to the attack and deals 1d6 points of sneak attack damage if applicable. `,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 enemy`,
          additionalInfoTags: ['Shadow Initiation'],
          },
          {
          school: `shadowAssassin`,
          level: 1,
          name: "Opening Strike",
          type: "Strike",
          longDesc: `You make a charge attack, however at any point before you are within 10 feet of the target you can make a single thrown ranged attack at the target of the charge. You can use your stealth in place of the attack roll, and the target is flat-footed for the attack. `,
          initiationAction: `full-round`,
          range: `charge distance`,
          duration: `instantaneous`,
          target: `1 enemy`,
          },
          {
          school: `shadowAssassin`,
          level: 1,
          name: "The First Shadow",
          type: "Boost",
          longDesc: `Place a shadow in your current square. You can only have 1 shadow from this maneuver at a time.`,
          initiationAction: `swift`,
          range: `0 ft.`,
          duration: `shadow`,
          target: `your space`,
          },
          {
            school: `shadowAssassin`,
            level: 2,
            name: "The Second Shadow",
            type: "Boost",
            longDesc: `Place a shadow up to 20 feet away. You must be able to see the location to place it, and its location cannot be threatening an enemy. You can only have 1 shadow from this maneuver at a time.`,
            initiationAction: `movement`,
            range: `20 feet`,
            duration: `shadow`,
            target: `square`,
          },
          {
            school: `shadowAssassin`,
            level: 3,
            name: "The Third Shadow",
            type: "Boost",
            longDesc: `Place a shadow up to close range. You must be able to see the location to place it. The first round you summon this shadow, its damage percentage increases by 20%. You can only have 1 shadow from this maneuver at a time.`,
            initiationAction: `movement`,
            range: `close (25ft. + 5ft./2 levels)`,
            duration: `shadow`,
            target: `square`,
          },
          {
          school: `shadowAssassin`,
          level: 1,
          name: "Surprising Dive",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] You can initiate this when moving. This movement you can use stealth in place of acrobatics to avoid attacks of opportunity or move through enemies squares, when you do, the DC to move through an enemy's square is reduced by 5, and your movement is not slowed for avoiding attacks of opportunity. If you move through a creature's square, it suffers a -2 penalty to armor class for 1 round. At level 8 and 16 the penalty increases by -1.`,
          initiationAction: `free`,
          range: `personal`,
          duration: `1 round`,
          target: `you`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
            school: `shadowAssassin`,
            level: 8,
            name: "Forbidden Animation Cancel",
            type: "Boost",
            subSchool:['shadowTechnique'],
            longDesc: `[Shadow Technique] You can initiate when initiating another <shadow> maneuver. You provoke an attack of opportunity from all creatures that threaten you, even if they are flat-footed or not aware of your presence. The maneuver you are initiating has its initiation action reduced by 1 step. `,
            initiationAction: `free`,
            range: `personal`,
            duration: `instantaneous`,
            target: `you`,
            additionalInfoTags: ['Shadow Technique'],
            },
          {
            school: `shadowAssassin`,
            level: 5,
            name: "Discombobulate",
            type: "Boost",
            longDesc: `Make a touch attack against the creature, on success, it suffers a penalty to its armor class against the next attack against them equal equal to your initiation modifier. Every time you use this on a creature again, the penalty lasts an additional attack. If you successfully discombobulate a creature 5 times in the same combat, they immediately fall unconscious for 1 round. Fortification has a chance to defend against this (critical immunity makes you immune to this).`,
            initiationAction: `swift`,
            range: `melee touch`,
            duration: `1 round`,
            target: `1 enemy`,
          },
          {
          school: `shadowAssassin`,
          level: 2,
          name: "Disengaging Leap",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] You can initiate this after finishing a melee strike or a strike that targets a location. Make an acrobatics check, move directly away from the target of the strike (or the maneuver's point of origin if AoE), equal to half the check. This movement provokes as normal, however you can use a stealth check in place of an acrobatics check for avoiding attacks of opportunity. You can move 50% further by falling prone at the end of your movement.`,
          initiationAction: `free`,
          range: `see text;`,
          duration: `instantaneous`,
          target: `1 enemy`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
            school: `shadowAssassin`,
            level: 2,
            name: "Predation",
            type: "Boost",
            longDesc: `You can expend up to 3 random readied maneuvers (no sp cost) to recover an equal number of random expended maneuvers. The maneuvers are expended before any are recovered, so you may end up with the same maneuvers. If you initiate any of these maneuvers this turn, you gain 1d6 points of sneak attack for 1 round (stacks if multiple). At level 9 and 18 you can expend and recover an additional maneuver.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `instantaneous`,
            target: `you`,
          },
          {
          school: `shadowAssassin`,
          level: 2,
          name: "Extraction",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] You can initiate this at any point of a strike. Teleport to a shadow's location, consuming it. A shadow must have at least 3 rounds of duration left to use this. If you teleport and then attack, your attack deals an additional 2 points of sneak attack damage for every round of duration it had left.`,
          initiationAction: `free`,
          range: `medium (100ft. + 10ft./level)`,
          duration: `instantaneous`,
          target: `1 shadow`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
          school: `shadowAssassin`,
          level: 3,
          name: "War Wraith",
          type: "Stance",
          longDesc: `Gain 2d6 points of sneak attack damage while in this stance. At the start of each of your turns, if you are not in bright light, you can as a free action make a stealth check against all creatures that are 30 feet or further away from you that can currently see you. This check is done at a -10 penalty unless you also have cover or can make stealth checks while observed. If you make a melee attack against any creature that is currently flat-footed against you because of using this ability, your attack gains a +2 circumstance bonus to it, has its critical threat range increased by a flat +1, and your sneak attack damage is multiplied on critical hits. Any time you activate a maneuver that allows you to move or teleport, you gain an additional 1d6 points of sneak attack damage until the next time your turn ends. This stacks, but a single ability can only activate this once per round.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
          school: `shadowAssassin`,
          level: 2,
          name: "Slither",
          type: "Counter",
          longDesc: `You can initiate this counter as a free action that you can take even when not your turn, and can be initiated under multiple circumstances. Its movement provokes as normal, but you can use acrobatics to avoid them without reducing the distance travelled, additionally you can use stealth in place of acrobatics. The options are as follows: 
          \n1: When you are about to fall prone or before standing up from prone: Move 5 feet. For every 10 ranks in acrobatics move an additional 5 feet. If you are falling prone willingly, you also gain a +4 dodge bonus to your armor class for 1 round.
          \n2: When fall prone or after standing up from prone: Move 10 feet. For every 5 ranks in acrobatics move an additional 5 feet. If you fell prone willingly, the distance you move doubles.
          \n3: After using any maneuver that allows you to move or after a charge: Move an 10 feet. For every 10 ranks in acrobatics move an additional 5 feet. You can go prone at the end of the movement until the start of your next turn to double the additional movement`,
          initiationAction: `free; see text`,
          range: `personal`,
          duration: `instantaneous`,
          target: `you`,
          },
          {
          school: `shadowAssassin`,
          level: 2,
          name: "Kawarmi",
          type: "Counter",
          longDesc: `This counter is made in response to an attack roll against you. You make a stealth check with the attack roll as the DC. If successful, you swap places with a nearby small or larger object, the object taking the attack in your place. You can teleport a maximum of 10 feet with this maneuver.`,
          initiationAction: `immediate`,
          range: `10 feet`,
          duration: `instantaneous`,
          target: `small or larger object`,
          },
          {
            school: `shadowAssassin`,
            level: 3,
            name: "Punish Restraint",
            type: "Counter",
            longDesc: `This counter is made in response to a creature that is either within your reach, or adjacent to one of your shadows, casts a spell, whether that would normally provoke attacks of opportunity or not. Make a stealth check against their spellcraft or perception (their choice), if you succeed, you become one of the targets of the spell (regardless of the caster's distance to you). If it targeted multiple creatures, you are added along with the others, if it only targeted a single creature, you are now the only target. If it targeted multiple creatures and this increased the total targets above their maximum limit on targets, choose one of the original targets to not be affected.`,
            initiationAction: `immediate`,
            range: `see text;`,
            duration: `instantaneous`,
            target: `1 enemy`,
          },
          {
            school: `shadowAssassin`,
            level: 4,
            name: "Blade in the Darkness",
            type: "Strike",
            longDesc: `[Shadow Initiation] Make a melee attack, it deals an additional 4d6 points of damage. If any of these bonus damage dice roll within two of the highest dice results (5-6 on a d6), you deal an additional dice of damage (same dice size). You can keep adding additional dice if the new added dice also roll within the required range. If this attack would deal sneak attack damage, you can choose for the the bonus 4d6 damage to be reduced to 2d6 sneak attack damage, but now this strike's effect applies to, and grants sneak attack damage dice instead of bonus damage dice.
            \nIf dealing sneak attack damage with a dice size of d4, this only applies on a 4. If the dice size is below d4, this doesn't affect it.`,
            initiationAction: `standard`,
            range: `melee or ranged attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            additionalInfoTags: ['Shadow Initiation'],
          },
          {
          school: `shadowAssassin`,
          level: 2,
          name: "Coming Nightfall",
          type: "Strike",
          longDesc: `Choose a square that you can see within close range, you throw a shadow to that tile. Once it arrives, it can make an immediate attack against a creature in its melee range that deals an additional 4d6 damage.`,
          initiationAction: `standard`,
          range: `close (25ft. + 5ft./2 levels)`,
          duration: `shadow`,
          target: `1 enemy`,
          },
          {
            school: `shadowAssassin`,
            level: 2,
            name: "Sharp Edge of Night",
            type: "Strike",
            longDesc: `Make an attack against an enemy, if it hits, a shadow that is threatening them can also make an attack against them.`,
            initiationAction: `standard`,
            range: `melee or ranged attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
          },
          {
            school: `shadowAssassin`,
            level: 2,
            name: "Silent Blade",
            type: "Strike",
            longDesc: `[Shadow Initiation] Make an attack against an enemy, making a stealth check in place of the attack roll (you can add any bonuses you gain to attack rolls from your weapon, feats, or abilities). If this attack deals sneak attack damage and was initiated through a shadow, the sneak attack damage is not reduced by the normal damage reduction of the shadow.`,
            initiationAction: `standard`,
            range: `melee or ranged attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            additionalInfoTags: ['Shadow Initiation'],
          },
          {
          school: `shadowAssassin`,
          level: 2,
          name: "Go for the Throat",
          type: "Boost",
          longDesc: `Increase your sneak attack damage this round by 2d6. At initiator level 8 and 16 this increases by 1d6.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `1 round`,
          target: `you`,
          },
          {
          school: `shadowAssassin`,
          level: 1,
          name: "Disorienting Style",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] You can initiate this after finishing a strike. Swap to a different martial stance or style feat as a free action.`,
          initiationAction: `free`,
          range: `personal`,
          duration: `instantaneous`,
          target: `you`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
          school: `shadowAssassin`,
          level: 2,
          name: "Assassin's Insight",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] You can initiate this after successfully damaging a creature with a strike. Choose a target damaged by the strike, you gain 1 stack of Assassin's insight against them. Whan making an attack against a creature that would qualify as a sneak attack (even if no sneak attack damage is dealt), you gain a +1 insight bonus to the attack roll and deal an additional 2 points of sneak attack damage. You cannot have more stacks of assassin's insight at a time than your initiation modifier. Adding new ones ends the oldest one.`,
          initiationAction: `free`,
          range: `sight`,
          duration: `1 hour`,
          target: `1 enemy`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
          school: `shadowAssassin`,
          level: 2,
          name: "Tangling Shadow Roll",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] You can initiate this after successfully damaging a creature with a melee attack. You make a free trip attempt, you can use your stealth in place of the CMB check.`,
          initiationAction: `free`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 enemy`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
          school: `shadowAssassin`,
          level: 3,
          name: "Hall of Shadows",
          type: "Stance",
          longDesc: `You can flank with your shadows. If you and a shadow attack the same target as a part of the same action, the damage the shadow deals is increased by 30%. You gain 1d6 points of sneak attack damage for every other shadow threatening the creature. When you 5-foot step, so can all of your shadows.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
          school: `shadowAssassin`,
          level: 3,
          name: "Spectral Kick",
          type: "Strike",
          longDesc: `When you initiate this maneuver, you can choose to either move 10 feet before or after the kick. For every 10 ranks of stealth, you can increase the distance moved by 5 feet. This movement must be in a straight line and does not provoke. Make an unarmed attack against a creature, if this is the first time you have used that unarmed attack against the creature, the target is flat-footed for the attack. The attack deals half damage and the damage is non-lethal, but if it hits, the target takes a -2 penalty on armor class for 1 round. The penalty is doubled if the unarmed attack was against their their flat-footed armor class. At level 14 the penalty to AC increases to -2.`,
          initiationAction: `swift`,
          range: `melee attack`,
          duration: `1 round`,
          target: `1 enemy`,
          },
          {
          school: `shadowAssassin`,
          level: 3,
          name: "Piercing Shuriken",
          type: "Strike",
          longDesc: `[Shadow Initiation] Pick a target location you or a shadow can see. You and all shadow's throw a single ranged weapon in a straight line towards the target point, each attack is a 20 foot line attack. Make a single attack roll and apply it against the armor class of all creatures within the area. It deals half the normal damage.`,
          initiationAction: `standard`,
          range: `20 foot line`,
          duration: `instantaneous`,
          target: `1 location`,
          additionalInfoTags: ['Shadow Initiation'],
          },
          {
            school: `shadowAssassin`,
            level: 3,
            name: "Sudden Blade",
            type: "Strike",
            longDesc: `You draw a thrown weapon and throw it. You cannot throw a weapon you were already wielding. This strike does not grant any additional ability to draw a thrown weapon, thus this strike can only be made with throwing weapons you can draw as a free action. If the attack is a confirmed vorpal critical (natural 20 that is confirmed as a critical), its critical damage multiplier is increased by +2.`,
            initiationAction: `swift`,
            range: `ranged attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
          },
          {
          school: `shadowAssassin`,
          level: 3,
          name: "Gone with the Night",
          type: "Counter",
          longDesc: `You make this counter at any time, except in response to a hostile action against you. You teleport to a square containing one of your shadows, consuming it.`,
          initiationAction: `immediate`,
          range: `medium (100ft. + 10ft./level)`,
          duration: `instantaneous`,
          target: `shadow`,
          },
          {
            school: `shadowAssassin`,
            level: 3,
            name: "Saving Trip",
            type: "Counter",
            longDesc: `At the last moment you knock an allies feet out from underneath them, dropping them beneath an attack. When an ally is about to be struck by an attack from an enemy, (from an attack you are aware of, can seem and would not be flat-footed against), you make a reflex save, DC 10 + the attacking creature's BAB. If successful, you sweep your allies feet out, causing the ally to fall prone, but also causing the attack to miss. This counter does not work on yourself or a flying allies. If the ally has 2 <shadow> combo points, they can expend them to move 5 feet after falling prone (can expend multiple). If they have two <technique> combo points, they can expend them to make an unarmed foot attack against the attacking creature (if they are within reach). This attack takes a -5 penalty, but the creature is flat-footed for it.`,
            initiationAction: `immediate`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 ally`,
          },
          {
          school: `shadowAssassin`,
          level: 3,
          name: "Shroud of Darkness",
          type: "Strike",
          longDesc: `[Shadow Initiation] Make a melee attack, if successful, it deals damage as normal and the creature must make a will save or it has its vision hampered for 1d4 rounds. The creature's vision becomes limited to 10 feet. Only See in the Dark and blindsight can foil this.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `1d4 rounds`,
          target: `1 enemy`,
          additionalInfoTags: ['Shadow Initiation'],
          },
          {
          school: `shadowAssassin`,
          level: 3,
          name: "Umbral Blades",
          type: "Strike",
          longDesc: `[Shadow Initiation] Make a full-round attack. Each attack does 1d6 points of negative energy damage. At level 9 and 18, the negative energy damage increases by 1d6.`,
          initiationAction: `full-round`,
          range: `melee or ranged attack`,
          duration: `instantaneous`,
          target: `1 enemy`,
          additionalInfoTags: ['Shadow Initiation'],
          },
          {
          school: `shadowAssassin`,
          level: 3,
          name: "Shiv",
          type: "Strike",
          longDesc: `You make a single melee attack against a creature, instead of normal damage, it only deals your sneak attack damage. They are flat-footed for the attack and the attack ignores their armor bonus to armor class. If the creature has immunity or resistance to sneak attack, the target has its chance to resist it reduced by 25% for this attack, and if it is successful, their fortification against sneak attack damage stays reduced by 25% for the rest of your turn.`,
          initiationAction: `swift`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 enemy`,
          },
          {
          school: `shadowAssassin`,
          level: 3,
          name: "Bunshin Daibakuha ",
          type: "Strike",
          longDesc: `You cause all of your shadows to explode, dealing 1d4 points of negative energy damage to all adjacent creatures for every 2 rounds of duration they had left. At level 9 it becomes 1d4 for every round of duration they had left. Creatures can make a will save to halve the damage. The damage of the shadows is combined for a creature in the area of multiple shadows.`,
          initiationAction: `standard`,
          range: `-`,
          duration: `instantaneous`,
          target: `your shadows`,
          },
          {
            school: `shadowAssassin`,
            level: 2,
            name: "Shadow Grasp",
            type: "Boost",
            subSchool:['shadowTechnique'],
            longDesc: `[Shadow Technique] You initiate this when an enemy takes a 5-foot step away from you, even if it is not your turn. You take a 5-foot step towards them, and they become entangled for 1 round. At level 9, you can initiate this if they move less than 10 feet away from you, and you can move up to 10 feet to follow them. At leve 18 you can follow up to 15 feet. The movement of this maneuver doesn't provoke against the followed creature, but provokes from others.`,
            initiationAction: `free`,
            duration: `1 round`,
            target: `1 enemy`,
            additionalInfoTags: ['Shadow Technique'],
          },
          {
            school: `shadowAssassin`,
            level: 3,
            name: "Black Moon",
            type: "Counter",
            longDesc: `When a threatened enemy moves out of your threatened area, even with teleportation, as long as you can still see them, you can initiate this counter to create a shadow adjacent to them at the end of their movement, which can take an immediate attack against them. They may make an opposed perception check against your stealth, or the attack is against their flat-footed armor class. If this movement was used to avoid an attack or ability of yours, the shadow's sneak attack gained from <shadow> maneuvers is doubled.`,
            initiationAction: `immediate`,
            duration: `shadow`,
            target: `1 enemy`,
          },
          {
          school: `shadowAssassin`,
          level: 3,
          name: "Reaper's Close",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] You initiate this before initiating a melee strike. The target of the strike must be the target of this maneuver. You must not be adjacent or threatening the target of this maneuver when you initiate it. Make a stealth check to hide from the creature while moving 10 feet towards it. Increase the distance moved by 5 feet for every 10 ranks of stealth you have. You do not need cover to make this stealth check, nor is it foiled by supernatural sights, but you only count as hiding from the target of the maneuver, and this is broken as normal once you make an attack, or at the end of your turn.`,
          initiationAction: `free`,
          duration: `1 turn`,
          target: `1 enemy`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
          school: `shadowAssassin`,
          level: 3,
          name: "Shadow Weave",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] You can initiate this after completing a strike. Make a stealth check, move a distance equal to half the result of the check, this doesn't provoke. Any creature that threatens you during the movement takes a -2 penalty on attacks against you for 1 round. For every 2 differnet squares adjacent to a creature that you move through, the penalty increases by -1.`,
          initiationAction: `free`,
          range: `personal`,
          duration: `1 round`,
          target: `you`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
          school: `shadowAssassin`,
          level: 4,
          name: "5 Point Strike",
          type: "Strike",
          longDesc: `[Shadow Initiation] You throw a flurry of ranged attacks in a cone in a 20 foot cone in front of you. The amount of attacks a creature takes depends on their distance from you:
          \nAdjacent: 4 attacks.\n10-15ft: 2 attacks.\n20ft: 1 attack, plus the target has its movement speed reduced by half and takes a -2 penalty to armor class and reflex saves for 1 round.
          \nYou can conjure shadowy projectiles to make this attack, however if you do, you receive a -4 to the attack rolls, they otherwise function as shuriken with with an enhancement bonus equal to your highest level Shadow Assassin maneuver.`,
          initiationAction: `standard`,
          range: `20ft. Cone`,
          duration: `instantaneous`,
          target: `1 or more enemies`,
          additionalInfoTags: ['Shadow Initiation'],
          },
          {
          school: `shadowAssassin`,
          level: 4,
          name: "Twilight Shroud",
          type: "Boost",
          longDesc: `You throw down a shroud of shadowy mist. This has a range of 30 feet and creates a shroud in a 15ft. square that lasts 1d4 plus half initiation modifier rounds. While inside of the shroud you gain 2d6 sneak attack damage, partial concealment (except from blindsight), and once per round you can use a free action to attempt a stealth check to hide (movement not included). The shroud counts as cover for whether or not you can make stealth checks from all creatures except those with blindsight. This doesn't hamper your vision.`,
          initiationAction: `standard`,
          range: `50ft. Area: 15ft. Square`,
          duration: `1d4 + 1/2 initiation modifier rounds`,
          target: `location`,
          },
          {
          school: `shadowAssassin`,
          level: 4,
          name: "Shadow Dance",
          type: "Boost",
          longDesc: `[Shadow Strike] Choose a target then make a stealth check. If the target is within feet equal to half the result of the check, you can move towards the creature, moving a distance equal to the result of the check, and if the check was higher than their perception bonus -11, you are also hidden from them for this movement, even foiling supernatural vision. You must end your movement threatening them. You then make a single melee attack against them for which they are flat-footed. The attack does not deal normal damage, instead it deals only your sneak attack damage. The damage is dealt even if the creature is immune to becoming flat-footed (but not if they are immune to sneak attack).`,
          initiationAction: `swift`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 enemy`,
          },
          {
          school: `shadowAssassin`,
          level: 4,
          name: "Paranoia",
          type: "Strike",
          longDesc: `[Shadow Initiation] Make an attack, if successful, the attack deals damage as normal plus 2d6, and their shadow becomes one of your shadows for half your shadow's normal duration (minimum 2 rounds). A successful will save reduces this to 1 round. It follows their movement, even teleportation, and always stays on the opposite side of them for you. If you desire you can have the shadow instead act as their shadow so they are unaware this is happening, requiring a stealth check.`,
          initiationAction: `standard`,
          range: `melee or ranged attack`,
          duration: `shadow/2`,
          target: `1 enemy`,
          additionalInfoTags: ['Shadow Initiation'],
          },
          {
            school: `shadowAssassin`,
            level: 5,
            name: "Shadow Bind Technique",
            type: "Strike",
            longDesc: `[Shadow Initiation] Make a touch attack, if successful it deals no damage, but you can attempt to bind their shadow to your will. They must make a will save, if they fail, you gain control of their shadow until the end of your next turn, which in turns also controls them. During the targets next turn they can only take purely mental actions, and then during your turn any action you take, they take, replicating your movements exactly. This includes all actions, even those not normally able to be taken by the creature, possibly making them able to move in supernatural ways. They move the directions you move, the distance you move (proportional to their movement speed of that type, except magical flight, in which case they move the exact distance you move), they even make attacks into the squares you attack. However, all of these actions are taken in reference to their position, not yours, so if you attacked a creature directly to your north, it would attack directly north from its location. During this, because it is replicating your actions exactly, it uses your physical ability scores to determine its abilities. This also does not replicate any supernatural effects or abilities that you take, only your physical actions. 
            \nWhenever you attack, either you or the controlled creature takes a -2 penalty on attack and damage rolls (your choice). If the creature is wielding a weapon of a different shape as yours, you can choose for either you or them to take a -2 penalty to attack and damage rolls.
            \nIf you and the controlled creature are both attacking something at the same time, if you are not both targetting proportionally identically sized creatures, the attacks take a -2 penalty for each size difference.
            \n\nIf you try to cause a creature to attack themselves with this, they recieve an additional will save to end the effect. If their shadow would be removed during this duration, such its area becoming complete darkness, or all encompassed by light, the effect ends immediately.`,
            initiationAction: `standard`,
            range: `touch attack`,
            duration: `1 round`,
            target: `1 enemy with a shadow`,
            additionalInfoTags: ['Shadow Initiation'],
          },
          {
            school: `shadowAssassin`,
            level: 4,
            name: "Expose Weakness",
            type: "Strike",
            longDesc: `[Shadow Initiation] Make a melee attack against a creature, it deals an additional 4d6 sneak attack damage. If it hits and the creature has a chance to negate critical hits and sneak attacks, it has the chance reduced by 50% for 1d4 rounds. It can roll a fortitude save to reduce this percentage down to 25%.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `1d4 rounds`,
            target: `1 enemy`,
            additionalInfoTags: ['Shadow Initiation'],
          },
          {
          school: `shadowAssassin`,
          level: 4,
          name: "Smoke and Shadow",
          type: "Counter",
          longDesc: `When you are targeted by an attack roll or allowed a reflex save vs an ability or spell, you can initiate this counter. Make a stealth check vs the attack, or make the reflex save, if successful the attack is redirected to a shadow in one of the two following ways (your choice of which):
          \n1: Teleport 10 feet and leave a shadow in your place to take the attack or effect. The shadow lasts half the duration. If the effect was an AoE and this does not take you out of the range of the effect, you are still also struck.
          \n2: Swap places with one of your shadows within 50 feet, it takes the attack in your place. Afterwards, If it is within melee reach of the creature who triggered this attack and still alive, it can make an immediate counter attack.  `,
          initiationAction: `immediate`,
          range: `personal`,
          duration: `shadow/2`,
          target: `you`,
          },
          {
          school: `shadowAssassin`,
          level: 4,
          name: "None Can Escape Their Shadow",
          type: "Counter",
          longDesc: `You initiate this counter when a creature within 10 feet of you or one of your shadows moves or teleports (or during your turn whenever you want). You dissolve into shadow, combining with their shadow. If triggered by movement near a shadow, you first teleport to the location of your shadow and consume it and then combine with the target's shadow. After they finish their movement or teleportation you exit from their shadow, appearing any empty square within 10 feet of them. If the creature used this teleportation or movement to negate one of your attacks, when they finish their movement you can make a single melee attack against them. When you combine with their shadow you can make a stealth check opposed by their perception check, special sights do not grant any kind of bonus or foil your stealth during this. If you win the opposed check, the target is flat-footed for your attack.
          \nWhen using this counter, if you win the opposed stealth check you can also choose to stay hidden inside of their shadow for up to initiation modifier rounds, however special sights that see auras can detect you now.`,
          initiationAction: `immediate`,
          range: `10 feet`,
          duration: `instantaneous`,
          target: `1 enemy with a shadow`,
          },
          {
          school: `shadowAssassin`,
          level: 4,
          name: "Shadow Haunter",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] You can initiate this technique after missing a creature with a strike. That creature is marked for 1 round. If a marked creature attempts to move, it provokes an attack of opportunity from you, even if it normally wouldn't, such as if they take a 5-foot step, use acrobatics to avoid you, teleport, or withdraw. The first attack of opportunity you make against a marked creature because of this ability catches the creature flat-footed.`,
          initiationAction: `free`,
          range: `melee attack`,
          duration: `2 rounds`,
          target: `1 enemy`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
          school: `shadowAssassin`,
          level: 4,
          name: "Walk the Shadow Path",
          type: "Boost",
          longDesc: `For 1 round you can swap places with your shadows as a free action, and the first time you swap with a shadow, it does not reduce its duration. You cannot swap with an individual shadow more than once.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `1 round`,
          target: `you`,
          },
          {
          school: `shadowAssassin`,
          level: 4,
          name: "Specter",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] You can initiate this at any point of a strike. Swap places with a shadow. You and the shadow complete the action the other was taking.`,
          initiationAction: `free`,
          range: `medium (100ft. + 10ft./level)`,
          duration: `instantaneous`,
          target: `shadow`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
          school: `shadowAssassin`,
          level: 4,
          name: "Assassin's Treachery",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] You can initiate this after making a successful melee strike. Make a dirty trick against a creature you successfully hit with your melee strike. This doesn't provoke.`,
          initiationAction: `free`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 enemy`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
          school: `shadowAssassin`,
          level: 5,
          name: "Memento Vivere",
          type: "Stance",
          longDesc: `You gain 2d6 points of sneak attack damage in this stance. If a creature you are attacking has a chance to ignore sneak attack damage, you ignore it. If the creature has immunity to sneak attacks or critical hits, it instead only has 50% chance to ignore your critical hits and sneak attacks. Creatures with uncanny dodge are no longer unable to be caught flat-footed by you, and creatures with improved uncanny dodge are no longer unable to be flanked by you, instead each have a 50% chance each round for your flat-footed or flanking attacks to catch them unaware and count as flanking or flat-footed.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
          school: `shadowAssassin`,
          level: 5,
          name: "Shadow Eater",
          type: "Stance",
          longDesc: `Whenever one of your shadows is consumed, you heal 1/4 of the hit points it had remaining. Whenever a shadow is destroyed by an enemy, you heal 1d6 points for every round of duration it had left. Whenever you kill an enemy that has at least half of your hit dice, you summon a shadow on a square adjacent to the creature, however it lasts half its normal duration. As a free action while adjacent to a shadow, you can consume them to instead heal 1/3 of their remaining hit points (doesn't stack with the healing as described before). You can as a swift action consume them at any range. You can only take these actions in combat, and only one of each per round. When you are healed, all shadows also heal half as many hit points.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
            school: `shadowAssassin`,
            level: 6,
            name: "Black Gate",
            type: "Stance",
            longDesc: `Once during each of your turns, you can as a free action create a shadow within 10 feet of you. You can have only single shadow created from this stance at a time, however when you create a second shadow, the other one remains for the rest of the current turn. The most recent shadow you created with this stance has its damage percentage increased by 20% and you can flank with it.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `stance`,
            target: `you`,
          },
          {
          school: `shadowAssassin`,
          level: 5,
          name: "Shadow Ravage",
          type: "Strike",
          longDesc: `[Shadow Initiation] You make a full-round attack. All shadow's can also make a single attack against a creature they threaten. These attacks gain a bonus 1d6 points of sneak attack damage for each other shadow that is attacking that target.`,
          initiationAction: `full-round`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `one or more enemies`,
          additionalInfoTags: ['Shadow Initiation'],
          },
          {
          school: `shadowAssassin`,
          level: 5,
          name: "Perfect Execution",
          type: "Strike",
          longDesc: `When you initiate this maneuver, you move any distance between 20 and 40 feet in a straight line in any direction (even straight up) directly towards the target of the strike, this movement must move you through a square adjacent to the target. Then when you are adjacent, you make a single melee attack against them at a -5 penalty. If you have more movement remaining after the attack (You must move at least 20 feet, but you can take the attack any point during that movement) you keep moving after the attack. After you do this, this manuever is not expended as normal, instead, after 2 rounds it becomes available again, then you have 2 rounds to activate it again as a swift action. Doing this allows you to move in a straight line the same distance you moved when you originally activated it, but now you do not have to move towards a target. Once during the reactivation, If you do move through a square adjacent to an enemy, you can take a single melee attack against them at -5. If the original target of this strike is the creature attacked during the reactivation, you get a +2 bonus on the attack and the creature is flat-footed for the attack. If they were already flat-footed for the attack then you instead gain +2 to attack and 4d6 sneak attack damage for it. During movement for this maneuver, you can move through creature's squares without requiring an acrobatics check, though your movement may still provoke, however you can make a stealth check in place of an acrobatics to avoid AoO's, and doing so with either acrobatics or stealth does not reduce the distance you move.`,
          initiationAction: `movement;see text`,
          range: `adjacent enemy`,
          duration: `4 rounds`,
          target: `1 enemy; see text`,
          },
          {
          school: `shadowAssassin`,
          level: 5,
          name: "Shadow Slash",
          type: "Strike",
          longDesc: `[Shadow Initiation] You make a melee attack against all enemies within reach. All of your shadows make an attack against all adjacent creatures. These attacks gain a +1 bonus and 2d6 points of damage for other shadow attacking the same creature.`,
          initiationAction: `full-round`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 or more enemies`,
          additionalInfoTags: ['Shadow Initiation'],
          },
          {
          school: `shadowAssassin`,
          level: 5,
          name: "Assassin's Surge",
          type: "Boost",
          longDesc: `This maneuver does not function like a standard maneuver, and it is not expended until after its duration has ended. When initiated you gain level/2 + initiation modifier surge points that last 1 round that you can spend at any point in the round (does not require an action) to recover maneuvers. After the round, Assassin's Surge expended as normal, however, it is not recoverable the normal way, instead you must recharge this maneuver times equal to half the amount of surge points spent. When you are recovering multiple maneuvers at once, you can recover it multiple times at once. Per surge point spent, you heal 1d8 hit points. The following list is the cost of recharging different maneuvers:
          \n1 point per maneuver level to recharge <shadow> and <death> maneuvers\n1 point per 2 maneuvers levels (rounded up) for [Shadow Technique] maneuver\n2 points per maneuver level for a maneuver of different schools`,
          initiationAction: `movement`,
          range: `personal`,
          duration: `1 round`,
          target: `you`,
          },
          {
          school: `shadowAssassin`,
          level: 5,
          name: "Chasing Shadows",
          type: "Counter",
          longDesc: `You make this counter at any time, except in response to a hostile action against you. You swap places with one of your shadows.`,
          initiationAction: `immediate`,
          range: `medium (100ft. + 10ft./level)`,
          duration: `instantaneous`,
          target: `shadow`,
          },
          {
          school: `shadowAssassin`,
          level: 5,
          name: "Hunting Shadow Technique",
          type: "Boost",
          longDesc: `When you activate this boost, choose one of your shadows. It can immediately move up to its movement speed, then for rounds equal to half your initiation modifier; attacks against it suffer a 50% miss chance, increase its damage percentage by 50%, and it doesn't have a maximum distance before it dissipates. If its movement ends it threatening a creature, it can take attacks of opportunity against that creature for 1 round.`,
          initiationAction: `swift`,
          range: `-`,
          duration: `1/2 initiation modifier rounds`,
          target: `shadow`,
          },
          {
          school: `shadowAssassin`,
          level: 5,
          name: "Assassin's Mark",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] Can be initiated after successfully damaging an enemy with a melee strike. The target becomes marked for initiation modifier rounds. If within that duration, any turn ends with them further than 50 feet away from you, the mark becomes prepped. If you deal damage to a creature with one of your prepped marks, the attack deals an additional 1d6 points of precision damage per 2 initiator levels (shadows still reduce this damage as normal).`,
          initiationAction: `free`,
          range: `reach`,
          duration: `initiation modifier rounds`,
          target: `1 enemy`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
          school: `shadowAssassin`,
          level: 5,
          name: "Melt Into the Shadows",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] Can be initiated after finishing a strike and when not in bright light. Make a stealth check to hide (movement not included). You do not need cover to do this, and your stealth doesn't end for not having cover for 1 round, and creatures with supernatural sights such as blindsight or lifesense do not automatically foil this, and still have to make an opposed perception check as normal, though they do gain a +5 bonus to their perception roll to detect you.`,
          initiationAction: `free`,
          range: `personal`,
          duration: `1 round`,
          target: `you`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
          school: `shadowAssassin`,
          level: 5,
          name: "Moonlit Haunting",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] You can initiate this technique at any point during a strike directly before the strike allows you to move. Leave a shadow in the square before moving.`,
          initiationAction: `free`,
          range: `personal`,
          duration: `shadow/2`,
          target: `you`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
          school: `shadowAssassin`,
          level: 4,
          name: "Shadows Everywhere",
          type: "Boost",
          longDesc: `You summon a shadow at any location within close range, even if you can't see the target location. You can see through this shadow's eyes at the same time as seeing through yours. You can swap places with it as a free action once per round, though this reduces its duration by 3 rounds instead of 1.`,
          initiationAction: `movement`,
          range: `close (25ft. + 5ft./2 levels)`,
          duration: `shadow/2`,
          target: `location`,
          },
          {
          school: `shadowAssassin`,
          level: 6,
          name: "Midnight",
          type: "Stance",
          longDesc: `While this stance is active, you can see through magical darkness for 60 feet. You surround yourself and all shadows with a circle of darkness with a radius of 5 feet. Only creatures that can see through magical darkness or those with blindsight can see through this darkness.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
          school: `shadowAssassin`,
          level: 6,
          name: "Shadow March",
          type: "Strike",
          longDesc: `[Shadow Initiation] You and all of your shadows can move up to their movement speed and make a single attack, or make a single attack and then move. You must all take the same order of actions.`,
          initiationAction: `full-round`,
          range: `melee or ranged attack`,
          duration: `instantaneous`,
          target: `1 or more enemies`,
          additionalInfoTags: ['Shadow Initiation'],
          },
          {
          school: `shadowAssassin`,
          level: 6,
          name: "Shadow Gangstalking",
          type: "Strike",
          longDesc: `Pick a creature. All shadows threatening that creature may make a melee attack against them. If their attacks are successful, they bind themselves to the target for 2 rounds, following them whenever they move, no matter the distance (even through teleportation). While following creatures this way, their movement does not provoke attacks of opportunity. When they finish moving with the creature, they can end their movement in any square adjacent to that creature of your choice.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `3 rounds`,
          target: `1 enemy`,
          },
          {
          school: `shadowAssassin`,
          level: 7,
          name: "Cut the Last Breath",
          type: "Strike",
          longDesc: `[death] While you have this strike readied, you automatically know if any creature you can see within 5 feet of you or a shadow is below 20% hit points. When you initiate this strike, you make an attack against the creature, if the attack is successful and they are below 20% hit points, they die. If they are below 33% hit points, they instead are allowed a fortitude save to avoid death, but for every 2% below 33% hit points they are, they recieve a -1 penalty on the save. If the creature is below 20% hit points or below 33% and fails the save but is immune to death effects, the attack is instead an automatic critical hit and your sneak attack damage is multiplied by the critical damage multiplier. 
          \nIf the creature remains conscious below 0 hit points, factor half its negative hit points in to what hit points it must be at to die from this maneuver.`,
          initiationAction: `standard`,
          range: `30 feet`,
          duration: `instantaneous`,
          target: `1 enemy`,
          },
          {
          school: `shadowAssassin`,
          level: 6,
          name: "Shadow Shield",
          type: "Counter",
          longDesc: `You can consume as many of your shadows as you'd like, gathering their essence to you. This graints you temporary hit points equal half the remaining hit points of all of the shadows you gathered. If done in response to a hostile action, these temporary hit points are gained before you take damage from the action, and if done in response to needing to make a saving throw, you gain a +1 bonus to the save for every 3 rounds of duration each shadow consumed had left.`,
          initiationAction: `immediate`,
          range: `personal`,
          duration: `3 rounds`,
          target: `you`,
          },
          {
          school: `shadowAssassin`,
          level: 7,
          name: "Amenotejikara",
          type: "Counter",
          longDesc: `You can initiate this counter at any point, but also in response to an attack roll being made against you or against an effect or spell that targets an area you are within. Target a creature or object, they must make a will save or you and them swap locations (if unattended object it makes no save), they take the attack or effect in your place. The target must be within 2 sizes of you.`,
          initiationAction: `immediate`,
          range: `close (25ft. + 5ft./2 levels)`,
          duration: `instantaneous`,
          target: `1 creature or object`,
          },
          {
          school: `shadowAssassin`,
          level: 6,
          name: "Shadow Chain",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] You can initiate this technique after successfully hitting a creature with a melee strike. You tangle them in shadow chains, they must make a reflex saving throw or they become entangled and cannot make any attacks of opportunity for 1d3 rounds.`,
          initiationAction: `free`,
          range: `melee attack`,
          duration: `1d3 rounds`,
          target: `1 enemy`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
          school: `shadowAssassin`,
          level: 6,
          name: "Lethal Shadow",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] You can initiate this technique after successfully hitting a creature that is flanked by 1 or more of your shadows. The flanking shadows make an attack against the creature.`,
          initiationAction: `free`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 enemy`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
          school: `shadowAssassin`,
          level: 6,
          name: "Shadow Dagger",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] You can initiate this technique after successfully hitting a creature that is flat-footed with a melee attack. Make a ranged touch attack against the creature, it is flat-footed for the attack. If it hits they take damage equal to your sneak attack damage, except that it is negative energy damage and they must make a reflex save or they become blinded for 1d4 rounds.`,
          initiationAction: `free`,
          range: `close (25ft. + 5ft./2 levels)`,
          duration: `1d4 rounds`,
          target: `1 enemy`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
          school: `shadowAssassin`,
          level: 6,
          name: "Thrashing Shadow Style",
          type: "Stance",
          longDesc: `When you enter this stance, and once per round as a swift or movement action, you can summon one of your shadows that is within 30 feet of you to coat your body. Doing so makes it follow along with you, sharing your square. This grants you temporary hit points equal to 50% of the hit points it had remaining. If those temporary hit points are lost, the shadow dissipates. While the shadow is bound to you this way, every time you make a full-round attack, the shadow also is able to take a single attack at its highest bonus, dealing your normal shadow, except your sneak attack damage is not reduced by the normal percentage. If you initiate a strike that allows you and your shadows to attack, this shadow also takes the attack as normal. You can have up to half your initiation modifier of shadows surrounding you. Whenever you take damage, the temporary hit points granted by this maneuver are always lost first, even before other temporary hit points, and the temporary hit points are lost from the most recent shadow you bound to you.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
          school: `shadowAssassin`,
          level: 7,
          name: "Sealed Fate",
          type: "Strike",
          longDesc: `You leave a shadow in your current position and then teleport up to medium range and make a melee attack against a creature, the attack deals an additional 6d6 damage. If the attack misses, the duration of this is reduced to 2 rounds, otherwise, for 4 rounds the target of the attack becomes marked for death. During this time, every time they take damge from one of your attacks they receive a shadow mark, unless it is done through a shadow, in which case they recieve one shadow mark. At the end of the duration, they take 1d6 points of damage for each shadow mark on them. If you are further than 100 feet away from the target when the death mark triggers, the damage is doubled. You can have only a single death mark at a time. You can trigger the mark prematurely as a movement action.`,
          initiationAction: `full-round`,
          range: `medium (100ft. + 10ft./level)`,
          duration: `4 rounds`,
          target: `1 enemy`,
          },
          {
          school: `shadowAssassin`,
          level: 6,
          name: "Deathly Hollow",
          type: "Counter",
          longDesc: `You can initiate this counter in response to making a saving throw or when a creature attacks you. Make a stealth check opposed by their attack roll or in place of the saving throw. Success causes the attack to miss or the save to succeed and allows you to move up to your movement speed, or swap places with a shadow, and then become hidden for 1 round, completely undetectable by the creature you used this counter against. This stealth check can also be used to hide from other creatures assuming you are able to.`,
          initiationAction: `immediate`,
          range: `personal`,
          duration: `1 round`,
          target: `you`,
          },
          {
          school: `shadowAssassin`,
          level: 7,
          name: "The Shadow Becomes Me",
          type: "Stance",
          longDesc: `Become quasi-intangible, similar to your shadows. You gain 50% critical hit immunity, reduce all damage you take by 50%, and all targeted spells that don't deal damage have 50% chance to miss you. Light damage deals double damage to you instead of 50% while in this stance.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
          school: `shadowAssassin`,
          level: 7,
          name: "Ambush",
          type: "Strike",
          longDesc: `Right as you are about to make a melee attack against an enemy, two shadows are summoned adjacent to the target of the attack, they cannot be adjacent to you or each other, but can otherwise be summoned in any squares adjacent to the creature. You and both shadows then make a melee attack against an enemy, each deals 4d6 bonus sneak attack damage. You can swap places with one of the shadows summoned by this maneuver as a free action on the round you initiated it.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `shadow`,
          target: `1 enemy`,
          },
          {
          school: `shadowAssassin`,
          level: 7,
          name: "Shadow Infusion",
          type: "Boost",
          longDesc: `You consume up to 3 of your shadows within close range. Doing causes your attacks to deal additional damage equal to what your shadows deal. This lasts rounds equal to the amount of shadows consumed. Your shadow must have at least 5 rounds of duration left to use this ability on it. For every 5 rounds of duration each shadow had longer than 5 rounds, this boost lasts an additional round. Consuming additional shadows only increases the duration, not the bonus damage changes to shadow damage during this ability affects the damage it deals as well.`,
          initiationAction: `swift`,
          range: `25ft. + 5ft./2 levels`,
          duration: `see text;`,
          target: `shadows`,
          },
          {
          school: `shadowAssassin`,
          level: 7,
          name: "Knife in the Back",
          type: "Counter",
          longDesc: `When a creature that you can see and is at least 30 feet away from you is about to make an offensive action against you, including things such as ranged attacks, casting ranged spells against you, or using a supernatural ability that would affect you, you can initiate this counter to interrupt the action, summoning a shadow any square adjacent to them. You can then choose for it to make an immediate attack against them for which they become flat-footed for (possible interrupting the ability, such as the damage causing a concentration check), or to swap places with the shadow. If you swap places with a shadow and your new location would remove you from the area of the effect or make you untargettable by that ability, you avoid it.`,
          initiationAction: `immediate`,
          range: `close (25ft. + 5ft./2 levels)`,
          duration: `instantaneous`,
          target: `1 enemy`,
          },
          {
          school: `shadowAssassin`,
          level: 7,
          name: "Hidden Shadow Snake Hand",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] You can initiate this technique after damaging a creature through a shadow with a [shadow technique] maneuver. You pin their shadow in place, making them unable to move more than 5 feet away from their current location for 1d4 rounds. The creature can use a standard action to make a CMB or escape artist check to free themselves. The DC for this is equal to your stealth bonus plus your initiation modifier, and any other bonuses you have to the DC of Shadow Assassin Maneuvers.`,
          initiationAction: `free`,
          range: `close (25ft. + 5ft./2 levels)`,
          duration: `1d4 rounds`,
          target: `1 enemy with a shadow`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
          school: `shadowAssassin`,
          level: 7,
          name: "Shadow Ambush",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] You can initiate this technique after summoning a shadow that is within melee reach of a creature. It can make a single melee attack against them. The target is flat-footed for the attack. It deals full sneak attack damage, however it cannot make any further attacks against the creature until the start of your next turn.`,
          initiationAction: `free`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 enemy`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
          school: `shadowAssassin`,
          level: 8,
          name: "Haunting Presence",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] You can initiate this technique when teleporting to the space of or swapping places with a shadow, and it can be initiated even when it is not your turn, but lasts for 1 full round. Any creature in between you and your target location takes negative energy damage equal to your sneak attack damage, though can make a will save to halve it. If you strike the same creature twice in one round, it must also make a fortitude save or it is stunned for 1 round. Every additional time you strike a creature with this on the same round the DC increases by +2. Swapping places with the same shadow does not activate this effect multiple times.`,
          initiationAction: `free`,
          range: `personal`,
          duration: `1 round`,
          target: `you`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
          school: `shadowAssassin`,
          level: 7,
          name: "Black Sakura",
          type: "Strike",
          longDesc: `You begin making a melee attack against a creature while also summoning a shadow on the opposite side of them in a flanking position, then, at the last moment, you swap places with the shadow. First, make a stealth check vs their perception, then make an attack roll for you and your shadow. If the opposed stealth check is successful, both attacks are at the creature's flat-footed armor class and have their sneak attack damage multiplied by your critical damage multiplier. For this attack, the shadow's damage percentage is increased by 50%. If the creature is normally unable to be caught flat-footed, they are allowed a reflex save against this, success causes the attacks to no longer multiply your sneak attack damage, but the attacks are still made against their flat-footed armor class.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 enemy`,
          },
          {
          school: `shadowAssassin`,
          level: 7,
          name: "Beyond the Limit",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] You can initiate this technique to initiate an expended maneuver. When you do this, that maneuver becomes unrecoverable for the rest of the floor and you take 2 points of constitution drain.`,
          initiationAction: `free`,
          range: `personal`,
          duration: `instantaneous`,
          target: `you`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
          school: `shadowAssassin`,
          level: 7,
          name: "Inevitability",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] You can initiate this technique after successfully striking a creature with a melee attack with a shadow. Swap places with that shadow and make a single melee attack against the creature the shadow struck with a -10 penalty. It cannot be a creature you have personally attacked this turn, nor can you make any further attacks against them. You also cannot swap places with a shadow again until the start of your next turn.`,
          initiationAction: `free`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `shadow`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
          school: `shadowAssassin`,
          level: 6,
          name: "Black Swan",
          type: "Strike",
          longDesc: `[Shadow Initiation] You make a melee attack against a creature, the attack is at the creature's flat-footed armor class, and if it hits, your sneak attack is doubled, or tripled if initiated through a shadow. If this attack brings the creature below 25% hit points, or they were already below 25% hit points when you struck them, you may make another attack against them for which they are also flat-footed against, however your sneak attack is not doubled unless delivered through a shadow. If this kills a creature, you recover this maneuver immediately, and your choice of either a random maneuver or a <shadow/death> maneuver of choice that is level 5 or below.`,
          initiationAction: `standard`,
          range: `melee attack`,
          duration: `instantaneous`,
          target: `1 enemy`,
          additionalInfoTags: ['Shadow Initiation'],
          },
          {
          school: `shadowAssassin`,
          level: 8,
          name: "Onslaught of Darkness",
          type: "Strike",
          longDesc: `You and all shadows with the range can make a full-round attack. You cannot initiate this maneuver the round you recover it, or recover it the round you initiate it. For each attack taken, your shadows have their duration reduces by 1 round (this is on top of the usual duration reduction).`,
          initiationAction: `full-round`,
          range: `50 feet`,
          duration: `instantaneous`,
          target: `1 or more enemies`,
          },
          {
          school: `shadowAssassin`,
          level: 8,
          name: "Pitch Black Night",
          type: "Strike",
          longDesc: `You summon a shadow adjacent to all enemies you can see within 50 feet of you, up to a maximum amount of shadows equal to your initiation modifier. All of them make a single melee attack against the creatures they were created adjacent to. These shadows only last half as long as shadows normally do, and if you initiate this strike again, the shadows created by the previous initiation dissipate.`,
          initiationAction: `full-round`,
          range: `50 feet`,
          duration: `shadow`,
          target: `1 or more enemies`,
          },
          {
          school: `shadowAssassin`,
          level: 8,
          name: "Omnipresence",
          type: "Stance",
          longDesc: `You can see through all of your shadows all at once, including seeing through darkness, even magical darkness. You can choose to swap locations with a shadow as a free action, though this reduces its duration by 3 rounds instead of 1. When activating a [Shadow Initiation] maneuver through a shadow, you do not reduce their duration. You and other allies can flank with your shadows. When you are flanking with a shadow you gain 2d6 points of sneak attack damage, plus an additional 1d6 for each other shadow threatening them. Your shadows can make attacks of opportunity and threaten in melee. Each shadow can make a single attack of opportunity each turn for free, but can take additional attacks of opportunity by expending 1 round from its duration. Your shadows are considered to have all of your teamwork feats for the bonuses they gain and give to other shadows.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          additionalInfoTags: ['Shadow Initiation'],
          },
          {
          school: `shadowAssassin`,
          level: 8,
          name: "Raw Talent",
          type: "Stance",
          longDesc: `You can recover a single [Shadow Technique] of your choice every round as a free action. You cannot use a [Shadow Technique] you recovered this round this way, nor can you recover one the round that you used it. You can use 2 [Shadow Technique] maneuvers every round, even multiple on the same triggering action. If you attack a creature and kill them, you can recover 1 <shadow> or <death> maneuver, and you restore hit points and gain temporary hit points equal to the slain creatures HD. The temporary hit points last until the end of combat. The slain creature must have at least 1/2 your HD to activate these effects.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
          school: `shadowAssassin`,
          level: 8,
          name: "Endless Darkness",
          type: "Boost",
          subSchool:['shadowTechnique'],
          longDesc: `[Shadow Technique] You can initiate this technique after successfully hitting a creature with a strike. You summon a shadow in a square adjacent to them. It lasts half its normal duration.`,
          initiationAction: `free`,
          range: `close (25ft. + 5ft./2 levels)`,
          duration: `shadow/2`,
          target: `1 enemy`,
          additionalInfoTags: ['Shadow Technique'],
          },
          {
          school: `shadowAssassin`,
          level: 8,
          name: "Silent Mist",
          type: "Strike",
          longDesc: `Make a stealth check and move that distance without provoking attacks of opportunity. This movement must be in a straight line, but can be any direction (even straight up), and during this movement you can move through creatures, solid objects, or difficult terrain without any adverse effect. Afterwards, you make a single melee attack against a creature. If the attack is successful, you teleport to the opposite side of them into any square that would have been flanking with your original position, while also leaving a shadow behind in the previous square. The shadow then can make an attack against them at a -10 penalty, if this attack misses, the shadow's duration is halved.`,
          initiationAction: `swift`,
          range: `see text;`,
          duration: `instantaneous`,
          target: `1 enemy`,
          },
          {
          school: `shadowAssassin`,
          level: 8,
          name: "Umbral Trespass",
          type: "Counter",
          longDesc: `[Shadow Initiation] You become a living shadow and tresspass into the creature's essence. You can initiate this counter in response to any action made by a creature within 10 feet of you or one of your shadows, and it interrupts that action, potentially negating it. Make a stealth check verses the creature's CMD, if you succeed, you bind yourself to their essence, becoming untargetable and immune to damage, except damage from light effects and spells for which you take double the normal amount (including if the creature you are tresspassing within takes light damage). You remain in the creature's body, unable to take any actions until the end of your next turn, where you burst out from the creature, appearing somewhere within 15 feet of them, dealing damage as if you had struck them with with a single melee weapon plus double your sneak attack damage. This sneak attack damage bypasses fortification, and treat creatures that are immune to sneak attack damage as having 50% fortification instead. When you burst out from the creature the damage counts as a [Shadow Strike] for initiating [shadow techniques]. While inside of the creature you are still aware of your surroundings.
          \nIf you use this through one of your shadows, you teleport to its square, consuming it, and then bind to the target's essense.`,
          initiationAction: `immediate`,
          range: `10 feet`,
          duration: `1 round`,
          target: `1 enemy`,
          additionalInfoTags: ['Shadow Initiation'],
          },
          {
          school: `shadowAssassin`,
          level: 9,
          name: "Forbidden Secrets of The Black Silence",
          type: "Stance",
          longDesc: `You gain 4d6 points of sneak attack damage while in this stance. You can redirect damage and offensive effects to one of your shadows. Doing so is a free action you can take even when not your turn, but reduces that shadow's duration by 1 round if it was damage, and 3 rounds if it was a saving throw. You cannot redirect an effect to a shadow that was already taking the effect. If an effect would stop you from taking certain actions, that shadow is unable to take those actions for the duration of the effect. Your shadows no longer have a maximum distance before they dissipate. Whenever someone attacks one of your shadows, or you avoid an attack or an ability with a shadow assassin counter, it provokes an attack of opportunity from all shadows that threaten them. You can swap places with a shadow as a free action, doing so reduces its duration by 3 rounds. Once per round as a free action one of your shadows can move up to their movement speed.`,
          initiationAction: `swift`,
          range: `personal`,
          duration: `stance`,
          target: `you`,
          },
          {
          school: `shadowAssassin`,
          level: 9,
          name: "Gaping Maw of the Cosmic Darkness",
          type: "Finisher",
          longDesc: `[shadow-void-death-void-shadow] [death] You unleash a forbidden technique, summoning a cosmic darkness to try and consume a creature. The creature must make a reflex saving throw or die, having its body and soul devoured by the cosmic darkness, making them there after unrevivable except through some divine power with the ability to recreate souls. Creatures immune to death effects who fail the reflex saving throw are still dragged deep out into the cosmic darkness, meaning unless they have the ability to return to the location with the usage of interplanatary travel of some kind, they are still lost in the void forever, taking 20d6 cold damage and untyped damage every round and are also unable to breath.`,
          initiationAction: `standard`,
          range: `close (25ft. + 5ft./2 levels)`,
          duration: `instantaneous`,
          target: `1 enemy`,
          },
          {
            school: `shadowAssassin`,
            level: 9,
            name: "Unseen Blade",
            type: "Strike",
            longDesc: `[death] Make an attack, it must be against a creature that is within a range you are able to sneak attack. The creature must make a fortitude save or die. If its save is successful or it is immune to death effects, the attack is still an automatic critical hit, and your sneak attack damage is also multiplied by your critical damage multiplier. This strike is special, as it consumes your combo (meaning it also doesn't grant combo), gaining a +1 bonus to the DC, and +1 damage per sneak attack dice for every <shadow/death> combo points expended.`,
            initiationAction: `full-round`,
            range: `see text;`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
          {
          school: `shadowAssassin`,
          level: 9,
          name: "Patient, Looming, It Comes",
          type: "Strike",
          longDesc: `A monsterous ancient shadow slowly creeps towards the creature, arriving in 3 rounds, no matter the distance. When it does, it lashes out, dealing massive damage, then dissapates. Make attacks as if making a full-round attack action. These attacks are not made at flat-footed armor class, but regardless they still deal your sneak attack damage with every successful hit (unless the creature is immune to sneak attack damage). This damage is not actually dealt by you, but by the shadow, however it deals your full damage. Bonuses to your shadow's damage can boost it beyond your normal damage. Creatures can make a perception check to notice the shadow, its stealth check equal to yours, and supernatural senses do not automatically foil its stealth, though this does not help them avoid it. This ancient shadow has no maximum range before dissapating and always follows the creature, even following them through teleportation and planar travel. After the ancient shadow finishes its attacks, you can teleport to a square adjacent to the target of the maneuver as a free action.`,
          initiationAction: `full-round`,
          range: `long (400ft. + 40ft./level`,
          duration: `3 rounds`,
          target: `1 enemy`,
          },
            {
            school: `sterlingSovereignty`,
            level: 1,
            name: "Battle Chant",
            type: "Stance",
            longDesc: `You gain a +1 morale bonus on weapon attack and damage rolls and to all saving throws against spells. Every 6 levels the bonuses increase by +1. If you cannot hear your battle chant, such as in areas of silence or if you have been muted, this stance does not work. You cannot stealth while using this stance.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `stance`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 1,
            name: "Life on the Edge",
            type: "Stance",
            longDesc: `At the start of each of turns you remove an additional desperation stack. At level 8 when you enter this stance you remove 2 desperation stacks immediately and remove an additional stack at the start of every turn, at level 16 you remove 3 when you enter this stance and 3 at the start of every turn.
            \nYour desperation does not reduce your rolls to confirm critical hits, whenever you confirm a critical hit it does bonus damage equal to your desperation stacks (after multiplication).`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `stance`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 1,
            name: "Tactical Genius",
            type: "Stance",
            longDesc: `Every turn you may use a single swift action Sterling Tactic boost as a free action. When recovering a Sterling Tactic, you can give it an additional sovereign stack per round (consuming an extra recovered maneuver). Every 9 levels, you can give it another additional sovereign stack, requiring another recovered maneuver.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `stance`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 1,
            name: "I'm Coming for You!",
            type: "Boost",
            longDesc: `Choose a creature that you can see and can hear you. You shout at them, letting them know they are next. Gain a +2 bonus to attack and damage against that creature, a +1 bonus on saves against their abilities, and they suffer a -2 penalty on attacks against you. However, you also take a -4 penalty to AC and attacks, and a -2 penalty on saves against all other creatures. These effects last for 1d4+1 rounds, and you can only have 1 instance of this boost active at once. If you kill the creature within the duration, the next time you use this boost this combat, the bonuses and penalties increase by +1. You cannot use this boost if there is only 1 enemy alive. Every 6 levels the duration increases by 1d4 rounds.`,
            initiationAction: `swift`,
            range: `close (25ft. + 5ft./2 levels`,
            duration: `1d4+1 rounds`,
            target: `1 enemy`,
            },
            {
              school: `sterlingSovereignty`,
              level: 3,
              name: "Brace For Assault",
              type: "Boost",
              longDesc: `Movement: Gain temporary counterpoints equal to your initiation modifier that last 1 round. When you level reaches 9 and 18, these last an additional round, however counterpoints from this do not stack with themselves.
              \nYou can gain 2 desperation, or expend one <technique/royal> combo point to gain an additional 2 counterpoints (max additional counterpoints equal to 2x initiation modifier)
              \n\nStandard: Gain 2 immediate actions this round you can use to initiate martial counters (or similar abilities, such as riposte), on top of counterpoints equal to your initiation modifier that dont have a duration.
              \nYou can gain 2 desperation, or expend one <technique/royal> combo point to gain an additional counterpoint (max additional counterpoints equal to initiation modifier)`,
              initiationAction: `movement or standard.`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 1,
            name: "Sterling Parry",
            type: "Counter",
            longDesc: `When attacked by a melee or ranged weapon, you make an opposing attack roll with a wielded weapon as if making an attack of opportunity (you take a -2 penalty for each size larger the attacker is), on success you negate the attack. This maneuver is not expended until the end of your next turn, and you can take 2 desperation to initiate it again as a free action (even when not your turn). If it is during your turn, it gives only 1 stack of desperation. You can only gain a single combo point from this counter per round.`,
            initiationAction: `immediate`,
            range: `personal`,
            duration: `instantaneous`,
            target: `you`,
            },
            {
              school: `sterlingSovereignty`,
              level: 1,
              name: "Last Ditch Dodge",
              type: "Counter",
              longDesc: `When a creature makes an attack against you, you can gain a +4 bonus to your armor class against it, and once it resolves, take an immediate 5-foot step. Afterwards, you fall prone. If you are flying, you instead fall 10 feet and take a -4 penalty to attacks and armor class for 1 round.`,
              initiationAction: `immediate`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 1,
            name: "Charge and Cover",
            type: "Strike",
            longDesc: `Make a melee attack, if it hits, it deals an additional +1d6 damage and you gain a 1d6 dodge bonus to armor class. The dodge bonus doesn't end normally, instead after each attack made against you, the dodge bonus reduces by 1 until it is gone. This bonus stacks with itself up to a maximum of 8. The dodge bonus is also lost when entering or leaving combat.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `see text`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 1,
            name: "Daring Strike",
            type: "Strike",
            longDesc: `Make an attack, you can take 1 stack of desperation to increase your damage with the attack by +1d4 per stack taken, up to a maximum amount of stacks equal to your initiation modifier. You decide how many stacks before the attack is rolled, but they don't penalize your attack until after. Every 6 BAB the dice step of the bonus damage increases by 1.
            \n[two-handed]: bonus damage increases by 50%.`,
            initiationAction: `standard`,
            range: `melee or ranged attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 2,
            name: "Covering Strike",
            type: "Strike",
            longDesc: `Make an attack, if it hits, it deals an additional 1d6 damage and you gain 2 counterpoints. You can take 1 desperation to increase the counterpoints you get by 1 (max initiation modifier desperation). Every 6 levels this grants an additional counterpoint. 
            \n[shield]: Increase initial counterpoints gained by 50%.\n[two-handed]: Increase counterpoints gained by taking desperation by 100%`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
              school: `sterlingSovereignty`,
              level: 1,
              name: "Hazy Cross",
              type: "Strike",
              longDesc: `You make a specialized disarming move which causes both you and the enemy to become disarmed in a single action. First make a disarm attempt with a +8 bonus, then you are automatically disarmed. If you have the quickdraw feat or a similar ability, you can then draw an additional weapon and attack the creature with it at a -4 penalty. Neither drawing the weapon or the disarm provoke. Each additional use on the same creature takes a -4 penalty to the disarm check. If you are not disarmed by this strike, it does not work.`,
              initiationAction: `standard`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
            },
            // {
            //   school: `sterlingSovereignty`,
            //   level: 4,
            //   name: "Iron Wave",
            //   type: "Strike",
            //   longDesc: `You make a melee attack against an enemy, it does half the normal damage, but you gain temporary hit points against them equal to the damage dealt. You also gain a +4 cover bonus to armor class against attacks made against you this round.`,
            //   initiationAction: `Standard Action`,
            //   range: `melee attack`,
            //   duration: `1 round`,
            //   target: `1 enemy`,
            // },
            {
              school: `sterlingSovereignty`,
              level: 4,
              name: "Endless Clash",
              type: "Strike",
              longDesc: `You can initiate this strike only when your only remaining maneuvers are strikes. Make a melee attack against an enemy with a -10 penalty. It deals damage as normal. You suffer 4 desperation after initiating this maneuver.`,
              initiationAction: `Free Action`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 1,
            name: "Never Out of Options",
            type: "Boost",
            longDesc: `You can initiate this boost when you miss with a melee manufactured weapon attack. Make an unarmed attack with a -2 penalty. The creature is flat-footed for this attack, but it deals damage as if it was an off-hand attack.`,
            initiationAction: `free`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 1,
            name: "Sterling Tactic: Weave",
            type: "Boost",
            subSchool:['sterlingTactic'],
            longDesc: `[Sterling Tactic] When initiating a strike or make a full-round attack, you can activate this boost before to move 5 feet, or activate it after to move twice as far.
            \nPer Sovereign Stack: Move an extra 2.5 feet (rounded down to nearest 5-foot increment when initiated)`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `instantaneous`,
            target: `you`,
            stacksOne: 0,
            stacksOneName: 'Sovereign Stacks',
            additionalInfoTags: ['Sterling Tactic'],
            },
            {
            school: `sterlingSovereignty`,
            level: 2,
            name: "Direct Counter",
            type: "Counter",
            longDesc: `When you take damage from an attack or from a spell/ability that allows a reflex save, you swing your weapon into it, reducing its impact with your own force. Roll a damage roll with a weapon you are wielding (at no target), you reduce the damage you take by the result of your damage roll. If your damage roll was higher than theirs, the attack or ability counts as missing you. If you negate it and they are also within your melee reach, you deal the excess damage of your roll to them. This only works on hit point damage.
            \n[two-hand] You instead deal double the excess damage to the creature.
            \n[shield] First reduce the damage by your shields hardness, however you have to make your damage roll as a shield bash attempt.`,
            initiationAction: `immediate`,
            range: `personal`,
            duration: `instantaneous`,
            target: `you`,
            },
            {
              school: `sterlingSovereignty`,
              level: 2,
              name: "Intercepting Counter",
              type: "Counter",
              longDesc: `<guardian> You can initiate this counter along with another counter (or similar ability, such as parry and riposte) that uses an attack or damage roll to deflect an attack targeted at you, and use it to deflect an attack from an ally. The ally must be within your reach.`,
              initiationAction: `free immediate`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              additionalTags:["Guardian"]
            },
            {
              school: `sterlingSovereignty`,
              level: 6,
              name: "Full Counter",
              type: "Counter",
              longDesc: `Your mastery of the blade has allowed you to use your offensive techniques as both an offense and a defense. When a creature strikes you with an attack, you expend this counter and a strike that has an initiation action of a standard action or less. Make a damage roll as if using the strike against them, reduce the damage of their attack by your damage roll. If your attack dealt more damage than theirs and they are a targetable creature for the attack, roll an attack roll against their armor class, if it hits, you deal the excess damage to them, and if the strike had any additional effects, those occur as well, as long as they are not effects that trigger before the attack of the strike. If your strike had multiple attacks associated with it, you can choose to either use multiple of those attacks to reduce their one damage roll, or use the remaining attacks in response to other attacks taken against you this round. On your next turn after initiating this counter, you are staggered and take 5 desperation.`,
              initiationAction: `immediate`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 2,
            name: "Sterling Tactic: Counterstrike",
            type: "Counter",
            subSchool:['sterlingTactic'],
            longDesc: `[Sterling Tactic] You initiate this counter when an enemy that you threaten misses you with an attack. Make a single melee attack against them with a -2 penalty. 
            \n[two-handed]: You deal an additional 1d6 damage on the attack. +1d6 per sovereign stack.\n[shield]: Your shield bonus to armor class increases by +2 for any more attacks against you they make this round. +1 per sovereign stack.`,
            initiationAction: `immediate`,
            range: `personal`,
            duration: `instantaneous`,
            target: `you`,
            stacksOne: 0,
            stacksOneName: 'Sovereign Stacks',
            additionalInfoTags: ['Sterling Tactic'],
            },
            {
            school: `sterlingSovereignty`,
            level: 2,
            name: "Sudden Grapple",
            type: "Counter",
            longDesc: `You can initiate this counter whenever you want, interrupting the actions of other creatures, and possibly negating them. Make a grapple attempt against an enemy within your natural reach. It doesn't provoke. When initiating this counter, you can let go of a weapon if you desire. You can take 1 desperation to gain a +2 bonus to the grapple attempt (max stacks initiation modifier).`,
            initiationAction: `immediate`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 2,
            name: "Fierce Charge",
            type: "Strike",
            longDesc: `Move 10 feet in any direction (even straight up) without provoking AoO's and then make a melee attack. You can take 1 desperation to move an additional 10 feet and increase the damage by 1d6 (max stacks initiation modifier). If you move your movement speed while using this, it can also count as a charge attack. You can only take 1 attack, even if you could normally take more than 1 attack during a charge.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 2,
            name: "Test of Skill",
            type: "Strike",
            longDesc: `Make a melee attack against an opponent, instead of using their armor class, they must also make an attack with a wielded weapon or natural attack (that attack does not provoke regardless of the situation). If your attack is higher, you hit them, if your attack roll is also higher than their amor class, the attack deals double damage, plus an additional +2 for every point you beat their attack roll by (after multiplication). If your attack roll is lower than theirs, it deals half damage, and only if it still beats their armor class.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 2,
            name: "Blade Lock",
            type: "Strike",
            longDesc: `Make a melee attack against an opponent, if it hits, it deals half its normal damage, and if they are wielding a manufactured weapon, you attempt to lock your blade against theirs. Make a CMB check as if making a disarm attempt (doesn't provoke). If successful, both your weapon and theirs becomes locked together, neither can use that weapon until the lock is ended. They can attempt to end the lock as a movement action by making a CMB or escape artist check vs your CMD, or by dropping their weapon. Until the lock ends, neither of you can move further than your combined reaches with your weapons (ignoring the normal 5 feet of reach). If the creature attempts to, but fails to end the lock, it provokes an attack of opportunity from you, though you must use an unarmed attack. If you are forcibly moved away from the creature, both of you are disarmed, both of your weapons ending in a space in the middle of both of you after the movement. Teleportation ends it without the disarm.
            \nYou can end the lock in 3 ways: \nFree action \nSwift action to disarm both of you \nMovement action to make a disarm attempt, or a CMB check to move the creature into another square within your reach (move them 5 feet, plus 5 feet for every 5 you beat their CMD by)
            \n[two-handed] Gain a +4 bonus to the lock attempt, and they also take a -4 penalty to armor class and attack rolls while locked.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `see text;`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 2,
            name: "Off-Balancing Swing",
            type: "Boost",
            longDesc: `Make a melee attack at a -5 penalty, if it misses, the creature takes a -4 penalty to armor class for 1 round. Every 8 levels the penalty to armor class increases by -1. You cannot willingly miss this attack.`,
            initiationAction: `swift`,
            range: `melee attack`,
            duration: `1 round`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 2,
            name: "Sucker Punch",
            type: "Boost",
            longDesc: `After making a full-round attack or a strike with a melee weapon, you can initiate this boost to make an additional attack with an unarmed weapon that you didn't make any attacks with during the strike or full-round attack. It deals damage as if it was an off-hand attack. If done after a full-round attack, and the unarmed attack is successful, the creature takes a penalty to its armor class equal to the number of attacks you have hit against it this round (excluding this one) until the beginning of your next turn. If done during a strike, you can also make a free bull rush attempt against them. The attack rolls made during this boost never provoke.`,
            initiationAction: `swift`,
            range: `melee attack`,
            duration: `1 round`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 2,
            name: "Sterling Tactic: Battering Attacks",
            type: "Boost",
            subSchool:['sterlingTactic'],
            longDesc: `[Sterling Tactic] The next successful strike you make this turn knocks the opponent off-balance and they take a -1 penalty on all attack rolls for 1 round, doubled on attack rolls against you.
            \nPer Sovereign Stack: increase the penalty by -0.5.`,
            initiationAction: `swift`,
            range: `melee attack`,
            duration: `1 round`,
            target: `1 enemy`,
            stacksOne: 0,
            stacksOneName: 'Sovereign Stacks',
            additionalInfoTags: ['Sterling Tactic'],
            },
            {
            school: `sterlingSovereignty`,
            level: 2,
            name: "Sterling Tactic: Survival",
            type: "Boost",
            subSchool:['sterlingTactic'],
            longDesc: `[Sterling Tactic] Gain 2 counterpoints.
            \nPer Sovereign Stack: Gain an additional counterpoint
            \n[shield] Increase the counterpoints gained by 50%, however the additional ones only last a single round.`,
            initiationAction: `swift`,
            range: `you`,
            duration: `instantaneous`,
            target: `personal`,
            stacksOne: 0,
            stacksOneName: 'Sovereign Stacks',
            additionalInfoTags: ['Sterling Tactic'],
            },
            {
            school: `sterlingSovereignty`,
            level: 3,
            name: "The Best Defense",
            type: "Stance",
            longDesc: `When you enter this stance, and at the start of each of your turns, you make an attack roll with a melee weapon, and use it as your armor class. This attack roll is against nothing, so it gains no situational bonuses, or any bonuses that only add to a single attack roll (such as true strike). The result of that attack roll becomes your armor class and touch armor class against any weapon or natural attacks for the rest of the round. While you are in this stance, you deal half damage with all weapon attacks and your flat-footed armor class takes a -5 penalty.
            \nAt the start of each of your turns, you gain counterpoints equal to your highest level <technique> counter known.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `stance`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 3,
            name: "Lone Knight",
            type: "Stance",
            longDesc: `You cannot be flanked. If you are the only creature threatening another enemy, you gain a +2 competence bonus on attacks against them and a +2 bonus on all rolls made as a part of a counter against them. For each enemy threatening you that is not also threatening, or threatened by an ally, you gain a +2 dodge bonus to your armor class. If you are the only target of a spell or supernatural ability, you gain a +2 bonus on saving throws against it.
            \n[shield]: bonus to saves and counters increases by 50%.\n[two-handed]: dodge bonus to armor class per enemy increases to +3 and the bonus on attacks increases by 50%.
            \nIf at the start of your turn you are threatened by 2 or more enemies that are not threatened by any allies, you gain 3 counterpoints, plus an additional 3 counterpoints for every enemy past 2 threatening you that aren't threatened by allies.`,
            gameDesc:`You cannot be flanked. If you are the only creature threatening another enemy, you gain a +2 competence bonus on attacks against them and a +2 bonus on all rolls made as a part of a counter against them. For each enemy threatening you that is not also threatening, or threatened by an ally, you gain a +1 dodge bonus to your armor class. If you are the only target of a spell or supernatural ability, you gain a +2 bonus on saving throws against it.
            \n[shield]: bonus to saves and counters increases to +4.\n[two-handed]: dodge bonus to armor class per enemy increases to +1.5 and the bonus on attacks increases to +3.
            \nIf at the start of your turn you are threatened by 2 or more enemies that are not threatened by any allies, you gain 3 counterpoints, plus an additional counterpoint for every enemy past 2 threatening you that aren't threatened by allies.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `stance`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 3,
            name: "Desperate Counter",
            type: "Counter",
            longDesc: `You automatically negate a weapon attack against you, then you choose a penalty:
            \n1: You cannot attack until the end of your next turn. Make an immediate counter attack with a weapon if you threaten the creature.
            \n2: The creature gets a free disarm attempt against you, the attempt doesn't provoke. If you have a Weapon cord, it is cut, and a locked gauntlet fails to keep the weapon in your hand. Make an immediate counter attack with an unarmed strike, if it succeeds, they must make a fortitude save or be staggered for the rest of the round.
            \n3: You can only use this if you are not prone. You fall prone. If you are flying, you instead fall to the ground and remain prone and cannot fly for 1 round. You gain a dodge bonus of 2 + 1 per 4 bab for 1 round. This can be used against magical attacks.
            \nYou can take 1 desperation to allow you to not expend this counter, however you cannot use the same penalty twice in 1 round.`,
            initiationAction: `immediate`,
            range: `personal`,
            duration: `1 round;see text`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 3,
            name: "Parry This You Filthy Casual",
            type: "Counter",
            longDesc: `If a creature activates an ability that negates an attack of yours and you are threatening the creature, you can make a melee unarmed attack against them. The unarmed attack deals double damage and they are flat-footed against this attack even if they are normally immune to being flat-footed. If the creature negates any other attacks against you during this round, you can make another unarmed attack. These attacks cannot be countered by an ability that activates, even by abilities that can counter anything.`,
            initiationAction: `immediate`,
            range: `melee attack`,
            duration: `1 round;see text`,
            target: `1 enemey`,
            },
            {
            school: `sterlingSovereignty`,
            level: 3,
            name: "Never Count Me Out",
            type: "Counter",
            longDesc: `When making a saving throw, you can initiate this counter so that instead of taking a penalty to saves due to your desperation, you instead gain half your stacks as a bonus. If you succeed on the save, remove half of your stacks of desperation, otherwise take 4 more.`,
            initiationAction: `immediate`,
            range: `personal`,
            duration: `instantaneous`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 3,
            name: "Adapting Technique",
            type: "Boost",
            longDesc: `Gain a +1 insight bonus to your manufactured weapon attacks. This stacks with itself, up to a maximum of your initiation modifier. If you do not make an attack on your turn, you lose half of your stacks of this. They are fully lost when you leave or enter combat.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `encounter`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 3,
            name: "Just Warming Up",
            type: "Boost",
            longDesc: `Gain a +2 insight bonus to your melee manufactured weapon damage rolls. This stacks with itself, up to a maximum of 2x your initiation modifier. If you do not make an attack on your turn, you lose half of your stacks of this. They are fully lost when you leave or enter combat.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `encounter`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 3,
            name: "Battle Tempo",
            type: "Boost",
            longDesc: `This boost has different effects each time you use it, going in a cycle. Each bonus lasts only a single round. The cycle is as follows:
            \n1st: Gain a dodge bonus to your armor class of +1 per 4 bab [shield]: +50%\n2nd: Gain a bonus on weapon attack rolls of +1 per 4 bab. \n3rd: Gain a bonus on weapon damage rolls of +2 per 4 bab [two-handed]: +100%\n4th: Reduce your desperation by level/3, gain level/3 counterpoints [shield]: +50% counterpoints [two-handed]: reduce desperation additional 50% \n5th: You gain all the bonuses of 1-3. At the start of your following turn you take 4 desperation
            \nYou can take 2 desperation to skip to the next bonus in the cycle.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 3,
            name: "All or Nothing",
            type: "Strike",
            longDesc: `Make a melee attack, it deals an additional +3d6 damage. For this attack, you take no penalty because of your desperation, and instead gain half of the stacks as a bonus to the attack roll. If your attack hits, you remove half of your desperation stacks, if you miss, you increase them by 50% and you cannot remove desperation until the end of your next turn.
            If the attack is a critical hit, it deals additional damage equal to your desperation * critical damage multiplier.
            If the attack is a natural 20, you remove all desperation. 
            If the attack is a natural 1, you double the desperation, and cannot remove it for 2 rounds.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 3,
            name: "Magic Is for Losers",
            type: "Strike",
            longDesc: `Make a melee attack, if the creature is benefiting from a supernatural or magical effect that is giving them a bonus to their armor class or a chance for the attack to miss (such as concealment from a spell or mirror images), you can ignore one of these effects (your choice if you know, otherwise whichever one the GM believes is most beneficial to the creature). For each of these effects they have on them, your attack deals an extra 1d8 damage. If you have beneficial spells active on you, this attack takes a -1 penalty to it for each of them.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 3,
            name: "Blade Whirl",
            type: "Strike",
            longDesc: `Make a melee attack that deals an additional +2d6 damage. On the next melee attack against you within 1 round you gain a +1d8 dodge bonus to your armor class. If the next attack misses you and the attacking creature is within your reach, they provoke an attack of opportunity from you. If the attack only missed because of the bonus to dodge you gained, you also gain a bonus on the attack roll equal to the dodge bonus gained and twice the bonus to the damage. If the attack is by the original target of this strike, the attack is also gains a flat +1 bonus to the critical threat range.
            \nIf a ranged attack is made against you, you can choose to expend the dodge bonus against it, ending the bonus of this maneuver.
            \n[shield] The counterattack bonus attack is increased by 50%\n[two-handed] The counterattack bonus damage is increased by 100%`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `1 round`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 3,
            name: "Backup Tactics",
            type: "Strike",
            longDesc: `Make a melee attack, it deals an additional 3d6 damage. If it misses, you can make one of the following attempts, none of which provoke:
            \nA disarm attempt\nA trip attempt\nAn unarmed attack, it deals damage as if it was an off-handed attack.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 3,
            name: "Send Reeling",
            type: "Strike",
            longDesc: `Make a melee attack against an opponent, it deals an additional 2d6 damage. If the attack is successful, they take a -2 penalty to attacks for 1 round. If the next attack they make against a creature that threatens them misses (within 1 round), it provokes an attack of opportunity from the target of the attack. If that attack only missed because the attack was countered, the attack of opportunity deals an additional 2d6 damage and has its critical threat range increased by a flat +1.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 3,
            name: "Sterling Tactic: Deadliness",
            type: "Boost",
            subSchool:['sterlingTactic'],
            longDesc: `[Sterling Tactic] The next weapon attack you make this round deals an extra 1d4 damage. Every 6 BAB the dice size increases by 1 dice step.
            \nPer Sovereign Stack: increase the damage by 1d4. 
            \n[two-handed] increase damage by 1 dice step.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
            stacksOne: 0,
            stacksOneName: 'Sovereign Stacks',
            additionalInfoTags: ['Sterling Tactic'],
            },
            {
            school: `sterlingSovereignty`,
            level: 3,
            name: "Sterling Tactic: Accuracy",
            type: "Boost",
            subSchool:['sterlingTactic'],
            longDesc: `[Sterling Tactic] The next weapon attack you make this round gains a +1 bonus on the attack.
            \nPer Sovereign Stack: increase the attack bonus by +1.
            \n[shield] Increase the bonus by 50% (minimum 0)`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
            stacksOne: 0,
            stacksOneName: 'Sovereign Stacks',
            additionalInfoTags: ['Sterling Tactic'],
            },
            {
            school: `sterlingSovereignty`,
            level: 4,
            name: "Right in the Gut",
            type: "Boost",
            longDesc: `You can initiate this boost as a free action even when not your turn when you are making an unarmed attack as a part of a <technique> maneuver. Increase the handedness of the damage the attack deals by 1 step (off-hand -> main -> two-handed, This doesn't actually effect the attack's functionality), and if it hits, the creature becomes staggered and sickened until the end of its next turn. If the unarmed attack is a critical hit, they are instead nauseated for 1 round. You can initiate this boost even when only wielding unarmed attacks. If you have used this strike on a creature previously, it is allowed a fortitude save to negate the stagger and sickened.`,
            initiationAction: `free immediate`,
            range: `personal`,
            duration: `instantaneous`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 3,
            name: "Sterling Tactic: Courage",
            type: "Boost",
            subSchool:['sterlingTactic'],
            longDesc: `[Sterling Tactic] Remove 1 desperation.
            \nPer Sovereign Stack: remove 1 additional desperation.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
            stacksOne: 0,
            stacksOneName: 'Sovereign Stacks',
            additionalInfoTags: ['Sterling Tactic'],
            },
            {
            school: `sterlingSovereignty`,
            level: 4,
            name: "I'll Show You How to Counterspell",
            type: "Counter",
            longDesc: `When someone casts a spell within your reach, you can activate this counter to cause the spellcasting to provoke an attack of opportunity from you, even if they cast it defensively or as a swift action.
            \nYou can take 1 desperation to increase the range of this counter by 5 feet, allowing you to move before they begin to cast the spell. You cannot take more desperation than you have speed to move, or more stacks than you have initiation modifier. You are staggered on your next turn if you move more than 5 feet this way.`,
            initiationAction: `immediate`,
            range: `melee attack; see text`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 4,
            name: "Bulwark Throw",
            type: "Counter",
            longDesc: `When a creature not using a reach weapon declares a melee attack you, you attempt a trip check against them (doesn't provoke). If you succeed, their attack automatically misses you, you can make a single off-handed unarmed attack, and they are moved to the opposite side of your space and knocked prone (fails if there isn't enough room). If the creature is flying, instead of falling prone they suffer a -4 penalty to attack rolls and armor class for 1 round. If your trip attempt fails, you take a -8 penalty to your armor class against the attack, and a -4 penalty to armor class to any further attacks this round by the creature. 
            \n[shield] the penalty to armor class for failure for the triggering attack and the subsequent reduces by -3 and -1 respectively. You can also deal damage as if making a shield bash instead of an off-hand unarmed attack.
            \n[two-handed] Gain a +4 on the trip attempt.`,
            initiationAction: `immediate`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 4,
            name: "Spinning Parry",
            type: "Counter",
            longDesc: `In response to an enemy declaring a melee attack against you, you can make a disarm attempt. This attempt does not provoke. If it succeeds, the creature is disarmed, its attack misses, and the opponent suffers a -4 penalty to armor class for 1 round. If the attempt fails but creature cannot be disarmed for any reason (such as locked gauntlet or natural attacks), that attack instead automatically misses and they suffer a -4 penalty on all attacks for 1 round in addition to the -4 penalty to armor class.`,
            initiationAction: `immediate`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 4,
            name: "Stunning Blow",
            type: "Strike",
            longDesc: `Make a melee attack, it deals an additional 2d6 damage and if successful they must make a fortitude save or be stunned for 1 round. Take 1 desperation to increase the DC by +1. You cannot take more stacks than your initiation modifier.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `1 round`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 4,
            name: "Master of Techniques",
            type: "Strike",
            longDesc: `Make a melee attack, initiating a Sterling Tactic boost on this attack is a free action. For each sovereign stack expended as a part of using this attack, the attack deals an additional 1d4 damage. For every different tactic that had at least two sovereign stacks expended, the attack gains a +1 to attack. For every tactic that had at least 4 sovereign stacks expended, the attack gains a +1 flat bonus to its critical threat chance. If this attack confirms a critical hit, you can allow one of your sterling tactics to not lose its sovereign stacks.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 4,
            name: "Forward March",
            type: "Strike",
            longDesc: `Make a melee attack, it deals an additional 4d6 damage, and if successful, you give a Sovereign Stack to 2 Sterling Tactics. At level 12, 16, and 20, give a stack to an additional sterling tactic.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 4,
            name: "Assault Order",
            type: "Strike",
            longDesc: `Make a full-round attack with melee weapons. For each successful attack, you make a bull rush attempt against the creature with a -4 penalty, however it does not move until after all of your attacks have been made. Once all attacks have been made, you total the distance it would have moved for each bull rush, then move them. These bull rush attempts do not provoke, and you cannot move with the creature.`,
            initiationAction: `full-round`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 4,
            name: "Masterful Thrust",
            type: "Strike",
            longDesc: `Make a melee attack, it deals an additional 5d6 damage and cannot be countered or avoided by activated abilities that allow any kind of roll in response.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 4,
            name: "Desperate Struggle",
            type: "Boost",
            longDesc: `For 1 round you do not take the AC penalty because of desperation, and instead gain a morale bonus to AC equal to the penalty you would have taken.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 4,
            name: "Grit Teeth",
            type: "Boost",
            longDesc: `For 1 round you DR /- equal to your stacks of desperation (max twice your initiation modifier). This stacks with other DR, but it is reduced by half. After the end of your next turn, you suffer 3 desperation.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 4,
            name: "Calm Mind, Measured Strikes",
            type: "Boost",
            longDesc: `Ignore any non-voluntary penalties to attack and damage rolls for 1 round. This applies to things such as desperation, prone, shaken, or sickened, but not things such as power attack or fighting defensively. This even ignores penalties from ability score damage or penalties (but not drain).`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 4,
            name: "Sterling Tactic: Whirling Blade",
            type: "Boost",
            subSchool:['sterlingTactic'],
            longDesc: `[Sterling Tactic] If your next attack this turn is successful, you gain a +1d2 dodge bonus to armor class for 1 round, doubled against the target of the attack.
            \nPer Sovereign Stack: Increase the bonus by 1d2.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
            stacksOne: 0,
            stacksOneName: 'Sovereign Stacks',
            additionalInfoTags: ['Sterling Tactic'],
            },
            {
            school: `sterlingSovereignty`,
            level: 5,
            name: "Blade Arts",
            type: "Stance",
            longDesc: `When you enter this stance, choose one of the following styles, you can swap your style as a free action once per turn (cannot be done mid attack):
            \nDaring Style: Take a -4 penalty on your melee attack rolls, but they gain a flat +1 bonus to their critical threat range and +1 critical multiplier on nat 20's. You can spend 1 desperation as a free action to reroll an attack roll. Can only reroll once per attack.
            \nBalanced Style: Your melee attacks cannot critically hit. Gain a +2 bonus to attack per crit range of the weapon. If you roll within what the crit range would have been, you remove desperation equal to your critical damage multiplier. This only grants bonus attack if the creature you are attacking can be crit, and the attack you are making can critically hit (therefor grants no benefits to parry attack rolls or similar abilities).
            \nAccurate Style: Take a -2 penalty to damage rolls to gain a +1 bonus to your melee attack. You can trade more than 2 damage at a time, up to a maximum of your BAB. As a free action you can take 1 desperation(applied at start of next turn) to gain a +1 to attacks for 1 round (max init mod per round) 
            \nDuelist Style: Whenever you successfully use a counter, you gain counterpoints equal to the level of the counter. This doesn't activate if you use counterpoints to initiate a counter. Whenever you succeed on a counter, you lose desperation equal to half the counter's level.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `stance`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 4,
            name: "Perfect Parry",
            type: "Counter",
            longDesc: `You initiate this counter as a free action that you can take even when not your turn. It allows you to initiate a counter when you normally couldn't, such as when the opponent rolled a natural 20 on their attack roll, when you are flat-footed, or when an attack cannot normally be countered. You gain a +4 bonus on an roll associated with the counter. If your counter is successful, you gain counterpoints equal to the level of the counter used, and if you threaten the creature you successfully countered at any point during the counter you may make a single melee attack against them.`,
            initiationAction: `free action;see text`,
            range: `personal`,
            duration: `instantaneous`,
            target: `you`,
            },
            {
              school: `sterlingSovereignty`,
              level: 5,
              name: "Overpower",
              type: "Counter",
              longDesc: `When you take damage from an attack or from a spell/ability that allows a reflex save, you swing your sword into it, reducing its impact with your own force. Roll a damage roll with a weapon you are wielding (at no target), you reduce the damage you take by the result of your damage roll. If your damage roll was higher than theirs, the attack or ability counts as missing you. If you negate it and they are also within your melee reach, you deal the excess damage to them, and they must make a fortitude save DC the damage you dealt to them or become stunned until the start of their next turn.`,
              initiationAction: `immediate`,
              range: `melee attack`,
              duration: `instantaneous;see text`,
              target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 6,
            name: "Sterling Perfection",
            type: "Strike",
            longDesc: `Make a melee attack that deals an additional 6d6 damage. This strike cannot be countered by activated abilities. If the target of the strike is benefitting from a supernatural or magical effect that is giving it a bonus to armor class or a miss chance, you can ignore all of these effects. For each ignored magical or supernatural effect, the attack deals an additional 2d6 damage. If the creature attempts to use an ability that would negate this attack (such as a counter), you catch their dodge and can make another attack against them, gaining all the bonuses of the initial attack. If a creature is using knowledge to identify this strike, you can replace the DC with an opposed bluff or knowledge martial check.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 5,
            name: "Flow of the Sword",
            type: "Strike",
            longDesc: `Make a melee attack. If successful, it deals an additional 2d6 points of damage per desperation you have, and you can recover a single <technique>, <sakura>, or <royal> maneuver. You also can also either add a sovereign stack to 2 different sterling tactics, or gain 5 counterpoints.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 5,
            name: "Rush Down",
            type: "Strike",
            longDesc: `As a full-round action make a single melee attack against a creature. You can expend a readied strike to make an additional attack. You can expend multiple readied strikes, but all of them must be from the same combo tag, and each must be a higher level than the previous expended strike (doesn't require expending spell points). These extra attacks deal additional damage equal to twice the level of the maneuver expended to make the attack. You can take 2 desperation immediately to expend a strike of a different discipline. 
            \nYou take 2 desperation after initiating this strike. You cannot recover this maneuver the round you use it, or use it the round you recover it.`,
            initiationAction: `full-round`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 5,
            name: "Bully Nerd",
            type: "Strike",
            longDesc: `Make a melee attack, it deals an additional 1d6 points of damage for each active spell on them. If the attack is successful it also dispels up to initiation modifier spells active on them as if you were using greater dispel magic. They can make a will save to reduce it to 1 spell and they get to pick which one. If you have beneficial spells active on you, this attack takes a -1 penalty to it per spell.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 5,
            name: "Heroic Engagement",
            type: "Strike",
            longDesc: `<heroic> Move up to your movement in a straight line, attack every enemy within reach along the way a single time. Each attack gains your bonuses to charge attacks, though you can make only a single attack per enemy, regardless of how many you would normally take on a charge. If you provoke an attack of opportunity for this movement, as long as they would be one of the creatures you are going to attack, take your attack against them before they get their attack of opportunity. You cannot make more attacks with this than BAB/2. During this charge, you double any morale bonuses you have. You are fatigued for 1 round after using this strike, and cannot initiate it while fatigued. You can move through enemy spaces while using this by making a CMB check as if bull rushing the creature (as a free action which does not provoke).
            \n[shield] You triple your shields base shield bonus during this charge, and if a creature misses you with an attack during it, you can use an attack of opportunity to make a free shield bash against them and move 5 feet (even not in a straight line).
            \n[two-handed] Each attack applies the effects of the vital strike feat, even if you dont have it. If you do have it, you can also apply it vital strike feat.`,
            initiationAction: `full-round`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 or more enemies`,
            additionalInfoTags: ['Heroic'],
            },
            {
            school: `sterlingSovereignty`,
            level: 5,
            name: "Brace Up",
            type: "Boost",
            longDesc: `You can expend up to initiation modifier/2 (minimum 1) readied counters to gain counterpoints equal to twice the level of the counters expended. Gain a dodge bonus to your Armor class equal to half the level of the counters expended for 1 round, however for every time you are attacked, the dodge bonus reduces by 1.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `instantaneous`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 5,
            name: "Sterling Tactic: Brutalize",
            type: "Boost",
            subSchool:['sterlingTactic'],
            longDesc: `[Sterling Tactic] If your next attack is successful, the creature takes a -4 penalty on all damage rolls for 1 round.
            \nPer Sovereign Stack: increase the penalty by -2.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
            stacksOne: 0,
            stacksOneName: 'Sovereign Stacks',
            additionalInfoTags: ['Sterling Tactic'],
            },
            {
            school: `sterlingSovereignty`,
            level: 5,
            name: "Sterling Tactic: Requiem",
            type: "Strike",
            subSchool:['sterlingTactic'],
            longDesc: `[Sterling Tactic] As a full-round action, make an attack. You suffer 1 desperation after initiating this strike and are staggered on your next turn.
            \nPer Sovereign Stack: Make an extra attack with a cumulitive attack penalty of -2 from the previous attack. Increase the desperation suffered afterwards by 1.`,
            initiationAction: `full-round`,
            range: `personal`,
            duration: `instantaneous`,
            target: `you`,
            stacksOne: 0,
            stacksOneName: 'Sovereign Stacks',
            additionalInfoTags: ['Sterling Tactic'],
            },
            {
            school: `sterlingSovereignty`,
            level: 6,
            name: "Unimpeachable Throne",
            type: "Stance",
            longDesc: `Whenever you successfully counter an attack or ability you gain 2 counterpoints (unless the counter was initiated with counterpoints), and if you are threatening the creature, the countered creature provokes an attack of opportunity from you. You gain additional attacks of opportunity every round equal to the amount of counters you have known of any single style of maneuvers (such as <technique> or <primal>).
            \n[shield] You gain a +3 on all rolls made during a counter. Gain an additional counterpoint when you succeed on a counter.
            \n[two-handed] The attack of opportunity you make when succeeding on a counter because of this stance also gains the benefits of the vital strike feat. If you have a vital strike feat, you can also apply it.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `stance`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 6,
            name: "Punish Cowardice",
            type: "Counter",
            longDesc: `When someone casts a spell within your reach, you can activate this counter to cause it to provoke an attack of opportunity from you, even if they cast defensively or quickened. If you successfully stop a spell with this maneuver, you can do one of two things, if the spell was a beneficial spell, you can cause it to instead effect you, if it was a harmful spell, you can turn it on the caster as 'Spell Turning'. You can spell turn the spell even if it was a touch or area of effect spell. If the spell was an area of effect spell, it makes their squares the only targets for the spell. If you cause it to effect you, you are the only target of it, regardless of how many creatures it would normally target.
            \nYou can take 1 desperation to increase the range of this counter by 5 feet, allowing you to move beofre they begin to cast the spell. You cannot take more desperation than you have speed to move, or more stacks than you have initiation modifier.`,
            initiationAction: `immediate`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 6,
            name: "Critical Moment",
            type: "Strike",
            longDesc: `Make an attack, after the roll has been made but before the result is declared, you can take 2 desperation stacks to increase the natural result of the dice by +1 (max 20) and increase the damage of the attack by 2d6. Abilities that only activate on natural 20's do not activate with this. If an attack with this ability is a critical hit before you modify the roll, you can instead take 5 desperation to increase the critical damage multiplier by +1. The desperation applies immediately, and may cause the attack to miss. If the roll was a natural 20, increase the total result of the attack roll by your level, but if you increase the critical damage multiplier this way, the attack no longer is an automatic hit. You cannot increase the critical damage multplier over double what the multiplier originally was.`,
            initiationAction: `standard`,
            range: `melee or ranged attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 6,
            name: "Full Engagement",
            type: "Strike",
            longDesc: `Make a full-round attack with a melee weapon. You can include any additional attacks you gain from other maneuvers as part of this. Each attack you make, the opponent makes an opposing attack roll using a wielded weapon, natural attack, or unarmed strike. Each time they make an attack, they must using a different attack that they have in their full-round attack combination. If they run out of attacks, they keep rolling at their lowest attack modifier -10, with an additional -5 for each previous attack roll they have not had a matching attack roll for. If your attack roll is higher, the attack hits, if it also beats their armor class it deals double damage. If it is lower but still beats their armor class, it deals half damage and you take 1 stack of desperation immediately. If at the end, the target has attacks of opportunities or full-round attacks remaining, it may use those to add a +4 to any of its attack rolls. You can take 1 desperation to gain a +4 bonus on a roll. You can both do this after the results are already being declared. You can take up to initiation modifier desperation for bonuses to your attacks throughout the entire strike.`,
            initiationAction: `full-round`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 5,
            name: "False Throne",
            type: "Strike",
            longDesc: `Expend up to 5 random maneuvers (doesn't cost spell points) and then make an attack. Your attack deals additional 1d6 damage per level of all the maneuvers expended. If this expends a [sterling tactic], it instead expends all its sovereign stacks. If it expends a <technique> maneuver, the attack also gains a +1 bonus to attack.`,
            initiationAction: `standard`,
            range: `melee or ranged attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 6,
            name: "Preparation",
            type: "Strike",
            longDesc: `Make an attack, it deals an additional 6d6 damage, and if it is successful you recover a single random maneuver and an expended counter of choice. The attack deals an additional 1d6 damage per level of the randomly recovered maneuver, and you gain 6 counterpoints, reduced by the level of the recovered counter.
            \nFor 1 round, every time you are attacked you gain a single counterpoint.`,
            initiationAction: `standard`,
            range: `melee or ranged attack`,
            duration: `1 round`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 6,
            name: "Push the Limit",
            type: "Boost",
            longDesc: `Choose a single strike, expend 3 random maneuvers (doesn't cost spell points), then immediately make that strike and its initiation action is reduced by 1 step. If you randomly expend the maneuver you intended to initiate, you fail to initiate it and you suffer a debilitating blunder, which causes you to be unable to take any actions for 1 round and take desperation equal to the level of the maneuver.`,
            initiationAction: `free`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 7,
            name: "Art of the King",
            type: "Boost",
            longDesc: `For 1 round, every time time you damage a creature with a manufactured weapon attack, you can add one sovereign stack to a Sterling Tactic. You cannot add more than 2 stacks per individual Sterling Tactic.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 6,
            name: "Sterling Tactic: Precision",
            type: "Boost",
            subSchool:['sterlingTactic'],
            longDesc: `[Sterling Tactic] Your next attack this turn has a flat +1 increase to its critical threat range.
            \nPer Sovereign Stack: increase the bonus by +1.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
            stacksOne: 0,
            stacksOneName: 'Sovereign Stacks',
            additionalInfoTags: ['Sterling Tactic'],
            },
            {
            school: `sterlingSovereignty`,
            level: 6,
            name: "Stand Your Ground",
            type: "Boost",
            longDesc: `Halve your stacks of desperation, then you gain counterpoints equal to your stacks of desperation. Unlike most counterpoints, these are removed at the end of your next turn.`,
            initiationAction: `movement`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
            additionalComboTags:["Heroic"],
            },
            {
            school: `sterlingSovereignty`,
            level: 6,
            name: "Prepare for the Onslaught",
            type: "Boost",
            longDesc: `Expend 1 counterpoint per level of the counter to recover it. If it is not a <technique>, <sakura>, <royal>, or <guardian> maneuver, it costs 2 points per level instead. You can recover multiple counters this way at once. Gain an additional immediate action next round that you can use to initiate one of the counters recovered this way.`,
            initiationAction: `movement`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 7,
            name: "Trust In Steel Alone",
            type: "Stance",
            longDesc: `While in this stance you cannot cast spells or use supernatural abilities. At the start of each of your turns you gain temporary hit points equal to your armor's bonus to your armor class. These both last 1 round. You must make saves against all magical and supernatural effects, even harmless or beneficial ones. If they are beneficial and would not normally allow a save, you are allowed to make one to negate the ability (use a save appropriate to the ability's function). If you have not benefited from a supernatural or spell effect within the last 2 rounds, you gain a +4 bonus on weapon attacks and armor class, a bonus to damage rolls equal to 1/2 your bab, and a +6 bonus to your saves, and you remove an extra desperation at the start of every one of your turns.
            \nIf you begin this stance while benefiting from a beneficial spell or supernatural effect that has a remaining duration longer than 2 rounds, and is not an ability that has triggered uses, you can end those effects on yourself immediately, and for the remaining duration they would have had, you get an additional +2 bonus to damage rolls (max 5 spells).  
            \nWhenever you score a critical hit with a weapon, you can recover a random maneuver or a stack to a sterling tactic (max 1 stack per tactic per round).
            \nWhen you end this stance, the penalties last for an additional 2 rounds.
            \n[shield]: The bonuses to saves and armor class increase by +2. Increase the temporary hit points you gain at the start of each turn by 2x your shield's shield bonus to armor class.
            \n[two-handed]: The bonus attack increases by +2, and the damage to your full BAB. Increase the temporary hit points you gain at the start of each turn by 2x your constitution modifier.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `stance`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 7,
            name: "Termina Strike",
            type: "Strike",
            longDesc: `Make an attack, its power is increased for all of your expended maneuvers. 
            \nFor each expended strike it deals an additional 3d6 damage. \nFor every 2 expended boosts it gains a +1 bonus to its attack. \nFor every 3 expended counters your critical threat range is increased by a flat +1.
            \nIf this kills the creature, you can recover 4 levels of maneuvers\nIf this attack is a critical hit, you can recover levels of maneuvers equal to 2x your critical damage multiplier (cannot recover this maneuver)`,
            initiationAction: `standard`,
            range: `melee or ranged attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 7,
            name: "Overthrow",
            type: "Strike",
            longDesc: `Make a melee attack, it deals an additional 2d6 damage per stack of desperation. If it hits, you transfer all of your desperation stacks to the creature. The creature removes them at twice the normal rate, and can take the total defense action to remove all of them.`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 7,
            name: "Cut In",
            type: "Counter",
            longDesc: `Gain an immediate action, take 3 desperation, then make a melee attack.`,
            initiationAction: `immediate`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 7,
            name: "Devastating Sidestep",
            type: "Counter",
            longDesc: `You initiate this counter when an enemy misses a melee attack against you. Take 4 desperation, and then you can make a <technique>, <sakura>, <royal>, or <guardian> strike against another creature that you are threatening and is threatening you. The strike must have an initiation action of a standard action or less. On your next turn you are staggered. This stagger cannot be resisted or removed. If what caused the creature to miss you was another counter, you can take 4 desperation to use this counter as a free action (that you can take even when not your turn), but the desperation applies before the strike is made.`,
            initiationAction: `immediate`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 7,
            name: "Harsh Lesson",
            type: "Strike",
            longDesc: `Make a melee attack that deals +6d6 damage, and if successful, for 1 round you gain a +1d8 dodge bonus to your armor class. If an attack misses you and you threaten the attacker, they provoke an attack of opportunity from you. If the attack only missed because of dodge bonuses you have gained from <technique>, <sakura>, or <royal> maneuvers, you also gain a bonus on the attack equal to the dodge bonus and twice that bonus to damage. If the attack is by the original target of this strike, the attack is also gains a flat +1 bonus to the critical threat range and critical damage multiplier. During the round, you gain additional attacks of opportunity equal to half your initiation modifier.
            \n[shield]: Dodge bonus increases by +2.
            \n[two-handed]: Counterattack damage Bonus +100%`,
            initiationAction: `standard`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 7,
            name: "Serpent Sword Technique",
            type: "Boost",
            longDesc: `For 1 round, if a creature you threaten makes an attack against you, it provokes an attack of opportunity from you. You can expend a boost in place of an attack of opportunity (or 2 sovereign stacks). This stacks with any attacks of opportunity provoked from other sterling sovereignty maneuvers. Your attack of opportunity is made after the attack roll is made, but before their damage roll is made (meaning it does not stop the damage if you are hit). If the creature's attack misses you, you gain a +2 bonus on your attack roll, if your attack of opportunity hits, they take a cumulative -1 penalty on attack rolls for the rest of their turn.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 7,
            name: "Flash of Inspiration",
            type: "Boost",
            longDesc: `You can expend a random maneuver (doesn't cost spell points). 
            \nIf it was a strike, you can initiate it this round. If you do, its initiation action is reduced by 1 step. 
            \nIf it was a boost, you can do 1 of 3 things: \n1: You can initiate it this round for no spell points and have its initiation action reduced by 1 step \n2: You can recover another maneuver of choice \n3: If it was a [Sterling Tactic], you can give it 3 sovereign stacks. 
            \nIf it was a counter, you gain counterpoints equal to twice its level, and you can initiate it within 1 round as a free action that you can take even when not your turn.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 7,
            name: "Sterling Tactic: Faith",
            type: "Boost",
            subSchool:['sterlingTactic'],
            longDesc: `[Sterling Tactic] If your next attack this round is successful, all allies that see you make that attack gain a +1 bonus on saving throws against that creature's spells and abilities for 1 round. You gain double this bonus.
            \nPer Sovereign Stack: increase the bonus by +1.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
            stacksOne: 0,
            stacksOneName: 'Sovereign Stacks',
            additionalInfoTags: ['Sterling Tactic'],
            },
            {
            school: `sterlingSovereignty`,
            level: 8,
            name: "Ruat Caelum",
            type: "Boost",
            longDesc: `Take an immediate standard action to initiate a strike with an initiation action of a standard action or less. At the end of the standard action you take 5 desperation and cannot remove desperation for 2 rounds.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `instantaneous`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 8,
            name: "Action Surge",
            type: "Boost",
            longDesc: `After the initiation action of this maneuver you expend up to initiation modifier random manuevers (min 4, max 8. doesn't cost spell points). Then for the round following the initiation, you can initiate any of those maneuvers (costing spell points as normal), but they have their initiation action reduced by 1 step (you can use counters as a free action that you can take when not your turn). You can only initiate each of those maneuvers once.`,
            initiationAction: `1 round`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
            },
            {
            school: `sterlingSovereignty`,
            level: 8,
            name: "Impugnatio Ultima",
            type: "Strike",
            longDesc: `As a full-round action you make a single melee attack against a creature. You can expend a readied strike of at least level 4 to make an additional attack (max attacks bab/2). 
            \nYou can also expend readied boosts of at least level 4 to increase the damage of all attacks by the level of the boost (or 2 sovereign stacks. Max expended boosts equal to your initiation modifier)
            \nYou take 1 desperation for each extra attack taken with this maneuver. Expended maneuvers don't cost spell points. You cannot recover this maneuver, or any of the additional strikes expended the round you use it, or use it the round you recover it.`,
            initiationAction: `full-round`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 8,
            name: "Miserere Mei, Deus",
            type: "Strike",
            longDesc: `Make a single melee attack against a creature, your penalty to attack because of desperation is reduced by half and it deals an additional 1d4 points of damage per desperation stack. If successful, remove half of your desperation stacks (minimum 3), otherwise remove 2 desperation. If it is a critical hit, remove as much desperation as you want.`,
            initiationAction: `swift`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 9,
            name: "Perfect Counter",
            type: "Counter",
            longDesc: `You automatically negate an attack against you and cause it to miss. You can even do this when you normally couldn't activate a counter, such as when the opponent rolled a natural 20 or you were flat-footed. This even allows you to counter attacks that normally can't be countered. After you counter their attack, if you threaten them, you can make an immediate counterattack with a melee weapon. If the attack hits, the creature must make a reflex save or the attack is an automatic potential critical hit. You take 2 desperation after initiating this counter.`,
            initiationAction: `immediate`,
            range: `you`,
            duration: `instantaneous`,
            target: `personal`,
            },
            {
            school: `sterlingSovereignty`,
            level: 8,
            name: "Sterling Tactic: Execution",
            type: "Boost",
            subSchool:['sterlingTactic'],
            longDesc: `[Sterling Tactic] Your next attack this round has a flat +0.5 increase to its critical damage multiplier. This is rounded down to the closest whole multiplier.
            \nPer Sovereign Stack: increase the bonus by +0.5.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `1 round`,
            target: `you`,
            stacksOne: 0,
            stacksOneName: 'Sovereign Stacks',
            additionalInfoTags: ['Sterling Tactic'],
            },
            {
            school: `sterlingSovereignty`,
            level: 8,
            name: "Sterling Tactic: Tenacity",
            type: "Boost",
            subSchool:['sterlingTactic'],
            longDesc: `[Sterling Tactic] Recover 1 maneuver. Max level 3 maneuver. You cannot use this to recover sterling tactics.
            \nPer Sovereign Stack: increase the maneuvers recovered by 0.5, or their max level by 1.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `instantaneous`,
            target: `you`,
            stacksOne: 0,
            stacksOneName: 'Sovereign Stacks',
            additionalInfoTags: ['Sterling Tactic'],
            },
            {
            school: `sterlingSovereignty`,
            level: 8,
            name: "Sterling Tactic: Inspiration",
            type: "Boost",
            subSchool:['sterlingTactic'],
            longDesc: `[Sterling Tactic] Recover a random maneuver.
            \nPer Sovereign Stack: increase the maneuvers recovered by 0.5.`,
            initiationAction: `swift`,
            range: `personal`,
            duration: `instantaneous`,
            target: `you`,
            stacksOne: 0,
            stacksOneName: 'Sovereign Stacks',
            additionalInfoTags: ['Sterling Tactic'],
            },
            {
            school: `sterlingSovereignty`,
            level: 9,
            name: "Omnislash",
            type: "Strike",
            longDesc: `As a full-round action you make a melee attack. You can choose to take another additional attack, but it is at a cumulative -2 penalty from the previous attack. You can take up to bab-5 attacks with this strike (max 15). You can can move 5 feet without provoking attacks of opportunity after each attack made. You cannot recover this maneuver the round you use it, or use it the round you recover it. After you use this strike, you suffer 1 desperation for every attack taken, and on your following turn you are staggered. If you took more than half your maximum attacks, you are also exhausted for the rest of combat (both are unresistable & unremovable).`,
            initiationAction: `full-round`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
            school: `sterlingSovereignty`,
            level: 9,
            name: "Sterling Tactic: True Sovereignty",
            type: "Strike",
            subSchool:['sterlingTactic'],
            longDesc: `[Sterling Tactic] Make a melee attack with a -1 penalty, then take 1 desperation. You are staggered for 1 round after using this boost. If you were already staggered next turn, you are instead stunned. (both are unresistable & unremovable)
            \nPer Sovereign Stack: You can make another melee attack, however all of your attacks during this maneuver take a -1 penalty and you also take another desperation afterwards.`,
            initiationAction: `movement`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            stacksOne: 0,
            stacksOneName: 'Sovereign Stacks',
            additionalInfoTags: ['Sterling Tactic'],
            },
            {
            school: `sterlingSovereignty`,
            level: 9,
            name: "Archistrategos Intercession",
            type: "Strike",
            longDesc: `Make a melee attack, the attack is an automatic critical hit, though you roll to confirm it anyway. If the confirmation roll is within your critical threat range, your attack has its critical damage multiplier increased by the weapons base critical damage multiplier-1 (before augmentation), and then you roll to confirm the attack again, though your critical threat range is reduced by a flat -1, and the attack is reduced by -2. If it is within the critical threat range again (and would still hit), you can keep rolling to confirm, each additional confirmation taking cumulative -1 to the threat range and -2 to the attack. This process ends when you fail to roll within your critical threat range or confirmirmation roll is not enough to confirm the attack. The confirmation rolls of this ability are not affected by abilities that automatically confirm critical hits, and abilities that modify your next critical confirmation roll only affect a single critical confirmation roll (if they affect multiple, it affects that many confirmation rolls, to a maximum of 3 rolls).
            \nThis attack can be made against creatures with critical hit immunity, it ignores the immunity, however the initial attack has its base critical damage multiplier reduced to x0 (meaning it does no damage unless you confirm at least 1 additional critical hit).`,
            initiationAction: `full-round`,
            range: `melee attack`,
            duration: `instantaneous`,
            target: `1 enemy`,
            },
            {
              school: 'blackSeraph',
              level: 1,
              name: "Demon's Grip",
              type: "Boost",
              longDesc: `For 1 round, you can take a -2 penalty on the attack roll to wield a two-handed weapon in one hand. It still deals damage as if it were wielded in two-hands. You can only attack with a single weapon this way per turn.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'blackSeraph',
              level: 2,
              name: "Terrifying Approach",
              type: "Boost",
              longDesc: `You move your movement speed as normal, if you end your movement threatening an enemy, you can make an intimidation check to demoralize them as a free action. If you succeed on demoralizing at least 1 creature, you gain temporary hit points equal to your intimidate bonus.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'blackSeraph',
              level: 3,
              name: "Devastating Grip",
              type: "Boost",
              longDesc: `If your next melee attack with a two-handed weapon this turn is successful, you roll the weapon's damage dice for the attack twice and add the results together before adding bonuses from other bonuses such as strength and enchantments. This otherwise functions like and stacks with vital strike and similar abilities`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'blackSeraph',
              level: 4,
              name: "Demonic Aura",
              type: "Boost",
              longDesc: `Make an intimidate check and then move up to your movement speed as normal. Your armor class and CMD (including against touch attacks) is equal to your intimidation check for attacks made against you during this movement, plus the first attack against you within 1 round after. If you activate this as a swift, it applies to any movement you make during the round, but you do not get to move as a part of initiating it, and you take a -10 penalty to your intimidate roll. This is a [mind-affecting] [fear] effect.`,
              initiationAction: `movement or swift`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
                school: 'unquietGrave',
                level: 3,
                name: "Grave Walk",
                type: "Boost",
                longDesc: `Move squares equal to your initiation modifier. This movement does not provoke. You can move through the spaces of enemies who's ability score that is the score you use as your initiation modifier without provoking. If you do, they suffer negative energy damage equal to half of a Knowledge (religion) check (will halves), and become shaken for 1 round. If you attempt to move through a creature's square and they have a higher score than you, the movement to enter their square is wasted, the maneuver ends with no further benefit, and you suffer a -2 penalty to attack, AC, and saves for 1 round.`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
                utility: true,
              }, 
              {
                school: 'blackSeraph',
                level: 3,
                name: "Trample the Weak",
                type: "Boost",
                longDesc: `Move squares equal to your strength modifier. This movement does not provoke. You can move through the spaces of enemies who's strength score is lower than yours without provoking. If you do, you can make an intimidate check to demoralize them as a free action, if it succeeds, they also suffer a -2 penalty to armor class as long as they remain shaken from this. If you attempt to move through a creature's square and they have a higher strength score than you, the movement to enter their square is wasted, the maneuver ends with no further benefit, and you suffer a -4 penalty to attack and AC for 1 round.`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
                utility: true,
              },
              {
              school: 'blackSeraph',
              level: 5,
              name: "Abyssal Gaze",
              type: "Boost",
              longDesc: `Choose an enemy and make an intimidate check. Your armor class and CMD (including against touch attacks) is equal to your intimidation check for attacks made against you by that creature for 1 round. You cannot initiate this maneuver two rounds in a row.`,
              initiationAction: `movement`,
              range: `melee reach`,
              duration: `1 round`,
              target: `threatened enemy`,
              utility: true,
              },
              {
                school: 'blackSeraph',
                level: 7,
                name: "Tyrant's Reign",
                type: "Boost",
                longDesc: `Make an intimidate check. Your armor class and CMD (including against touch attacks) is equal to your intimidation check for attacks made against you for 1 round. Creatures who miss you with an attack during this round, suffer a -1 penalty to AC and saves for 1 round (stacks).`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
                utility: true,
              },
              {
              school: 'brokenBlade',
              level: 1,
              name: "High Blade Kick",
              type: "Strike",
              longDesc: `Move 10 feet in a straight line without provoking attacks of opportunity and make a foot attack with a -4 penalty. The attack deals damage as if it were a two-handed attack. The space you move into with this maneuver must be the closest space available for you to attack the creature (similar to a charge). After using this maneuver, you suffer a -2 penalty to AC for 1 round.`,
              initiationAction: `movement`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              additionalInfoTags:["Special Body Attack"]
              },
              {
              school: 'brokenBlade',
              level: 3,
              name: "Slide Kick",
              type: "Boost",
              longDesc: `You can use this maneuver in one of two ways.
              \n1: You move up to your movement speed as normal -5 feet. In the last 10 feet of your movement, you break into a slide and attempt to kick the legs out from a creature. This last 10 feet of movement does not provoke unless the creature can make attacks of opportunity while flat-footed. Then at the end of your movement you make an unarmed foot attack, though the creature is flat-footed for the attack. If successful, it deals half the normal damage, but you also make a trip attempt as a free action which doesn't provoke, gaining a bonus on the attempt an amount equal to half the damage dealt.
              \n2: You move half your movement speed in a straight line. Only the first square of movement from this maneuver provokes. If you collide with a creature, you may make a trip attempt against them which doesn't provoke, and for which they are flat-footed. If it succeeds, they are knocked prone and you may continue moving through their square without provoking attacks of opportunity.
              \nAt the end of this maneuver, you become prone. If you are flying, you instead receive a -4 penalty to AC until the start of your next turn.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'brokenBlade',
              level: 4,
              name: "Ankle Shatter",
              type: "Strike",
              longDesc: `Make an unarmed trip attempt without provoking. If successful, you deal unarmed damage as if you had struck them with an off-hand foot attack.`,
              initiationAction: `movement`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'brokenBlade',
              level: 5,
              name: "Adamantine Hand",
              type: "Boost",
              longDesc: `You must have a free hand to initiate or gain the benefits of this maneuver. Choose an enemy, you raise your hand in preperation for their next melee against you. The next time within 1 round that they make a melee attack against you (that you can see and are not flat-footed for), the attack suffers a penalty to its attack roll equal to your initiation modifier, and if the attack would be a critical hit, it has a 50% chance to be reduced to a normal hit instead. This stacks with fortification, but is rolled seperately. Any reduction to fortification also applies to this percentage.`,
              initiationAction: `movement`,
              range: `sight`,
              duration: `1 round`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'brutalCrocodile',
              level: 1,
              name: "Spin About",
              type: "Boost",
              longDesc: `You move a grappled enemy to the square on the exact opposite side of you. After moving them, you can choose to make a trip attempt against them that doesn't provoke as a free action. This attempt gains a +5 bonus, and uses the bonuses you gain to grapple and trip at the same time (like bonuses still do not stack, eg morale, but improved trip and improved grapple do), this still only counts as making a trip attempt. If you use this option, you fall prone after using it, whether it is successful or not.`,
              initiationAction: `movement`,
              range: `grappled creature`,
              duration: `instantaneous`,
              target: `grappled creatre`,
              utility: true,
              },
              {
              school: 'brutalCrocodile',
              level: 2,
              name: "Crocodile Sprint",
              type: "Boost",
              longDesc: `You make a climb check, moving feet equal to the result of the check, plus half of your movement speed. You can use the result of this check in place of acrobatics for moving through enemies squares or threatened area without reducing your movement speed, and you can do this even if in heavy armor. You must be on the ground to use this, and can use this to move its full speed even if prone.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'brutalCrocodile',
              level: 3,
              name: "Crocodile Ride",
              type: "Boost",
              longDesc: `You move, snagging an ally from a dangerous situation and carrying them with you. Move up to your movement speed, as you do, you can climb as if you had a climb speed, and you can make a grapple attempt against another ally that is within your reach at any point during the movement, gaining a bonus to it equal to your level (the ally cannot automatically accept this grapple). If you succeed, they ally moves with you the remainder of your movement, though you move at half speed for your remaining movement. Neither your grapple attempt or their movement provokes attacks of opportunity. When you end your movement, you can end them in any squares within your natural reach. If the ally was grappled when you used this, you must make an opposing grapple check against the creature grappling them, on success, you pull the ally from their grasp and continue your movement.`,
              initiationAction: `movement`,
              range: `natural reach`,
              duration: `instantaneous`,
              target: `1 ally`,
              utility: true,
              },
              {
              school: 'brutalCrocodile',
              level: 4,
              name: "Crocodile Bounce",
              type: "Boost",
              longDesc: `You grab an ally and use a powerful throw to hurl them. Make a climb check, move an ally within your natural reach in a straight line any direction away from you a distance equal to the result of the check. You can move up to half your movement speed first if you'd like, but you reduce the result of the check by half. The allies movement does not provoke against any of the enemies that are threatening them at the start of their movemenent, and they can use your climb check in place of their acrobatics check for avoiding attacks of opportunity without reducing the distance they move.`,
              initiationAction: `movement`,
              range: `natural reach`,
              duration: `instantaneous`,
              target: `1 ally`,
              utility: true,
              },
              {
              school: 'burningCitadel',
              level: 1,
              name: "Pyre Rush",
              type: "Boost",
              longDesc: `Move up to your movement speed, any creature you are adjacent to at any point of your movement gains 1 immolation stack. Every 5 levels the immolation stacks given are increased by +1. At level 10, this increases to all creatures you threaten during your movement. You also receive these immolation stacks.
              \n[Overheat-10]: Increase your movement speed by 10 feet and enemies you give immolation stacks to with this maneuver also suffer fire damage equal to your immolation stacks.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'burningCitadel',
              level: 2,
              name: "Burning Waltz",
              type: "Boost",
              longDesc: `If Movement: Move 5 feet per 2 immolation stacks on yourself. This movement does not provoke.
              \nIf Swift: Move 5 feet per 4 immolation stacks. This movement does not provoke.
              \nWhen moving with this maneuver, you cannot go more than 3 tiles in a single direction until you move at least 3 tiles in a different direction. Diagonally counts as both directions but doesn't count towards resetting other directions.`,
              initiationAction: `movement or swift`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'burningCitadel',
              level: 2,
              name: "Ashen Barrier",
              type: "Boost",
              longDesc: `Move up to half your movement speed in a straight line. You gain a shield bonus to your armor class equal to 1/3 your immolation stacks against the next attack against you. If the attack is a melee attack and misses, they suffer fire damage equal to 2x your immolation and receive 4 immolation
              \n[Overheat-10x]: This lasts an additional attack against you. You suffer untyped damage equal to your immolations stacks.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'burningCitadel',
              level: 3,
              name: "Searing Rebuke",
              type: "Boost",
              longDesc: `Choose a creature, they suffer a penalty on their next attack within 1 round equal to 1/4 of their immolation stacks. If they hit the attack, they can choose to remove all immolation stacks. If the attack misses, they take fire damage equal equal to their immolation stacks and then remove half of their immolation stacks.`,
              initiationAction: `movement`,
              range: `1 enemy`,
              duration: `1 round`,
              target: `30 feet`,
              utility: true,
              },
              {
              school: 'burningCitadel',
              level: 2,
              name: "Scorching Threat",
              type: "Boost",
              longDesc: `Make an intimidate check against a creature, instead of becoming shaken, they suffer 1d3 fire damage and 1 immolation stack per round they would have be shaken.`,
              initiationAction: `movement`,
              range: `1 enemy`,
              duration: `instantaneous`,
              target: `30 feet`,
              utility: true,
              },
              {
              school: 'burningCitadel',
              level: 3,
              name: "Flashfire",
              type: "Boost",
              longDesc: `If movement: Move half of your movement speed without provoking attacks of opportunity, and then your next melee attack during a strike this turn has its reach increased by 5 feet and deals an additional 2d6 fire damage and gives 1 immolation stack. 
              \nIf Swift: Your next melee attack during a strike this turn has its reach increased by 5 feet and deals an additional 1d6 fire damage, but you suffer a -2 penalty to AC for 1 round.
              \nFor either option, the attacks must be with a two-handed or a one-handed weapon wielded in two hands to gain these benefits. At level 11 the reach increases to 10 feet.
              \nWhen you initiate this maneuver you take 1 fire damage and then receive 3 immolation stacks.`,
              initiationAction: `movement or swift`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
                school: 'burningCitadel',
                level: 5,
                name: "Ride the Phoenix",
                type: "Boost",
                longDesc: `Make a CMB check as if making a bull rush, move in a straight line any direction (even upwards) a distance up to the result of the check -10. You can move through the squares of enemies with this as long as the result of the check is higher than their CMD vs bull rush, though your movement provokes as normal. You and any creatures adjacent to you at any point of this maneuver, or that you charge while using this, takes 4d6 points of fire damage and 2 immolation stacks (reflex halves). You can use this as apart of a charge attack, doing so doesn't double the distance you can move, and reduces your armor class by a further -2, deals 2d6 fire damage to you and gives 4 immolation, but grants the attack +2d6 bonus fire damage.`,
                gameDesc: `Make a CMB check as if making a bull rush, move in a straight line any direction (even upwards) a distance up to the result of the check -10. You can move through the squares of enemies with this as long as the result of the check is higher than their CMD vs bull rush, though your movement provokes as normal. You and any creatures adjacent to you at any point of this maneuver, or that you charge while using this, take 4d6 points of fire damage and 2 immolation stacks (reflex halves). You can use this as apart of a charge attack, doing so doesn't double the distance you can move, and reduces your armor class by a further -2, deals 2d6 fire damage to you and gives 4 immolation, but grants the attack +2d6 bonus fire damage.
                \nZhao: You can add your ranks of Profession (Monster Rider) to the check.`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
                utility: true,
              },
              {
              school: 'burningCitadel',
              level: 4,
              name: "Phoenix Dive",
              type: "Boost",
              longDesc: `You sprout phoenix wings that lift you 60 feet upwards (or highest possible), and then bring you plummeting downwards in a fiery landing to a square within 60 feet of where you initiated this maneuver (bonuses to flight speed are added to the distance travelled). This movement does not provoke. When you land, you unleash a blast of flame that deals 5d6 points of fire damage and gives 2 stacks of immolation to all creature's adjacent to where you land. Creatures can make a reflex save to halve the damage.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'burningCitadel',
              level: 4,
              name: "Smoldering Path",
              type: "Boost",
              longDesc: `You can initiate this maneuver in 1 of two ways.
              \n1: You move your movement speed, as you do, you leave a trail of smoke behind you. This restricts vision as If it was fog cloud, lasting 1 round.
              \n2: You fill the area within your reach with smoke, restricting vision as the fog cloud spell for 1 round, except that you extend the distance you can see within the fog by 5 feet.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'burningCitadel',
              level: 4,
              name: "Blazing Advance",
              type: "Boost",
              longDesc: `You move up to your movement speed, igniting the area behind you as you move for 1 round. Any creature that enters or ends their turn in the area you moved through receives 3d6 + initiation modifier fire damage and suffers 2 immolation stacks. They can only take this damage once per movement.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'burningCitadel',
              level: 5,
              name: "Firestorm Vanguard",
              type: "Boost",
              longDesc: `Move 5 feet per immolation stack on yourself. You expend half of the immolation stacks on yourself and gain a dodge bonus to armor class equal to half of the stacks expended for 1 round. If an attack misses you, the dodge bonus decreases by 1.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'burningCitadel',
              level: 3,
              name: "Surging Fire",
              type: "Boost",
              longDesc: `Increase or decrease your immolation stacks by up to your initiation modifier (minimum 2, +1 per 4 levels). If you decrease them, you heal 1d6 per stack removed and can move 5 feet per stack removed. If you increase them, you take 1d2 points of fire damage per stack added but gain a +1 shield bonus to armor class for 1 round.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'burningCitadel',
              level: 3,
              name: "Burning Resurgence",
              type: "Boost",
              longDesc: `Expend up to initiation modifier immolation stacks on yourself (minimum 3), heal 1d4 hit points and gain 1d6 temporary hit points per stack expended. The temporary hit points last level/2 rounds.
              \n[Overheat-10x]: Move 5 feet without provoking attacks of opportunity, but only as long as you are moving towards an enemy. You also gain a +2 shield bonus to armor class against the creature for the next attack against you they make.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'burningCitadel',
              level: 5,
              name: "Inferno Shield",
              type: "Boost",
              longDesc: `Expend half of your immolation stacks, gaining DR /- equal to the stacks expended for 1 round. This DR stacks with other DR, but is halved. If the attack deals any cold damage, this DR is ignored.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'burningCitadel',
              level: 6,
              name: "Blazing Vanguard",
              type: "Boost",
              longDesc: `Expend half of your immolation stacks. For 1 round you increase your armor bonus an amount equal to half your current immolation stacks. You must be wearing medium or heavy armor to use this maneuver. If you have at least 1 immolation stack and a creature misses you with a melee attack, you reduce your immolation stacks by 1 and they receive 2 immolation stacks.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
                school: 'burningCitadel',
                level: 7,
                name: "Blast Shield",
                type: "Boost",
                longDesc: `You wrap yourself in blazing shield. Expend all stacks of immolation on yourself and gain 1d6 temporary hit points for every stack expended. These temporary hit points last until the end of combat, and are always lost first, even before other temporary hit points. As long as these temporary hit points last, every time an enemy makes a successful melee attack against you they suffer 1 immolation stack. If these temporary hit points are reduced to 0 due to hit point damage, the shield explodes outwards, dealing fire damage equal to the damage of the attack that removed them (max the shields initial amount). This has a range of 10 feet centered on you, and creatures can make a reflex save to halve the damage.`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `combat`,
                target: `you`,
              },
              {
              school: 'crimsonReaper',
              level: 2,
              name: "Bloodstained Hunt",
              type: "Boost",
              longDesc: `Move up to your movement speed as normal. If a creature attacks you during it, you can move an extra 10 feet during your movement, they suffer siphon damage equal to your constitution modifier, and any damage they deal with their attack is reduced by the amount of siphon damage dealt. At level 10 the siphon damage increases to your constitution score.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
                school: 'crimsonReaper',
                level: 4,
                name: "Garnet Barrier",
                type: "Boost",
                longDesc: `Swift: Gain a deflection bonus to your armor class equal to your constitution modifier for 1 round. Every time an enemy misses you with a melee attack, they take siphon damage equal to your constitution score and the gained deflection bonus reduced by 1.
                \nMovement: Move up to half your movement speed and then gain the bonuses of activating this as a swift action, however the bonus to deflection is not reduced if they missed you by an amount greater than the gained deflection bonus.`,
                initiationAction: `swift or movement`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
                utility: true,
              },
              {
                school: 'primalFury',
                level: 4,
                name: "Savage Resolve",
                type: "Boost",
                longDesc: `Move 5 feet per strength modifier without provoking attacks of opportunity. During this movement and for 1 round after, gain an enhancement bonus to your natural armor equal to your strength modifier. Every time you are attacked, the natural armor bonus reduces by 1.`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
                utility: true,
              },
              {
              school: 'crimsonReaper',
              level: 2,
              name: "Prepare for Violence",
              type: "Boost",
              longDesc: `Gain temporary hit points equal to your constitution score for 1d4 rounds and an enhancement bonus to your natural armor equal to your constitution modifier for 1 round. You can expend <death> combo points or blood points to increase the temporary hit points by your half constitution score and their duration by 1 round.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `see text;`,
              target: `you`,
              utility: true,
              },
              {
                school: 'crimsonReaper',
                level: 2,
                name: "Blood Pact",
                type: "Boost",
                longDesc: `Choose a creature within 30 feet, you take 1d6 points of damage for every odd level, but every attack against them has their critical threat range against them increased by a flat +1 for 1 round. If the creature suffers a critical hit in the duration, you heal hit points equal to 2x your level and the creature takes additional siphon damage equal to the amount healed.`,
                initiationAction: `movement`,
                range: `30 feet`,
                duration: `1 round`,
                target: `1 enemy`,
                utility: true,
              },
              {
              school: 'crimsonReaper',
              level: 3,
              name: "Surging Violence",
              type: "Boost",
              longDesc: `You can expend 2 <death/arcane> combo points in place of a blood point this round.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              },
              {
                school: 'crimsonReaper',
                level: 5,
                name: "Pull the Red Thread",
                type: "Boost",
                longDesc: `When you initiate this maneuver, your turn ends immediately. Pick a target you can see, then you leap into the air directly upwards and cause a red string to appear beneath you for which you stand on. Make a spellcraft check, you move directly upwards that distance and stand on the thread. This movement does not provoke. At the start of your next turn as a free action, you rush directly at the target, moving in a straight line up to twice your movement speed. You can fly during this, as long as you are attacking a creature of a lower elevation than when you were standing on the thread. When you arrive, you attack the creature, though you do not need to make an attack roll. Deal damage as normal with your weapon, plus 6d6 siphon damage. The creature may make a reflex save to halve this damage. Although you did not roll an attack roll, treat this as an attack for most purposes, including needing to roll against concealment, they also are unable to counter this attack unless the counter applies to reflex saves. If their reflex save rolls within a range of a natural one that is the same that is equal to or less than the amount of numbers on a dice you get a critical hit, the attack deals critical damage (if the reflex save was still successful, they halve the damage after the critical damage is dealt).`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },
              {
              school: 'crimsonReaper',
              level: 2,
              name: "Unstaunched Agony",
              type: "Boost",
              longDesc: `[pain] Target a creature that you can see that is currently bleeding, for 1 round, for each stack of bleeding the creature is suffering from, they suffer a penalty on damage rolls, half the penalty on attack rolls (minimum 0), and twice the penalty to concentration checks. If any of the bleeding requires a check to remove, the DC to remove it increases by +2 for 1 round.`,
              initiationAction: `movement`,
              range: `30 feet`,
              duration: `2 rounds`,
              target: `1 bleeding enemy`,
              utility: true,
              },
              {
              school: 'crimsonReaper',
              level: 3,
              name: "Urging",
              type: "Boost",
              longDesc: `You can initiate this for one of two benefits:
              \n1: Move your movement speed. For every blood point you currently have, the movement increases by 10 feet.
              \n2: Move half of your movement speed. For 1 round, you gain a dodge bonus to your armor class equal to your blood points. Every time an attack misses you, the dodge bonus is reduced by 1.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous or 1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'crimsonReaper',
              level: 3,
              name: "Crimson Wake",
              type: "Boost",
              longDesc: `You move up to your movement speed, leaving a trail of blood along the ground behind you for 1 round. Any creature that tries to move through those squares must make a reflex save or be entangled to the spot for 1 round and suffer 1d6 points of bleeding damage (stacks with other bleed damage). Moving over multiple squares can require multiple saves.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'crimsonReaper',
              level: 3,
              name: "Corrupted Cells",
              type: "Boost",
              longDesc: `<curse> Make a touch attack against an enemy, if it hits and they are above 25% hit points, they are cursed for 5 rounds. If within those rounds, they are reduced below 25% hit points, you may make an immediate melee attack against them if you threaten them, and they immediately take 1d6 per initiator level siphon damage (fort halves), and you heal half of this damage. Once this triggers, the effect ends.`,
              initiationAction: `movement`,
              range: `melee touch attack`,
              duration: `5 rounds`,
              target: `1 living enemy`,
              utility: true,
              },
              {
                school: 'crimsonReaper',
                level: 3,
                name: "Bite of Flesh",
                type: "Strike",
                longDesc: `Make a melee touch attack, if successful, it deals no damage, but the creature takes damage equal to its current temporary hit points, these bypass any temporary hit points it has. It then may make a fortitude save, on failure, it then losses half of its temporary hit points, you gain them, and it becomes cursed for 1 round. While cursed, if it gains temporary hit points, it takes damage equal to half of the temporary hit points gained (also bypasses its temporary hit points), and you gain half the temporary hit points it gained.`,
                initiationAction: `standard`,
                range: `touch`,
                duration: `1 round`,
                target: `1 living enemy`,
              },
              // {
              //   school: 'crimsonReaper',
              //   level: 3,
              //   name: "Blood Pact",
              //   type: "Strike",
              //   longDesc: ``,
              //   initiationAction: `swift`,
              //   range: `touch`,
              //   duration: `1 round`,
              //   target: `1 living enemy`,
              // },
              {
              school: 'crimsonReaper',
              level: 4,
              name: "Wings of Blood",
              type: "Boost",
              longDesc: `Teleport adjacent to a bleeding creature. The next attack this turn you make against the bleeding target gets a +2 bonus to attack and deals an additional 2d6 damage. If your attack misses or you fail to attack it at all this round, you suffer 4d6 points of damage and take a -2 penalty on all d20 rolls for 1 round after.`,
              initiationAction: `movement`,
              range: `bleeding creature`,
              duration: `instantaneous`,
              target: `medium (100 ft. + 10ft./level)`,
              utility: true,
              },
              {
              school: 'crimsonReaper',
              level: 4,
              name: "Warm Pulse",
              type: "Boost",
              longDesc: `You can take up to 1d6 points of damage per 2 initator levels, to grant yourself fast healing equal to 2x the amount of d8's rolled for rounds equal to your initiation modifier. This stacks with other fast healing (except itself), but it counts as a single source of healing. You can only use this during combat.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `initiation modifier rounds`,
              target: `you`,
              utility: true,
              },
              {
              school: 'crimsonReaper',
              level: 4,
              name: "Sacrificial Pact",
              type: "Boost",
              longDesc: `You take 1d4 damage per 3 levels (minimum 2d4), and then have your maximum hit points reduced by the same amount (this doesn't reduce your current hit points). You then gain temporary hit points equal to your maximum hit points (before the reduction). Until 2 rounds after these temporary hit points are lost, you cannot heal or gain temporary hit points from any source. You can only use this maneuver in combat. These temporary hit points last until lost, or the end of combat.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `combat`,
              target: `you`,
              },
              {
              school: 'crimsonReaper',
              level: 6,
              name: "Bloody Wrath",
              type: "Boost",
              longDesc: `You can only initiate this maneuver when below 10% hit points. The next time this round that you deal siphon damage, the damage is doubled. If this damage would heal or grant you temporary hit points, you do not gain them.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'crimsonReaper',
              level: 6,
              name: "Sharpened by Crimson Tears",
              type: "Boost",
              longDesc: `You must be below 50% of your normal maximum hit points to initiate this maneuver (not including temporary hit points). You move up to half of your movement speed, running your hand along one of your bladed weapons and coating it in your blood. This deals 1d4 points of damage to you per level. Both the movement and the act of coating your weapon in blood provoke attacks of opportunity; however, if you have the ability to draw your weapon as a free action, the act of coating your weapon in blood no longer provokes. The next time you threaten a critical hit with a <death> or <sakura> maneuver with this weapon, the critical damage multiplier is increased by +1. This does not stack. If you are below 25% hit points when you use this, increase your critical threat range by a flat +1 for your next attack with the weapon as well. You must be wielding the weapon to gain the benefits of this maneuver.
              \nIf you are bleeding when you initiate this maneuver, the critical hit empowered by this maneuver also deals bonus damage equal 2x the amount of bleed damage you took the round you initiated this maneuver (not multipied by the critical hit)`,
              initiationAction: `movement`,
              range: `melee weapon`,
              duration: `1 minute or expended`,
              target: `1 weapon`,
              utility: true,
              },
              {
              school: 'cursedRazor',
              level: 1,
              name: "Hexwalker's Glide",
              type: "Boost",
              longDesc: `Move 10 feet without provoking attacks of opportunity. During this movement, choose any creature you are adjacent to at any point. You curse a creature for 1 round, making them unable to take 5-foot steps. Every 6 initiator levels, the distance you move increases by 5 feet. You can also expend a <curse> combo point to move an additional 5 feet.`,
              initiationAction: `movement`,
              range: `adjacent`,
              duration: `1 round`,
              target: `1 creature`,
              utility: true,
              },
              {
              school: 'cursedRazor',
              level: 2,
              name: "Cursed Stride",
              type: "Boost",
              longDesc: `[curse] Move up to your movement speed. You can use spellcraft in place of acrobatics to avoid attacks of opportunity or move through threatened creatures, which you can do even if wearing heavy armor, and doing so does not reduce your movement speed. Every enemy adjacent to you during this movement becomes cursed for 1 round. Every 8 initiator levels, the curse lasts an additional round.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'cursedRazor',
              level: 3,
              name: "Walk To Your Death",
              type: "Boost",
              longDesc: `You compel a creature to move 10 feet directly closer towards you. It does this immediately as a free action it can take even when not its turn. The location it moves to cannot be inherently dangerous or this fails, and the movement does not provoke attacks of opportunity any under circumstance (even with abilities that can make AoO's for unusual circumstances). It must then make a will save or have its movement speed reduced by half for 1 round.`,
              initiationAction: `movement`,
              range: `30 feet`,
              duration: `1 round`,
              target: `1 creature`,
              utility: true,
              },
              {
              school: 'cursedRazor',
              level: 4,
              name: "Ticking Clock",
              type: "Boost",
              longDesc: `[curse] Choose a creature within 30 feet, it becomes cursed until you recover this maneuver. When you recover this maneuver, it suffers 1d3 damage per your initiation modifier (max dice steps equal to level/2). For every round this maneuver is not recovered, the damage increases by 1 dice step. If you recover this maneuver randomly, the damage increases by 2 dice steps. You must have sight of the creature cursed at least once every round or this maneuver ends.`,
              gameDesc: `[curse] Choose a creature within 30 feet, it becomes cursed until you recover this maneuver. When you recover this maneuver, it suffers 1d3 damage per your initiation modifier (max dice steps equal to level/2). Creatures are aware they have been cursed by this maneuver. For every round this maneuver is not recovered, the damage increases by 1 dice step. If you recover this maneuver randomly and are in combat when it is recovered, the damage increases by 2 dice steps.`,
              initiationAction: `movement`,
              range: `30 feet`,
              duration: `see text`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'cursedRazor',
              level: 3,
              name: "Cripple the Soul",
              type: "Boost",
              longDesc: `You must make a melee touch attack, or see them if they are cursed. The cursed creature suffers a -2 penalty to the DC of any spell, ability, or maneuver they use for 1 round. You can expend a <curse> combo point as you initiate this maneuver to increase the duration by 1 round.`,
              initiationAction: `movement`,
              range: `touch, or cursed`,
              duration: `1 round`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'eternalGuardian',
              level: 4,
              name: "Warden's Lockdown",
              type: "Boost",
              longDesc: `Make a CMB check against a creature as if making a bull rush, reposition, or drag (your choice, you can make this check with your weapon). This doesn't provoke, and if it succeeds, instead of having the benefits of the CMB check made, the creature is unable to move for 1 round.`,
              initiationAction: `movement`,
              range: `threatened creature`,
              duration: `1 round`,
              target: `1 creature`,
              utility: true,
              },
              {
              school: 'eternalGuardian',
              level: 1,
              name: "Prison of the Damned",
              type: "Boost",
              longDesc: `For 1 round, enemies treat your threatened area as difficult terrain. If a square was already difficult terrain, enemies in those squares suffer a -4 penalty to AC against attacks of opportunity.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'eternalGuardian',
              level: 3,
              name: "Arm of the Law",
              type: "Boost",
              longDesc: `Your reach increases by 5 feet for 1 round, and you gain a +2 bonus to attack and damage when making attacks of opportunity. You also gain a single extra attack of opportunity. Every 8 levels, you gain another attack of opportunity and the bonus to damage on attacks of opportunity increase by +1. If you use another eternal guardian maneuver that increases or sets your reach to a certain amount, this stacks with it.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'eternalGuardian',
              level: 2,
              name: "Forbidding Edict",
              type: "Boost",
              longDesc: `Move up to 1/4 of your movement speed, then make a CMB check against a creature as if making a bull rush, reposition, or drag (your choice, you can make this check with your weapon). This doesn't provoke, and if it succeeds, instead of having the benefits of the CMB check made, the creature is unable to make attacks of opportunity for 1 round.`,
              initiationAction: `movement`,
              range: `threatened creature`,
              duration: `1 round`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'eternalGuardian',
              level: 5,
              name: "Path of Justice",
              type: "Boost",
              longDesc: `Move up to your movement speed. As you do, choose initiation modifier squares that you have moved through (minimum 1). Those squares also count as squares that you threaten for 1 round. You can take attacks of opportunity against creature's who provoke in them, teleporting if required to complete them.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'eternalGuardian',
              level: 4,
              name: "Warden's Authority",
              type: "Boost",
              longDesc: `For 1 round, when an ally within your reach would be forcibly moved out of their square by a creature making a CMB check, you may make an opposing CMB check as an attack of opportunity. If you succeed, the forced movement is negated. You gain an additional attack of opportunity during the next round when you initiate this maneuver.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'eternalGuardian',
              level: 8,
              name: "Absolute Law",
              type: "Boost",
              longDesc: `Move up to 1/4 of your movement speed, then choose a threatened creature, for 1 round, as long as you continue to threaten them, they cannot make attacks of opportunity.`,
              initiationAction: `movement`,
              range: `threatened creature`,
              duration: `1 round`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'eternalGuardian',
              level: 6,
              name: "Absolute Jurisdiction",
              type: "Boost",
              longDesc: `Move up to 1/4 of your movement speed, then for 1 round, allies within your threatened area gain a +4 shield bonus to their armor class. You can expend an attack of opportunity to increase an ally within your threatened area's shield bonus to armor class by +2 vs a single attack. You must declare the use of this ability before the attack roll is made. You gain 2 additional attacks of opportunity during the round you initiate this maneuver. You cannot use these benefits for yourself.`,
              initiationAction: `movement`,
              range: `threatened area`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'eternalGuardian',
              level: 3,
              name: "Judge, Jury, and Executioner",
              type: "Boost",
              longDesc: `As long as you have this maneuver unexpended, you gain an additional attack of opportunity every round. Additionally, successful attacks of opportunity made that were provoked from moving through area you threaten (while this maneuver is readied and unexpended) cause the movement action to have its distance moved reduced by 5 feet. Every 9 their speed is reduced by a further 5 feet. 
              \nOnce initiated, you gain initiation modifier additional attacks of opportunity this round (minimum +2), and all attacks of opportunity gain a +2 bonus to attack, and deal additional damage equal to your highest mental modifier (minimum +4), and if successful, the struck creature is cursed for initiation modifier rounds. If they were already cursed, the damage bonus is doubled instead.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'goldenLion',
              level: 1,
              name: "Lead the Way",
              type: "Boost",
              longDesc: `You and another adjacent ally may both move up to your movement speed, unless yours is higher, in which case they can move yours (doesn't grant movement types you dont have). They can take this movement as a free action they can take even when not their turn, or immediate if using your movement speed. You must both end your movements adjacent to each other. For 1 round, as long as you and the ally are adjacent to each other, you both gain a +2 morale bonus to armor class. At level 9 and 18, you may bring an additional adjacent ally with you, and the morale bonus to armor class lasts an additional round (as long as you remain adjacent to one of the allies).`,
              initiationAction: `movement`,
              range: `adjacent ally`,
              duration: `instantaneous`,
              target: `1 ally`,
              utility: true,
              },
              {
              school: 'goldenLion',
              level: 3,
              name: "Pride's Resurgence",
              type: "Boost",
              longDesc: `You rush to the side of an ally, your presence encouraging them to continue the fight. Move up to your movement speed, ending your movement adjacent to an ally. At the end of it, you select a single adjacent ally, they gain a +2 morale bonus to armor class and saves for 1 round, and you make a diplomacy check, they gain temporary hit points equal to the result of that check for 1 round. Both you and the ally can expend a <heroic> combo point to increase the temporary hit points by 2x the expender's charisma modifier, and the temporary hit points duration by 1 round.`,
              initiationAction: `movement`,
              range: `adjacent ally`,
              duration: `1 round`,
              target: `1 ally`,
              utility: true,
              },
              {
              school: 'goldenLion',
              level: 2,
              name: "Glorious Advance",
              type: "Boost",
              longDesc: `You may move up to your movement speed. During this, you can use your diplomacy in place of your acrobatics to avoid attacks of opportunity and move through enemies. You can do so even when wearing heavy armor, and doing so does not reduce your movement speed. Gain temporary hit points equal to your diplomacy bonus for 1 round.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'goldenLion',
              level: 5,
              name: "Pack Formation",
              type: "Boost",
              longDesc: `All of your allies within your threatened area may immediate move up to half their movement speed as a free immediate action, as long as their movement ends within your threatened area. This movement threatens as normal. You cannot move with this. All allies who use this, gain a +2 bonus to attacks when flanking for 1 round.`,
              initiationAction: `movement`,
              range: `allies in reach`,
              duration: `instantaneous`,
              target: `allies`,
              utility: true,
              },
              {
              school: 'goldenLion',
              level: 3,
              name: "Perfect Instruction",
              type: "Boost",
              longDesc: `You give an instruction for the perfect attack against an enemy within 30 feet of you. All allies also within 30 feet of you gain bonus precision damage on their next attack within 1 round against the target equal to your ranks in diplomacy. This doesn't affect you.`,
              initiationAction: `movement`,
              range: `30 feet`,
              duration: `1 round`,
              target: `initiation modifier allies`,
              utility: true,
              },
              {
              school: 'heartOfTheMaelstrom',
              level: 5,
              name: "Stormdash",
              type: "Strike",
              longDesc: `Make an acrobatics check and then move in a straight line up to that distance any direction (even straight up). You can move directly through enemies with this maneuver, and doing so does not provoke attacks of opportunity. During this movement you are not affected by difficult terrain. Every creature you move directly through takes 1d6 electricity damage per 10 feet of your movement speed (not the distance moved by this maneuver), plus any additional electricity damage that a wielded weapon does (this only deals electricity damage if the weapon deals it for every attack in a round). Reflex halves this damage.`,
              initiationAction: `movement`,
              range: ``,
              duration: `instantaneous`,
              target: `enemies`,
              utility: true,
              },
              {
              school: 'heartOfTheMaelstrom',
              level: 2,
              name: "Lightning Dash",
              type: "Boost",
              longDesc: `Move up to your movement speed, plus additional distance equal to your enhancement bonus and stance bonus to movement speed.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'heartOfTheMaelstrom',
              level: 4,
              name: "Explosive Footwork",
              type: "Boost",
              longDesc: `Move exactly your movement speed, excluding any enhancement bonuses, or bonuses from your stance. During this movement, and then for 1 round, you gain a +1 dodge bonus to AC for every 15 feet of movement speed you have from enhancement bonuses or your stance. Every time an attack misses you, the dodge bonus is reduced by 1. If you lose any of these movement bonuses at any point during this maneuver's duration, the dodge bonus is also reduced.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'heartOfTheMaelstrom',
              level: 5,
              name: "Maximum Overdrive",
              type: "Boost",
              longDesc: `For 1 round, your armor classes are halved, however, you gain a percentage dodge chance equal to 2x your dodge bonus to armor class, plus the rest of your armor class. Your normal and touch armor class still only use the relavent bonuses to them to determine their dodge chance. If you are caught flat-footed by an attack, you use your normal flat-footed armor class -10. At the end of a creature's turn, if they attacked you, you can move 5 feet for every attack that missed you. This movement does not provoke.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              additionalInfoTags:["Dodge Percentage"]
              },
              {
              school: 'heartOfTheMaelstrom',
              level: 3,
              name: "Supersonic",
              type: "Boost",
              longDesc: `Move twice your movement speed in a straight line. This movement is so fast that creatures cannot react to the movement, meaning they cannot take prepared actions or attacks of opportunity, and you move so fast that you are unaffected by moving through treacherous areas, except those that would physically block your movement (such as a wall of spikes). After initiating this maneuver you suffer a -2 penalty to armor class for 1 round.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'heartOfTheMaelstrom',
              level: 4,
              name: "Surging Initiative",
              type: "Boost",
              longDesc: `You can initiate this maneuver as either a standard or movement action.
              \nStandard: Gain 2 movement actions or a movement and a swift action
              \nMovement: Gain a swift action.`,
              initiationAction: `standard or movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              },
              {
              school: 'heartOfTheMaelstrom',
              level: 2,
              name: "Ephemeral Storm",
              type: "Strike",
              longDesc: `Draw a melee weapon and make an attack with it at a -4 penalty, then sheathe the weapon again immediately (neither of these provoke). This attack deals an additional 2d6 electricity damage. After initiating this maneuver, you suffer a -4 penalty to armor class against all attacks, except from the target of this maneuver if your attack was successful, for who you instead gain a +2 dodge bonus against.`,
              gameDesc: `Draw a melee weapon and make an attack with it at a -8 penalty, then sheathe the weapon again immediately (neither of these provoke). This attack deals an additional 2d6 electricity damage. After initiating this maneuver, you suffer a -4 penalty to armor class against all attacks, except from the target of this maneuver if your attack was successful, for who you instead gain a +2 dodge bonus against.`,
              initiationAction: `movement`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'heartOfTheMaelstrom',
              level: 4,
              name: "Rekkairan",
              type: "Strike",
              longDesc: `Make a melee attack against an enemy with a -8 penalty, it deals an additional 2d6 electricity damage. You can initiate this maneuver as a free action the round you recover it, and can initiate even if the recovery method used does not normally allow you to initiate maneuvers the round you recover them. You cannot initiate this maneuver multiple times per round. When you initiate it at as a free action, you suffer a -2 penalty to armor class for 1 round. If you recover this maneuver randomly and initiate it on the same round, then the attack penalty is reduced to -6 and instead deals an additional 4d6 electricity damage. If you recover it randomly and initiate it immediately (no actions between), the attack penalty becomes -4 and it deals an additional 6d6 electricity damage.`,
              initiationAction: `movement`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              },
              {
                school: 'heartOfTheMaelstrom',
                level: 3,
                name: "Shippū Jinrai",
                type: "Strike",
                longDesc: `Recover a random maneuver and make an attack at a -10 penalty. If you expend this maneuver through an ability other than initiating it normally, you can make an immediate melee attack at a -8 penalty that deals an additional 2d6 electricity damage. If you randomly expend this maneuver you can instead make an immediate melee attack with a -4 penalty that deals an additional 4d6 electricity damage.`,
                initiationAction: `movement`,
                range: `melee`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
              school: 'heartOfTheMaelstrom',
              level: 6,
              name: "Zetsuran",
              type: "Boost",
              longDesc: `For 1 round, whenever you score a critical hit, you can recover a single maneuver. This maneuver must be of a level equal to or lower than half your highest level of <sakura> maneuver known (rounded down). The maneuver recovered cannot be used this round, nor can it be a maneuver you are currently initiating. Additionally, this boost gains 1 extra effect of your choice when initiated:
              \n1: You gain a flat +1 to critical threat range for 1 round, but a -5 to confirm critical hits threatened by rolling within the additional threat range gained by this maneuver.
              \n2: Treat fortification as being 33% lower, or critical immunity as only being 80% fortification. This only applies to critical damage, use the normal fortification to determine if the attack deals sneak attack or other precision damage).
              \n3: Your critical hits deal an additional 4d6 electricity damage.`,
              initiationAction: `swift`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              },
              {
              school: 'heartOfTheMaelstrom',
              level: 4,
              name: "Muranretsu",
              type: "Boost",
              longDesc: `Your next weapon attack this turn ignores fortification and critical immunity, and all physical damage of the attack is converted to electricity damage. If you successfully score a critical hit with the attack, the creature has its fortification or critical immunity reduced by 10% * your critical multiplier until the end of your next turn.`,
              initiationAction: `swift`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              },
              {
              school: 'heartOfTheMaelstrom',
              level: 5,
              name: "Sealed Blade, Shūsen",
              type: "Strike",
              longDesc: `As long as you have this maneuver readied and unexpended, every time you draw your weapon as a part of an attack made during initiating a maneuver (max twice per maneuver), this gains 1 storm charge (max initiation modifier). When you initiate this maneuver, you sheathe your sword and your turn ends immediately, but you gain a deflection bonus to your armor class equal to your storm charges. Until the start of your next turn, you cannot attack, take your hand off the hilt of your weapon, or willingly move, or you lose all storm charges and this maneuver is expended with no further effects. 
              \nAt the start of your next turn, as a free action you must make before any other action, you expend all storm charges, immediately moving 5 feet, +5 ft. per 2 storm stacks (doesn't provoke, and this movement doesn't stop you from taking 5-foot steps), and then draw the sheathed weapon and make a melee attack with a -5 penalty. Per charge expended, the attack has its critical threat range increased by a flat +1 and deals an additional 1d6 points of electricity damage.
              \nStorm charges can only be accumulated during combat, and are lost when combat ends.`,
              initiationAction: `movement`,
              range: `melee attack`,
              duration: `1 round`,
              target: `1 enemy`,
              utility: true,
              stacksOne: 0,
              stacksOneName: "Storm Charges",
              },
              {
              school: 'heartOfTheMaelstrom',
              level: 8,
              name: "Raikazai",
              type: "Strike",
              longDesc: `When you initiate this maneuver, you sheathe your sword, and your turn ends immediately. Until the start of your next turn, you cannot attack, remove your hand from the hilt of your weapon, or willingly move; doing so expends this maneuver with no further effects.
              \nAt the start of your next turn, as a free action that must be taken before making a standard or movement action, you move a distance equal to twice the bonus movement provided by your stance. Then, you draw the sheathed weapon (neither the movement nor the drawing provokes attacks of opportunity) and make a single melee attack with it.
              \nThis attack deals an additional 5d6 electricity damage, has a flat +4 bonus to its critical threat range, and a +1 bonus to its critical damage multiplier. Electricity damage dealt with this attack is multiplied on critical hits (including electricity damage not originating from this maneuver).
              \nAfter this attack, you take a -5 penalty to attack rolls and AC until the start of your next turn. If the attack successfully deals electricity damage, the target must make a Will save or become vulnerable to electricity for 3 rounds. The save DC is increased by twice the critical damage multiplier of the attack.`,
              initiationAction: `standard`,
              range: `melee attack`,
              duration: `1 round`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'heartOfTheMaelstrom',
              level: 4,
              name: "Shin Kairan",
              type: "Boost",
              longDesc: `Move your stance bonus movement speed and sheathe your weapon and end your turn immediately. Immediately recover 2 random maneuvers. For each Heart of the Maelstrom Strike recovered, your first attack before the end of your next turn gains 1d4 electricity damage per level of recovered strike. For each Heart of the Maelstrom Boost recovered, gain a dodge bonus to armor class equal to half its level for 1 round.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'indomitableWill',
              level: 3,
              name: "Eminence",
              type: "Boost",
              longDesc: `Can be initiated as a movement, standard, or full-round action.
              \nMovement: Reduce the damage you take from all attacks by 1/4 your base will save, or your base will save the next time you take damage within 1 round.
              \nStandard: Reduce all damage you take by your full will save for 1 round.
              \nFRA: Reduce all damage you take by your full will save, plus 1/4 of your base will save.
              \n\nThis damage reducing lasts 1 round, applies only once per attack, and stacks with other abilities that reduce damage`,
              initiationAction: `see text;`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'indomitableWill',
              level: 2,
              name: "Assert Dominance",
              type: "Boost",
              longDesc: `Move in a straight line up to half your movement speed towards an enemy. You cannot use acrobatics to avoid attacks of opportunity during this movement. As long as you take less damage than your wisdom score during this movement (damage to temporary hit points do not count as taking damage for this effect), after the movement the creature you moved towards must win an opposing will save against you or become shaken for 1d4+1 rounds, and take an additional -2 penalty on all attacks against you, and you gain a +2 bonus on saves against their abilities for 1 round. `,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'indomitableWill',
              level: 5,
              name: "Looming Presence",
              type: "Boost",
              longDesc: `You give an imposing look at all enemies around you. You make an opposing will save against all enemies within 50 feet, the losers are shaken for 1d4 rounds, +1 round for every 4 they lost by. If they were already shaken, the penalty for being shaken increases by -1 for the duration instead. For every creature shaken this way, you gain a +1 morale bonus to damage until the end of your next turn. For every enemy who wins on this opposing save, you suffer a stacking -1 penalty to attacks and saves for 1d2 rounds per enemy who succeeded. [fear][mind-affecting]`,
              initiationAction: `movement`,
              range: `50 feet`,
              duration: `see text;`,
              target: `enemies`,
              utility: true,
              },
              {
              school: 'indomitableWill',
              level: 8,
              name: "Absolute Judgement",
              type: "Boost",
              longDesc: `Move half your movement speed in a straight line towards a creature, giving them a stare that completely demolishes their fighting spirit. Make an opposing will save, the loser is panicked for 1 round and suffers a -4 penalty on further saving throws for 1d4 rounds, +1 round per 4 they lost by [fear][mind-affecting]. If you lose, this bypasses any immunity to [fear] or [mind-affecting] effects you may have.`,
              initiationAction: `movement`,
              range: `60 feet`,
              duration: `1 and 1d4 rounds`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'indomitableWill',
              level: 1,
              name: "Endure",
              type: "Boost",
              longDesc: `You prepare yourself for the oncoming onslaught, if within the next 1 round you either suffer damage or must make a save, you gain a bonus. The bonus only applies to the next instance of either of these conditions. The conditions are:
              \nDamage: You reduce the damage by your base will save bonus. Increase the reduction by half your base will save every 9 levels.
              \nSaving Throw: You gain a +2 bonus on the saving throw. +1 every 9 levels.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'indomitableWill',
              level: 3,
              name: "Overcome Crisis",
              type: "Boost",
              longDesc: `You can ignore any condition that is limiting your movement speed or ability to take actions, and then immediately move your movement speed (except death or being unconcious). The condition returns after the movement, and you cannot take any other actions during this movement.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
                school: 'indomitableWill',
                level: 3,
                name: "Glory Unbound",
                type: "Boost",
                longDesc: `Move squares equal to your wisdom modifier. This movement does not provoke. You can move through the space of enemies with a lower wisdom score than you during this without provoking. For every enemy's space you move through during this, you gain a +1 morale bonus to your AC and CMB for 1 round. If you attempt to move through a creature's square and they have a higher wisdom score than you, your movement stops and this maneuver ends with no additional benefits and you suffer a -2 penalty to attack and AC for 1 round.`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
                utility: true,
              },
              {
                school: 'indomitableWill',
                level: 3,
                name: "Scatter the Meek",
                type: "Strike",
                longDesc: `You grab a creature and hurl them into another enemy, damaging them both. Make a CMB check to grapple a creature without provoking, if you succeed, you can make a CMB check against another enemy within 30 feet of you. If that succeeds, you throw the creature at the target and they both take damage as if struck by an unarmed attack. They must both then make reflex saves or fall prone. If you succeed the grapple but fail the second CMB check, the creature is still thrown, landing in the closest adjacent square to the target, but neither take damage or fall prone. The damage increases by 25% for every size category larger the thrown creature is than the struck creature. Alternatively, you can also throw the creature into a wall or the ground, causing them to instead roll an acrobatics check against the normal DC to halve the damage and a reflex save to negate the prone.`,
                initiationAction: `standard`,
                range: `melee`,
                duration: `instantaneous`,
                target: `2 enemies`,
              },
              {
                school: 'indomitableWill',
                level: 3,
                name: "Unslain Pride",
                type: "Strike",
                longDesc: `Make an attack, if it hits it deals additional damage equal to half the damage the creature dealt to you on the most recent time within 1 round that they damaged you.`,
                initiationAction: `standard`,
                range: `melee or ranged`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                school: 'indomitableWill',
                level: 3,
                name: "Earned Arrogance",
                type: "Strike",
                longDesc: `Take any penalty to attack you choose (max initiation modifier), then make a melee attack against an enemy. If the attack hits, you gain 1d6 temporary hit points for every penalty to attack you took and deal an additional 2 points of damage. The temporary hit points last level/2 rounds. For every CR lower than your HD the creature is, the damage and temporary hit points are reduced by 1d6 and 2 respectively.`,
                initiationAction: `standard`,
                range: `melee`,
                duration: `level/2 rounds`,
                target: `1 enemy`,
              },
              {
                school: 'indomitableWill',
                level: 6,
                name: "Let Them Tremble",
                type: "Strike",
                longDesc: `[death] Make a melee attack, if it hits, it deals no damage, but the creature makes a fortitude and will save, if it fails one, it suffers 3x your unarmed damage, if it fails both, the creature is automatically reduced to -1 hit points and all enemies who see this must make a will save or be frightened for 1 round, on success they are shaken for 1 round. If it succeeds both, you provoke an attack of opportunity from the creature you attempted it on, and they gain a +4 bonus to the attack roll.`,
                initiationAction: `standard`,
                range: `melee`,
                duration: `instantanous`,
                target: `1 enemy`,
              },
              {
                school: 'indomitableWill',
                level: 5,
                name: "Domination",
                type: "Strike",
                longDesc: `You grab a creature and slam them into the ground or a wall within your reach. Make a CMB check to grapple them (doesn't provoke), if you succeed, you deal damage with an unarmed attack, they fall prone, and then they must make a fortitude save or be stunned for 1 round. You can keep grappling them, maintaining as normal, but with the option of a new grapple action to slam them again, this deals damage equal to an unarmed attack, and causes them to make another fortitude save or be stunned for 1 round again.`,
                initiationAction: `standard`,
                range: `melee`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
              school: 'indomitableWill',
              level: 2,
              name: "Prepared Mind",
              type: "Boost",
              longDesc: `Gain a +4 bonus on your next save within 1 round. If you succeed on the save, you gain temporary hit points equal to half the result of the save. These last 5 rounds. Every 8 initiator levels, this lasts an additional save and an additional round.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'indomitableWill',
              level: 6,
              name: "Manifest Destiny",
              type: "Boost",
              longDesc: `Move up to half your movement speed, as you do, roll a will save, gaining temporary hit points equal to the will save. These temporary hit points are always lost first, even before other temporary hit points. As long as these temporary hit points last, your armor class, touch armor class, and flat-footed armor class become equal to the result of this save.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              },
              {
              school: 'indomitableWill',
              level: 7,
              name: "Approach of the Titan",
              type: "Strike",
              longDesc: `Move up to twice your movement speed in a straight line. As you move, you can make overrun attempts against every creature you pass directly through as free actions with a +4 bonus. This provokes as normal, but any damage you take is reduced by half your will save bonus and you take no penalty to the overrun attempts due to damage. During this movement, you can also choose a single creature you would move directly through, but instead of overrunning them, you instead make a grapple attempt against them with a +4 bonus (doesn't provoke). If you succeed, they take damage as if you had struck them with an unarmed attack, but it deals damage as if it were a two-handed weapon, they must also make a will save or become paralyzed by fear for 1 round or until you release the grapple ([mind-affecting][fear]). Afterwards, if the grapple as successful, you continue your movement, moving them with you. You cannot release the grapple until the end of your movement. If your movement ends directly into a wall, you can slam them into the wall, causing them and the wall to take 1d6 damage per 5 feet of movement left. As long as you maintain control of the grapple over the creature, any damage they do to you with attacks is reduced by half of your base will save. If the creature is a size too large for you to normally grapple, you can make an opposed will save against them, though you take a -2 penalty for every size larger than you that they are, if you win, you can grapple and move them regardless of size.`,
              initiationAction: `standard`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              },
              {
              school: 'indomitableWill',
              level: 5,
              name: "My Answer",
              type: "Strike",
              longDesc: `Make an unarmed attack foot attack with a -5 penalty, but dealing damage as if it were a two-handed attack. If it hits, you also make a free bull rush attempt against the creature (doesn't provoke), gaining a bonus on the attempt equal to half of the damage dealt. You can bullrush creatures directly upwards or downwards with this, even if you are not above or below them.
              \nAfter initiating this maneuver, you suffer a -2 penalty to armor class for 1 round, and you cannot move for the rest of the round after initiating it.`,
              initiationAction: `movement`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'ironTortoise',
              level: 3,
              name: "Shield Feint",
              type: "Boost",
              longDesc: `Pick a creature, you lose your shield's bonus to your armor class for 1 round, but the creature has its armor class reduced by the same amount against the next attack against it. You can make a normal feint during this action as well.`,
              initiationAction: `movement`,
              range: `melee attack`,
              duration: `1 round`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'ironTortoise',
              level: 2,
              name: "Shared Shell",
              type: "Boost",
              longDesc: `Pick an ally, you lose your shield's shield bonus to your armor class, but the ally gains the shield bonus as long as it remains within your reach, and you can use personal counters to negate attacks against them. All of these bonuses only last 1 round, and you cannot initiate any personal counters for them that allow them to move from their square.`,
              initiationAction: `movement`,
              range: `reach`,
              duration: `1 round`,
              target: `1 ally`,
              utility: true,
              },
              {
              school: 'ironTortoise',
              level: 6,
              name: "Turtle Sanctuary",
              type: "Boost",
              longDesc: `You lose your shield's shield bonus to your armor class, but all allies gain the shield bonus as long as they remain within your reach, and you can use personal counters to negate attacks against them. All of these bonuses only last 1 round, and you cannot initiate any personal counters for them that allow them to move from their square. You gain an additional immediate action in the next turn to make a martial counter for an ally.`,
              initiationAction: `movement`,
              range: `reach`,
              duration: `1 round`,
              target: `allies`,
              utility: true,
              },
              {
              school: 'ironTortoise',
              level: 4,
              name: "Shield Rush",
              type: "Boost",
              longDesc: `Move up to your movement speed. Your shield's base shield bonus to armor class is doubled during this movement and for the next attack against you after the movement. The next shield slam attack you make within 1 round has its damage increased by 2 dice steps.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'ironTortoise',
              level: 2,
              name: "Pushing Slam",
              type: "Boost",
              longDesc: `If Movement: Make a shield slam attack, if it hits, it deals damage as normal, plus if the attack roll is higher than their CMD, and they are a valid size to be bull rushed, they are also pushed durectly away from you 10 feet. You gain any bonuses to the attack roll that you gain to bull rush attempts. You do not lose your shield's bonus to armor class against the target of this attack after using this maneuver. If you already didn't, your shield bonus against them increases by +2 for 1 round.
              \nIf Swift: You do not gain the shield slam as a part of initiating this maneuver, instead you initiate it when making shield slam, and gain the bonuses specified from the movement action initiation.`,
              initiationAction: `swift or movement`,
              range: `melee attack`,
              duration: `instantaneous `,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'ironTortoise',
              level: 3,
              name: "Dissorientating Slam",
              type: "Boost",
              longDesc: `If Movement: Make a shield slam attack, if it hits, it deals damage as normal, plus if the attack roll is higher than their CMD, they are disorientated for 1 round, suffering a -2 penalty on all attacks and a -4 penalty on concentration checks. You do not lose your shield's bonus to armor class against the target of this attack for using this maneuver. If you already didn't, your shield bonus against them increases by +2 for 1 round.
              \nIf Swift: You do not gain the shield slam as a part of initiating this maneuver, instead you initiate it when making shield slam, and gain the bonuses specified from the movement action initiation.
              \nCreatures without heads are or are immune to being stunned are immune to the disorientation`,
              initiationAction: `swift or movement`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'ironTortoise',
              level: 1,
              name: "Iron Defense",
              type: "Boost",
              longDesc: `You lose your shield's shield bonus to AC, but gain the lost amount as DR /-. This DR stacks with other DR, but is reduced by half. This lasts 1 round, and during this, you cannot make shield bash attempts.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'sterlingSovereignty',
              level: 5,
              name: "Martial Superiority",
              type: "Boost",
              longDesc: `Your next melee attack this round has its physical damage dealt increased by 15%. If the attack misses, instead it deals 25% of the physical damage it would have dealt (without 15% increase) to the target, no additional effects of the attack occur, it only deals the instantaneous physical damage. This damage bypasses no types of DR.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'sterlingSovereignty',
              level: 4,
              name: "Noble Crest",
              type: "Boost",
              longDesc: `The next counter you initiate within one round using counterpoints costs half the required counterpoints. After initiating the counter, you gain a dodge bonus to your armor class equal to the level of the counter against the next attack made against you after initiating the counter. You take 2 desperation after initiating the counter.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'sterlingSovereignty',
              level: 3,
              name: "Commandeering",
              type: "Boost",
              longDesc: `The next time within 1 round that a creature you threaten misses an attack against you, it provokes an attack of opportunity from you, this stacks with any other attack of opportunity you would gain from a sterling sovereignty maneuver. If your attack of opportunity hits, they suffer a -2 penalty on all further attacks against you until the end of your next turn. If the attack missed because of a counter, you gain 2 additional attacks of opportunity this round.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'sterlingSovereignty',
              level: 4,
              name: "Into the Fray",
              type: "Boost",
              longDesc: `Move up to your movement speed, as you do, make an attack roll with a melee weapon at your highest bonus (with no target). Your armor class against attacks during this movement, as well as the for 1 round after you complete the movement, your armor class becomes the attack roll. This applies only to attacks that are not magical touch attacks, and you must be aware of and see the attack. You must also always be wielding the weapon used to make the attack roll to gain this bonus. When a creature misses you with a melee attack and you threaten them, they take damage equal to the base damage of your weapon (does not include enchantements or size increases)`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              },
              {
              school: 'sterlingSovereignty',
              level: 1,
              name: "Superior Defense",
              type: "Boost",
              longDesc: `Move up to your movement speed, as you do, make an attack roll with a melee weapon (with no target). Your AC during this movement, as well as the first attack within the next round after, becomes the result of the attack roll. This applies only to attacks that are not magical touch attacks, and you must be aware of and see the attack. You must also always be wielding the weapon used to make the attack roll. If the attack misses, it counts as successfully countering the attack.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              },
              {
              school: 'sterlingSovereignty',
              level: 4,
              name: "Endless Battle",
              type: "Strike",
              longDesc: `You initiate this strike after making another strike. Make another attack at a -5 penalty against the same target of the original strike. If the target of the strike is no longer in range to make this attack, you can move up to your movement speed as long as you end your movement in a position where you can attack the creature again. If the original strike did bonus damage (only from the strike, no other modifiers or maneuvers), this attack also gains half of that bonus to damage as long as that damage was not variable (it gains no further effects from the strike).`,
              initiationAction: `movement`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'sterlingSovereignty',
              level: 2,
              name: "Battle Ardor",
              type: "Strike",
              longDesc: `Make an attack at a -5 penalty. If the attack is successful, it deals damage as normal and you remove 2 desperation, otherwise take 4.`,
              initiationAction: `movement`,
              range: `melee or ranged attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'sterlingSovereignty',
              level: 1,
              name: "Defensive Form I",
              type: "Boost",
              longDesc: `You prepare your weapon to defend against attacks from a certain direction. For 1 round, when a weapon attack is made against you, you roll a 1d2. On a 1, if it is the first attack against you since initiating this maneuver, you choose to either gain a +6 shield bonus to armor class, or make to make an opposing attack roll against their attack roll with a +2 bonus, negating their attack on success. If it isn't the first attack agaisnt you since initiating this maneuver and it is a 1, you gain a +4 bonus to your armor class against the attack and this maneuver ends. On a 2, your armor class is reduced by -2 against the attack. Every 6 BAB the shield bonus to AC increases by +1.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'sterlingSovereignty',
              level: 2,
              name: "Defensive Form II",
              type: "Boost",
              longDesc: `You prepare your weapon to defend against attacks from a certain direction. For 1 round, when a weapon attack is made against you, you roll a 1d3, on 1, you gain a +3 bonus to your armor class against the attack, and if it misses, you may end this maneuver to allow you to make an attack of opportunity against the creature. At bab 6, plus every 5 BAB thereafter, the bonus to armor class increases by +1.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'sterlingSovereignty',
              level: 5,
              name: "Defensive Form III",
              type: "Boost",
              longDesc: `You prepare your weapon to defend against attacks from a certain direction. For 1 round, when a weapon attack is made against you, you roll a 1d4, on 1, if it is the first attack against you since initiating this maneuver, the attack misses, otherwise, you make an opposing attack roll (taking -2 for ever size larger), negating the attack on success, then, this maneuver ends.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'mithralCurrent',
              level: 2,
              name: "Piercing Rain Dance",
              type: "Boost",
              longDesc: `You feint all adjacent enemies using your perform (dance) in place of your bluff, and then immediately sheathe your weapon and move 10 feet. The sheathing doesn't provoke, and the movement doesn't provoke against any of the creatures you successfully feinted. Every creature successfully feinted also suffer a -2 penalty on their next attack against you, and your next melee attack against them deals an additional 2d6 damage (these both only apply to the next attack within 1 round).`,
              initiationAction: `movement`,
              range: `adjacent enemies`,
              duration: `instantaneous`,
              target: `enemies`,
              utility: true,
              },
              {
              school: 'mithralCurrent',
              level: 6,
              name: "The Strid",
              type: "Boost",
              longDesc: `Move up to your movement speed, gaining a +4 dodge bonus to your armor class as you do. If a creature makes an attack against you during this movement, it provokes an attack of opportunity from you, it suffers a -4 penalty but you can take your attack before they take theirs. If you drew your weapon as a part of this attack, the creature is flat-footed for the attack, and if it hits they suffer a -2 penalty on all attacks against you and they must make a will save or become vulnerable to silver (both effects last 1 round). You can draw a weapon as a part of making an attack with this boost as if it were a strike.`,
              gameDesc: `Move up to your movement speed, gaining a +4 dodge bonus to your armor class as you do. If a creature makes an attack against you during this movement, it provokes an attack of opportunity from you, it suffers a -4 penalty but you can take your attack before they take theirs. If you drew your weapon as a part of this attack, you may make a bluff attempt against the creature as a free action (and you may use your perform(dance) in place of bluff. This bluff has no additional effects from bluffing the creature) to cause the attack to be made against the creature flat-footed armor class. If your bluff attempt fails, your attack suffers a further -4 penalty to hit. If your attack of opportunity hits, they suffer a -2 penalty on all attacks against you and they must make a will save or become vulnerable to silver (both effects last 1 round). You can draw a weapon as a part of making an attack with this boost as if it were a strike.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'mithralCurrent',
              level: 2,
              name: "Flowing Stride",
              type: "Boost",
              longDesc: `Move up to your movement speed. You can use perform (dance) in place of acrobatics for moving through threatened area or through creature's squares without provoking, and if you do use perform, doing so does not reduce your movement speed. You also gain a bonus on the roll equal to your dexterity modifier (or initiation modifier if your dexterity modifier is higher). If you move through a creature's space with this, they suffer a -2 penalty to armor class against the next attack against them within 1 round.`,
              gameDesc: `Move up to your movement speed. You can use perform (dance) in place of acrobatics for moving through threatened area or through creature's squares without provoking, and if you do use perform (dance), doing so does not reduce your movement speed. You also gain a bonus on the roll equal to your dexterity modifier (or initiation modifier if already using dexterity to determine perform (dance) bonus). If you move through a creature's space with this, they suffer a -2 penalty to armor class against the next attack against them within 1 round.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'mithralCurrent',
              level: 5,
              name: "Cross Wave",
              type: "Boost",
              longDesc: `Sheathe your weapon and end your turn immediately. The next creature that makes a melee attack against you that is within your threatened area (even with a sheathed weapon), you may immediately move to the exact opposite side of the creature, and then draw a melee weapon and make an attack against them with it. You can move directly through the creature with this, and moving doesn't provoke attacks of opportunity, but the distance you need to move to must be within your movement speed, otherwise this maneuver fails. If you are within the creature's space, you instead move to the space outside of their area that is nearest to the exact opposite side of them.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'mithralCurrent',
              level: 4,
              name: "Gentle Rainfall",
              type: "Boost",
              longDesc: `Move your movement speed, plus an additional 5 feet for every creature you threaten at the start of your movement. Choose a number of squares equal to the amount of bonus movement this granted, leaving those squares does not provoke attacks of opportunity during the movement. For every square selected this way that you move through, all enemies adjacent to that square suffer a -2 penalty to their next attack roll within 1 round. This stacks if you move through multiple squares adjacent to a creature, each time the total penalty increases by -1 and it lasts an additional attack and round, though the penalty reduces by -1 each time they attack. Moving through the same square multiple times does not count.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'piercingThunder',
              level: 2,
              name: "Lancer's Lunge",
              type: "Boost",
              longDesc: `Move up to half your movement speed and then increase your reach by 5 feet until the start of your next turn. For 1 round, melee discipline weapon attacks against targets at your maximum reach deal an additional 1d6 damage. At level 9 and 18 the additional damage increases by 1d6. At level 12 the reach increases by 5 feet.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'piercingThunder',
              level: 4,
              name: "Thunder Hunter",
              type: "Boost",
              longDesc: `Make an acrobatics check to jump with a +20 bonus (you're considered to have a running start). During this jump, the DC for high jumps is halved and your maximum jump distance is not limited by your movement speed. During this movement, you can make attacks and strikes while in the air without any penalties. You can make only a single attack per creature you move over during this, but the bonus from attacking from high ground is increased to +4 and the attack deals an additional 3d6 damage. For every enemy you successfully hit during this, attacks against following enemies deal an additional 1d6 damage.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'piercingThunder',
              level: 4,
              name: "Sudden Pierce",
              type: "Boost",
              longDesc: `Make a melee attack with a discipline weapon against a creature exactly 5 feet out of your reach with a -5 penalty. The attack is against their flat-footed armor class and deals an additional 2d6 damage. You suffer a -4 penalty to your armor class for 1 round after initiating this maneuver. Once you've used this maneuver on a specific creature, it no longer hits their flat-footed armor class if used against them again.`,
              initiationAction: `movement`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'piercingThunder',
              level: 1,
              name: "Lancer's Footwork",
              type: "Boost",
              longDesc: `To use this maneuver the target enemy must be adjacent to you. Move 5 feet directly away from them without provoking attacks of opportunity. If the target moves adjacent to you within 1 round, you may take a 5-foot step immediately (this 5-foot step is not restricted by other movement you've taken, nor does it stop you from moving more).`,
              initiationAction: `movement`,
              range: `adjacent enemy`,
              duration: `1 round`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'piercingThunder',
              level: 3,
              name: "Charge Breaker",
              type: "Boost",
              longDesc: `For 1 round, if a creature charges you, it provokes attacks of opportunity from you, even if it normally wouldn't (such as through the use of maneuvers). You gain initiation modifier additional attacks of opportunity during the round, but they can only be used for the effects of this maneuver, and when you do use them, they deal an additional 2d6 damage.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'primalFury',
              level: 1,
              name: "Ruinous Leap",
              type: "Boost",
              longDesc: `Make an acrobatics check to make a jump, using a survival check in place of an acrobatics check (you count as having a running start). The square you land in, as well as all adjacent squares, becomes difficult terrain for initiation modifier rounds (minimum 1). This difficult terrain is caused by tearing the earth up, and places with exceptionally durable ground may be immune to this.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `initiation modifier rounds`,
              target: `you`,
              utility: true,
              },
              {
              school: 'primalFury',
              level: 3,
              name: "Roll to Survive",
              type: "Boost",
              longDesc: `Make a survival check, gain temporary hit points equal to the result of the check for 1 round. Every 9 levels the duration increases 1 round. If your roll is a natural 20, you cant die for 1 round (but your hit points can still be reduced, and you may die after). If you roll a natural 1, the next attack against you made by an enemy automatically hits, and if it would have hit anyway, it deals double damage.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `initiation modifier rounds`,
              target: `you`,
              utility: true,
              },
              {
              school: 'primalFury',
              level: 3,
              name: "Path of Ruin",
              type: "Boost",
              longDesc: `Move up to your movement speed, as you do you ignore difficult terrain, and every square you pass through, you can choose to become difficult terrain for 1 round. This difficult terrain is caused by tearing the earth up, and places with exceptionally durable ground may be immune to this.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'primalFury',
              level: 4,
              name: "Concussive Slam",
              type: "Boost",
              longDesc: `Make an acrobatics check to jump, using a survival check in place of acrobatics (as if you had a running start). All creatures adjacent to where you land must make a reflex save or fall prone. You must land on solid ground to knock creatures prone. Alternatively, you can try to land on a creature that is flying, causing it to instead need to make a reflex save or suffer a -4 penalty to AC and attacks for 1 round. This all provokes as normal, and landing on a creature ends your movement in the last valid square in your movement. When landing on a creature, for every 10 feet of movement left during the movement, the DC increases by +1.`,
              initiationAction: `movement`,
              range: `adjacent creatures`,
              duration: `instantaneous`,
              target: `creatures`,
              utility: true,
              },
              {
              school: 'primalFury',
              level: 6,
              name: "Primal Impact",
              type: "Boost",
              longDesc: `Make an acrobatics check to jump (counts as having a running start), except using a survival check in place of acrobatics. All creatures adjacent to where you land must make a fortitude save or become stunned for the rest of your turn. You must land on solid ground to stun creatures. Alternatively, you can try to instead land on a creature that is flying, causing only it to make the fortitude save or be stunned. This all provokes as normal, and landing on a creature ends your movement in the last valid square in your movement. When landing on a creature, for every 10 feet of movement left during the movement, the DC increases by +1.`,
              initiationAction: `movement`,
              range: `adjacent creatures`,
              duration: `1 turn`,
              target: `creatures`,
              utility: true,
              },
              {
              school: 'primalFury',
              level: 5,
              name: "Storm Through",
              type: "Boost",
              longDesc: `Move up to your movement speed, as you do, every time you leave a square with difficult terrain caused by natural impedements, you can destroy it. During this movement, you are not slowed by difficult terrain. For every square of difficult terrain you clear, you gain a +2 morale bonus to damage for 1 round (stacks).`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
                school: 'eternalGuardian',
                level: 5,
                name: "Sacred Path",
                type: "Boost",
                longDesc: `Move up to your movement speed, as you do, every time you leave a square with difficult terrain caused by natural impedements, you can destroy it. During this movement, you are not slowed by difficult terrain. For 1 round, allies gain a +2 sacred bonus to armor class while in squares you cleared difficult terrain from.`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
                utility: true,
              },
              {
              school: 'primalFury',
              level: 1,
              name: "Ferocious Swing",
              type: "Boost",
              longDesc: `The next melee melee attack you make this round deals additional damage equal to your strength modifier, and gains a +2 to attack. At level 9 and 18 the attack bonus increases by +1 and the damage bonus increases by 1/2 strength modifier. Once you initiate this maneuver, you suffer a -2 penalty to AC for 1 round.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'primalFury',
              level: 5,
              name: "Thick of the Fight",
              type: "Boost",
              longDesc: `For every creature (friend or foe) that you currently threaten, you gain a +1 bonus on your melee damage rolls and a +1 morale bonus to your melee damage rolls for 2 rounds (the damage bonus is determined when initiated, even if the amount of creatures around you changes). Summoned creatures only count if summoned by enemies.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `2 rounds`,
              target: `you`,
              utility: true,
              },
              {
              school: 'primalFury',
              level: 2,
              name: "Accelerated Carnage",
              type: "Boost",
              longDesc: `You initiate this maneuver after successfully defeating an opponent with a melee attack. Gain temporary hit points equal to your HD, move up to your movement speed without provoking attacks of opportunity, then make a melee attack against another creature. If the attack hits, you gain a +2 morale bonus on attacks for 2 rounds and temporary hit points equal to your HD. These temporary hit points stack with each other and last until combat ends. `,
              initiationAction: `movement`,
              range: `personal`,
              duration: `2 rounds`,
              target: `you`,
              utility: true,
              },
              {
              school: 'primalFury',
              level: 2,
              name: "Crushing Advance",
              type: "Boost",
              longDesc: `Move squares equal to your strength modifier. This movement does not provoke. You can move through enemies with a lower strength score than you during this without provoking, if you do, they suffer a -2 penalty to attack and AC for 1 round. If you attempt to move through a creature's square and they have a higher strength score than you, the movement to enter their square is wasted and instead you suffer a -2 penalty to attack and AC for 1 round.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'primalFury',
              level: 4,
              name: "Lion's Den",
              type: "Boost",
              longDesc: `All enemies you threaten take damage equal to your strength modifier. Until the start of your next turn, any enemy that moves into a square that you threaten takes damage equal to your strength modifier. This can activate multiple times if they move through multiple squares.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'primalFury',
              level: 3,
              name: "Battering Shove",
              type: "Boost",
              longDesc: `Make a melee touch attack against an enemy. If successful, make an opposing strength roll against the creature, if successful, they suffer a penalty to their armor class equal to your strength modifier against the next attack against them within 1 round, and suffer damage equal to 2x your strength modifier.`,
              initiationAction: `movement`,
              range: `melee touch`,
              duration: `1 round`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'radiantDawn',
              level: 1,
              name: "Breathe the Sun",
              type: "Boost",
              longDesc: `Heal hit points equal to your initiation modifier. If you are between 10-50% hit points, the healing is doubled. If you are 10% hit points or lower, the healing is instead tripled. Every 6 levels the healing increases by your initiation modifier.
              \nFor every essence invested, the healing increases by +2.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
                school: 'radiantDawn',
                level: 2,
                name: "Astral Seal",
                type: "Boost",
                longDesc: `Make a melee touch attach, if it hits, it deals no damage, but the creature's armor class is reduced by 2, and the next creature other than you that hits them with an attack heals 2d6 + initiation modifier damage. Once they are hit, the armor class penalty ends.
                \nFor every essence invested, the armor class reduction and healing on hit lasts an additional attack, though it must be from a new creature (the AC penalty ends in respect to a creature who has already benefited from it).`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
                utility: true,
              },
              {
              school: 'radiantDawn',
              level: 4,
              name: "Divine Ward",
              type: "Boost",
              longDesc: `Move up to half your movement speed and touch an ally. If you do not move, this still provokes as if you had. The ally gains a divine ward for 1 round, causing the next damage they take within 1 round to reduced by 50%. You cannot use this on yourself. The percentage damage reduction is applied after all other resistances.`,
              initiationAction: `movement`,
              range: `melee touch`,
              duration: `1 round`,
              target: `1 ally`,
              utility: true,
              },
              {
              school: 'radiantDawn',
              level: 7,
              name: "Divine Shield",
              type: "Boost",
              longDesc: `Move up to half your movement speed and touch an ally. If you do not move, this still provokes as if you had. The ally gains a divine shield for 1 round, causing the next damage they take within 1 round to reduced to 0. You cannot use this on yourself.`,
              initiationAction: `movement`,
              range: `melee touch`,
              duration: `1 round`,
              target: `1 ally`,
              utility: true,
              },
              {
              school: 'radiantDawn',
              level: 3,
              name: "Castigate",
              type: "Boost",
              longDesc: `Move up to your movement speed and make a melee touch attack against an enemy. If successful, the next time within 1 round that they deal damage to you, the damage you take is reduced by 50%. If you do not move, this still provokes as if you had. The percentage damage reduction is applied after all other resistances.
              \nFor every essence invested, this lasts an additional round, and additional damage instance. `,
              initiationAction: `movement`,
              range: `melee touch`,
              duration: `1 round`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'radiantDawn',
              level: 4,
              name: "Radiant Blade",
              type: "Boost",
              longDesc: `Choose a wielded weapon, the next time within 1 round you make an attack with it, it gains the benefits of the brilliant energy enchantment, except that it still deals damage to undead.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
                school: 'radiantDawn',
                level: 5,
                name: "Winged Cavalry",
                type: "Boost",
                longDesc: `Move up to twice your movement speed towards an enemy. Your movement must end threatening an enemy that also threatens another ally that is below 33% hit points. When you arrive, make a melee attack against the enemy, it deals an additional 6d6 damage, and the threatened ally heals 50% of the damage dealt. If the movement meets the requirements, this can count as a charge. Additionally, if the attack hits, the enemy also suffers -4 to all attacks against the ally for 1 round. You cannot initiate this maneuver against an enemy you are already threatening.
                \nFor every essence invested, the damage and healing increases by 2d6, and the attack penalty increases by 1.`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
                utility: true,
              },
              {
                school: 'radiantDawn',
                level: 7,
                name: "Army on Wings",
                type: "Boost",
                longDesc: `Move up to your movement speed towards an enemy. Your movement must end threatening an enemy that also threatens an ally that is below 33% hit points. When you arrive, make a melee attack against the enemy, it deals an additional 6d6 damage, and the threatened ally heals 6d6 hit points. You cannot initiate this maneuver against an enemy you are already threatening. When you first initiate this maneuver, any ally within 20 feet of you can use an immediate action to also move, their movement has the same restrictions as yours (and cannot be against a creature they already threaten). If they do, the next attack they make gains the benefits of this maneuver's attack.
                \nFor every essence invested, the damage and healing increases by 2d6, and the range allies for allies to move with you increases by 5 feet.`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
              },
              {
              school: 'radiantDawn',
              level: 5,
              name: "Divine Sanction",
              type: "Boost",
              longDesc: `Make a touch attack against an enemy. If it hits, they suffer a penalty on all damage rolls equal to your initiation modifier for 1 round.
              \nFor every essence invested the penalty to damage increases by 2, and they suffer a -1 to the DC of all of their abilities and spells.`,
              initiationAction: `movement`,
              range: `melee touch`,
              duration: `1 round`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'rivenHourglass',
              level: 1,
              name: "Movement in a Bottle",
              type: "Boost",
              longDesc: `Move up to your movement speed. Any movement remaining, you store in a bottle that you can use as a free action when taking a movement action to move. When you do, you increase your movement during that action an amount equal to the movement speed stored. You can only have a single bottle of movement at a time, and bottles of movement can only be made during combat. You can give a bottle to an ally by handing it to them.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 minute`,
              target: `you`,
              utility: true,
              },
              {
              school: 'scarletThrone',
              level: 1,
              name: "Royal Posture",
              type: "Boost",
              longDesc: `The next counter you initiate within 3 rounds gains a +4 bonus on any d20 roll made during it.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              utility: true,
              },
              {
              school: 'scarletThrone',
              level: 4,
              name: "Unbroken Crown",
              type: "Boost",
              longDesc: `Your next counter within 1 round does not use up your immediate action, and if it successfully negates or avoids the attack, you can recover another counter that is a lower level than the counter initiated.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'scarletThrone',
              level: 5,
              name: "Royal Guard",
              type: "Boost",
              longDesc: `For 1 round, when a creature makes a weapon attack against you, you may expend an attack of opportunity to increase your armor class against the attack by +2. You must expend them before the attack is made, and you can expend multiple at the same time. You cannot expend more attacks of opportunity this way during the round than twice your initiation modifier. For every attack that misses you because of the armor class you gained, you gain a +1 dodge bonus to armor class for the rest of the round.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'scarletThrone',
              level: 3,
              name: "Scarlet Advance",
              type: "Boost",
              longDesc: `Move half of your movement speed in a straight line (even up, doesn't provoke). The next attack you make this turn gains a +2 bonus and deals an additional 2d8 damage. This 2d8 damage is multiplied on critical hits.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'scarletThrone',
              level: 2,
              name: "Noble Footwork",
              type: "Boost",
              longDesc: `Take a 5-foot step. You then gain three 5-foot steps that you can take during your turn. You can take these 5-foot steps even if you have already moved or taken another 5-foot step that turn. During the duration, every time you take a 5-foot step, you gain a +1 dodge bonus to armor class for 1 round.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              utility: true,
              },
              {
              school: 'scarletThrone',
              level: 2,
              name: "Passata Sotto",
              type: "Boost",
              longDesc: `Your next attack this turn has your reach increased by 5 feet, and if you make it immediately after initiating this maneuver, it also targets the creature's flat-footed armor class. Both of these bonuses are lost if you move from your current square. After initiating this maneuver, you suffer a -4 penalty to armor class for 1 round (this penalty does not stack with the penalty to armor class from being prone). You cannot initiate this while prone.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'scarletThrone',
              level: 3,
              name: "Red Invitation",
              type: "Boost",
              longDesc: `Take a 5-foot step away from an adjacent enemy. If within 1 round that enemy takes a 5-foot step closer to you and you threaten them at the end of the movement, it provokes an attack of opportunity from you. This attack of opportunity has a flat +1 bonus to its critical threat range and deals additional precision damage equal to your level.`,
              initiationAction: `movement`,
              range: `adjacent enemy`,
              duration: `1 round`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'scarletThrone',
              level: 3,
              name: "Art of the Crown",
              type: "Boost",
              longDesc: `As long as you have this maneuver unexpended, you gain an additional attack of opportunity every round and all attacks of opportunity gain a +1 bonus on attack rolls.
              \nOnce initiated, gain additional attacks of opportunity this round equal to your initiation modifier, or levels of <royal/technique> maneuvers known (whichever is higher). For the round, your attacks of opportunity this round gain a +2 bonus, and cause the creature to bleed for 2d6 damage. They deal this bleed damage as long as an attack of opportunity is expended to make an attack roll (as long as you threaten them with the weapon used to make the attempt), such as when making a parry attempt with the parry and riposte ability.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'scarletThrone',
              level: 4,
              name: "Ultimate Bladework",
              type: "Boost",
              longDesc: `Your next melee attack cannot critically strike or be multiplied, but deals bonus precision damage equal to your level. Your next melee attack after that has a flat +1 bonus to its critical threat range, and on a successful critical hit deals bonus damage equal to your level multiplied by your critical damage multiplier. Both of these attacks must be within 3 rounds. If the second attack is successful, you gain a +10 bonus to your movement speed for 1 round, or can make an immediate 5-foot step (can be taken even if already moved or if you took one)`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              utility: true,
              },
              {
              school: 'scarletThrone',
              level: 4,
              name: "Vigilant Throne",
              type: "Boost",
              longDesc: `You gain additional attacks of opportunity equal to your initiation modifier. These attacks of opportunity do not recover and are lost once used. If you initiate this maneuver again, the additional attacks of opportunity do not stack with previous uses, only refreshing them. These additional attacks of opportunity are lost when combat starts or ends. 
              \nYour attacks of opportunity deal +1 damage per attack of opportunity you have remaining from this maneuver.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `combat`,
              target: `you`,
              utility: true,
              },
              {
              school: 'scarletThrone',
              level: 6,
              name: "Suffer No Tresspass",
              type: "Boost",
              longDesc: `As long as you have this maneuver unexpended, you gain an additional attack of opportunity every round, and all attacks of opportunity gain a +1 bonus on attack rolls.
              \nOnce initiated, move half your movement speed, and then gain additional attacks of opportunity this round equal to your initiation modifier, or levels of <royal/guardian> maneuvers known (whichever is higher). For the round, your attacks of opportunity this round gain a flat +1 bonus to their critical threat range. `,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'scarletThrone',
              level: 4,
              name: "Pressing Engagement",
              type: "Boost",
              longDesc: `You can only initiate this maneuver against a creature you have taken an attack of opportunity against since your last turn. Make a melee attack against them with a -5 penalty, it has a +1 flat bonus to its critical threat range for every attack past the first you have taken against them since the end of last turn, but before your current turn. Attacks of opportunity during your turns are also added to this total.`,
              initiationAction: `movement`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'scarletThrone',
              level: 2,
              name: "Devastating Feint",
              type: "Boost",
              longDesc: `Make a feint against a creature you threaten, if successful, instead of the normal penalty, their armor class is reduced by your dexterity modifier for the next attack against them within 1 round.`,
              initiationAction: `movement`,
              range: `melee attack`,
              duration: `1 round`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'shadowAssassin',
              level: 3,
              name: "Night Stalker",
              type: "Stance",
              longDesc: `If you are the only creature threatening an enemy, your attacks against them gain an additional 1d6 sneak attack damage, + 1d6 every 5 levels. On attacks against such creatures that also qualify for sneak attack (even if they are immune to sneak attack), you gain a +1 circumstance bonus on attacks against them.
              \nIf you are also only threatening only the single enemy, you also gain +2 sneak attack damage per dice this grants.`,
              initiationAction: `swift`,
              range: `personal`,
              duration: `stance`,
              target: `you`,
              },
              {
              school: 'shadowAssassin',
              level: 3,
              name: "Shadow Step",
              type: "Boost",
              longDesc: `You must be adjacent to a creature to initiate this maneuver. Teleport adjacent to another creature within range. You leave a shadow behind, however it only lasts 1 round, +1 round per 6 levels. You must be able to see both the target creature and location.`,
              initiationAction: `movement`,
              range: `close (25ft. + 5ft./2 levels)`,
              duration: `instantaneous`,
              target: `1 creature`,
              },
              {
              school: 'shadowAssassin',
              level: 2,
              name: "Assassin's Trick",
              type: "Boost",
              longDesc: `Make a melee touch attack, if successful, it deals no damage, but the creature has its fortification reduced by 25% for 3 rounds. This stacks. At level 9 and 18, the amount of fortification reduced increased by 15%. This can be used against creatures immune to critical hits, treating them as if they had 100% fortification, but the amount reduced is halved.`,
              initiationAction: `movement`,
              range: `touch`,
              duration: `3 rounds`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'shadowAssassin',
              level: 3,
              name: "Shrouded Path",
              type: "Boost",
              longDesc: `Move up to your movement speed. As you do, pick a single square that you move through, leaving a shadow there. For the first round, this shadow can flank for you and your allies.`,
              initiationAction: `movement`,
              range: `0 feet`,
              duration: `1 round`,
              target: `-`,
              utility: true,
              },
              {
              school: 'shadowAssassin',
              level: 2,
              name: "Wraith's Advance",
              type: "Boost",
              longDesc: `Move up to your movement speed. During this movement, you can move through enemy's spaces without requiring an acrobatics check to do so, and doing so does not provoke. Additionally, during this movement, you can use a stealth check in place of acrobatics for avoiding attacks of opportunity, and doing so does not reduce your movement speed. Any creature you move directly through suffers a -2 penalty on all attack rolls and to AC for 1 round.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'shadowAssassin',
              level: 1,
              name: "Into the Night",
              type: "Boost",
              longDesc: `Move up to your movement speed. If you start this movement adjacent to a creature, but end your movement not threatening, or being threatened by it, you can make a stealth check to hide from it, even if you do not have cover, though you suffer a -10 penalty to the check in that case.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'shadowAssassin',
              level: 3,
              name: "Evershifting Shadows",
              type: "Boost",
              longDesc: `Swap places with a shadow and gain 2d6 sneak attack damage for the rest of your turn. At the end of your turn you swap places with the shadow again. Each swap uses 2 rounds of your shadow's duration, and it must have 4 rounds of duration for you to activate this.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 turn`,
              target: `you`,
              utility: true,
              },
              {
              school: 'shadowAssassin',
              level: 4,
              name: "Shadow Pursuit",
              type: "Boost",
              longDesc: `Make a touch attack against a creature, success granting you partial control over their shadow. For rounds equal to half your shadow's duration (minimum 1 round), you can as an immediate action teleport adjacent to the creature, ending this ability. You cannot use this immediate action to interrupt another action, but can use it between them. Their controlled shadow does not count as a shadow in any other way, but can be destroyed if exposed to direct bright light.`,
              initiationAction: `movement`,
              range: `touch`,
              duration: `shadow/2`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'shadowAssassin',
              level: 1,
              name: "Umbral Misdirection",
              type: "Boost",
              longDesc: `Feint an adjacent enemy using stealth in place of bluff and then take a 5-foot step away from them. If the feint was successful, it is feinted as normal but also the creature immediately takes a 5-foot step into the square you left (even if it is not its turn). This doesn't stop the creature from taking a 5-foot step or moving during its next turn. This movement counts as willing movement from the creature. The creature suffers an additional 1d6 sneak attack damage from all attacks for 1 round.`,
              initiationAction: `movement`,
              range: `adjacent enemy`,
              duration: `instantaneous`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'shadowAssassin',
              level: 3,
              name: "Shadow Caltrops",
              type: "Boost",
              longDesc: `Move up to your movement speed. As you do, you can leave shadow caltrops on any space you move through that last 1 round. If a creature moves over them, they must make a perception check DC equal to your stealth bonus, on failure their movement speed is reduced by half for 1 round and they take damage equal to half of your sneak attack damage.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'shadowAssassin',
              level: 2,
              name: "Duskwalker",
              type: "Boost",
              longDesc: `Make a stealth check, move a distance equal to the result of the check without provoking attacks of opportunity. Additionally, until an attack misses you, your armor class, touch armor class, and flat-footed armor class, becomes equal to the result of the check.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'shadowAssassin',
              level: 5,
              name: "Dead Silence",
              type: "Boost",
              longDesc: `Expend any number of <shadow> or <death> combo points. For every <death> combo point expended, you gain 1d6 sneak attack damage for 1 round plus 1 rounder per <shadow> combo point expended. Additionally, when you initiate this maneuver you can immediately make a stealth check to hide (movement not included), even if you dont have cover or concealment, though you suffer a -10 penalty in that case, +2 per <shadow> combo point spent.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `see text;`,
              target: `you`,
              utility: true,
              },
              {
              school: 'shadowAssassin',
              level: 3,
              name: "Grasping Shadows",
              type: "Boost",
              longDesc: `Move up to half your movement speed. During your movement, all enemies adjacent to you must make a reflex save or become entangled by grasping shadows and be unable to take 5-foot steps. Both of these effects last 1 round. You can target a maximum amount of creatures with this equal to your initiation modifier (minimum 1).`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'shadowAssassin',
              level: 4,
              name: "Shadow Noose",
              type: "Boost",
              longDesc: `[Shadow Initiation] Make a ranged touch attack, if successful, you wrap a shadow noose around a creature within 30 feet for 3 rounds. Once per round as a free action, you can roll a stealth check vs the creature's CMD, if you succeed, you move the creature 10 feet closer towards you. If this ends them adjacent to you, they must roll a reflex save or become entangled for 1 round. At level 9 and 18 this lasts an additional round.`,
              initiationAction: `movement`,
              range: `10 feet`,
              duration: `3 rounds`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'shatteredMirror',
              level: 1,
              name: "Mirrored Self",
              type: "Boost",
              longDesc: `You gain a single mirror image. You can expend a <shadow> combo point to increase the amount of mirror images by 1 (max initiation modifier). These mirror images stack with other mirror images (but not repeated uses of this maneuver).`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 minute`,
              target: `you`,
              utility: true,
              },
              {
              school: 'shatteredMirror',
              level: 3,
              name: "Reflected Intent",
              type: "Boost",
              longDesc: `Choose another creature, for 1 round, every time they initiate a maneuver that gives combo points, you also gain those combo points. Alternatively, you can instead choose one willing creature within range, whenever you initiate a maneuver that gives combo points, they gain those combo points.`,
              initiationAction: `movement`,
              range: `close (25ft. + 5ft./2 levels)`,
              duration: `1 round`,
              target: `1 creature`,
              utility: true,
              },
              {
              school: 'shatteredMirror',
              level: 2,
              name: "Splintered Stride",
              type: "Boost",
              longDesc: `You create an illusion of you that moves to any square you would be able to move to, provoking attacks of opportunity as normal. You make a spellcraft check, and enemies that threaten the illusion must make an opposing sense motive or perception check or be forced to attack the mirror image (unless they can see through it). After the illusion reaches its location, it dissapates and you teleport to its location.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'shatteredMirror',
              level: 4,
              name: "Echoing Phantom",
              type: "Boost",
              longDesc: `You gain invisibility (as the spell) for rounds equal to your initiation modifier and then immediately teleport 10 feet. Once this invisibility ends, you teleport back to the square you were in when you initiated this maneuver.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `initiation modifier rounds`,
              target: `you`,
              utility: true,
              },
              {
              school: 'shatteredMirror',
              level: 5,
              name: "Mirror Pact",
              type: "Boost",
              longDesc: `You and an ally trade places through teleportation. For 1 round, when one of you takes damage, you can choose which of you takes the damage.`,
              initiationAction: `movement`,
              range: `close (25ft. + 5ft./2 levels)`,
              duration: `1 round`,
              target: `1 willing ally`,
              utility: true,
              },
              {
              school: 'shatteredMirror',
              level: 3,
              name: "Friend in the Mirror",
              type: "Boost",
              longDesc: `You teleport an ally to a square adjacent to you. At the end of their next turn, they teleport back.`,
              initiationAction: `movement`,
              range: `close (25ft. + 5ft./2 levels)`,
              duration: `instantaneous`,
              target: `1 willing ally`,
              utility: true,
              },
              {
              school: 'shatteredMirror',
              level: 3,
              name: "Flip the Image",
              type: "Boost",
              longDesc: `Choose a creature, teleport to the square on the exact opposite side of them from your current position, the same distance from them included. The creature must be within close range, but the target destination does not need to be. Alternatively, you can use this on a single willing ally, but the range decreases to 5 feet/2 initiator levels. Teleport the ally to the square exactly opposite of you from their current position, distance from you included.`,
              initiationAction: `movement`,
              range: `close (25ft. + 5ft./2 levels)`,
              duration: `instantaneous`,
              target: `1 creature`,
              utility: true,
              },
              {
              school: 'shatteredMirror',
              level: 6,
              name: "Bogoshift",
              type: "Boost",
              longDesc: `Move up to your movement speed, as you do, you choose 2 locations you could have moved to for shadowy images of yourself to move to. These shadowy images can be hit just as you could, provoke for moving, and take damage just as you do. For the rest of your turn, or at the start of your next turn before you have taken any other actions, you can as a free action teleport to either of these locations. If you do, you revert all of the actions you took since initiating it, including reverting any damage, healing, or effects, and take on the hit points, spell points, and conditions of the shadowy image. You can only teleport with this maneuver once per use.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'shatteredMirror',
              level: 2,
              name: "Inverted Reflection",
              type: "Boost",
              longDesc: `Touch two creatures within your reach, they swap places. If both creatures are the same size, this can swap which of the creatures are in control of a grapple.`,
              initiationAction: `movement`,
              range: `touch`,
              duration: `instantaneous`,
              target: `2 creatures`,
              utility: true,
              },
              {
              school: 'shatteredMirror',
              level: 4,
              name: "Shifting Panes",
              type: "Boost",
              longDesc: `All creatures within 30 feet take a 5-foot step of your choice. This doesn't restrict any of the creatures from moving or taking 5-foot steps on their turn.`,
              initiationAction: `movement`,
              range: `30 feet`,
              duration: `instantaneous`,
              target: `all creatures`,
              utility: true,
              },
              {
              school: 'silverCrane',
              level: 3,
              name: "Crane's Ascent",
              type: "Boost",
              longDesc: `Gain a fly speed (good) and then immediately move up to your movement speed. The fly speed ends after the movement. Wherever you finish moving, allies adjacent to the end of the movement heal 2d6 + initiator level hit points.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'silverCrane',
              level: 1,
              name: "Savior's Rush",
              type: "Boost",
              longDesc: `Move up to your movement speed to a place adjacent to an ally who is currently affected by a status that is restricting their ability to take any actions. You can choose to either double your movement speed or to move without provoking attacks of opportunity.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'silverCrane',
              level: 2,
              name: "Wake of Light",
              type: "Boost",
              longDesc: `Move up to your movement speed. You leave a trail of lingering motes of light in every square you move through. Other creatures can move onto a square containing a mote to heal 1d2 hit points. At level 9 and 18 the healing increases by 1d2. The healing of multiple motes in one round stacks, but counts as only a single source of healing.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'silverCrane',
              level: 2,
              name: "Descent of the Dove",
              type: "Boost",
              longDesc: `Move up to half your movement speed and touch an ally. If you do not move, this still provokes as if you had. The ally heals 2d6 + initiator level hit points. You cannot use this on yourself. If the ally is below 0 hit points, the healing doubles and they gain a +2 sacred bonus to armor class for 1 round.`,
              initiationAction: `movement`,
              range: `touch`,
              duration: `instantaneous`,
              target: `1 ally`,
              utility: true,
              },
              {
              school: 'silverCrane',
              level: 3,
              name: "Bleed Light",
              type: "Boost",
              longDesc: `Make a touch attack against an enemy. If it hits, for 1 round, every time an ally damages them with melee weapon attack, they heal 1d6 + initiation modifier damage. If the damage they deal is from a standard action strike that makes only a single attack against the creature, the healing is tripled.`,
              initiationAction: `movement`,
              range: `touch`,
              duration: `1 round`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'silverCrane',
              level: 4,
              name: "Call to Salvation",
              type: "Boost",
              longDesc: `Choose an ally, they can as an immediate action move towards you without provoking attacks of opportunity. Their movement must end adjacent to you, and at the end of the movement they cannot be threatening, or threatened by any enemies. Once they move, they heal 6d6 + initiation modifier hit points.`,
              initiationAction: `movement`,
              range: `close (25ft. + 5ft./2 levels)`,
              duration: `instantaneous`,
              target: `1 ally`,
              utility: true,
              },
              {
              school: 'silverCrane',
              level: 5,
              name: "Silver Sun",
              type: "Boost",
              longDesc: `You eminate an aura of light and positive energy around you in a 10 foot radius. When you initiate this maneuver, or when an ally ends their turn within the aura, they heal 5d6 hit points. All allies have all damage deal to them reduced by an amount equal to your initiation modifier while inside of the aura (excludes you. This applies after all other resistances and damage reduction, but doesn't stack with like effects to reduce damage).`,
              initiationAction: `movement`,
              range: `10 feet`,
              duration: `1 round`,
              target: `allies`,
              utility: true,
              },
              {
              school: 'sleepingGoddess',
              level: 3,
              name: "Dreamwalker's Stride",
              type: "Boost",
              longDesc: `Move up to your movement speed. You are incorporeal for the entire movement, allowing you to move through physical objects.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'sleepingGoddess',
              level: 3,
              name: "Shared Dream",
              type: "Boost",
              longDesc: `Move up to  your movement speed. During the movement, you can touch a single ally that you move within reach of as a free action (not yourself), if you do, they teleport to the square you started your movement in.`,
              initiationAction: `movement`,
              range: `touch`,
              duration: `instantaneous`,
              target: `1 ally`,
              utility: true,
              },
              {
              school: 'sleepingGoddess',
              level: 4,
              name: "Unapproachable Goddess",
              type: "Boost",
              longDesc: `Move up to  your movement speed. If your movement started with you threatening an enemy, but not threatening them at the end of the movement, the creature has a hard time approaching you. If one of those enemies tries to move to a location where it threatens you within 1 round, it must make a will save or be unable to do so. If you move to a position where you threaten the enemy within the round, this effect ends on them. This also has no effects on creatures who already threaten you before they move. This is a [mind-affecting][compulsion] effect.`,
              initiationAction: `movement`,
              range: `adjacent enemies`,
              duration: `1 round`,
              target: `enemies`,
              utility: true,
              },
              {
              school: 'sleepingGoddess',
              level: 1,
              name: "Divine Stride",
              type: "Boost",
              longDesc: `Move up to  your movement speed. If a creature attempts to make an attack of opportunity against you, they must make a will save or the attack is wasted. After finishing this movement, the next time within 1 round a creature tries to attack you, they must make a will save or the attack is wasted. [mind-affecting]
              \nIf a creature fails a will save from this maneuver, they are shaken for 1 round.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'sleepingGoddess',
              level: 2,
              name: "Inescapable Blade",
              type: "Boost",
              longDesc: `Move up to 10 feet without provoking attacks of opportunity. Your next melee attack this round has its reach increased by 10 feet. You cannot attack creatures within 10 feet of you. This attack ignores cover, even total cover, but they still may gain concealment from total cover. 
              \nYou can expend 2 power points to make another attack during this round also have this effect (they must be used in a row).
              \nEvery 9 levels, the distance moved, the reach, and the area you cannot attack creatures increases by 5 feet.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'sleepingGoddess',
              level: 4,
              name: "Dreamed Passage",
              type: "Boost",
              longDesc: `Touch an ally and then move up to your movement speed. At the end of your movement, they teleport to a square within your natural reach.`,
              initiationAction: `movement`,
              range: `touch`,
              duration: `1 round`,
              target: `1 ally`,
              utility: true,
              },
              {
              school: 'sleepingGoddess',
              level: 6,
              name: "Transcendant Advance",
              type: "Boost",
              longDesc: `Make a melee touch attack against a creature. If successful, the creature is moved directly away from you squares equal to your initiation modifier, then you teleport adjacent to them in the square exactly opposite of the side you initiated this maneuver from.`,
              initiationAction: `movement`,
              range: `touch`,
              duration: `instantaneous`,
              target: `1 creature`,
              },
              {
              school: 'sleepingGoddess',
              level: 3,
              name: "Ascending Step",
              type: "Boost",
              longDesc: `You and all adjacent creatures may make a 5-foot step, and gain a +2 bonus to armor class against attacks of opportunity. Enemies choose whether they take the 5-foot steps before or after your allies. Enemies who take this 5-foot step suffer damage equal to your initiation score. This doesn't limit any of the creatures except you from taking a 5-foot step or moving.`,
              initiationAction: `movement`,
              range: `adjacent creatures`,
              duration: `instantaneous`,
              target: `creatures`,
              utility: true,
              },
              {
              school: 'solarWind',
              level: 1,
              name: "Dazzling Dash",
              type: "Boost",
              longDesc: `Move up to your movement speed, any enemy that threatens you during this movement is dazzled for 1 round. If you end your movevement adjacent to an enemy, they instead become blinded until the end of your turn. They can make a reflex save to avoid the blind, but if they were dazzled before you initiated this maneuver, they suffer a -2 penalty to their save.`,
              initiationAction: `movement`,
              range: `adjacent enemies`,
              duration: `1 round`,
              target: `enemies`,
              utility: true,
              },
              {
              school: 'solarWind',
              level: 2,
              name: "Phantom Reload",
              type: "Boost",
              longDesc: `You reload a single weapon with phantom ammunition. This ammunition has all of its damage converted to fire damage, and must be fired within 1 round or it dissipates.`,
              initiationAction: `movement`,
              range: `touch`,
              duration: `1 round`,
              target: `1 weapon`,
              utility: true,
              },
              {
              school: 'solarWind',
              level: 2,
              name: "Dazzling Escape",
              type: "Boost",
              longDesc: `You create an effect identical to the glitterdust spell in a 10-foot radius around you, except that its duration is reduced to 1 round (doesn't effect you), then you move half your movement speed.`,
              initiationAction: `movement`,
              range: `enemies`,
              duration: `1 round`,
              target: `10 feet`,
              utility: true,
              },
              {
              school: 'solarWind',
              level: 2,
              name: "Fiery Imbuement",
              type: "Boost",
              longDesc: `[Ammunition Imbument] You touch a piece of ammunition, granting it special properties for 1 minute. You can initiate this maneuver as part of another action (at least movement action) when loading the ammunition into a weapon. If that ammunition hits an enemy, all of its damage is converted to fire damage, but it also deals an additional 1d6 points of fire damage per initiation modifier.`,
              initiationAction: `movement`,
              range: `touch`,
              duration: `1 minute`,
              target: `piece of ammunition`,
              utility: true,
              additionalInfoTags:["Ammunition Imbument"]
              },
              {
              school: 'solarWind',
              level: 3,
              name: "Dazzling Trail",
              type: "Boost",
              longDesc: `Move up to  your movement speed, leaving a trail of glitterdust behind you. Any creature that enters one of those squares must make a reflex save or suffer the effects of glitterdust for 1 round. During your next turn, you gain a +4 bonus on ranged attacks against creatures that have been glitterdusted by this ability.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'solarWind',
              level: 5,
              name: "Explosive Imbument",
              type: "Boost",
              longDesc: `[Ammunition Imbument] You touch a piece of ammunition, granting it special properties for 1 minute. You can initiate this maneuver as part of another action (at least movement action) when loading the ammunition into a weapon. When that ammunition strikes something, the arrow explodes, dealing half its damage to creatures adjacent to the struck square. All of this damage is converted to fire damage, and creatures can make a reflex save to negate this damage. If the attack hits a creature directly, it is expempt from the additional damage. This damage gains none of the special properties of the attack, and doesn't count as a part of the attack for the damage dealt.`,
              initiationAction: `movement`,
              range: `touch`,
              duration: `1 minute`,
              target: `piece of ammunition`,
              utility: true,
              additionalInfoTags:["Ammunition Imbument"]
              },
              {
              school: 'solarWind',
              level: 4,
              name: "Sun Spot",
              type: "Boost",
              longDesc: `Move up to half of your movement speed in a straight line. This doesn't provoke. If you started the movement being threatened by an enemy, but end your movement not threatened by them, you gain a +4 bonus on ranged attacks against them for 1 round. The next time within 1 round that creature attacks you, it suffers a -4 penalty on the attack.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'solarWind',
              level: 4,
              name: "Shimmer",
              type: "Boost",
              longDesc: `You can only initiate this maneuver when below 33% hit points. Become invisible, gain temporary hit points equal to your initiation score that last 2 rounds, then move 10 feet in a straight line, this doesn't provoke attacks of oppportunity, then move the rest of your movement speed as normal. If you initiate this maneuver while below 15% hit points, you can initiate it again before the end of your next turn (only activates once per normal recovery) as a swift action, but the distance moved is reduced by half.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'solarWind',
              level: 3,
              name: "Heat Haze",
              type: "Boost",
              longDesc: `Move up to half your movement speed and make an opposing perception check against an opponent within range that you can see, and can see you. If you win, the creature suffers a -4 penalty on all ranged attacks against you for 1 round, and as long as the attack is made at a range greater than 60 feet, you gain a +2 circumstance bonus on ranged attacks against them for 2 rounds. Creatures with blindsight are immune to this.`,
              initiationAction: `movement`,
              range: `60 feet`,
              duration: `1 round`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'solarWind',
              level: 4,
              name: "Phoenix Shot",
              type: "Strike",
              longDesc: `You unleash an attack from a ranged weapon, imbuing it with a phoenix's energy. It flies in a straight line, striking all creatures whose tile it moves through. All creatures struck heal hit points equal to half the damage of the attack. This is positive energy, and can also damage undead. All creatures struck receive a reflex save to negate it.`,
              initiationAction: `standard`,
              range: `ranged attack`,
              duration: `instantaneous`,
              target: `creatures`,
              },
              {
              school: 'solarWind',
              level: 3,
              name: "Solar Shot",
              type: "Boost",
              longDesc: `[Ammunition Imbument] You touch a piece of ammunition, granting it special properties for 1 minute. You can initiate this maneuver as part of another action (at least movement action) when loading the ammunition into a weapon. The ammunition becomes incorporeal until it strikes a creature. This allows it to move directly through solid terrain, allowing it to avoid cover, full cover, and improved cover, though the target may still have concealment. All of the damage of the attack is converted to fire damage.`,
              initiationAction: `movement`,
              range: `touch`,
              duration: `1 minute`,
              target: `piece of ammunition`,
              utility: true,
              additionalInfoTags:["Ammunition Imbument"]
              },
              {
              school: 'solarWind',
              level: 1,
              name: "Solar Shift",
              type: "Boost",
              longDesc: `Move up to your movement speed. During this movement, you can use the action to reload ranged weapons (this doesn't accelerate reloading in any way, you just get to move while reloading). You can even draw special ammunition from your bag and reload that without requiring any additional actions.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'steelSerpent',
              level: 1,
              name: "Surgical Precision",
              type: "Boost",
              longDesc: `Make a heal check against a creature that you can clearly see, DC 10 + creature's HD. If you succeed, the next attack you make against the creature within 1 round has a flat +1 increase to its critical threat range. At level 9 and 18, this lasts an additional round and attack. `,
              initiationAction: `movement`,
              range: `60 feet`,
              duration: `1 round`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'steelSerpent',
              level: 1,
              name: "Vivisectionist's Eye",
              type: "Boost",
              longDesc: `Move up to half your movement speed directly towards a creature, then make a heal check against them, DC 10 + creature's HD. If you succeed, ignore 25% of the creature's fortification and critical immunity until the end of your next turn. At level 9 and 18, the fortification bypass increases by 10%, and the duration increases by 1 round.`,
              initiationAction: `movement`,
              range: `60 feet`,
              duration: `1 round`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'steelSerpent',
              level: 4,
              name: "Killer's Insight",
              type: "Boost",
              longDesc: `Make a heal check against a creature that you can clearly see, DC 20 + creature's HD. If you succeed, the next attack you make against the creature within 1 round has a flat +1 increase to its critical damage multiplier. At level 9 and 18, this lasts an additional round and attack. `,
              initiationAction: `movement`,
              range: `60 feet`,
              duration: `1 round`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'steelSerpent',
              level: 2,
              name: "Viper's Pursuit",
              type: "Boost",
              longDesc: `Move up to  your movement speed. If you end your turn adjacent to an enemy, if within 1 round the creature 5-foot steps away from you, you can also take an immediate 5-foot step so long as you also end adjacent to them. This doesn't stop you from taking a 5-foot step or moving on your next turn.`,
              initiationAction: `movement`,
              range: `adjacent enemy`,
              duration: `1 round`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'steelSerpent',
              level: 3,
              name: "Relly Sprint",
              type: "Boost",
              longDesc: `If an enemy was threatened by you at the end of your previous turn, but no longer is, you can move up to twice your movement speed, so long as you end the movement threatening them. You gain a +2 insight bonus on all attacks against them for 1 round.
              \nFor 1 round, If the target is below 25% hit points, your attacks against them deal an additional 2d6 precision damage. This increases by 1d6 every 9 levels.`,
              initiationAction: `movement`,
              range: `sight`,
              duration: `1 round`,
              target: `1 enemy`,
              utility: true,
              },
              // {
              // school: 'steelSerpent',
              // level: 2,
              // name: "Serpent's Trick",
              // type: "Boost",
              // longDesc: `Make a melee touch attack, if successful, it deals no damage, but the creature has its fortification reduced by 15% for 3 rounds. This stacks. At level 9 and 18, the amount of fortification reduced increased by 5%. This can be used against creatures immune to critical hits, causing them to act as if they had fortification 100% - half of the normal reduced reducing amount.`,
              // initiationAction: `movement`,
              // range: `touch`,
              // duration: `3 rounds`,
              // target: `1 enemy`,
              // utility: true,
              // },
              {
              school: 'steelSerpent',
              level: 3,
              name: "Steel Dance",
              type: "Boost",
              longDesc: `Move up to your movement speed, as you do, roll a heal check, your armor class against attacks during the movement is equal to the heal check. After the movement, your armor class against the next attack within 1 round is also equal to the heal check rolled. If a creature attacks you and misses you during this movement, they are flat-footed against your next attack within 1 round.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'steelSerpent',
              level: 5,
              name: "Snake Fang",
              type: "Boost",
              longDesc: `Make a melee touch attack, if successful, it deals precision damage equal to a heal check -10 (cannot do less than 0 damage). If the attack is a critical hit, the damage is not multiplied, but the creature is paralyzed until the end of your next turn (fort reduces this to the end of your current turn). Fortification and critical immunity applies against this entire maneuver.`,
              initiationAction: `movement`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'steelSerpent',
              level: 3,
              name: "Cobra's Revenge",
              type: "Strike",
              longDesc: `You can only initiate this maneuver against a creature that has taken an attack of opportunity against you since the start of your last turn. Make a melee attack against them. If this attack was provoked for a reason other than you taking an action that normally provokes attacks of opportunity, (eg, not moving through their threatened space, drawing an item, casting a spell, etc) it deals additional precision damage equal to your ranks in heal. This attack gains a +1 bonus to attack and +4 to damage for every attack of opportunity past the first they took against you.`,
              initiationAction: `movement`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'steelSerpent',
              level: 2,
              name: "Greet the End",
              type: "Boost",
              longDesc: `Make a touch attack against an enemy. If they were going to take ongoing damage from a maneuver next turn, they take that damage immediately (this includes ability score damage). If that damage was going to allow a save, they take a -4 penalty to the save.`,
              initiationAction: `movement`,
              range: `touch`,
              duration: `instantaneous`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'tempestGale',
              level: 1,
              name: "Wind's Swiftness",
              type: "Boost",
              longDesc: `You gain a standard action that you can use to reload ranged weapons or draw ammunition or ranged weapons.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'tempestGale',
              level: 2,
              name: "Bullseye",
              type: "Boost",
              longDesc: `Your next ranged attack within 1 round gains a +4 bonus to the attack roll and ignores soft cover.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'tempestGale',
              level: 2,
              name: "Wind Runner's Barrage",
              type: "Boost",
              longDesc: `Move up to your movement speed in a straight line. During this movement, you can use your remaining actions to make ranged attacks at any part of the movement. Your movement after the first square left does not provoke attacks of opportunity.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'tempestGale',
              level: 2,
              name: "Cyclone Dash",
              type: "Boost",
              longDesc: `Move up to your movement speed. Any creature that was adjacent to you of where you started your movement, takes a -2 penalty on armor class against ranged attacks for 1 round. At level 9 and 18 the penalty increases by 1. At level 10, the duration increases by 1 round.`,
              initiationAction: `movement`,
              range: `10 feet`,
              duration: `1 round`,
              target: `enemies`,
              utility: true,
              },
              {
              school: 'tempestGale',
              level: 3,
              name: "Zephyr's Path",
              type: "Boost",
              longDesc: `Move up to your movement speed. Until the end of your next turn, as long as you are adjacent to any square you moved through during this movement, you can use any other square that you moved through as the initiating point of ranged weapon attacks. The creature may still have concealment against you if you cannot see them.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'tempestGale',
              level: 3,
              name: "Sky Shot",
              type: "Boost",
              longDesc: `Move up to your movement speed in a straight line directly upwards, and then up to 1/4 your movement speed sideways (rounded up). During this movement you can use stealth in place of acrobatics to move without threatening attacks of opportunity, and if you do, doing so does not reduce your movement speed. You can do this even if you cannot fly, and you do not fall or take any penalty to ranged attacks until the start of your next turn. Any creature that is twice as far beneath you as they are away from you, you gain a +2 bonus to ranged attack rolls and ranged damage rolls against them.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'tempestGale',
              level: 4,
              name: "Wind Current",
              type: "Boost",
              longDesc: `You fire your ranged weapon in a direction, dealing no damage, but creating a wind current behind it, flowing in the direction of the shot. The distance is equal to the range increment of the weapon. Creatures who move through the wind current in the direction of the shot move twice as fast, whereas creatures moving against the direction move at half speed. Ranged weapon attacks fired through it in the right direction gain a +2 bonus, and ranged weapon attacks fired through it going the wrong direction suffer a -2 penalty. This attack penalty or bonus is doubled if the entire attack moves through the wind current.`,
              initiationAction: `movement`,
              range: `-`,
              duration: `1 round`,
              target: `-`,
              utility: true,
              },
              {
              school: 'tempestGale',
              level: 6,
              name: "Hurricane Draw",
              type: "Boost",
              longDesc: `Your next ranged attack with a discipline weapon within 1 round pierces through the target of the attack, striking another creature behind the target. The primary attack suffers a -5 penalty, and the penetrating attack suffers a -10 penalty, but otherwise gains the benefits of the attack that is penetrating through them, including bonuses from strikes. You must be able to draw a line through yourself to both targets of the attack. This boost does not work with any ammunition that is expended after being fired, such as explosive arrows, or any gear ammunition.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'thrashingDragon',
              level: 2,
              name: "Dragon Waltz",
              type: "Boost",
              longDesc: `Gain three 5-foot steps that you can take during the next 5 rounds. These 5-foot steps do not limit your ability to take other 5-foot steps or move, nor are they limited by you having moved or taken another 5-foot step this round. They do not return at the start of your turn, and are lost once used. After taking one of these 5-foot steps, you gain a +1 dodge bonus to your armor class until the start of your next turn (stacks) and your next attack gains a +1 circumstance bonus to its attack and damage roll. You cannot take multiple 5-foot steps the round you initiate this maneuver. Every 9 levels, you gain an additional 5-foot step that you can expend. These are lost when entering or leaving combat, and do not stack with similar abilities.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `5 rounds`,
              target: `you`,
              utility: true,
              },
              {
                school: 'thrashingDragon',
                level: 2,
                name: "Wyrm's Weave",
                type: "Boost",
                longDesc: `Move squares up to your dexterity modifier. This movement does not provoke. You can move through enemies with a lower dexterity score than you during this without provoking, if you do, they suffer a -2 penalty on attacks against you, while you gain a +2 bonus attacks against them. These both last 1 round. If you attempt to move through a creature's square and they have a higher dexterity score than you, the movement to enter their square is wasted and instead you suffer a -2 penalty to attack and AC for 1 round.`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
                utility: true,
              },
              {
                school: 'shadowAssassin',
                level: 4,
                name: "Dusk Closing",
                type: "Boost",
                longDesc: `Move squares up to your dexterity modifier. This movement does not provoke. You can move through enemies with a lower dexterity score than you during this without provoking, if you do, they suffer damage equal to your sneak attack damage, even if they were not flat-footed. This still counts as precision damage. If you attempt to move through a creature's square and they have a higher dexterity score than you, the movement to enter their square is wasted, this maneuver ends, and instead you suffer a -4 penalty to attack and AC for 1 round. For every enemy you move through, treat your dexterity score as being 2 lower for all subsequent creatures.`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
                utility: true,
              },
              {
                school: 'primalFury',
                level: 7,
                name: "Rampage",
                type: "Boost",
                longDesc: `Move squares equal to your strength modifier. This movement does not provoke. You can move through enemies with a lower strength score than you during this without provoking, if you do, they suffer damage equal to an unarmed or natural attack. This always deals damage as if it were an off-hand/secondary attack. If you attempt to move through a creature's square and they have a higher strength score than you, you fail to move, this maneuver ends, and it provokes an attack of opportunity from the creature, for which you suffer a -4 penalty to AC for. For every enemy you successfully move through, you gain a +3 bonus on damage rolls for 1 round (max initiator level).`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
                utility: true,
              },
              {
              school: 'thrashingDragon',
              level: 1,
              name: "Sudden Slash",
              type: "Strike",
              longDesc: `Make an attack with an off-hand weapon at your highest bonus -2. This off-hand weapon must be the same weapon all of your other off-hand attacks have been, or will be during this round. If the attack hits, you may move 5 feet without provoking attacks of opportunity. This movement isn't limited by or stop you from taking 5-foot steps.`,
              initiationAction: `movement`,
              range: `melee or ranged attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              utility: true,
              },
              {
              school: 'thrashingDragon',
              level: 5,
              name: "Crimson Dragon",
              type: "Strike",
              longDesc: `Move half of your movement speed in a straight line (minimum 30 feet) even straight up. During this movement, you can move directly through enemies threatened area or squares without provoking attacks of opportunity, or requiring an acrobatics check to do so. Each creature you pass through, you make an attack with both your primary and off-hand weapons against them at your highest bonus plus your two-weapon fighting penalties. These attacks deal damage as normal plus 4d6. If both your primary and off-hand attacks hit a creature, they take additional damage equal to half the damage of the lower damage attack.`,
              initiationAction: `full-round`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `enemies`,
              },
              {
              school: 'thrashingDragon',
              level: 3,
              name: "Prepare the Frenzy",
              type: "Boost",
              longDesc: `Make an attack with your off-hand weapon at a -5 penalty. If it hits, it deals damage as normal and you gain 1 dragon frenzy stack (max initiation modifier). For every dragon frenzy stack, whenever you make a full-attack action with two weapons, those attacks deal an additional 1d2 damage. For every 3 stacks, they all gain a +1 bonus to attack. All dragon frenzy stacks are lost at the start or end of combat. At level 10, 15, and 20 the bonus damage dice increases by 1 step.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `combat`,
              target: `you`,
              utility: true,
              stacksOne: 0,
              stacksOneName: "Dragon Frenzy",
              },
              {
                school: 'thrashingDragon',
                level: 3,
                name: "Deadly Grip",
                type: "Boost",
                longDesc: `You flip the grip of your off-hand weapon, causing it to become more deadly on its next vital attack. The next time you roll a potential critical hit with the weapon, it suffers a -5 penalty to the confirmation roll, but it has its critical damage multiplier increased by +1. Once this potential critical is rolled (whether confirmed or not) this ends. Once you use this on a weapon, it can only be used as an off-hand weapon until this triggers.`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
                utility: true,
              },
              {
              school: 'thrashingDragon',
              level: 4,
              name: "Titan Slayer",
              type: "Strike",
              longDesc: `You leap at a creature, spinning as you move, stabbing your weapons into the creature to deal damage to them as you move along their body. Make an acrobatics check, moving in a straight line a distance equal to or less than the result of the check. You cannot initiate this maneuver while within the target's reach, and your movement must end with you inside of their reach, and not have total cover between the two of you. You spin along the creature, making alternating primary and off-hand attacks against them, each one with a -5 penalty from the previous attack with that hand. You can make attacks equal to the creature's area, divided by your area (your minimum area is considered 5 feet). Each attack deals an additional 3d6 damage. After this finishes, you finish your movement adjacent to the creature in the exact opposite square of your position when you started the attacks. None of this movement provokes.`,
              initiationAction: `full-round`,
              range: `adjacent enemy`,
              duration: `instantaneous`,
              target: `1 enemy`,
              },
              {
                school: 'thrashingDragon',
                level: 5,
                name: "Deadly Strafe",
                type: "Strike",
                longDesc: `Move up to your movement speed in a straight line. You gain a bonus equal to your level on acrobatics checks to move through threatened area or the squares of enemies and doing so does not slow your movement speed. During this movement, if you move through an enemy's space, you can make an attack with both your primary and off-hand weapons at a -5 penalty (as if two-weapon fighting). If those attacks hit, they deal only their base damage plus their enchantments. If both attacks hit, you also deal additional damage equal to 1.5x your dexterity modifier.`,
                initiationAction: `movement`,
                range: `enemies you move through`,
                duration: `instantaneous`,
                target: `enemies`,
              },
              {
                school: 'thrashingDragon',
                level: 5,
                name: "Dance of the Dragon",
                type: "Boost",
                longDesc: `Make an acrobatics check. Move that distance without provoking attacks of opportunity. Gain five 5-foot steps that you can take during the next minute. These 5-foot steps do not limit your ability to take other 5-foot steps or move, nor are they limited by you having moved or taken another 5-foot step this round. They do not return at the start of your turn and are lost once used. After taking one of these 5-foot steps, you gain a +2 dodge bonus to your armor class until the start of your next turn (stacks), and a +1 when you take a regular 5-foot step. If you make multiple 5-foot steps while adjacent to a creature, you gain a +1 bonus on attacks and damage against them for 1 round for every 5-foot step after the first. You cannot take multiple 5-foot steps the round you initiate this maneuver. These are lost when entering or leaving combat, and do not stack with similar abilities.`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `1 minute`,
                target: `you`,
              },
              {
              school: 'thrashingDragon',
              level: 4,
              name: "Dragon's Spines",
              type: "Boost",
              longDesc: `Move up to half your movement speed. For 1 round, any creature that attacks you with a non-reach melee weapon takes damage equal to the damage dice of your off-hand weapon, plus any enhancement bonus the weapon may have. During this whole duration, including any attacks you take, or did take during the round of activation, you must always use the same off-hand.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
                school: 'thrashingDragon',
                level: 4,
                name: "Claw and Fang Style",
                type: "Boost",
                longDesc: `Choose one of your weapons to become your off-hand weapon until this triggers. That off-hand weapon has its base critical threat range become the base critical threat range of your primary weapon. The primary weapon cannot critically hit until this triggeres.`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `combat`,
                target: `you`,
                utility: true,
              },
              {
                school: 'thrashingDragon',
                level: 5,
                name: "The First Claw",
                type: "Boost",
                longDesc: `This round, you can initiate a standard action strike that allow you to make a single attack as a part of taking a full-attack action, causing the strike to be the first attack made in your full attack action. All attacks in the round take a penalty equal to the level of the maneuver initiated. Either this maneuver, or the initiated maneuver do not grant a combo point (your choice). Using this technique causes great strain on your body afterwards, causing you to suffer a -6 penalty to your armor class for 1 round.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },
              {
              school: 'unquietGrave',
              level: 4,
              name: "Haunted Advance",
              type: "Boost",
              longDesc: `You can move up to your movement speed, becoming incorporeal during the movement, allowing you to move through solid barriers and creatures. If you move through a creature during this, they take 4d8 negative energy damage, and you gain half the damage as temporary hit points, this stacks with itself, as long as they are part of the same initiation. These temporary hit points last 1 minute.
              \nGrave Call: the temporary hit points instead become healing, and you heal 4d8 when you initiate this maneuver.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'unquietGrave',
              level: 3,
              name: "Grave Chains",
              type: "Strike",
              longDesc: `You touch a creature, attaching spectral chains to their body that are bound to you. This requires a touch attack to do, and lasts until the end of your next turn. A creature with spectral chains who attempts to move further than 10 feet away from you must make a strength check, DC equal to this maneuver's DC, or they are unable to move further than 10 feet away from you during that movement. If you have a creature attached to you, you can use a movement action to pull a creature to any square adjacent to you, requiring a reposition check, though gaining a +5 bonus, and it doesn't provoke.
              \nGrave Call: If you pull a creature towards you, or the creature fails to move away from you, they take 4d8 negative energy damage, and you heal half the damage dealt.`,
              initiationAction: `movement`,
              range: `touch`,
              duration: `1 round`,
              target: `1 enemy`,
              },
              {
              school: 'unquietGrave',
              level: 1,
              name: "Unstoppable Approach",
              type: "Boost",
              longDesc: `Move up to your movement speed. During this movement, you are immune to effects that reduce your movement speed, except for effects that rely on lack of vision. You gain DR equal to half your level on the next attack that hits you within 1 round (stacks with other DR).`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'unquietGrave',
              level: 7,
              name: "March of Shadows",
              type: "Boost",
              longDesc: `Move up to twice your movement speed in a straight line. During this movement, you can use your knowledge (religion) in place of acrobatics for avoiding attacks of opportunity. During your movement, any enemy that threatens you must make a will save or become panicked until the start of their next turn, and staggered and shaken on their next turn.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'unquietGrave',
              level: 6,
              name: "Spirit of Dread",
              type: "Boost",
              longDesc: `Until the start of your next turn, whenever a living creature is damaged within 10 feet of you, you gain 1d8 temporary hit points (stacks with itself, as long as it is apart of the same initiation of this maneuver, doesn't include when you are damaged). If a creature is killed, you gain 1d8 plus the creatures hit dice in temporary hit points. These temporary hit points last 1 minute.
              \nGrave Call: You instead heal this amount.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              utility: true,
              },
              {
              school: 'unquietGrave',
              level: 4,
              name: "Dreadful Specter",
              type: "Boost",
              longDesc: `Roll a knowledge (religion) check. Teleport a distance up to the result of the check. You teleport in a straight line, and must see and have line of effect to the destination. Any creature you directly teleported through, suffers 4d8 negative energy damage, and are shaken for 1 round. If you finish this teleportation adjacent to a creature that you teleported through, they must instead make a will save or they become panicked for 1 round.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'veiledMoon',
              level: 2,
              name: "Mark and Advance",
              type: "Boost",
              longDesc: `Pick a square within close range, at the end of your next turn, you teleport there (regardless of distance, though you must be on the same plane). If the space is no longer available, the telportation fails and you suffer 5d6 damage. You must see and have line of effect to the chosen destination when you initiate this maneuver, but not actually when it teleports you.`,
              initiationAction: `movement`,
              range: `close (25ft. + 5ft./2 levels)`,
              duration: `1 round`,
              target: `location`,
              utility: true,
              },
              {
              school: 'veiledMoon',
              level: 1,
              name: "Fading Shift",
              type: "Boost",
              longDesc: `Teleport a distance equal to your movement speed. For your next attack this turn, you are considered in both squares for whether you flank a creature.`,
              initiationAction: `movement`,
              range: `movement distance`,
              duration: `instantaneous`,
              target: `you`,
              utility: true,
              },
              {
              school: 'veiledMoon',
              level: 3,
              name: "Wane and Wax",
              type: "Boost",
              longDesc: `Teleport a distance up to close range. At the end of your next turn, you teleport back to the square you were in when you initiated this maneuver. If the space is no longer available, the telportation fails and you suffer 5d6 damage. You must see and have line of effect to the chosen destination when you initiate this maneuver, but not actually when it teleports you.`,
              initiationAction: `movement`,
              range: `close (25ft. + 5ft./2 levels)`,
              duration: `1 round`,
              target: `location`,
              utility: true,
              },
              {
              school: 'veiledMoon',
              level: 4,
              name: "Boogie Woogie",
              type: "Boost",
              longDesc: `You swap the position of two creatures within 30 feet of you via teleportation. You can choose yourself for this. If either of the creatures is unwilling, they are allowed a will save to negate, which if successful, causes the entire maneuver to fail, and any willing targets take 5d6 damage. If you use this in tandem with an attack (you or another creature), the target of the attack is flat-footed for it, though the attacker suffers a -2 penalty to their attack. There must be enough space for both creatures in both destinations.`,
              initiationAction: `movement`,
              range: `30 feet`,
              duration: `instantaneous`,
              target: `2 creatures`,
              utility: true,
              },
              {
              school: 'veiledMoon',
              level: 6,
              name: "Hunter's Moon",
              type: "Boost",
              longDesc: `You can make a ranged or melee touch attack against a creature, if it hits, they are marked for 1 minute. As a part of the initiation of this maneuver, you can choose to immediately activate it as a free action to teleport to any square adjacent to them, or leave the mark lingering. If it is lingering, you can consume the mark within 1 minute as an immediate action to teleport to any square adjacent to them. Your next attack against a creature the same round as teleporting to them this way, they are flat-footed for. You must see and have line of effect to the target creature when you initiate this maneuver, but not when it actually teleports you.`,
              initiationAction: `movement`,
              range: `30 feet`,
              duration: `1 minute`,
              target: `1 creature`,
              utility: true,
              },
              {
              school: 'veiledMoon',
              level: 5,
              name: "Dimensional Parasite",
              type: "Boost",
              longDesc: `You infest a single creature within 30 feet with a dimensional parasite. For 1 minute, in order for it to teleport, it must make a concentration check DC your initiation score + level/2 or the teleportation fails. If they succeed on the concentration check, you are immediately aware as long as you are on the same plane, and as a free action you can take when not your turn, choose to follow their teleportation, appearing adjacent to them at their destination. If you follow them, the parasite is expended.`,
              initiationAction: `movement`,
              range: `30 feet`,
              duration: `1 minute`,
              target: `1 creature`,
              utility: true,
              },
              
              
            {
              comboTags: ['Light','Guardian'],
              level: 9,
              name: `Sword of Revealing Light`,
              type: ['Finisher'],
              finisherType:'Boost',
              longDesc: `[light-guardian-light-guardian-light] You hold your sword high in the air, unleashing a devastatingly powerful light from it that keeps enemies at bay. For 1 round, evil and neutral enemies cannot make attacks or use offenseive spells. You also suppress all darkness and illusion spells for 1 round and all stealth checks automatically fail.`,
              initiationAction: `standard`,
              range: `map`,
              target: `all allies`,
              duration: `1 round`,
            },
            {
              comboTags: ['Heroic','Guardian',"Light"],
              level: 9,
              name: "Sky Blue Days",
              type: "Finisher",
              finisherType:"Strike",
              longDesc: `[heroic-light-heroic-guardian-heroic-light-heroic] You carry the hopes and dreams of all of your allies with you, and you wont let them down. You channel the emotions and energy of you and all your allies into a final attack, utilizing every ounce of the journey you have all gone on. All allies, whether alive or dead can contribute to this maneuver, assuming they have the required spell points and readied maneuvers and spells.
              \nEach of your other allies choose a role; depending on the tags associated with that role, they may expend maneuvers or spells of the required tags/types to grant bonuses to this finisher. Expending spells/maneuvers this way spends spell points as normal and they become unavailable for the rest of the floor.
              \nRival <technique/shadow>/[damage]: For every 9 levels expended, you may make an additional attack. Each additional attack takes a cumulative -2 penalty from the previous one.
              \nBrawns <guardian/primal>/[buff]: For every 2 levels expended, all attacks gain a +1 bonus to damage.
              \nBrains <void/arcane>/[control]: For every 9 levels expended, all attacks gain a +1 bonus on their attack rolls.
              \nMentor <sakura/royal>/[utility]: For every 12 levels expended, all attacks gain a flat +1 bonus to their critical damage multiplier.
              \nHeart <heroic/light>/[healing]: Someone MUST choose heart, and they must expend at least 12 levels of spells/maneuvers for you to initiate this finisher. For every addititional 12 levels of maneuvers expended, increase the critical damage multiplier of attacks by +1. You can lower the bonus critical damage multiplier on further attacks by 1 to allow you to instead reroll a single attack roll made. The heart is able to spend spell points for allies to expend their abilities, however they pay double the cost.
              \n\nAfter you initiate this finisher, you can never initiate it again. If the target of this maneuver is not dead, or a final boss sent to next phase, you die instantly and can never be revived again, however, you grant this maneuver to a single ally and recover all of your maneuvers.`,
              initiationAction: `full-round`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
            },
            {
              comboTags: ['Sakura','Royal'],
              level: 7,
              name: `Silver Crown Strike`,
              type: `Finisher`,
              finisherType:"Strike",
              longDesc: `[royal-sakura-royal] With a single swing of your blade, you strike your foe with the force of a thousand blows. Although you only swing your sword once, you make a number of attacks with a single weapon against the target as if you had made a full attack against them. These attacks deal weapon damage as normal, except that the damage from all hits is totalled before applying damage reduction, resistances, or immunities. If any of the attacks is a successful critical hit, the total damage from the entire strike is multiplied. You can only confirm one critical hit in this way. If you drew your weapon as part of this strike, you gain a circumstance bonus on critical confirmation rolls for these attacks equal to your initiation modifier.`,
              initiationAction: `standard`,
              range: `Melee attack`,
              target: `One creature`,
              duration: `Instantaneous`
            },
            {
              comboTags: ['Arcane'],
              level: 5,
              name: `Arcane Surge`,
              type: `Finisher`,
              finisherType:"Boost",
              longDesc: `[arcane-arcane-arcane] You cast a single spell as part of this finisher's initiation action. It must be of a lower level than the highest level of maneuver used to initiate this finisher.`,
              initiationAction: `swift`,
              range: `Personal`,
              duration: `instantaneous`,
              target: `You`,
            },
            {
              comboTags: ['Technique',"Air"],
              level: 1,
              name: `Swift Storm`,
              type: `Finisher`,
              finisherType:"Strike",
              longDesc: `[technique-air-technique] Make an attack with a -5 penalty, it deals an additional 1d6 points of electricity damage per 10 <air> mastery. If the attack is against an enemy wearing metal armor or primarily made of metal, the attack roll gains a +1 bonus on attack rolls per 20 <technique> mastery.`,
              initiationAction: `free`,
              range: `melee or ranged attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
            },
            {
              comboTags: ['Technique',"Earth"],
              level: 1,
              name: `Mountain Blade`,
              type: `Finisher`,
              finisherType:"Strike",
              longDesc: `[technique-earth-technique] Make an attack with a -6 penalty (or -2 if initiated as a movement), its damage is increased by 1 dice step, plus 1 step per 25 <earth> mastery. For every 50 <technique> mastery the attack has its critical damage multiplier increased by +1.`,
              initiationAction: `swift or movement`,
              range: `melee or ranged attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
            },
            {
              comboTags: ['Technique',"Water"],
              level: 1,
              name: `Ocean Slash`,
              type: `Finisher`,
              finisherType:"Strike",
              longDesc: `[technique-water-technique] Make a melee attack against 2 creatures within your reach with a -4 penalty (or +2 if initiated as a movement). It deals an additional 1d6 points of cold damage per 10 <water/technique> mastery. For every 25 <water/technique> mastery you may attack an additional creature.`,
              initiationAction: `swift or movement`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
            },
            {
              comboTags: ['Technique',"Sakura"],
              level: 1,
              name: `Swallow Return Strike`,
              type: `Finisher`,
              finisherType:"Strike",
              longDesc: `[technique-sakura-technique] Make a melee attacks against 2 enemies within your reach with a -4 penalty. Each attack deals an additional 1d4 points of damage per 10 <sakura> mastery. If you make another successful attack within the same turn of initiating this finisher against one of the targets of this finisher, it deals 1d4 per 10 <technique> mastery bonus damage. If you strike one of the creatures multiple additional times, the bonus damage reduces to 1 per 10 <technique> mastery after the first.`,
              initiationAction: `movement`,
              range: `melee attack`,
              duration: `1 round`,
              target: `2 enemies`,
            },
            {
              comboTags: ['Technique',"Fire"],
              level: 1,
              name: `Burning Flash`,
              type: `Finisher`,
              finisherType:"Strike",
              longDesc: `[technique-fire-technique] Make a melee attack (-10 when free action), it deals an additional 1d6 points of fire damage per 5 <fire> mastery. If successful, the creature also suffers 1 immolation per 10 <fire> mastery, and you may remove up to half your current desperation stacks and inflict an additional immolation for every desperation removed.`,
              initiationAction: `swift or free`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
            },
            {
              comboTags: ["Water",'Royal'],
              level: 3,
              name: `Fatal Rainscreen`,
              type: `Finisher`,
              finisherType:"Strike",
              longDesc: `[water-royal-water] Make a melee attack, it deals 1d6 additional damage per 10 <royal> mastery, then move 10 feet directly away from the target of the attack (doesn't provoke). Afterwards, you are surrounded by 3 rain swords, plus an additional sword per 10 <royal/water> mastery. Each time you take damage from an enemy's attacks or abilities, one sword is consumed to reduce the damage by a percentage equal to half your <water> mastery (max 66%).`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `5 rounds`,
              target: `you`,
            },
            {
              comboTags: ['Royal',"Water"],
              level: 6,
              name: `Raincutter`,
              type: `Finisher`,
              finisherType:"Boost",
              longDesc: `[royal-water-royal] You surround yourself in swirling water swords. When you initiate this finisher you gain 3 swords, plus 1 sword per 10 <sakura/water> mastery. Every time you make an attack, a sword is expended and launched at the target of the attack. Make a ranged touch attack (doesn't provoke), if it hits, the creature takes 1d6 cold damage, plus 1d6 per 10 <water> mastery. For each sword you have remaining, you reduce the damage you take from hostile creature's attacks and offensive spells by 5%, plus 1% per 15 <royal/water> mastery (max 80% total).`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `5 rounds`,
              target: `you`,
            },
            {
              comboTags: ['Air',"Guardian"],
              level: 3,
              name: `Guardian Wind`,
              type: `Finisher`,
              finisherType:"Boost",
              longDesc: `[air-guardian,(guardian)-air] You are surrounded by a windwall as the spell. If you use the additional (guardian) combo point, instead the edge of your reach counts as a wind wall. For every 10 <air/guardian> mastery, enemies attacking through the windwall take a -1 penalty on attack rolls.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
            },
            {
              comboTags: ["Guardian"],
              level: 3,
              name: `Stand Against the Darkness`,
              type: `Finisher`,
              finisherType:"Boost",
              longDesc: `[guardian-guardian-guardian-guardian] When you initiate this finisher, make an immediate bull rush attempt against all enemies within your reach, this doesn't provoke. If successful, they are immediately moved to the nearest square outside of your reach. Afterwards, enemies cannot enter your reach by moving for 1 round. Creatures can still attack from outside of your reach, but attacks take a -1 penalty per 10 <guardian> mastery. For every 50 <guardian> mastery you have, this lasts an additional round. `,
              initiationAction: `swift`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
            },
            {
              comboTags: ['Air'],
              level: 1,
              name: `Guiding Wind`,
              type: `Finisher`,
              finisherType:"Boost",
              longDesc: `[air-air-air] While moving, attacks against you suffer a 50% miss chance. You also increase your movement speed by feet equal to 5 feet per 25 <air> mastery. If you are already gaining the benefits of another miss-chance, the stacks, but the benefit is reduced to 25%.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
            },
            {
              comboTags: ['Air'],
              level: 1,
              name: `Heaven's Tailwind`,
              type: `Finisher`,
              finisherType:"Boost",
              longDesc: `[air-air-air] Increase your movement speed by feet equal to 10 + 1/2 of your <air> mastery (rounded down to the nearest 5-foot increment). Half of this bonus counts as an enhancement bonus, while the other half improves your base movement speed. While this is active, you always count as having a running start to jumps.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
            },
            {
              comboTags: ['Air'],
              level: 1,
              name: `Ascendant Walk`,
              type: `Finisher`,
              finisherType:"Boost",
              longDesc: `[air-air-air-air] Gain a fly speed equal to your land speed. While this is active, you can use your fly in place of acrobatics for avoiding attacks of opportunity when moving through a creature's threatened area, or for moving through their space, and when doing so, your movement speed is not reduced.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
            },
            {
              comboTags: ['Air','Void'],
              level: 3,
              name: `Chasing Star`,
              type: `Finisher`,
              finisherType:"Strike",
              longDesc: `[air-void-air] Make a ranged touch attack (doesn't provoke). If it hits, it deals 1d4 electricity damage per 5 <air/void> mastery, and the target becomes marked for 5 rounds. At any point during the duration as a swift or movement action, you can teleport to a square adjacent to the creature and make a single melee attack against them. This teleportation has no maximum range.`,
              initiationAction: `swift`,
              range: `30 feet`,
              duration: `5 rounds`,
              target: `1 enemy`,
            },
            {
              comboTags: ['Curse', 'Air'],
              level: 1,
              name: `Swirling Windstorm`,
              type: `Finisher`,
              finisherType:"Boost",
              longDesc: `[curse-air-curse] For 2 rounds all of the creature's attacks suffer a miss chance of 25% plus half your <curse/air> mastery. Attacks against the enemy suffer half of this miss chance, but the creature also takes a -2 penalty to armor class, -1 per 20 <curse/air> mastery.`,
              initiationAction: `free`,
              range: `30 feet`,
              duration: `2 rounds`,
              target: `1 enemy`,
            },
            {
              comboTags: ['Air','Curse'],
              level: 3,
              name: `Cutting Windstorm`,
              type: `Finisher`,
              finisherType:"Boost",
              longDesc: `[air-curse-air] For 2 rounds, every time the creature makes an attack it suffers 1d6 points of slashing damage. Increased by 1d6 every 20 <air/curse> mastery.`,
              initiationAction: `free`,
              range: `30 feet`,
              duration: `2 rounds`,
              target: `1 enemy`,
            },
            {
              comboTags: ['Technique','Air','Curse'],
              level: 5,
              name: `Cut Their Breath`,
              type: `Finisher`,
              finisherType:"Strike",
              longDesc: `[technique-air,curse-technique] Make a melee attack, if it hits, it deals damage as normal, but the creature suffers a suffocating curse. At the start of each of its next turns for the duration, the creature must make a fortitude save. The first time it fails it is reduced to 0 hit points. The second time it fails it is reduced to -1 hit points. The third time it dies. During this, if it fails a save, for that round it is unable to speak.`,
              initiationAction: `movement`,
              range: `melee attack`,
              duration: `3 rounds`,
              target: `1 enemy`,
            },
            {
              comboTags: ['Water', "Guardian"],
              level: 3,
              name: `Redirecting the Flow`,
              type: `Finisher`,
              finisherType:"Boost",
              longDesc: `[guardian-water-guardian] Make a CMB check against all threatened enemies as if making a reposition or bull rush attempt (your choice). You gain a bonus of +1 per 5 <guardian/water> mastery. If successful, you move each enemy into a new square within your reach. This square cannot be inherently dangerous, and this movement does not provoke. There must also be enough space for the creature. For 1 round, if a new enemy enters your threatened area, you can immediately attempt this on them as well.`,
              initiationAction: `movement`,
              range: `threatened enemies`,
              duration: `1 round`,
              target: `enemies`,
            },            
            {
              comboTags: ['Flurry', "Air"],
              level: 3,
              name: `Stormfury Assault`,
              type: `Finisher`,
              finisherType:"Boost",
              longDesc: `[flurry-air-flurry] Make a full attack, each attack deals 1d6 additional electricity damage, plus 1d6 per 20 <air> mastery. For every successful attack you made during this turn, you retain some of the lingering energy, storing it. After you have made your full attack, you make one additional attack at your highest bonus that deals an additional 1d6 electricity damage per successful attack made this turn. The additional electricity damage per successful attack increases by 1d6 per 50 <flurry> mastery. If this bonus attack hits, the creature is moved directly away from you feet equal to half the electricity damage it took from this final attack (before resistances and immunities)`,
              initiationAction: `full-round`,
              range: `melee or ranged attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
            },
            {
              comboTags: ['Water', 'Void'],
              level: 5,
              name: `Celestial Shower`,
              type: `Finisher`,
              finisherType:"Boost",
              longDesc: `[water-void-water] You summon a celestial shower in a circle around you. Immediately, plus at the start of each of your turns, icicles fall on random enemies within its area. Each icicle deals 1d8 plus 1d8 per 10 <water> mastery. Every turn, 3 icicles fall, plus 1 icicle per 25 <void> mastery. No more than half of these icicles can strike the same enemy. Allies within the area gain a +1 bonus to the caster level of cold spells (bypasses usual damage limit), and all allies cold damage (except that dealt from this) deals an additional point of damage per dice rolled.`,
              initiationAction: `movement`,
              range: `0ft. Area: 30 feet`,
              duration: `3 rounds`,
              target: `enemies`,
            },
            {
              comboTags: ['Primal'],
              level: 1,
              name: `Pure Primality`,
              type: `Finisher`,
              finisherType:"Strike",
              longDesc: `[primal-primal-primal-primal] Make an attack with every weapon you are wielding, every natural attack you have, and a single unarmed attack (doesn't provoke). All of these attacks are made at your highest bonus -2. Each attack deals an additional 1d6 plus 1d6 per 15 <primal> mastery. You can initiate this as a full-round action to initiate it at the end of a charge.`,
              initiationAction: `standard`,
              range: `melee`,
              duration: `instantaneous`,
              target: `1 enemy`,
            },
            {
              comboTags: ['Power'],
              level: 1,
              name: `Overpowering Chop`,
              type: `Finisher`,
              finisherType:"Strike",
              longDesc: `[power-power-power] Make an attack with a melee weapon with a -8 penalty (or -4 if initiated as swift). The attack deals the weapon's damage dice an additional time. Every 20 <power> mastery it deals it's base damage dice an additional time.`,
              initiationAction: `free or swift`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
            },
            {
              comboTags: ['Power','Primal'],
              level: 1,
              name: `Ferocious Bash`,
              type: `Finisher`,
              finisherType:"Strike",
              longDesc: `[power-primal-power] Make an attack with a melee weapon wielded in two hands that is using strength to determine its damage. The attack suffers a -8 penalty (or -4 if initiated as swift) but has its strength modifier to damage increased by 0.5x. Every 15 <power/primal> mastery it increases by an additional 0.5x your strength modifier.`,
              initiationAction: `free`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
            },
            {
              comboTags: ['Power','Air'],
              level: 1,
              name: `Thunder Guillotine`,
              type: `Finisher`,
              finisherType:"Strike",
              longDesc: `[power-air-power] You begin to charge power into your weapon, then bring it down in a thunderous strike. When you initiate this finisher you must pick a weapon you are wielding, then your turn ends immediately. Until the start of your next turn you cannot attack with the chosen weapon. At the start of your next turn as a free action, you make a single melee attack with the chosen weapon (with a -5 penalty if initiated as a free action). The attack has its reach increased by 5 feet and its critical threat range increases by a flat +1 and its critical damage multiplier increased by +1. It also deals an additional 1d6 points of electricity damage per 10 <power/air> mastery, and has its reach increased by 5 feet per 20 <air> mastery.`,
              initiationAction: `free/movement/swift`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
            },
            {
              comboTags: ['Power','Air'],
              level: 1,
              name: `Concussive Cyclone`,
              type: `Finisher`,
              finisherType:"Strike",
              longDesc: `[power-air-power] You spin with reckless abandon, your weapon carving a spiral of destruction. Make an attack against all enemies you threaten (with a -6 penalty if initiated as a movement action). These attack deal an additional 1d4 points of electricity damage per 10 <air/power> mastery, but also if it hits, you may bull rush them as a free action that does not provoke. You cannot move with these bull rush attempts, and you gain a +1 bonus on the attempt per 5 <air/power> mastery.`,
              initiationAction: `standard or movement`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
            },
            {
              comboTags: ['Air','Flurry','Power'],
              level: 3,
              name: `Ruten Storm`,
              type: `Finisher`,
              finisherType:"Strike",
              longDesc: `[air-power/flurry-air] Every 6th melee attack you make, you may make an additional attack against the same target at a bonus of 5 lower than the attack that triggered this. This extra attack does not count towards the next extra attack. These attacks deal an additional 1d6 points of electricity damage per 10 <air/power/flurry> mastery, but also an additional 1d6 points of electricity damage and gain a +1 bonus to attack for every time this activation of the finisher you have used this attack.`,
              initiationAction: `swift`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
            },
            {
              comboTags: ['Power','Fire'],
              level: 1,
              name: `Blazing Conquest`,
              type: `Finisher`,
              finisherType:"Strike",
              longDesc: `[power-fire-power] Make a melee attack (with a -5 penalty if initiated as a free action). If the attack hits, it deals an additional 1d4 points of fire damage per 10 <fire/power> mastery and all enemies that you threaten other than the target of the attack take damage equal to half of the damage you dealt with this attack. All of this damage becomes fire damage and they can make a reflex save to reduce it by half.`,
              initiationAction: `free or swift`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
            },
            {
              comboTags: ['Power','Fire'],
              level: 1,
              name: `Flowing Flame`,
              type: `Finisher`,
              finisherType:"Strike",
              longDesc: `[fire-power-fire] The first melee attack you make each of your turns for the next 3 rounds gains bonus fire damage of 1d4 plus 1d4 per 10 <fire/power> mastery and gives 1 immolation, plus 1 immolation per 20 <fire/power> mastery. As long as this empowered attack hits, the first melee attack you make next turn has its bonus fire damage (from this finisher) increased by 2 dice steps. If you hit all 3 of them, until the end of your next turn, all of your weapon and natural attacks deal bonus damage equal to 2x your strength modifier as bonus fire damage.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
            },
            {
              comboTags: ['Fire','Power'],
              level: 3,
              name: `Fire and Steel`,
              type: `Finisher`,
              finisherType:"Boost",
              longDesc: `[fire-power-fire] You leap in a straight line a distance equal to your movement speed and stab your weapon into the ground creating a burning ring in a 10 foot radius around the area you land. Creatures within the ring (except you) take 1d4 points of fire damage per 5 <fire/power> mastery. Afterwards, the ring of fire lingers, and while within it's area, you and your allies attacks made with a two-handed weapon or a weapon wielded in two hands deal an additional 1 point of fire damage, plus 1 per 5 fire mastery.`,
              initiationAction: `movement`,
              range: `10 foot radius`,
              duration: `3 rounds`,
              target: `allies`,
            },
            {
              comboTags: ['Power','Death'],
              level: 5,
              name: `True Disarm`,
              type: `Finisher`,
              finisherType:"Strike",
              longDesc: `[power-death-death-death-power] Make a CMB attempt with your weapon as if making a disarm, but with a -10 penalty. If it hits, it deals no damage, but the target makes a fortitude save with a penalty equal to 1 per 10 <death/power>. If they fail, you remove one of their limbs of your choice. This also deals 4 constitution drain.`,
              initiationAction: `standard`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
            },
            {
              comboTags: ['Technique',"Dark"],
              level: 1,
              name: `Tenebris Aeternus`,
              type: `Finisher`,
              finisherType:"Strike",
              longDesc: `[technique-dark-technique] Make a melee attack against a creature. If it hits, it deals an additional 1d6 points of negative energy damage per 10 <dark> mastery. One time within 1 round, if the struck enemy attacks you, you can initiate a counter without using your immediate action. For 1 round after initiating this finisher as long as your initial attack hits, when you initiate a counter that causes a creature's attack to miss or deal no damage and you threaten them, you can expend a use of an attack of opportunity to make an immediate melee attack against them (doesn't count as an AoO). If it hits it deals an additional 1d4 per 5 <dark/technique> mastery negative energy damage. For every 30 <technique> mastery you can initiate another counter without expending your immediate action that round.`,
              initiationAction: `movement`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
            },
            {
              comboTags: ['Technique',"Death"],
              level: 1,
              name: `Tenebris Rising`,
              type: `Finisher`,
              finisherType:"Strike",
              longDesc: `[technique-death-death-technique] Make a melee attack with a -5 penalty (or 0 if initiated as swift), it gains a +1 bonus to the attack roll per 10 <death> mastery. If it hits and deals damage, for 1 round you gain a +1 bonus on all attack rolls per 20 <death> mastery, and a +1 on damage rolls for every 5 <technique> mastery.`,
              initiationAction: `free or swift`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
            },
            {
              comboTags: ['Technique',"Curse"],
              level: 3,
              name: `Cursed Technique: Ten Strokes`,
              type: `Finisher`,
              finisherType:"Strike",
              longDesc: `[technique-curse-curse-technique] You create a weakpoint on the creature. All attacks you make against the creature cannot critically hit the normal way, instead your successful attack against them has 1/7 chance to be an automatic critical hit. Each time you make a successful attack and it doesn't critically hit, the chance improves by 1/7 (2/7 -> 3/7 -> 4/7, etc.). A critical caused by this ability gains a flat +1 to its critical damage multiplier and bypasses critical hit immunity and resistance. Once this ability grants a critical hit, the ability ends. For every 50 <technique/curse> mastery, the critical damage multiplier increases by a flat +1.`,
              initiationAction: `free`,
              range: `30 feet`,
              duration: `24 hours or until discharged`,
              target: `1 enemy`,
            },
            {
              comboTags: ['Flurry',"Death"],
              level: 5,
              name: `Deep Crimson`,
              type: `Finisher`,
              finisherType:"Strike",
              longDesc: `[flurry-death-flurry] You make a devastating charge in a straight line, dashing through enemies and delivering two deadly blows as you move. The distance you move is equal to your movement speed plus 5 feet per 15 <flurry> mastery. You can move any direction with this movement, even straight up, and it doesn't provoke attacks of opportunity, even for entering a creature's space. In order to move through a creature's space you make an acrobatics or CMB check, your choice. For whichever you choose you gain a +1 bonus per 5 <flurry/death> mastery. For every creature's space you successfully move through, make a melee attack with two wielded weapons against them at your highest bonus, and for which the creature is flat-footed against, each also deals an additional 1d6 damage per 10 <death/flurry> mastery. If you enter a creatures space and dont have enough movement to move through them, or if you fail the check to move through their space, you end your movement in the last square you moved through, but you can still make your two attacks against them, however they are no longer against the creatures flat-footed armor class, nor do they deal bonus damage.`,
              initiationAction: `movement`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `enemies`,
            },
            {
              comboTags: ['Fire',"Air"],
              level: 3,
              name: `Pyronado`,
              type: `Finisher`,
              finisherType:"Boost",
              longDesc: `[fire-air-air-fire] You create a 5ft swirling pyronado that follows and rotates around you. When you first initiate this finisher it deals its damage to all creatures adjacent to you, then you choose one adjacent square for it to finish its movement in. Then, at the start of each of your turns it rotates 3 squares clockwise around you. Any creature who comes into contact with it takes 1d6 points of fire damage per 5 <fire/air> mastery. Creatures can make a reflex save to halve the damage. For every 15 <air> mastery it rotates an additional square. For every 30 <fire/air> mastery it lasts an additional round.`,
              initiationAction: `movement`,
              range: `melee attack`,
              duration: `3 rounds`,
              target: `creatures`,
            },
            {
              comboTags: ["Earth",'Air'],
              level: 3,
              name: `Rocknado`,
              type: `Finisher`,
              finisherType:"Boost",
              longDesc: `[earth-air-air-earth] You create a 5ft swirling rocknado that follows and rotates around you. When you first initiate this finisher it deals its damage to all creatures adjacent to you, then you choose one adjacent square for it to finish its movement in. Then, at the start of each of your turns it rotates 3 squares clockwise around you. Any creature who comes into contact with it takes 1d6 points of bludgeoning/slashing damage per 5 <earth/air> mastery. Creatures can make a reflex save to halve the damage. For every 15 <air> mastery it rotates an additional square. For every 30 <earth/air> mastery it lasts an additional round.`,
              initiationAction: `movement`,
              range: `melee attack`,
              duration: `3 rounds`,
              target: `creatures`,
            },
            {
              comboTags: ["Water",'Death'],
              level: 5,
              name: `Hyōmei no Shō`,
              type: `Finisher`,
              finisherType:"Boost",
              longDesc: `[death-water-water-death] You can only use this finisher on a creature who is currently flat-footed on attacks against you. Make a touch attack, if it succeeds the creature must make a will save or become paralyzed until the end of your turn. The DC of this maneuver increases by +1 per 15 <water/death> mastery.`,
              initiationAction: `swift`,
              range: `melee attack`,
              duration: `1 turn`,
              target: `1 enemy`,
            },
            {
              comboTags: ["Dark",'Air'],
              level: 5,
              name: `Midnight Phantasmogoria`,
              type: `Finisher`,
              finisherType:"Boost",
              longDesc: `[dark-air-dark] You swirl into a dark mist, moving up to twice your movement speed. Any enemy within 10 feet of you for this movement immediately takes 1d4 points of electricity damage per 5 <air> mastery and 1d4 points of negative energy damage per 5 <dark> mastery, reflex halves, and they suffer a -2 penalty to all d20 rolls for 1 round. Your next attack within this turn causes a creature struck to make a will save or be frightened for 1 round. This bypasses immunity to fear and mind-affecting effects.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
            },
            {
              comboTags: ["Sakura",'Earth'],
              level: 1,
              name: `Rock Wall`,
              type: `Finisher`,
              finisherType:"Boost",
              longDesc: `[sakura-earth-sakura] Make an attack roll with a melee weapon, your armor class against attacks you aren't flat-footed against becomes this attack roll for 1 round. For every 30 <sakura/earth> mastery the duration increases by 1 round. This ends if your weapon is no longer wielded. You move at half speed while this finisher is active.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
            },
            {
              comboTags: ['Royal','Heroic'],
              level: 7,
              name: `Stance of Assured Victory`,
              type: `Finisher`,
              finisherType:"Stance",
              longDesc: `[royal-heroic-royal-heroic-royal] You can adopt this stance in place of your previous one. On the turn it ends, you can re-adopt whichever stance you left when activating this finisher as a free action. You let out a battlecry, spurring yourself and allies within 30 feet of you towards assured victory. All allies within 30 feet of you gain a circumstance bonus on attack rolls equal to your highest initiation modifier. In addition, whenever an opponent within 30 feet of you attacks an ally, they provoke an attack of opportunity from any ally other than the target who is also within 30 feet of you. This attack of opportunity can be made even if the opponent is not within that ally's melee reach. An attack can only provoke one such attack of opportunity in this way.`,
              initiationAction: `swift`,
              range: `Personal`,
              target: `You`,
              duration: `3 rounds`
            },
              {
              comboTags: ['Earth','Guardian','Light','Heroic',],
              level: 1,
              name: "Blessing of Iron",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[earth-{multi}-earth] To initiate this maneuver, {multi} must include either <heroic> or <guardian>. When initiated, you gain DR adamantine of 1 per 5 <earth> mastery for 3 rounds. This DR stacks with other DR, but is reduced by half.
              \nIf it includes two of <guardian>, <heroic>, or <light>, it instead blesses you and all allies within 30 feet of you, granting the DR to you all. The DR granted to your allies does not stack with other DR. 
              \nIf it possess all 3, the DR to allies now stacks with other DR and the duration becomes 6 rounds.`,
              initiationAction: `free`,
              range: `see text;`,
              duration: `3 rounds`,
              target: `see text;`,
              },
              {
              comboTags: ['Heroic','Guardian',],
              level: 1,
              name: "Inspired Durability",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[heroic-guardian-guardian-heroic] The next time within 1 round that you use an ability that grants you temporary hit points, those temporary hit points are also granted to all of your other allies within 30 feet of you. This lasts a maximum of 3 rounds, or the duration of the ability that gave you temporary hit points, whichever is shorter. The temporary hit points you gain from the maneuver yourself is increased by 1% per 2 <heroic> mastery (this increased amount is not given to allies). 
              \nYou can initiate this Finisher with [heroic-guardian-guardian] combo if the maneuver you are about to use that is granting temporary hit points is a <heroic> maneuver. If this is combined with an ability that was already granting allies temporary hit points, they gain the higher of the amount you gained or what they were going to gain, not both.`,
              initiationAction: `free`,
              range: `30 feet`,
              duration: `see text;`,
              target: `allies`,
              },
              {
              comboTags: ['Heroic'],
              level: 1,
              name: "Passion Overload",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[heroic-heroic-heroic-heroic] You utilize your stream of powerful emotions to bolster yourself to an even greater extent. Gain 1d8, plus 1d8 per 10 <heroic> mastery temporary hit points. These temporary hit points are lost first, even before other temporary hit points, but as long as these last, you increase the bonuses you gain from morale bonuses by +1.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `1 minute`,
              target: `you`,
              },
              {
                comboTags: ['Heroic'],
                level: 1,
                name: "I'm Still Standing",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[heroic-heroic-heroic-heroic] Gain temporary hit points equal to your <heroic> mastery for 3 rounds.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ['Heroic',"Primal"],
                level: 1,
                name: "Steeled Will",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[heroic-primal-heroic] Whenever you take damage that fails to penetrate your temporary hit points, DR, resistances, or protections, you may make an immediate opposing d20 roll against the creature as a free action (even if not your turn), both of you adding your will saves to the roll. If your roll is higher than theirs, they suffer 1 stack of crushed will. They suffer a -1 penalty on attacks, saves, damage rolls, ability checks, and skill checks for every stack of crushed will. 1 stack of crushed will is removed at the start of each of their turns. [mind-affecting]`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Heroic"],
                level: 1,
                name: "Rise Above",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[heroic-heroic-heroic-heroic-heroic] Gain temporary hit points equal to your current temporary hit points, max 2x <heroic> mastery. Further uses of this finisher do not stack, and do not count temporary hit points gained from this finisher for how many temporary hit points you gain. These temporary hit points last 3 rounds.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ['Heroic',"Air"],
                level: 1,
                name: "Guardian Spirit",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[heroic-air-heroic] Move up to your movement speed, and then if an ally provokes an attack of opportunity within 1 round while within your threatened area, the attack of opportunity is directed at you (even if the attack couldn't normally reach you, you do not gain concealment or cover based on position if the ally wouldn't), for which you suffer a -4 penalty to your armor class. During this round, you gain temporary hit points equal to your <heroic/air> mastery, but these temporary hit points only apply when intercepting these attacks of opportunity.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },
              {
                comboTags: ['Heroic',"Air"],
                level: 1,
                name: "Wings of Valor",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[heroic-air-air-heroic] For every 10 feet that you move this round (teleportation doesn't count) you gain 1d6 temporary hit points that last 3 rounds. If you move because of a maneuver, you gain 1d8 temporary hit points for every 10 feet moved. This stacks with itself, however moving through a square you have already moved through this round doesn't add to this.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },
              {
              comboTags: ['Flurry',],
              level: 1,
              name: "Unleashed Flurry",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[flurry-flurry-flurry] Every time you take a full attack action while two-weapon fighting you can take an additional attack with both your primary and off-hands, both at your lowest attack with that hand at -5. When you do, all attacks you take in a round are at a -2 penalty. This finisher lasts 3 rounds. For every 20 <flurry> mastery, you gain a +1 bonus on full attacks with two weapons during the duration.`,
              initiationAction: `swift`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              },
              {
              comboTags: ['Flurry','Primal',],
              level: 3,
              name: "Dragon God's War Dance",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[flurry-primal-flurry] Whenever you are taking a full attack action you can move half your movement speed before or after the full-round attack. For every 15 <flurry> mastery, every attack you take while two-weapon fighting deals an additional 1d6 damage.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              },
              {
              comboTags: ['Light','Dark','Fire',],
              level: 3,
              name: "Phoenix Wing Strike",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[light/dark-fire-light/dark] You create a 30-foot cone of mystical fire and divine energy that deals 1d6 points of damage per level to any enemy caught within the area, though they can make a reflex save to halve it. Half of this damage is fire damage, and the other half is dependant on what type of <light/dark> maneuvers you used to initiate this combo. 
              \nIf you used <light> manuevers, half of the damage is sacred damage and allies within the area are healed for the half of its damage. 
              \nIf you used <dark>, then half of its damage is profane damage and enemies within the area that fail their reflex saving throw are blinded for 1 round. 
              \nIf you used one of each, then this maneuver deals an additional 1d6 points of damage per 2 levels, but all of it is fire damage.`,
              initiationAction: `swift`,
              range: `30 foot cone`,
              duration: `instantaneous`,
              target: `all creatures`,
              },
              {
              comboTags: ['Light','Fire',],
              level: 1,
              name: "Cleansing Flames",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[light-fire-light] You allow an ally within 60 feet to attempt another saving throw against an ongoing condition affecting them. The DC for this saving throw is the same as the original effect that caused the condition, and a successful save ends the condition. This ability cannot be used to end conditions that allowed no saving throw. For every 10 <light> mastery they gain a +1 bonus on their saving throw.`,
              initiationAction: `free`,
              range: `60 feet`,
              duration: `instantaneous`,
              target: `1 ally`,
              },
              {
              comboTags: ['Light','Void'],
              level: 1,
              name: "Eyes of Heaven",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[light-void-light] For 1 round, you gain truesight 30 feet, your attacks deal an additional 1d6 sacred damage, and with each hit you heal 1d6 hit points. Every 20 <light> mastery both the bonus damage and the healing increase by 1d6. For every 30 <void> mastery the duration increases by 1 round.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              },
              {
              comboTags: ['Shadow','Dark'],
              level: 1,
              name: "Shadow Blades",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[shadow-dark-shadow] For 3 rounds all of your weapon attacks deal additional cold damage equal to your highest mental modifier +1 per 10 <dark> mastery. Additionally, if you possess the sneak attack ability; all of your sneak attack damage is converted to cold damage. Whenever you deal sneak attack damage the creature takes -1 penalty to its dexterity score. This stacks, but ends 1 round after this finisher does.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              },
              {
              comboTags: ['Shadow','Technique'],
              level: 1,
              name: "Blade of Knight",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[shadow-technique-shadow] Make a melee attack with a -5 penalty, the creature is always flat-footed for this attack regardless of its normal immunity to being flat-footed. This attack deals 1d6 additional sneak attack damage for every 10 <shadow> mastery. If the attack is successful, you gain 1 counterpoint, +1 per 10 <technique> mastery. These counterpoints can only be used on <technique> and <shadow> counters. If all 3 of the combo points used to initiate this finisher were gained on the same round, its initiation action becomes a free action.`,
              initiationAction: `swift`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 creature`,
              },
              {
              comboTags: ['Shadow','Void',],
              level: 6,
              name: "Shadow Form",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[shadow-void-shadow] You wrap yourself in a shroud of shadows. All attacks against you have a 20% miss chance (stacks with concealment but not full concealment), deal 25% less damage to you, and any targeted spell or ability that doesn't deal damage has a 50% chance to miss you. Light damage deals double damage to you instead of 50% and has no miss chance against you. Creatures with blindsight can penetrate the miss chance, but the attacks still deal less damage.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              },
              {
              comboTags: ['Void','Arcane',],
              level: 1,
              name: "Open Inner Eye",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[void-arcane-void] You open your inner eye, granting you additional insight into all you do. For 3 rounds, you gain a +1 insight bonus on attack rolls, damage rolls, to your AC, skill checks, and saves, and all attacks deal an additional 1d6 points of precision damage. Every 40 <void> mastery all of these effects increase by one increment. At level 10 when you miss due to concealment, you can reroll it, taking the new result. `,
              initiationAction: `free`,
              range: `personal`,
              duration: `2 rounds`,
              target: `you`,
              },
              {
              comboTags: ['Arcane','Royal'],
              level: 1,
              name: "Noble Defense",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[arcane-royal-arcane] As a free action you can cast a single spell with the range of personal on yourself. If the spell would normally target multiple creatures or affect an area, it now only effects you. Spells cast this way ignore somatic components, do not provoke attacks of opportuntity, and dont require a free hand to cast.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              },
              {
              comboTags: ['Arcane','Void',],
              level: 1,
              name: "Magic Rending Strike",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[arcane-void-arcane] Make an attack against a creature with a -5 penalty (or none if initiated with swift), if successful, it deals damage as normal, plus you can make a dispel magic check against the creature or their weapon, as if casting the dispel magic spell. If the creature or their weapon has no dispellable effects, this attack does no damage.`,
              initiationAction: `free or swift`,
              range: `60 feet`,
              duration: `instantaneous`,
              target: `1 creature`,
              },
              {
              comboTags: ['Royal','Arcane','Guardian',],
              level: 3,
              name: "Mage Harrier",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[royal-arcane,guardian-royal] Make a melee attack, if it hits, it deals damage as normal and the creature loses the ability to defensively cast spells for 1 round. The creature does not know about this, and if it attempts to cast a spell they do not know until it provokes attacks of opportunity.`,
              initiationAction: `movement`,
              range: `melee attack`,
              duration: `1d4 rounds`,
              target: `1 creature`,
              },
              {
              comboTags: ['Arcane','Guardian',],
              level: 3,
              name: "Mageknight's Delivery",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[arcane-guardian-arcane] You can cast a single spell on an ally within your melee weapon's reach. This finisher can only be used to cast spells on allies, not yourself, and not enemies. The spell has its range reduced to your reach, even if it normally had a greater range, and even if the spell would normally target multiple creatures or affect an area, it now only effects them. Spells cast this way ignore somatic components, do not provoke attacks of opportuntity, and dont require a free hand to cast.`,
              initiationAction: `swift`,
              range: `reach`,
              duration: `instantaneous`,
              target: `1 ally`,
              },
              {
              comboTags: ['Curse','Earth',],
              level: 1,
              name: "Gravity of Iron",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[curse-earth-curse] [curse] Choose a creature currently cursed by you and is either wearing metal armor, or made primarly out of metal, they must make an immediate fortitude save or become paralyzed and fall prone. This curse persists, and at the start of each of their turns they must make an additional fortitude save or become paralyzed and fall prone for 1 round again. This curse ends when the creature makes 2 saves in a row. As long as this curse persists, you deal 1d6 points of acid damage to them with every attack. Every 20 <curse/earth> mastery the additional damage increases by 1d6.`,
              initiationAction: `free`,
              range: `-`,
              duration: `initiation modifier rounds`,
              target: `1 enemy`,
              },
              {
              comboTags: ['Curse','Water',],
              level: 1,
              name: "Drowning Curse",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[curse-water-curse] [curse] Choose a creature currently cursed by you and that needs to breathe. They instantly become nauseated and are unable to speak or use verbal components. At the start of each of its turns for the duration, it makes a fortitude save to ignore these penalties for 1 round. If it makes 3 saving throws in a row, this curse ends. As long as the curse persists, all of your attacks against them deal 1d6 points of cold damage. Every 15 <curse/water> mastery the additional damage increases by 1d6.`,
              initiationAction: `free`,
              range: `-`,
              duration: `initiation modifier rounds`,
              target: `1 enemy`,
              },
              {
              comboTags: ['Earth','Heroic',],
              level: 1,
              name: "Stoneheart",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[earth-heroic-earth] You gain 25% plus 1/4 <earth> mastery fortification that stacks with other fortification.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              },
              {
              comboTags: ['Arcane','Light',],
              level: 1,
              name: "Incandescent Array",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[arcane-light,(guardian)-arcane] You surround the area in an array of swirling and confusing lights. Attacks against allies within 30 feet of you suffer a 25% + <light> mastery miss chance for 3 rounds. Every 25 <arcane> mastery this lasts an additional round. Enemies that don't rely on sight do not suffer from this. Additionally, the area shines as if daylight, potentially dispelling darkness spells. If you do not include the <guardian> point this combo only effect you.`,
              initiationAction: `swift`,
              range: `30 feet`,
              duration: `3 rounds`,
              target: `allies`,
              },
              {
              comboTags: ['Arcane','Shadow',],
              level: 1,
              name: "Shadowmeld",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[arcane-shadow,(guardian)-arcane] You wrap all allies within 30 feet of you in shadows. Affected allies gain the benefits of partial concealment for 3 rounds. Every 25 <arcane> mastery this lasts an additional round. If the ally is benefiting from any other percentage miss chance, this stacks with it, but is halved. If you do not include the <guardian> point this combo only effect you.`,
              initiationAction: `swift`,
              range: `30 feet`,
              duration: `3 rounds`,
              target: `allies`,
              },
              {
              comboTags: ['Royal','Shadow',],
              level: 1,
              name: "Blinding Slash",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[royal-shadow-royal] Make an attack with a slashing weapon with a -8 penalty (or -4 if initiated with swift). If it hits, it deals damage as normal but also blinds the creature for 1 round. For every 20 <royal/shadow> mastery the duration increases by 1 round.`,
              initiationAction: `free or swift`,
              range: `melee attack`,
              duration: `1rd + 1rd/20 <shadow>`,
              target: `1 enemy`,
              },
              {
              comboTags: ['Death','Curse',],
              level: 1,
              name: "Dead Steel",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[death-curse-death] You empower your attacks, causing all of them to do an additional 1d6 points of negative energy damage with each successful hit and causing the target to become cursed for 1 round. This cursed duration stacks. For every 20 <death/curse> mastery the damage increases by 1d6.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              },
              {
              comboTags: ['Curse','Death'],
              level: 1,
              name: "Omen of Ruin",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[curse-death-curse] [curse] Choose a creature currently cursed by you. For 3 rounds every time the creature takes damage it takes 1d4 additional points of negative energy damage. If a creature rolls a potential critical hit against it, it gains a +4 bonus to confirm the critical hit. For every 30 <curse/death> mastery the damage increases by 1d4.`,
              initiationAction: `movement`,
              range: `-`,
              duration: `3 rounds`,
              target: `1 enemy`,
              },
              {
              comboTags: ['Earth','Arcane','Guardian','Heroic','Light',],
              level: 1,
              name: "Blessing of Stone",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[earth-arcane,{multi}-earth] This finisher does not need to include something in the multi tag. When initiated, you gain a +2 bonus to your natural armor for 3 rounds. This stacks with any other natural armor bonus. For every 20 <earth> mastery the natural armor bonus increases by +1. 
              \nIf multi includes one of <guardian>, <light>, or <heroic>, the blessing is also bestowed to all allies within 30 feet of you, however the bonus they receive is an enhancement bonus.
              \nIf it posses 2 of the optional tags, the bonus becomes untyped and lasts 5 rounds instead.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              },
              {
              comboTags: ['Air','Arcane','Heroic',],
              level: 3,
              name: "Wind Speed",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[air-arcane-air] When initiated with this combo, you gain the benefits of the haste spell for 3 rounds.
              \n[air-arcane-heroic/light-arcane-air] When initiated with this combo, the blessing is instead granted to you and all allies within 30 feet.`,
              initiationAction: `free`,
              range: `see text;`,
              duration: `3 rounds`,
              target: `see text;`,
              },
              {
              comboTags: ['Arcane','Shadow',],
              level: 1,
              name: "Illusionary State",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[arcane-shadow-arcane] Gain 1d4+1 illusionary doubles as if using the mirror images spell. For every 10 <arcane/shadow> mastery the mirror images increase by 1.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              },
              {
              comboTags: ['Shadow','Arcane'],
              level: 1,
              name: "Arcane Shadow",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[shadow-arcane-shadow] You gain invisibility for 3 rounds. If you have at least 50 <shadow> mastery you instead gain greater invisibility. For every 15 <arcane> mastery the duration increases by round.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              },
              {
              comboTags: ['Royal','Death',],
              level: 5,
              name: "Royal Execution",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[royal-royal-death-death] Make a melee attack, if it hits, instead of dealing normal damage it deals damage equal to the amount of hit points the creature is missing. Creatures immune to death effects take half damage.`,
              initiationAction: `standard`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              },
              {
              comboTags: ['Royal','Void',],
              level: 3,
              name: "Return to the Void",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[royal-void-royal] For attacks equal to your highest mental modifier, you roll twice and take the higher result. For every 15 <void> mastery this lasts additional attacks equal to your highest mental modifier.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              },
              {
              comboTags: ['Shadow','Technique',],
              level: 3,
              name: "Sudden Technique",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[shadow-technique-technique-shadow] When you initiate this finisher you can initiate any strike that has an initiation action of a standard action or less as a part of the action. The target of the attack is flat-footed for it. You are staggered for 1 round after using this finisher (unresistable or removable).`,
              initiationAction: `immediate`,
              range: `see text;`,
              duration: `instantaneous`,
              target: `see text;`,
              },
              {
              comboTags: ['Primal','Royal',],
              level: 5,
              name: "Royal Dragon Stance",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[primal-royal-primal] For the duration of this finisher, every time a creature that you threaten strikes you, it provokes an attack of opportunity from you. For every 15 <royal> mastery you gain an additional attack of opportunity during your turn. For every 20 <primal> mastery your attacks of opportunity deal an additional 1d6 damage.`,
              initiationAction: `swift`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              },
              {
                comboTags: ['Royal',],
                level: 1,
                name: "Royal Fencer",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[royal-royal-royal] You gain Royal Fencer points equal to either your dexterity modifier or initiation modifier (whichever is higher). You can expend one of these points to take an attack of opportunity if a creature provokes one, but you are out of attacks of opportunity this round. Alternatively, if you are making an attack of opportunity not gained from expending a Royal Fencing Point, you can expend a Royal Fencing point to take an additional attack against the target of the attack of opportunity at a -5 penalty. Doing this is a free action you can take even when not your turn and does not count as an attack of opportunity for other bonuses or abilities. For every 10 <royal> mastery your attacks gained by using Royal Fencing points deal an additional 1d4 damage. Additional uses of this resets your total Royal Fencer points.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `24 hours`,
                target: `you`,
              },
              {
                comboTags: ['Royal',],
                level: 1,
                name: "Legendary Bladework",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[royal-royal] You can only initiate this finisher when initiating a <royal/technique> strike that is allowing you to make an attack with a melee weapon, and must do so before the attack roll for the strike is made. If the strike hits, you can make an additional with the weapon attack at a -8 penalty. This attack gains none of the bonuses the strike, except those that apply to all attacks in a round. This finisher recovers every time you score a critical hit with a piercing or slashing weapon.`,
                initiationAction: `free`,
                range: `melee attack`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
              comboTags: ['Technique','Shadow',],
              level: 1,
              name: "Skitter",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[technique-shadow-technique] Gain a 1d6 dodge bonus to your armor class. This finisher lasts until expended (max 24 hours). Whenever a creature misses you with a melee attack by less than the bonus this granted to your armor class, the bonus it granted is reduced by 1, it provokes an attack of opportunity from you, and you gain 2 counterpoints. You gain additional attacks of opportunity when you activate skitter equal to the dodge bonus you rolled, however they do not recover each round, instead once used they are expended (or the benefits of this finisher are expended). For every 20 <shadow/technique> mastery the dodge bonus increases by 1 dice step.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `see text;`,
              target: `you`,
              },
              {
              comboTags: ['Technique','Primal','Flurry',],
              level: 1,
              name: "Desire for Violence",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[technique-primal/flurry-technique] Recover 2 strikes and a random maneuver. If the random maneuver was also a strike, your next attack this round gains a bonus on the attack roll equal to the level of the maneuver (the chosen maneuvers are recovered first before the random one). The turn you activate this, all of your attacks deal an additional 1d4 points of damage, plus 1d4 per 25 <technique/primal/flurry> mastery.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              },
              {
              comboTags: ['Technique','Royal','Guardian',],
              level: 1,
              name: "High Guardian",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[technique-royal/guardian-technique] Recover 2 counters and gain counterpoints equal to your highest level of counter known. You gain a +1 dodge bonus to armor class per 10 <guardian/technique> mastery for 1 round.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              },
              {
              comboTags: ['Technique','Heroic',],
              level: 1,
              name: "Giga Boosted",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[technique-heroic-technique] Recover 1 boost. When you initiate this finisher you gain 1 boosted point. You can use your boosted point during your turn to gain an additional swift action that turn. For every 25 <technique/heroic> mastery you gain an additional boosted point.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              },
              // {
              // comboTags: ['Primal','Technique','Royal'],
              // level: 1,
              // name: "Deadly Guard",
              // type: "Finisher",
              // finisherType: "Boost",
              // longDesc: `[primal-technique/royal-primal] Make a damage roll with a wielded weapon, the next time you take damage from a weapon attack you reduce the damage by the roll you made. If the damage of their attack would be reduced to 0 and you threaten the creature, the excess damage is dealt to the creature who struck you.`,
              // initiationAction: `free`,
              // range: `personal`,
              // duration: `24 hours`,
              // target: `you`,
              // },
              {
              comboTags: ['Technique','Guardian','Royal',],
              level: 1,
              name: "En Garde",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[technique-guardian/royal-technique] Gain 1 counterpoint, +1 per 5 <technique/guardian/royal> mastery. You suffer 1 desperation for every 3 counterpoints gained`,
              initiationAction: `free`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              },
              {
              comboTags: ['Guardian','Void',],
              level: 1,
              name: "Warp Space",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[guardian-void-guardian] Increase your reach by 5 feet for 3 rounds. For every 25 <void/guardian> mastery the reach increases by 5 feet. You also gain a +2 bonus on attacks of opportunity for the duration. For eternal guardian maneuvers that set your reach, this stacks with those.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              },
              {
              comboTags: ['Curse',],
              level: 1,
              name: "Cursed Technique: Unending Curses",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[curse-{multi}-curse] [cursed] {multi} can only be curse combo points. Choose a creature, they must make a will save or become cursed and take a -2 penalty on all d20 rolls for 2 rounds. If the creature was already cursed by you, they are not allowed a save. For every 20 <curse> mastery the penalty increases by -1. For every additional <curse> combo point you include in {multi} past the first, you can increase the duration by 1 round or the penalty by -1, your choice.`,
              initiationAction: `free`,
              range: `-`,
              duration: `2 rounds`,
              target: `1 enemy`,
              },
              {
              comboTags: ['Technique',],
              level: 1,
              name: "Styles, Styles, Styles",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[technique-{multi}-technique] All {multi} must be technique. As a part of initiating this finisher you enter into a new martial stance that stacks with your previous martial stance, allowing you to maintain both at once. For every additional <technique> combo point you use past the first, you can increase duration by 1 round. `,
              initiationAction: `swift`,
              range: `personal`,
              duration: `1d4 rounds`,
              target: `you`,
              },
              {
              comboTags: ['Guardian','Heroic','Light',],
              level: 1,
              name: "I am tired and out of names",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[guardian-{multi}-guardian] {Multi} must include either <light> or <heroic>. You or an ally within 30 feet gains a +3 bonus on all saves for 3 rounds. If it includes both <light> and <heroic>, it instead blesses you and all allies within 30 feet, but the bonus reduces by 2. If single target, for every 30 <light/heroic> mastery the bonus increases by +1. If AoE, the bonus instead increases by +1 every 50 <light/heroic> mastery.`,
              initiationAction: `free`,
              range: `see text;`,
              duration: `3 rounds`,
              target: `see text;`,
              },
              {
              comboTags: ['Void','Flurry',],
              level: 3,
              name: "Void Assault",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[void-flurry-void] When you initiate this finisher and every time during this round you make a melee attack, you can teleport 30 feet. If you attack the same target twice during this full-round attack, that attack and every subsequent attack treats the creature as if you were flanking them. All attacks deal an additional 1d6 points of force damage, plus 1d6 per 20 <void/flurry> mastery.`,
              initiationAction: `free`,
              range: `see text;`,
              duration: `1 round`,
              target: `you`,
              },
              {
              comboTags: ['Elemental',],
              level: 3,
              name: "Elemental Imbuement",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[{multi}] This finisher requires you have used at least a 3 element combo, but can be initiated with an up to 7 element combo. Your weapons are imbued by the elements, dealing 1d4 points of damage of every element included in the combo. If you used the same element multiple times, instead of dealing additional damage dice, the dice steps for that element increases by 2. If your elemental combo is at least 5, this lasts 2 rounds, if it is 7, it lasts 3 rounds.`,
              initiationAction: `swift`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              },
              {
                comboTags: ['Technique'],
                level: 3,
                name: "Strike of Legend",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[technique-{multi}-technique] {multi} can include 1 combo point, plus an additional combo point per 30 <technique> mastery. This combo point can be from any tag except <technique> as long as they are unique. Make an attack, it deals bonus damage equal to your combined mastery from all tags used in the {multi} mastery.`,
                initiationAction: `swift`,
                range: `melee attack`,
                duration: `instantaneous`,
                target: `melee or ranged attack`,
                },
              {
                comboTags: ['Water',"Curse"],
                level: 3,
                name: "Cold Feet",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[curse-water-water-curse] The next time this floor a creature enters combat, it cannot move from its current square for 1 round. If multiple creatures enter at once, choose randomly. Once your <curse/water> mastery reaches 30, it also has its speed reduced by half on the next round, plus 1 round per <30> more <curse/water> mastery.`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },
              {
              comboTags: ['Guardian','Heroic',],
              level: 3,
              name: "Iron Oath",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[heroic-guardian-guardian-heroic] All allies within 30 feet of you (you excluded) gain 1d6 plus 1d6 per 10 <heroic/guardian> mastery temporary hit points. If an ally has these temporary hit points reduced to 0 because of an attack made by an enemy you are threatening, that enemy provokes an attack of opportunity from you. If your attack defeats the creature or is a critical hit, the duration for this finisher refreshes and all allies within 30 feet of you gain 1d6 per 10 <heroic/guardian> mastery temporary hit points (lasts 3 rounds).`,
              initiationAction: `swift`,
              range: `30 feet`,
              duration: `3 rounds`,
              target: `allies`,
              },
              {
                comboTags: ['Guardian','Heroic',],
                level: 1,
                name: "No Dying!",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[heroic-guardian-guardian-heroic] Lose all of your temporary hit points, but your allies within 30 feet of you gain half of them. Their duration becomes 3 rounds, or less if those temporary hit points had a lower amount of time remaining.`,
                initiationAction: `free`,
                range: `30 feet`,
                duration: `3 rounds`,
                target: `allies`,
              },
              {
              comboTags: ['Heroic','Fire',],
              level: 7,
              name: "Set Your Heart Aflame",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[heroic-fire-fire-fire-heroic] You become immune to dying from hit point damage and don't fall unconcious when you are reduced below 0 hit points for 3 rounds. If at the end of its duration your hit points are at a point where you would die, you die as normal and cannot be revived for 6 rounds, however, all allies who saw you die, gain this effect for 2 rounds.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              },
              {
              comboTags: ['Fire','Sakura',],
              level: 3,
              name: "Unknowing Fire",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[sakura-fire-sakura] When you initiate this maneuver you move in a straight line up to 10 feet and attack a single creature. It deals an additional 1d6 points per 5 <fire> mastery. For every 10 sakura <mastery> you can move an additional 5 feet.`,
              initiationAction: `swift`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              },
              {
              comboTags: ['Fire','Sakura',],
              level: 3,
              name: "Blooming Flame Undulation",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[fire-sakura-fire] Make a melee attack with a -5 penalty against all enemies you threaten, if it hits, it deals damage as normal, plus 1d4 per 10 <fire> mastery. Then, for 1 round, your armor class against attacks made against you equals the result of the attack roll. This is bypassed if the creature has blindsight and you are flat-footed against the attack.`,
              initiationAction: `swift`,
              range: `melee attack`,
              duration: `1 round`,
              target: `threatened enemies`,
              },
              {
              comboTags: ['Water','Sakura',],
              level: 3,
              name: "Constant Flux",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[sakura-water-sakura] Move up to your movement speed, making a melee attack against all creatures you threaten during the movement. If an enemy takes an attack of opportunity against you for this movement, you can make an opposed attack roll against their, success negating their attack. For every attack you take during this finisher, your following attacks during it gain a +1 bonus to the attack and deals an additional 2d6 damage.`,
              initiationAction: `standard`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `threatened enemies`,
              },
              {
              comboTags: ['Shadow'],
              level: 1,
              name: "Special Rogue Technique",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[shadow-shadow-shadow] Move up to half your movement speed, this movement does not provoke. If at any point during your movement you were adjacent to treasure, you can pick it up as a free action (maximum 2).`,
              initiationAction: `free`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              },
              {
              comboTags: ['Shadow','Void',],
              level: 1,
              name: "All Belongs To Me",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[shadow-void-shadow] You can buy treasure within 30 feet. For every 5 <void> mastery you increase the range by 5 feet. For every 5 <shadow> mastery, you get a 2% discount on the item. This finisher only works during combat.`,
              initiationAction: `swift`,
              range: `30 feet`,
              duration: `instantaneous`,
              target: `treasure`,
              },
              {
                comboTags: ['Death','Air'],
                level: 1,
                name: "Dead Air",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[death-air-death] A creature is silenced for 1 round. It cannot make any sound or cast any spell that requires verbal components. The creature suffers a -2 penalty to its armor class and on all attack rolls.`,
                initiationAction: `free immediate action`,
                range: `30 feet`,
                target: `1 enemy`,
                duration: `1 round`,
              },
              {
                comboTags: ['Light'],
                level: 5,
                name: "Angel",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[light-light-light] An ally is instantly cured of any single status, condition, or effect. This cures anything, even things that aren't normally conditions. The exceptions are permanent or temporary negative levels, death, dying. You can initiate this finisher as long as you are conscious and can see the ally.`,
                initiationAction: `free immediate action`,
                range: `30 feet`,
                target: `1 ally`,
                duration: `instantaneous`,
              },
              {
                comboTags: ['Void','Guardian','Heroic'],
                level: 3,
                name: "Step Into Paradise",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[void-guardian/heroic-void] An ally is instantly teleported adjacent to you. They gain 1d4 temporary hit points per 5 <void/guardian/heroic> mastery that last 3 rounds.`,
                initiationAction: `free`,
                range: `50 feet`,
                target: `1 ally`,
                duration: `instantaneous`,
              },
              {
                comboTags: ['Guardian','Flurry'],
                level: 3,
                name: "Punish Trespassors",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[guardian-flurry-guardian] For 1 round, whenever you make an attack of opportunity you can make another attack with your off-hand weapon. For this round, you gain additional attacks of opportunity of +1 per 10 <flurry> mastery. For every 10 <guardian> mastery your attacks of opportunity this turn gain a +1 bonus on attack rolls, and deal an additional +2 damage.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `2 rounds`,
              },
              {
                comboTags: ['Void','Light','Earth','Air','Sakura'],
                level: 8,
                name: "Harmony Between Heaven and Earth",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[sakura-void,light,earth,air-sakura] Make a melee attack, applying the attack roll to all enemies within 30 feet of you, rolling twice and taking the higher result on the attack roll. This attack ignores all concealment and all cover, allowing you to attack through walls. This attack deals an additional 1d6 points of damage for every 10 <light/sakura> mastery, and 1d6 additional damage for every 10 <earth/air> mastery. Half of the damage dealt by this attack can be redistributed to allies within the range as healing (as you see fit). For every 20 <void> mastery the range increases by 5 feet, and for every 50 <void> you can roll the attack roll an additional time, taking the highest result. If your attack is a natural 20 following by a confirmed critical hit on all enemies in the area, you can immediately initiate this finisher again as a free action, and the range for initiating this again increases by 1 (19-20, then 18-20, etc.).`,
                initiationAction: `full-round`,
                range: `30 feet`,
                target: `creatures`,
                duration: `instantaneous`,
              },
              {
                comboTags: ['Void', 'Technique','Sakura'],
                level: 4,
                name: "That Which Cannot Be Seen",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[void-technique-sakura-void] During your turn, your reach increases by 15 feet and your melee attacks ignore cover, even total cover. This means you can attack through walls. For the duration, you can reroll miss chances due to concealment once, taking the favorable result. For every 20 <void> mastery the reach increases by 5 feet. For every 30 <technique/sakura> mastery, this lasts an additional round.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`,
              },
              {
                comboTags: ['Primal', 'Water'],
                level: 3,
                name: "Frostbite",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[primal-water-primal] Make an attack with a natural weapon with a -5 penalty (or none if initiated with a swift). If it hits, it deals an additional 1d4 points of cold damage per 5 <primal/water> mastery and the creature is unable to move from its square for 1 round.`,
                initiationAction: `free or swift`,
                range: `melee attack`,
                target: `1 enemy`,
                duration: `1 round`,
              },
              {
                comboTags: ['Shadow', 'Sakura','Void'],
                level: 5,
                name: "Second Eclipse, Phantom Moon: Nyx",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[shadow-sakura,sakura/void-shadow] Make 3 melee attacks against an enemy at your highest bonus -6. Each attack deals damage as normal, plus an additional 1d6 damage per 15 <shadow/sakura> mastery, however the creature takes none of the damage immediately, instead it is delayed for 4 rounds. If any of the attacks is a critical hit, the delay is reduced by 1 round. If all 3 are critical hits, the creature takes the damage immediately and you may initiate this finisher again immediately (Max 1 additional initiation)`,
                initiationAction: `swift`,
                range: `melee attack`,
                target: `1 enemy`,
                duration: `4 rounds`,
              },
              {
                comboTags: ['Guardian', 'Water'],
                level: 3,
                name: "Ice Wall",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[guardian-water-guardian] For 1 round, whenever a creature deals damage to an ally within your reach with a weapon attack, you can roll a damage roll as if you had just struck something with an attack of opportunity. Reduce the damage the ally takes by half that roll. Each usage of this expends an attack of opportunity, but you gain an additional attack of opportunity per 10 <guardian/water> mastery.`,
                initiationAction: `movement`,
                range: `reach`,
                target: `allies`,
                duration: `1 round`,
              },
              {
              comboTags: ['Royal','Water','Sakura',],
              level: 1,
              name: "Dead Calm",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[royal-sakura-water] For 1 round, every time a creature you can properly see makes a weapon attack against you, you can make an opposing attack roll against it, success causing their attack to miss. You gain a +1 bonus on your attacks for every size larger than you that the creature is.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              },
              {
                comboTags: ['Dark','Sakura'],
                level: 5,
                name: "Asura's Wrath",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[dark-sakura-sakura-dark] Gain regeneration 1 per 10 <dark> mastery. You do not fall unconscious when below 0 hit points, instead acting as if you were disabled. All positive energy healing you receive is reduced by 50% for the duration.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `2 rounds`,
                target: `you`,
              },              
              {
              comboTags: ['Earth'],
              level: 1,
              name: "Great Barrier",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[earth-earth-earth] You create a wall along one side of your reach. It is 5 feet thick of stone and is your height plus 5 feet tall. You can choose to exclude any squares you choose. You must be within reach of the ground to initiate this finisher.`,
              initiationAction: `swift`,
              range: `reach`,
              duration: `instantaneous`,
              target: ``,
              },
              {
              comboTags: ['Sakura','Primal','Flurry'],
              level: 1,
              name: "Sudden Fang",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[sakura-primal,(flurry)-sakura] You must initiate this finisher with a melee weapon. You throw your weapon in a surprising move, if your attack hits, it deals damage as normal, plus the creature becomes staggered until the start of your next turn. If you include <flurry> in this, you can throw two weapons at once, though both attacks must be at the same target. For every 10 <sakura> mastery the attack gains a +1 bonus to it. For every 10 <primal> mastery the attack gains a 1d6 bonus damage.`,
              initiationAction: `immediate`,
              range: `ranged attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              },
              {
              comboTags: ['Power','Sakura',],
              level: 1,
              name: "Explosive Rush",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[power-sakura-power] Make a charge attack against an enemy, movement made during this charge does not provoke attacks of opportunity. You can only make a single attack on this charge, regardless of how many attacks you can normally make. For every 10 <primal/sakura> mastery, your attack's damage increases by 1 dice step.`,
              initiationAction: `standard`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              },
              {
                comboTags: ['Death'],
                level: 1,
                name: "Blood is Fuel",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[death-death-death] All of your melee attacks heal you for a percentage of the damage dealt, 25% + 1% per 3 <death> mastery.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },
              {
                comboTags: ['Death'],
                level: 3,
                name: "Ultrakill",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[death-death-death-death] Make a melee attack, if it hits, it is an automatic potential critical hit. If this kills the creature, they erupt in a gory explosion, healing you for half the damage dealt by the attack and creating a 30 foot cone from you through the creature. All creatures in the area of the cone must make a reflex save or be blinded for 1 round.`,
                initiationAction: `swift`,
                range: `melee attack`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
              comboTags: ['Water','Power',],
              level: 1,
              name: "Rushing Tides",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[power-water-power] For 3 rounds you do not need to charge in a straight line when making charge attacks, and charge attacks deal an additional 1d6 points of bludgeoning damage. For every 15 <water/primal> mastery the damage increases by 1d6.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              },
              {
              comboTags: ['Sakura','Light',],
              level: 5,
              name: "Sun Breathing",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[light-sakura-sakura-light] Gain a +3 inherent bonus to all of your physical ability scores for 3 rounds. During this you also bypass the DR of undead and demons and deal an additional 1d6 points of sacred damage, plus 1d6 per 10 <sakura/light>. For every 30 <light/sakura> mastery the bonus to ability scores increases by +1, and for every 50 <light> the duration increases by 1 round.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              },
              {
              comboTags: ['Void','Shadow',],
              level: 1,
              name: "Above Combos",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[void-shadow-void] Gain any 2 finisher combo points of your choice.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              },
              {
              comboTags: ['Void','Shadow','Technique',],
              level: 5,
              name: "Perfect Visualization",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[void-shadow,techniqe-void] You can expend up to 3 maneuvers of your choice. You gain combos as if you had initiated all of those expended maneuvers. For each maneuver expended, you restore spell points equal to twice its level -6.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              },
              {
              comboTags: ['Heroic','Sakura',],
              level: 3,
              name: "Stand United",
              type: "Finisher",
              finisherType: "Counter",
              longDesc: `[heroic-sakura,guardian-heroic] You cannot initiate this finisher on your turn, or on yourself. When you initiate this maneuver, you target one ally on the same plane of existence as you. They immediately gain temporary hit points equal to a the same percentage of your maximum hit points, as the percentage of the hit points they are currently missing. These last 3 rounds. On your next turn after initating this finisher, you do not gain a standard action, and at the end of your turn, you teleport adjacent to your ally. For the duration of this finisher, the ally gains DR /- equal 1 per 5 <guardian> mastery. For every 5 <sakura> mastery the ally gains a +1 deflection bonus to their armor class for 1 round after initiating this finisher.`,
              initiationAction: `immediate`,
              range: `-`,
              duration: `3 rounds`,
              target: `1 ally`,
              },
              {
              comboTags: ['Arcane','Technique',],
              level: 1,
              name: "Spellblade",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[arcane-technique-arcane] When you initiate this finisher you cast a single touch spell with a casting time of a standard action or less and channel it through your weapon, making an attack which deals damage as normal, but also delivers the spell if it hits. The spell cast must match the type of weapon used to deliver it, ranged for ranged touch attacks, and melee attacks for melee touch attacks. A spell cast this way does not provoke attacks of opportunity and does not require a somatic components. If the spell has multiple attacks, your weapon remains imbued by the spell for attacks equal to however many attacks you can make during the spell, though this finisher only grants one. The spell's damage is also multiplied if the attack roll would be a critical hit, dealing damage equal to your weapon's critical damage multiplier. Any bonuses you have to weapon or spell critical hits apply to both the spell and the attack. Meaning increased spell critical damage will also increase the weapons damage on the critical hit.`,
              initiationAction: `swift`,
              range: `attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              },
              {
              comboTags: ['Royal','Sakura','Air',],
              level: 5,
              name: "Musou Shinsetsu",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[sakura-air-royal-air-sakura] When you initiate this finisher, make a melee touch attack that deals 1d6 points of electricity damage, plus 1d6 per 10 <air/sakura> mastery. While this is active, the first time each round that you damage any enemy, they takes an additional 1d4 points of electricty damage per 10 <air/sakura/royal>, and every time you score a critical hit with a weapon attack, you can choose to gain one <air> combo point.
              \nWhile this finisher is active, you gain a new finisher: 
              \nMusou Isshin: \nFree action \nStrike Finisher \n[air-air-air-air-air-air] Make a melee attack, it deals an additional 1d4 points of damage for every 5 <royal/air> mastery and has its critical damage multiplier increased by a flat +1. For this attack and for 1 round after, all of your attacks made with the weapon you used to initiate this finisher have their base damage converted to electricity damage. If the initiatal attack hits, the duration of Musou Shinsetsu is increased by 1 round. If it is a critical hit, the duration instead increases by 2 rounds.`,
              initiationAction: `movement`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              additionalTags:["Air"]
              },
              {
              comboTags: ['Technique','Flurry',],
              level: 3,
              name: "Cherry Blossom",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[technique-flurry-flurry-technique] As a full-round action you can initiate 2 strikes that have initiation actions of a standard action or less. During this round, you cannot initiate any boosts. On your turn after initiating this, you are staggered and fatigued. These conditions cannot be resisted or removed.`,
              initiationAction: `full-round`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              },
              {
              comboTags: ['Technique','Flurry',],
              level: 7,
              name: "Cherry Blossom Rapid Bloom",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[technique-flurry-technique-technique-flurry-technique] As a full-round action you can initiate 3 strikes that have initiation actions of a standard action or less. During this round, you cannot initiate any boosts. On your turn after initiating this, you are staggered and cannot make any attacks, and you are exhausted for 3 rounds. These conditions cannot be resisted or removed. If you were already exhausted or fatigued, you cannot initiate this finisher.`,
              initiationAction: `full-round`,
              range: `personal`,
              duration: `instantaneous`,
              target: `you`,
              },
              {
              comboTags: ['Heroic','Light',],
              level: 3,
              name: "Latirmo",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[heroic-light-heroic] Make a melee attack against an enemy, if it hits, all allies that are threatening the creature can make a melee attack against it. 
              \nYou can also initiate this finisher with [heroic-light-light-heroic] if you do and you hit, all allies who can make an attack against the creature, can, and even if you miss, all allies threatening the enemy can make a melee attack, though they suffer a -5 penlaty to their attack.`,
              initiationAction: `swift`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              },
              {
              comboTags: ['Dark','Air','Fire'],
              level: 3,
              name: "Dark Phoenix Dance",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[dark-air,fire-dark] You gain a fly speed equal to your land speed and emit an aura that provides bonuses to allies within 10 feet of you. All allies gain the benefits of the protection from good spell and a +2 profane bonus on attack rolls against good creatures.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              },
              {
                comboTags: ['Light','Air','Fire'],
                level: 3,
                name: "Rising Phoenix Dance",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[light-air,fire-light] You gain a fly speed equal to your land speed and emit an aura that provides bonuses to allies within 10 feet of you. All allies gain the benefits of the protection from evil spell and a +2 sacred bonus on attack rolls against evil creatures.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
                },
              {
              comboTags: ['Death','Dark',],
              level: 1,
              name: "Shadow Consumption",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[death-dark-death] You gain temporary hit points equal to your level * your initiation modifier. While this lasts, you heal from negative energy, reduce the healing you gain from positive energy by 50%, and no longer heal from natural healing.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              },
              {
              comboTags: ['Void','Royal',],
              level: 1,
              name: "Precognitive Defense",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[void-royal-void] The next time within the duration you initiate a counter, the counter does not become expended your immediate action. For every 50 <royal/void> mastery this lasts an additional counter.`,
              initiationAction: `swift`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              },
              {
              comboTags: ['Fire','Curse','Arcane',],
              level: 3,
              name: "Burning Dispel",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[fire,curse,arcane] Make a melee attack, if it hits, it deals damage as normal, but you can also make a dispel magic check as if making a dispel magic check with the dispel magic spell. For every level of the spell dispelled, the creature takes 1d6 points of untyped damage. `,
              initiationAction: `swift`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              },
              {
              comboTags: ['Arcane','Elemental',],
              level: 1,
              name: "Elemental Storm",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[arcane-elemental-arcane] You imbue the weapons of you and your allies within 30 feet, causing them to deal 1d6 points of damage of that element for 3 rounds. For every 15 arcane> mastery, the duration increases by 1 round. For every 20 <elemental> mastery of the element used to initiate this finisher, the damage increases by 1d6. `,
              initiationAction: `swift`,
              range: `30 feet`,
              duration: `3 rounds`,
              target: `allies`,
              },
              {
              comboTags: ['Guardian','Elemental',],
              level: 1,
              name: "Elemental Guardian",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[guardian-elemental,{multi}-guardian] You do not need to include something in the {multi} slot. When initiated, for 3 rounds you gain energy resistance 10 to the element that is opposing the element you used for your <elemental> combo points. This increases by 1 per <elemental> mastery of the same element used to initiate this finisher. This stacks with any other elemental resistance you have.
              \nIf you include either <light> or <arcane> in {multi}, this also affects all allies within 30 feet of you, but doesn't stack with any elemental resistances they have. If you include both, its duration increases to 6 rounds and does stack.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              },
              {
              comboTags: ['Heroic','Sakura','Fire',],
              level: 9,
              name: "Ninth Form: Absolution",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[heroic-sakura-fire-sakura-heroic] During this finisher's initiation round and the round you actually make the attack, you are immune to dying and any status or condition that would stop you from finishing its initiation. When you finish initiating this maneuver, you move up to twice your movement speed in a straight line, even straight up. All allies adjacent to you at any point in this movement heal 1d6 hit points for every 5 <fire> mastery, and all enemies take a like amount of fire damage. After you finish moving, you make a full attack against the target. During the round you make the attack, the target is immune to dying or being disabled. All attacks with this finisher deal additional 1d6 fire damage per 10 <fire/heroic> mastery. This maneuver ignores fire resistance, and creatures with immunity still take 50% of the fire damage. You can expend <sakura/heroic> strikes (at half sp cost) to make an additional attack, of 1 bonus attack for every 5 levels of <sakura/heroic> maneuvers expended. For every additional attack taken, all attacks in the round take a -1 penalty. After you make this attack, the opponent may make an immediate attack against you that if it hits, is an automatic critical threat. Alternatively they can cast a single spell against you that doesn't provoke.`,
              initiationAction: `1 round`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              },
              {
              comboTags: ['Air','Heroic','Light',],
              level: 1,
              name: "Protection of Air",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[air-{multi}-air] {multi} must be <light> or <heroic>. You gain the benefits of the evasion ability for 3 rounds.
              \nIf you use both <light> and <heroic> for this finisher, it also grants all allies within 30 feet the finisher's benefits.`,
              initiationAction: `free`,
              range: `see text;`,
              duration: `3 rounds`,
              target: `see text;`,
              },
              {
              comboTags: ['Water','Heroic','Light',],
              level: 1,
              name: "Protection of Water",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[water-{multi}-water] {multi} must be <light> or <heroic>. When making a will save, you can roll twice and take the higher of the two rolls.
              \nIf you use <light> and <heroic> to initiate this finisher, it instead grants its benefits to all allies within 30 feet.`,
              initiationAction: `free`,
              range: `see text;`,
              duration: `3 rounds`,
              target: `see text;`,
              },
              {
              comboTags: ['Earth','Heroic','Light',],
              level: 1,
              name: "Protection of Earth",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[earth-{multi}-earth] {multi} must be <light> or <heroic>. When making a fortitude save, if it would have a reduced effect on a successful save, you instead completely ignore it.
              \nIf you use <light> and <heroic> to initiate this finisher, it instead grants its benefits to all allies within 30 feet.`,
              initiationAction: `free`,
              range: `see text;`,
              duration: `3 rounds`,
              target: `see text;`,
              },
              {
              comboTags: ['Void','Water',],
              level: 3,
              name: "Shifting Tides",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[void-water-void] For the duration, every time a creature makes an attack against you, they must roll twice and take the lower result.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `2 rounds`,
              target: `you`,
              },
              {
              comboTags: ['Curse','Void',],
              level: 1,
              name: "Steal Purpose",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[curse-void-curse] When you initiate this finisher, choose either attacks or saves. For 1 round, every time the creature rolls the selected roll, it rolls twice taking the lower result.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `1 round`,
              target: `you`,
              },
              {
              comboTags: ['Curse','Dark','Void',],
              level: 1,
              name: "Cursed Death",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[curse,dark,void] Choose a creature, for 1 round, every attack against them allows the attacker to roll twice and take the higher result. Creatures rolling to confirm critical hits against the creature gain a +4 bonus, and confirmed critical hits deal additional damage equal to 1/4 your <curse/dark> mastery (after the damage is multiplied)`,
              initiationAction: `movement`,
              range: `30 feet`,
              duration: `1 round`,
              target: `1 enemy`,
              },
              {
              comboTags: ['Curse','Elemental',],
              level: 1,
              name: "Elemental Curse",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[curse-elemental-curse] Make a melee attack, if it hits, it deals damage as normal, but also the creature becomes cursed for 1 round, becoming vulnerable to the elemental tag used.`,
              initiationAction: `swift`,
              range: `melee attack`,
              duration: `1 round`,
              target: `1 enemy`,
              },
              {
              comboTags: ['Guardian','Dark',],
              level: 1,
              name: "Punishing with Hatred",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[guardian-dark-guardian] For 3 rounds, whenever you successfully hit with an attack of opportunity the creature becomes shaken and cursed for 1 round and takes an additional 1d6 points of negative energy damage. Additionally, after initiating this finisher you gain additional attacks of opportunity equal to your highest mental modifier. These additional attacks are not regained during each turn, instead being lost when expended. For every 15 <dark> mastery, the damage increases by 1d6 and the shaken lasts an additional round.`,
              initiationAction: `free`,
              range: `personal`,
              duration: `3 rounds`,
              target: `you`,
              },
              {
              comboTags: ["Royal","Death"],
              level: 7,
              name: "Royal Decree: Death",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[royal-royal-royal-royal-death] Make a single melee attack, for every 3 <royal> mastery the attack deals an additional 1d4 damage.`,
              initiationAction: `movement`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              },
              {
              comboTags: ['Royal',],
              level: 1,
              name: "Royal Lunge",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[royal-royal-royal] Move 10 feet in a straight line and make a single melee attack, your reach increases by 5 feet for this attack. This movement does not provoke. For every 10 <royal> mastery the distance you move increases by 5 feet.`,
              initiationAction: `movement`,
              range: `melee attack`,
              duration: `instantaneous`,
              target: `1 enemy`,
              },
              {
              comboTags: ['Void','Royal','Sakura',],
              level: 6,
              name: "Judgement Cut",
              type: "Finisher",
              finisherType: "Strike",
              longDesc: `[void-royal/sakura-royal/sakura-void] You make a full-round attack against all enemies within the area with melee weapons. All of these attacks are made as if you are in any square within the area that you desire when making them. You can change which square you are in between every attack. All attacks deal an additional 1d6 points of force damage per 10 <royal/void/sakura> mastery.`,
              initiationAction: `standard`,
              range: `30 feet`,
              duration: `instantaneous`,
              target: `enemies`,
              },
              {
                comboTags: ['Void'],
                level: 9,
                name: "⎯⎯⎯⎯⎯⎯⎯",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[void-void-void-void-void-void] Gain a full round of actions.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
              },
              {
              comboTags: ['Arcane','Royal',],
              level: 1,
              name: "Arcane Expemplar",
              type: "Finisher",
              finisherType: "Boost",
              longDesc: `[arcane-royal-arcane] You imbue all allies within the area with your lingering arcane power for 1 round. The next spell they cast within 1 round gains a +2 bonus on its caster level. This bypasses the usual level cap for the spell. For every 20 <arcane> mastery the caster level bonus increases by +1. They also receive a bonus on concentration checks of +1 per 5 <royal> mastery.`,
              initiationAction: `free`,
              range: `30 feet`,
              duration: `1 round`,
              target: `allies`,
              },
              {
                comboTags: ['Flurry'],
                level: 5,
                name: "Unleash the Frenzy",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[flurry-{multi}-flurry] {multi} must be all <flurry> combo points. You can initiate this finisher in one of two ways, as a swift action as part of making a full-round attack, or as a movement action. 
                \nIf initiated as a swift action while making a full-round attack, you can take additional attacks equal to the amount of flurry combo points used in place of the {multi}. These additional attacks are at the same bonuses as if making a full-round attack, eg: the first bonus attack is at your highest bonus, second attack at second highest bonus. You can two-weapon fight for these bonus attacks, gaining an off-hand attacks at the normal penalties each time you spend a combo point for the bonus attack. Your maximum bonus attacks is equal to the amount of attacks you make during a full-round attack. You must decide if you are using this finisher at the start of your full-round attack, and you take a -2 penalty on all attack rolls during the round you initiate this finisher. If at the end of your full-round attack you no longer want to initiate this finisher, you do not have to.
                \nIf initiated as a movement action, you instead gain attacks for every combo point used for this finisher, not just the combo points used in {multi}. This otherwise functions the same way as initiating it as a swift action.`,
                initiationAction: `see text;`,
                range: `melee or ranged attacks`,
                duration: `instantaneous`,
                target: `you`,
              },
              {
                comboTags: ['Earth','Guardian','Arcane'],
                level: 1,
                name: "Stone Guardian",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[earth-guardian-arcane] When you initiate this finisher, you cause a chunks of stone to swirl around you, defending you from oncoming attacks. While active you gain a +4 cover bonus to your armor class, and a +2 cover bonus to your reflex saves. For every 10 <earth/guardian> mastery the bonuses increase by +1.`,
                initiationAction: `free`,
                range: `you`,
                duration: `3 rounds`,
                target: `personal`,
              },
              {
                comboTags: ['Dark'],
                level: 3,
                name: "Perfect Hatred",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[dark-dark-dark-dark] As long as you know this finisher, every time you take damage from an enemy you gain 1 stack of hatred. When you initiate this finisher, you make a single attack, it deals bonus damage of 1 per stack. The amount of damage dealt per stack increases by 1 per 30 <dark> mastery. If your attack hits, the stacks are expended. If the target of the attack has scored a successful critical hit against you or reduced you below 0 hit points at some point, the bonus damage doubles.`,
                initiationAction: `swift`,
                range: `melee or ranged attack`,
                duration: `instantaneous`,
                target: `1 enemy`,
                stacksOne: 0,
                stacksOneName: 'Hatred Stacks',
              },
              {
                comboTags: ['Technique',"Heroic","Sakura"],
                level: 3,
                name: "Desiderata",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[technique-heroic-heroic-technique/sakura] While this finisher is readied and unexpended, every time an ally (other than you) initiates a finisher in combat, this gains 1 resolve stack per combo point used as a part of the finisher. If the combo point used was <heroic/technique>, the resolve is doubled. When you initiate this finisher, your resolve stacks are consumed and your next attack this round deals an additional 2% of damage per stack consumed.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
                stacksOne: 0,
                stacksOneName: 'Resolve',
              },
              {
                comboTags: ['Technique'],
                level: 9,
                name: "Ultima Concordia",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[technique-technique-technique-technique-technique-technique] Make an attack, if it hits, its deals additional damage equal to your total combined mastery in all combo tags.`,
                initiationAction: `standard`,
                range: `melee or ranged`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags: ['Light',"Death"],
                level: 1,
                name: "Soulpierce",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[light-death-light] Your attacks this round gain the benefits of the brilliant energy enchantment, except they still damage to undead, and against undead they have their critical threat range increased by a flat +1. For every 20 <light/death> mastery, the attacks also deal an additional 1d6 points of untyped damage that is doubled against undead.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },
              {
                school:"sterlingSovereignty",
                level: 3,
                name: "Last Stand",
                type: "Strike",
                longDesc: `<heroic> You can only initiate this strike when you have no counters available and this is your last available strike (except Sterling Tactics). Make an attack, if successful, it deals an additional 1d6 damage for the level of your highest <heroic> maneuvers known, you recover a single strike, counter, and boost, and you gain counterpoints equal to your highest level <technique> or <royal> maneuver. You take 4 desperation for initiating this strike.`,
                initiationAction: `standard`,
                range: `melee attack`,
                duration: `instantaneous`,
                target: `1 enemy`,
                additionalTags:["Heroic"],
              },
              {
                school:"sterlingSovereignty",
                level: 3,
                name: "Trust In My Blade",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[technique-technique-technique] Clear half of your desperation, minimum 2.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
              },
              {
                school:"indomitableWill",
                level: 2,
                name: "Bring It On!",
                type: "Boost",
                longDesc: `With a challenging roar, a demeaning look and stance, or perhaps a jovial grin, you give an opponent a clear opening to attack you. You can only initiate this on an enemy that is currently threatening you. They may take a single attack against you as a free action (even if not their turn), and if they hit you, you may make a will save to reduce the damage by the result of the roll. If this attack deals no damage against you, including if it only deals damage to your temporary hit points, that enemy is shaken, you gain a +2 morale bonus all attack rolls, saving throws, skill checks, and ability checks, and you may make a will save and gain temporary hit points equal to the result. These effects all last 1d6 rounds. If the attack does deal damage to you, you are instead suffer a -2 penalty to attacks, saves, skill checks, and ability checks, and you gain none of the benefits. If they choose not to attack you, for 1 round, they are shaken and you gain a +2 morale bonus to attacks and damage against them.`,
                initiationAction: `free`,
                range: `threatening enemy`,
                duration: `1d6 rounds`,
                target: `1 enemy`,
              },
              // {
              //   school:"indomitableWill",
              //   level: 2,
              //   name: "indom will finisher",
              //   type: "Finisher",
              //   longDesc: `[heroic-heroic-heroic] `,
              //   initiationAction: `free`,
              //   range: `threatening enemy`,
              //   duration: `1d6 rounds`,
              //   target: `1 enemy`,
              // },
              {
                school:"shadowAssassin",
                level: 2,
                name: "Backstab",
                type: "Strike",
                longDesc: `[Shadow Initiation] Make a melee attack against an enemy, if successful and they are full hit points, the attack gains your sneak attack damage, regardless of whether they are flat-footed. If they were flat-footed for the attack and at full-hit points, you instead deal double your sneak attack damage. If they are not at full-hit points but the attack does deal sneak attack damage, the attack deals an additional 2 point of sneak attack damage per sneak attack dice rolled.`,
                initiationAction: `standard`,
                range: `melee attack`,
                duration: `instantaneous`,
                target: `1 enemy`,
                additionalInfoTags: ['Shadow Initiation'],
              },
              {
                comboTags:['Primal',"Dark"],
                level: 2,
                name: "Bloodlust",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[primal-dark-primal] With a ferocious shout, you channel the dark and wild energies surging within you, driving yourself and your allies into a frenzy. You all gain a +4 morale bonus to strength and a -2 penalty to armor class for 3 rounds. If you have the rage ability, this bonus stacks with it (it does not stack with allies rage). For every 15 <dark/primal> mastery, the bonus to strength and the penalty to armor class increases by 1. Allies can attempt a will save against this to negate it.`,
                initiationAction: `free`,
                range: `20 feet`,
                duration: `3 rounds`,
                target: `allies`,
              },
              {
                comboTags:['Primal'],
                level: 1,
                name: "Primal Rage",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[primal-primal-primal] You allow your primal ferocity to push your body to new limits. When you activate this finisher, and again at the start of each of your turns, you take 1 point of damage per 2 HD, but you gain a bonus to all weapon damage rolls of +1 per 10 <primal> mastery.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags:['Primal',"Flurry"],
                level: 3,
                name: "Warpath",
                type: "Finisher",
                finisherType:"Strike",
                longDesc: `[primal-flurry-flurry-primal] Make a melee attack. You can expend a <primal> or <flurry> strike (no sp cost) to take 1d3 damage per level of the maneuver and then take an additional attack at a -8 penalty, but gaining a bonus on the attack roll equal to the level of the maneuver and a bonus to its damage equal to 1d6 per 2 levels of the maneuver. If you are wielding two-weapons while using this finisher, the penalty to your attack rolls is reduced to -4. If you attack a new target you have not yet attacked this round, you take no penalty on the attack roll, and all further attacks that round gain a +1 bonus to them.`,
                initiationAction: `standard`,
                range: `melee attack`,
                duration: `instantaneous`,
                target: `enemies`,
              },
              {
                comboTags:['Power',"Heroic"],
                level: 3,
                name: "Heroic Charge",
                type: "Finisher",
                finisherType:"Strike",
                longDesc: `[power-heroic-power] You can initiate this maneuver as either a swift action or a movement action. If you initiate it as a swift action, you make a melee attack. If you initiate it as a movement action, you may move in a straight line up to your movement speed, even vertically. This attack gains the benefits of charging, but you can only make a single attack regardless of how many attacks you would normally get on a charge. If the attack hits, it deals 1d6 points of damage for every 5 <primal> mastery. Regardless of the action chosen, this attack provokes an attack of opportunity, potentially two for the movement. For each attack of opportunity taken against you during this maneuver, your attack gains a +2 bonus to the attack roll and a +1 bonus to its critical threat range.`,
                initiationAction: `see text;`,
                range: `melee attack`,
                duration: `instantaneous`,
                target: `one enemy`,
              },
              {
                comboTags:['Primal'],
                level: 3,
                name: "Battlerage",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[primal-primal-primal] When you initiate this finisher, for every party memeber that is below 50% hit points you recover an expended strike or <primal> boost, gain your level in temporary hit points, gain a +1 bonus on melee attack rolls, and +2 bonus on melee damage rolls. If the attacks are made with a two-handed weapon the damage bonus increases to +3. These bonuses last for 3 rounds.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags:['Primal',"Dark"],
                level: 3,
                name: "Rampage",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[primal-dark-primal] You enter into an unbridled rage of frenzy. For 3 rounds you can take no actions except:
                \nMaking melee attacks against an enemy \nMoving towards an enemy to take a melee attack against them \nInitiating <dark> and <primal> boosts and counters. 
                \n\nIf you do not know the position of an enemy to move towards to attack, you instead attack the nearest creature. If there are none, you attack yourself. During this time, you take a -10 penalty to your armor class, you gain a +1 bonus on will saves and melee attack rolls, +1 per 5 <dark> mastery, and a bonus +1 bonus on melee damage rolls and DR /- per 5 <primal> mastery. The bonus damage is doubled for two-handed weapon attacks. After this finisher ends you are fatigued for 3 rounds.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags:['Sakura',"Death","Flurry"],
                level: 3,
                name: "Fate Sealed",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[sakura-death-flurry-death-sakura] Once you initiate this maneuver, your turn ends immediately, and you cannot attack or move from your space until the start of your next turn. You also pick the direction you will move with this finisher, when you initiate it. At the start of your next turn, you move in a straight line exactly 30 feet (even upwards), making a melee attack with up to two wielded weapons against all enemies adjacent to you during your movement, each dealing damage as normal, plus 1d6 per 10 <flurry/death/sakura> mastery. You can move through creatures or their threatened area with this finisher without provoking attacks of opportunity, and regular means of stopping or slowing your movement are ineffective against you during it. Every creature within the area you'd be able to have made attacks against is subject to these attacks once you start your next turn, even if they move out of it, or try to avoid it via teleportation or movement, though they still can be blocked. Every creature you successfully attack and damage with this finisher is swept up in your fury, and at the end of the movement, they are moved appear behind you in the closest available space (your movement ends with you facing straight in the direction you moved), and are stunned for 1 round (fortitude negates, the DC increases by +1 per 10 <sakura/death/flurry> mastery, +4 if both attacks hit).`,
                initiationAction: `movement`,
                range: `30 feet`,
                duration: `instantaneous`,
                target: `enemies`,
              },
              {
                comboTags:['Power',"Earth"],
                level: 3,
                name: "Colossal Clash",
                type: "Finisher",
                finisherType:"Strike",
                longDesc: `[power-earth-power] Make a charge attack against a creature. If the attack hits, for this round, for every size larger the creature is than you, your melee weapon attacks have their dice steps increased by 2 size steps. You also count as its size for whether you can bullrush and trip it. For every 5 <earth> mastery, you gain a +1 bonus on CMD and CMB checks for that round.`,
                initiationAction: `standard`,
                range: `melee attack`,
                duration: `one round`,
                target: `1 enemy`,
              },
              {
                comboTags:["Guardian",'Power'],
                level: 1,
                name: "Bulk Up",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[guardian-power-guardian] You grow 1 size larger for 2 rounds. For every 40 <power/guardian> mastery you increase the duration by 1 round. This stacks with all other size increases.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `2 rounds;see text`,
                target: `you`,
              },
              {
                comboTags:["Heroic",'Primal'],
                level: 3,
                name: "Ancestor's Call",
                type: "Finisher",
                finisherType:"Strike",
                longDesc: `[heroic-primal-heroic] You feel the deep desire of your ancestors to challenge the mighty in battle, a desire even your enemies find infectious and difficult to resist. Choose an enemy that has a clear charge path between you and them with a maximum distance equal to both of your movement speeds. Both of you make an immediate charge attacks against each other, meeting in the middle of the distance. Creatures can attempt to negate this with a will save, however to even attempt so is devastatingly damaging to ones ego and spirit, thus they take a penalty of -1 per 10 <heroic> mastery on their save, and then all d20 rolls for 2 rounds for even attempting to resist it. You can also take a -2 penalty to your attack rolls and AC for the charge attack and for 1 round after in order to increase the DC of this finisher by +1 (max initiation modifier DC increase). Mindless creatures, or creatures immune to emotion effects are immune to this, however creatures just immune to mind-affecting are not. You gain a bonus on your damage roll of 1d6 per 10 <heroic/primal>, and the enemy gains half of this, unless they attempted to resist it.`,
                initiationAction: `full-round`,
                range: `see text;`,
                duration: `1 round`,
                target: `1 enemy`,
              },
              {
                comboTags:["Guardian"],
                level: 1,
                name: "Shield Stance",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[guardian-guardian-guardian] You double your shield's shield bonus to armor class for 2 rounds. This only works with physical shields. All allies within your reach can choose to either double their own shields shield bonus to AC or gain a shield bonus to their armor class equal to your shield's shield bonus to armor class. You can end this bonus during its duration as a free action you can take even when not your turn when a creature attacks an ally within the area you threaten with your shield, make an opposing attack roll as if making a shield bash, success negates that attack, allows you to move adjacent to the ally, and if you threaten the enemy after that movement, you can make an immediate bull rush attempt against them which doesn't provoke. On both the attack roll and the bull rush, you gain a bonus equal of +1 per 20 <guardian> mastery.`,
                initiationAction: `movement`,
                range: `reach`,
                duration: `2 rounds`,
                target: `you`,
              },
              {
                comboTags:["Flurry",'Primal'],
                level: 1,
                name: "Reckless Flurry",
                type: "Finisher",
                finisherType:"Strike",
                longDesc: `[flurry-primal-flurry] Make an attack with two different wielded weapons, both deal damage as if they were primary attacks. You take damage as if struck by the weapon that did more damage, though only as if it were off-hand damage. Both of these attacks gain a +1 bonus on the attack roll for every 20 <flurry> mastery, and a +1 on damage for every 5 <primal> mastery (The additional damage is not dealt to you). If both of these attacks hit, you deal additional damage to the enemy equal to 2x the damage you took from this finisher.`,
                initiationAction: `swift`,
                range: `melee attack`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags:["Flurry",'Primal'],
                level: 1,
                name: "Rip and Tear",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[flurry-primal-primal-flurry] For 1 round, every time you hit the same creature with both a primary and off-hand attack, you deal an additional 1d10 + 1/2 strength modifier damage as if using the rend ability. This can be applied multiple times this round every time you hit with both attacks against the same creature again, and each additional time you apply it to the same creature, it deals an additional 1d10 damage than the previous activation. Every 5 <flurry/primal> mastery the rend does an additional +1 damage.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },
              {
                comboTags:["Fire","Flurry"],
                level: 1,
                name: "Flame Cascade",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[fire-flurry-fire] Your successful attacks give 1 stack of immolation, +1 for every previous successful attack this round. At the start of your next turn, every creature that you have applied immolation to during this finisher takes 1 point of fire damage. For every 50 <fire/flurry> mastery this lasts an additional round, but the immolation stacks you apply reset at the start of each of your turns.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },
              {
                comboTags:["Fire","Curse"],
                level: 1,
                name: "Blightfire",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[fire-curse-fire] All enemies within 60 feet that have immolation stacks have half of them removed, but suffer 1d6 points of negative energy damage for every stack removed. For every 30 <fire/curse> the damage increases by 1 dice step.`,
                initiationAction: `free`,
                range: `60 feet`,
                duration: `1 round`,
                target: `enemies`,
              },
              {
                comboTags:["Fire","Curse"],
                level: 1,
                name: "Scorching Malediction",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[curse-fire-fire-curse] Choose an enemy within 60 feet. If they die within 3 rounds, all of their immolation stacks are spread to all enemies within 10 feet of them. All enemies that take immolation stacks from this, take negative energy damage equal to the stacks taken immediately. A will save reduces the stacks taken by half, and negates the negative energy damage. The DC increases by +1 every 20 <curse/fire> mastery.`,
                initiationAction: `free`,
                range: `60 feet`,
                duration: `3 rounds`,
                target: `1 enemy`,
              },
              {
                comboTags:["Fire","Curse"],
                level: 1,
                name: "Burning Damnation",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[curse-fire-fire-curse] Choose an enemy within 30 feet. They take 1 immolation stack, +1 for every 10 <fire/curse> mastery, and for 3 rounds, whenever an immolations stack is removed from them, they suffer 1d6 points of negative energy damage per stack removed.`,
                initiationAction: `free`,
                range: `30 feet`,
                duration: `3 rounds`,
                target: `enemies`,
              },
              {
                comboTags:["Water",'Flurry'],
                level: 1,
                name: "Riptide",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[water-flurry/technique-water] For 3 rounds, whenever you successfully damage an opponent with a weapon attack, they suffer 1 riptide stack. At the start of each of their turns, they take 1 cold damage per riptide stack. This is considered a curse and lasts 1 minute. When you successfully confirm a critical hit or make a successful a <water/flurry> strike against a creature with riptide stacks, the riptide stacks are removed and they suffer 1d6 cold damage per riptide stack, and all other creatures with riptide stacks you applied suffer 1 cold damage per riptide stack they have.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags:["Water","Flurry","Technique"],
                level: 1,
                name: "Raging Tide",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[water-flurry,technique-water] You coat up to two wielded manufactored weapons in tearing waters for 3 rounds. Every time you make a successful attack with them, all enemies adjacent to the target suffer 1d6 points of cold damage. Every 20 <water/flurry/technique> the cold damage increases by 1d6. When you make a <water/flurry/technique> strike that makes only a single attack against a single target, any additional damage dealt by the strike is also dealt to creatures adjacent to them.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags:["Curse"],
                level: 1,
                name: "Wither",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[curse-curse-curse-curse] Choose a creature you have cursed that is within 60 feet of you, it immediately takes negative energy damage equal to 1/10 of your <curse> mastery. At the start of your next 5 turns, it takes the damage again, but increased by a further 1/10th of your curse mastery.`,
                initiationAction: `free`,
                range: `60 feet`,
                duration: `5 rounds`,
                target: `cursed enemy`,
              },
              {
                comboTags:["Flurry","Heroic"],
                level: 1,
                name: "Inspiring Technique",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[flurry-heroic-flurry] For 1 round, every time you make a successful attack, choose an ally within 60 feet, they gain a +1 insight bonus to attack and damage next round. This stacks if the same ally is chosen multiple times (cannot select yourself). `,
                initiationAction: `free`,
                range: `60 feet`,
                duration: `1 round`,
                target: `allies`,
              },
              {
                comboTags:["Flurry","Death"],
                level: 1,
                name: "Crack in the Shell",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[flurry-death-flurry] Make a melee touch attack against a creature, if successful, you open a weakness in their body. Once they have successfully been struck by weapon attacks 5 times, the next time they are struck by a weapon attack, it is an automatic potential critical hit.`,
                initiationAction: `free`,
                range: `touch`,
                duration: `1 minute`,
                target: `1 enemy`,
              },              
              {
                comboTags:["Curse"],
                level: 1,
                name: "Bad Day",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[curse-curse-curse] You curse a creature within 60 feet to suffer a random unfortunate event at the start of each of its next 3 turns. If the effect has a DC, the DC increases by +1 per 20 <curse> mastery. Roll a d10 to determine which random effect befalls them:
                \n1: They make a reflex save or drop a wielded weapon\n2: They fall prone, or fall 20 feet if flying\n3: Their next d20 roll this round they roll twice and take the lower result\n4: A random falling object strikes them and they take 1d4 per 5 <curse> bludgeoning damage\n5: The suffer a -2 penalty to all d20 rolls this round\n6: They roll minimum damage on all attacks this round, will save reduces to next attack this round\n7: They are stunned for 1 round, fort negates\n8: They provoke an attack of opportunity from creatures that threaten them\n9: roll again, taking the new result, but the duration of the curse also extends 1 round\n10: They are dazed`,
                initiationAction: `free`,
                range: `60 feet`,
                duration: `3 rounds`,
                target: `1 enemy`,
              },
              {
                comboTags:["Curse"],
                level: 1,
                name: "Mark of Perdition",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[curse-curse-curse] Choose a creature, for 3 rounds, every time it is cursed it suffers negative energy damage as follows:
                \nIf the curse has no additional effects, they take 1d6, plus 1d6 per 25 <curse> mastery and the curse is immediately removed after the damage.
                \nIf the curse does have additional effects but its duration is less than level minutes, it deals 1d6 plus 1d6 per 15 <curse> mastery. 
                \nIf the curse has additional effects but its duration is longer than level minutes but less than permanent, it deals 1d6 plus 1d6 per 10 <curse> mastery.
                \nIf the curse has additional effects and is permanent, the damage is equal to 1d4 per 5 <curse> mastery.`,
                initiationAction: `free`,
                range: `60 feet`,
                duration: `3 rounds`,
                target: `1 enemy`,
              },
              {
                comboTags:["Guardian",'Power'],
                level: 3,
                name: "Shattershield",
                type: "Finisher",
                finisherType:"Strike",
                longDesc: `[power-guardian-power] Make an attack with a wielded shield. If it hits, it deals damage equal to half the shield's hit points. After the attack, the shield immediately loses half its maximum hit points. If this destroys the shield, you create a cone with an area equal to 5 feet per 10 <primal/guardian> mastery, all creatures within the cone take damage equal to the hit points lost with this finisher. Reflex save halves.`,
                initiationAction: `swift`,
                range: `melee attack`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags:["Shadow","Heroic"],
                level: 1,
                name: "Daring Escape",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[heroic-shadow-heroic] You and all allies within the area can make an immediate move action. This movement does not provoke. Neither you or any of the moving allies can end their movement threatening an enemy. For every 10 <shadow> mastery you all receive a +1 dodge bonus to armor class for 1 round. For every 10 <heroic> mastery the area increases by 5 feet.`,
                initiationAction: `swift`,
                range: `15 feet`,
                duration: `instantaneous`,
                target: `allies`,
              },
              {
                comboTags:["Shadow","Guardian"],
                level: 1,
                name: "Shadow Waltz",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[shadow-guardian-shadow] All of your allies within your reach can immediately move to any other square within your reach. This movement does not provoke attacks of opportunity. As long as the have moved at least 10 feet from their previous square, they gain a dodge bonus to their armor class of +1 for every 10 <guardian/shadow> mastery. You gain none of these benefits.`,
                initiationAction: `swift`,
                range: `reach`,
                duration: `instantaneous`,
                target: `allies`,
              },
              {
                comboTags:["Shadow","Flurry"],
                level: 5,
                name: "Eviscerate",
                type: "Finisher",
                finisherType:"Strike",
                longDesc: `[shadow-flurry-shadow] For every maneuver you have initiated since the start of your last turn, you can make a single melee attack with a -10 penalty, but they gain a bonus of +2 for every maneuver initiated.`,
                initiationAction: `free`,
                range: `melee attack`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags:["Shadow","Arcane"],
                level: 3,
                name: "Secret Passage",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[shadow-arcane-shadow] You sneak into a secret hole that only you were aware of, vanishing from the map. At the start of your next turn you can make a stealth check to hide, and re-enter the map any square within feet equal to your <shadow/arcane> mastery. You must enter and exit adjacent to at least a large physical object. Though they dont have to actually connect to each other.`,
                initiationAction: `free`,
                range: `5 feet/<arcane> level`,
                duration: `1 round`,
                target: `you`,
              },
              {
                comboTags:["Shadow","Void"],
                level: 3,
                name: "Burgle",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[shadow-shadow-void-shadow-shadow] You can initiate this finisher when adjacent to an enemy. Make a stealth check versus the creatures CMD. If you succeed, you gain a small gold pile. If you succeed by 15, you gain a medium gold pile. Any individual creature can only be burgled once.`,
                initiationAction: `movement`,
                range: `adjacent`,
                duration: `instantaneous`,
                target: `you`,
              },
              {
                comboTags:["Shadow", "Heroic"],
                level: 3,
                name: "Gang Up",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[shadow-heroic-shadow] Pick a creature you are threatening, you and all allies that threaten it can take an immediate move action so long as they finish their turn threatening it. Double the bonuses you all gain for flanking for 1 round, and you all gain 1d6 points of sneak attack damage. Every 20 <shadow> mastery, the damage increases by 1d6. For every 20 <heroic> mastery, the bonus lasts an additional round.`,
                initiationAction: `movement`,
                range: `see text;`,
                duration: `1 round`,
                target: `allies`,
              },
              {
                comboTags:["Shadow", 'Primal'],
                level: 3,
                name: "Survival Instinct",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[shadow-primal-shadow] Move up to half your movement speed. This provokes as normal. While doing this, you can expend a maneuver, plus an additional maneuver per 5 <primal> mastery (no sp cost). After you have expended them (as long as you expended at least one), you recover a single maneuver of choice, plus an additional random maneuver per maneuver expended past the first. For every maneuver recovered that is not one of the maneuvers you expended, you gain a +1 dodge bonus to your armor class and to saves for 1 round.`,
                initiationAction: `swift`,
                range: `personal;`,
                duration: `1 round`,
                target: `you`,
              },
              {
                comboTags:["Shadow", "Curse"],
                level: 3,
                name: "Sudden Betrayal",
                type: "Finisher",
                finisherType:"Counter",
                longDesc: `[shadow-curse-shadow] You can initiate this finisher at 5 different times, each as a free action you can take even when not your turn.
                \nReason 1: No reason. An enemy makes an immediate attack against an ally. The enemy must be able to take this attack for you to use this on them.
                \nReason 2: When an enemy makes an attack against you but threatens another creature, the attack is redirected to that creature.
                \nReason 3: When an enemy rolls a natural 1 when threatening an ally, It becomes a confirmed critical fumble.
                \nReason 4: When an enemy confirms a critical fumble against an ally, The critical fumble becomes a critical hit.
                \nReason 5: An ally confirms a critical fumble and would hit you. It hits one of your allies instead.`,
                initiationAction: `free`,
                range: `sight`,
                duration: `instantaneous`,
                target: `see text;`,
              },
              {
                comboTags:["Shadow", "Technique"],
                level: 3,
                name: "Sabatoge",
                type: "Finisher",
                finisherType:"Strike",
                longDesc: `[technique-shadow-technique] Make a touch attack against a creature, if you hit, make a sunder CMB check against them (doesn't provoke). If it succeeds, a piece of equipment being worn is considered broken for 3 rounds. If the touch attack succeeded but the sunder check failed, it is considered broken for 1 rounds. For every 15 <shadow> mastery their penalties increase (weapon: -1 attack and damage. Armor: -1 AC.)`,
                initiationAction: `swift`,
                range: `melee attack;`,
                duration: `3 rounds`,
                target: `enemy`,
              },
              {
                comboTags:["Shadow", "Arcane"],
                level: 4,
                name: "Vanish",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[arcane-shadow-shadow-arcane] You and all allies within the range become invisible as the spell for 3 rounds.`,
                initiationAction: `swift`,
                range: `30 feet`,
                duration: `3 rounds`,
                target: `allies`,
              },
              {
                comboTags:["Shadow", "Arcane"],
                level: 1,
                name: "Cloak of Shadows",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[shadow-arcane-shadow] You become invisible as per the spell for 3 rounds. If you break this stealth by making an attack roll, the attack deals an additional 1d4 sneak attack damage per 5 <shadow> mastery.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags:["Shadow", "Air"],
                level: 1,
                name: "Sprint",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[shadow-air-shadow] You can immediately move up to your movement speed without provoking attacks of opportunity. Recover a boost and a random maneuver. For every 10 <shadow/air> mastery, recover an additional boost or random maneuver.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
              },
              {
                comboTags:["Water", "Royal"],
                level: 5,
                name: "Flow",
                type: "Finisher",
                finisherType:"Counter",
                longDesc: `[water-royal-water] This finisher counts as a counter. When you are about to take damage from an attack or an instantaneous spell, you deflect the damage so that attacking creature takes it instead. You can initiate this counter in response to a natural 20. If it was a AoE instantaneous effect, the damage is only negated for you.`,
                initiationAction: `free immediate action`,
                range: `60 feet`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags:["Heroic"],
                level: 1,
                name: "Call to Heroism",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[heroic-heroic-heroic] You and all allies double your morale bonuses for 1 round. For every 50 <heroic> mastery the duration increases by 1 round.`,
                initiationAction: `free`,
                range: `30 feet`,
                duration: `1 round`,
                target: `allies`,
              },
              {
                comboTags:["Heroic"],
                level: 1,
                name: "Surge of Heroism",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[heroic-heroic-heroic-heroic] You double your morale bonuses for 2 rounds. For every 50 <heroic> mastery, choose a single effect that is granting you a morale bonus and add +1 to morale the bonus it is giving (after it is doubled).`,
                initiationAction: `free`,
                range: `personal`,
                duration: `2 rounds`,
                target: `you`,
              },
              {
                comboTags:["Sakura",'Void'],
                level: 1,
                name: "Blade of the 5th Ring",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[sakura-void-sakura] For 1 round, every time you make an attack roll you roll twice and take the higher result. You gain bonus damage on critical hits equal to your <void/sakura> mastery (after the damage is already multiplied)`,
                initiationAction: `free`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },
              {
                comboTags:["Dark"],
                level: 1,
                name: "Victimize",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[dark-dark-dark] For 1 round, you increase the severity of any status a creature is suffering:
                \nShaken->Frightened->Panicked->Cowering\nStaggered->Nauseated->Dazed->Stunned->Paralyzed->Unconscious\nSickened->Nauseated\nFatigued->Exhausted->Staggered\nEntangled->Entangled to spot\nConfused->Always hit self\nDazzled->Blinded.
                \nThis applies to all statuses it is suffering at once.`,
                initiationAction: `swift`,
                range: `60 feet`,
                duration: `1 round`,
                target: `1 enemy`,
              },
              {
                comboTags:["Dark"],
                level: 5,
                name: "Symphony of Sins",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[dark-dark-dark-dark] Gain random benefit depending on the result of a d6 roll:
                \nEnvy: Steal a buff currently affecting another creature. You can choose a specific one if you know what they have, otherwise it is random. This has a 60 foot range. The creature can make a will save and you only get the buff for 1 round.
                \nPride: The next strike you initiate within 1 round has its initiation action reduced by 1 step, however you take a -4 penalty on d20 rolls during it. If your strike fails to deal damage to the target or you fail to make an attack roll during the round, you take a -4 penalty on all d20 rolls for 2 rounds. 
                \nWrath: Make a single melee attack against ALL creatures within reach.
                \nGluttony: You can draw and drink a potion immediately. This doesn't provoke and its effects are increased by 50%. You must select a potion that you have at least 2 of, the second one is lost.
                \nLust: Make a melee attack, heal hit points equal to half the damage dealt.
                \nGreed: Recover 3 random maneuvers.
                \nSloth: Gain temporary hit points equal to your missing hit points for 3 rounds. These end if you heal yourself.`,
                initiationAction: `swift`,
                range: `see text;`,
                duration: `see text;`,
                target: `see text;`,
              },
              {
                comboTags:["Light"],
                level: 1,
                name: "Flash of Light",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[light-light-light] Choose an ally, they heal 1d6 per 3 <light> mastery, and they can recover a maneuver of choice, and a random maneuver.`,
                initiationAction: `swift`,
                range: `30 feet`,
                duration: `instantaneous`,
                target: `1 ally`,
              },
              {
                comboTags:["Light",'Primal'],
                level: 1,
                name: "Vitality Surge",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[light-primal-light] You heal 1d6 hit points per 3 <light> mastery and recover a maneuver of choice and a random maneuver. For 1 round, you gain DR /- equal to the level of the random maneuver recovered.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },
              {
                comboTags:["Light", "Curse"],
                level: 1,
                name: "Righteous Defense",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[light-curse-light] You target an enemy with this curse, the next time it makes an attack against an ally they take -2 a penalty on the attack and damage roll, increased by -1 per 20 <curse/light> mastery. The ally gains that penalty as bonuses on attack and damage rolls against the enemy for 1 round.`,
                initiationAction: `swift`,
                range: `60 feet`,
                duration: `1 round`,
                target: `1 enemy`,
              },
              {
                school:"primalFury",
                level: 2,
                name: "Shoulder Check",
                type: "Strike",
                longDesc: `You cannot attack a creature you initiate this strike against until the start of your next turn. Move 5 feet towards an enemy and make an unarmed attack against them (doesn't provoke). You must end your movement closer to the enemy than you started, thus you cannot use it while adjacent to them. If the attack hits, it deals damage as normal, except it deals damage as an off-hand attack, and you can expend a maneuver (no sp cost) to recover a lower level maneuver. You can initiate this maneuver as part of taking the charge action in place of any other attack.`,
                initiationAction: `movement`,
                range: `melee attack`,
                duration: `1 round`,
                target: `1 enemy`,
              },
              {
                school:"primalFury",
                level: 3,
                name: "Primal Surge",
                type: "Boost",
                longDesc: `You 3 expend random maneuvers (no sp cost) and then recover 2 random maneuvers. If neither of the recovered maneuvers are the maneuvers expended, you heal 1d6 hit points for every level of maneuver expended. Every 9 levels you can expend an additional maneuver. You can only do this while in combat.`,
                initiationAction: `movement`,
                range: `you`,
                duration: `instantaneous`,
                target: `you`,
              },
              {
                school:"thrashingDragon",
                level: 3,
                name: "Up the Frenzy",
                type: "Boost",
                longDesc: `You can only initiate this maneuver after making a full-round attack with at least two weapons. Recover a maneuver that is a of a level lower than the amount of successful weapon or natural attacks you made this turn. If you hit with all of your attacks, and the maneuver you recovered was a <flurry> maneuver, you gain an additional <flurry> combo point.`,
                initiationAction: `swift`,
                range: `you`,
                duration: `instantaneous`,
                target: `you`,
              },
              {
                school:"thrashingDragon",
                level: 2,
                name: "Dragon Onslaught",
                type: "Strike",
                longDesc: `Make a full-round attack with at least two weapons. For every <flurry> combo point you have, you gain +2 damage to each attack. For every 2 <flurry> combo points you have in a row, you gain +1 to attack.`,
                initiationAction: `full-round`,
                range: `melee attack`,
                duration: `instantaneous`,
                target: `enemies`,
              },
              {
                school:"thrashingDragon",
                level: 1,
                name: "Winding Tempest",
                type: "Boost",
                longDesc: `When you are beginning an action that is going to allow you to make an attack with at least two weapons that is also not part of a strike, you can initiate this boost. Your attacks gain a +1 bonus on damage rolls for every <flurry> combo point you have.`,
                initiationAction: `free`,
                range: `you`,
                duration: `1 round`,
                target: `personal`,
              },
              {
                comboTags:["Flurry"],
                level: 1,
                name: "Sudden Flurry",
                type: "Finisher",
                finisherType:"Strike",
                longDesc: `[flurry-flurry-flurry] Make a full-round attack. For every 10 <flurry> mastery all of these attacks deal an additional 1d4 damage.`,
                initiationAction: `standard`,
                range: `melee attack`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags:['Primal',"Shadow"],
                level: 2,
                name: "Relentless Pursuit",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[primal-shadow-primal] Choose a creature, for 2 round they provoke attacks of opportunity from you whenever they move, even with 5-foot steps, withdrawing, or teleportation. If the creature 5-foot steps out of your threatened area, you can immediately move 5 feet without provoking attacks of opportunity as long as you end your movement threatening them again. If the creature takes a move action to move, you can take an immediate movement action to follow them, as long as you end your movement threatening them again. You cannot move further in a round with this maneuver than your maximum movement speed. If a creature ends its movement out of your reach, you become shaken for 1 round. For every 10 <shadow> mastery your attacks of opportunity against the creature deal an additional 1d6 damage. For every 30 <primal> mastery this lasts an additional round.`,
                initiationAction: `swift`,
                range: `threatened creature`,
                duration: `2 rounds`,
                target: `1 enemy`,
              },
              {
                comboTags:["Guardian", "Dark"],
                level: 2,
                name: "Subjugation",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[guardian-dark-guardian] Choose a creature, for 1 round they provoke attacks of opportunity whenever they move, even with 5-foot steps, withdrawing, or teleportation. If the creature 5-foot steps out of an allies threatened area, they can can immediately move 5 feet without provoking attacks of opportunity as long as they end their movement threatening them again. For every 20 <dark> mastery attacks of opportunity against the creature deal an additional 1d6 damage. For every 30 <guardian> mastery this lasts an additional round.`,
                initiationAction: `swift`,
                range: `threatened creature`,
                duration: `1 round`,
                target: `1 enemy`,
              },
              {
                comboTags:["Guardian", "Curse"],
                level: 1,
                name: "Torment",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[guardian-curse-guardian] This creature loses 4 armor class against attacks of opportunity, and every time it takes damage from an attack of opportunity it takes 1d4 more. For every 10 <guardian> mastery attacks of opportunity against the creature deal an additional 1d4 damage.`,
                initiationAction: `free`,
                range: `threatened creature`,
                duration: `3 rounds`,
                target: `1 enemy`,
              },
              {
                comboTags:["Light"],
                level: 3,
                name: "Purify",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[light-light-light-light] Choose an ally, they may make a saving throw against a harmful ongoing effect currently affecting them. This effect must be an ability they can normally resave against. Failure on the save never results in penalties. For every 10 <light> masteery they gain a +1 bonus on this saving throw. If this save was against a poison or disease and they succeed this additional save, it also cures any condition the poison or disease gave them, and clears half of the damage or drain dealt to them.`,
                initiationAction: `swift`,
                range: `30 feet`,
                duration: `instantaneous`,
                target: `1 ally`,
              },
              {
                comboTags:["Light","Heroic","Royal","Guardian"],
                level: 9,
                name: "Viva La Vida",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[light-heroic-royal-guardian-light] You throw down your weapon and channel an immensely powerful light that radiates down from the sky into a dome around you. When you initiate this finisher all allies in the area heal for twice your <light> mastery. Allies below 0 hit points double this healing. Allies healed above their maximum hit points are granted the excess as temporary hit points that last 3 rounds. These do not stack with themselves. Enemies within this aura are immediately moved outside of it to any square of their choice. Enemies cannot enter the area while you continue to concentrate on this finisher, though they can attack through it at a penalty equal -1 per 10 <royal> mastery.
                \nWhile allies remain the area, they gain a sacred bonus on saving throws of +1 per 20 <guardian> mastery, a sacred bonus on attack rolls equal to +1 per 15 <royal> mastery, and +1 sacred bonus on damage rolls per 10 <heroic> mastery. 
                \nAt the start of your next turn you can choose to continue concentrating on this finisher, doing so is a full-round action. If you do, your allies within the area are healed again, though only healing half as much as they did the previous round, and enemies continue to be unable to enter the area. You cannot move or teleport while concentrating on this or it immediately ends. You can concentrate on this for maximum rounds equal to 1 per 30 <heroic/light> mastery.`,
                initiationAction: `full-round`,
                range: `20 feet`,
                duration: `concentration`,
                target: `all allies`,
              },
              {
                comboTags:["Light","Guardian"],
                level: 1,
                name: "Shield of Righteousness",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[light-guardian-light] The next time you take damage, the damage is reduced to 0 and the attack or spell that damaged counts as having missed you. This finisher lasts 1 round, plus 1 round per 5 <light> mastery.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `1 + 1/5 <light> mastery rounds`,
                target: `you`,
              },
              {
                comboTags:["Primal","Arcane"],
                level: 1,
                name: "Primal Surge",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[primal-arcane-primal] You can cast a random spell from your spells known. Casting this spell does not provoke attacks of opportunity, nor does it require a free hand to cast.`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
              },
              {
                comboTags:["Heroic","Water"],
                level: 5,
                name: "Turn the Tide",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[heroic-water-heroic] When an ally is being charged by an enemy, but a space exists between the ally and the charging creature that you have the ability to charge to that would interrupt their charge, you can move there, interrupting their charge mid-way, and making a single melee attack against them. The creature can now make its charge attack against you instead. If the charged ally chooses, they can use an immediate action to also make a charge attack against the creature. Both you and the ally are staggered on the next round after using this (unresistable and unremovable)`,
                initiationAction: `immediate`,
                range: `60 feet`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags:["Light","Heroic"],
                level: 1,
                name: "Divine Spirit",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[light-heroic-light] Double your temporary hit points. This does not effect their durations.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
              },
              {
                comboTags:["Light","Earth"],
                level: 1,
                name: "Unbreakable Heart",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[light-earth-light] As long as your current temporary hit points last, you gain DR /- of 1 per 5 <earth> mastery.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `see text;`,
                target: `you`,
              },
              {
                comboTags:["Light","Technique"],
                level: 1,
                name: "Blessing of Wisdom",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[light-technique-light] All allies (you excluded) within 30 feet can immediately recover 1 maneuver.`,
                initiationAction: `swift`,
                range: `30 feet`,
                duration: `instantaneous`,
                target: `allies`,
              },
              {
                comboTags:["Light","Water"],
                level: 1,
                name: "Holy Light",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[light-water-light] For 3 rounds, a random ally within 30 feet of you is healed for 1d6 hit points, plus 1d6 per 10 <light> mastery. This happens immediately when you activate this finisher, then at the start of each of your turns for its duration.`,
                initiationAction: `free`,
                range: `30 feet`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags:["Dark"],
                level: 1,
                name: "Sinburst",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[dark-{multi}-dark] Multi can only include <dark>. An enemy takes 1d4 points of negative energy damage per 3 <dark> mastery. For every additional <dark> combo point included past the first, this finisher's damage dice is increased by 1 step.`,
                initiationAction: `swift`,
                range: `30 feet`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags:["Light", "Royal"],
                level: 5,
                name: "Dei Gratia Rex",
                type: "Finisher",
                finisherType:"Counter",
                longDesc: `[royal-light-royal] Initiating <royal/technique/light> counters this round does not use your immediate action, and can instead be done as a free action you can take even when not your turn. Counters are still expended as normal.`,
                initiationAction: `immediate`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
              },
              {
                comboTags:["Light", "Technique"],
                level: 5,
                name: "Dei Gratia",
                type: "Finisher",
                finisherType:"Counter",
                longDesc: `[technique-light-technique] All of your counters for 2 rounds automatically succeed. For every 5 <light> mastery you gain a counterpoint.`,
                initiationAction: `free immediate action`,
                range: `personal`,
                duration: `2 rounds`,
                target: `you`,
              },
              {
                comboTags:['Primal', "Death"],
                level: 1,
                name: "Eye For an Eye",
                type: "Finisher",
                finisherType:"Strike",
                longDesc: `[primal-death-primal] Make a melee attack, if it hits, it deals damage as normal, but your attack deals also inflicts one of the statuses the creature has inflicted you with. It gains the same saves or chances of failure as you were allowed against it, however this bypasses any immunities the creature might have. The condition lasts a maximum of 1 round, plus 1 round for every 20 <death/primal> mastery. If the inflicted status was blindness in particular, the blindness you give if your attack hits becomes permanent.`,
                initiationAction: `movement`,
                range: `melee`,
                duration: `1 rounds, +1 rd/3 <death> levels`,
                target: `1 enemy`,
              },
              {
                level: 5,
                school:"enlightenedPath",
                name: "Serenity",
                type: "Counter",
                longDesc: `<light> When a creature that you threaten deals damage to you that would reduce you below 0 hit points, you can initiate this counter to make an immediate unarmed attack against them. You heal hit points equal to the damage dealt by this unarmed attack. If the damage it dealt to you would have killed you, your immediate attack deals an additional 5d6 damage.`,
                initiationAction: `immediate`,
                range: `melee`,
                duration: `instantaneous`,
                target: `1 enemy`,
                additionalTags:["Light"],
              },
              {
                comboTags:["Light","Guardian"],
                level: 2,
                name: "Seal of Light",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[light-guardian-light] You surround an enemy in a seal of divine energy that stop it from damaging creatures outside of it. The seal has 1d8 hit points 5 <light> mastery, and until its hit points are reduced to 0 (or this expires), every time the creature would deal damage to a ally with an attack or spell that requires line of effect, the seal absorbs it, taking the damage in place of the target. Any excess damage dealt past the seal's hit points is dealt to the targets. When the enemy makes an attack against an ally, it takes a penalty on its attack rolls of -1 per 10 <guardian> mastery as long as the seal remains. The seal otherwise has zero effect on the creature's ability to move, or other creatures ability to attack, damage, or target them. The creature can choose to attack solely the seal, for which it has an armor class of 10, but whatever damage it deals is reduced by half.`,
                initiationAction: `swift`,
                range: `30 feet`,
                duration: `3 rounds`,
                target: `1 enemy`,
              },
              {
                comboTags:["Light","Fire"],
                level: 1,
                name: "Consecration",
                type: "Strike",
                longDesc: `[light-fire-light] All enemies within the area take 1d6 points of damage, plus 1d6 per 10 <light/fire> mastery. Half of this damage is fire damage, while the other half comes from divine energy and bypasses energy resistance.`,
                initiationAction: `swift`,
                range: `30 foot cone`,
                duration: `instantaneous`,
                target: `area`,
              },
              {
                scbool:"radiantDawn",
                level: 4,
                name: "Avenging Wrath",
                type: "Strike",
                longDesc: `You immediately expend a random maneuver (no sp cost), and channel that energy into a wild blast of divine Energies. For every level the maneuver was, 2d6 points of sacred damage is dealt to a random enemy within the area. If the maneuver was a <light> maneuver, the damage increases to 4d6 per level, and if that enemy was threatening an ally, that ally gains a sacred bonus to their armar class equal to half the level of the expended maneuver for 1 round on attacks made by the enemy. This bonus can be granted to multiple allies.
                \nFor every essence invested, you can expend another random maneuver. The ally only gains the highest deflection of the two maneuvers levels, but the bonus is increased by a flat +1.`,
                initiationAction: `movement`,
                range: `30 foot radius of you`,
                duration: `instantaneous`,
                target: `random enemy`,
              },
              {
                scbool:"radiantDawn",
                level: 5,
                name: "Divine Favor",
                type: "Boost",
                longDesc: `You can expend <light> combo points to allow an ally to recover maneuvers (you are excluded). The ally can recover 1 level of maneuvers for every combo point spent. They can combine these into 1 maneuver, or recover multiple of lower levels, so long as their levels combined are below the combo points spent.
                \nFor every point of essence invested, the ally can recover an additional 1 level of maneuvers.`,
                initiationAction: `movement`,
                range: `30 feet`,
                duration: `instantaneous`,
                target: `1 ally`,
              },
              {
                comboTags:["Light"],
                level: 5,
                name: "Blessed Champion",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[light-light-light-light-light] Your next attack deals double damage. This is additive with other multipliers, critical hits included.`,
                initiationAction: `free`,
                range: `you`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags:["Shadow","Heroic"],
                level: 3,
                name: "Need for Greed",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[shadow-heroic-heroic-shadow] Move up to twice your speed, along the way you can expend a heroic maneuvers to pick up memories or gold as a free action. You must expend a maneuver for every individual item.
                \nSmall Gold Pile: level 1+\nMedium Gold Pile: level 3+\nLarge Gold Pile: level 6+\nMemories: level 2+\nGear: level 1+`,
                initiationAction: `standard`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
              },
              {
                comboTags:["Dark"],
                level: 4,
                name: "Cycles of Hatred",
                type: "Strike",
                longDesc: `[dark-dark-dark-dark] Make an attack, it deals damage as normal, however, after the damage is dealt, the damage is dealt to another enemy on the map. If no other enemies are available, this strike immediately damages an ally instead (see later for details). After you deal this additional damage to a random enemy, that enemy that holds the Hatred. The next time they make a melee attack, the attack deals damage as normal plus 1d6 for every 3 levels of <dark> maneuvers you know, and then deals the damage dealt on the attack to one of your allies at random. They then hold the hatred, their next attack continuing the chain, the damage increasing each time. Creatures can continue doing this until the hatred returns to you, however if they dont attack a creature on their turn they have it, it automatically dissipates and you suffer a -2 penalty on all d20 rolls for 1 round. If the hatred returns to you, for 1 round, you gain a +1 bonus on all d20 rolls for every creature other than you who delivered it, plus your next attack this round deals the bonus damage it was doing when it returned to you, except its damage becomes 1d10s. If the damage dealt by receiving the hatred kills a creature, it ends and you gain half the bonuses you would have had it returned to you.`,
                initiationAction: `standard`,
                range: `melee attack`,
                duration: `see text;`,
                target: `1 enemy`,
              },
              {
                comboTags:["Light", "Technique"],
                level: 3,
                name: "Call to Arms",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[light-technique-light] All allies (except you) within the area recover maneuvers, they can choose for it to be either 2 random maneuvers, or 1 manuever of choice. If they choose for it to be a maneuver of choice, they cannot recover a maneuver of higher level than you have levels known of <technique> maneuvers.`,
                initiationAction: `movement`,
                range: `30 feet`,
                duration: `instantaneous`,
                target: `allies`,
              },
              {
                comboTags:["Light", "Arcane"],
                level: 1,
                name: "Deliverance",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[light-arcane,{multi}-light] You do not need to include something in the {multi} slot, but if you do, it must be <guardian>. You can cast a single conjuration(healing) spell on yourself as a part of initiating this finisher. Spells cast this way ignore somatic and material components, and only affect you, even if they would normally affect others. The spell has increased effect of +10% healing given for every level of <arcane> maneuver you know. The spell also cannot be higher than the highest level <light> maneuver you know. If you included <guardian> in the {multi} slot, you can instead cast the spell on an ally within range of touch.`,
                initiationAction: `swift`,
                range: `personal or reach;see text`,
                duration: `instantaneous`,
                target: `you or touch;see text`,
              },
              {
                comboTags:["Light","Royal"],
                level: 2,
                name: "Blessing of Kings",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[light-royal-light] You touch an ally and grant it the blessing of kings. They gain a +4 sacred bonus on their strength and constitution for 3 rounds. For every 15 <royal> mastery the blessing increases by +1.`,
                initiationAction: `movement`,
                range: `touch`,
                duration: `3 rounds`,
                target: `1 ally`,
              },
              {
                comboTags:["Dark","Royal"],
                level: 3,
                name: "Burden of Pride",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[dark-royal-dark] You gain a +3 bonus on all attack rolls, saves, ability checks, and skill checks. Every time you make a d20 roll and fail, the bonus reduces by 1. Once the bonus reaches 0, you suffer a -5 penalty on all d20 rolls for 3 rounds. For every 20 <royal> mastery, the bonus and penalty increases by 1.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `see text;`,
                target: `you`,
              },
              {
                comboTags:['Primal','Void'],
                level: 1,
                name: "Survival of the Fittest",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[primal-void-primal] Make an attack, it deals an additional 1d6 points of damage for every evolution stack this finisher has. Every time you initiate this finisher, it gains 1 stack, plus 1 stack per 20 <void> mastery. Evolution stacks are not lost between floors, though half are lost when you die.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `see text;`,
                target: `you`,
                stacksOne:0,
                stacksOneName:"Evolution Stacks"
              },
              {
                comboTags:["Light","Dark"],
                level: 1,
                name: "Extreme Centerism",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[light,dark-light,dark] All creatures in the current combat become confused for 1 round, except for you (you've somehow already learned to live like this).`,
                initiationAction: `swift`,
                range: `map`,
                duration: `1 round`,
                target: `all creatures`,
              },
              {
                comboTags:["Royal","Dark"],
                level: 1,
                name: "Improve Morale",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[royal-dark-royal] Make a melee attack against an ally, if it hits, all allies who see you strike them gain a +1 morale bonus on d20 rolls for every 5 <royal> mastery, max of +1 per 10 lethal damage dealt to the ally. The bonuses lasts 1 round, plus 1 round per 10 <dark> mastery. Additionally, if the attack hits, it also grants allies who are currently suffering from fear (with the exception of the struck ally) a new save against that effect, assuming it had a save to begin with (this reroll never penalizes the ally). If the ally was suffering from a fear effect, you can choose to deal double damage to grant allies a +5 bonus on their new save and cause the ally to take a -4 penalty on further saves against fear this floor. 
                \nThis finisher can be initiated as an immediate action if an ally suffering from a fear affect is running away and would have provoked an attack of opportunity from you.`,
                initiationAction: `swift`,
                range: `melee attack`,
                duration: `1rd + 1 rd/10 <dark>`,
                target: `1 ally`,
              },
              {
                comboTags:["Shadow","Void"],
                level: 1,
                name: "Cheat Death",
                type: "Finisher",
                finisherType:"Counter",
                longDesc: `[shadow-void-shadow] The next time you would die within the duration, you somehow avoid it, being reduced to 1 hit point instead. This cannot heal you if you were already below 1 hit point. Afterwards, you can make a stealth check and move a number of feet equal to the result of the check without provoking attacks of opportunity. Its duration is 1d4 rounds plus 1 round, per 10 <shadow> mastery. Every time you successfully use this to avoid death, it permanently takes a stacks of inevitability. Every time you initiate this finisher, roll a d100, if the result of the roll is within 3% per stack of inevitability, it summons a grim reaper who's sole goal is to kill you (not worth experience if slain). Every time this activates, it summons an additional grim reaper. If the percentage dice result is a 100%, this finisher's duration permanently becomes permanent (though ends as normal once triggered), though you can only have a single instance of it active at a time.`,
                initiationAction: `1 free action`,
                range: `personal`,
                duration: `1d4 + 1 rd/10 <shadow>`,
                target: `you`,
                stacksOne:0,
                stacksOneName:"Inevitability"
              },
              {
                comboTags:["Arcane","Curse"],
                level: 1,
                name: "Sinister Spellbane",
                type: "Finisher",
                finisherType:"Strike",
                longDesc: `[arcane-curse-arcane] Make a melee attack against a creature, if it hits, it deals an additional 1d4 points of damage for every spell or spell-like ability they know. For 1 round the creature suffers a spell failure chance equal to 1/4 of the bonus damage dealt with this attack, to a maximum of your <curse/arcane> mastery.`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `1d4 rounds`,
                target: `you`,
              },
              {
                comboTags:["Light","Earth"],
                level: 1,
                name: "Sacred Ground",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[light-earth-light] You bless the ground beneath your feet for 3 rounds. Any ally that finishes their turn within the radius and is on the ground heals 1 hit point per 3 <light> mastery, and they gain a +1 deflection bonus per 5 <earth> mastery against creatures who are flying.`,
                initiationAction: `swift`,
                range: `30 feet`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags:["Light"],
                level: 2,
                name: "Benediction",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[light-{multi}-light] {multi} must be <light> points. If you have only a single <light> point in {multi} you can activate this as an immediate action when an ally within 30 feet is healed through positive energy. The healing is increased by 10%, plus 2% per <light> mastery. 
                \nIf {multi} contains at least 2 <light>, the duration increases to 1 round, it is activated as a swift action, and instead all allies healed with positive energy within the area gain this bonus healing. For each additional <light> point past 2, this finisher lasts an additional round. If an ally is healed to full hit points who wouldn't have without this bonus, they gain a +2 sacred bonus on attack rolls, saves, and skill checks for 1 round.`,
                initiationAction: `swift`,
                range: `30 feet`,
                duration: `see text`,
                target: `allies`,
              },
              {
                comboTags:["Light"],
                level: 1,
                name: "I Shall Preserve Thee",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[light-light-light] You grant a blessing of light to all allies within 30 feet of you for 1 round. The blessing causes all healing from positive energy to be increased by a percentage equal to your <light> mastery.`,
                initiationAction: `free`,
                range: `30 feet`,
                duration: `1 round`,
                target: `allies`,
              },
              {
                comboTags:["Technique","Light","Heroic"],
                level: 9,
                name: "Caliburnus",
                type: "Finisher",
                finisherType:"Strike",
                longDesc: `[technique-light-heroic-light-technique] You can choose where to aim this ability after the initiation action. Make an attack with a wielded heavy blade, applying the attack roll against all creatures in the area. You can expend <heroic> maneuvers to increase the damage, increasing it by an additional x1 it for every 10 levels of maneuvers spent (x2,x3,x4,etc.). The attack does a bonus 1d6 points of damage for every 10 <light> mastery you have. You can also expend technique maneuvers to reroll the attack roll against a specific creature, expending 4 levels per reroll. All of the damage of this attack is converted to untyped damage, and deals double damage against creatures weak to light.`,
                initiationAction: `1 round`,
                range: `60 foot cone or 120 foot line`,
                duration: `instantaneous`,
                target: `creatures`,
              },
              {
                comboTags:["Technique","Light"],
                level: 3,
                name: "Radiant Strike",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[technique-light-technique] Your next attack with a melee weapon can be at a range of up to 30 feet + <technique> mastery feet. The attack deals additional 1d6 points of untyped damage for every 10 <light> mastery. This bonus damage is light damage, and deals bonus damage against some creatures.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },
              {
                comboTags:["Technique","Dark"],
                level: 3,
                name: "Tenebris Aeternus",
                type: "Finisher",
                finisherType:"Strike",
                longDesc: `[technique-dark-technique] The next time within the duration that you successfully counter an enemy that you threaten, you can move 5 feet without provoking and make an attack against then as a free action you can take even when not your turn. They are flat-footed for this attack. If the attack hits, it deals damage as normal and then from then on every time that creature threatens an attack of opportunity from you, or you get an attack against them as part of a counter, the attack deals an additional 1d4 points of negative energy damage for every 5 <dark> mastery you have. If the creature provokes an attack of opportunity against you, you can also expend any <technique> maneuver to gain an attack of opportunity (doesn't cost sp), and the attack gains bonus attack equal to the level of the maneuver expended (you dont need to do this if you have normal attacks of opportunity available). After every attack made that gained benefits from this ability, you can move 5 feet without provoking.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ['Sakura','Death'],
                level: 5,
                name: `Falling Blossom`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[sakura-death-sakura] Make a full attack, for every attack you roll twice taking the higher result. For every potential critical hit you roll during this, all further attacks this round have their critical threat range increased by a flat +1.`,
                initiationAction: `standard`,
                range: `melee attack`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags: ['Sakura'],
                level: 1,
                name: `Dance of the East`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[sakura-sakura-sakura] You can take an additional 5-foot step every round. You can take this additional 5-foot step even if you have moved this round.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ['Sakura',"Royal"],
                level: 1,
                name: "Royal Waltz",
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[sakura-royal-sakura] Every time an attack misses you, you can move 5 feet and you gain a +1 dodge bonus to your armor class for 1 round. This movement does not provoke.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ['Void','Light'],
                level: 3,
                name: `Forbidden Healing`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[void-light-void] Expend 3 random maneuvers, then heal an ally (not you) heals 1d6 hit points for every level of every maneuver expended. The ally can then recover 3 random maneuvers. For every level of the maneuvers they recover, you heal 1d6 hit points.`,
                initiationAction: `free`,
                range: `30 feet`,
                duration: `instantaneous`,
                target: `ally`,
              },
              {
                comboTags: ['Void','Technique'],
                level: 3,
                name: `Twisting Nether`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[technique-void-technique] Make a melee attack against all creatures within reach (cannot intentionally miss). This attack deals 1d6 bonus force damage per 5 <void/technique> mastery. All creatures struck immediately move to any square within your reach of their choice. This movement doesn't provoke.`,
                initiationAction: `movement`,
                range: `threatened creatures`,
                duration: `instantaneous`,
                target: `creatures`,
              },
              {
                comboTags: ['Dark', 'Curse'],
                level: 3,
                name: `Dark Contract`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[curse-curse-dark-dark] You and the target both take damage equal to half of your maximum hit points. If the target is not dead within 3 rounds, they heal those hit points back and you lose hit points equal to your maximum hit points.`,
                initiationAction: `free`,
                range: `30 feet`,
                duration: `3 rounds`,
                target: `1 enemy`,
              },
              {
                comboTags: ['Primal','Death'],
                level: 1,
                name: `Coldblooded`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-death-primal] The first attack you take this turn gains a +5 bonus, the rest of the attacks this round gain a +4. For 2 rounds after, you gain a +2 bonus. Your first attack each turn, your attacks deal an additional 1d6 points of sneak attack damage, plus 1d6 per 10 <death/primal> mastery.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ['Primal','Void'],
                level: 1,
                name: `Apex Predator`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-void-primal] Make a melee attack, it deals an additional 1d6 points of damage for every time you have personally defeated an enemy this game. This finisher recovers every time you defeated an enemy. If you kill an enemy with this attack, you gain 5 Apex Stacks. For every 30 <primal/void> mastery the bonus damage increases by 1 step. Every time you are killed, the stacks reduce by half.`,
                initiationAction: `movement`,
                range: `melee attack`,
                duration: `instantaneous`,
                target: `1 enemy`,
                stacksOne:0,
                stacksOneName:"Apex Stacks",
              },
              {
                comboTags: ['Shadow','Water'],
                level: 1,
                name: `Cold Case`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[shadow-water-shadow] Make a melee attack, it deals an additional 1d6 points of cold damage per 5 <shadow/water> mastery. Afterwards, you can make an immediate stealth check and move up to half your speed. This movement does not provoke, and you can make this stealth check whether or not you have cover.`,
                initiationAction: `swift`,
                range: `melee attack`,
                duration: `1 round`,
                target: `1 enemy`,
              },
              {
                comboTags:["Fire"],
                level: 1,
                name: `Searing Flame`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[fire-fire-fire] You create a 15-ft cone of searing fire that deals 1d6 points of fire damage per 3 <fire> mastery. Creatures can make a reflex save to halve this. Every 10 <fire> mastery the cone's size increases by 5 feet.`,
                initiationAction: `swift`,
                range: `15-foot cone`,
                target: `creatures`,
                duration: `instantaneous`
              },
              {
                comboTags:['Air', 'Dark'],
                level: 1,
                name: `Nightcore`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[air-dark-air] You gain the benefits of the haste spell. All creatures who end their turn adjacent to you take 1d4 untyped damage per 5 <dark/air> mastery. Deaf and chaotic evil creatures are immune to this. Unless you are choatic evil you also take the damage this finisher deals, though it is halved unless you are lawful good.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags:['Fire', 'Flurry','Power'],
                level: 1,
                name: `Searing Onslaught`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-flurry/power-fire/power-fire] 3 times within the duration you gain the ability to make a special swift action attack. This attack is a normal melee attack at your highest bonus, except it deals additional fire damage. The first special attack you do it deals additional 1d6 points of fire damage per 10 <fire/power/flurry> mastery. The second attack deals 1d4 fire per 5 <fire/power/flurry> mastery. The third attack deals 1d6 points of fire damage per 10 <fire/power/flurry> mastery and its critical threat range and critical damage multiplier both increase by flat +1.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 minute`
              },
              {
                comboTags:["Water"],
                level: 1,
                name: `Tidal Surge`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[water-water-water] You create a 15-ft cone of water that deals 1d4 points of cold damage per 5 <water> mastery, reflex halves. Every 10 <water> mastery the cone's size increases by 5 feet. You can then make a bull rush attempt against all creatures within the area, pushing them directly away from you (doesn't provoke). You take a -5 penalty to bull rush creatures that succeeded on the reflex save.`,
                initiationAction: `movement`,
                range: `15-foot cone`,
                target: `creatures`,
                duration: `instantaneous`
              },
              {
                comboTags:["Air"],
                level: 1,
                name: `Conduit`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[air-air-air] You unleash a blast electricity around you, dealing 1d4 points of electricity damage per 5 <air> mastery to creatures in the area. Creatures struck may make a reflex save to halve. Creatures who fail must make a fortitude save DC +4 or become stunned until the start of their next turn. Every 30 <air> mastery the area increases by 5 feet.`,
                initiationAction: `free`,
                range: `10-foot radius`,
                target: `creatures`,
                duration: `instantaneous`
              },
              {
                comboTags:["Earth"],
                level: 1,
                name: `Acid Stream`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[earth-earth-earth] You unleash a blast of acid in a line, dealing 1d4 points of acid damage per 5 <earth> mastery to creatures in the area. Creatures struck may make a reflex save to halve. Every 20 <earth> mastery the distance increases by 5 feet. Creatures who fail the reflex save take an additional 1d4 points of acid damage per 10 <earth> mastery at the start of their next turn.`,
                initiationAction: `swift`,
                range: `30-foot line`,
                target: `creatures`,
                duration: `instantaneous`
              },
              {
                comboTags:["Air","Flurry"],
                level: 3,
                name: `Windfury`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[air-flurry-air] For 3 rounds, whenever you take a full attack, you can make an additional attack at your highest bonus-5. If you are two-weapon fighting, it instead is at your highest bonus.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags:["Fire","Dark"],
                level: 1,
                name: `Hellfire Blast`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-dark-fire] You unleash a blast of hellfire, this deals 1d8 points of fire damage per 3 <dark/fire> mastery. Creatures struck may make a reflex save to halve it. You also take half this damage, and can make a save to halve it further (though abilities like evasion do not function to negate it). All creatures struck (you excluded) also suffer a -2 penalty to all attack rolls for 1 round, unless they are evil.`,
                initiationAction: `movement`,
                range: `30 foot cone`,
                duration: `instantaneous`,
                target: `creatures`,
              },
              {
                comboTags:["Flurry", "Fire"],
                level: 1,
                name: `Wildfire`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-fire-flurry] When you make a full attack, you can take an additional melee attack at your highest bonus -5 against every enemy you threaten at the end of the full-round attack, but did not attack during it. These additional attacks deal an additional 1d4 points of fire damage per 10 <fire/flurry> mastery and give 1 immolation stack.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags:["Fire", "Air"],
                level: 3,
                name: `Billowing Inferno`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-air-air-fire] You pick a target within 30 feet. All creatures within 30 feet of them take immolation stacks equal to half of the primary targets immolation stacks. A reflex save reduces this by half.`,
                initiationAction: `movement`,
                range: `30 feet, Area: 30 feet`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags:["Guardian", "Flurry"],
                level: 1,
                name: `Iron Reprisal`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[guardian-flurry-flurry-guardian] For 1 round, you suffer a penalty to your armor class equal to your level, however whenever an enemy that you threaten attacks an ally other than you, it provokes an attack of opportunity from you, though it deals damage as if it were an off-hand attack, and it suffers a -6 penalty, unless it is made with an off-hand weapon. For every 10 <flurr/guardian> these attacks deal an additional 1d4 damage.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },
              {
                comboTags:["Fire", "Sakura"],
                level: 1,
                name: `Flash of Sunup`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[fire-sakura-fire] move 30 feet in a straight line, you can move through enemies during this finisher and the movement does not provoke. Make a melee attack against the first enemy who you move directly through. If the attack hits, they take an additional 1d4 points of fire damage per 5 <sakura/fire> mastery. They take a penalty on their next weapon damage roll equal to the fire damage the attack dealt (before resistances/immunities).`,
                initiationAction: `movement`,
                range: `melee attack`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },              
              {
                comboTags:["Fire", "Royal"],
                level: 1,
                name: `Judgement of the Burning Crown`,
                type: `Finisher`,
                finisherType:"Counter",
                longDesc: `[royal-fire-royal] You can initiate this finisher when you take damage. At the start of your next turn you may move up feet equal to your <fire> mastery and make a single melee attack, it deals additional damage equal to half the damage you took from the attack that activated this finisher. All of the additional damage is fire damage. If you strike the creature who damaged you, it instead becomes the full damage, and it increases by 1% per <royal> mastery.`,
                initiationAction: `free immediate action`,
                range: `melee attack`,
                duration: `1 round`,
                target: `1 enemy`,
              },
              {
                comboTags:["Water", "Air"],
                level: 1,
                name: `Biting Windchill`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[water-air-water] You create a cone of blistering cold, all creatures in the area take 1d6 points of cold damage per 5 <air/water> mastery, reflex halves, and all of them have their movement speed reduced by half for 1 round. If a creature who took damage from this does not move at least 10 feet during their next turn, they take a -4 penalty to their armor class and reflex saves for 1 round.`,
                initiationAction: `swift`,
                range: `30 foot cone`,
                duration: `1 round`,
                target: `creatures`,
              },
              {
                comboTags:["Air"],
                level: 1,
                name: `Airburst`,
                type: `Finisher`,
                finisherType:"Counter",
                longDesc: `[air-air-air] You create a concussive blast of air. Choose a square adjacent to you, all creatures within 10 feet of that space are moved 10 feet directly away from that point, you included. For every 10 <air> mastery, the distance moved and its area increases by 5 feet. Creatures can make a reflex save to halve the movement.`,
                initiationAction: `free immediate action`,
                range: `adjacent. Area: 10 feet`,
                duration: `instantaneous`,
                target: `creatures`,
              },
              {
                comboTags:["Death","Shadow"],
                level: 3,
                name: `The Shadow of Death`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-death-shadow] Pick a creature that can see you. You give it a look that drives a deep sense of fear right to its very core. The creature takes a -1 penalty on all attack rolls, saving throws, skill checks, and ability checks. At the start of each of your following turns, the penalty increases by -1. This penalty continues to increase each round, but ends when you damage the creature. When you damage them, the damage is increased by 1d6, plus 1d6 per 15 <death> mastery for every round this was active. Creatures immune to fear reduce the penalties they are taking from this by half. For every 30 <shadow> mastery, the initial penalty and the increase to the penalty every round increases by -1.`,
                initiationAction: `free`,
                range: `30 feet`,
                duration: `see text;`,
                target: `one creature`,
              },              
              {
                comboTags:["Earth","Void"],
                level: 1,
                name: `Tectonic Tide`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[earth-void-earth] Make a melee touch attack, it deals 1d6 points of force damage per 5 <earth/void> mastery, and the creature is moved directly away from you feet equal to 1/2 your <earth/void> mastery.`,
                initiationAction: `swift`,
                range: `reach`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags:["Primal","Air"],
                level: 1,
                name: `Thunderous Leap`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[primal-air-primal] You leap into the air and slam down in a thunderous crash. When you leap, you can move any direction feet equal to your movement speed plus 1/2 <primal/air> mastery. You must have an equal amount of space above you to do this. When you land, you slam down, dealing 1d6 points of electricity damage per 5 <air> mastery to all creatures adjacent to wherever you land. Instead of landing on the ground, you can choose to collide with a creature, if you do, instead make an unarmed attack against the target, success deals your damage as normal, plus the additional electricity damage. Doing this provokes an attack of opportunity.`,
                initiationAction: `movement`,
                range: `<air/primal> feet`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags:["Death","Fire"],
                level: 4,
                name: `Die in a Fire`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[death-fire-fire-death] You cause a creature to burst into flame. This deals 1d4 damage to them at the start of each of their turns. During the duration, every time you strike and damage them with a weapon attack, the damage they take at the start of each turn increases by 1d4. At the end of the duration, if their hit points are below 25%, they take the damage one more time. If this kills them, this finisher is recovered.`,
                initiationAction: `swift`,
                range: `30 feet`,
                duration: `3 rounds`,
                target: `1 enemy`,
              },
              {
                comboTags:["Death","Water"],
                level: 3,
                name: `Frozen Kiss`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[death-water-death] Make a melee attack against an enemy, they are paralyzed for the attack and it deals an additional 1d4 points of cold damage per 5 <water/death> mastery. If the attack is a critical hit, your critical damage multiplier increases by +1.`,
                initiationAction: `full round`,
                range: `melee attack`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags:["Flurry","Water"],
                level: 4,
                name: `Vortex Blades`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[flurry-water-flurry] Make an attack with two wielded weapons against all enemies within reach, each with a -5 penalty, plus the penalty you receive for two-weapon fighting. These attacks deal an additional 1d4 cold damage per 10 <flurry/water> mastery.`,
                initiationAction: `movement`,
                range: `melee attack`,
                duration: `instantaneous`,
                target: `enemies in reach`,
              },
              {
                comboTags:["Flurry","Dark", "Sakura"],
                level: 5,
                name: `Dual Eclipse, Dark Moon: Charon`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[flurry-dark-dark/sakura-flurry] Pick a target you threaten, they must predict the result of a 1d2 roll, if they guess incorrect, you make an attack with up to two wielded weapons against them, each dealing an additional 1d4 points of damage per 5 <dark/flurry> mastery. If they guess correct, they get an immediate attack on you, then you make a single melee attack against them with a -10 penalty, if it hits, the attack is an automatic critical threat, though if the attack was already within your normal critical threat range, the critical damage multiplier increases by +1.`,
                initiationAction: `swift`,
                range: `melee attack`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags:["Dark","Void"],
                level: 1,
                name: `Gaze Back`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[dark,void] You stare directly at a creature who is using a gaze attack, you must immediately take the effects of the gaze, if you succeed, you direct the gaze attack back on them, they suffer its effects, getting its save as normal, however they take a -1 penalty on any save related to it per 5 <void/dark> mastery. Their own gaze attack now bypasses any immunity they may have. If they fail the save to their own gaze, they are also paralyzed in fear for 1 round. If the creature is immune to fear, it instead is only staggered by the fear for 1 round.`,
                initiationAction: `movement`,
                range: `60 feet`,
                duration: `1 round`,
                target: `1 enemy`,
              },
              {
                comboTags:["Death","Void"],
                level: 3,
                name: `Dying Star`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[death-void-death] On the round you initiate this, all of your attacks deal an additional 1d6 points of damage per 10 <death/void> mastery and your melee reach increases by 10 feet during your turn. On the round after, they deal 1 point of additional damage per 5 <death/void> mastery and your reach increases by 5 feet during your turn. On the third round, you suffer a -2 penalty to damage per 5 <death/void> mastery and your reach decreases by 5 feet. You must use the same mastery to determine the bonuses and penalties of this whole finisher.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags:["Dark","Water"],
                level: 1,
                name: `Frigid Gaze`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[dark-water-dark] You give a deathy glare to all enemies within the area. They must make a will save or become shaken for 3 rounds and have their movement speed reduced by half. Creatures immune to fear are immune to the shaken, but not the movement speed reduction.`,
                initiationAction: `free`,
                range: `30 feet`,
                duration: `3 rounds`,
                target: `enemies`,
              },
              {
                comboTags:["Earth","Curse"],
                level: 1,
                name: `Cursed Ground`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth-curse-earth] You curse the ground beneath you, causing it to become difficult terrain for 3 rounds for enemies. All enemies that end their turn on the cursed ground suffer a -2 penalty to armor class and saves for 1 round.`,
                initiationAction: `free`,
                range: `0 feet. Area: 10 foot radius`,
                duration: `3 rounds`,
                target: `ground`,
              },
              {
                comboTags: ['Earth','Void',"Dark"],
                level: 4,
                name: "Chthonic Burial",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[earth-void,dark-earth] Make a melee attack against a creature, if it hits, it deals damage as normal but the creature must also make a reflex save or be immediately dragged deep underground. Once a creature is underground, it can take no actions, cannot be targeted or target other creatures, and every turn it must attempt a will save, failure results in it taking 1d6 points of negative energy damage per 5 <void/dark> mastery and it continues to be trapped underground for another round, the DC to escape increasing by +2 each time it fails the save. For every 10 <earth> mastery, the creature must make an additional will save to escape, however if it succeeds on a save, it may make another one immediately. Once a creature saves, it returns to its previous position immediately.`,
                initiationAction: `standard`,
                range: `melee attack`,
                duration: `see text;`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Elemental","Arcane"],
                level: 1,
                name: "Elemental Conduit",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[elemental-arcane-elemental] both <elemental> must be the same type. As a part of initiating this finisher you cast a spell with the same elemental type. A spell cast this way does not require a free hand to cast.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
              },
              {
                comboTags: ["Shadow","Technique","Void"],
                level: 3,
                name: "Really Finishing",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[void-shadow-technique-void] The next time you initiate a finisher this floor, you can initiate it again as a part of the same action.`,
                initiationAction: `full round`,
                range: `personal`,
                duration: `floor`,
                target: `you`,
              },
              {
                school: "elementalFlux",
                level: 2,
                name: "Elemental Unload",
                type: "Strike",
                longDesc: `Expend as many elemental combo points as you have, then make an attack. It deals 1d4 points of bonus damage of the elements of the points expended. For every unique element of the points expended past the first, the bonus elemental damage increases by 1 step.`,
                initiationAction: `standard`,
                range: `melee or ranged attack`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                school: "elementalFlux",
                level: 3,
                name: "Elemental Infusion",
                type: "Stance",
                longDesc: `Increase your caster level for spells of the type of your active element by +1. This bypasses the usual level cap on spells. Every time you complete the casting of an elemental spell in combat you gain a combo point for the element of the type. You can only every gain a single combo point from casting a spell.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `stance`,
                target: `you`,
                additionalTags:["Fire","Earth","Air","Water"]
              },
              {
                school: "elementalFlux",
                level: 3,
                name: "Arcane Combo",
                type: "Boost",
                longDesc: `You can expend <elemental> combo points of the same element when you initiate this boost, if the next spell you cast this round is of the same type as the <elemental> combo points spent, the spell deals an additional point of damage per dice rolled for each <elemental> combo points spent.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },
              {
                school: "silverCrane",
                level: 3,
                name: "Divine Combo",
                type: "Boost",
                longDesc: `You can expend <light> combo points when you initiate this boost, the next healing spell you cast this round has its healing increased by 1 point per dice rolled for every combo point expended.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },
              {
                school: "silverCrane",
                level: 3,
                name: "Light Infusion",
                type: "Stance",
                longDesc: `Whenever you complete the casting of a healing spell in combat you gain a <light> combo point. Healing spells that heal hit points heal an additional hit point for every <light> combo point you have * their caster level. You can only every gain a single combo point from casting a spell.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `Stance`,
                target: `you`,
                additionalTags:["Light"]
              },
              {
                school: "cursedRazor",
                level: 3,
                name: "Dark Infusion",
                type: "Stance",
                longDesc: `Whenever you complete the casting of a control spell in combat you gain a <curse> combo point. For every 3 <curse> combo points you have when you cast a control spell, its DC increases by +1. You can only every gain a single combo point from casting a spell.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `Stance`,
                target: `you`,
                additionalTags:["Curse"]
              },
              {
                school: "cursedRazor",
                level: 3,
                name: "Cursed Combo",
                type: "Boost",
                longDesc: `You can expend <curse> combo points when you initiate this boost, the next control spell you cast this round has its DC increased by +1 per 2 combo points spent, and gains a +1 bonus to defeat spell resistance per <curse> combo point spent.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },
              {
                school: "goldenLion",
                level: 3,
                name: "Heroic Infusion",
                type: "Stance",
                longDesc: `Whenever you complete the casting of a buff spell in combat you gain a <heroic> combo point. Whenever you cast a buff spell on an ally, they gain a morale bonus to one of: armor class, attack rolls, damage rolls, or saves for 1 round, equal to your current amount of <heroic> combo points.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `Stance`,
                target: `you`,
                additionalTags:["Heroic"]
              },
              {
                school: "goldenLion",
                level: 3,
                name: "Heroic Combo",
                type: "Boost",
                longDesc: `You can expend <heroic> combo points when you initiate this boost, the next buff spell you cast this round has its caster level increased by +1 per combo point spent.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },
              {
                school: "shadowAssassin",
                level: 3,
                name: "Shadow Infusion",
                type: "Stance",
                longDesc: `Whenever you cast a utility or illusion spell in combat you gain a <shadow> combo point. While in this stance, for every <shadow> combo point you have, you gain a 5% miss chance (foiled by truesight and blindsight). This miss chance stacks with other miss chances, though it is reduced by half. You can as an immediate action expend a <shadow> combo point when you are attacked and the attack either bypasses your miss chance, or if it rolls to determine if it hits you and succeeds. Doing this causes the creature to need to roll for your miss chance, or reroll your miss chance.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `Stance`,
                target: `you`,
                additionalTags:["Shadow"]
              },
              {
                school: "shadowAssassin",
                level: 3,
                name: "Shadow Boost",
                type: "Boost",
                longDesc: `As a part of initiating this boost you can spend <shadow> combo points while also casting a utility or illusion spell. The spell must be of a level lower than the amount of combo points spent and also cannot be a spell within 3 levels of your highest spell level known.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
              },
              {
                comboTags: ["Void"],
                level: 1,
                name: "Visualize Finishing",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[void-void] Remove any unwanted combo points in your bar and gain a single one of a maneuver you know. You must expend that maneuver. Using this finisher does not otherwise clear your finisher combo.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
              },
              {
                comboTags: ["Royal"],
                level: 1,
                name: "Royal Aid",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[royal-arcane-royal] An ally within 30 feet can cast a single spell targeting you as an immediate action. This spell must be a spell that can target you, and it can ignore restrictions on its range, however, the spell has its spell point cost doubled and it only affects you, regardless of how many creatures it would normally affect or target. This spell also cannot be of their highest level of spell known.`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
              },
              {
                comboTags: ["Earth","Light"],
                level: 1,
                name: "Serenity",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[earth-light-earth] Reduce the damage the creature deals with its next weapon attack by 1/3 <earth/light> mastery. If this reduces the damage to 0, the creature takes the damage instead.`,
                initiationAction: `free`,
                range: `30 feet`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Earth","Royal"],
                level: 1,
                name: "Untouchable Crown",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[earth-royal-earth] the next time you take damage within the duration, reduce the damage you take by your <earth/royal> mastery. If this reduces the damage to 0, the creature who dealt the damage takes it instead.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Earth","Dark"],
                level: 1,
                name: "Blunt Force Trauma",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[earth-death-earth] Make a melee attack with a -4 penalty, this gains the bonuses you gain for attacking with an improvised weapon. If it hits, it deals damage as normal and if the creature has a discernable head, it becomes dizzy for 1 round, suffering a -2 penalty on attack rolls and loses up to 1 point of its dexterity bonus to its armor class, +1 per 10 <death/earth> mastery. If this reduces its dexterity bonus to armor class to 0, it also falls prone. This doesn't count as being denied its dexterity bonus to armor class. If the creature is flying but would fall prone, it instead takes a -4 penalty to attacks and armor class for 1 round.`,
                initiationAction: `swift`,
                range: `melee attack`,
                duration: `1 round`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Shadow","Void"],
                level: 1,
                name: "Wierd Attack",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[void-shadow-void] Make an attack against an enemy, if it hits, all enemies in this combat except the one you attacked takes the damage. For every 10 <shadow/void> mastery this attack deals an additional 1d6 points of damage.`,
                initiationAction: `swift`,
                range: `melee or ranged attack`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Void"],
                level: 1,
                name: "Time Out",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[void-void-void] Make a melee touch attack, if it hits, it doesn't do damage, but instead the creature is shunted forwards in time, reappearing in 1 round.`,
                initiationAction: `swift`,
                range: `melee attack`,
                duration: `1 round`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Fire"],
                level: 3,
                name: "Violent Flame",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[fire-fire-fire] Your next melee attack is dealt in a cone, comparing the results of the attack to all targets within the area. The area of the cone is 15 feet, plus 5 feet per 15 <fire> mastery. All of the damage of this attack is converted to fire damage, and it deals an additional 1d6 points of fire damage per 10 <fire> mastery.`,
                initiationAction: `swift`,
                range: `melee attack`,
                duration: `1 round`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Shadow", "Void", "Death"],
                level: 6,
                name: "Dimensional Ambush",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[shadow-death-void-death-shadow] The next time an enemy enters the combat, you immediately teleport adjacent to them, have a single standard action to attack them, for which they are flat-footed, and then you immediately teleport back to your previous space.`,
                initiationAction: `swift`,
                range: `map`,
                duration: `1 combat`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Void"],
                level: 4,
                name: "Echoes from the Future",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[void-void-void-void-void] In 5 turns, you gain an additional standard action.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `5 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Primal"],
                level: 3,
                name: "Wild Surge",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[primal-primal-primal-primal-primal] Choose a strike with an initiation action of a standard action or less, plus an additional strike for every 10 maneuvers you know. Expend up to your level in random maneuvers (no sp cost), if one of the chosen maneuvers is expended, you can initiate it as a part of this action. For every 30 <primal> mastery, you can choose an additional maneuver.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
              },
              {
                comboTags: ["Primal"],
                level: 5,
                name: "Beastial Surge",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[primal-primal-primal-primal-primal] Choose a strike with an initiation action of a standard action or less, expend random maneuvers (no sp cost) until you expend it, then you can initiate it immediately.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
              },
              {
                comboTags: ["Void","Water"],
                level: 1,
                name: "In the Zone",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[water-void-water] The next maneuver you initiate restores spell points instead of expending them. For every 15 <water/void> mastery this lasts an additional maneuver.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `24 hours`,
                target: `you`,
              },
              {
                comboTags: ["Void","Water","Heroic"],
                level: 4,
                name: "Lock In",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[water-heroic,void-water] The next maneuver you and all allies within 30 feet initiate restores spell points instead of expending them. For every 30 <water/void> mastery this lasts an additional maneuver.`,
                initiationAction: `swift`,
                range: `30 feet`,
                duration: `24 hours`,
                target: `allies`,
              },
              {
                comboTags: ["Curse","Technique"],
                level: 1,
                name: "Curse: Getting Stabbed",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[curse-technique-curse] Make a melee attack against all enemies currently cursed by you or an ally. You can make this melee attack regardles of range. For every 10 <curse/technique> mastery this attack deals an additional 1d4 damage.`,
                initiationAction: `movement`,
                range: `map`,
                duration: `instantaneous`,
                target: `cursed enemies`,
              },
              {
                comboTags: ["Air","Royal","Sakura"],
                level: 1,
                name: "Barrel Roll",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[air-royal/sakura-air] You do a barrel roll. When attacked you can initiate this finisher as a free action you can take even when not your turn. You immediately move 10 feet without provoking attacks of opportunity and gain a +4 dodge bonus to your armor class for 1 round. For every 10 <air> mastery the movement distance increases by 5 feet. For every 10 <sakura/royal> mastery the dodge bonus increases by +1. Additionally, all frogs gain a +1 morale bonus to all rolls for 1 round.`,
                initiationAction: `free immediate action`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },              
              {
                comboTags: ["Shadow","Light"],
                level: 3,
                name: "Stolen Light",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[shadow-light-shadow] Make a melee touch attack against a creature. If it hits it deals no damage, but for 3 rounds the creature's fast healing and regeneration is reduced to by 1 point per 3 <shadow/light> mastery and you gain fast healing equal to the amount reduced. If this reduces the creature's fast healing/regeneration below 0, it takes that amount of damage at the start of each of its turns. If this reduces the creatures regeneration to 0, this does not cause it to die earlier than it normally would, only that it no longer heals while this is active. If the creature is healed through other means, it must attempt a will save against this maneuver or the healing is also transfered to you. If you are healed to full health while this is active, it ends.`,
                initiationAction: `swift`,
                range: `melee attack`,
                duration: `3 rounds`,
                target: `1 creature`,
              },
              {
                comboTags: ["Light","Curse"],
                level: 1,
                name: "Die in Darkness",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[curse-light-curse] Make an attack, it deals no damage, however unless the creature heals itself through means that isn't fast healing or regeneration by the end of its next turn, it takes the damage. For every 5 <light/curse> mastery this attack deals an additional 1d6 damage.`,
                initiationAction: `free`,
                range: `melee or ranged attack`,
                duration: `1 round`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Primal"],
                level: 9,
                name: "Primal Fury",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[primal-primal-primal-primal-primal-primal-primal] Make a charge attack and take a full-round attack at the end of it. Instead of an attack, you are allowed to make a strike with an initiation action of a standard action or less. Each time you do initiate a strike this way, you take 2 constitution drain. For every 20 <primal> mastery, the total amount of constitution drain you take is reduced by 2. You cannot initiate any other boosts this turn.`,
                initiationAction: `full-round`,
                range: `melee attack`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Primal"],
                level: 1,
                name: "Primal Inspiration",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[primal-primal-primal] Expend up to 1 random maneuver (no sp cost) per 5 <primal mastery>. For rounds equal to twice the amount of maneuvers you expended, you recover a random maneuver at the start of each of your turns. You cannot initiate it the round you recover it.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `see text;`,
                target: `you`,
              },
              {
                comboTags: ["Primal","Flurry"],
                level: 8,
                name: "Unleash the Beast",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[primal/flurry-primal/flurry-primal/flurry-primal/flurry-primal/flurry-primal/flurry] Expend 3 random maneuvers, you can initiate all of them as part of the initiation action. You cannot initiate any other boosts this turn. For every 50 <primal/flurry>, you can expend an additional random maneuver, however you still can only initiate 3 of them.`,
                initiationAction: `full-round`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
              },
              {
                comboTags: ["Primal","Sakura"],
                level: 1,
                name: "Primal Instincts",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[sakura-primal-sakura] Gain blindsight with a range of 1 foot per <primal/sakura> mastery. You can focus these instincts as a movement action to double the range during that movement action.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Primal","Sakura"],
                level: 1,
                name: "Predatory Instincts",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[primal-sakura-sakura-primal] Increase your critical threat range with melee weapons by a flat +1. Your critical hits deal an additional 1d6 precision damage, + 1d6 per 10 <sakura/primal> mastery.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Technique","Power"],
                level: 1,
                name: "Blade Fury",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[technique-power-power-technique] Increase your critical damage multiplier with melee weapons by +1.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Shadow","Void"],
                level: 1,
                name: "Cheat Time",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[shadow-void-shadow] The next time you would die, you instead ignore the killing damage and disappear from time for 1d2+1 rounds, reappearing anywhere within 30 feet of where you left. You heal hit points equal to your <shadow/void> mastery.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `5 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Light","Dark"],
                level: 1,
                name: "Feed the Demon",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[dark-light-dark] The target creature takes 1d4 points of negative energy damage, plus 1d4 per 5 <dark/light> mastery. You heal half the damage it takes.`,
                initiationAction: `free`,
                range: `30 feet`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Arcane","Heroic"],
                level: 1,
                name: "Heroic Sacrifice",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[heroic-arcana-heroic] Choose an ally within the range, they can as an immediate action cast any damage spell. Spells cast this way have their cost increased by 100% and the spell must include you in its area. The caster of the spell is staggered on its next turn (unresistable and unremovable)`,
                initiationAction: `swift`,
                range: `60 feet`,
                duration: `instantaneous`,
                target: `1 ally`,
              },
              {
                comboTags: ["Arcane","Void"],
                level: 7,
                name: "Echo From the Beyond",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[void-arcana-arcane-arcane-void] Summon a copy of yourself in a square within 30 feet which gets to take an immediate turn. It has all of your current stats, however its current and max hit points are reduced by half, and it only deals a percentage of your damage equal to your <void/arcana> mastery. Spells that dont do damage have a percentage to fail equal to 100% - <void/arcane> mastery. If this copy dies, you also die. Any spell points it spends, you also lose at the end of its duration. If this reduces you to 0 or lower spell points, you are stunned for 2 rounds (unresistable and unremovable).`,
                initiationAction: `swift`,
                range: `30 feet`,
                duration: `1 round`,
                target: `you`,
              },
              {
                comboTags: ["Dark","Shadow","Death"],
                level: 1,
                name: "Decimation",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[dark-death/shadow-dark] Gain 1d6 points of sneak attack for the duration. For every 30 <death/shadow/dark> mastery the damage increases by 1d6.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Heroic", "Dark"],
                level: 3,
                name: "Triumphant Ascension",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[heroic-dark-heroic] If you defeat an opponent this round, you gain a +1 bonus on all attack rolls, damage rolls, saves, and ability checks for the rest of the floor. For every 30 <dark/heroic> mastery this increases by +1.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `1 round and 24 hours`,
                target: `you`,
              },
              {
                comboTags: ["Light"],
                level: 3,
                name: "Miracle Worker",
                type: "Finisher",
                finisherType: "Boost",
                longDesc: `[light-light-light] All healing you do to allies other than yourself is increased by 25% plus 1% per 3 <light> mastery for 2 rounds.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `2 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Light","Dark"],
                level: 1,
                name: "Retribution",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[light-dark-light] Make an attack with a -10 penalty (or -5 if initiated as swift), if it hits, it deals damage as normal and you can heal an ally within 30 feet of you (cannot heal yourself) for an amount equal to the damage your attack dealt. The chosen ally must be a creature that the target of the attack has damaged in the last 2 rounds.`,
                initiationAction: `free or swift`,
                range: `30 feet`,
                duration: `instantaneous`,
                target: `1 ally`,
              },
              {
                comboTags: ["Death", "Dark"],
                level: 9,
                name: "Fatal Touch",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[death-dark-dark-dark-death] Make a touch attack, if it hits and the creature has less hit points than you, it dies. If the creature is immune to death effects, you must have twice its current hit points.`,
                initiationAction: `standard`,
                range: `melee attack`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Royal","Curse"],
                level: 1,
                name: "Divine Judgement",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[light-dark-light] Make a melee attack, if it hits it deals damage as normal, but depending on how close your alignment is to the creature, it suffers a penalties on all attack rolls, saves, and ability checks.\n\nSame Alignment: -4 for 3 rounds\n1 Step Away: -3 for 2 rounds\n2 Steps Away: -2 for 1 round.`,
                initiationAction: `swift`,
                range: `melee attack`,
                duration: `max 3 rounds`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Dark","Curse"],
                level: 3,
                name: "Die With Me",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[dark-curse-curse-dark] You bind yourself to the target and ready to do anything to kill them. You automatically crit yourself (rolling for potential multi-crits normally), then the target takes damage equal to the damage you did (will save halves). The damage they take is increased by a percentage equal to your <dark/curse>.`,
                initiationAction: `movement`,
                range: `60 feet`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Technique","Curse"],
                level: 5,
                name: "Five Point Palm Exploding Heart Technique",
                type: "Finisher",
                finisherType: "Strike",
                longDesc: `[technique-curse-curse-technique] [death] You make an unarmed attack against an opponent, if it hits, it doesn't deal any damage, but instead once the creature takes 7 steps, it's heart explodes and it dies. A walking creature can move a distance equal to 7 times its size before it dies, however every individual time it moves it counts as at least 1 step (such as taking a 5-foot step). Creatures immune to critical hits or those without hearts are immune to this effect. A heal spell, regeneration, restoration, or similar or more powerful effects end this.`,
                initiationAction: `standard`,
                range: `melee attack`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Earth"],
                level: 1,
                name: `Tremoring Earth`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[earth-earth-earth] Make a melee attack with a -5 penalty to attack (or none if initiated as swift), but a +1 bonus on its critical damage multiplier. If it hits, it deals damage as normal and the target must make a fortitude save or be unable to cast spells or spell-like abilities for 1 round, plus 1 round per 40 <earth> mastery.`,
                initiationAction: `free or swift`,
                range: `Melee attack`,
                target: `One creature`,
                duration: `1 rd + 1rd/40 <earth>`,
              },
              {
                comboTags: ["Air"],
                level: 1,
                name: `Gathering Winds`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[air-air-air] Make a melee attack with a -8 penalty (or -4 if initiated as a swift), if successful it deals damage as normal and the target must make a fortitude save or be surrounded by buffeting winds, causing all attacks it makes to suffer a 20% miss chance for 1 round, plus 1 round per 40 <air> mastery. This stacks with other miss chances (but is rolled seperately), except those that are essentially the same effect on the creature.`,
                initiationAction: `free swift`,
                range: `Melee attack`,
                target: `One creature`,
                duration: `1 rd + 1rd/30 <air>`
              },
              {
                comboTags: ["Water"],
                level: 1,
                name: `Strike of Seasickness`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[water-water-water] Make a melee attack with a -5 penalty (or none if initiated as swift), if successful it deals damage as normal and the target must make a fortitude save or be staggered for 1 round, plus 1 round per 10 <water> mastery.`,
                initiationAction: `free`,
                range: `Melee attack`,
                target: `One creature`,
                duration: `1 rd + 1rd/10 <water>`
              },              
              {
                comboTags: ["Earth","Light"],
                level: 1,
                name: `Strength of Stone`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth-light-earth] With a quick prayer you grant a blessing of earth to yourself and all allies within 30 feet of you for 1 round, plus 1 round per 30 <earth/light> mastery. All allies blessed becomes immune to daze, paralysis, stun, and sleep.`,
                initiationAction: `free`,
                range: `30 feet`,
                target: `all allies`,
                duration: `1 rd + 1rd/20 <earth/light>`
              },
              {
                comboTags: ["Air","Light"],
                level: 1,
                name: `Cloud Walker`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[air-light-air] With a quick prayer you grant a blessing of air to yourself and all allies within 30 feet of you for 2 rounds, +1 round per 50 <light/air> mastery. All allies blessed are surrounded in buffeting winds, causing all physical attacks against them to suffer a 20% miss chance. This stacks with other miss chances (but is rolled seperately), except those that are essentially the same effect on the creature.`,
                initiationAction: `free`,
                range: `30 feet`,
                target: `all allies`,
                duration: `2 rds + 1 rd/50 <light/air>`
              },
              {
                comboTags: ["Fire","Light"],
                level: 1,
                name: `Bask in the Sun`,
                type: `Finisher`,
                longDesc: `[fire-light-fire] With a quick prayer you grant a blessing to yourself and all allies within 30 feet of you for 2 rounds, +1 round per 50 <fire/light> mastery. All allies blessed gain a +2 bonus on attack rolls, saves, and skill checks.`,
                initiationAction: `free`,
                range: `30 feet`,
                target: `all allies`,
                duration: `2 rds + 1 rd/50 <light/fire>`
              },
              {
                comboTags: ["Water","Light"],
                level: 1,
                name: `Flow of Light`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[water-light-water] With a quick prayer you grant a blessing to yourself and all allies within 30 feet for 2 rounds. All allies blessed have the cost of their spells reduced by 25% (minimum 0 spell point reduction). They also gain 1d4, plus 1d4 every 25 <water/light> mastery temporary spell points that last 1 round. You gain the reduction to spell point costs, but not the temporary spell points.`,
                initiationAction: `swift`,
                range: `30 feet`,
                target: `all allies`,
                duration: `2 rds`
              },
              {
                comboTags: ["Dark"],
                level: 1,
                name: `Cursed Strike`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[dark-dark-dark] [curse] Make a melee attack with a -10 penalty (or -5 if initiated as swift), if successful it deals damage as normal and the target must make a fortitude save or be struck by a terrible curse, halving all positive energy healing done to them, and reducing their fortification by 25%, and increasing its negative energy vulnerability by 25% for 3 rounds, plus 1 round per 20 <dark> mastery.`,
                initiationAction: `free or swift`,
                range: `melee attack`,
                target: `one creature`,
                duration: `3 rds + 1 rd/20 <dark>`
              },
              {
                comboTags: ["Earth", "Dark"],
                level: 1,
                name: `Pain Strike`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[earth-dark-earth] Make a melee attack with a -10 penalty (or -5 if initiated as swift), if successful it deals damage as normal and the target must make a fortitude save or be nauseated for 1 round, plus 1 round per 30 <earth/dark> mastery.`,
                initiationAction: `free or swift`,
                range: `melee attack`,
                target: `one creature`,
                duration: `1 rd + 1 rd/30 <dark/earth>`
              },
              {
                comboTags: ["Air","Dark"],
                level: 1,
                name: `Blinding Strike`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[air-dark-air] Make a melee attack with a -10 penalty (or -5 if initiated as swift), if successful it deals damage as normal and the target must make a fortitude save (dc= 10 + level/2 + initiation modifier) or become blind for 1 round, plus 1 round per 30 <air/dark> mastery.`,
                initiationAction: `free or swift`,
                range: `melee attack`,
                target: `one creature`,
                duration: `1 rd + 1 rd/20 <dark/air>`
              },
              {
                comboTags: ["Fire","Dark"],
                level: 1,
                name: `Burning Wrath`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[fire-dark-fire] Make a melee attack with a -5 penalty, it gains a flat +1 bonus to its critical threat range, +1 per 30 <fire/dark> mastery.`,
                spCost:"level spell points",
                initiationAction: `swift or movement`,
                range: `melee attack`,
                target: `one creature`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Water","Dark"],
                level: 1,
                name: `Frozen Heart`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[water-dark-water] Make a melee attack with a -5 penalty, if successful it deals damage as normal and the target must make a fortitude save or become paralysed for 1 round, plus 1 round per 50 <dark/water> mastery.`,
                initiationAction: `swift or movement`,
                range: `melee attack`,
                target: `one creature`,
                duration: `1 rd + 1 rd/30 <dark/water>`
              },
              {
                comboTags: ["Void"],
                level: 1,
                name: `Warped Force`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[void-void-void] Make a melee attack with a -10 penalty (or -5 if initiated as swift), if successful it deals damage as normal and you can make a free bull rush attempt against the creature as a free action gaining a bonus on the attempt equal to half the damage dealt by the attack. This bull rush attempt does not provoke and you cannot follow the creature.`,
                initiationAction: `free`,
                range: `melee attack`,
                target: `one creature`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Earth","Void"],
                level: 1,
                name: `Stardust`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth-void-earth] With a quick prayer, you grant a blessing to yourself and all allies within 30 feet 30 feet of you. For 3 rounds, all those blessed gain fortification equal to your <void/earth> mastery. This stacks with other fortification, but it is reduced by half.`,
                initiationAction: `free`,
                range: `30 feet`,
                target: `all allies`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Earth","Curse","Void"],
                level: 1,
                name: `Return to Dust`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[void-earth-curse-void] With a quick curse, you twist the essence of a creature, drawing it back to the dust from which it came. For 3 rounds the creature has its fortification reduced by 1% per <void/earth/curse> mastery. You deal additional damage on critical hits against the creature of 1 per 2 <void/earth/void> mastery. This additional damage is not multiplied by the critical hit.`,
                initiationAction: `free`,
                range: `60 feet`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Water", "Curse"],
                level: 1,
                name: `Corruption`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[water-curse-water] With a quick curse, you twist the flesh of a creature, reducing its damage reduction by 1 point per 5 <water/curse> mastery for 2 rounds. If this reduces its DR to 0, any additional points reduce its natural armor bonus. If this reduces its natural armor to 0, an additional points are dealt as constitution damage.`,
                initiationAction: `free`,
                range: `60 feet`,
                target: `1 enemy`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Arcane", "Curse"],
                level: 1,
                name: `Cursed Weave`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[arcane-curse-arcane] With a quick curse, you twist a creature's connection to the weaves of magic, causing it to suffer a spell failure chance equal to your <arcane/curse> mastery for 2 rounds. If the creature rolls a 1 on this spell failure chance on a harmful spell, the spell is turned on them. It only affects them, even if it would normally affect multiple creatures, and AoO spells only target their current squares.`,
                initiationAction: `swift`,
                range: `60 feet`,
                target: `1 enemy`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Guardian", "Curse"],
                level: 1,
                name: `Rattling Blow`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[guardian-curse-guardian] Make an attack against a creature with a -5 penalty, if successful, it deals damage as normal, but the damage counts as continuous damage for the next 2 rounds for making concentration checks on spells and spell-like abilities.`,
                initiationAction: `free`,
                range: `melee or ranged attack`,
                target: `1 enemy`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Air","Void"],
                level: 1,
                name: `Step of the Void`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[air-void-air] You can teleport to any square within feet equal to your <void/air>. You can initiate this finisher as a free action even when it is not your turn, though it does not negate actions taken against you.`,
                initiationAction: `free`,
                range: `<void/air> feet`,
                target: `you`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Flurry","Earth"],
                level: 1,
                name: `Seismic Slash`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-earth-earth-flurry] You spin your weapons around you in a devastating swing empowered by the weight of stone. Make a melee attack against all threatened enemies, the damage of the attack increases by 1 size step per 10 <earth> mastery, but for every enemy past the first that you hit, the damage increases by 1 dice step. You can instead choose to initiate this finisher to attack only a single creature, making an attack with two wielded weapons against them, taking penalties as if two-weapon fighting, but instead increasing the damage by only 1 dice step plus 1 dice step per 15 <earth/flurry> mastery.`,
                initiationAction: `movement`,
                range: `melee attack`,
                target: `threatened enemies`,
                duration: `instantaneous`
              },
              {
                school:"brokenBlade",
                level: 2,
                name: `Rolling Leg Takedown`,
                type: `Strike`,
                longDesc: `You drop to the ground while wrapping your legs around an enemy and twisting your body to take a creature's legs out from under them. Make an unarmed trip attempt against a threatened creature and then fall prone. This trip attempt does not provoke attacks of opportunity and you gain a +4 bonus to it. If the trip attempt succeeds, you can also move 5 feet without provoking attacks of opportunity.`,
                initiationAction: `movement`,
                range: `melee attack`,
                target: `threatened enemies`,
                duration: `instantaneous`
              },
              {
                school:"brokenBlade",
                level: 4,
                name: `Spinning Leg Sweep`,
                type: `Strike`,
                longDesc: `You drop to the ground and spin your legs around, attemping to sweep the legs out from beneath the enemies around you. Make an trip attempt against all threatened enemies and then fall prone. This trip attempt does not provoke attacks of opportunity and you gain a +2 bonus to it.`,
                initiationAction: `movement`,
                range: `melee attack`,
                target: `threatened enemies`,
                duration: `instantaneous`
              },
              {
                school:"brokenBlade",
                level: 3,
                name: `Shoving Kick`,
                type: `Strike`,
                longDesc: `You make an unarmed attack with your foot (doesn't provoke). If it hits, it deals damage as if it was an off-hand attack, and if they are a size you are allowed to bull rush, they are moved 5 feet directly away from you.`,
                initiationAction: `movement`,
                range: `melee attack`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                school:"rivenHourglass",
                level: 3,
                name: `Extra Tick`,
                type: `Boost`,
                longDesc: `[Time Pocket] Gain a swift action. You can have only a single additional action from [Time Pocket] maneuvers at a time. Actions gained from [Time Pocket] maneuvers last through rounds, but once used are expended. They are also lost as the start or end of combat.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `5 rounds or until expended`,
                //additionalInfoTags:["Time Pocket"]
              },
              {
                school:"rivenHourglass",
                level: 5,
                name: `Second Second`,
                type: `Boost`,
                longDesc: `[Time Pocket] Gain an immediate action. You can have only a single additional action from [Time Pocket] maneuvers at a time. Actions gained from [Time Pocket] maneuvers last through rounds, but once used are expended. They are also lost as the start or end of combat.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `5 rounds or until expended`,
                //additionalInfoTags:["Time Pocket"]
              },
              {
                school:"rivenHourglass",
                level: 2,
                name: `Count of the Clock`,
                type: `Boost`,
                longDesc: `[Time Pocket] Gain a movement action. You can have only a single additional action from [Time Pocket] maneuvers at a time. Actions gained from [Time Pocket] maneuvers last through rounds, but once used are expended. They are also lost as the start or end of combat.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `5 rounds or until expended`,
                //additionalInfoTags:["Time Pocket"]
              },
              {
                school:"mithralCurrent",
                level: 4,
                name: `Modorishio`,
                type: `Boost`,
                longDesc: `Move 10 feet and sheath a weapon without provoking attacks of opportunity. You cannot attack for the rest of your turn, however, until the end of your next turn you gain the benefit of the quickdraw feat, and when you draw your weapon as part of an attack, your reach increases by 5 feet and the attacks deals an additional 1d6 damage. You can draw weapons as a part of attacks of opportunity, and you threaten the area around you as if your weapon was drawn.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Air","Void"],
                level: 1,
                name: `Drawn into Oblivion`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[air-void-air] You make a melee touch attack, if it hits it deals no damage, but you and the target of the attack teleport to any square within feet equal to your <void/air> mastery. You and the target arrive adjacent to each other. It receives a will save to negate this, however it takes a penalty equal to -1 per 10 <void/air> mastery. The chosen destination must have space to accomedate you both or it automatically fails.`,
                initiationAction: `free`,
                range: `<void/air> feet`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Dark","Arcane"],
                level: 1,
                name: `Fear The Violence`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[dark-arcane-dark] For 3 rounds you increase the concentration DC for threatened enemies to cast defensively by +4, +1 per 10 <dark/arcane> mastery.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Dark","Arcane"],
                level: 1,
                name: `Murderous Presence`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[dark-death-dark] For 3 rounds, enemies within 30 feet of you take a -2 penalty on saves against fear, and when shaken the penalty they take to rolls increases by -1. For every 30 <dark/death> mastery the penalties to their saves and what is taken when shaken increases by a further -1.`,
                initiationAction: `free`,
                range: `30 feet`,
                target: `enemies`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Death","Void"],
                level: 3,
                name: `Cosmic Predator`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[death-void-death] You teleport an enemy within feet equal to your <void/death> mastery to any square within your threatened area and then make an immediate melee attack against them. Afterwards, the creature makes a will save, on success it immediatly teleports back to its previous space, otherwise it remains in the square until the start of its next turn and then teleports back. You can initiate this as a movement action, but they can make their will save to determine whether they are teleported immediately and you do not get a free attack as part of initiating it.`,
                initiationAction: `standard`,
                range: `<void/death> feet`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Air","Royal"],
                level: 1,
                name: `Royal Summon`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[air-royal-air] You summon an enemy within feet equal to half your <air/royal> mastery to stand before you. The creature makes a reflex save, on failure it is drawn directly towards into the closest square until it is adjacent to you or enters your threatened area (whichever happens first). This movement does not provoke and it chooses which of the closest squares to you it wishes to move to. The creature suffers a -2 penalty to its armor class against attacks from you for 1 round if it fails the reflex save.`,
                initiationAction: `swift`,
                range: `1 foot/2 <void/air>`,
                target: `1 enemy`,
                duration: `instantaneous and 1 round`
              },
              {
                comboTags: ["Fire","Void"],
                level: 1,
                name: `Call of the Void`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[fire-void-fire][mind-affecting] Make a melee attack with a -5 penalty (or none if initiated as swift), if successful it deals damage as normal and the creature is dazed. At the start of each of its turns and any time it is attacked it gets a fortitude save to end this. It suffers a -1 penalty to its save for ever 10 <fire/void> mastery.`,
                initiationAction: `free or swift`,
                range: `melee attack`,
                target: `one creature`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Water","Void"],
                level: 1,
                name: `Clear the Waters`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[water-void-water] With a quick prayer you grant a blessing to yourself and all allies within 30 feet of you. For 2 rounds, all those blessed gain a +3 bonus on attack rolls and skill checks. Every 50 <water/void> mastery this lasts an additional round.`,
                initiationAction: `free`,
                range: `30 feet`,
                target: `all allies`,
                duration: `2 rds + 1 rd/50 <void/water>`
              },
              {
                comboTags: ["Curse","Void"],
                level: 1,
                name: `Clouded Future`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[curse-void-curse] With a quick curse you twist the futures of all enemies within 30 feet of you. For 2 rounds, all those cursed take a -3 penalty on attack rolls and skill checks. Every 50 <curse/void> mastery this lasts an additional round.`,
                initiationAction: `swift`,
                range: `30 feet`,
                target: `all enemies`,
                duration: `2 rds + 1 rd/50 <void/curse>`
              },
              {
                comboTags: ["Flurry","Curse"],
                level: 1,
                name: `Stabs Into the Soul`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-curse-flurry] You initiate this finisher when making multiple attacks against the same enemy as a part of the same action (such as a full-round attack). For every successful attack against the enemy during that action they take a -1 penalty to armor class and saves for 2 rounds, up to a maximum of -2, -1 per 10 <flurry/curse> mastery.`,
                initiationAction: `free`,
                range: `melee or ranged attacks`,
                target: `1 enemy`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Water","Flurry","Sakura"],
                level: 5,
                name: `Soumetsu`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[water-flurry-sakura-flurry/sakura-water] You launch a devastating storm of cutting ice. The storm covers a 10 foot square and travels up to 20 feet, stopping when it comes into contact with a creature. When a creature comes into contact with it, it takes damage as if you had struck them with an attack with two wielded non-unarmed weapons (when you initiated it. If you only had one weapon when initiating it, its damage is reduced to one attack), plus an additional 2 attacks with each weapon every 30 <flurry/sakura> mastery. All of the damage is converted to cold damage and is increased by 1d4 per 5 <water/sakura> mastery, and the creature is allowed a reflex save to halve the total damage. At the start of each of your turns it moves 5 feet (even past 20 feet) and no longer stops if it strikes a creature, continuing in a straight line away from where it was initiated. Soumetsu lasts for 2 rounds, plus 1 round per 50 <water/flurry/sakura> mastery.`,
                initiationAction: `full-round`,
                range: `20 feet`,
                target: `creatures in the area`,
                duration: `2 rounds, +1 rd/30 mastery`
              },
              {
                comboTags: ["Water","Sakura"],
                level: 5,
                name: `Snowswept Sakura`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[water,sakura,sakura,water] When you initiate this finisher your turn immediately ends, you sheathe your blade (might provoke), and you cannot move or make any attacks until the start of your next turn. At the start of your next turn you draw your sword in an a unbelievably fast multi attack. This takes no additional actions during that turn, but you cannot take any actions before making this attack. For this attack, you suffer a -8 penalty, but your reach increases by 5 feet, and instead of choosing a single target you make 3 melee attacks against all creatures within a 10 foot square within your reach, applying the attack rolls against all creatures within the area. Each attack deals an additional 1d4 cold damage per 5 <water/sakura> mastery. If any of these attacks are critical hits, you can recover a single <water/sakura> maneuver.`,
                initiationAction: `movement`,
                range: `melee attack`,
                target: `creatures in the area`,
                duration: `1 round`
              },
              {
                comboTags: ["Water","Sakura"],
                level: 3,
                name: `Hyouka`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[water-sakura-sakura-water] when you activate this finisher your turn immediately ends and you are nauseated until the end of your next turn (unresistable and unremovable). When you initiate this finisher your reach increases by 10 feet, and then you make a melee attack against all threatened enemies with a flat +2 bonus to your critical threat range. This attack deals an additional 1d4 points of cold damage per 5 <water/sakura> mastery. After this attack your reach returns to normal, but for 3 rounds your melee critical hits deal an additional 1d4 points of cold damage per 5 <water/sakura> mastery.`,
                initiationAction: `swift`,
                range: `melee attack`,
                target: `threatened creatures`,
                duration: `3 rounds`
              },
              // {
              //   comboTags: ["Primal","Curse"],
              //   level: 1,
              //   name: `Rejection From Nature`,
              //   type: `Finisher`,
              //   finisherType:"Strike",
              //   longDesc: `[primal-curse-primal] `,
              //   initiationAction: `swift`,
              //   range: `melee attack`,
              //   target: `threatened creatures`,
              //   duration: `3 rounds`
              // },
              {
                comboTags: ["Royal","Water"],
                level: 1,
                name: `Kanten Senmyou`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[royal-water-water-royal] All cold damage you deal as a part of weapon attacks is increased by a percentage equal to 1/2 your <water/royal/sakura> mastery. On the turn you initiate this, you gain a movement action.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Sakura","Water"],
                level: 1,
                name: `Senho`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[water,sakura] Immediately move 5 feet, plus 5 feet per 15 <water/sakura> mastery without provoking attacks of opportunity. If you end your movement adjacent to a creature, they take 1d4 points of cold damage per 5 <sakura/water> mastery, reflex halves. For 1 round afterwards, your melee weapons deal an additional 1 point of cold damage per 5 <sakura/water> mastery.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Sakura","Royal"],
                level: 5,
                name: `Amatsumi Kunitsumi Sanctification`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[sakura-royal-sakura-royal-sakura] During attacks made as part of a maneuver, your critical threat range and critical damage multiplier both increase by a flat +1. For every 50 <sakura/royal> mastery, your critical threat range increases by another flat +1.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Sakura","Water"],
                level: 1,
                name: `Frostbloom Kamifubuki`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[sakura-water-sakura] When you initiate a maneuver that makes a melee attack, you may make an additional 2 attacks against 2 different targets within your reach. If the maneuver is making an attack against only a single creature, these extra attacks cannot be made against that creature. These attacks have all of their damage converted to cold damage, gain none of the benefits of the maneuver, and only deal a percentage of the damage of your normal attacks: 10% plus 1% per 2 <sakura/water> mastery.
                \nIf your maneuver is one that lets you move, you may make these attacks at any point during the maneuver.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Death","Water"],
                level: 1,
                name: `Kyouka Fuushi`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[death-water-death] Attacks against targets lower that 25% hit points deal an additional 5% damage, plus 1% per 5 <death/water> mastery. All bonus damage is cold damage.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Death","Water","Void","Arcane"],
                level: 6,
                name: `Boundless Origin`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[death-water-void/arcane-water-death] The next time within 1 round that you make a melee attack that targets only a single creature, 2 shimmering duplicates appear and each make an attack against it as well. These extra attacks gain any bonus to attack or damage that the triggering attack made (this does include bonuses like bonus damage from strikes or vital strike), but otherwise none of the benefits of the attack are conferred. Each attack does only a percentage of the normal damage, equal to 10% plus 1% per 2 mastery of any of the combo points used as a part of initiating this finisher (your choice of which combo point, Max 66%)`,
                initiationAction: `swift or movement`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Flurry","Light"],
                level: 1,
                name: `Dawn's Dance`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-light-flurry] For 3 rounds all melee attacks you make deal additional untyped damage equal to your highest mental modifier. Additionally, for every 2 successful melee attacks against a creature they suffer a -1 penalty on attack rolls until this finisher ends. Creatures immune to being dazzled are immune to this, and creatures who suffer additional penalties from being dazzled take double the penalty. For every 30 <flurry/light> mastery this lasts an additional round.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Flurry","Light"],
                level: 1,
                name: `Lightspeed`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-light-flurry] Make a full-round attack. During this full-round action you can move up to your movement speed plus 1/2 your <light/flurry> mastery. You can split this movement speed up between, before, or after attacks as you see fit, and it doesn't provoke attacks of opportunity. Every time you move at least 20 feet, your next attack is against the targets flat-footed armor class.`,
                initiationAction: `full-round`,
                range: `personal`,
                target: `you`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Light","Flurry"],
                level: 1,
                name: `Dawnflower Blades`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[light-flurry-light] Make a full-round attack. All of the damage is converted to positive energy. If this is used to heal a living creature, the healing is halved. You cannot attack yourself during this.`,
                initiationAction: `full-round`,
                range: `melee attacks`,
                target: `creatures`,
                duration: `instantaneous`
              },              
              {
                comboTags: ["Royal","Flurry"],
                level: 1,
                name: `Unapproachable Throne`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[royal-flurry-royal] Every time you make a successful melee attack, you gain a +1 dodge bonus to your armor class until the start of your next turn.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Flurry","Royal"],
                level: 3,
                name: `Spiked Crown Stance`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-royal-flurry] During the duration, you gain a number of attempts at parrying weapon attacks against you equal to the amount of attacks you make during a full-round attack. Each parry uses the attack bonus of that attack in a full-round attack in descending order like normal. Parrying works the same as the parry and riposte feature (though you cannot make ripostes, and it does not require attacks of opportunity). If you have abilities that allow you to make additional attacks during a full-round action, you can expend them during the initiation action to also gain those additional attacks. Although initiating these additional abilities takes no additional actions, you cannot initiate more of them than you could in a single round, though you can expend any ability that grants you more actions during this.`,
                initiationAction: `movement and swift action`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Guardian","Light","Arcane"],
                level: 3,
                name: `Clear Blue Sky`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[guardian-light/arcane-light/arcane-guardian] You swing your blade around you, sweeping away obstacles and harmful magic. The area within your reach is cleared of difficult terrain. If it is natural difficult terrain then it is cleared permanently, if it is from magic then this lasts only 3 rounds. This also sweeps away the effects of ongoing spells in the area that target terrain if you can succeed on a CMB check vs the spells DC. You suffer a -15 penalty on this check, though you gain a +1 per 10 <guardian/light> mastery. This only clears them in the area of your reach. If the spell would naturally reform over time, this only lasts 3 rounds (such as fog cloud or black tentacles), but spells that can be permanently destroyed (such as web or spike stones) are cleared permanently. This does not stop new abilities from creating difficult terrain or harmful spell effects where you have cleared.`,
                initiationAction: `swift`,
                range: `reach`,
                target: `you`,
                duration: `instantaneous and 3 rounds`
              },
              {
                comboTags: ["Death","Light"],
                level: 3,
                name: `Death's Mercy`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[death-light-death] You promise a quick and painless death to a suffering creature. If a creature is affected by at least 4 valid conditions you can initiate this finisher to move up to your movement speed and coup-de-grace them without provoking attacks of opportunity (even if the creature is not helpless). For every condition past 3 that the creature is suffering from your critical damage multiplier increases by +1 for the coup-de-grace.
                \nValid Conditions: bleeding, blind, confused, cowering, dazed, dazzled, deafened, entangled, exhausted, fascinated, fatigued, frightened, grappled, nauseated, panicked, paralyzed, petrified, pinned, prone, shaken, sickened, staggered, sleeping, stunned, ability score drain, negative levels, charmed, dominated.`,
                initiationAction: `movement`,
                range: `melee attack`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Arcane","Technique"],
                level: 5,
                name: `Spell Parry`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[arcane-technique-arcane] The next save you make within 3 rounds against a hostile spell or spell-like ability can use your attack modifier minus your level in place of your normal save modifier. If you succeed on the save, you can turn it back on the caster as the spell turning spell. This only affects how the spell effects you, not anybody else.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Dark","Death"],
                level: 7,
                name: `Harmony of Overwhelming and Collective Murder`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[dark-death-dark-death-dark] All creatures on the map (you included) can take an immediate standard action to use an offensive ability or attack another creature. For these attacks everything gains a bonus on attacks equal to +1 per 10 <dark> mastery and a +1 to damage per 5 <dark> mastery. The DC's of all offensive abilities also rise by +1 per 15 <dark/death> mastery. Any creature that reduces another creature to below 0 hit points during this round can move up to their movement speed and take another standard action. For 1 round creatures cannot use healing spells, abilities that only heal without dealing damage, buff spells, control spells that dont deal damge. All creatures count as enemies to all other creatures and cannot provide any form of assistance to another creature. During this round, for every creature reduced below 0 hit points, the bonuses to damage persist for you for 1 additional round.`,
                initiationAction: `standard`,
                range: `map`,
                target: `all creatures`,
                duration: `1 round`
              },
              {
                comboTags: ["Earth","Death"],
                level: 1,
                name: `Mausoleum Shell`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth-death-earth] Whenever you take damage, if it would be lower than 1/5 your <earth> mastery, you take no damage. If you negate damage from a melee attack with this ability, the attacker takes 1d4, plus 1d4 per 15 <death> mastery bludgeoning damage.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Death","Earth"],
                level: 5,
                name: `Premature Burial`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[death-earth-earth-death] You target a creature, if it has less hit points than your <death> mastery, it is immediately pulled underground. In order to escape it must make a cmb or escape artist check equal to 10 + 1/2 <earth> mastery. Doing this is a full-round action, and it cannot see, breath, or speak while undergound. If the creature fails to escape for 3 rounds, it dies. Creatures immune to death and suffocation have 6 rounds to escape before they die.`,
                initiationAction: `standard`,
                range: `30 feet`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Air","Water"],
                level: 4,
                name: `Dance of Two Dragons`,
                type: `Finisher`,
                finisherType:"Counter",
                longDesc: `[air-sakura-water] When you initiate this finisher, once within the next 3 rounds when a creature that you threaten attacks you, you can make a special counter attack against them as a free (even if not your turn). When you do, you make an immediate attack against the attacker, this attack deals an additional 1d4 points of electricity damage per 5 <air> mastery. Then, the creature makes its attack, for which you gain a dodge bonus to your armor class of +1 per 15 <water/air> mastery. If the attack against you misses, you can make another immediate attack, dealing an additional 1d4 points damage per 5 <water> mastery, unless the attack missed by an amount equal to or less than the dodge bonus you gained from this finisher, then the bonus damage is doubled. While this finisher is active, but before you have used the special counter attack, every time an enemy makes an attack of opportunity against you, you gain 1 dragon dance stack. Then, when you initiate the special counter attack, the dodge bonus you gain increases by +1 per dragon dance stack.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Curse","Light"],
                level: 1,
                name: `False Light`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[curse-light-curse] You grant an enemy the ability to roll twice on any d20 roll and take the higher result for 3 rounds. Every time it does, your attacks against them deal a stacking +2 damage, +1 per 20 <curse/light> mastery, and you also gain 1 stolen light. Stolen light lasts until the end of the floor, and you can expend 1 before you make a roll to roll 3 times and take the highest result.`,
                initiationAction: `free`,
                range: `60 feet`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Water","Fire"],
                level: 5,
                name: `Life, In Two Forms`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[water,fire-water,fire] Every time an enemy attacks you, you heal 1d4 hit points, plus 1d4 every 10 <fire/water> mastery. Every time you attack, you take 1d6 damage but deal an additional 1d4 points of cold damage and 1d4 points of fire damage, both increased by 1d4 per 10 <fire/water> mastery. When selecting which mastery you use to increase the power of this finisher's two aspects, you must select <fire> for one, and <water> for the other. You can change which aspect you are using once per round, every time you do, something new happens to you depending on how many times you have swapped:
                \n1st Time: Roll a 1d100, on 1-25 this finisher has its duration reduced by 1 round. On 26-100 you increase its duration by 1 round. \n2nd Time: You gain only the healing or damage bonus, but this round it is doubled. \n3rd Time: Increase the duration by 1 round. You gain both bonuses, but choose one to be doubled.\n4th time: You automatically succeed on all saving throws for 1 round.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Earth","Air"],
                level: 3,
                name: `Philosophy, In Two Forms`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth,air-earth,air] When you activate this finisher, and then at the start of each of your turns, you can choose to either gain temporary hit points for 1 round equal to your <earth> mastery, or to gain a miss chance chance of 1% per 2 <air> mastery (stacks with other miss chance, but is halved). Each time you select a different bonus than what you picked the previous round, a bonus effect occurs depending on how many times you have changed which bonus you selected:
                \n1st Time: Roll a d100, on 1-50: This finishers duration reduces by 1 round and you gain no bonuses this round. On 51-100: The duration increases by 1 round but the bonus you selected is halved. \n2nd Time: You gain half the bonus for both options \n3rd Time: You gain the full bonuses of both. \n4th Time: (can only be done in combat) Roll d100, on 51-100 you gain your choice of a <light>, <dark>, or <void> maneuver. Every future maneuver you select from this must be of the same type. Every additional maneuver you have gained from this maneuver increases the chance to gain the next one by 10%.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Earth",'Water'],
                level: 1,
                name: `Endurance, In Two Forms`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth,water-earth,water] When you activate this finisher, and then at the start of each of your turns, you can choose to either gain a dodge bonus to armor class of +1, +1 per 10 <water> mastery, or DR 1/-, +1 per 10 <earth> mastery (stacks with other DR). Each time you select a different bonus than what you picked the previous round, a bonus effect occurs depending on how many times you have changed which bonus you selected:
                \n1st Time: Roll a d100, on 1-50: This finishers duration reduces by 1 round and you gain no bonuses this round. On 51-100: The duration increases by 1 round but the bonus you selected is halved. \n2nd Time: You gain half the bonus for both options\n3rd Time: You gain the full bonuses of both. \n4th Time: You are immune to damage from enemies.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`,
              },
              {
                comboTags: ["Sakura","Arcane"],
                level: 1,
                name: `Evening Moon`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[sakura-arcane-sakura] Using this finisher requires you have a sheathed weapon. Draw a weapon (without provoking) and make a melee attack with it at a -5 penalty, for which the target is flat-footed. This attack bypasses all of the creatures magical defenses, such as miss chances from effects like invisibility and displacement, effects that give bonuses to armor class, and even spells that grant damage reduction. The attack gains a bonus on the attack roll of +1 per 10 <arcane> mastery, and deals 1d4 bonus damage per 5 <sakura> mastery. For every 15 <sakura> mastery, you can move 5 feet before making the attack.`,
                initiationAction: `swift`,
                range: `melee attack`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Sakura","Guardian","Shadow"],
                level: 1,
                name: `New Shadow Draw`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[sakura-guardian/shadow-sakura/guardian] Initiating this finisher requires you threaten no enemies and cannot be initiated where it would immediately threaten a creature (you can reduce its range when initiating it). When you initiate this finisher, your turn immediately ends, you sheathe a weapon, and then enter a drawing stance, creating an area around you with a radius around you equal to your reach with the sheathed weapon plus 5 feet, increasing by 5 feet every 20 <guardian> mastery. The next time an enemy enters into the area, you draw the weapon in a blazingly fast attack. Move directly towards them the minimum required distance to make a melee attack against them. The creature is flat-footed for this attack, bypassing any resistance to being flat-footed. The attack gains a bonus to damage of 1d6 per 5 <sakura/shadow> mastery.
                \nDuring the round you initiated the finisher, until you have made the attack you cannot make any other attacks or move, though teleportation is allowed. If you teleport where an enemy would be within the area, you cannot make the attack against them. Until you have made the attack, if a creature makes a ranged weapon attack against you (that you are aware of and can see), you can make an attack roll with the sheathed weapon and use that as your armor class against the attack (max 1 attack, plus 1 attacker per 10 <sakura/guardian> mastery. You sheathe the weapon directly after this). You can never make this special attack with a drawn weapon.`,
                initiationAction: `swift`,
                range: `melee attack`,
                target: `1 enemy`,
                duration: `3 rounds or until used`
              },
              {
                comboTags: ["Guardian","Fire"],
                level: 1,
                name: `Blistering Ward`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[guardian-fire-guardian] You create an aura around you of blistering flames that shield allies from attacks. Every time an enemy makes a melee attack against an ally within your reach, they take 1d4 points of fire damage, plus 1d4 every 15 <fire/guardian> mastery. Their attack roll is reduced by 1/4 of the fire damage they take.`,
                initiationAction: `free`,
                range: `reach`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Fire","Water","Dark"],
                level: 3,
                name: `Warcrime Style: Napalm`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-water-water/dark-fire/dark] Combo must contain at least 1 <dark> combo point. Make an attack with a -5 penalty (or none if initiated as movement), if it hits, it deals damage as normal and the creature must make a reflex save or catch fire, taking 1d8 points of fire damage per 5 <water/fire> mastery immediately and then at the start of each of its turns. You use the lower of your <fire> and <water> mastery to determine this damage. The creature takes a penalty on its reflex save to avoid this maneuver of -1 per 10 <dark> mastery. Each round the creature can make a reflex save to extinguish the fire, but the DC to do so is the DC of this maneuver + 5, for which is still takes the penalty from your dark mastery. Every round a creature takes damage from this, all its allies that can see it must make a will save or become shaken until the the fire is put out or the creature dies.`,
                initiationAction: `swift or movement`,
                range: `melee or ranged attack`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Heroic","Curse"],
                level: 1,
                name: `Curse of Heroism`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-curse-heroic] You suffer a -4 penalty to your armor class and to your saves, but allies within the area gain a +2 bonus to armor class and to saves. For every 30 the penalty you take increases by -2, and the bonus your allies gain increases by +1.`,
                initiationAction: `swift`,
                range: `30 feet`,
                target: `allies`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Light","Dark","Void"],
                level: 1,
                name: `Enlightenment`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[light,void,dark] Gain a +4 inherent bonus to all of your mental ability scores. Every 30 <light/void/dark> mastery the bonus increases by +1.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Heroic","Death"],
                level: 1,
                name: `Rising Revengeance`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-death-death-heroic] Your armor class reduces to 0, but you gain DR and elemental resistance of 1 per 5 <heroic/death> mastery, and you delay the onset of 50% of the damage you take until the end of this finisher. For every increment of your level x3 damage you have delayed or taken during this finisher, your melee attacks gain a morale bonus of +1 to attack and +2 to damage (stacks with itself).`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Fire","Dark"],
                level: 1,
                name: `Shadowflame`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[dark-fire-dark] Take damage equal to your <fire/dark> mastery and then make an attack, it deals bonus damage equal to 1.5x the damage you took.`,
                initiationAction: `free`,
                range: `melee or ranged attack`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Guardian","Void"],
                level: 1,
                name: `Gravity Well`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[guardian-void-(void)-guardian] For 1 round every ranged weapon attack that passes within your threatened area is automatically redirected at you. Ranged weapon attacks targeted directly at you without being redirected gain a +4 bonus. Additionally, for an enemy to move away from you it must make an opposing CMB check as a part of the movement with a DC equal to 10 + 1/2 <guardian/void> mastery. For every 15 <guardian/void> mastery the area increases by 5 feet. If you include the second <void> combo point this also affects ranged spell attacks and the duration increases to 2 rounds.`,
                initiationAction: `movement`,
                range: `reach`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Guardian","Fire"],
                level: 1,
                name: `Stoic Valcano`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[guardian-fire-guardian] For 1 round you may choose to redirect any attacks against a creature within your reach to yourself, suffering a -4 penalty to your armor class against it for doing do so. For this round, every creature that attacks you suffers 1d6 points of fire damage and 1 stack of immolation. For every 15 <fire/guardian> mastery the damage increases by 1d6 and the immolation stacks by 1.`,
                initiationAction: `swift`,
                range: `reach`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Shadow","Fire"],
                level: 1,
                name: `Forbidden Flame`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-fire-shadow] For 3 rounds your sneak attack damage is converted to fire damage. Every time you successfully deal sneak attack damage, the creature takes 1 stack of shadow immolation, which increases the damage they take from both fire and sneak attack damage (this only increases the damage by 1 point if its both). During this, you gain 1d6 points of sneak attack damage, plus 1d6 per 40 <fire/shadow> mastery.`,
                initiationAction: `swift`,
                range: `porsonal`,
                target: `you`,
                duration: `3 round`
              },
              {
                comboTags: ["Shadow","Fire"],
                level: 1,
                name: `Blazing Eclipse`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-fire-shadow/fire] You unleash a wave of shadowy flame in a 30 foot radius around you, dealing 1d6 points of fire damage per 5 <shadow/fire> mastery and giving 1 immolation. Creatures can make a reflex saving throw to halve both. Enemies within the area that fail the reflex saving throw are also blinded for 1 round and have all immolation stacks currently on them converted to shadow immolation, which increases the damage they take from both fire damage, and when they take sneak attack damage. If a creature already had shadow immolation on them, they suffer a penalty to their reflex save equal to -1 per 3 stacks of shadow immolation.`,
                initiationAction: `standard`,
                range: `30 foot radius`,
                target: `creatures`,
                duration: `1 round`
              },
              {
                comboTags: ["Shadow","Earth"],
                level: 1,
                name: `Shadow Graveyard`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-earth-shadow] You fill the area with shadowy pits that blink in and out of existence for all enemies within 30 feet around you. All enemies move at half speed within the area and cannot take 5-foot steps. If a creature attempts to ignore this penalty with an ability, there is a 5% chance for every square they travel through that they actually do fall into a shadowy pit, having their movement immediately stopped and taking damage equal to 1/2 your <shadow/earth> mastery and suffering a -4 penalty to attack and AC for 1 round.`,
                initiationAction: `movement`,
                range: `30 foot radius`,
                target: `enemies`,
                duration: `3 round`
              },
              {
                comboTags: ["Fire","Earth"],
                level: 1,
                name: `Burning Mountain`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-earth-fire] Enemies within the area move at half speed when moving towards you, and when they move away from you they must make a reflex save or fall prone. Flying creatures ignore both of these effects, however they must instead make a fortitude save at the start of each of their turns or become nauseated for 1 round, and they suffer a 20% miss chance on all attacks due to the billowing smoke blinding them.`,
                initiationAction: `movement`,
                range: `30 foot radius`,
                target: `enemies`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Earth","Fire"],
                level: 3,
                name: `Meteor`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth-fire-earth] You hurl a two-handed weapon in a meteoric throw at a creature within feet equal to your 2x <fire> mastery. Make a ranged attack with the weapon, however you can use your strength to determine its attack bonus. If it hits, it deals damage as if you struck them with a melee attack with the weapon, but its damage is increased by 1 dice step. For every 10 feet the attack travels, and for every 10 <earth> mastery, the damage increases by a further dice step. The attack deals bonus fire damage equal to 1% per <fire/earth> mastery of the physical damage of the attack.`,
                initiationAction: `movement`,
                range: `<fire> feet`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Earth","Power"],
                level: 1,
                name: `Clubbing`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth-power-earth] Make a melee attack against an enemy, if it hits it deals damage as normal and they must make a fortitude save or be stunned for 1 round. For every 10 <earth/power> mastery, the DC of this finisher increased by +1. For every 4 that they fail the DC by, they are stunned for an additional round.`,
                initiationAction: `swift or movement`,
                range: `Melee attack`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Earth"],
                level: 1,
                name: `Behold, Rock`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth-earth-earth] The next rock you throw within 3 rounds has its damage increased by 2 dice steps, plus 1 dice step per 10 <earth> mastery. For every 10 <earth> mastery it also gains a +1 bonus on attack.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Earth","Void"],
                level: 9,
                name: `Rocks Fall`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth-void-void-void-void-earth] Every creature in the combat has a 1% per 2 <earth/void> mastery chance to just instantly die. No immunities or powers can resist this, except great old ones who are immune to this, and final bosses who are only pushed to their next phase. If you kill your party and the final boss, you still lose.`,
                initiationAction: `1 round action`,
                range: `map`,
                target: `creatures`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Heroic","Flurry"],
                level: 5,
                name: `Hero Complex`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[heroic-flurry-flurry/heroic-heroic] Choose an enemy, pointing to them and declaring your intent to defeat them for the sake of justice/love/hope/your friends etc. etc. in a long drawn out speech that takes 1 round. After this, for 3 rounds you can take no actions other than the actions granted by this finisher or <heroic/flurry> boosts. At the start of your next 3 turns you move to a position that threatens the target of the finisher and make a full attack. Your movement speed cannot be restricted during this, and you can move up to 10x your speed to reach the creature. During these 3 rounds you delay all damage and negative conditions/statuses until the end of the duration (pausing their duration). You cannot take any attacks of opportunity except against the target. All of your attacks during this gain a +1 bonus per 20 <flurry> mastery and +1 to damage per 10 <heroic> mastery. For every 50 <heroic> mastery this lasts an additional round. For every 30 <flurry> mastery you can make an additional attack at your highest bonus when using this finisher, with a stacking -5 for each additional attack gained. You cannot gain or give bonuses for flanking during this, and if an ally attemps to sneak attack (or do anything else treacherous) the target of this finisher it immediately ends it, you take the damage of that attack, and you lose your next turn as you chastise your ally. 
                \nIf you kill the target during this, for 1 round you and all allies gain a +4 morale bonus on all attacks, saves, and damage, +1 per 50 <heroic/flurry> mastery.`,
                initiationAction: `1 round`,
                range: `60 feet`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Flurry","Heroic",],
                level: 1,
                name: `Protagonist Stance`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[flurry-heroic-flurry] Make a full attack against a creature, except for any attacks you can take with your off-hand (though you still gain any bonuses or penalties for two-weapon fighting). With your off-hand you prepare to counter, for which you gain 1 counter for every off-hand attack you have. These counters last until all are expended. When a creature makes a weapon attack against you, you make an opposed attack roll as if using that off-hand attack, from highest to lowest bonuses. If your attack roll is higher, you negate the attack and you can choose to either move up to 10 feet while swapping places with an ally (movement doesn't provoke) and granting that ally an attack of opportunity against the creature, or to make an immediate counter attack against the enemy at your highest bonus. You gain a bonus on your opposed attack rolls of +1 per 15 <flurry>, and either your ally gains a bonus on their attack of opportunity roll, or you gain a bonus on your counter attack's damage rolls of +1 per 5 <heroic> mastery. You gain a shield bonus to your armor class equal to your remaining counter stacks.`,
                initiationAction: `standard`,
                range: `personal`,
                target: `you`,
                duration: `24 hours`
              },
              {
                comboTags: ["Guardian","Death"],
                level: 1,
                name: `Treacherous Opportunist`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[guardian-death-guardian] You dart and weave around your allies, using the openings created by them being attacked to strike back at the creatures attacking them. During the duration, you gain an additional attack of opportunity, plus another every 10 <guardian/death> mastery. These attacks of opportunity are not regained at the beginning of each round, and are lost when expended. For the duration, whenever an ally that you threaten is attacked by an enemy that you threaten, you can expend an attack of opportunity cause them to suffer a -5 penalty to their armor class against that attack to cause that attack to provoke an attack of opportunity from you. Your attack of opportunity is after the attack is made. For every 45 <death/guardian> mastery this lasts an additional round.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Shadow","Guardian",],
                level: 1,
                name: `Scoundrel`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-guardian-shadow] You dart and weave around your allies, using them as cover against attacks made against you. During the duration, you gain an additional attack of opportunity, plus another every 10 <guardian/shadow> mastery. These attacks of opportunity are not regained at the beginning of each round, and are lost when expended. For the duration, whenever you are attacked by a creature and are adjacent to an ally that would also have been a valid target for the attack, you can expend an attack of opportunity to redirect the attack to the ally, for which they suffer a -5 penalty to their armor class. If they hit your ally and you threaten the creature, you can expand another attack of opportunity to make an immediate attack against the creature, for which it is flat-footed. You can only do this once per ally per round. For every 45 <shadow/guardian> mastery this lasts an additional round.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Sakura","Curse",],
                level: 1,
                name: `Curse of the Blade`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[sakura-curse-sakura] Make a full attack against an enemy. For every attack you can roll twice and take the higher result, and all attacks deal an additional 1d4 damage per 5 <sakura/curse> mastery. If you do not kill the creature during this, you can never initiate this finisher again and take a permanent -2 penalty on melee weapon attacks, doubled on weapons of the same type as the weapon you initiated this finisher with.`,
                initiationAction: `movement`,
                range: `melee attack`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Curse","Sakura"],
                level: 1,
                name: `Binding Vow`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[curse-sakura-curse] Your next melee attack this round automatically hits and cannot be countered. If successful, it deals an additional 1d6 damage per 3 <curse/sakura> mastery, is an automatic critical hit, and its critical damage multiplier increased by +1. Once you use this finisher, you can never attack with a weapon that shares a weapon group with the weapon you initiated this with. If you initiate it with a wakizashi, katana, odachi, or masamune, the critical damage multiplier increases by an additional +1, it bypasses critical immunity and fortification, and the bonus damage increases to d8's.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Arcane","Flurry"],
                level: 1,
                name: `Arcane Flurry`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[arcane-flurry-arcane] You can cast two different spells as a full-round action. You do this as if casting a spell with each hand, causing attacks made with the spells to gain both the bonuses and penalties as if two-weapon fighting. Both of these spells must have a casting time of a standard action or less. Spells cast this way treat hands with weapons in them as free for casting spells.`,
                initiationAction: `full-round`,
                range: `personal`,
                target: `you`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Flurry","Arcane"],
                level: 3,
                name: `Acceleration`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-arcane-flurry] You gain the effects of both the haste and displacement spells for 3 rounds. If you are two-weapon fighting, you can gain an additional attack with both your main hand and off-hand, though all attacks in the round take a -4 penalty. For every 45 <arcane/flurry> mastery this lasts an additional round.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Flurry","Arcane"],
                level: 1,
                name: `Fool's Errand`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[flurry-arcane-flurry] You can make a full attack with your melee weapons at a range, causing them to fly out of your hands strike the target and then return. The range of this is 5 + 1/4 <arcane> mastery feet, and the attacks gain a bonus on attack rolls equal to +1 per 15 <arcane/flurry> mastery. You can use any of your ability scores to determine the attack and damage modifiers of these attacks. For every 40 <flurry> mastery you can make an additional attack during the full-round attack, but all attacks take a -2 penalty.`,
                initiationAction: `standard`,
                range: `10 + <arcane> feet`,
                target: `enemies`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Sakura","Shadow",],
                level: 1,
                name: `Absolute Precision`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[sakura-shadow-sakura] or [shadow-sakura-shadow] Your weapon attacks ignore 10% plus 1/2 <shadow/sakura> mastery of the target's fortification. This percentage is halved if the creature has critical immunity.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Death","Curse",],
                level: 1,
                name: `Grave Hex`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[death-curse-death] [curse] You touch a creature and hex them with a curse of death. If the attack is successful they immediately take 1d6 points of negative energy damage per 10 <death> mastery and then they are cursed for 5 rounds. Each time within that duration that they take damage they receive 1 blood curse stack. At the start of each of their turns for 5 rounds they take 1 point of negative energy damage per stack. Damage inflicted by <curse/death> maneuvers adds two stacks instead. Every 50 <death/curse> mastery the damage increases by 1 per stack. This damage cannot be healed until the duration has expired.`,
                initiationAction: `swift`,
                range: `touch`,
                target: `1 enemy`,
                duration: `5 rounds`
              },
              {
                comboTags: ["Death","Curse",],
                level: 1,
                name: `Soulsiphon Curse`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[death-curse-death] [curse] You hex a creature with a dark blood binding. Every time the creature takes damage for 3 rounds you heal 1 hit points and gain 1d4 temporary hit points that last until the end of combat (stack with themselves). For every 15 <curse/death> mastery they recieve a -1 penalty on attack and damage rolls for the duration, and you heal an additional hit point and gain an additional temporary hit point every time they are damaged.`,
                initiationAction: `free`,
                range: `30 feet`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Water","Sakura",],
                level: 1,
                name: `Flowing Petal Guard`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[water-sakura-water] You adopt a stance as fluid as a stream. For 3 rounds, you gain a +2 dodge bonus to AC and +10 bonus to your ground movement speed. Every time an attack misses you, you may take a 5-foot step, even if you have already taken one this round, or it is not your turn. Every 20 <water/sakura> mastery the dodge bonus to your armor class increases by +1 and the movement speed increases by 5 feet.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Water","Sakura",],
                level: 1,
                name: `Deadly Dewdrop`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[water-sakura-water] You gain a flat +1 bonus to your critical threat range with melee weapon attacks. If you confirm a critical hit with a melee attack, you may sheathe the weapon as a free action you can take even when not your turn to gain a +4 dodge bonus to AC until your next turn. You can activate this multiple times in a single round, but your dodge bonus only increases by +1.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Shadow","Sakura",],
                level: 4,
                name: `Veil of Cherry Blossoms`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-sakura-sakura-shadow] For 3 rounds, you gain 10% miss chance plus 1% per 5 <shadow/sakura> mastery (stacks with other miss chance, but is rolled seperately, cannot be foiled). Whenever an enemy misses you due to this finisher or other concealment and they threaten another enemy, the attack is instead redirected to that enemy.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Air","Sakura",],
                level: 1,
                name: `Hurricane's Edge`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[air-sakura-air] For 3 rounds, you gain a +1 insight bonus to attack and damage rolls for every 20 feet you have moved this round (max 2x initiation modifier). Every 20 <air/sakura> mastery you have, you also gain a +5 foot bonus to your land movement speed.`,
                gameDesc: `[air-sakura-air] For 3 rounds, you gain a +1 insight bonus to attack and damage rolls for every 30 feet you have moved this round (max initiation modifier). Every 20 <air/sakura> mastery you have, you also gain a +5 foot bonus to your land movement speed.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Flurry","Air",],
                level: 1,
                name: `Cyclonic Blade Dance`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-air-flurry] You spin through the battlefield like a whirlwind, your blades a blur of motion as you strike with the speed of a gale. For 3 rounds, whenever you make a full-attack action, after moving at least 10 feet before hand, you may make an additional attack at your highest bonus. If you are attacking with two weapons, you may also make an additional off-hand attack at your lowest off-hand attack bonus.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Primal","Death","Curse",],
                level: 1,
                name: `Curse of Raging Blood`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[primal-curse-primal/death] [curse] Make a melee attack, if successful, it deals damage as normal + 1d4 bleed damage per 15 <primal> mastery and the creature is cursed. While cursed, whenever it makes an attack, the bleed damage increases by 1d4. If the target dies before the curse ends, all enemies within 15 feet + 5 feet per 20 <curse/primal> take negative energy damage equal to the amount of bleed damage the creature was taking, takes the bleed damage this maneuver inflicted on hit, and gains the curse for rounds equal to the duration the original creature had left +1 round. The bleeding damage the cursed creature is taking from this maneuver cannot be removed as long as the curse remains, and the bleed damage stacks with other bleed damage.`,
                initiationAction: `movement`,
                range: `melee attack`,
                target: `1 enemy`,
                duration: `3 rds + 1 rd/20 <primal/curse>`
              },
              {
                comboTags: ["Primal","Curse",],
                level: 1,
                name: `Carving Fury`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[primal-curse-primal] You carve a cursed rune into your foe, marking them as prey for your fury. Make a melee touch attack, on success, the creature is marked by you. For 3 rounds, your attacks against the cursed target deal +1 damage per 10 <primal> mastery, and every time you make a successful attack against them, your further attacks  against them for the remaining duration gain a +1 morale bonus (stacks with itself). If this bonus increases to +5, the bonus resets to +0 but the target takes 2 points of constitution drain and must make a fortitude save or be staggered during its next turn. Every time this triggers per activation, the DC increases by +5.`,
                initiationAction: `free`,
                range: `personal`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Primal"],
                level: 1,
                name: `Howl of the Untamed`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[primal-primal-primal] You unleah a roar in a 20 foot cone + 5 feet per 20 <primal> mastery. Enemies with the area take 1d6 points of sonic damage per 5 <primal> mastery (fortitude halves) a -2 penalty on attack and damage rolls, whereas allies gain a +2 morale bonus to attack and damage rolls. Every 30 <primal> mastery the bonus and penalty to attack and damage increases/decreases by 1.`,
                initiationAction: `movement`,
                range: `20 foot cone`,
                target: `creatures`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Curse","Primal"],
                level: 1,
                name: `Spiteful Haunt`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[curse-primal-curse] For 3 rounds, whenever a creature successfully damages you with an attack, they suffer a -1 penalty to armor class for the remaining duration. If this penalty reaches -5, they are staggered for 1 round no save and the penalty resets, but now every time they damage you with an attack, the penalty applies to an additional roll type of your choice (attack, saves, damage). If they reach -5 again, this resets the same way and applies to another roll type, but the duration does not increase. For every 30 <curse/primal> mastery the base duration increases by 1 round.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rds + 1 rd/30<curse/primal>`
              },
              {
                comboTags: ["Primal","Curse","Guardian"],
                level: 1,
                name: `Primal Challenge`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[guardian-primal,curse-guardian] You mark a creature with your primal wrath. Every time they attack an ally but not you, they take 1d6 points of damage plus 1d6 per 15 <primal/curse/guardian> mastery of negative energy damage. This doesn't apply if an attack hits both you and an ally, such as with cleave, or fireball. While this is in effect, they gain a +1 bonus on attack rolls against you equal to twice the amount of d6's they'd take if they attacked an ally.`,
                initiationAction: `free`,
                range: `20 feet`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Royal","Fire"],
                level: 1,
                name: `Crown's Pyreguard`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-royal-fire] You raise a blazing aura around yourself, punishing attackers while shielding allies with royal defiance. For 3 rounds, you and all allies within 15 feet of you gain the pyreguard aura, which grants DR 5/-, three times as much fire resistance, and any time an enemy strikes you with a melee attack with a non-reach weapon they take 1d4 points of fire damage. Every 15 <fire/royal> mastery the DR increases by 1 and the damage increases 1d4 points of fire damage. Additionally, if it is you that is struck, the creature takes 1 immolation stack.`,
                initiationAction: `swift`,
                range: `15 feet aura centered on you`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Royal","Fire"],
                level: 1,
                name: `Blazing Decree`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-royal-fire] You and all allies within 30 feet gain 1d4 + 1d4 per 10 <fire/royal> mastery fire damage on your next weapon attack within 3 rounds. If this attack hits, the ally gains temporary hit points equal to the bonus fire damage dealt before resistances are applied (but not immunity). Whenever one of your allies delivers this attack (except you), you gain half the temporary hit points they gain from it (this stacks, except from reactivations of this finisher).`,
                initiationAction: `movement`,
                range: `30 feet burst centered from you`,
                target: `allies`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Royal","Fire"],
                level: 5,
                name: `Immolating Throne`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[royal-fire-fire-royal] For 3 rounds, whenever an enemy misses you with an attack, they take 1d4 points of fire damage, plus 1d4 per 15 <fire/royal> mastery. If the attack only missed because of the activation of a defensive ability such as a martial counter or parry, the fire damage they take doubles, they take 1 immolation stack per 2d4 points of fire damage dealt, and your next melee attack against them deals additional d4's of fire damage equal to half the d4's dealt to them. If the attack you use to deliver this damage is an attack of opportunity, the additional fire damage doubles and they take 1 immolation stack per 2d4 fire damage dealt.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Light","Fire"],
                level: 1,
                name: `Phoenix Rising`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[light-fire-light] The next time this encounter you are damaged by an enemy and your hit points are reduced below 25%, you immediately heal 1d4 points of hit points per 5 <fire/light> mastery, enemies within 10 feet of you take the same amount of fire damage, and you gain a +2 sacred bonus to your armor class until the start of your next turn. If this triggers within 2 rounds of activation, the healing and damage is doubled. You can only have a single instance of this finisher active on you at a time.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `encounter`
              },
              {
                comboTags: ["Air","Guardian"],
                level: 1,
                name: `Sentinel Winds`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[air-guardian-air] For 3 rounds, you gain 20% miss chance + 1% per 3 <air/guardian> mastery against ranged attacks (stacks with other miss chance, but is rolled seperately). When a ranged attack is made against an ally within your threatened area + 5 feet per 20 <guardian/air> mastery, you can expend an attack of opportunity or an immediate action to redirect the attack to you.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Guardian","Air"],
                level: 1,
                name: `Gale Rider Guardian`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[guardian-air-guardian] For 3 rounds, whenever an ally within half your movement speed is attacked, you can as an immediate action move up to half your movement speed so long as you end your movement adjacent to them. If you do, they gain a +4 bonus to their armor class against the attack. If the attack misses, you regain your immediate action and if the attack only missed because of the bonus armor class given, you can gain a <guardian> combo point.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Earth","Air"],
                level: 1,
                name: `Iron Wind Sentinel`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth-air-earth] You anchor yourself with wind currents, becoming an immovable fortress. For 3 rounds, you gain a +4 bonus to your CMB and CMD when making or against bull rush, trip, reposition, pull, push, and grapple attempts. Every 10 <earth/air> mastery this bonus increases by +1. If a creature fails one of these attempts agaisnt you, they take 1d4 points of bludgeoning damage per 10 <air/earth> mastery. Whenever you succeed on one of these attempts against an enemy, they take 1d4 points of bludgeoning damage, plus 1d4 per 15 <earth/air> mastery.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Sakura"],
                level: 1,
                name: `Falling Petals`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[sakura-sakura-sakura] For 3 rounds, the first time each turn that you draw your weapon as a part of making an attack, its critical threat range increases by a flat +1 and it deals additional 1d6 points of precision damage, plus 1d6 per 20 <sakura> mastery. Once per round when you sheathe your weapon, or if you use a maneuver or stance that allows you to sheathe your weapon, an enemy within your melee reach takes 1d6 points of slashing damage, plus 1d6 per 10 <sakura> mastery.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },              
              {
                comboTags: ["Sakura"],
                level: 5,
                name: `Final Tranquility`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[sakura-sakura-sakura-sakura-sakura] Make a full-attack action against an enemy with a slashing melee weapon, gaining an additional attack at your lowest bonus -5. Each successful attack increases the critical threat range of subsequent attacks by a flat +1, and all successful critical hits cause subsequent attacks to deal +1d8 damage (multiplied by critical hits). All attacks gain a +1 bonus on the attack roll per 25 <sakura> mastery. The final attack gains a +1 bonus on its critical damage multiplier and the bonus damage gained from previous critical hits increases to d12's.`,
                initiationAction: `full-round`,
                range: `melee attack`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Sakura"],
                level: 7,
                name: `Moment of Bloom`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[sakura-sakura-sakura-sakura-sakura] Make a single melee attack that deals additional damage equal to 2x your <sakura> mastery (not multiplied on critical hits). Afterwards you move 10 feet and sheathe your weapon immediately (doesn't provoke) and you gain a +3 dodge bonus to your armor class for 1 round, increased to +6 against the target of the attack as long as it hit. If this attack was a critical hit, the next time you hit the creature with a slashing melee attack, the attack deals additional damage equal to your <sakura> mastery. You can keep dealing this damage as long as every attack is a critical hit.`,
                initiationAction: `standard`,
                range: `melee attack`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Sakura"],
                level: 3,
                name: `Tsukikage`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[sakura-sakura-sakura-sakura] Every time a creature misses you with an attack, you gain 1 point of moon dance. For each point of moon dance you currently have, you gain a +1 dodge bonus to your armor class (max initiation modifier). Every time you attack a creature, you lose one moon dance stack and the attack deals an additional 1d6 points of precision damage per 6 <sakura> mastery. All stacks are lost at the end of the duration, but the dodge bonus remains, reducing by 1 every time a creature misses you with an attack (or the encounter ends). This dodge bonus does not stack with this finisher if it is reactivated.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Sakura"],
                level: 1,
                name: `One Cut, Ten Thousand Petals`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[sakura-sakura-sakura] Draw a sheathed melee weapon and make an attack with it and compare it to the armor class of all creatures within a 30 foot cone. This counts as a melee attack. It deals damage as normal plus 1d6 per 10 <sakura> mastery. This additional damage is multiplied on critical hits. After the attack you sheathe your weapon immediately. Neither sheathing or drawing this weapon provokes. If an attack is a successful critical hit, the creature takes the additional damage again at the start of its next turn.`,
                initiationAction: `movement`,
                range: `30 foot cone`,
                target: `creatures`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Sakura","Death"],
                level: 1,
                name: `Red Chrysanthemum`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[sakura-death-sakura] Draw a sheathed melee weapon, all creatures within a 30 foot cone must make a reflex save or take damage as if struck by the weapon plus 1d4 points of bleed damage plus 1d4 per 10 <sakura> mastery. After the attack you sheathe your weapon immediately. Neither sheathing or drawing this weapon provokes. If any of the creatures rolls a natural 1 on their save, the bleed damage they take is doubled. The DC increases by +1 per 10 <death> mastery.`,
                initiationAction: `movement`,
                range: `30 foot cone`,
                target: `creatures`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Death","Air"],
                level: 1,
                name: `Reaping Whirlwind`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[death-air-death] Every time you make a successful attack you gain 1 reaping wind stack. Every time you defeat a creature the duration of this finisher extends by 1 round and you gain 3 reaping wind stacks. For ever 2 reaping wind stacks your movement speed increases by 5 feet. This is an enhancement bonus. When it ends, enemies within 5 feet of you take 1d6 points of electricity damage per 2 stacks.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Death","Air"],
                level: 1,
                name: `Gale Reaper`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[death-air-death] Make an attack against all enemies within your reach. This attack deals damage as normal, plus 1d6 points of electricity damage per 10 <air/death> mastery. For every enemy hit, you gain a stacking +2 bonus on all damage rolls for 3 rounds. For every 20 <death/air> mastery the bonus to damage increases by +1.`,
                initiationAction: `standard`,
                range: `melee attack`,
                target: `enemies`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Air","Arcane"],
                level: 1,
                name: `Shredding Cyclone`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[air-arcane-air] You make a touch attack against an enemy. On success, they are surrounded by shredding cyclone for 3 rounds. At the start of each of their turns for 3 rounds they take 1d4 points of slashing damage, plus 1d4 per 10 <air/arcane> mastery. All ranged projectile attacks against them gain a +2 bonus on the attack roll.`,
                initiationAction: `free`,
                range: `melee attack`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Air","Death"],
                level: 1,
                name: `Murderous Gale`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[air-death-air] You make a touch attack against an enemy. On success, they are surrounded by murderous cyclone that punishes them for moving. For every 5 feet they willingly move, they take 1d4 points of slashing damage. For every 25 <death/air> mastery the damage increases by 1d4. This damage is totalled before being applied to DR for every movement action they take.`,
                initiationAction: `swift`,
                range: `melee attack`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Air","Death"],
                level: 3,
                name: `Last Breath on the Wind`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[air-death-death-air] Your next attack this round deals bonus precision damage equal to half the distance you have moved this round. Every square must be a unique square to count to the distance moved. Max damage is equal to  1.5x <death/air> mastery.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Void","Death"],
                level: 3,
                name: `Vector Force`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[void-death-death-void] Your next attack this round deals bonus damage equal to the distance away from where you started your turn. Max damage is equal to your <void/death> mastery.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Void","Death"],
                level: 1,
                name: `Voidwalker's Pounce`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[void-death-void] For every 15 feet you teleport, your next attack deals an additional 1d4 points of force damage. For every 20 <void/death> mastery, the damage per 15 feet increases by 1.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Arcane","Primal"],
                level: 1,
                name: `Primal Spellstorm`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[arcane-primal-arcane] Your damage spells deal an additional point of damage per dice rolled, but you take 2 points of damage per dice rolled. Your damage spells also gain a percentage critical chance equal to 1 per 20 <primal/arcane> mastery.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Arcane","Primal"],
                level: 1,
                name: `Arcane Bloodsurge`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-arcane-primal] For 3 rounds whenever you take damage, you restore 1 spell point. For every 20 <primal/arcane> the spell points gained increases by 1. The damage must be at least equal to your level to trigger this.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Arcane","Light"],
                level: 1,
                name: `Unicorn's Light`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[arcane-light-arcane] For every spell point you spend, you heal 1 hit point.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Arcane","Light","Heroic"],
                level: 3,
                name: `Unicorn's Glory`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[arcane-light-light/heroic-arcane/light] For every spell point you spend, you and all allies within 30 feet heal 1 hit point.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Arcane","Primal"],
                level: 1,
                name: `Spellrending Claws`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[primal-arcane-primal] Make an attack that ignores all miss chance granted by spells or supernatural effects. It deals damage as normal, plus 2d6 for every active spell on the target, and for every spell active, they have their spell resistance reduced by 1 for 1 round. If the target of the attack has no active spells on them, the attack automatically misses.`,
                initiationAction: `swift`,
                range: `melee or ranged attack`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Arcane","Primal"],
                level: 1,
                name: `Runic Savagery`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[arcane-primal-arcane] For 3 rounds, every time you make a successful weapon or natural attack you gain one savage rune. If the attack is made as a part of a primal or arcane strike, you instead gain 2 savage runes. After the duration ends, the next damage spell you cast within 3 rounds after that gains a bonus to damage of 1 plus 1 per 15 <arcane/primal> mastery, multiplied by your number of savage runes.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Primal","Air"],
                level: 1,
                name: `Reckless Swing`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[primal-air-primal] Move at least 10 feet in a straight line (even up) directly towards the target of this maneuver and then make a melee attack against them. Initiating this finisher costs hit points equal to twice your HD. It does bonus electricity damage equal to 1d4 plus 1d4 per 10 <primal/air> mastery.`,
                initiationAction: `free`,
                range: `melee attack`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Primal","Air"],
                level: 5,
                name: `Ragnarok`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-air-heroic-air-primal] For 3 rounds your armor class reduces by 8, but you reduce all damage you take by 10, you become immune to all crowd control effects, your movement speed increases by 5 feet per 15 <air/primal> mastery, and all your melee attacks deal additional 1d4 points of electricity damage per 15 <air/primal> mastery. After this finisher ends you become exhausted, and you cannot initiate it while exhausted.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Primal","Fire"],
                level: 1,
                name: `Burning Grasp`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-fire-primal] Every time you succeed on a grapple attempt the creature takes 1d6 points of fire damage, plus 1d6 per 10 <primal/fire> mastery. You also gain a +1 bonus on CMB checks to grapple per 10 <primal/fire> mastery.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Fire","Primal"],
                level: 1,
                name: `Demonfire Chokehold`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[fire-primal-fire] Make a grapple attempt that doesn't provoke, gaining a bonus on the roll of +1 per 10 <fire/primal> mastery. If it succeeds, the target immediately takes 1d6 points of fire damage per 5 <primal/fire> mastery. If at the start of your next turn you are still grappling them, they take the damage again, your grapple ends, and then they are immediately knocked prone (launching them downwards up to 500 feet, this also deals fall damage).`,
                initiationAction: `movement`,
                range: `melee`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Primal","Fire"],
                level: 1,
                name: `Unleashed Wildfire`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[primal-fire-primal] Expend an amount of random maneuvers of 1 + 1 per 10 <primal/fire> mastery (no sp cost). Afterwards, make a ranged or melee touch attack against an enemy within 50 feet, if successful, it deals 1d6 points of fire damage per level of all randomly expended maneuvers. It also gives 2 immolation per expended maneuver. These maneuvers cannot be recovered the round you use this. If a primal or fire maneuver is expended, the damage per level for that maneuver increases to 1d8, and if it is both, it increases to 2d6.`,
                initiationAction: `free`,
                range: `50 feet`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Primal","Fire"],
                level: 5,
                name: `Rampaging Supernova`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-fire-fire-primal] Every time you take at least HD damage from an attack while this is active, you gain 1 rampage stack. Whenever you reach 5 stacks, your stacks reduce to 0 and you can make make a melee attack as a free action that you can take even when not your turn. This attack deals an additional 1d4 points of fire damage per 10 <primal/fire> mastery. Every time this activates, the amount of stacks needed to activate it again reduce by 1 (minimum 2, resets every time you initiate it again).`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Power","Curse"],
                level: 1,
                name: `Shattering Hex`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power-curse-power] Make a melee attack, if it hits, it deals an additional 1d4 bludgeoning damage per 10 <power/curse> mastery, and they take a -2 penalty to AC and have their damage reduction reduced by 1 per 10  <power/curse> mastery. Whenever they take damage from a power maneuver, they take additional 1d6 bludgeoning damage and the penalty to damage reduction increases by 1.`,
                initiationAction: `movement`,
                range: `melee`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Power","Curse"],
                level: 1,
                name: `Wrathful Brand`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power-curse-curse-power] For 3 rounds, whenever a creature strikes you with a melee weapon, they take bludgeoning damage equal to your strength modifier.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Power","Curse"],
                level: 3,
                name: `Crushing Curse`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[power-curse-power] Make a melee attack, it deals damage as normal plus 1d4 per 5 <curse/power> mastery, and for 3 round they suffer a -2 to attack rolls, and if they roll a natural 1 on an attack roll they are automatically staggered for 1 round and this curse ends.`,
                initiationAction: `movement`,
                range: `melee`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Heroic","Royal"],
                level: 1,
                name: `Crown Forwards`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-royal-heroic] lose 1d4 hit points per 5 <heroic/royal> mastery and gain temporary hit points equal to the amount lost. As long as these temporary hit points last, you gain a +2 shield bonus to your armor class, plus 1 every 40 <heroic/royal> mastery. These temporary hit points are always lost before any other temporary hit points.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `up to 24 hours`
              },
              {
                comboTags: ["Dark","Power"],
                level: 3,
                name: `Dark Herald`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[dark-power-dark] lose 1d4 hit points per 5 <dark/power> mastery and gain temporary hit points equal to the amount lost. As long as these temporary hit points last, every time a creature attack you, they take damage equal to your strength modifier. These temporary hit points are always lost before any other temporary hit points.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `1 minute`
              },
              {
                comboTags: ["Guardian","Earth"],
                level: 1,
                name: `Iron Coat`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[guardian-earth-guardian] lose 1d4 hit points per 5 <guardian/earth> mastery and gain temporary hit points equal to the amount lost. As long as these temporary hit points last, you gain damage reduction adamantine equal to 1 per 10 <earth/guardian> mastery. This DR can stack with other DR, but it is reduced by half. These temporary hit points are always lost before any other temporary hit points.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `1 minute`
              },
              {
                comboTags: ["Curse","Death"],
                level: 1,
                name: `Blood Curse`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[curse-death-curse] lose 1d4 hit points per 5 <curse/death> mastery and gain temporary hit points equal to the amount lost. As long as these temporary hit points last and you remain with 60 feet of the target, they suffer a -2 penalty to attacks, armor class, and saves. These temporary hit points are always lost before any other temporary hit points.`,
                initiationAction: `swift`,
                range: `60 feet`,
                target: `1 enemy`,
                duration: `24 hours`
              },
              {
                comboTags: ["Primal","Dark"],
                level: 1,
                name: `Dark Predator`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-dark-primal] lose 1d4 hit points per 5 <primal/dark> mastery and gain temporary hit points equal to the amount lost. As long as these temporary hit points last, you take a -2 penalty to your armor class but you gain a +1 bonus on melee damage rolls per 5 <dark/primal>. These temporary hit points are always lost before any other temporary hit points.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `24 hours`
              },
              {
                comboTags: ["Air","Power"],
                level: 1,
                name: `Gale Hammer`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[air-power-air] You push a target directly away from you squares equal to your strength modifier, and they take 1d8 points of electricity damage for every square moved. If they strike a wall, they must make a fortitude save DC 10 + level/2 + initiation modifier + squares left to travel before striking the wall or be stunned until the start of their turn. This cannot push creatures more than 2 sizes larger than you.`,
                initiationAction: `swift`,
                range: `melee`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Power","Air"],
                level: 3,
                name: `Storm Blitz`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[power-air-power] Move up to your movement speed in a straight line and make a single melee attack at the end of the movement. The attack deals an additional 1d6 points of electricity damage per 10 feet moved and they must then make a fortitude save DC 10 + level/2 + initiation modifier +1 per 10 feet moved or become dazed for 1 round. For 1 round the weapon you used to make this attack becomes unusable and you take a -4 penalty to armor class.`,
                initiationAction: `standard`,
                range: `melee`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Power","Air"],
                level: 1,
                name: `Storm Surge`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[power-air-power] You spin your weapon and throw it, letting its momentum carry you through the air. Move 5 feet * your strength multiplier in a straight line any direction (even up) without provoking attacks of opportunity. If you directly collide with a creature or object, your movement stops, but you may make a touch attack against then, if successful dealing 1d4 points of electricty and 1d4 points of bludgeoning damage per your strength modifier. Alternataively, you can activate this when making a charge attack, if you do, your charge can move the additional distance equal to how far this ability would allow you to travel, and your first attack with the charge deals the bonus damage.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Technique","Power"],
                level: 1,
                name: `1st Class Soldier`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[technique-power-technique] You gain a +1 bonus on attack rolls while power attacking with a two-handed weapon (whether wielded in two hands or not). This bonus increases by +1 every 4 BAB. If you are not wielding a two-handed weapon, the bonus this grants is halved, and is halved again for off-hand attacks (minimum 0).`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Power","Technique"],
                level: 1,
                name: `1st Class Barbarian`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power-technique-power] You suffer a -1 penalty on attack rolls but gain a +3 bonus on damage rolls attacking with a two-handed weapon (whether wielded in two hands or not). The penalty increases by -1 and the bonus increases by +3 every 4 BAB. The bonus (including the increase every 4 BAB) is reduced to +2 damage while wielding one handed weapons, and reduced to +1 with off-hand weapons.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Power"],
                level: 1,
                name: `Strength Surge`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power-power-power] Increase your damage with melee weapons by your strength modifier. This is reduced to half strength modifier on one-handed weapons, and quarter strength modifier on off-hand weapons.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Arcane","Power"],
                level: 1,
                name: `Arcane Strength`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[arcane-power-arcane] Gain an enhancement bonus to your strength score equal to the amount of levels you have spells known.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Arcane","Power"],
                level: 1,
                name: `Runic Titan`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[arcane-power-power-arcane] Your spells and <arcane> maneuvers can use your strength modifier instead of initiation modifier to determine their DC's.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Arcane","Power"],
                level: 1,
                name: `Earthward Smite`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[power-air-earth/power] You knock a creature adjacent to you prone, and they take 1d6 damage per your strength modifier. If they are flying, they are instead launched directly downwards squares equal to your strength modifier. If they collide with the ground, they take fall damage as normal and fall prone.`,
                initiationAction: `movement`,
                range: `touch`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Arcane","Guardian"],
                level: 1,
                name: `Runic Shell`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[arcane-guardian-arcane] You gain 1d4 temporary hit points per 5 <arcane/guardian> mastery. These temporary hit points only reduce the damage of spells and spell-like abilities. As long as these last, you gain a +2 bonus on saves against spells and spell-like abilities. If you roll a natural 20 on a saving throw against a hostile spell or spell-like ability, the temporary hit points increase by 1d3 per level of the spell.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `24 hours`
              },
              {
                comboTags: ["Arcane","Power"],
                level: 7,
                name: `Mana Breaker`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[power-arcane-power-arcane-power] Make a melee attack, if it hits, it deals damage as normal plus they lose 1 spell of each level of spells known, and 1 use of a spell-like ability per 10 <power/arcane> mastery. The attack deals 1 bonus damage per level of spell lost, and 1d6 per spell-like ability lost.`,
                initiationAction: `movement`,
                range: `melee attack`,
                target: `1 enemy`,
                duration: `24 hours`
              },
              {
                comboTags: ["Arcane","Power"],
                level: 3,
                name: `Mana Hammer`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[arcane-power-power-arcane] You summon a magical hammer and slam it into the ground, causing all creatures within a 10-foot radius to make a fortitude save or take 1d4 points of force damage per 5 <arcane/power> mastery and be stunned for 1 round. You can choose for the DC of this ability to use either your initiation modifier or your strength modifier.`,
                initiationAction: `movement`,
                range: `30 feet; area: 10ft. radius burst`,
                target: `creatures`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Curse","Arcane","Elemental"],
                level: 3,
                name: `Ruinous Hexbrand`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[curse-arcane,elemental-curse] You cause a creature to become vulnerable to the elemental combo point used for 2 rounds.`,
                initiationAction: `swift`,
                range: `30 feet`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Power","Arcane"],
                level: 1,
                name: `Magus' Blade`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power-arcane-power] expend a spell slot when initiating this finisher. For melee attacks equal to the level of the spell, the attacks deal additional force damage equal to the base damage dice of your weapon (base damage dice is the damage dice it deals before modifiers except for size). For every 30 <power/arcane> mastery, the force damage increases by 1 dice step.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `until expended or 24 hours`
              },
              {
                comboTags: ["Power","Shadow"],
                level: 3,
                name: `Greatword in the Dark`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power-shadow-power] For 2 rounds, your melee attacks deal additional sneak attack damage equal to the damage dice of your weapon.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Death","Sakura"],
                level: 1,
                name: `Butterfly's Embrace`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[death-sakura-death] For 3 rounds, your melee attack apply 1 stack of Butterfly's Embrace. When a critical hit is confirmed against a creature with Butterfly's Embrace (by any creature), it takes 1d4 points of bonus precision damage and has its armor class and damage reduction lowered by 1 per 5 stacks expended for 1 round.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Arcane","Guardian","Power"],
                level: 5,
                name: `Runic Skin`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[arcane-power,guardian-arcane] You reduce the damage you take from spells and spell-like abilities by your strength modifier. Whenever a creature damages you with a spell, they take damage equal to your strength modifier.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Heroic","Power"],
                level: 3,
                name: `Power Through`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-power-heroic] You can use your strength modifier in place of your other modifiers for saving throws for 3 rounds. Every time you do this, you take a -2 penalty on all further saving throws for the rest of the duration, however you can end its duration as a free action.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Power","Dark"],
                level: 1,
                name: `Forsaken Self`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power-dark-power] Your attacks deal additional damage equal to your weapon's damage dice, however you take 25% of the bonus damage dealt. You can end this whenever you choose. If you defeat a creature with an attack empowered by this, you gain a +2 morale bonus to attack and damage for the remaining duration, and the duration increases by 1 round. This morale bonus stacks with itself.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Death","Dark"],
                level: 3,
                name: `Complete Disdain`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[death-dark-death] Take damage as if you had struck yourself with a weapon and then make a single melee attack with that weapon. It is an automatic potential critical hit and it has its critical damage multiplier increased by +1.`,
                initiationAction: `movement`,
                range: `melee`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Power","Void"],
                level: 1,
                name: `Lighter Than It Looks`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power-void-power] You can wield a two-handed weapon in one hand without penalties. It deals damage as if it was a one-handed weapon.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Power","Guardian","Heroic"],
                level: 1,
                name: `The Indomitable`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power-guardian/heroic-power] Immediately, plus at the start of your turn for the next 3 rounds, you gain temporary hit points equal to your strength modifier. These stacks with themselves.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Dark","Power"],
                level: 3,
                name: `Truly Fearsome`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[dark-power-dark] Gain a morale bonus to your intimidate equal to your strength modifier. The penalties shaken give to a creature during the duration of this ability become -3. Every 30 <dark/power> mastery, you can intimidate already shaken creatures an additional time, increasing their current penalties from being shaken by 1, however the duration of the shaken is not increased. `,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Dark","Power"],
                level: 1,
                name: `Strike of True Fear`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[dark-power-dark] Your next attack this round deals bonus damage equal to your intimidate bonus. This bonus damage is not multiplied on critical hits.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Curse","Dark","Power"],
                level: 3,
                name: `Contemptful Condemnation`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[curse-dark,power-curse] Make a damage roll with a weapon (no conditional bonuses) and curse all creatures within 20 feet of you. Within 3 rounds, the next time they make a damage roll, their damage is reduced by the damage roll you made. If they fail to do any damage, they take the damage of your damage roll, which bypasses DR, and you gain temporary hit points equal to half the damage this dealt (stacks, and lasts until combat ends).`,
                initiationAction: `swift`,
                range: `20 foot radius centered on you`,
                target: `enemies`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Heroic","Power"],
                level: 1,
                name: `Perfect Physical Specimen`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-power-heroic] You give an inspiring flex to allies within 30 feet of you (you are excluded). They gain a morale bonus on attacks that are using strength to determine their attack modifier equal to your strength modifier for 1 round.`,
                initiationAction: `swift`,
                range: `30 foot radius`,
                target: `allies`,
                duration: `1 round`
              },
              {
                comboTags: ["Void","Power"],
                level: 1,
                name: `Event Horizon`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[void-power-void] All enemies within 20 feet are pulled 5 feet towards you. Every 30 <void/power> mastery, the range increases by 10 feet and the distance pulled increases by 5 feet.`,
                initiationAction: `swift`,
                range: `30 foot radius`,
                target: `enemies`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Void","Power"],
                level: 1,
                name: `Singularity Hammer`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[void-power-power-void] Make a melee attack, For every 10 <void/power> mastery, you suffer a -4 penalty to the attack roll, but its damage dealt is increased by 1 dice step. You can choose to reduce the bonuses and penalties of this, but you must choose the penalty to attack before the roll is made.`,
                initiationAction: `swift`,
                range: `melee`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Earth","Power"],
                level: 1,
                name: `Adamantine Muscles`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth-power-earth] Gain a racial bonus to your natural armor equal to your strength modifier. Every time a creature misses you with an attack, the bonus is reduced by 1, but every time you are struck they take bludgeoning damage equal to the natural armor bonus left.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `1 minute`
              },
              {
                comboTags: ["Power","Fire"],
                level: 1,
                name: `Wildfire Reaving`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power-fire-power] Every time you make an attack that hits multiple creatures at once (such as cleave, or attacks that attack multiple creatures at once), all attacks deal an additional 1d3 points of fire damage per 5 <fire/power> mastery.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Power","Flurry"],
                level: 3,
                name: `Mordkonter`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power-flurry-flurry-power] You gain a dodge bonus to your armor class equal to your strength modifier. Every time an attack misses you, the bonus reduced by 1, but you can make a free touch attack against the attacker at a -5 penalty, if it hits, you deal damage equal to the base damage dice of one of a wielded weapon. This ends once the bonus has reached 0.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },              
              {
                comboTags: ["Void","Power"],
                level: 3,
                name: `Cosmic Cleave`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[void-power-power-void] Make a melee attack against an enemy, if it hits, it deals damage as normal plus 1d4 points of force damage per 10 <power/void> mastery, but all enemies except the creature struck, take 50% of the damage dealt as pure force damage. This transfered damage ignores critical hit damage.`,
                initiationAction: `movement`,
                range: `melee or ranged`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Technique","Power"],
                level: 1,
                name: `Mordhau`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[technique-power-technique] Make a melee attack against an enemy using a two-handed weapon, except that it becomes a bludgeoning weapon and it ignores armor bonus and half their natural armor bonus to armor class. After the attack, you suffer a -4 penalty to attacks and your attacks stay blugeoning damage until you spend a swift action to right your grip.`,
                initiationAction: `free`,
                range: `melee`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Technique","Power"],
                level: 1,
                name: `Krumphau`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[power-technique-power] Make a disarm attempt against an weapon or natural attack of your opponent, this attempt can be made with your weapon and doesn't provoke. If successful, the creature suffers a -4 penalty to its armor class until the start of its turn, and its next attack with that weapon or natural attack suffers a penalty on the roll equal to your strength modifier.`,
                initiationAction: `swift`,
                range: `melee`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                school: "sterlingSovereignty",
                level: 2,
                name: `Absetzen`,
                type: `Boost`,
                longDesc: `You choose one creature you can see, if it makes a melee attack against you within 1 round, you make a prepared attack that both parries and counterstrikes at the same time. You and the creature both make your attack rolls, however you suffer a -2 penalty for every size category larger it is than you. If your attack roll is higher than theirs, their attack misses, and if your attack roll is higher than their armor class, you also deal half your damage.`,
                initiationAction: `movement`,
                range: `melee`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Royal","Light"],
                level: 3,
                name: `Divine Cascade`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[royal-light-royal] Every time a creature misses you with an attack, you heal 1d6 hit points, plus 1d6 every 30 <light/royal> mastery. If the attack misses you because of you activating a counter, the healing is also given to all allies within 30 feet of you, and the healing specifically on you is doubled.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Death","Light"],
                level: 3,
                name: `Drink the Sacrifice`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[death-light-death] Every time you a creature takes damage because of one of your attacks, abilities, or spells, you heal 1d3 hit points, plus 1d3 every 40 <light/death> mastery. This activates even from damage over time effects like bleed.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Power","Light"],
                level: 3,
                name: `Will of God`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[power-light-power] Gain 1d4 temporary hit points, plus 1d4 per 10 <light/power> mastery. As long as those temporary hit points last, you gain a sacred bonus to your strength equal to your initiation modifier. These temporary hit points are always lost first, even before other temporary hit points.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `1 minute`
              },
              {
                comboTags: ["Void","Power"],
                level: 1,
                name: `Singularity Stance`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[void-power-void] You anchor yourself to this position in space. You are unable to move or teleport, willingly or unwillingly for 3 rounds. During this time, you gain DR /- 1 per 10 <void/power> mastery, and your attacks with melee weapons have their damage increased by 1 dice step, plus 1 step per 50 <void/power> mastery.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Power","Royal"],
                level: 1,
                name: `Overwhelming Fence`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power-royal-power] When you power attack with a two-handed weapon or a weapon wielded in two hands, you gain a shield bonus to your armor class equal to the penalty you normally recieve to your attack modifier from power attack (even if it is later reduced). If a creature misses you by an amount equal to or less than the shield bonus gained, they take bludgeoning damage equal to the base damage dice of your weapon. Every 40 <royal/power> mastery this lasts an additional round.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Power","Shadow"],
                level: 1,
                name: `Colpo di Villano`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[power-shadow-power] You can initiate this finisher when making another attack. Before you make the attack, make a feint against the attack's target. You can choose to use either stealth or bluff for the feint, and you gain a bonus on the roll equal to your strength modifier. If your feint check succeeds, they are flat-footed for the attack and it deals additional sneak attack damage equal to your weapon's base damage dice, +1 base damage dice per 40 <shadow/power> mastery. If the check fails, you can choose to resolve the attack normally, or you can choose to suffer a penalty to your armor class for 1 round equal to your strength modifier to also gain a bonus to the damage roll equal to twice your strength modifier (1.5x for one-handed, 1x for off-hand attacks).`,
                initiationAction: `free`,
                range: `melee`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Power","Primal"],
                level: 1,
                name: `Savage Power`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power/primal-power/primal-power] For 1 round, you take a penalty to your armor class equal to your strength modifier, but also gain a primal bonus to your strength score equal to your strength modifier. The added amount of strength does not change the bonus this gives. If your armor class drops to 0 because of the use of this ability, the duration increases by 1 round (this can only happen once per activation).`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },              
              {
                comboTags: ["Power","Void","Sakura"],
                level: 7,
                name: `I Need More Power`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power-void-sakura-void-power] On the round following the activation of this finisher, once during the round when making an attack roll, percentage miss chance, or saving throw versus a hostile effect, you are able to roll twice and take the better result. You must declare use of this before the roll is made. As long as you succeed on the roll, on the subsequent round, the amount of times you can reroll increases by 1. This can keep increasing each round, as long as you do not miss the attack or fail the save. Once you miss an attack or faill a save, you enter the crushing failure state. In this state you must roll twice on every attack roll, save, and miss chance and take the worse result. This continues until you roll a natural 20 on a save, or score a successful critical hit. You also enter the crushing failure state if you fail to use the reroll ability for an entire round.`,
                initiationAction: `full-round`,
                range: `personal`,
                target: `you`,
                duration: `see text`
              },
              {
                comboTags: ["Power","Guardian"],
                level: 1,
                name: `Unburdened Juggernaut`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power-guardian-power] You can increase the maximum dexterity bonus to armor class of your armor/shield/clothing of +1, +1 per 10 <guardian/power> mastery. You can split this bonus up amongst your armor, shield, or clothing as you see fit. For every additional point of armor class that this finisher is giving you, you gain a +2 bonus to your melee damage rolls, and a +1 bonus to your CMB and CMD.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Power","Sakura"],
                level: 1,
                name: `Power Waltz`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power-sakura-power] You can use your strength in place of your dexterity to determine your armor class and CMD.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Power"],
                level: 7,
                name: `Sweep The Field`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power-power-power-power-power] Your next single target melee attack with a two-handed weapon this round is resolved as a cone with a size equal to your reach. Treat this as a scatter weapon.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Power"],
                level: 1,
                name: `Titan's Challenge`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power-power-power] Make an opposed strength check versus a creature. The loser suffers a -4 penalty to attacks and armor class for 1 round, and a penalty to their damage rolls equal to 1/2 the winner's strength modifier. For every 30 <power> mastery the penalty increases by -1.`,
                initiationAction: `free`,
                range: `melee`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Power","Death"],
                level: 5,
                name: `Brutal Beat Down`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power-death-power] Make a melee attack with a two-handed weapon against a creature. If it hits, it deals damage as normal plus 1d6 per 10 <power/death> mastery, and you make an opposing strength check versus the creature, if you succeed, they fall prone and it provokes an attack of opportunity from you. If the creature is flying, it instead falls squares equal to your strength modifier.`,
                initiationAction: `movement`,
                range: `melee`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Royal","Death"],
                level: 3,
                name: `Scarlet Butchery`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[royal-death-royal] You gain Butcher points equal to either your dexterity modifier or initiation modifier (whichever is higher). You can expend one of these points to take an attack of opportunity. When you use these attacks of opportunity against a creature that provoked them because of an action you took (such as tripping a creature with the greater trip feat), or an ability that you activated that caused actions that dont normally to provoke anyway (such as abilities that cause them to provoke if they miss you with an attack), you can expend a Butcher point to cause the attack of opportunity to also deal bleed damage equal to the base damage of your weapon. If the creature was already bleeding, instead it doubles their bleed damage. If this bleed was caused by this ability, the doubling is permanent, if it was not, it is only doubled next round.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `24 hours`
              },
              {
                comboTags: ["Curse","Primal"],
                level: 3,
                name: `Feral Malediction`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[curse-primal-curse] [curse] You make an attack against a creature, on success it deals damage as normal but also curses them to degrade into a feral state. They must successfully deal damage with a melee attack every round to a creature with blood or they suffer a -1 penalty to their armor class, attack rolls, saves, and twice the penalty to concentration checks. This stacks every round they fail. During this time, they must always make concentration checks when attempting to cast spells DC 15 + spell level. If they fail to attack at all on a round, the penalty they are currently suffering doubles.`,
                initiationAction: `movement`,
                range: `melee or ranged`,
                target: `1 enemy`,
                duration: `1 minute`
              },
              {
                comboTags: ["Curse","Primal"],
                level: 1,
                name: `Savage Blood`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[curse-primal-curse] [curse] You make a melee attack against a creature, on success it deals damage as normal but also curses them to lash out in primal fury. They suffer a -4 penalty to armor class and reflexs saves, and they must make a will save to cast spells, but they also gain a +6 bonus to their strength score and a +2 bonus on their will saves. They cannot cast spells that heal hit points.`,
                initiationAction: `movement`,
                range: `melee`,
                target: `1 creature`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Curse","Primal"],
                level: 1,
                name: `Murderous Vow`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-curse-primal] You curse yourself, vowing to kill a creature you can see. You gain a +4 bonus on attacks against them, +4 bonus on saves against their abilities and spells, all of your attacks against them deal +1 damage per 5 <curse/primal> mastery, and your movement speed gains a +20 bonus when moving towards them (must end threatening them to gain this movement bonus). If the creature is alive in 1 round, you instantly take damage equal to 50% of your maximum hit points (before any temporary reductions).`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Primal","Flurry","Earth"],
                level: 1,
                name: `Mountain Cascade`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal/flurry-earth-primal/flurry] Your attacks deal an additional 1d6 damage. Each successful melee attack causes all subsequent attacks this round to deal an additional 1d6 damage. For every 20 <primal/flurry/earth> mastery the base damage per d6 increases by +1.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Earth","Power"],
                level: 1,
                name: `Crashing Down`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth-power-earth] When you activate this finisher, choose a melee weapon and then your turn ends. You cannot attack with that weapon until the start of your next turn. The first melee attack you make next turn with the weapon has its damage dealt increased by 2 dice steps and gains a +1 bonus to attack. Every 30 <earth/power> mastery the damage is increased by an additional dice step and it gains an additional +1 to attack. After making this attack, whether successful or not, you suffer twice the bonus you gained to the attack as a penalty to further attacks and your armor class for 1 round.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Arcane","Technique"],
                level: 1,
                name: `Arcane Blade`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[arcane-technique-arcane] You gain an enhancement bonus to your damage rolls equal to your initiation modifier. Additionally, you can choose to use your initiation modifier in place of your strength or dexterity to determine the attack bonus to your weapons, when you do, the enhancement bonus to damage instead becomes damage of an element of your choice (fire, electricity, cold, acid). For every 50 <arcane/technique> mastery this lasts an additional round.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Curse","Flurry"],
                level: 1,
                name: `Cuts From Nowhere`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[curse-flurry-curse] You curse a single creature you can see so that every time for 1 round that you make an attack against a creature other than them, they take 1d4 points of negative energy damage. Every 50 <curse/flurry> mastery this lasts an additional round and the damage increases by 1 dice step.`,
                initiationAction: `swift`,
                range: `50 feet`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Royal","Guardian","Earth"],
                level: 1,
                name: `Crown Trap`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[royal/guardian-earth-royal/guardian] You cannot move willingly or teleport for 3 rounds. During this time, any enemy that moves into your threatened area provokes attacks of opportunity from you (still only 1 AoE for a movement action). For every 15 <royal/guardian/earth> these attacks of opportunity deal an additional 1d6 points of damage and you gain an additional attack of opportunity each round.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Heroic","Earth"],
                level: 1,
                name: `The Wall`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-earth-heroic] You build a line of stone on the border of your threatened area. This wall is only an inch tall and cannot be destroyed. Enemies treat the area within the border as difficult terrain (even flying enemies). Each round that only you and allies are within the border, you all allies within it heal 1d6 hit points per enemy within 50 feet of the border, and those enemies take 1d6 damage per ally within the border. If any enemy is within the border, this ability does not function and you take 1d6 damage for every enemy within the border. Every 30 <heroic/earth> mastery, the damage and healing increases by 1d6 per ally/enemy.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Guardian","Death"],
                level: 1,
                name: `A Line You Shouldn't Cross`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[guardian-death-guardian] You create a shimmering line around your threatened area. As long as you remain within the area, if an enemy crosses the border it provokes an attack of opportunity from you, even if that movement normally wouldn't provoke. Once an enemy crosses over the border, the section they crossed over dissapates. If they provoke an attack of opportunity for trying to cross it, but you stop them from crossing it, that portion of the border is not broken. Enemies within the border can take the full defense action and leave the border without provoking from you, even if that normally would provoke from you. If the border is created where an enemy already is, that part of the border fails to materialize.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Heroic","Guardian","Water","Earth"],
                level: 3,
                name: `ICE`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic,guardian-earth,water] You can make a CMB check against all enemies that you threaten as if making a bull rush attempt (doesn't provoke). Any enemy that this succeeds against is automatically pushed out of your threatened area to the nearest acceptable square. If within 3 rounds they move into a square you threaten, it provokes an attack of opportunity from you. If this attack of opportunity hits, you can make a free bull rush attempt as described before, pushing them out of your threatened area again. This does not stop their movement in any way and they can continue moving, even charging. Once you miss one of these attacks against a creature, this ability ends in respect to them.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Earth",'Water'],
                level: 3,
                name: `Rock Shower`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth-water-earth] You create a storm of rocks in a 30 foot cone. All creatures within the cone take 1d3 points of bludgeoning damage per 5 <earth/water> mastery, though they can make a reflex save to halve it. All creatures that roll a natural 1 on the save fall prone.`,
                initiationAction: `movement`,
                range: `30 foot cone`,
                duration: `instantaneous`,
                target: `creatures`,
              },
              {
                comboTags: ["Royal","Earth"],
                level: 1,
                name: `Weight of the Crown`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[royal-earth-royal] The enemy treats every square as difficult terrain, even when flying. If the tile is difficult terrain because of a different natural obstacle, they must make an acrobatics (or fly if they are flying) check DC equal to your half of your <royal/earth> mastery or they provoke an attack of opportunity for leaving that square.`,
                initiationAction: `movement`,
                range: `15 feet`,
                duration: `3 rounds`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Royal","Earth"],
                level: 1,
                name: `Sovereign Mire`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth-royal-earth] The next time within 3 rounds the target creature tries to 5-foot step, it falls prone instead. If the creature is flying, it instead falls feet equal to half your <earth/royal> mastery. It can make an acrobatics check (or fly if flying) DC half of your <royal/earth> mastery to negate this.`,
                initiationAction: `free`,
                range: `10 feet`,
                duration: `3 rounds`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Death","Royal"],
                level: 3,
                name: `Death To Deserters`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[death-royal-death] The next time within 3 rounds an enemy that you threaten tries to move away from you, even if that movement doesn't normally provoke (such as 5-foot steps or using acrobatics) or tries to teleport away from you, that action provokes from you, and if the attack hits, their movement speed is halved, or negated if it was a 5-foot step. If it was telportation, they must make a concentration check DC equal to the damage dealt or the teleportation fails (Or just a 1d20 + level + highest mental if the teleportation wasn't from a spell or spell-like ability).`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Royal","Death"],
                level: 3,
                name: `Duel To the Death`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[royal-death-royal] You create a border around yourself and an enemy that you threaten. This border is the minimum size to encompass both of you and doesn't have any other effects like limiting other creatures movement or targeting. If either of you cross the border willingly, it provokes an attack of opportunity from the other, and that attack of opportunity deals double damage. This border remains until one of you is knocked unconcious or killed. If either of you willingly leaves before the other is defeated, they suffer a -4 penalty on all d20 rolls for 2 rounds and the other gains a +4 bonus on all d20 rolls against the other. If they are pushed outside out of their will, the border grows to encompass the new area. Attacks made by other creatures against the dueling creatures suffers a -4 penalty. Your attacks of opportunity against the dueling creature deal an additional 1 point of damage per 5 <royal/death> mastery.`,
                initiationAction: `swift`,
                range: `reach`,
                duration: `3 rounds`,
                target: `you and 1 enemy`,
              },
              {
                comboTags: ["Death"],
                level: 3,
                name: `It Has To Be This Way`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[death-death-death-death] You open yourself up to a deadly blow, exploiting that opportunity to make your own. When you initiate this finisher, you choose a target that you threaten and that threatens you, then you choose for either them, or for you to attack first. Whoever attacks first makes an attack as normal, but if the attack hits, its an automatic critical threat. As long as they survive, the other now does the same, but if it hits, its an automatic critical threat and the critical damage multiplier of the attack increases by a flat +1, and if its you, you can choose to gain either +4 to the attack roll or also deal your sneak attack damage as if they were flat-footed (ignores immunity to being flat-footed). For every 10 <death> mastery this attack deals an additional 1d6 damage. 
                \nIf you choose for them to attack first, they can choose not to attack at all, and then your attack is just a normal attack, however you still gain either +4 to the attack or deal your sneak attack damage and the bonus finisher damage. 
                \nAlternatively, they can instead choose to enter the full defense state for 1 round instead of attacking you. If the do, they do not get their standard action on their next turn and you do not get an attack at all.`,
                initiationAction: `movement`,
                range: `melee`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Dark","Death"],
                level: 7,
                name: `Now Kill Yourself`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[dark-death-dark-death-dark] You throw a weapon to the ground at a creature's feet and demand it kill itself. The creature makes a will save, on success, it immediately uses the weapon and deals critical damage to itself with it. This takes no actions for the creature and does not provoke. If it fails the save, on its next turn it instead uses a full-round action to deal critical damage to itself. The DC of this ability is increased by +1 per 20 <dark/death> mastery. If the creature does die from this, you immediately gain a dark combo point, and this maneuver permanently gains a +1 to its DC. If it does not, this finisher suffers a permanent -3 penalty to its DC. Creatures immune to mind-affecting or compulsion effects gain a +5 bonus on this save, but it otherwise still effects them.`,
                initiationAction: `standard`,
                range: `20 feet`,
                duration: `instantaneous or 1 round;see text`,
                target: `1 enemy`,
                stacksOne:0,
                stacksOneName:"Failure Count",
              },
              {
                comboTags: ["Sakura","Air","Void","Dark"],
                level: 7,
                name: `Approaching Storm`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[void/dark-sakura x2, air x2-void/dark] You take a round to find your motivation. During this round, a creature must make a will save DC 1/2 of your <void/dark/sakura/air> mastery or your intimidation bonus (whichever is higher) in order to attack or use any offensive ability against you. If they succeed this will save and successfully damage you, this finisher ends and has no further effects. Otherwise, during your next turn, you gain a +4 bonus on attacks and saves, +8 armor class, your critical threat range with all weapons increases by a flat +2, and your critical damage multiplier increases by +1. Additionally, you can move feet equal to your <void/air> mastery during your turn as a free action (you can split the movement into up to 3 free actions), and your attacks deal an additional 1d6 points of precision damage per 10 <sakura/dark> mastery, doubled on <sakura/dark/void/air> strikes that make only a single attack. None of these benefits apply to creatures that dont see you finding your motivation. 
                \nAdditionally, you can spend additional rounds finding your motivation, if you do, its duration increases by 1 round, and the bonuses to attack, AC, and saves increases by 1.`,
                initiationAction: `1 round`,
                range: `personal`,
                duration: `2 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Heroic","Sakura","Void"],
                level: 7,
                name: `Where's Your Motivation?`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-sakura,void-heroic] You demand to see the motivation of a creature. This must be used on a creature that threatens you, and if the creature is unable to take the attack for any reason, this finisher fails. As part of initiating this finisher the creature makes an immediate attack against you that never provokes. If the attack misses, your attacks against them gain a flat +1 bonus to their critical threat range and successful critical hits against them deal an additional 1d4 points of precision damage per 5 <void/sakura/heroic> mastery. Every time the creature misses you, the damage increases by 1 dice step, however once it hits you, this finisher ends. Every time you successfully confirm a critical hit on them, the critical threat range increases by an additional flat +1.`,
                initiationAction: `swift`,
                range: `see text`,
                duration: `1 minute`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Flurry"],
                level: 5,
                name: `Flurry Of Flurries`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[flurry-flurry-flurry-flurry] Every time you expend a flurry combo point (except with this finisher) you gain 1 flurry count stack. When you initiate this finisher, make a full-attack, while also gaining a bonus to all attacks equal to the amount of flurry stacks expended. You also gain additional attacks equal to your flurry count, each one at a -5 penalty from your previous attack, unless you are two-weapon fighting, in which case you take alternating main-hand then off-hand attacks, each only taking a -5 penalty for each previous attack with that hand you have taken. All of these attacks deal an additional 1 point of damage per 10 <flurry> mastery.`,
                initiationAction: `full-round and swift`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
                stacksOne:0,
                stacksOneName:"Flurry Count"
              },
              {
                comboTags: ["Flurry","Void"],
                level: 1,
                name: `Top Speed`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-void-flurry] You gain an additional standard action the round you initiate this boost. You can only use this standard action to make attacks or use <flurry/void> maneuvers.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },
              {
                comboTags: ["Royal","Flurry"],
                level: 1,
                name: `Twin King Style`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[royal-flurry-royal] For 3 rounds, whenever you make an attack of opportunity, you can also make an additional attack with your off-hand weapon. You take penalties for both attacks as if two-weapon fighting, and the off-hand attack does not count as an attack of opportunity for any other bonuses or abilities. Every time you use this effect and both attacks hit, they suffer an additional 1d4 points of precision damage plus 1d4 per 10 <royal/flurry>.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Flurry","Royal"],
                level: 1,
                name: `Wolf's Bite`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-royal-flurry] Choose a creature within 60 feet that you can see. Every time this round you successfully make an attack against that creature, they suffer a stacking -1 penalty to their armor class against attacks of opportunity and their movement speed is reduced by 5 feet (minimum 5 feet). These both last 3 rounds. If you reduce a creature's movement speed to 5 feet (cant activate once its speed has already reached 5 feet), it immediately provokes an attack of opportunity from all creatures that threaten it, though it does not take the penalty to AC for those attacks from this ability, then it falls prone.`,
                initiationAction: `free`,
                range: `60 feet`,
                duration: `3 rounds`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Flurry","Curse"],
                level: 1,
                name: `Mounting Spike`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-curse-flurry] Choose an enemy, every time you successfully damage that creature with an attack within 3 rounds, they take 1 mounting spike stack. When they reach 5 stacks, they suffer 1d4 points of damage plus 1d4 per 10 <curse/flurry> and their mounting spike stacks are returned to zero, however any additional activations of mounting spike have their damage dice increased by 1 step (per activation of it). This stacks.`,
                initiationAction: `free`,
                range: `60 feet`,
                duration: `3 rounds`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Sakura","Flurry"],
                level: 1,
                name: `Falling Petal Tempest`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[sakura-flurry-sakura] For 3 rounds, when you score a critical hit you may make an attack an additional attack at the same attack bonus of the critical hit, but with a -4 penalty. This attack deals off-hand damage, and unless you make it with an off-hand weapon, it suffers an additional -2 penalty to the attack. You can activate this only once during the duration, plus an additional time per 10 <flurry/sakura>.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Flurry","Sakura"],
                level: 1,
                name: `Perfect Petals`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-sakura-sakura-flurry] While you have this finisher readied and unexpended, whenever you score a critical hit in combat, you gain 1 perfect petal stack. When you initiate this finisher, you make an attack per perfect petal stack. These attacks start at your highest bonus, and then suffer mounting penalties as a full attack normally does (first at full BAB, next at -5, however if you have off-hand attacks, you can take those for lesser penalties. If you have more perfect petal stacks just keep iterating the attack penalties with primary and off-hand attacks as you did before).`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
                stacksOne:0,
                stacksOneName:"Perfect Petal Count"
              },
              {
                comboTags: ["Flurry","Sakura"],
                level: 1,
                name: `Crimson Petal`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-sakura-flurry] Every time you confirm a critical hit, it deals bonus precision damage equal to the damage dice of your off-hand weapon plus its enhancement bonus or dexterity modifier (your choice). If you are not using an off-hand weapon, instead just deals bonus precision damage equal to your weapons base damage dice. Every 5 <sakura/flurry> mastery this deals an additional point of damage.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Flurry","Fire"],
                level: 1,
                name: `Blazing Torrent`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-fire-flurry] During the duration, every successful attack applies 1 stack of immolation. On the turn this finisher ends, you may make 1 attack as a free action that deals an additional 1 point of fire damage per immolation stack applied during this finisher. Every 50 <fire/flurry> mastery this lasts an additional round.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `2 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Flurry","Technique"],
                level: 1,
                name: `Mounting Precision`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-technique-flurry] You gain a bonus to your attacks equal to the amount of previous attacks you have taken this round.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Flurry","Dark"],
                level: 1,
                name: `Mounting Fury`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-dark-flurry] For 3 rounds, every time you make a successful attack that doesn't defeat a creature, you gain 1 mounting fury stack. On the turn this finisher ends, you may make a melee attack at your highest bonus as a free action, it deals 1d6 bonus damage per mounting fury stack you have. For every 15 <dark/flurry> this attack gains a +1 bonus on the attack roll.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Flurry","Death"],
                level: 5,
                name: `Death's Duet`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-death-flurry] Make 2 attacks at a -10 penalty. The second attack deals off-hand damage and if it is not made with an off-hand weapon, suffers an additional -5 penalty to the attack. You also suffer penalties for two-weapon fighting (regardless of whether you are or not). If both attacks hit, the creature takes additional bleed damage of 1 per 5 <death/flurry>.`,
                initiationAction: `swift`,
                range: `melee`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Primal","Flurry"],
                level: 1,
                name: `Wallop`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-flurry-primal] Make a melee attack, it deals bonus damage equal to the base damage dice of every other weapon you are wielding or natural attack that you have.`,
                initiationAction: `movement`,
                range: `melee`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Death","Curse"],
                level: 1,
                name: `Sentence of the Doomed`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[death-curse-death] Your critical threat range with attacks becomes 20 (this cannot increase your critical threat range, or be increased by any abilities or effects). Every successful attack grants one stack of Mounting Doom. Once you threaten a critical hit with a weapon attack, all stacks are expended, and if that critical threat confirms, it deals an additional 1d2 points of damage per stack expended. For every number in your critical threat range (without any modifiers, unless they were active the whole duration of this finisher), the bonus damage increases by 1 dice step. For every 15 <death/curse> mastery, you gain a +1 bonus on confirmig this critical threat, and ignore 5% of the creature's fortification.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `until triggered or 1 minute`,
                target: `you`,
              },
              {
                comboTags: ["Sakura","Power"],
                level: 1,
                name: `Blooming Guillotine`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[sakura-power-sakura] For this round or until you threaten a critical hit, your critical threat range has your critical damage multiplier added to it as a flat bonus. Every 50 <sakura/power> mastery, this lasts an additional round and an additional threatened critical hit.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },
              {
                comboTags: ["Sakura","Power"],
                level: 5,
                name: `Guillotine in Full Bloom`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[sakura-power-sakura-power-sakura] For your next attack this round, your critical threat range is reduced by a flat -1, but its new critical threat range (the amount of results on the dice that would result in a potential critical hit) is added to your weapon's critical damage multiplier. Every 50 <power/sakura> mastery this lasts an additional attack.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },
              {
                comboTags: ["Technique","Fire"],
                level: 1,
                name: `Sunset Blade`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[technique-fire-technique] Make an attack, it deals an additional 1d6 points of fire damage, +1d6 per 10 <fire/technique>. If the target of the attack is below 50% hit points when you make it, then your critical threat range increases by a flat +1 and the fire damage is multiplied on critical hits. If the target is not below 50% when you make the attack, but is reduced to or below it by the attack, then it catches fire, taking an amount of d6's every round equal to this maneuvers bonus fire damage, reduced by 1d6 every round. It can put this fire out with the normal rules for putting out fire, however the reflex DC increases by the amount of d6's of fire damage it is taking, and your initiation modifier.`,
                initiationAction: `movement`,
                range: `melee or ranged`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Technique","Death"],
                level: 1,
                name: `Put Down`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[technique-death-technique] You can initiate this finisher against a prone, dazed, stunned, or helpless target. Make a melee attack against the target at a -10 penalty, but its damage is increased by 1% per 2 <technique/dark> mastery.`,
                initiationAction: `movement`,
                range: `melee`,
                duration: `instantaneous`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Fire","Curse"],
                level: 1,
                name: `Pyre of the Accursed`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-curse-fire] Make a touch attack, if successful the target must make a will save or become the Accursed Pyre for 3 rounds. It suffers a -2 penalty on this save if it is already cursed, and a -1 for every 5 immolation stacks. While cursed this way, it suffers a -2 penalty on all saves against fire effects, and when it takes fire damage, all its allies within 20 feet of it take 10% of the fire damage it took plus 1% per 3 <fire/curse> mastery. If the effect that is dealing fire damage to it is also injuring those allies, the damage they take from this is reduced by half.`,
                initiationAction: `movement`,
                range: `melee`,
                duration: `2 rounds`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Curse","Elemental"],
                level: 1,
                name: `Accursed Nexus`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[curse-elemental-curse] Make a touch attack, if successful, the target becomes cursed to absorb elemental energy. It suffers a -1 penalty on all saves that deal energy damage of the combo point used, and every time one of its allies within 20 feet of it (not including itself) takes energy damage of the combo point used, it takes 1% of that damage per 2 <elemental/curse> mastery. If elemental damage from multiple attacks are damaging a creature at once (like multiple attacks from a single creature that all deal elemental damage), total the elemental damage before applying the percentage of damage. The target of this maneuver only takes this damage from this finisher once if an effect deals elemental damage to multiple creatures within the range at once.`,
                initiationAction: `movement`,
                range: `melee`,
                duration: `2 rounds`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Elemental","Light"],
                level: 3,
                name: `Elemental Benediction`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[elemental-light-elemental] both elemental combo points must be the same. For 1 round, every time a creature within 30 feet of you takes elemental damage of the combo points used, you heal hit points equal to half the damage taken. Every time you take damage of the elemental combo point used, allies within 15 feet gain temporary hit points equal to the damage taken that last 2 rounds. These apply after the damage is dealt if the damage also would be dealt to them.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },
              {
                comboTags: ["Technique","Death"],
                level: 1,
                name: `Cull The Weak`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[death-death-death] Your next attack this round has its critical threat range increased by a flat +1 for every different source of bleeding the creature is currently suffering from. A successful critical hit deals additional precision damage equal to the bleed damage it is suffering from, multiplied by your critical damage multiplier.`,
                initiationAction: `swift`,
                range: `melee`,
                duration: `1 round`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Death","Technique"],
                level: 1,
                name: `Broken Dreams`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[death-technique-death] Make a melee attack at a -5 penalty, it deals additional precision damage equal to 1d4 for every -1 penalty the creature is currently suffering to its armor class. This only includes penalties, not lack of bonuses (such as being flat-footed). If the attack hits, for every different source of penalties to AC that they are suffering, they take 1d4 points of bleed damage.`,
                initiationAction: `movement`,
                range: `melee`,
                duration: `1 round`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Power"],
                level: 1,
                name: `Pump Up The Power!`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power-power-power] Every time you initiate this finisher, you gain a stacking +3 to damage rolls with two-handed weapons for the rest of the encounter. One handed weapons gain +2, and off-hand weapons gain +1. This bonus ends if you exit or enter combat.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `encounter`,
                target: `you`,
              },
              {
                comboTags: ["Primal"],
                level: 1,
                name: `Numbers Go Up`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-primal-primal-primal-primal] At the start of your next 3 turns, roll 1d4, for the rest of the duration of this finisher, you gain that bonus to your melee damage rolls (this stacks each turn). If you roll a 1, the damage bonus reduces by 3, but if you roll a 4, the duration increases by 1 round.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Sakura","Fire","Curse"],
                level: 1,
                name: `Shōen`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[sakura-fire-curse] The next time within 3 rounds that you confirm a critical hit, the target receives one stack of Shōen's curse. For each stack of Shōen's curse that a creature has, it takes 1d6 points of fire damage at the start of its turn, creatures receive a +1 bonus to confirm critical hits against it, and it loses 5% of its fortification. Until this fire is put out, every time a critical hit is confirmed against the creature, the amount of stacks are doubled. If a cursed creature is killed by a confirmed critical hit, this curse jumps to another enemy within feet equal to half of your <curse/fire/sakura> mastery. A creature can attempt to end this curse by spending a full round action to make a will save vs this maneuver's DC.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Flurry","Water"],
                level: 1,
                name: `Riptide Stride`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-water-flurry] For 1 round, every time you move as a part of a movement action, maneuver, or ability, you can make a single melee attack against a creature you threaten during the movement as a free action. These attacks all deal off-hand damage, but if not made with an off-hand weapon suffer a -4 penalty to the attack. For every 15 <flurry/water> mastery these attacks deal an additional 1d4 points of damage.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `1 round`,
                target: `you`,
              },
              {
                comboTags: ["Fire","Curse"],
                level: 1,
                name: `Hellfire Reproach`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-curse-fire] For 2 rounds, every time you are attacked, the attacker takes 1 immolations stack. If a creature receives 10 stacks from 1 activation of this finisher, they immediately take fire damage equal to 1/2 your <fire/curse> mastery.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Curse","Fire"],
                level: 1,
                name: `Burning Toll`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[curse-fire-curse] All enemies within 60 feet immediately take 1d4 points of fire damage per immolation stack they have. You can also remove immolation stacks on creatures in increments of 5 to give them a -1 penalty to attacks and saves for 1 round, and they must make a will save with a penalty equal to however many 5 stacks you removed, or they suffer an additional 1d4 points of fire damage for every stack removed.`,
                initiationAction: `swift`,
                range: `60 feet`,
                target: `enemies`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Fire","Light"],
                level: 1,
                name: `Kindled Oath`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-light-fire] All allies within 60 feet immediately heal 1d4 points per immolation stack they have. You can also choose to remove up to half the stacks a creature has. For every stack removed, except the ones removed from you, you heal an additional hit point. For every 5 stacks removed from allies (still not you), you gain a +1 bonus on attacks and saves for 1 round.`,
                initiationAction: `swift`,
                range: `60 feet`,
                target: `enemies`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Arcane"],
                level: 1,
                name: `Overflow`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[arcane-arcane-arcane] In 3 rounds, you gain an extra swift action. When your <arcane> mastery reaches 40, it instead becomes a movement action. when it reaches 80, it becomes a standard action.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Arcane"],
                level: 1,
                name: `Pure Burn`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[arcane-arcane-arcane] The next time within 3 rounds that you deal elemental, force, or siphon damage, all creatures damaged suffer 1 constitution damage at the start of their next 3 turns. Every 50 <arcane> mastery the damage increases by 1 constitution damage.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Arcane"],
                level: 1,
                name: `Spellplague`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[arcane-arcane-arcane] You carve an arcane mark into the air. For 1 round every time a creature within 30 feet of the rune takes elemental (not force), or siphon damage, they also take 1d4 points of force damage. If an attack deals elemental damage from multiple sources at once, such as a flaming sword using a fire maneuver, they creature takes 1d4 force damage for both sources. Every 50 mastery this lasts an additional round, and the damage increases by 1 dice step.
                \nThis damage cannot trigger itself under any circumstance, even if you somehow make this force damage deal a different energy type, make them take additional damage when they take damage, or anything else.`,
                initiationAction: `movement`,
                range: `30 feet`,
                target: `square`,
                duration: `1 round`
              },
              {
                comboTags: ["Heroism","Curse"],
                level: 1,
                name: `Tribute of Agony`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroism-curse-heroism] You take 1d4 points of unresistable damage, but all allies within 50 feet heals that amount. Every round, at the start of your turn, the amount of D4's you roll doubles, and continues for up to 5 rounds, however you can end it as a free action, though you cannot end it before it is rolled on your turn. Every 40 mastery the damage starts at 1d4 higher.`,
                initiationAction: `swift`,
                range: `50 feet`,
                target: `you`,
                duration: `5 rounds`
              },
              {
                comboTags: ["Heroism","Curse"],
                level: 1,
                name: `Shield of Suffering`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroism-curse-heroism] You immediately transfer a non-permanent condition that an ally has to yourself, and then you make an immediate save against it at the same DC it was applied to them at. If you succeed, the effect is treated as if you had saved against the original effect, but you otherwise suffer its penalties, but you also gain a +2 bonus to attacks, saves, and damage rolls for 2 rounds, and the creature whose effect you saved against suffers a -2 penalty to all attacks, saves, and damage rolls for 2 rounds.`,
                initiationAction: `swift`,
                range: `50 feet`,
                target: `you`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Dark","Curse"],
                level: 1,
                name: `Blighted Strength`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[dark-curse-dark] Pick a one of the following: armor class, saves, attack, or ability score damage. For 2 rounds, you gain a bonus on damage rolls equal to the penalty you are taking to any of those roll types, even willing penalties such as from power attack. If you picked ability score damage, it can be damage you have to all of your ability scores at once.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Dark","Death"],
                level: 1,
                name: `Death Spiral`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[dark-death-dark] For 1 round, you deal bonus damage equal to the damage the target of the attack has to all of its ability scores combined. You get double the bonus for points of drain, and half the bonus for penalty. This bonus damage is not multiplied on critical hits.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Death","Dark"],
                level: 5,
                name: `Crushing Malediction`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[death-dark-dark-death] Choose an ability score for a creature, all of its penalty to that ability score becomes damage, and any damage becomes drain. If they had drain already, they suffer a -1 on all d20 rolls for 1 round equal to their drain.`,
                initiationAction: `movement`,
                range: `30 feet`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Curse","Sakura"],
                level: 1,
                name: `Twilight Flower`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[curse-sakura-curse] Choose a creature, at the end of each of their turns they suffer 1d6 points of damage. Each round after, the damage doubles. Once they score a critical hit, this finisher ends immediately. They can also spend a full-round action to make a will save against it. Every 25 <sakura/curse> the base damage increases by +1.`,
                initiationAction: `swift`,
                range: `30 feet`,
                target: `1 enemy`,
                duration: `1 minute`
              },
              {
                comboTags: ["Curse","Heroic"],
                level: 1,
                name: `Pain Prism`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[curse-heroic-curse] Your allies within 30 feet of you (you excluded) suffer 1d6 points of damage, plus 1d6 per 15 <heroic/curse> mastery. You gain temporary hit points equal to the total damage done. As long as these temporary hit points last, they gain a +2 bonus on attacks and saves. You can end these temporary hit points as an immediate action, doing so allows you to choose a cursed enemy within 30 feet to take damage equal to the temporary hit points you have left from this ability, and you heal half of the damage dealt. These temporary hit points are lost first, even before other temporary hit points.`,
                initiationAction: `movement`,
                range: `30 feet`,
                target: `allies`,
                duration: `1 minute`
              },
              {
                comboTags: ["Curse","Light"],
                level: 1,
                name: `Radiant Retribution`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[curse-light-curse] Choose an ally (you excluded), all damage they take from enemies for 3 rounds, you heal half of. If this heals you to maximum hit points, for every hit point this has healed since you activated it, the creature that dealt the damage that caused you to heal to full, takes that much damage. Once this happens, this finisher ends.`,
                initiationAction: `swift`,
                range: `30 feet`,
                target: `ally`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Arcane","Dark"],
                level: 1,
                name: `Doom Equation`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[arcane-dark-arcane] In 3 rounds, the target enemy suffers damage equal to 1/2 your <dark/arcane> mastery. As a standard action, you can reduce the time until this is delivered by 1 round, and increase the damage by 100%. This adds cumulatively.`,
                initiationAction: `free`,
                range: `30 feet`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Dark","Guardian"],
                level: 1,
                name: `Doomward`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[dark-guardian-dark] Every time you take damage from a creature, they take an equal amount of damage back. Once this finisher has dealt damage equal to your <dark/guardian> mastery, this finisher ends.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Arcane","Guardian"],
                level: 1,
                name: `Rune Guardian`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[arcane-guardian-arcane] Every time you take damage from a creature, they take an equal amount of damage back. Once this finisher has dealt damage equal to your <dark/guardian> mastery, this finisher ends, but the creature that dealt the remaining damage immediately provokes an attack of opportunity from you, and the attack deals additional damage equal to half the damage of the attack that activated this effect.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Dark","Royal"],
                level: 1,
                name: `Bloody Mandate`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[dark-royal-dark] Choose a creature, they must deal damage to you equal to your <dark/royal> mastery within 3 rounds, if they fail, they immediately suffer damage equal to your <dark/royal> mastery, and provoke an attack of opportunity from all creature that threaten them, and also suffer a -2 penalty to their armor class for all of these attacks, and they deal an additional 1d4 points of negative energy damage per 10 <dark/royal> mastery.`,
                initiationAction: `swift`,
                range: `30 feet`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Dark","Royal","Guardian"],
                level: 5,
                name: `Black Scourge`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[dark-guardian-royal-guardian-dark] Your armor class suffers a -8 penalty. Any creature who damages an ally within 20 feet of you, also takes half of that damage back. You gain temporary hit points equal to your <dark/guardian/royal> mastery, which are always lost first, even before other temporary hit points. As long as these last, every time you take damage from an enemy, all other enemies within your reach suffer damage equal to the damage you took and allies gain an equal amount of temporary hit points that last 1 round (stacks).`,
                initiationAction: `movement`,
                range: `20 feet`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Dark","Primal"],
                level: 1,
                name: `Dark Fury`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[dark-primal-dark] For 3 rounds, whenever a creature within your reach threatens a critical hit against you (this is determined after fortication is rolled), it provokes an attack of opportunity from you. This attack of opportunity deals an additional 1d6 points of damage per 15 <dark/primal> mastery. If their critical threat confirms, you gain temporary hit points equal to the damage it dealt for 1 round.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Heroic","Curse"],
                level: 1,
                name: `King's Chains`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-curse-heroic] Choose a creature, every time you damage them, your damage against them reduces by 1 for the remaining duration, but all of your allies gain an equal amount of a damage bonus against that creature.`,
                initiationAction: `swift`,
                range: `50 feet`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Dark","Light"],
                level: 1,
                name: `Cycle of Agony`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[dark-light-dark] For 1 round, every time the enemy takes damage from a creature other than you, you heal half that amount. If you are healed to full, this ends, but it immediately takes damage equal to a percentage of the amount you healed from this finisher equal to 25% plus half <light/dark> mastery.`,
                initiationAction: `free`,
                range: `30 feet`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Light","Dark"],
                level: 1,
                name: `Darklight`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[light-dark-light] When you activate this finisher, choose a creature you can see. At the start of your next turn, it takes a damage equal to a percentage of the hit points you healed during the previous round. The percentage being 25% plus half <light/dark> mastery. Overhealing, temporary hit points, and healing that goes above your maximum hit points do not count for this damage.`,
                initiationAction: `free`,
                range: `30 feet`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Royal","Light"],
                level: 1,
                name: `Gilded Line`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[royal-light-royal] For 3 rounds, you heal 1d4 hit points every time you take an attack of opportunity, and every time you deal damage with an attack of opportunity you gain 1d4 temporary hit points (stacks). If it is provoked because of an action you took, the healing and temporary hit points are doubled. The temporary hit points last 3 rounds and stack with each other. Every 20 <light/royal> mastery the healing and temporary hit points increase by 1d4. If you are full hit points, your attacks of opportunity instead deal damage equal to the amount of healing you would have recieved, and you gain a +1 to attack per 20 <light/royal> mastery on these attacks.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Curse","Dark"],
                level: 5,
                name: `Black Communion`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[curse-dark-curse-dark-curse] Kill an ally, all enemies within 60 feet take damage equal to the hit points they had before they died, and all allies heal an equal amount of hit points. The total damage is increased by 1% per 2 <dark/curse> mastery, if this kills an enemy, you can recover initiation modifier maneuvers. The ally killed by this ability cannot be revived for 3 rounds.`,
                initiationAction: `full-round`,
                range: `60 feet`,
                target: `creatures`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Curse","Shadow"],
                level: 1,
                name: `Sable Requiem`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[curse-shadow-curse] Whenever the target suffers precision damage, they also suffer a -1 penalty to armor class for 1 round (stacks). The max total penalty that this can apply over its duration is equal to 1 per 5 <shadow/curse> mastery, and never more than -5 to any specific creature. If a creature has a -5 penalty from this, all attacks against it gain a flat +1 bonus to their critical threat range.`,
                initiationAction: `swift`,
                range: `60 feet`,
                target: `creatures`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Arcane","Death"],
                level: 1,
                name: `Finger of Death`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[arcane-death-arcane] Make a melee attack with a -5 penalty, it deals bonus damage equal to your <death/arcane> mastery, however they are allowed a fortitude save to reduce the total damage of the attack by half. `,
                initiationAction: `movement`,
                range: `melee attack`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Shadow","Air"],
                level: 1,
                name: `Drifting Shade`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-air-shadow] Move squares equal to your dexterity modifier (doesn't provoke). The next attack against you within 1 round suffers a miss chance equal to your <shadow/air> mastery (stacks with othe miss-chance, but is rolled seperately). If that attack misses you because of this miss chance, you can move the distance again as a free action you can take even when not your turn, though you move 1 square shorter than you did last time and the miss chance reduces by 10%. You can keep doing this, as long as the attacks keep missing you, but the distance moved reduced by 1 every time.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Fire","Death"],
                level: 5,
                name: `Heat Death`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-death-death-fire] The next time this round that you deal fire damage with a weapon attack, that fire damage becomes bleed damage. This can only affect a single creature that takes the fire damage.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Shadow","Technique"],
                level: 1,
                name: `Discombobulation`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[shadow-technique-shadow] Make a touch attack, if successful, the creature suffers a penalty to its armor class equal to your dexterity modifier or initiation modifier, whichever is higher. Every time they are attacked, this penalty reduces by 1. This finisher is not expended when used, but can only be used against the same target again until the penalty is reduced to 0, at which point it is expended as normal. If you can reduce a creature's total armor class below 0 with this finisher, they are automatically stunned for 1 round, this finisher recovers, but also ends on them, and you may make an attack against them as a free action, for which you do bonus damage of 1d4 per 5 <shadow/technique> mastery.`,
                initiationAction: `swift`,
                range: `touch`,
                target: `1 enemy`,
                duration: `1 minute`
              },
              {
                comboTags: ["Technique","Water"],
                level: 1,
                name: `Northern Saint`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[technique-water-technique] Make a ranged attack with a melee weapon. Treat this in all ways as if it was a melee attack, including how your attack and damage are calculated, however it has a range of 50 feet, +5 feet per 15 <water/technique>. This attack has its base damage dice doubled, and deals an additional 1d6 points of damage per 5 feet the weapon travels.`,
                initiationAction: `immediate`,
                range: `ranged attack`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Technique","Earth"],
                level: 1,
                name: `Leaden Foot`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[technique-earth-technique] Make a touch attack against an opponent, on success, they are unable to move from their current space for 1 round, they are unable to stand up from being prone, and cannot take attacks of opportunity provoked when someone tries to trip them. Additionally, they suffer a -4 penalty to their CMD against trips, increasing by -1 every 30 <technique/earth> mastery. If they are successfully tripped during this, they suffer 1d6 points of damage per your strength modifier.`,
                initiationAction: `free`,
                range: `melee touch`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Technique","Earth"],
                level: 1,
                name: `Stonebreaker's Stance`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[technique-earth-technique] You can take the penalty for using power attack with melee weapons to your armor class instead of your attack modifier. During this, your BAB counts as 1 higher for the damage gained and armor class lost per 20 <earth/technique> mastery.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Technique","Dark"],
                level: 1,
                name: `Harsh Requiem`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[technique-dark-technique] Make a melee attack, it provokes attacks of opportunity from the target of the attack, but it gains a +5 bonus to the attack and bypasses DR, however the attack roll is considered 10 lower for counters. If successful, it deals an additional 1d4 points of damage per 5 <dark/technique> mastery.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Technique","Dark"],
                level: 1,
                name: `Tenebris Thrust`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[technique-dark-technique] The next time within 3 rounds that you successfully counter an attack and cause it to deal no damage to you, and you threaten the attacker, it provokes an attack of opportunity from you. This stacks if you could already make an attack of opportunity for countering an attack. If the attack hits, the creature must make a fortitude save, or be staggered for the rest of their turn.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Technique","Air"],
                level: 1,
                name: `Whirlwind Finish`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[technique-air-technique] The next time within 3 rounds that you successfully confirm a critical hit, you can make an additional attack at your highest bonus -5 as a free action. This additional attack deals an additional 1d6, plus 1d6 points of electricity damage per 10 <air/technique> mastery. After making this attack, at any point before the end of your next turn, you can move 5 feet as a free action you can take even when not your turn.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Technique","Water"],
                level: 1,
                name: `Riptide Wake`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[technique-water-technique] Move up to your movement speed, making a single melee attack against a creatue you threaten as you move. You cannot end your movement threatening them, nor can you attack a creatue you are threatening at the start of your movement. This attack deals an additional 1d6 points of cold damage per 10 <water/technique> mastery. You gain a dodge bonus to your armor class equal to your initiation modifier against the target of the attack during the movement and for 1 round after. During the movement, if they miss you with an attack of opportunity, it provokes an attack of opportunity from you, though it suffers a -5 penalty.`,
                initiationAction: `movement`,
                range: `melee attack`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Technique","Primal"],
                level: 1,
                name: `Fanged Defense`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[technique-primal-technique] For 1 round, every time a creature misses you with a melee attack, they suffer damage equal to a natural weapon's base damage plus your 1/2 strength modifier. If they miss you because you countered the attack, they suffer damage as if you had struck them with your natural weapon as an off-hand attack.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Shadow","Royal"],
                level: 1,
                name: `Treacherous Rule`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-royal-shadow] The next time a creature you threaten misses you with an attack within 3 rounds, you can make an immediate dirty trick against them as a free action you can take even when not your turn (doesn't) provoke. If the dirty trick is successful, they suffer bleed damage equal to your sneak attack or similar precision damage.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 round`
              },
              {
                comboTags: ["Water","Shadow"],
                level: 1,
                name: `Treacherous Tide`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[water-shadow-water] Make a melee touch attack, if successful, move the target squares equal to your initiation modifier. All of these squares must be within your natural reach, except for the last one. For every square you dont move them, they suffer a -1 penalty to their armor class and to counters for 1 round.`,
                initiationAction: `movement`,
                range: `melee touch`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Shadow","Water"],
                level: 1,
                name: `Phantom Undertow`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-water-shadow] Choose a creature, for the next 3 rounds, once per round as a free action, you can move the creature 10 feet directly towards, or away from you. If the creature moves more than 30 feet away from you, its movement speed is halved.`,
                initiationAction: `movement`,
                range: `30 feet`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Shadow","Water"],
                level: 1,
                name: `Ebb and Weave`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-water-shadow] Make an opposed reflex check versus a creature, if you win, until the end of your next turn, all of your attacks against them are flat-footed as if they had been feinted by you, and suffer a -4 on all attacks against you.`,
                initiationAction: `free`,
                range: `30 feet`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Shadow","Water"],
                level: 1,
                name: `Tide and Shadow`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-water-shadow] Make an opposed reflex check versus a creature, the winner may make a melee attack against the loser.`,
                initiationAction: `free`,
                range: `melee attack`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Shadow","Air"],
                level: 1,
                name: `Sable Dart`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-air-shadow] Make a ranged attack against an enemy with a throwing or light weapon. Light weapons suffer no penalty when being thrown this way, and have a range of 10 feet. If the attack hits, they are blinded for 1 round, and it deals an additional 1d6 points of electricity damage per 10 <shadow/air> mastery.`,
                initiationAction: `free`,
                range: `30 feet`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Shadow","Air"],
                level: 1,
                name: `Wraithfog`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-air-shadow] You create a cloud of fog that obscures sight of you, only foiled by blindsight. This doesn't obscure anything but you. Immediately upon activation you can move 10 feet without provoking. Afterwards, you can make an immediate stealth check to hide as a free action. Once per round as a swift action you can attempt to hide in the fog again. Every time you succeed in doing so to hide from at least 1 enemy, you can recover a single <shadow/air> maneuver. Each maneuver must be at least 1 level lower than the previous maneuver recovered.`,
                initiationAction: `movement`,
                range: `10 feet`,
                target: `point`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Shadow","Air"],
                level: 1,
                name: `Nightwind Rider`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-air-shadow] You dont need to provoke attacks of opportunity while moving or standing up from prone, move at full speed while stealthing without penalty, and gain a +1 circumstance bonus to your stealth for every 10 <shadow/air> mastery. Every time you use acrobatics or stealth to avoid an attacks of opportunity, you can choose to either make a stealth check to hide, or move 5 feet.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Air","Water"],
                level: 1,
                name: `Zephyr's Flow`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[air-water-air] Move up to half your movement speed plus 1/4 your <shadow/air> without provoking attacks of opportunity. Any creature you move adjacent to during this movement, you can move 5 feet in a direction of your choice. You cannot move them to an inherently dangerous space. Allies you move gain a +2 dodge bonus to armor class for 1 round, and enemies you move suffer a -2 penalty to AC for 1 round.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Air","Technique"],
                level: 1,
                name: `Whirling Storm`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[air-technique-air] Your threatened area increases by 5 feet, but this does not increase your reach, requiring you to move in order to take attacks of opportunity. Every time you move to take these attacks of opportunity, it doesn't provoke attacks of opportunity and all enemies who threaten you for the movement take electricity damage equal to your initiation modifier. Any movement you take during these attacks reduces your movement next turn, including being unable to take 5-foot steps. Every 30 <air/technique> mastery the threatened area increases by 5 more feet, and the electricity damage increases by your initiation modifier again.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Heroic","Shadow"],
                level: 3,
                name: `Sinister Deliverance`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-shadow-heroic] Make a melee touch attack, if successful, you move them 10 feet in the direction of your choice. This provokes attacks of opportunity from creatures other than you. Every 30 <heroic/shadow> mastery, you move them 5 more feet, but they must move in a straight line.`,
                initiationAction: `free`,
                range: `touch`,
                target: `1 enemy`,
                duration: `instantenous`
              },
              {
                comboTags: ["Heroic","Dark"],
                level: 5,
                name: `Overwhelming Existence`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-dark-heroic] Whenever you would gain temporary hit points, you instead deal damage to a creature within your melee reach equal to a percentage of the the temporary hit points you would have gained, equal to 25% + 1/2 <dark/heroic> mastery. All damage dealt in one round must be against the same creature, and they receive a will save the first time they take damage that round to halve it.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Shadow","Air"],
                level: 1,
                name: `Like the Wind`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-air-shadow] Creature you are adjacent to cannot take attacks of opportunity against you for moving unless you are moving out of their threatened area. You can move through enemies without provoking attacks of opportunity, or rolling an acrobatics check to do so. If you move during your turn, and your new location would be in a place where you would have flanked with your original position, your first attack against a creature that turn counts as flanking, and deals an additional 1d4 sneak attack damage per 10 <shadow/air> mastery.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Shadow","Flurry"],
                level: 1,
                name: `Umbral Flurry`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-flurry-shadow] For 1 round, every time you successful attack a creature, you wrap them in increasingly intense shadows. The creature suffers a stacking 5% miss-chance on all attacks for 2 rounds. This is reduced by 50% effectiveness for creatures who have truesight or see in the dark, and is foiled by blindsight. The miss chance granted by this does not stack with other miss chance. If the creature has 50% miss chance from this, they are considered blind.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Shadow","Flurry"],
                level: 1,
                name: `Nightshade's Grasp`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-flurry-shadow] For 1 round, your weapon and unarmed attacks are enhanced with the sharp cold of the nightshade. With each attack, you deal 1d4 cold damage per 15 <shadow/flurry> mastery, and 1 point of dexterity damage.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Shadow","Flurry"],
                level: 1,
                name: `Umbral Dance`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-flurry-shadow] For 1 round, every time you make an attack, afterwards you can teleport 5 feet. Every enemy you are adjacent to during this, suffers a -2 penalty to attacks next round. The first time you attack a new target during this round, you deal an additional 1d6 points of cold damage per 10 <shadow/flurry>`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Shadow","Flurry"],
                level: 1,
                name: `Dusk Strike`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-shadow-flurry] Make a bluff attempt, if you succeed, you can make a melee attack against the creature as a free action that deals damage as normal, but if it hits, all of your further attacks this round deal an additional 1d6 sneak attack damage, plus 1d6 per 25 <shadow/flurry> mastery.`,
                initiationAction: `swift`,
                range: `melee attack`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Shadow","Flurry"],
                level: 1,
                name: `Ghostwalker's Drift`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-flurry-shadow] Make a stealth check, within the next 3 rounds, you can move a distance equal to the check rolled, split up as you see fit. Using this movement is a free action, and can be split up however you see fit.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Technique","Shadow","Flurry","Death"],
                level: 1,
                name: `Spectral Dissection`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[technique-flurry,shadow/death-technique] Make attacks as if making a full round attack, however you cannot use natural attacks. Each attack, instead of dealing normal damage, deals your sneak attack damage.`,
                initiationAction: `movement`,
                range: `melee`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Void","Shadow"],
                level: 1,
                name: `Phantom Pain`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[void-shadow-void] Make an attack at your highest bonus. It deals damage as normal, but unless the creature is defeated within 3 rounds, the damage done by this attack is removed.`,
                initiationAction: `free`,
                range: `melee`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Air","Shadow"],
                level: 1,
                name: `Whispering Tempest`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[air-shadow-air] Your movement becomes completely silent and you gain a fly speed equal to your <air/shadow> mastery. You can use stealth to move through creatures threatened area or space without provoking, and every time you succeed on such a check, they suffer a -2 penalty to attack and armor class for 1 round.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Air","Shadow"],
                level: 1,
                name: `Unseen Windblade`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[shadow-air-shadow] Make a ranged touch attack against a creature, success deals 2x your sneak attack damage plus your initiation modifier. This is not precision damage like normal sneak attack damage and can critically hit. For every 25 <shadow/air> mastery, the damage increases by 1x your sneak attack damage.`,
                initiationAction: `swift`,
                range: `close (25' + 5'/2 levels)`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Shadow","Air"],
                level: 1,
                name: `Gale Snare`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[shadow-air-shadow] Make a ranged touch attack against a creature, success causes them to need to make a reflex save or fall prone, or if flying, suffer a -4 penalty to attack and armor class for 1 round. Your next attack against them within 1 round is against their flat-footed armor class.`,
                initiationAction: `free`,
                range: `medium (100' + 10'/level)`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Sakura","Shadow"],
                level: 1,
                name: `Sable Eye`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[sakura-shadow-sakura] Attacks you make against creatures you are flanking have their critical threat range increased by a flat +1. On confirmed critical hits, your sneak attack or similar precision damage is increased by 1 dice step. When you reach 50 <shadow/sakura> mastery, your critical threat range also increases by a flat +1, and whenever you teleport from a location not threatening the creature, to a place where you do, your next attack against them this turn has its critical threat range increased by a further flat +1.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Shadow","Royal"],
                level: 3,
                name: `Tyrian's Shadow`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-royal-shadow] Make a stealth check, your armor class and touch armor class become equal to the result of this check for 3 rounds. Every time a creature misses you with an attack, the armor class lowers by 1 (minimum your actual armor class).`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Sakura","Arcane"],
                level: 1,
                name: `Arcane Blossom`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[sakura-arcane-sakura] Make an attack, it deals damage as normal, but if successful, it also creates an arcane blossom within their body that bursts in 3 rounds, dealing 1d4 per 10 <sakura/arcane> mastery, but it also increases by 1d4 every time the creature is damage before it blossoms. Damage dealt with <sakura/arcane> add 2d4 damage. This damage is slashing damage.`,
                initiationAction: `movement`,
                range: `melee attack`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Sakura","Arcane"],
                level: 1,
                name: `Mystic Bloom`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[arcane-sakura-arcane] Make a touch attack, if successful, the creature has all attacks (even spell attacks) against it gain a flat +1 critical threat range until a critical hit is threatened against it. If the critical hit is successful, the attack deals an additional 1d4 points of force damage per 5 <sakura/arcane> mastery.`,
                initiationAction: `free`,
                range: `touch`,
                target: `1 enemy`,
                duration: `1 minute`
              },
              {
                comboTags: ["Arcane"],
                level: 1,
                name: `Spellblade Hanami`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[arcane-arcane-arcane] All magical damage types (elemental, siphon, force, negative energy, etc. but only hit point damage) dealt through your weapon has its damage dice increased by 1 dice step (count each elemental dice seperately for calculations).`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Sakura","Arcane"],
                level: 4,
                name: `Garden of Wisteria`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[sakura-arcane-sakura] You gain points equal to your highest mental modifier, plus 1 per 20 <arcane/sakura> mastery. You can expend one of these points after making an attack or roll against miss chance, taking the better dice roll. You can do this multiple times on a single roll, but doing so costs an additional point than the previous usage. Once you expend all points, you can make an immediate attack at a -10 penalty as a free action that you can take even when not your turn.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `1 minute`
              },
              {
                comboTags: ["Sakura","Arcane"],
                level: 6,
                name: `Seal of 9 Blossoms`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[arcane-sakura-sakura-arcane] 9 seals are placed on the battlefield that are broken when anyone apart of the combat, ally or enemy accomplishes them. Each time a seal is broken, you gain a +2 bonus to attacks for 1 round, and always gain a bonus on damage equal to the amount of broken seals. Additionally, when 3 seals are broken, you gain a +2 dodge bonus to your AC and rolls apart of counters. At 6 seals you gain +2 to saves and fast healing 3 (stacks with other fast healing). At 9 seals, you gain a flat +1 bonus to your critical threat range.
                \n\n1: A critical hit is confirmed\n2: Someone rerolls an attack roll or save which is successful\n3: Someone is killed\n4: Non-lethal damage is dealt to an opponent\n5: Someone is healed by a healing spell\n6: An attack is successfully countered\n7: A successful attack of opportunity is made\n8: A critical hit fails to confirm\n9: A potential critical hit is countered.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `1 minute`
              },
              {
                comboTags: ["Sakura","Death"],
                level: 1,
                name: `1000 Times Measured`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[sakura-death-death-sakura] If your next weapon attack this round hits, all damage dice are maximized.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Power","Death"],
                level: 1,
                name: `Skullsplitter`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power-death-power] If your next weapon attack this round hits, all dice have their dice increased by 1 step. Base weapon damage counts as one dice, whereas additional dice all count individually.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Royal","Arcane"],
                level: 1,
                name: `Wizard King's Decree`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[royal-arcane-royal] When a creature you threaten fails a saving throw against a supernatural, spell, or spell-like ability, it provokes an attack of opportunity from you.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Royal","Arcane"],
                level: 1,
                name: `Imperial Insight`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[royal-arcane-royal] You gain a dodge bonus to your armor class equal to your intelligence modifier. Every time an attack misses you by an amount less than the bonus granted, the bonus reduces by 1, but you gain a +1 bonus on attacks against the creature that triggered this for 1 round (stacks).`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Royal","Shadow"],
                level: 1,
                name: `Oligarchy`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[royal-shadow-royal] You gain a +4 bonus to AC against creatures you dont threaten and that are not adjacent to you. The bonus you gain from cover (including soft cover) increases by +2.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Primal","Royal"],
                level: 1,
                name: `Beast King's Rush`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-royal-primal] Move in a straight line a distance equal to half your movement speed plus 1/4 your <royal/primal> mastery. You can move through enemies threatened area or space without provoking attacks of opportunity. Make a CMB check against all creatures you move through as if making a bull rush or overrun (your choice) as a free action, this doesn't provoke attacks of opportunity. If you succeed, they are knocked prone (or -4 penalty to AC and attack if flying). If they were already prone, instead they provoke an attack of opportunity from all allies who threaten them (you excluded).`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Royal","Primal"],
                level: 1,
                name: `Master of the Pack`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-royal-primal] Allies you are flanking with gain an additional +2 on attacks against the flanked creature. This does not effect you, but for every ally flanking an enemy with you, you gain +1d6 damage on all attacks, this stacks, and applies even if you aren't attacking the flanked creature.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Royal"],
                level: 1,
                name: `Mastery Opportunist`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[royal-royal-royal] Actions that normally provoke attacks of opportunity, but currently isn't because of a special ability an enemy has, now provokes attacks of opportunity from you again. If this is because of CMB checks, your damage does not reduce their CMB roll, and all of these attacks of opportunity suffer a -8 penalty.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Royal","Primal"],
                level: 1,
                name: `Fearsome Lunge`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[royal-primal-royal] You eschew all defense to make a devastating lunge. Your armor class reduces by 1 per 4 BAB, but your next attack gains 5 feet of reach, and as long as you are making an attack against a creature that you wouldn't threaten before your reach increased, gains a bonus on attack equal to the amount of armor class lost, and gains +1 to its critical damage multiplier.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Primal","Royal"],
                level: 1,
                name: `Fearsome Defense`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-royal-primal] You gain a +1 shield bonus to your armor class for every attack you take. This stacks, but the bonus lasts only 1 round.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Primal","Royal"],
                level: 1,
                name: `Panther's Charge`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-royal-primal] When a creature makes an attack of opportunity for moving through their threatened area, it provokes an attack of opportunity from you as long as you threaten them. If their attack of opportunity hits you, your attack of opportunity back deals an additional 1d6 points of damage, plus 1d6 per 20 <primal/royal> mastery, if it doesn't your attack of opportunity gains a +2 bonus.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Flurry","Royal"],
                level: 1,
                name: `Whirling Steel`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-royal-royal] You gain a +1 shield bonus to your armor class for every attack you take. This stacks, but the bonus lasts only 1 round.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Heroic","Royal"],
                level: 1,
                name: `Trust the King`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-royal-heroic] You gain a +4 bonus on saves against fear, allies within 30 feet of you gain a +2. The bonus you gain increases by +1 every 40 <royal/primal> mastery. Every time you make a successful save against a hostile fear effect, you and all allies gain 1d4 temporary hit points, plus 1d4 per 15 <heroic/royal>, these stack and last 3 rounds.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Heroic","Royal"],
                level: 1,
                name: `My Soldiers Rage`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-royal-royal-heroic] For 3 rounds, when an ally is reduced below 0 hit points, they are not immediately knocked unconscious, instead they remain conscious for 1 round, and when an ally is reduced below 0, the attacker provokes an attack of opportunity from them. The ally is still staggered. Allies that can normally remain conscious below 0 are instead not staggered, and allies who wouldn't even be staggered, instead gain a +2 morale bonus on attacks and +4 damage for 1 round. If you are reduced below 0 and fall unconscious during this, designate 1 ally, they gain a +1 bonus on damage rolls against the creature that killed you per 10 <royal/heroic> mastery. This lasts 1 round, or until you are conscious again.`,
                initiationAction: `movement`,
                range: `30 feet`,
                target: `allies`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Royal","Heroic"],
                level: 1,
                name: `Royal Elation`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[royal-heroic-royal] For 3 rounds, whenever an enemy misses you with an attack, you gain 1 temporary hit point per 5 <heroic/royal>. These stack and last until the end of combat. The temporary hit points gained are doubled if the attack missed you due to a counter.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Primal","Royal"],
                level: 1,
                name: `Hyena's Charge`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-royal-primal] Make a charge attack, making a full-round attack at the end of it. If the creature tries to move away from you during it's next turn, it provokes an attack of opportunity from you. This provokes even if the movement normally wouldn't, and you can take two attacks of opportunity if their movement would have provoked.`,
                initiationAction: `full-round`,
                range: `melee`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Primal","Guardian"],
                level: 1,
                name: `Ursine's Roar`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-guardian-primal] You unleash a devastating roar. This deals 1d6 points of sonic damage, plus 1d6 per 15 <primal/guardian> mastery, but all creatures within the cone suffer a -2 penalty to attack any creature except you for 3 rounds. For every creature struck by this, you gain a stacking DR 1/- (stacks with itself, not other DR). This also lasts 3 rounds.`,
                initiationAction: `movement`,
                range: `30 foot cone`,
                target: `creatures`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Guardian","Primal"],
                level: 1,
                name: `Verdant Warden`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[guardian-primal-guardian] You and all Allies within a 15 foot aura gain a +4 bonus on CMD against checks that would forcefully move them. You also all heal 1d6 hit points per round. The bonus to CMD increased by +1 and the healing increases by 1d6 every 40 <guardian/primal>.`,
                initiationAction: `swift`,
                range: `15 foot emination`,
                target: `allies`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Guardian","Primal"],
                level: 1,
                name: `Cornered Frenzy`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-guardian-primal] Every time you are struck with an attack, you gain a stacking DR 1/-. This stacks with itself, and other DR, but it is halved if you do stack it with other DR. If a critical hit is confirmed against you, this finishers duration increases by 1 round. This DR starts at 1 higher for every 25 <primal/guardian>.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Heroic","Guardian"],
                level: 1,
                name: `Unyielding Flesh`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-guardian-heroic] You delay the onset of all damage against you for 2 rounds. This finisher cannot be recovered until its duration ends.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Curse","Royal"],
                level: 1,
                name: `Decree of Suffering`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-guardian-heroic] You and all allies within 30 feet of you gain a +4 bonus on damage rolls. Allies making attacks of opportunity also gain a +2 bonus on attack rolls and the damage bonus increases to +6.`,
                initiationAction: `swift`,
                range: `30 feet`,
                target: `allies`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Royal","Curse"],
                level: 1,
                name: `Foxglove Harrier`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[royal-curse-royal] Every time you make a successful attack of opportunity, the target suffers a -1 penalty to its armor class for the rest of the duration of the finisher. If a creature is currently suffering a -5 penalty to armor class from this, they provoke attacks of opportunity from you even when they are taking 5-foot steps or making movement that doesn't normally provoke.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              // {
              //   comboTags: ["Royal","Power"],
              //   level: 1,
              //   name: `Pomp and Power`,
              //   type: `Finisher`,
              //   finisherType:"Boost",
              //   longDesc: `[royal-curse-royal] `,
              //   initiationAction: `swift`,
              //   range: `personal`,
              //   target: `you`,
              //   duration: `3 rounds`
              // },
              {
                comboTags: ["Royal","Dark"],
                level: 1,
                name: `Black Coronation`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[royal-dark-royal] Make a ranged touch attack against an enemy. If they fall below 10% hit points within 3 rounds, they must make a will save or die instantly, taking a penalty on the save of -1 per 10 <royal/curse> mastery. You gain temporary hit points equal to your <royal/curse> mastery if they die. This is a death effect, but creatures immune to death effects only gain a +5 bonus on the save. If you use this on a creature already below 10% hit points, they must make the will save immediately and the penalty they suffer due to your mastery doubles.`,
                initiationAction: `swift`,
                range: `45 feet`,
                target: `1 enemy`,
                duration: `encounter`
              },
              {
                comboTags: ["Royal","Curse"],
                level: 1,
                name: `Tyrant's Scourge`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[royal-curse-royal] Every time a creature misses you with an attack, they suffer a -1 penalty on saving throws against maneuvers (stacks) for 1 round. The penalty is doubled if the attack misses you due to a counter.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Power","Royal"],
                level: 1,
                name: `Regal Breach`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[power-royal-power] Make an attack at a -5 penalty, if it succeeds, you may make a free sunder attempt against the creature as a free action that doesn't provoke. If it succeeds, you sunder them as normal, but they also suffer 1 point of dexterity damage per 10 <royal/power> mastery. You gain a bonus on this sunder attempt of +1 per 10 <power/royal> mastery.`,
                initiationAction: `movement`,
                range: `melee`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Power","Royal"],
                level: 5,
                name: `Hegemony`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[power-royal-power] Make an opposed strength check against a creature within your natural reach, if you succeed, they provoke attacks of opportunity from you next round when they attack you.`,
                initiationAction: `movement`,
                range: `melee`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Power","Royal"],
                level: 1,
                name: `Imperium Onslaught`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[royal-power-royal] Double your weapon's base damage dice on attacks of opportunity, and every time you succeed on an attack of opportunity, you gain +2 damage for the rest of this finisher. Critical hits on attacks of opportunity increase the duration of this finisher by 1 round.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Fire","Death"],
                level: 1,
                name: `Funeral Pyre`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[fire-death-fire] Make a melee attack at a -5 penalty, if it hits, it deals damage as normal, but the creature catches fire, taking 1d6 points of fire damage every round, plus 1d6 per <25> fire mastery. As long as this persists, all healing effects on the target are halved. This stacks with other sources of catching on fire, and this can be put out the same way catching fire can be normally, except the DC increases by your initiation modifier +1 per 20 <fire/death> mastery. Creatures who take no fire damage from this are not effected on the rounds they take no fire damage.`,
                initiationAction: `swift`,
                range: `melee`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Fire","Death"],
                level: 1,
                name: `Searing Hemorrhage`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[death-fire-death] Make a melee touch attack, if it hits, you get your choice of either dealing bleed damage equal to the continuous fire damage the target is taking, or causing them to catch fire that deals damage equal to the bleed damage they are currently taking.`,
                initiationAction: `swift`,
                range: `melee`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Fire","Death"],
                level: 1,
                name: `Bloodfire Affliction`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[fire-death-fire] Make a melee touch attack, if it hits, all of the targets immolation stacks are converted to bloodfire stacks. These increase fire damage as normal for immolation stacks (and otherwise count as immolation stacks), but they also increase the damage they take from bleed damage, and when an attack applies bleed damage to them (even if it isn't included because bleed doesn't stack), they take damage equal to their bloodfire stacks.`,
                initiationAction: `swift`,
                range: `touch`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Fire","Earth"],
                level: 1,
                name: `Molten Obsidian Tomb`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[fire-earth-fire] Make a touch attack against an enemy. If it hits, they suffer fire damage equal to their armor and shield's armor/shield bonus at the start of each of their turns for the next 3 rounds, plus 1 round per 20 <fire/earth>. Each time this deals damage, both their armor and shield's AC bonus is reduced by 1. After this ends, the armor bonus immediately returns.`,
                initiationAction: `movement`,
                range: `touch`,
                target: `1 enemy`,
                duration: `3 rds + 1 rd/20 <fire/earth>`
              },
              {
                comboTags: ["Fire","Guardian"],
                level: 3,
                name: `Phoenix Aegis`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-guardian-guardian-fire] At the start of your next 3 turns, you gain 1d6 temporary hit points per 10 <fire/guardian> mastery that last 1 round. If during this duration you are reduced below 0 hit points, you automatically heal hit points equal to 1/2 your <fire/guardian> mastery and all enemies within 10 feet of you suffer an equal amount of damage (reflex halves) and this finisher ends.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Fire","Guardian"],
                level: 1,
                name: `Burning Guard`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-guardian-fire] You gain 1d4 temporary hit points per 5 <guardian/fire> that last the rest of combat. Whenever a creature reduces these temporary hit points by any means (such as damage), they take fire damage equal to the amount they reduced.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `combat`
              },
              {
                comboTags: ["Fire","Guardian"],
                level: 1,
                name: `Santuary of Flame`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-guardian-guardian-fire] You create a ring of fire centered on your current location with a radius of 10 feet. Any enemy that enters the area suffers 1d6 points of fire damage per 10 <fire/guardian> mastery. Enemies that attack from outside of the ring to an ally within the ring suffer a -2 penalty on their attack rolls, and if their attack misses, they suffer 1d6 fire damage. Every 30 <fire/guardian> mastery the attack penalty increases by -1 and the damage on miss increases by 1d6.`,
                initiationAction: `movement`,
                range: `0 feet`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Fire","Earth"],
                level: 1,
                name: `Blazing Bulwark`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-earth-fire] You spring up a massive stone shield along on one of the edges of your space, providing you cover against attacks from that direction as normal, however its cover bonus increases by +1 per 30 <fire/earth> mastery. If this stone provides cover for you against a melee attack and it misses, the attacker suffers 1d4 plus 1d4 per 10 <fire/earth> mastery fire damage. As an immediate action you can launch the bulwark away from you in a straight line the direction it was facing, doing so does not interrupt actions, however it allows you to make a bull rush against the first creature it strikes, gaining a +1 bonus to the bull rush per 10 <fire/earth> mastery, and if the bull rush succeeds it deals the damage this finisher deals if it misses. This bull rush has a range equal to its length.`,
                initiationAction: `free`,
                range: `0 feet`,
                target: `you`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Fire","Light"],
                level: 1,
                name: `Sacred Flame`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-light-light-fire] For 1 round, whenever you are healed, you convert the amount of hit points you would have healed into fire damage that deals its damage to creatures adjacent to you. The first time this would deal damage, the creatures may make a fortitude save to halve all further damage from it this round.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Fire","Death"],
                level: 1,
                name: `Blood for Ash`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-death-fire] You can suffer damage equal to your HD to gain 2 immolation stacks. You can make this trade multiple times when you initiate this finisher (max 2x initiation modifier times). For each time that you do this, you gain a +1 morale bonus to your strength (stacks with itself). These last 3 rounds.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },              
              {
                comboTags: ["Death","Guardian"],
                level: 1,
                name: `Vengeance Vitalis`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[death-guardian-death] For 1 round, whenever an enemy damages you, half of the damage is taken as normal, but the other half is negated and stored. Your next weapon or unarmed attack within 1 round deals additional damage equal to the damage you stored (not multiplied on criticals). This has a maximum of 2x your <death/guardian> mastery. If your attack misses, or you fail to attack on your next round, you take double the stored damage which cannot be negated, delayed, or reduced.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Fire"],
                level: 5,
                name: `Scorching Torment`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-fire-fire-fire-fire] Your next weapon attack this combat that deals fire damage causes the target to roll a reflex save or catch fire, taking additional fire damage each round equal to a percentage of the fire damage dealt from the attack, the percentage equaling 25% + 1/2 <fire> mastery (max 75%). Each round they receive an additional reflex save to end the effect as per normal of catching fire. This does not stack with other effects that cause the target to catch fire. The DC for avoiding and ending the fire damage is 15 + initiation modifier, +1 per 10 <fire> mastery. If your attack strikes multiple creatures at once, choose only one to be affected by this finisher.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Fire","Technique"],
                level: 5,
                name: `Flaming Dragon Fist`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-technique-technique-fire] Once you initiate this maneuver your turn ends immediately and you cannot attack again until this triggers. The next time within 1 round a creature makes a melee attack against you, you make an opposed attack roll with an unarmed attack against theirs with a bonus of +1 per 10 <technique>. If you win, you negate their attack, and if your attack roll also would be enough to hit them, you also deal your unarmed attack's damage plus 1d6 plus 1d6 per 10 <fire/technique> mastery and catch them on fire, for which they take fire equal to the fire damage you dealt with this attack at the start of each round. The DC to put out the fire is increased by +1 per 5 <fire> mastery. If your opposed attack roll was a potential critical hit, you confirm as normal however your critical damage multiplier increases by +1 and ALL of the attack's fire damage is multiplied by your critical damage multiplier.`,
                initiationAction: `swift`,
                range: `melee`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Fire"],
                level: 8,
                name: `Helios Flare`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-fire-fire-fire-fire-fire] Your next weapon attack or maneuver this combat that deals fire damage causes the target to roll a reflex save or catch fire, taking additional fire damage each round equal to a percentage of the fire damage dealt from the attack, the percentage equaling 50% + 1/2 <fire> mastery (max 100%). Each round they receive an additional reflex save to end the effect as per normal of catching fire. This does not stack with other effects that cause the target to catch fire. The DC for avoiding and ending the fire damage is 15 + initiation modifier, +1 per 10 <fire> mastery. This can effect multiple creatures at once.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `instantaneous`
              },              
              {
                comboTags: ["Fire","Arcane"],
                level: 1,
                name: `Spellfire Storm`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[fire-arcane-fire] Every time you are targeted by a spell, you deal 1d4 points of fire damage to all enemies within 15 feet of you. This increases by 1d4 every 20 <fire/arcane> mastery.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Fire"],
                level: 1,
                name: `Blazing Pyre`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[fire-fire-fire] Make a melee touch attack, if successful, double their immolation stacks.`,
                initiationAction: `free`,
                range: `touch`,
                target: `1 creature`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Fire","Arcane"],
                level: 1,
                name: `Fireflux`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-arcane-fire] If you deal fire damage through an attack or cause a creature to make a save, if the creature rolls below a 5 on the dice, or you roll above 15 to deliver the fire damage, the damage also catches them on fire, or increases the damage from being on fire by 1d6. This damage can stack on itself, and every stack increases the DC of removing the fire by +1. Every 20 <fire/arcane> mastery increases the dice roll range by 1.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Arcane","Fire"],
                level: 1,
                name: `Scorching Feedback`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[arcane-fire-arcane] Every time a hostile creature targets you with a spell, they take 1d6 points of fire damage. This increases by 1d6 every 20 <arcane/fire> mastery. Each time they target you with a spell again during the duration, the damage increases by 1 increment.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Arcane","Fire"],
                level: 3,
                name: `Blazing Sigil`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[arcane-fire-fire-arcane] Make a melee touch attack against a creature, if successful, they are marked by a burning sigil, every time you initiate an <arcane> or <fire> maneuver during the duration, or cast a fire spell, a number of burning marks appears on them equal to the level of the maneuver/spell. In 3 rounds, the sigils explode, dealing 1d4 points of fire damage, plus 1d4 per 2 marks.`,
                initiationAction: `swift`,
                range: `touch`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Void","Fire"],
                level: 3,
                name: `Voidflame`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[void-fire-fire-void] Make a melee touch attack against a creature, if successful, every time they take any action, including free actions, they take 1d4 points of fire damage. This counts every attack as a seperate action. Every 50 <void/fire> mastery increases the damage by 1d4. All damage is totaled in a round for the amount of damage taken before applying fire resistance and immolation.`,
                initiationAction: `swift`,
                range: `touch`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Void","Fire"],
                level: 3,
                name: `Stellar Expansion`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[void-fire-fire-void] You grow 1 size category larger. This effects your ability scores, and your reach as normal. The round after, you grow an additional size category larger. On the 3rd round, you return to your normal size and are fatigued for 1 round. On the 4th round, you shrink one size, are staggered for 1 round, and exhausted.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `4 rounds`
              },
              {
                comboTags: ["Fire","Void"],
                level: 9,
                name: `Stellar Collapse`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[void-fire-fire-fire-void] Every round you can initiate a single <fire> maneuver that has an initiation action of a standard action or less as a free action. You take 1 constitution drain every time you do this. You cannot recover any maneuvers until all of your fire maneuvers are expended, and once they are, this finisher ends.`,
                initiationAction: `standard`,
                range: `personal`,
                target: `you`,
                duration: `1 minute`
              },
              {
                comboTags: ["Fire","Void"],
                level: 3,
                name: `Nullfire Conduit`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[void-fire-fire-void] Your fire damage is converted to force damage. Abilities that enhance fire damage enhance force damage now. This only effects new effects, not lingering old ones, and old ones lose the benefits of your abilities that enhance fire damage, including immolation.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Fire","Heroic"],
                level: 3,
                name: `Stellar Heart`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-fire-fire-heroic] You remove all of your temporary hit points, and unleash it in a blast in a 20 foot radius around you. Allies within the radius gain half the temporary hit points for 1 round, whereas enemies take fire damage equal to half the temporary hit points lost, reflex halves. You cannot gain temporary hit points until the end of your next turn after initiating this finisher. Every 40 <heroic/fire> mastery increases the radius by 5 feet.`,
                initiationAction: `movement`,
                range: `20 foot radius`,
                target: `you`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Fire","Heroic"],
                level: 3,
                name: `True Aura`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-heroic-heroic-fire] You catch on fire, taking 1d6 + HD fire damage every round and take up to initation modifier immolation stack (min 1). While this is active, every time you successfully intimidate a creature, you gain +1 Aura. First, you make an intimidate check against all enemies who can see you. If it succeeds, they are shaken, even if immune to fear (even mindless creatures). Each round, you can expend another movement action, to attempt to intimidate all enemies again. If you successfully intimidate every enemy in the combat, increase your Aura by 1. Allies can spend a movement action, being amazed by your aura, to increase your Aura by initiation modifier. You gain 1/3 your aura as a bonus to intimidate checks. If you fail to intimidate an enemy, -2 Aura. You can intimidate the same creature multiple times, each time you do, the DC increases by 5, but if you succeed, the penalties they receive from being shaken increases by 1. At any point during its duration, you can declare a target that you can see, the next attack you make against them, it deals additional damage equal to your aura. If this kills them, the maneuver's duration is extended 1 minute, and you can activate it this way again. If the damage fails to kill them, you suffer -1,000,000 aura, and you take a penalty to damaging the selected target equal to your current Aura (Aura expires the next time you initiate this finisher or at the end of combat). If an ally heals you during this duration, -10 aura.`,
                gameDesc: `[fire-heroic-heroic-fire] You catch on fire, taking 1d6 + HD fire damage every round and take up to initation modifier immolation stack (min 1). While this is active, every time you successfully intimidate a creature, you gain +1 Aura. First, you make an intimidate check against all enemies who can see you. If it succeeds, they are shaken, even if immune to fear (even mindless creatures). Each round, you can expend another movement action, to attempt to intimidate all enemies again. If you successfully intimidate every enemy in the combat, increase your Aura by 1. Allies can spend a movement action, being amazed by your aura, to increase your Aura by initiation modifier. You gain 1/3 your aura as a bonus to intimidate checks. If you fail to intimidate an enemy, -2 Aura. You can intimidate the same creature multiple times, each time you do, the DC increases by 5, but if you succeed, the penalties they receive from being shaken increases by 1. At any point during its duration, you can declare a target that you can see, the next attack you make against them, it deals additional damage equal to your aura. If this kills them, the maneuver's duration is extended 1 minute, and you can activate it this way again. If the damage fails to kill them, you suffer -1,000,000 aura, and you take a penalty to damaging the selected target equal to your current Aura (Aura expires the next time you initiate this finisher or at the end of combat). 
                Zhao: If this attack fails to kill them, your rage ends, and you are shaken for 3 rounds. But if it kills them, your rage extends 1d4 rounds, and if it rolls a 4, you gain a +2 morale bonus to strength (stacks with rage).`,
                initiationAction: `Movement`,
                range: `personal`,
                target: `you`,
                duration: `1 minute`
              },
              {
                comboTags: ["Fire","Heroic"],
                level: 1,
                name: `Burning Passion`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-heroic-fire] All allies within 30 feet of you gain a +10 bonus to their movement speeds, and can move through 10 feet of difficult terrain per round as if it were normal terrain. If an ally moves at least 10 feet, and ends their movement adjacent to an ally also affected by this, they both gain 1d6 temporary hit points, this stacks.`,
                initiationAction: `free`,
                range: `30 feet`,
                target: `allies`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Fire","Heroic"],
                level: 1,
                name: `Flames of Despair`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-fire-heroic] Every time you intimidate or inflict a more serious fear condition to a creature, they take 1d4 fire damage, plus 1d4 every 10 <heroic/fire> mastery.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                school: "sterlingSovereignty",
                level: 2,
                name: `Zwerchau`,
                type: `Counter`,
                longDesc: `You initiate this counter when a creature makes a charge attack against you. To take this attack, you must either threaten the space they are making their charge attack from, or they must be attacking you with natural attacks. Make a melee attack against the charging creature before they make their first attack. If your attack hits, it deals damage as normal, and they suffer a -4 penalty to their charge attacks. If you miss, they instead just suffer a -2 penalty to their charge attacks. If their attack misses by an amount equal to or less than the attack penalty you gave, they provoke an attack of opportunity from you, though it suffers a -5 penalty (max 1 AoO per charge).`,
                initiationAction: `immediate`,
                range: `personal`,
                target: `you`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Arcane","Water"],
                level: 1,
                name: `Drowning Phantom`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[arcane-water-arcane] Once per round as a free action, or afterwards as a swift action, you can cause yourself to dissolve into a puddle of water, or return to your normal form. While dissolved, you cannot be hurt by physical attacks and take half damage from all magical damage types. You also are unable to take any actions or attacks while dissolved except a single movement action to move. The first attack you take each round after reforming deals an additional 1d4 points of cold damage per 10 <water/arcane> mastery.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Water","Arcane"],
                level: 1,
                name: `Tidal Phantom Waltz`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[water-arcane-water] You dissolve into a shimmering cascade of water, becoming a spectral current that dances through the battlefield. You can move through enemies as if they were difficult terrain and use perform(dance) in place of acrobatics in order to move through creature's threatened area or space without provoking attacks of opportunity. Once per round when you successfully move through an opponents space, you can attempt to disorientate them with the shimmering waters, causing them to suffer a 20% miss-chance on all attacks for 1 round. Will save negates. While in this form, all attacks against you also suffer a miss chance of 10% plus 1% per 4 <water/arcane> mastery (stacks with disorientating them).`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Heroic","Death"],
                level: 1,
                name: `Rallying Carnage`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-death-heroic] You unleash a roar of rage, spurring you and allies within 30 feet to fight harder. You all gain a +1 bonus to attack rolls and +2 to damage rolls for every 15% of your hitpoints you are missing at the time of initiating this finisher. If any of you defeat a foe during this time, they gain temporary hit points equal to 1/2 your <heroic/death> mastery that last 1 round (does not stack with itself). Every 50 <heroic/death> mastery increases this finishers duration by 1 round.`,
                initiationAction: `swift`,
                range: `30 feet`,
                target: `allies`,
                duration: `1 round`
              },
              {
                comboTags: ["Primal","Earth"],
                level: 1,
                name: `Tectonic Stampede`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[primal-earth-primal] Make a charge attack at an enemy with a maximum distance of your 1/2 your movement speed plus 1/2 your <earth/primal> mastery. This movement does not provoke. At the end of your charge, make a single melee attack (even if you could normally take more), the attack has its damage dice increased by 1 step for every 20 feet moved. For 1 round, the line you charged through, as well as the adjacent tiles becomes difficult terrain for enemies, but allies who charge through them can charge an extra 10 feet, and the damage of their first attack during a charge increases by 1 dice step.`,
                initiationAction: `standard`,
                range: `melee`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Earth","Primal","Heroic"],
                level: 1,
                name: `Fighting Ring`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth-primal-earth/heroic] You unleash a devastating stomp on the ground, knocking up stone to cage in, or out, enemies. The stomp creates a stone wall along your reach (minimum 10 feet), angled diagonally so that it covers above as well. You must include at least one enemy in the area to use this, and You must be on the ground, but the ground does not need to be stone, the material the wall forms from does not keep the properties of the ground it was made out of, nor does it affect the ground's shape. The stone has a hardness equal to your initiation modifier and each 5-foot section has hit points equal to 1/4 of your <earth/primal> mastery. After the duration, the ground returns to its previous state (even if it was destroyed). For every enemy within the fighting ring, you gain a +2 morale bonus to attack and damage for its duration. For every 25 <earth/primal> mastery, this lasts an additional round, though you can dismiss it as a free action if there are no more enemies within.`,
                initiationAction: `swift`,
                range: `reach`,
                target: `ground`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Earth","Primal"],
                level: 1,
                name: `Quaking Rush`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth-primal-earth] For 1 round, every time you move, all creatures adjacent to your movement must make a reflex save DC 10 + level/2 + 1 per 10 <primal/earth> or fall prone. Creatures who succeed the save still suffer a -2 penalty to armor class. You and the create must be on the ground for the to affect them.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Primal","Earth"],
                level: 1,
                name: `Seismic Slam`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[primal-earth-primal] You leap into the air, grabbing a creature and then come crashing back to the ground in a seismic slam. Move directly upwards a distance up to your <primal/earth> mastery, then make a grapple attempt (doesn't provoke, gain a +2 on the check if it already wouldn't) with a +1 bonus per 10 feet of distance moved upwards, and then come slamming down. If the grapple was successful, the creature comes crashing down with you, you take no fall damage, but it takes fall damage with a percentage increase equal to your <earth/primal> mastery. If you fail the grapple attempt, you take the minimum amount of fall damage and do not fall prone. You must be on the ground to initiate this.`,
                initiationAction: `movement`,
                range: `melee`,
                target: `1 flying enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Earth","Primal"],
                level: 1,
                name: `Rage of the Living Mountain`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth-primal-earth] You stomp your legs into the ground, making yourself an immovable behemoth. Gain temporary hit points equal to your <earth/primal> mastery, as long as these last, your melee attacks have their damage dice increased by 1 step, and you cannot be tripped or move from your current location willingly or unwillingly except through teleportation, which automatically ends this and the benefits of this finisher. You must be on the ground to initiate this. `,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 minute`
              },
              {
                comboTags: ["Earth","Primal"],
                level: 1,
                name: `Granite Hide`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth-primal-earth] Whenever you begin or maintain a grapple, or are grappled by, or have a grapple maintained against you the creature grappling with you takes 1d6 points of bludgeoning damage. This increases by 1d6 every 20 <primal/earth> mastery.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Primal","Earth"],
                level: 1,
                name: `Tectonic Momentum`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-earth-primal] Whenever you make a successful charge action against an enemy, they take 1d8 points of bludgeoning damage, plus 1d8 every 10 <primal/earth> mastery. This activates on the charge action, and it does not matter if your attack agaisnt them is successful, or how many attacks you make, it activates a single time.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Primal","Earth"],
                level: 1,
                name: `Hunting Grounds`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-earth-primal] You can move through natural difficult terrain as if it were normal terrain. This includes difficult terrain created by magical effects as long as it is difficult terrain created from stone or plants.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Earth","Primal"],
                level: 1,
                name: `Seismic Sense`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth-primal-earth] You gain tremorsense with a range equal to your <earth/primal> mastery (rounded down to the nearest 5 foot increment). When a creature you can see with your seismic sense attempts to use an ability that would cause you to be flat-footed, you can make a sense motive check DC = 10 + their 1/2 HD + their charisma modifier, or 10 + bluff, whichever is higher. If you succeed, you are not caught flat-footed by the ability.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Primal","Earth"],
                level: 1,
                name: `Earth-shattering Stomp`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[primal-earth-primal] You unleash a devastating stomp on the ground in a 30 foot cone plus 5 feet per 20 <primal/earth>. All creatures in the area take 1d6 points of bludgeoning damage, plus 1d6 every 5 <primal/earth> mastery and fall prone, though they can make a reflex save to halve the damage and negate the prone condition. After stomping, for 3 rounds the whole area is difficult terrain for all creatures except for you (even flying creatures).`,
                initiationAction: `movement`,
                range: `30 foot cone`,
                target: `creatures`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Fire","Primal"],
                level: 1,
                name: `Molten Grip`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-primal-fire] Whenever you begin or maintain a grapple, or are grappled by, or have a grapple maintained against you the creature grappling with you takes 1d6 points of fire damage. This increases by 1d6 every 20 <primal/fire> mastery.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Primal","Earth"],
                level: 3,
                name: `Silver Crown Stomp`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[primal-earth-earth-primal] Make a single natural attack, it deals damage as normal, but for every other natural attack you have, it's damage increases by 1 dice step.`,
                initiationAction: `movement`,
                range: `melee`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Primal","Earth"],
                level: 1,
                name: `Crashing Rock`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[primal-earth-primal] Move up to half your movement speed plus 1/2 your <earth/primal> mastery in a straight line. During this movement you gain DR 1/- per 5 <earth/primal> mastery and you cannot be tripped or grappled. You can use a CMB as if making a bullrush or overrun check to move through enemies spaces, and if you do and succeed, they suffer 1d6 points of damage per 10 <earth/primal> and fall prone. You gain a +1 bonus on these CMB checks per 5 <earth/primal> mastery. You can only attempt this once per creature.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Shadow","Earth"],
                level: 1,
                name: `Dust Devil`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-earth-shadow] You kick up a cloud of dust around you in a 15 foot radius around you. This cloud obscures vision as fog cloud and all creatures other than you treat it as difficult terrain (even flying creatures). As long as you are in the dust cloud, you can see all other creatures within the cloud as if you had tremorsense (even if they are not touching the ground, as long as they are touching the cloud). If a creature tries to leave the cloud, even with a 5-foot step or while withdrawing, it provokes an attack of opportunity from you.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Shadow","Earth"],
                level: 1,
                name: `Bury the Blade`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-earth-shadow] Increase the damage of your sneak attack or similar abilities by 1 step (1d4 -> 1d6 -> 1d8 -> 1d10 -> 1d12 -> 2d8 etc.). Every 30 <earth/shadow> mastery each increase it by an additional step.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Earth","Shadow"],
                level: 1,
                name: `Shadow Spike`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[earth-shadow-earth] Make a melee touch attack against an enemy, if it hits, you pin their shadow to the ground, stopping them from moving more than 5-feet from their current position and they suffer a -2 penalty to their armor class and reflex saves for 3 rounds. They can also attempt to escape using a standard action to make an escape artist attempt or CMB check DC 10 + your level/2 + initiation modifier + 1 per 10 <earth/shadow> mastery. There must be ground within 100 feet beneath them to use this, and there must be enough light to create a shadow on the ground.`,
                initiationAction: `swift`,
                range: `melee`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Shadow","Earth"],
                level: 1,
                name: `Sudden Fissure`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[shadow-earth-shadow] Rocks always seem to get in the way of the creature when they try to move. Every time the creature moves except when flying, they must make an acrobatics check DC 10 + 1 per 10 <shadow/earth> mastery, or after moving a random amount of squares they intended to move, their movement stops and they fall prone.`,
                initiationAction: `free`,
                range: `30 feet`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Death","Earth"],
                level: 1,
                name: `Curb Stomping`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[death-earth-death] Your attacks against prone creatures gain an additional +2 bonus to their attack rolls, and deal an additional 1d4 bludgeoning damage, plus 1d4 per 15 <death/earth> mastery.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Death","Air"],
                level: 1,
                name: `Air Supperiority`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[death-air-death] Your melee attacks against creatures at lower elevation to you (your bottom corner must be equal to or higher than their highest corner) you gain a +2 bonus on the attack roll and deal an additional 1d4 points of slashing damage, plus 1d4 per 20 <air/death> mastery.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Shadow","Earth"],
                level: 1,
                name: `Shadow Mantle`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-earth-shadow] All squares within 10 feet of you count as difficult terrain for 2 rounds (this deosn't affect you). If an enemy leaves the area, you can expend an immediate action to attempt a stealth check with a DC of their CMD, if you succeed, at the end of their movement, you can move them back towards you 10 feet.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Earth","Shadow"],
                level: 1,
                name: `Umbral Quagmire`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth-shadow-earth] You cause a shadowy quagmire to surround and follow the target for 3 rounds, halving its movement speed and stopping it from taking 5-foot steps. It can attempt a will save as a standard action to end this, but it suffers a penalty to the roll of -1 per 10 <shadow/earth>.`,
                initiationAction: `movement`,
                range: `30 feet`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Earth","Death"],
                level: 1,
                name: `Grave Hand`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth-death-earth] Once per turn as a free action, you can attempt to pull a creature within 20 feet 5 feet closer directly towards you. Doing so requires a stealth check against their CMD or a CMB check as if making a bullrush or dirty trick. Neither of these provoke. You gain a bonus on the check of +1 per 10 <shadow/earth>.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Shadow","Earth"],
                level: 1,
                name: `Umbral Fortress`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-earth-shadow] For 3 rounds, the first time a creature tries to attack you, you make a stealth check opposed by their perception check. If you succeed, you gain a +4 bonus to your armor class against all attacks they make against you for the remaining duration of this finisher.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Power","Water"],
                level: 1,
                name: `Tidal Cleave`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[power-water-power] Make a melee attack, you can then move 5 feet and make another attack against a creature different than any other creature you have attacked with this finisher. You can keep moving 5 feet and attacking creatures as long as you attack unique creatures, and for every attack past the first, you gain a +1 bonus to the attack roll. This movement doesn't provoke. These attacks all deal an additional 1d4 points of cold damage per 10 <power/water>. For every 25 <water/power> mastery you have, during the finisher you can move an additional 5 feet between one of the attacks.`,
                initiationAction: `standard`,
                range: `melee`,
                target: `enemies`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Power","Water"],
                level: 1,
                name: `Aqua Vise`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[power-water-power] Make an opposed strength roll against an opponent (treat this as a touch attack for miss chance etc.), if you succeed, they drop 1 weapon they are wielding, or one of their natural attacks becomes unusable for 1 round.`,
                initiationAction: `swift`,
                range: `touch`,
                target: `1 enemy`,
                duration: `instantaneous or 1 round`
              },
              {
                comboTags: ["Power","Shadow"],
                level: 1,
                name: `Crushing Feint`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[power-shadow-power] Make an opposed strength roll against an opponent within your natural reach (treat this as a touch attack for miss chance etc.), if you match or beat their roll, they become flat-footed for 1 round. For every 25 <power/water> mastery you gain a +1 bonus on this roll.`,
                initiationAction: `free`,
                range: `touch`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Water","Power"],
                level: 1,
                name: `Momentum Flow`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[water-power-water] Every time you miss a melee attack, your next melee attack gains a +2 bonus to the attack. This stacks if you miss multiple attacks in a row. Every 50 <water/power> mastery this lasts an additional round.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Power","Water"],
                level: 1,
                name: `Tidal Wave`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power-water-power] The next time you make a melee attack this round, it unleashes a wave from the blade in a line, striking all creatures in a straight line behind the target of the attack (the line that crosses through both you and the target of the attack. This doesn't damage the target of the attack). This deals damage equal to the weapon's base damage dice, plus an additional damage added because of a strike or maneuver, though all of the damage becomes bludgeoning damage, and it applies no other effects of the strike. The line is 20 feet long, plus 5 feet per 30 <water/power> mastery, and creatures can make a reflex save to halve the damage.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Fire","Power"],
                level: 1,
                name: `Scorching Cleave`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-power-power-fire] The first time each round that you make a melee attack, you also unleash a blazing cone of fire with an area equal 2x your reach with the attack. This cone deals 1d6 points of fire damage and applies 1 stack of immolation, plus 1d6 fire damage per 15 <fire/power> and plus 1 stack of immolation per 30 <fire/power>. Creatures in the area can make a reflex save to halve the damage.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `5 rounds`
              },
              {
                comboTags: ["Primal","Water"],
                level: 1,
                name: `Death Twist`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[primal-water-primal] Make a grapple attempt against a creature (doesn't provoke, gain +2 if it already wouldn't), gaining a bonus of +1 per 10 <primal/water>. If it succeeds, you grab and spin them around you violently, dealing 1d6 points of damage per 10 <primal/water> mastery and they must make a fortitude save with a penalty of -2 per 5 you beat their CMD by, or they become prone and nauseated for 1 round. After the grapple, you can move the creature to any square within your natural reach that you choose.`,
                initiationAction: `swift`,
                range: `touch`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Heroic","Dark"],
                level: 1,
                name: `Shatter Spirit`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-dark-heroic] Make an opposed will save against a creature that you can see, and can see you. If your roll is higher than theirs, all of their morale bonuses turn into penalties for 2 rounds.`,
                initiationAction: `swift`,
                range: `30 feet`,
                target: `1 enemy`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Heroic","Death"],
                level: 1,
                name: `Solemn Lament`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-death-death-heroic] Your next attack this round gains bonuses depending on the deeds of the creature. For every critical hit it has confirmed against one of your allies this combat, the attack gains a +1 flat bonus to critical threat range. For every ally it has killed during this combat, the attack gains a +1 bonus to its critical damage multiplier. For every 20 <heroic/death> mastery, the attack gains a +1 bonus on attack.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              // {
              //   comboTags: ["Heroic","Death"],
              //   level: 1,
              //   name: `Will of the People`,
              //   type: `Finisher`,
              //   finisherType:"Boost",
              //   longDesc: `[heroic-death-heroic] `,
              //   initiationAction: `swift`,
              //   range: `30 feet`,
              //   target: `1 enemy`,
              //   duration: `2 rounds`
              // },
              {
                comboTags: ["Heroic","Death"],
                level: 1,
                name: `Nec Fatum Finire Te`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[heroic-death-death-heroic] Within 1 minute, if a creature would make an attack that would bring you below 0 hit points, you may move up to 10 feet without provoking attacks of opportunity and make an attack against them with a -10 penalty. If the attack hits, it deals damage as normal, and the damage they dealt to you with the attack is negated. For every 10 <heroic/death> the attack deals an additional 1d6 damage, and for every 25 <heroic/death> it gains a +1 bonus to the attack.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `1 minute`
              },
              {
                comboTags: ["Guardian","Flurry"],
                level: 1,
                name: `Steel Bastion`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[guardian-flurry-guardian] For 1 round, allies within your threatened area gain a shield bonus to their AC for every successful melee attack you have made this round. For every 50 <guardian/flurry> mastery, the duration increases by 1 round.`,
                initiationAction: `free`,
                range: `reach`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Flurry","Guardian"],
                level: 1,
                name: `Spiked Citadel`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[guardian-flurry-guardian] Make a full attack. For 1 round, any of the creatures you struck during that full-round attack provoke an attack of opportunity if they attack you. The attack of opportunity is made after their attack is finished, and can only be made if you are able to make it after the attack has finished its effects. It also suffers a -5 penalty unless made with an off-hand weapon, but always deals damage as if it were an off-hand attack. For every 20 <flurry/guardian> mastery, these attacks of opportunity deal an additional 1d6 points of damage.`,
                initiationAction: `full-round`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Primal","Water"],
                level: 1,
                name: `Hunter In the Depths`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-water-primal] After you complete a charge, you can move 10 feet without provoking attacks of opportunity, and you gain a +2 dodge bonus to your armor class for 1 round, increased to +4 against the target of the charge. This applies only once after all attacks of a charge are made.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Primal","Water"],
                level: 1,
                name: `Torrent of Claws`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-water-water-primal] You can use each of your natural attacks a single time to make a counter attack against a weapon or natural attack made against you. Doing so is a free action you can take even when not your turn. When you counter an attack with this, you roll the base damage dice of the natural attack, adding no modifiers, even your ability modifier, and reduce the attackers attack mod by half of the result of the dice. You can use only a single natural attack to counter per attack against you. If you gain new natural attacks during the finisher's duration, you cannot counter with them still, but if you lose an attack, you cannot counter with it still. Until you have countered with a natural attack, you suffer a -4 penalty on attacks with it.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Fire","Death"],
                level: 1,
                name: `Paramita Papilio`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-death-fire] Immediately lose hit points equal to 10% of your maximum hit points. Your attacks this round deal additional fire damage equal to 33% the hit points lost. If you initiate this when below 33% hit points, the duration increases by 1 round and the damage increases to 50% of the hit points you lost.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 rounds`
              },
              {
                comboTags: ["Death","Fire"],
                level: 1,
                name: `Blood Blossom`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[death-fire-death] Every creature you successfully make a weapon attack against for the next 3 rounds have a blood blossom attached to their soul which combusts 3 rounds after it is applied. When it combusts, they take fire damage equal to 5% of your maximum hit points, plus 1% per 10 <fire/death> mastery. A creature can have only a single blood blossom applied to them at once.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Fire","Death"],
                level: 5,
                name: `Spirit Soother`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[fire-death-death-death-fire] Make a melee touch attack against all creatures within your natural reach. Every creature you successfully strike takes fire damage equal to 5% of your maximum hit points, plus 1% per 20 <fire/death> mastery and heals you for 1d6 plus 1d6 per 10 <fire/death> mastery. If you are below 50% hit points when you use this, the percentage of damage gained from your <fire/death> mastery doubles.`,
                initiationAction: `movement`,
                range: `melee touch`,
                target: `creatures`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Light","Primal"],
                level: 3,
                name: `Roar of the Radiant Beast`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[light-primal-primal-light] You unleash a primal roar infused with divine light. You emit a 30-foot cone of sound, and all allies that can hear it heal 1d6 hit points per 10 <light/primal> mastery and gain a +2 morale bonus on attack rolls for 1 round. Enemies in the cone take 1d6 sonic damage per 10 <light/primal> mastery and must succeed on a Will save or be shaken for 1 round. Every 25 <light/primal> mastery increases the area of the cone by 5 feet.`,
                initiationAction: `movement`,
                range: `30 foot cone`,
                target: `creatures`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Primal","Light"],
                level: 1,
                name: `Survival Instict`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-light-primal] When below 50% hit points, you gain fast healing of 1 + 1 per 5 <light/primal> mastery, and when making a saving throw you can roll twice and take the higher result, although both gain a -2 penalty.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Light","Power"],
                level: 1,
                name: `Feels Good`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[light-power-light] You immediately gain temporary hit points equal to your strength score, and then every round after at the start of your turn you gain temporary hit points equal to your strength modifier. Every 40 <light/power> mastery, these temporary hit points per round increase by your strength modifier. These temporary hit points stack with themselves and last until 1 round after this finisher ends, at which point enemies within your melee reach take bludgeoning damage equal to half the temporary hit points remaining (reflex halves).`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `6 rounds`
              },
              {
                comboTags: ["Power","Light"],
                level: 1,
                name: `Power of the Light`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[power-light-power] Make a melee attack, it deals additional untyped damage equal to your <light> mastery, and if it hits, you heal hit points equal to half your <power> mastery.`,
                initiationAction: `movement`,
                range: `melee`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Light","Power"],
                level: 1,
                name: `Divine Supremacy`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[light-power-light] Make an opposed strength check versus a creature within your melee touch (treat this as an attack for miss-chance etc.), if successful, for 3 rounds, every time you make a saving throw against one of their spells or abilities, you may roll twice and take the higher result.`,
                initiationAction: `swift`,
                range: `melee touch`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Dark","Power"],
                level: 1,
                name: `Complete Humiliation`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[dark-power-dark] Make an opposed strength check versus a creature within your melee touch (treat this as an attack for miss-chance etc.), if successful, for 3 rounds, every time they make a saving throw against one of your spells or abilities, they must roll twice and take the lower result.`,
                initiationAction: `movement`,
                range: `melee touch`,
                target: `1 enemy`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Shadow","Light"],
                level: 1,
                name: `Metsubushi`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[shadow-light-shadow] You throw a flashbang as a ranged touch attack with a range increment of 10 feet. All creatures within 10 feet of the impact point must make a reflex save or be blinded for 1 round. For every 10 <shadow/light> mastery the DC increases by +1. You are immune to being blinded by this. If you use this against a creature who would be flat-footed against one of your attacks, they suffer a -2 penalty to their reflex save and they fail, they are blinded for 2 rounds.`,
                initiationAction: `swift`,
                range: `ranged touch`,
                target: `ground`,
                duration: `1 round`
              },
              {
                comboTags: ["Light","Shadow"],
                level: 1,
                name: `Shadow Imbument`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[light-shadow-light] Make a stealth check to hide from all creatures who can see you, even if you dont have cover. You heal hit points equal to the result of the check and if you successfully hide from at least 1 enemy, you can also move a distance up to your <shadow/light>.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Shadow","Light"],
                level: 1,
                name: `Think Fast`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[shadow-light-shadow] You make a melee or ranged touch attack against an enemy (if ranged, 10 foot range increment), if successful, they are blinded by a flash of light for 1 round. If they are flat-footed for the attack, they are blinded for an additional round and suffer a -2 on all attacks, saves, and skill checks for 1 round.`,
                initiationAction: `free`,
                range: `melee or ranged touch`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Shadow","Light"],
                level: 1,
                name: `Gone in a Flash`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-light-shadow] You gain the benefits of the evasion class ability for 3 rounds. Every time you make a successful reflex save against an AOE instantaneous spell and negate the damage, you can immediately move up to half your movement speed as a free action you can take even when not your turn. If you already had evasion, you instead gain greater evasion, or +2 to reflex saves if you already had greater evasion.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Shadow","Light"],
                level: 1,
                name: `Light Dash`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[light-shadow-light] You turn into light and instantaneously move a distance equal to your <light/shadow> mastery. You never provoke for moving like this, and are immune to all physical damage during it. You can also move up freely whether you can normally fly or not.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Void","Primal"],
                level: 1,
                name: `Hyper Mutation`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[void-primal-primal-void] At the start of each of your following turns, you gain a new mutation that lasts for the rest of this finishers duration. To determing your mutation, roll a 1d10.
                \n1: You suffer a -2 penalty on all attacks, saves, damage rolls, skill checks, and ability checks.\n2: The finishers duration is reduced by 1 round.\n3: Gain +2 on all melee damage rolls\n4: Gain a secondary tentacle attack. 1d4 B, 20x2.\n5: Gain +2 on all attack rolls.\n6: Gain +2 on all saves\n7: Gain (or increase) fly speed (good) 30 feet.\n8: One of your natural attacks has its damage increased by 1 dice step.\n9: Gain an additional swift action each round\n10: This finisher's duration increases by 1 round.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `4 rounds`
              },
              {
                comboTags: ["Primal","Technique"],
                level: 1,
                name: `Clever Beast`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-technique-primal] You gain interative attacks with one of your natural attacks based on BAB. You cannot take these attacks if you take them with a weapon attack.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Flurry","Guardian"],
                level: 1,
                name: `Stormwall Flurry`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[flurry-guardian-flurry] Make a full-round attack. For 3 rounds, you gain a shield bonus to your armor class equal to the amount of successful attacks you made minus the unsuccessful attacks you made. When a creature misses you with an attack during this duration, they take 1d4 points of slashing damage per 15 <guardian/flurry> mastery.`,
                initiationAction: `full-round`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Void","Primal"],
                level: 1,
                name: `Cosmic Hunter`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[void-primal-void] Teleport adjacent to an enemy with medium range (100ft. + 10ft./level) that is below a percentage of hit points equal to 10 plus 1/3 your <void/primal> mastery and make an immediate attack agaisnt them. For every 5% below the range that they are, your critical threat range increases by a flat +1. If there are multiple enemies within this range, you get to choose which to teleport to, if there are none, this finisher fails, but you regain 1 void combo point.`,
                initiationAction: `swift`,
                range: `100ft. + 10ft./level`,
                target: `enemy below certain hp %`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Death","Void"],
                level: 3,
                name: `Cosmic Execution`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[void-death-death-void] The creature with the lowest hit point percentage immediately takes 1d8 points of negative energy damage per 5 <void/death> mastery and suffers a -4 penalty to their armor class, and a -2 penalty on all saves for 2 rounds, and critical hits against them have their damage multiplier increased by +1 for 1 round.`,
                initiationAction: `swift`,
                range: `100ft. + 10ft./level`,
                target: `lowest HP% creature`,
                duration: `1 round`
              },
              {
                comboTags: ["Flurry"],
                level: 3,
                name: `Savage Cascade`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[flurry-flurry-flurry-flurry-flurry] Make a melee attack, if it hits, you can take another melee attack at a -5 penalty. You can keep doing this until you miss an attack, the attack penalty stacking every attack. Every attack you take deals damage to you equal to your HD. If you attack with an off-hand attack, the stacking penalty for that attack is reduced to -3. For every 10 <flurry> mastery, you gain a +1 bonus to all of these attacks.`,
                initiationAction: `full-round`,
                range: `melee or ranged`,
                target: `1 creature`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Primal","Void"],
                level: 1,
                name: `Cosmic Jaws`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[primal-void-primal] Make a grapple attempt against a creature you can see within a distance of <primal/void> feet. This bypasses effects like freedom of movement (though when you attempt to maintain the grapple it will still fail as normal). If it succeeds, they are moved adjacent to you as normal and take 1d8 points of force damage per 10 <void/primal> mastery.`,
                initiationAction: `movement`,
                range: `<primal/void> ft.`,
                target: `1 creature`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Royal","Void"],
                level: 1,
                name: `Temporal Expropriation`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[royal-void-void-royal] If you defeat a creature when it is not your turn, you gain an immediat standard action.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Shadow"],
                level: 1,
                name: `Night's Embrace`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-shadow-shadow-shadow] All of your attacks for 1 round are made against a creature's flat-footed armor class. For every 25 <shadow> mastery, you gain 1d6 points of sneak attack damage.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Shadow"],
                level: 1,
                name: `Hollowpoint Fang`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[shadow-shadow-shadow-shadow] Make a melee touch attack, if it hits, it deals precision damage equal to your <shadow> mastery. If the creature has fortification, the damage is reduced by an amount equal to their fortification, however, you also reduce their fortification by the amount of damage reduced. This reduced fortification lasts until the end of your turn. Treat creatures with immunity to critical hits as if they had 125% fortification.`,
                initiationAction: `free`,
                range: `touch`,
                target: `1 enemy`,
                duration: `1 turn`
              },
              {
                comboTags: ["Water","Primal"],
                level: 1,
                name: `Otter's Play`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-water-primal] Gain +4 Dodge AC against attacks from enemies you've hit this round. You also increase the AC bonus you gain from cover by +2. If a creature misses you by an amount less than the bonus to armor class gained by your cover bonus to AC, you can move 5 feet as a free action you can take even when not your turn.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Shadow"],
                level: 1,
                name: `Shadow Mark`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-shadow-shadow] All enemies within feet of you equal to your <shadow> that cannot currently detect you are marked for 1 minute. When you attack a marked creature, the mark is consumed and the attack gains a +2 bonus and deals an additional 1d6 points of precision damage plus 1d6 per 10 <shadow> mastery if it hits. This precision damage acts like sneak attack damage, but doesn't require the attack to be against their flat-footed armor class or a flanked creature.`,
                initiationAction: `free`,
                range: `<shadow> ft.`,
                target: `enemies`,
                duration: `1 minute`
              },
              {
                comboTags: ["Shadow"],
                level: 1,
                name: `Specter's Lunge`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-shadow-shadow] Move in a straight line a distance equal to your <shadow> towards a target and make a single melee attack against them. This movement doesn't provoke, however as you move, you make a stealth check against the creature's perception check, this check doesn't automatically fail if the creature has supernatural senses. If your check matches or exceeds their perception check, your attack is against their flat-footed armor class and after the attack you can move an additional distance equal to half your stealth check without provoking.`,
                initiationAction: `movement`,
                range: `<shadow> ft.`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Technique","Water"],
                level: 1,
                name: `Twisting Stream`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[technique-water-technique] When you successfully counter an attack, you can redirect that attack to another enemy within the attackers reach. The attack must beat the new targets armor class as normal, but gains a bonus to damage of 1d6 per 10 <technique> mastery, and a bonus to attack of +1 per 10 <water> mastery.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Technique","Light"],
                level: 1,
                name: `Knowledge Saves`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[technique-light-technique] Make an attack, if it hits, it deals damage as normal plus additional untyped damage equal to your <light>, and you heal hit points equal to your <technique> mastery.`,
                initiationAction: `movement`,
                range: `melee or ranged`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Shadow"],
                level: 1,
                name: `3 Fold Feint`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-shadow-shadow] Make 3 bluff checks as if feinting versus a creature you threaten, if all are successful, they are stunned for 1 round.`,
                initiationAction: `movement`,
                range: `reach`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Void","Technique"],
                level: 1,
                name: `Temporal Schism`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[void-technique-void] Roll a d100, if it is below your <void/technique> mastery, make an attack. It deals bonus damage equal to your <void/technique> mastery minus the roll. If your <void/technique> mastery is 100 or higher, you can roll the d100 again, subtracting 100 from your effective <technique/void> mastery for the attack (bonus damage included), rolling it again and possibly making another attack.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Void","Technique"],
                level: 5,
                name: `Temporal Onslaught`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[void-technique-void-technique-void] Roll a d100, if it is below your <void/technique> mastery, make an attack. It deals bonus damage equal to the result of the d100 roll. You then roll again, if the roll is still below your <void/technique> mastery - the results of all previous d100 rolls during this activation of the finisher, you make another attack. You can keep making attacks, as long as the result continues to be below your mastery.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Technique","Heroic"],
                level: 1,
                name: `Hero's Opening`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[technique-heroic-technique] When you successfully counter an attack, another ally that threatens that creature can take an attack against the creature as a free action they can take even when not their turn. This attack deals an additional 1d6 points of damage per 15 <technique/heroic> mastery.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Technique","Royal"],
                level: 1,
                name: `Silver Reprisal`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[technique-royal-technique] When you successfully counter an attack, the attacker provokes an attack of opportunity from you if you threaten them. This attack deals an additional 1d6 points of damage per 15 <technique/royal> mastery.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Technique"],
                level: 1,
                name: `Master at Arms`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[technique-technique-technique] Gain a +4 bonus on all rolls make during a counter, and counter attacks have their critical threat range increased by a flat +1.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Technique","Sakura"],
                level: 1,
                name: `Perfect Response`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[technique-sakura-technique] When making counter attacks apart of a counter, you can roll twice and take the higher result, and all of them have their critical threat range increased by a flat +1. Every 25 <sakura/technique> mastery they also deal an additional 1d6 points of damage.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Air","Royal"],
                level: 1,
                name: `Preemptive Mandate`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[air-royal-air] The first time a creature attacks you, it provokes an attack of opportunity from you if you threaten them. Your attack occurs first. This attack deals an additional 1d6 electricty damage per 15 <air/royal> mastery.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Technique","Void"],
                level: 1,
                name: `Clock Strikes Death`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[technique-void-technique] Choose an enemy that you currently do not threaten. The next time you are threatening that enemy, you may make an immediate attack against them as a free action you can take even when not your turn. This attack suffers a -15 penalty, reduced by 2 every round since you initiated this finisher. For every 25 <void/technique> mastery the base penalty is reduced by 1.`,
                initiationAction: `free`,
                range: `sight`,
                target: `1 enemy`,
                duration: `1 minute`
              },
              {
                comboTags: ["Water","Air"],
                level: 1,
                name: `Tide and Tempest Dance`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[water-air-water] or [air-water-air] For 1 round, double your dodge bonus to armor class. If an attack misses you, you can move 5 feet without provoking attacks of opportunity.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Technique","Guardian"],
                level: 1,
                name: `Shield Lord`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[guardian-technique-guardian] or [technique-guardian-technique] For 2 rounds, double your shield bonus to armor class. If an attack misses you, you gain a stacking DR 1/- for the rest of the finisher. This DR only stacks with itself, not other DR.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Sakura","Death"],
                level: 1,
                name: `Hakanai`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[sakura-death-death-sakura] Make a melee attack, gaining a +1 bonus to its critical threat range (this is doubled by keen or similar abilities). It deals no damage unless it is a potential critical hit (whether it confirms or not). It deals an additional 1d6 damage per 5 <sakura/death> mastery.`,
                initiationAction: `free`,
                range: `melee`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Technique","Arcane"],
                level: 1,
                name: `Thaumic Blade`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[technique-arcane-technique] Spend an amount of spell points up to half of your <technique/arcane> mastery, and then make a melee attack. If it hits, it deals bonus force damage equal to 2x the spell points spent.`,
                initiationAction: `movement`,
                range: `melee or ranged`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Sakura","Arcane"],
                level: 1,
                name: `Rainbara`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[sakura-arcane-sakura] You gain a bonus on confirming critical hits equal to your initiation modifier. If you confirm a critical hit, it deals an additional 1d6 points of a random magical damage (fire,cold,electricity,acid,force,sonic) of 1d4 per 5 <arcane/sakura> mastery. If the critical hit only confirmed because of the bonus this granted, the bonus elemental damage is doubled.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Flurry","Death"],
                level: 1,
                name: `Reaper's Tally`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-death-flurry] Make a touch attack against a creature, if successful, the creature is marked. Every time you attack the creature, whether successful or nor, it adds one more stack. Any time within 1 minute, you can make another melee touch attack against the creature, if successful, the creature takes 1d6 points of precision damage per stack. Every 30 <flurry/death> the damage per dice rolled increases by +1. If the damage kills the creature, you can choose to gain a death combo point, and you heal hit points equal to the stacks expended.`,
                initiationAction: `free`,
                range: `touch`,
                target: `1 enemy`,
                duration: `1 minute`
              },
              {
                comboTags: ["Flurry","Void","Death"],
                level: 1,
                name: `Final Dirge`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-void-death] If you make 11 successful attacks on enemies within 3 rounds, your next attack is an automatic potential critical hit, and it deals an additional 1d6 points of damage per 10 <void/flurry> mastery.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Primal","Heroic"],
                level: 1,
                name: `Imposing Will`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[primal-heroic-primal] All enemies within feet equal to your <primal/heroic> mastery that have a lower will save bonus than you suffer a -2 penalty on attack rolls, saving throws, skill checks, and ability checks for 1d4 rounds. For every creature penalized from this, you gain a +2 morale bonus on damage rolls for the same duration (max level).`,
                initiationAction: `free`,
                range: `mastery ft.`,
                target: `enemies`,
                duration: `1d4 rounds`
              },
              {
                comboTags: ["Primal","Heroic"],
                level: 1,
                name: `Your Will is Everything`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-primal-primal-heroic] Your BAB becomes equal to your wisdom modifier for 3 rounds. For every 30 <primal/heroic> mastery, your BAB increases by a further +1.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Primal","Heroic"],
                level: 1,
                name: `Your Training Is Nothing`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-primal-heroic] You can use your wisdom in place of your dexterity to determine your armor class and CMD.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Sakura","Technique"],
                level: 1,
                name: `Tenchiryū`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[sakura-technique-technique-sakura] You can use your dexterity in place of your initiation modifier to determine the DC's of maneuvers used this round. Every 20 <sakura/technique> mastery, the DC increases by an additional +1.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Sakura","Technique"],
                level: 1,
                name: `Transcendent Kensei`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[technique-sakura-sakura-technique] If a maneuver is a potential critical hit, it's DC against that creature increases by half any bonus you gain to confirming critical hits. If it is a confirmed critical hit, it increases by the full bonus you gain to confirming critical hits. For every 50 <sakura/technique> mastery, you gain a +1 bonus to confirming critical hits while this finisher is active.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Sakura","Death","Technique"],
                level: 3,
                name: `Black Blossom`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[sakura-death-death-sakura/technique] When you confirm landing a maneuver that has a DC, the creature rolls to determine if it succeeds or fails that DC before you roll the damage of that attack, and if they fail the DC, the critical threat range of the attack increases by a flat +1, potentially retroactively turning the attack into a critical hit. If the attack is already a confirmed critical hit and the creature fails the DC, instead, instead of the threat range increasing, the critical damage multiplier increases by +1. Every 20 <technique/death/sakura> mastery you have, critical hits deal an additional 1d6 damage.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Shadow","Void"],
                level: 1,
                name: `Walk of the Moon`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow,void] Although the shadow and void combo points are removed, the rest of your combo points are not, and you can reorganize them as you'd like. If within 3 rounds you use combo points again, your remaining combo points are not removed, and you can reorganize them again, and you recover a <shadow> maneuver.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Heroic","Primal","Flurry"],
                level: 9,
                name: `My Way`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[heroic-primal-flurry-primal-heroic] You can only initiate this finisher when your hit point percentage is lower than 5% + 1/4 of your <heroic/primal> mastery. Make a full-round attack. During this action, you can move as far as you'd like without provoking during this action, however you cannot go further than 60 feet from where you started. You also gain additional attacks during this action for various reasons, each additional attack is at your highest bonus -5, with a stacking -1 for every previous bonus attack. The bonus attacks are for the following reasons:
                \n1: For every enemy within 60 feet that has more than twice your hit point percentage and has HD at least equal to your level\n2: For every ally within 60 feet that is unconscious\n3: For every ally within 120 feet that is dead, you gain 2 attacks. \n4: For every 2 CR higher the encounter is than your level.
                \nOnce you initiate this finisher, you immediately go to the maximum hit points you could be at to initiate it, and you gain temporary hit points equal to your missing hit points that last 3 rounds, however your maximum hit points become your current hit points for the rest of the day.`,
                initiationAction: `full-round and swift`,
                range: `60 feet`,
                target: `enemies`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Shadow","Primal"],
                level: 1,
                name: `Prowler's Claw`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[shadow-primal-primal-shadow] Make a melee touch attack, if it hits, you dash through the creature without provoking attacks of opportunity, ending the movement on the on the exact tile on the other side of the creature, they suffer damage equal to your <primal/shadow> mastery, and every time the creature is damaged for 1 round, it suffers an additional 1d6 precision damage. Every 50 <primal/shadow> mastery, the additional damage increases by 1d6`,
                initiationAction: `movement`,
                range: `touch`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Heroic","Primal"],
                level: 3,
                name: `Voice of The Conqueror`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-primal-primal-heroic] You unleash a thunderous roar that emboldens you and your allies, while terrifying your enemies. You and all allies within the area become immune to fear for 1 round, while enemies in the area must make a will save or be frightened for 1 round. For every enemy frightened, you and your allies gain a +1 morale bonus to attack and damage for 1 round. For every 50 <primal/heroic> mastery, the duration for the immunity to fear increases by 1 round. For every 20 <heroic/primal> mastery, the cone increases by 5 feet.`,
                initiationAction: `movement`,
                range: `30 foot cone`,
                target: `creatures`,
                duration: `1 round`
              },
              {
                comboTags: ["Heroic","Flurry"],
                level: 7,
                name: `Champion of the People`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-flurry-heroic-flurry-heroic] Pick a creature you can see, for 1 round, every time an ally attacks the creature, you may also attack them (as long as they are a viable target to attack). Each attack suffers a -8 penalty, or -4 if made with alternating main and off-hand attacks, plus a stacking -2 penalty for every previous attack you made (or -1 if made with alternating main and off-hand attacks).`,
                initiationAction: `full-round`,
                range: `60 feet`,
                target: `1 enemy`,
                duration: `1 round`
              },
              {
                comboTags: ["Water","Light"],
                level: 1,
                name: `Song of Water`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[water-light-water] Every time you hit an enemy with an attack and it deals damage, you can heal an ally other than yourself within 30 feet of you for 1d6 hit points. Every 20 <water/light> the healing increases by 1d6 and the range by 5 feet.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Air","Light","Heroic"],
                level: 1,
                name: `Divine Wind`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[air-light/heroic-air] You have the blessings of a divine wind that causes attacks at critical moments to miss. The next time within the duration a critical hit would be scored against you, it automatically misses. For every 50 <air/light/heroic> mastery, this lasts an additional round and critical hit. For every dead LG, CG, or NG ally that is currently dead, this also lasts an additional attack and round (if they are revived before this finisher ends, you lose that extra activation)`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Air","Guardian"],
                level: 1,
                name: `Shinzokaze`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[air-guardian-air] or [guardian,sakura,light] You bless an ally (not you) within 30 feet of you for 2 rounds, critical hits against the creature suffer a 25% miss chance, +1% per 3 <guardian/air> (max 75%). This stacks with other miss chance, but is rolled seperately. If you are dead, the miss chance is increased by 25% (max now 100%)`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Technique","Air"],
                level: 5,
                name: `Resonating Strike`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[technique-air-air-technique] Make a ranged touch attack against a creature within 30 feet, +5 feet per 20 <technique/air>, if successful it deals 1d6, plus 1d6 per 15 <technique/air> sonic damage. For 3 rounds, you can now see them as if you had tremorsense, even if you or them are not on the ground. Within those 3 rounds, you can activate this maneuver again as a swift action, allowing you to move any distance (ignoring your max movement speed) towards the creature. For this movement, you must end it threatening the creature, you must move in a straight line to the closest square you can reach them from (similar to a charge), cannot move through solid objects, but can move through creatures (provoking as normal). If you successfully arrive at your target destination, you can make a single unarmed attack against them at a -5 penalty, if successful, it deals damage as normal plus additional damage equal to 10% of their missing hit points, plus 1% per 10 <technique/air>. This does not become expended until you either reactivate it, or choose to expend it, stopping you from reactivating it.`,
                initiationAction: `movement`,
                range: `30 feet, +5/20<technique/air>`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Technique","Earth"],
                level: 3,
                name: `Crippling Tempest`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[technique-earth-technique] You slam your hand against the ground or each other, dealing 1d6 plus 1d6 per 10 <technique/earth> sonic damage to all creatures within a 10 foot radius of you (even through walls). Every creature hit must make a reflex save, or you gain sight of them no matter where they are as if you had tremorsense (even if you or them are not on the ground). Within the next 2 rounds, you can activate this against as a swift action to cripple their movement for 1 round, causing them to move at half speed. This does not become expended until you either reactivate it, or choose to expend it, stopping you from reactivating it.`,
                initiationAction: `swift`,
                range: `10 foot radius`,
                target: `creatures`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Technique","Heroic"],
                level: 3,
                name: `Safeguard`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[technique-heroic-heroic-technique] You dash to an ally within 30 feet of you, granting both you 1d4 plus 1d4 per 10 <technique/heroic> temporary hit points that last 3 rounds. You can also activate this on yourself to increase the temporary hit points gained to d6's, but you cannot move. You can activate this again within the next 3 rounds as a swift action to cause your next attack that round to heal you for 20% of the damage it deals. This does not become expended until you either reactivate it, or choose to expend it, stopping you from reactivating it.`,
                initiationAction: `free`,
                range: `30 feet`,
                target: `ally`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Flurry","Technique"],
                level: 3,
                name: `Fists of Fury`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-technique-flurry] For the next 3 rounds, once per round when you you initiate a strike that allows you to make a single attack against a single creature, you can make an additional single melee attack against the creature as a free action at a -5 penalty from the previous attack taken. Whenever you initiate a finisher, you can make a single melee attack against a creature you threaten at highest BAB -5 penalty as a free action you can take even when not your turn. These attacks deal an additional 1d4 points of damage per 10 <flurry/technique> mastery.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `5 rounds`
              },
              {
                comboTags: ["Technique","Primal"],
                level: 3,
                name: `Dragon's Rage`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[technique-primal-technique] Make a single melee unarmed attack, if it hits, it deals damage as normal, but you also make a CMB check to bull rush the creature as a free action which doesn't provoke (or gain +2 if it already wouldn't), gaining a bonus of +1 per 5 <primal/technique> (you cannot move with this bullrush). If the bullrush was successful, if the bullrushed creature impacts another creature, the impacted creature takes damage equal to your CMB check multiplied * the amount of size categories larger than small the bullrushed creature is, and they fall prone, and instead of the bullrushed creature stopping its movement, if your CMB check to bullrush was higher than the impacted creature's CMD, the bullrushed creature keeps moving, possibly striking multiple creatures. If they strike a solid wall, apply your CMB to the wall to break it and keep them moving, but on failure they take 1d10 damage for every 5 feet left to move.`,
                initiationAction: `movement`,
                range: `melee`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Flurry","Technique"],
                level: 1,
                name: `Furious Combos`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-technique-technique-flurry] Every 5th attack during this finisher becomes a furious finish, causing it to suffer a -4 penalty to hit, but to deal additional damage equal to ability score modifier to damage the attack normally deals (only the default one, no additional bonuses). For every successful melee attack you make during this finisher, you also gain one furious combo stack, causing the next furious finish attack to deal an additional +2 damage (resents once you make a successful furious finish). For every successful furious finish you make, your further furious finishers this activation also gain +1 to attack and +4 to damage. For every 30 <flurry/technique> the damage per furious combo stack increases by +1.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Technique","Guardian","Primal"],
                level: 1,
                name: `Dragon's Defense`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[technique-guardian/primal-technique] Once you initiate this finisher, your turn ends and you cannot attack until the start of your next turn. While this finisher is active, you reduce all damage you take by a 25% plus 1% per 5 <technique/guardian/heroic> (max 75%). At the start of your next turn, you gain temporary hit points equal to the damage reduced for 3 rounds and your next attack this round deals additional damage equal to half the temporary hit points gained.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `1 round`
              },
              {
                comboTags: ["Technique","Heroic","Primal"],
                level: 1,
                name: `Living Weapon`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[technique-heroic-primal-heroic-technique] For 3 rounds, all melee attacks gain +2 bonus to attack rolls and deal additional damage equal to your initiation modifier, plus 1 damage per 10 <technique/heroic/primal>. Every 25 <technique/heroic/primal> mastery, the attack bonus increases by +1.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `2 rounds`
              },
              {
                comboTags: ["Technique","Light"],
                level: 1,
                name: `In Harmony`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[technique-light-technique] You cannot attack while this is active, but you can end it whenever you like as a free action. At the end of every turn you have this active, except the turn you initiate it, you heal hit points equal to 1/2 your <technique/light> mastery, and you reduce all damage you take by 33%. Every 50 <technique/light> mastery this can last an additional round.`,
                initiationAction: `movement`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Shadow","Fire"],
                level: 1,
                name: `Cinder Shroud`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-fire-shadow] You create a cloud of cinder and smoke in a 5 foot radius around you that lingers for 3 rounds. This acts like fog cloud, except you gain total concealment against opponents instead of concealment while within 5 feet of them. Creatures that end their turn within the cloud suffer 1d6 points of fire damage plus 1d6 per 10 <fire/shadow> mastery. You can choose to stop the cloud from following you as a free action, spending the rest of its duration in the location you leave it. When you do this, the next attack you make is at the targets flat-footed armor class.`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Shadow","Fire"],
                level: 1,
                name: `Dirty Smoke`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[shadow-fire-fire-shadow] Make a touch attach against a creature. If successful, the target catches on fire that produces large amounts of ash and cinder. This fire deals 1d6 points of fire damage, plus 1d6 points of fire damage per 20 <fire/shadow> mastery at the start of each of their turns. Additionally, the creature treats all creatures within 5 feet as having concealment and creatures further than 5 feet away from them as having total concealment (unless they can see through the smoke). Attacks against them also suffer from concealment. The creature can attempt to extinguish the fire as a normal, but if they do, it provokes an attack of opportunity from you. They suffer a penalty to extinguish the flame of 1 per 5 <fire/shadow> mastery.`,
                initiationAction: `swift`,
                range: `touch`,
                target: `1 enemy`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Fire","Earth"],
                level: 1,
                name: `Molten Pit`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[fire-earth-earth-fire] You touch a creature and cause a lava pit to open up beneath them, encompassing their entire space. The pit is 1 foot deep and counts as difficult terrain. Any creature that enters the lava immediately suffers 1d6 plus 1d6 per 10 <fire/earth> mastery fire damage, and creatures that end their turn in the lava suffer 1d6 plus 1d6 per 10 <fire/earth> mastery fire damage. If a creature is within the area when this ends, they are trapped within the hardened lava counting as entangled to the square and require an escape artist or CMB check of 10 + initiation modifier + 1 per 5 <fire/earth> mastery to escape.`,
                initiationAction: `swift`,
                range: `touch`,
                target: `1 enemy`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Earth","Fire"],
                level: 1,
                name: `Molten Crust`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth-fire-fire-earth] The first time each turn you are attacked you gain DR -/ 1 plus 1 per 5 <earth> mastery. This DR stacks with other DR. If the attack still damages you, you erupt with a molten explosion, and if the attack was a melee attack, it deals 1d6 fire damage per 5 <fire> mastery to the attacker. The creature can make a reflex save to halve the damage.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },

              // {
              //   comboTags: ["Technique","Heroic"],
              //   level: 1,
              //   name: ``,
              //   type: `Finisher`,
              //   finisherType:"Strike",
              //   longDesc: `[technique-heroic-technique] turn your desperation into something else. `,
              //   initiationAction: `movement`,
              //   range: `sight`,
              //   target: `1 enemy`,
              //   duration: `1 minute`
              // },
              // {
              //   comboTags: ["Technique","Void"],
              //   level: 1,
              //   name: ``,
              //   type: `Finisher`,
              //   finisherType:"Strike",
              //   longDesc: `[technique-heroic-technique] `,
              //   initiationAction: `movement`,
              //   range: `sight`,
              //   target: `1 enemy`,
              //   duration: `1 minute`
              // },
              // {
              //   comboTags: ["Shadow","Void"],
              //   level: 1,
              //   name: `Completely Beffudled`,
              //   type: `Finisher`,
              //   finisherType:"Boost",
              //   longDesc: `[shadow-shadow-shadow] `,
              //   initiationAction: `movement`,
              //   range: `reach`,
              //   target: `1 enemy`,
              //   duration: `1 round`
              // },
              // {
              //   comboTags: ["Death","Heroic"],
              //   level: 1,
              //   name: `Rallying Carnage`,
              //   type: `Finisher`,
              //   finisherType:"Boost",
              //   longDesc: `[death-heroic-death] You choose a single target you can see and pick them out for slaying next. `,
              //   initiationAction: `swift`,
              //   range: `30 feet`,
              //   target: `allies`,
              //   duration: `1 round`
              // },
              // {
              //   comboTags: ["Heroic","Dark"],
              //   level: 1,
              //   name: `Sumary Judgement`,
              //   type: `Finisher`,
              //   finisherType:"Boost",
              //   longDesc: `[heroic-dark-heroic] `,
              //   initiationAction: `movement`,
              //   range: `touch`,
              //   target: `1 enemy`,
              //   duration: `instantenous`
              // },
              // {
              //   comboTags: ["Power","Primal"],
              //   level: 1,
              //   name: `Power Hungry`,
              //   type: `Finisher`,
              //   finisherType:"Boost",
              //   longDesc: `[power-primal-power] Make a bite attack. If you dont have a bite attack, you can still make one, however it deals 1d4 points of damage `,
              //   initiationAction: `movement`,
              //   range: `personal`,
              //   duration: `encounter`,
              //   target: `you`,
              // },
              {
                comboTags: ["Technique","Sakura","Water"],
                level: 1,
                name: `Shimotsuki`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[technique/sakura-water-technique/sakura] Choose a creature you can see and that currently threatens you, then your turn ends immediately. For 1 round, every time it attacks you, you gain a +1 dodge bonus to your armor class against its attacks until the start of your next turn. At the start of your next turn, as a free action you make before any other action, you can make a single attack at your highest bonus against the targeted creature, for which your reach increased by 5 feet. If succesful, it deals an additional 1d3 points of cold damage for every time you were attacked, but the cold damage increased by 1 dice step for every time the chosen creature missed you with an attack. If it fails to attack you a single time during the round, but attacks something else, the attack instead deals an additional 1d4 points of cold damage per 5 <water/sakura/technique> mastery.`,
                initiationAction: `movement`,
                range: `see text;`,
                duration: `1 round`,
                target: `1 enemy`,
              },
              {
                comboTags: ["Sakura","Dark","Death"],
                level: 3,
                name: `Spirit Cleave`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[sakura-dark-sakura/death] Make a a single melee attack, applying it against the armor class of all creatures in a 15 foot cone. It deals damage as normal plus 1d4 per 10 <sakura/dark/death> mastery, apply one damage roll against all creatures. This attack cannot critically hit, but if it rolls within its critical range on the attack, the additional damage it deals from your mastery is multiplied by your critical damage multiplier. As long as it hits and deals damage against at least one enemy, it grants temporary hit points equal to the highest damage dealt during the attack, +50% for every creature past the first that it struck. These last initiation modifier rounds. This does not stack with any other maneuver that grants temporary hit points or healing from damage dealt. Every 30 <sakura/dark/death> mastery the range of this maneuver increases by 5 feet.`,
                initiationAction: `movement`,
                range: `15 foot cone`,
                duration: `initiation modifier`,
                target: `creatures`,
              },
              {
                comboTags: ["Power","Dark","Death"],
                level: 3,
                name: `Black Cleave`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[power-dark-power] Make a a single melee attack, applying it against the armor class of all creatures in a 15 foot cone. It deals damage as normal plus 1d4 profane damage per 10 <power/dark> mastery, apply one damage roll against all creatures. This attack cannot critically hit, but the additional damage granted by mastery is automatically multiplied by the weapons critical damage multiplier. As long as it hits and deals damage against at least one enemy, it grants temporary hit points equal to 50% of the highest damage dealt during the attack, +25% for every creature past the first that it struck. These last initiation modifier rounds. These do not stack with any other maneuver that grants temporary hit points or healing from damage dealt. Every creature struck by this, must make a will save or become frightened until the start of their next turn, and staggered during their next turn. Every 30 <power/dark> mastery the range of this maneuver increases by 5 feet.`,
                initiationAction: `movement`,
                range: `15 foot cone`,
                duration: `initiation modifier`,
                target: `creatures`,
              },
              {
                comboTags: ["Dark","Sakura"],
                level: 3,
                name: `Mortal Steel`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[dark-sakura-dark] 3 times within the duration you gain the ability to make a special swift action attack. This attack is a normal melee attack at your highest bonus, except it deals additional profane damage. If the previous special attack from this finisher hit, the next attack is upgraded. For any previous attack that was a critical, the profane damage increases by 1 dice step
                \nAttack 1: Deals an additional 1d8 profane damage per 10 <dark/sakura> mastery. 
                \nAttack 2: Deals an additional 1d6 profane per 5 <dark/sakura> mastery. 
                \nAttack 3: Move a distance equal to twice the spaces you occupy along one side +5 feet (med: 3, large: 5, etc.) in a straight line when making this attack (doesn't provoke, can move through enemies), applying your attack roll to all creatures you move through, dealing an 1d8 points of profane damage per 10 <dark/sakura> mastery, and creatures struck must make a reflex save or be dazed for 1 round.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `1 minute`,
                target: `you`,
              },
              {
                comboTags: ["Sakura","Air"],
                level: 3,
                name: `Steel Tempest`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[sakura-air-sakura] 3 times within the duration you gain the ability to make a special swift action attack. This attack is a normal melee attack at your highest bonus, except it deals additional electricity damage. If the previous special attack from this finisher hit, the next attack is upgraded. For any previous attack that was a critical, the electricity damage increases by 1 dice step
                \nAttack 1: Deals an additional 1d6 electricity damage per 10 <sakura/air> mastery. 
                \nAttack 2: Deals an additional 1d4 electricity per 5 <sakura/air> mastery. 
                \nAttack 3: This attack launches a gust of wind in a straight line 20 feet. Make an attack roll, applying it to all creatures within the area. It deals damage as if struck by a weapon attack plus 1d6 electricity damage per 10 <sakura/air> mastery, and creatures struck must make a reflex save or be dazed for 1 round.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `1 minute`,
                target: `you`,
              },
              {
                comboTags: ["Earth","Sakura"],
                level: 1,
                name: `Stone Breathing`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[earth-sakura-sakura-earth] For 3 rounds you gain a +4 inherent bonus to your strength, DR /adamantine equal to your initiation modifier, and blindsight 20 feet as your hearing improves tremendously. Every 25 <earth/sakura> the strength bonus and DR increases by +1, this DR becomes /- (stacks with the adamantine given), and for every 50 <earth> the duration increases by 1 round.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Air","Sakura"],
                level: 1,
                name: `Wind Breathing`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[air-sakura-sakura-air] For 3 rounds you gain a +2 inherent bonus to your wisdom and will saves and gain a dodge bonus to your armor class and reflex saves equal to half of your wisdom modifier. Every 25 <air/sakura> the wisdom bonus increases by +1, and for every 50 <air> the duration increases by 1 round.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Air","Sakura"],
                level: 1,
                name: `Thunder Breathing`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[air-sakura-sakura-air] For 3 rounds you gain a +4 inherent bonus to your dexterity, and when moving gain a +4 dodge bonus to armor class, your movement speed increases by 10 feet, and you gain blindsense 30 feet from your incredible hearing. Every 25 <air/sakura> the dexterity and dodge bonus increases by +1, and the movement speed increases by 5 feet. For every 50 <air> the duration increases by 1 round.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Water","Sakura"],
                level: 1,
                name: `Water Breathing`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[water-sakura-sakura-water] For 3 rounds you gain a +4 inherent bonus to your dexterity, every round you can take a 5-foot step for free, and you gain a +2 dodge bonus to your armor class against any creature attacking you with a melee attack from more than 5-feet away, and if such an attack misses, once per round, you can take a 5-foot step as a free action you can take even when not your turn. Neither of these 5-foot steps impact your ability to take other 5-foot steps or move. You also gain scent 50 feet (or improve it by 15 feet). Every 25 <water/sakura> the dexterity bonus increases by +1. For every 50 <water> the duration increases by 1 round and you can take an additional 5-foot step per round (you can choose whether its in response to an attack, or during your turn).`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Shadow","Sakura"],
                level: 1,
                name: `Shadow Breathing`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-sakura-sakura-shadow] For 3 rounds you gain a +3 inherent bonus to your intelligence, your unarmed and sneak attacks deal additional precision damage equal to your intelligence modifier, and when making a sneak attack you gain a +2 bonus on the attack rolls. You also gain scent 50 feet (or improve it by 15 feet). Every 30 <shadow/sakura> the dexterity bonus and damage increases by +1. For every 50 <shadow> the duration increases by 1 round.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Heroic","Sakura"],
                level: 1,
                name: `Love Breathing`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[heroic-sakura-sakura-heroic] For 3 rounds you gain a +3 inherent bonus to your charisma and strength, and gain a shield bonus to armor class equal to your charisma modifier. Every 30 <heroic/sakura> the strength and charisma bonus increases by +1.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Curse","Sakura"],
                level: 1,
                name: `Serpent Breathing`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[curse-sakura-sakura-curse] For 3 rounds you gain a +4 inherent bonus to your intelligence, an insight bonus to armor class equal to half of your intelligence modifier, and a bonus on feint checks equal to your intelligence modifier. Whenever you successfully feint a creature, you gain a +2 bonus on your next attack against them, and it deals an additional 1d6 precision damage. Every 25 <curse/sakura> the intelligence bonus increases by +1, and the damage bonus increases by 1d6. For every 50 <curse> the duration increases by 1 round.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Royal","Sakura"],
                level: 1,
                name: `Mist Breathing`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[royal-sakura-sakura-royal] For 3 rounds you gain a +4 inherent bonus to your strength. Whenever a creature misses an attack against you, you gain a bonus on your next weapon attack against them equal to your initiation modifier. This stacks for every attack against you that they miss, applying to an additional attack you make. You also gain blindsense 50 feet. Every 25 <royal/sakura> the strength bonus increases by +1. For every 50 <royal> the duration increases by 1 round.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Flurry","Sakura"],
                level: 1,
                name: `Beast Breathing`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-sakura-sakura-flurry] For 3 rounds you gain a +4 inherent bonus to your strength, and you gain 25% fortification, which stacks with other fortification. Every time you strike a creature with two different weapons during the same round, they suffer 1d6 + 1/2 strength modifier damage. This can apply multiple times per round. You also gain 20 feet tremorsense. Every 25 <flurry/sakura> the strength bonus increases by +1, and the damage by 1d6. For every 50 <flurry> the duration increases by 1 round.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Sakura","Void"],
                level: 1,
                name: `Flower Breathing`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[sakura-sakura-sakura-sakura] For 3 rounds you gain a +4 inherent bonus to your dexterity, your critical threat range with melee weapons increases by a flat +1, and your critical hits deal additional precision damage equal to your performance(dance). You can gain truesight 60 feet for 1 round as a free action, however doing so causes you to become blind after this finisher ends for rounds equal to however many times you activated it during. Every 25 <sakura> the dexterity bonus increases by +1. For every 50 <sakura> the duration increases by 1 round.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Death","Sakura"],
                level: 1,
                name: `Insect Breathing`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[death-sakura-sakura-death] For 3 rounds you gain a +3 inherent bonus to your dexterity and intelligence, and your weapon attacks deal additional negative energy damage equal to your intelligence modifier. Every 30 <death/sakura> the dexterity and intelligence bonus increases by +1. For every 50 <death> the duration increases by 1 round.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Fire","Sakura"],
                level: 1,
                name: `Flame Breathing`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[fire-sakura/heroic-sakura/heroic-fire] For 3 rounds you gain a +3 inherent bonus to your strength and wisdom, and damage reduction /- equal to your wisdom modifier, which doubles when below 10% hit points. When below 33% hit points, you also gain a bonus on attacks equal to half your wisdom modifier, and a bonus on damage equal to your whole wisdom modifier. You also gain detect evil with a range of 60 feet. Every 30 <fire/sakura> the strength and wisdom bonus increases by +1. For every 50 <fire/heroic> the duration increases by 1 round.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Technique","Sakura"],
                level: 1,
                name: `Sound Breathing`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[technique-sakura-sakura-technique] For 3 rounds you gain a +4 inherent bonus to your charisma. Every time an attack misses you, you gain a stacking +1 bonus to your next weapon attack roll. Every time one of your attacks hits, you gain a +1 stacking dodge bonus to your armor class for 1 round, reducing by 1 every time you are attacked. Both bonuses max out at your charisma modifier. Every 25 <technique/sakura> the charisma bonus increases by +1. For every 50 <technique> the duration increases by 1 round.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Void","Sakura"],
                level: 5,
                name: `Moon Breathing`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[void-sakura-sakura-void] For 3 rounds you gain a +3 inherent bonus to all mental ability scores. You gain an insight bonus to your attack equal to your lowest mental bonus, an insight bonus to armor class equal to your middle mental bonus, and an insight bonus on damage to your highest mental bonus. You also gain truesight and blindsight with a range of 60 feet. Once during the duration, you can make a melee attack against any creature within 30 feet of you as a free action you can take even when not your turn, and your critical threat range when doing so increases as a flat +2. You can make this attack regardless of your normal reach, and it ignores cover, even total cover. Every 30 <void/sakura> the ability score bonuses increase by +1. For every 50 <void> the duration increases by 1 round, and you can take the special attack an additional time, though it suffers a -5 penalty, and cannot be used on the same round.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Void","Fire","Death"],
                level: 5,
                name: `Solar Collapse`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[void-fire-death-fire-void] You are reduced to 0 hit points, all creatures within 15 feet of you take fire damage equal to the amount of hit points you just lost (reflex halves). You then vanish for 2 rounds, reappearing in the square you left at the end of your turn.`,
                initiationAction: `movement`,
                range: `15 feet radius`,
                target: `creatures`,
                duration: `1 round`
              },
              {
                comboTags: ["Flurry","Air"],
                level: 1,
                name: `Whirlwind Onslaught`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-air-flurry-air-flurry] You can take a full attack action as a standard action. All attacks suffer a -2 penalty while doing this, but deal an additional +1 electricity damage per 10 <flurry/air>`,
                initiationAction: `swift`,
                range: `personal`,
                target: `you`,
                duration: `3 rounds`
              },
              {
                comboTags: ["Flurry","Arcane"],
                level: 1,
                name: `Chrono Flurry`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-arcane-flurry] For 1 minute, when you take a full attack action, any attacks you dont use, you can store. Within the duration, you can expend all stored attacks as a swift action if it is less than 2, or a movement action if it is more than 2, to take all of those stored attacks. Once you take the stored attacks, this finisher ends. Each attack stored this way deals an additional +1 damage per 5 <arcane/flurry>.`,
                initiationAction: `free`,
                range: `personal`,
                target: `you`,
                duration: `1 minute`
              },
              {
                comboTags: ["Royal"],
                level: 5,
                name: `Grand Challenge`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[royal-royal-royal-royal-royal] You declare a grand challenge against a creature. 8 Marks appear around the creature, one for each of its 4 sides, and one for each of its 4 corners. If you make a successful weapon attack that deals damage against the creature from a marked side/corner, while also being adjacent to the creature, that specific mark is consumed and the attack deals additional damage equal to 2x the creature's HD. If all 8 marks are consumed within 1 minute, you heal hit points equal to 1/2 your <royal> mastery, and your next attack against the creature cannot be countered, and if successful is an automatic potential critical hit (bypasses fortification and critical hit immunity). If you trigger a mark with an attack of opportunity, the damage increases to 3x their HD. This damage is not multiplied by critical hits, but can be by <royal> maneuvers.`,
                initiationAction: `free`,
                range: `30 feet`,
                target: `1 enemy`,
                duration: `1 minute`
              },
              {
                comboTags:["Void","Fire"],
                level: 9,
                name: `Supernova`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[void-fire-fire-fire-fire-void] On the turn this initiatiates, plus the next 2 rounds after, you expend 1 random maneuver. If the maneuver was a <void> or <fire> maneuver, you can initiate it this round, and its initiation action is reduced by 2 steps (counters become free actions you can initiate even when not your turn). You suffer 2 constitution drain at the start of each of these turns.`,
                initiationAction: `1 round`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags:["Light","Void"],
                level: 9,
                name: `Born of a Star`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[light-void-light-void-light] You gain immunity to criticals, sneak attack, disease, poison, bleed, stun, daze, paralysis, blind, fear, dead, dying, exhausted, fatigue, nauseated, petrified, staggered, unconsciousness. Additionally, at the start of each turn, you restore yourself to full hit points, and remove all temporary negative levels, ability score damage and penalties from yourself. At the end of this finishers duration, you suffer -4 drain to your wisdom, and intelligence. This drain cannot be removed until the start of the next floor.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `3 rounds`,
                target: `personal`,
              },
              {
                comboTags:["Curse","Death"],
                level: 1,
                name: `Fuel For the Fire`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[curse-death-curse] You curse a creature so that every time they take at least 1/2 their HD of damage, you heal 1d6 hit points. Every 30 <curse/death/arcane> the healing increases by 1d6.`,
                initiationAction: `free`,
                range: `30 feet`,
                duration: `3 rounds`,
                target: `one creature`,
              },
              {
                comboTags:["Power","Air","Earth"],
                level: 1,
                name: `Slam Attack`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[power-air,earth-power] You slam downwards while in the air, impacting the ground to deal devastating damage. When you initiate this maneuver, you descend directly downwards, impacting the ground and making a damage roll with a melee weapon against all creatures within 5 feet of your landing area. Creatures can make a reflex save to halve the damage. For every 10 feet downards charged you deal an additional 1d6 damage, for every 60 feet the area increases by 5 feet and the DC increases by 1. You take half the normal fall damage from initiating this maneuver, and the maximum travel distance is 600 feet. Only the damage of the attack is confered, no additional effects from being struck by the weapon.`,
                initiationAction: `standard`,
                range: `see text`,
                duration: `instantaneous`,
                target: `creatures`,
              },
              {
                comboTags:["Power","Technique"],
                level: 1,
                name: `Charge Attack`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[power-technique-power] You make a powerful, though slower attack. You cannot take any more attacks until the start of your next turn. This attack suffers a -5 penalty to hit, but deals double damage (added, not multiplied by critical hits). After initiating this, you are staggered on your next turn. It also deals additional damage equal to 1/2 your <power/technique> mastery. This additional damage is not doubled by the maneuver, or criticals.`,
                initiationAction: `swift`,
                range: `melee`,
                duration: `instantaneous`,
                target: `1 creature`,
              },
              {
                comboTags:["Arcane","Technique"],
                level: 1,
                name: `Flawless Duet`,
                type: `Finisher`,
                finisherType:"Strike",
                longDesc: `[arcane-technique-arcane] Choose a square within 10 feet of you. At the start of your next turn as a free action, choose another square within 10 feet of you. The round after the second square is chosen, draw a line between the center of both squares, all creatures between the lines suffer 1d6 damage per 5 <arcane/technique> and are stunned for 1 round. Reflex halves the damage and negates the stun. The DC increases by +1 per 10 <technique/arcane>. The maximum distance of the line is 10ft. + 1/2 <arcane/technique> mastery.`,
                initiationAction: `swift`,
                range: `30 feet`,
                duration: `3 rounds`,
                target: `one creature`,
              },
              {
                comboTags:["Arcane","Guardian"],
                level: 1,
                name: `Defiant Dance`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[arcane-guardian-guardian-arcane] You wrap yourself in a defensive stance, reducing all physical, fire, cold, electricity, acid, sonic damage by 25% plus 1% per 3 <guardian/arcane> mastery. This applies after any damage reduction or other forms of defensive abilities. While this is active, you cannot move or attack, and it does not end from being stunned, paralyzed, dazed, or other forms of crowd control, except mind-affecting crowd control. As you take damage, you store every point that this maneuver negates, at the end of the duration, you make a 10-foot line attack, dealing the stored damage back against creatures within the line (reflex halves). You can end this early as an immediate action.`,
                initiationAction: `movement`,
                range: `personal`,
                duration: `1 round`,
                target: `You`,
              },
              {
                comboTags:['Void',"Heroic"],
                level: 5,
                name: "Stolen Valor",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[void-heroic-void-heroic-void] Choose a creature you can see, your party gains experience as if you had killed the creature. 1 round later, you all lose the gained experience and are stunned for 1 round. This does not work on final bosses.`,
                initiationAction: `1 round`,
                range: `sight`,
                duration: `1 round`,
                target: `1 enemy`,
                secret:true,
              },
              {
                comboTags:["Heroic"],
                level: 1,
                name: "Inexhaustible",
                type: "Finisher",
                finisherType:"Boost",
                longDesc: `[heroic-{multi}-heroic] Multi must have 1 <heroic> combo point for every maneuver you have unexpended. You recover a maneuver and a random maneuver. You can recover another random maneuver for every 30 <heroic> mastery.`,
                initiationAction: `free`,
                range: `personal`,
                duration: `instantaneous`,
                target: `you`,
              },
              {
                comboTags:['Void'],
                level: 9,
                name: "Incomprehensible",
                type: "Boost",
                longDesc: `[void-void-void-void-void-void-void] Make an intelligence check. If this check is modified by any abilities, the bonuses to the check only last as long as those abilities would have (this is just to save time). For the duration, the first time any creature who perceive you in any way must make an intelligence check opposed by your check. If they fail, they lose the ability to perceive your existence for the duration. The first time each round you make a hostile action against them they can make a new check, but they suffer a -2 on the check. If their check ever results in a 0, they can never perceive you until you allow it, even after the duration. While this is active, you are immune to critical hits, diease, poison, stun, daze, paralysis, grappled, entangled, prone, bleed, negative energy, positive energy, nauseated, petrified, staggered, unconsciousness, all elemental and physical damage, and your movement speed becomes teleportation and you can move to any square you can see. This even allows you to 5-foot step any distance, but this does stop you from teleporting or moving again that round. Every time this negates a condition/damage or you teleport greater than your movement speed, your intelligence check is reduced by 1. Great Old Ones are immune to this.`,
                initiationAction: `swift`,
                range: `personal`,
                duration: `3 rounds`,
                target: `you`,
              },
              {
                comboTags: ["Light","Flurry"],
                level: 1,
                name: `Blades of Light`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[flurry-light-flurry] Make a full-attack action at a -2 penalty to hit. All of these attacks only deal the attacks's base damage dice, no additional modifiers, but the damage becomes untyped. For every 20 <light/flurry> mastery, the damage of each attack is increased by 1d6.`,
                initiationAction: `swift`,
                range: `melee attacks`,
                target: `creatures`,
                duration: `instantaneous`
              },
              {
                comboTags: ["Shadow","Heroic"],
                level: 5,
                name: `Talk no Jutsu`,
                type: `Finisher`,
                finisherType:"Boost",
                longDesc: `[shadow-heroic-heroic-shadow] You channel the force of heartfelt conviction, character development, flashbacks, friendship, love, etc. etc. into a verbal technique so potent it can shake the very foundations of evil. This technique causes the enemy to become a friendly creature for 3 rounds, though a successful will save causes the creature to instead become stunned for 1 round and charmed by you for 3 rounds. The creature is allowed a new save at the end of each of its turns as a free action to end this effect and cause it to become dazed until the end of its next turn. If you or an ally attacks or uses any offensive action against the creature, all of the effects of this finisher immediately end and it gains a +4 morale bonus on attacks and damage against you. This finisher's DC is increased by +1 per 10 <shadow/heroic> mastery. [Mind-affecting, Language-dependent, Compulsion]`,
                initiationAction: `full-round`,
                range: `30 feet`,
                target: `One intelligent creature that can hear and understand you`,
                duration: `3 rounds`
              },
              //Light Dark when someone heals, another enemy takes damage
               // cursed to heal you when the target takes elemental damage. 
              //cursed to heal you when they take damage
              //cursed to take fire damage when they damage something
              //set things that attack you on fire, more attacks, more stacks, at the end, explodes. "ashen retribution"
              //curse-heroic: take a condition an ally has, make an immediate save, if you succeed, bonuses. alternative, next time you hit, the creature must make a save DC the same one you did or take that condition for 1 round.
              //heroic-curse: when you do damage, reduce it by any amount you'd like, the next damage the creature deals, is reduced by that amount, can stack for multiple attacks. option 2, if it fails to do more damage than you did, rebounds.
              //heroic-curse: curse an enemy that every time it damages something it takes a -1 penalty on attacks until it reaches certain stacks, or nat 20 or something
              //curse-heroic: steal allies hp, get bonuses for it.
              //curse-heroic: allies who attack a creature give you temp hp, marked creature dies, all allies heal something


              // {
              //   comboTags: ["Fire","Light"],
              //   level: 1,
              //   name: `The Burning Gift`,
              //   type: `Finisher`,
              //   finisherType:"Boost",
              //   longDesc: `[fire-void-void-fire] `,
              //   initiationAction: `free`,
              //   range: `personal`,
              //   target: `you`,
              //   duration: `1 round`
              // },
              // {
              //   comboTags: ["Fire","Death"],
              //   level: 1,
              //   name: `Kindle My Pain`,
              //   type: `Finisher`,
              //   finisherType:"Boost",
              //   longDesc: `[fire-death-fire] `,
              //   initiationAction: `free`,
              //   range: `personal`,
              //   target: `you`,
              //   duration: `3 rounds`
              // },
              // {
              //   comboTags: ['Power','Dark'],
              //   level: 1,
              //   name: `Ravage`,
              //   type: `Finisher`,
              //   finisherType:"Strike",
              //   longDesc: `[power-dark-power] `,
              //   initiationAction: `standard`,
              //   range: `melee attack`,
              //   duration: `instantaneous`,
              //   target: `1 enemy`,
              // },    
              // {
              //   comboTags: ["Heroic","Curse"],
              //   level: 1,
              //   name: `Curse of Vengeance`,
              //   type: `Finisher`,
              //   finisherType:"Boost",
              //   longDesc: `[curse-heroic-curse] `,
              //   initiationAction: `movement`,
              //   range: `melee or ranged attack`,
              //   target: `1 enemy`,
              //   duration: `instantaneous`
              // },

              // {
              //   comboTags: ["Water","Air"],
              //   level: 3,
              //   name: `Change, In Two Forms`,
              //   type: `Finisher`,
              //   finisherType:"Boost",
              //   longDesc: `[water,air-water,air] `,
              //   initiationAction: `free`,
              //   range: `personal`,
              //   target: `you`,
              //   duration: `3 rounds`
              // },

              // {
              //   comboTags: ["Light","Death"],
              //   level: 3,
              //   name: ``,
              //   type: `Finisher`,
              //   finisherType:"Strike",
              //   longDesc: `[light-death-light] `,
              //   initiationAction: `movement`,
              //   range: `melee attack`,
              //   target: `1 enemy`,
              //   duration: `instantaneous`
              // },
              // {
              //   comboTags: ["Dark","Death"],
              //   level: 7,
              //   name: `There is no harmony`,
              //   type: `Finisher`,
              //   finisherType:"Strike",
              //   longDesc: ``,
              //   initiationAction: `standard`,
              //   range: `map`,
              //   target: `all creatures`,
              //   duration: `instantaneous`
              // },          
              

              // on the they recover 1 expended maneuver and the spell points equal to its level.
]
